const _ = {
  T_50_XYL_2NBCL_BLOODMOON_SKYBOX: "Fondo del Tsukuyomi",
  BR_WORKSHOP_INVALID_PERFORMANCE_COST: "No se ha podido publicar debido a un exceso de recursos en escena. Elimina algunos recursos e inténtalo de nuevo.",
  BR_WORKSHOP_NO_PERMISSION_PUB_MONETIZATION_MAP: "No tienes permiso para acceder a funciones relacionadas con la membresía",
  T_12_I_GIFT_SENDER_BELL: "Campana",
  T_12_L_ACCESSORY_COS_MOTORHELMET_DESC: "Me ves… ahora no me ves [FFB300](Oculta el Casco)[-]",
  T_12_L_ACCESSORY_COS_SANTAHEAD: "Máscara del Viejo",
  T_12_L_COS_PINKMAN: "DINO Rosa",
  T_12_L_COS_POLAR: "Polar",
  T_12_L_COS_RENDER: "Dinocornio",
  T_12_L_COS_TIGER: "Dino Tigre",
  T_12_L_MALE_BOTTOM_COS_ELF: "Elfo Invernal (Inferior)",
  T_12_L_MALE_COS_SANTA: "Santa Gruñón",
  T_12_L_MALE_HAIR_COS_ELF: "Elfo Invernal (Cabeza)",
  T_12_L_MALE_SHOE_COS_ELF: "Elfo Invernal (Zapatos)",
  T_12_L_MALE_TOP_COS_ELF: "Elfo Invernal (Superior)",
  T_12_O_CAT_NAME: "Gatito",
  T_12_O_M1014_CHRISTMAS_NAME: "M1014 - Felices Fiestas",
  T_12_O_MACHETE_GOLD_NAME: "Machete Dorado",
  T_12_O_PET_TITLE: "MASCOTAS",
  T_12_Q_ITEM_AN94: "AN94",
  T_12_Q_ITEM_DOUBLEJUMPSHOE: "Zapatos para saltar",
  T_12_Q_ITEM_DOUBLEJUMPSHOE_DESC: "Zapatos con tecnología moderna. Permiten hacer doble salto.",
  T_12_Q_ITEM_FLYSHOE: "Zapatos Jet Pack",
  T_12_Q_ITEM_FLYSHOE_DESC: "Permiten que vueles. No te quedes sin combustible en el aire",
  T_12_Q_ITEM_STOCK1: "Culata Nvl. 1",
  T_12_Q_ITEM_STOCK2: "Culata Nvl. 2",
  T_12_Q_ITEM_STOCK3: "Culata Nvl. 3",
  T_12_Q_ITEM_TREATMENTGUN: "Pistola Curativa",
  T_12_Q_ITEM_VEST4: "Chaleco Nivel 4",
  T_12_R_CHARACTER_GANGLEADER_NAME: "Antonio",
  T_12_R_CHARACTER_MONKEYGOD_NAME: "Wukong",
  T_12_R_EMOTE_SHOOTDANCE_NAME: "Baile de Disparos",
  T_12_R_EMOTE_WAVE_NAME: "Ola",
  T_12_R_SKILL_NAME_GANGLEADER: "Espíritu del Mafioso",
  T_12_R_SKILL_NAME_MONKEYGOD: "Ilusión",
  T_13_I_COLLECTION_V_AMPHIBIAN: "Vehículo Anfibio",
  T_13_I_COLLECTION_V_JEEP: "Jeep",
  T_13_I_COLLECTION_V_MONSTER: "Camioneta Monster",
  T_13_I_COLLECTION_V_MOTOBIKE: "Motocicleta",
  T_13_I_COLLECTION_V_ROADSTER: "Auto Deportivo",
  T_13_I_COLLECTION_V_SUV: "Camioneta Pickup",
  T_13_I_COLLECTION_V_TUTU: "Carrito Tuk Tuk",
  T_13_L_MALE_ACCESSORY_COS_BJD: "Azul Ártico (Máscara)",
  T_13_L_MALE_BOTTOM_COS_VALENTINE: "Amor en el Aire (Inferior)",
  T_13_L_MALE_HAIR_COS_BJD: "Azul Ártico (Cabeza)",
  T_13_L_MALE_TOP_COS_VALENTINE: "Amor en el Aire (Superior)",
  T_13_M_PVE_MATCH_SUMMARY_WEAPON: "Arma",
  T_13_O_PETSKIN_OCELOT_CAT_NAME: "Aspecto de Mascota: Detective Gatuno",
  T_13_O_SCAR_VALENTINE_NAME: "SCAR- Cupido",
  T_13_R_CHARACTER_HACKERGIRL_NAME: "Moco",
  T_13_R_EMOTE_BABYSHARK_NAME: "Tiburoncín",
  T_13_R_EMOTE_BOMBSQUAD_NAME: "Lagartija",
  T_13_R_EMOTE_EGYPT_NAME: "Baile de la Momia",
  T_13_R_PVE_WEAPON_SLOT: "Espacio de Arma",
  T_13_R_PVE_WEAPONSKIN_RANGE: "Rango",
  T_13_R_PVE_WEAPONSKIN_SPEED: "Velocidad",
  T_13_R_SKILL_DESC_HACKERGIRL: "Marca a los enemigos que les dispares durante [FFB300]{0}s[-]. La información se compartirá con tus compañeros.",
  T_13_R_SKILL_NAME_HACKERGIRL: "Ojo de Hacker",
  T_13_Z_KICKOFF_BAN: "SUSPENDER",
  T_13_Z_ROOM_MORNING: "Día",
  T_13_Z_ROOM_NIGHT: "Noche",
  T_14_G_ITEM_KATANA: "Katana",
  T_14_I_HEADPIC_SONGKRAN_NAME: "¡SPLASH!",
  T_14_L_ACCESSORY_COS_EASTERHEAD2: "Cubiconejo",
  T_14_L_COS_EASTER: "Observador 1937",
  T_14_L_FEMALE_SHOE_COS_FIREFIGHTERS: "Dama de la Flama (Zapatos)",
  T_14_L_MALE_ACCESSORY_COS_EASTERRABBIT: "Conejo Guerrero (Máscara)",
  T_14_O_AK_WATERSPLASHING_NAME: "AK47- Globo de Agua",
  T_14_O_DOG_NAME: "Perrito Mecánico",
  T_14_O_PETSKIN_IRON_DOG_NAME: "Aspecto de Mascota: Perrito de Acero",
  T_14_O_PETSKIN_LIGNTNING_DOG_NAME: "Aspecto de Mascota: Perrito Luminoso",
  T_14_O_PETSKIN_MAGNETIC_DOG_NAME: "Aspecto de Mascota: Perrito Magnético",
  T_14_O_PETSKIN_NIGHT_CAT_NAME: "Aspecto de Mascota: Gatito Nocturno",
  T_14_O_SCAR_BLOODMOON_NAME: "SCAR - Luna Sangrienta",
  T_14_O_SCAR_SHARK_NAME: "SCAR- Ataque de Tiburón",
  T_14_Q_ITEM_RGS50: "RGS50",
  T_14_R_CHARACTER_SAMURAI_NAME: "Hayato",
  T_14_R_SKILL_DESC_SAMURAI: "Tras perder [FFB300]{0}%[-] de tus PV, obtienes [FFB300]{1}%[-] de penetración de armadura.",
  T_14_R_SKILL_NAME_SAMURAI: "Bushido",
  T_15_L_MALE_ACCESSORY_COS_FAIM: "Hambruna (Máscara)",
  T_15_L_MALE_ACCESSORY_COS_PESTILENCE: "Pestilencia (Máscara)",
  T_15_L_MALE_BOTTOM_COS_FAIM: "Hambruna (Inferior)",
  T_15_L_MALE_BOTTOM_COS_PESTILENCE: "Pestilencia (Inferior)",
  T_15_L_MALE_SHOE_COS_FAIM: "Hambruna (Zapatos)",
  T_15_L_MALE_SHOE_COS_PESTILENCE: "Pestilencia (Zapatos)",
  T_15_L_MALE_TOP_COS_FAIM: "Hambruna (Superior)",
  T_15_L_MALE_TOP_COS_PESTILENCE: "Pestilencia (Superior)",
  T_15_L_TOP_COS_MOTHERSDAY: "Mejor Mamá (Superior)",
  T_15_O_AN94_APOCALYPSE_NAME: "AN94 - Cataclismo",
  T_15_O_BASEBALLBAT_VIKING_NAME: "El Vikingo",
  T_15_O_M1014_APOCALYPSE_NAME: "M1014 - Cataclismo",
  T_15_O_M4A1_APOCALYPSE_NAME: "M4A1 - Cataclismo",
  T_15_O_PANTHER_NAME: "Pantera Nocturna",
  T_15_O_PETSKIN_CAPTAIN_PANTHER_NAME: "Aspecto de Mascota: Pantera Capitán",
  T_15_O_PETSKIN_GOLDEN_PANTHER_NAME: "Aspecto de Mascota: Pantera Dorada",
  T_15_O_PETSKIN_PURPLE_PANTHER_NAME: "Aspecto de Mascota: Pantera Dominación",
  T_15_O_SKS_DEATH_NAME: "SKS – Deseo Mortal",
  T_15_O_UMP_APOCALYPSE_NAME: "UMP - Cataclismo",
  T_15_Q_ITEM_CG15: "CG15",
  T_15_Q_ITEM_GATLING: "GATLING",
  T_15_R_CHARACTER_AGENT_NAME: "Laura",
  T_15_R_EMOTE_LETSGROOVE_NAME: "Baila conmigo",
  T_15_R_SKILL_DESC_AGENT: "Aumenta [FFB300]{0}%[-] la precisión al usar la mira.",
  T_15_R_SKILL_NAME_AGENT: "Tiradora Audaz",
  T_15_W_BACKPACK_MECHGIRL_NAME: "Alas Púrpuras",
  T_16_B_ITEM_GRAPPLINGHOOK: "Gancho",
  T_16_B_ITEM_GRAPPLINGHOOKGUN: "Pistola de Gancho",
  T_16_L_MALE_COS_LEGO: "Tío Tijolino",
  T_16_L_MALE_SHOE_COS_SUMMER: "Look Veraniego (Zapatos)",
  T_16_P_MANUAL_MONSTER: "Camioneta Monster",
  T_16_P_MANUAL_MUSHROOM1: "Hongo Nvl. 1",
  T_16_P_MANUAL_MUSHROOM2: "Hongo Nvl. 2",
  T_16_P_MANUAL_MUSHROOM3: "Hongo Nvl. 3",
  T_16_P_MANUAL_MUSHROOM4: "Hongo Nvl. 4",
  T_16_P_MANUAL_ROADSTER_DESC: "Un auto deportivo de mucho estilo. Con pocos PV, pero tan veloz que vuelas. Puede transportar hasta 2 personas.",
  T_16_P_MANUAL_STROP: "Tirolesa",
  T_16_P_MANUAL_SUV: "Camioneta Pickup",
  T_16_P_MANUAL_SUV_DESC: "El vehículo modelo de Free Fire. Armadura media y velocidad máxima. Puede transportar hasta 2 jugadores.",
  T_16_P_MANUAL_TUTU_DESC: "Un vehículo con pocos PV y que es lento al moverse. Puede transportar hasta 3 jugadores.",
  T_16_P_MANUAL_WEAPON_AR: "Rifle",
  T_16_P_MANUAL_WEAPON_BOMB: "Granadas",
  T_16_P_MANUAL_WEAPON_PISTOL: "Pistola",
  T_16_P_MANUAL_WEAPON_SG: "Escopeta",
  T_16_P_MANUAL_WEAPON_SMG: "Subfusil",
  T_16_P_MANUAL_WEAPON_SR: "Rifle de Francotirador",
  T_16_Q_MINISENTRY: "Minitorreta",
  T_16_Q_MINISENTRY_DESC: "Una torreta automática hecha con tecnología moderna. Escaneará y atacará a los enemigos cercanos.",
  T_16_R_EMOTE_DESERT_NAME: "Furioso",
  T_16_R_EMOTE_EPHUNTER_NAME: "Danza de la Guerra",
  T_16_R_EMOTE_EPHUNTER2_NAME: "¡Dame esos cinco!",
  T_16_R_EMOTE_KICKTHEMOON_NAME: "Patea Lunas",
  T_16_R_EMOTE_WIGGLEWALK_NAME: "Wiggle-wiggle",
  T_16_W_AK_FIRE_NAME: "AK47- Rojo Llameante",
  T_16_W_SCAR_LLENN_NAME: "SCAR - Diablura Rosada",
  T_16_W_SCAR_WATER_NAME: "SCAR - Maremoto",
  T_16_Y_CHARACTER_HITMAN_NAME: "Rafael",
  T_16_Y_PANDA_NAME: "Detective Pandita",
  T_16_Y_PETSKIN_BROWN_PANDA_NAME: "Aspecto de Mascota: Pandita Salvaje",
  T_16_Y_PETSKIN_SKELETON_PANDA_NAME: "Aspecto de Mascota: Esquelepanda",
  T_16_Y_PETSKIN_THOR_PANDA_NAME: "Aspecto de Mascota: Electropanda",
  T_17_B_CS_MODE_NAME: "Duelo de Escuadras",
  T_17_C_SKILL_NAME_PLAYBOY: "Movimiento Seductor",
  T_17_L_FEMALE_ACCESSORY_COS_JOKER_ROYAL: "Joker Real (Máscara)",
  T_17_L_FEMALE_ACCESSORY_COS_VAMPIRE: "Señorita Sangrienta (Casco)",
  T_17_L_FEMALE_BOTTOM_COS_VAMPIRE: "Señorita Sangrienta (Inferior)",
  T_17_L_FEMALE_HAIR_COS_SELVEDGEWORK: "Dama Zafiro (Cabeza)",
  T_17_L_FEMALE_SHOE_COS_VAMPIRE: "Señorita Sangrienta (Zapatos)",
  T_17_L_FEMALE_TOP_COS_VAMPIRE: "Señorita Sangrienta (Superior)",
  T_17_L_MALE_ACCESSORY_COS_VAMPIRE: "Vampiro Sangriento (Máscara)",
  T_17_L_MALE_BOTTOM_COS_BOSOZOKU: "Pandillero Rudo (Inferior)",
  T_17_L_MALE_BOTTOM_COS_VAMPIRE: "Vampiro Sangriento (Inferior)",
  T_17_L_MALE_HAIR_COS_FFUNIT: "Espectro Violeta (Cabeza)",
  T_17_L_MALE_SHOE_COS_INDEPENDENCE: "El Mariachi (Zapatos)",
  T_17_L_MALE_SHOE_COS_VAMPIRE: "Vampiro Sangriento (Zapatos)",
  T_17_L_MALE_TOP_COS_VAMPIRE: "Vampiro Sangriento (Superior)",
  T_17_L_MALE_TOP_COS_YINYANG_GOLD: "Yang Dorado (Superior)",
  T_17_O_PETSKIN_ANNIVERSARY_CAT_NAME: "Aspecto de Mascota: Princesa Felina",
  T_17_O_PETSKIN_EARTHDRAGON_SHIBA_NAME: "Aspecto de Mascota: Shiba Dragoncito Terrenal",
  T_17_O_PETSKIN_ELECTRICDRAGON_SHIBA_NAME: "Aspecto de Mascota: Shiba Dragoncito Eléctrico",
  T_17_O_PETSKIN_GREENDRAGON_SHIBA_NAME: "Aspecto de Mascota: Shiba Dragoncito Naturaleza",
  T_17_O_SHIBA_NAME: "Shiba",
  T_17_Q_FOLDWINGS: "Planeador",
  T_17_Q_FOLDWINGS_DESC: "Te permite deslizarte hacia abajo desde terrenos elevados.",
  T_17_Q_SUPERHEAT: "Plasma",
  T_17_R_EMOTE_PARTYDANCE_NAME: "Baile de Fiesta",
  T_17_W_FAMAS_VAMPIRE_NAME: "FAMAS- Vampiro Sangriento",
  T_17_W_SCAR_ASSASSIN_NAME: "SCAR- Ventisca Helada",
  T_17_W_SCAR_PLAYBOY_NAME: "SCAR- Casanova",
  T_17_Y_CHARACTER_MADEMANA_NAME: "A124",
  T_17_Y_CHARACTER_PLAYBOY_NAME: "Joseph",
  T_17_Z_CS_NAME: "Nombre",
  T_17_Z_ROOM_JUMP_SWITCH: "Altura del salto",
  T_17_Z_ROOM_SPEED_SWITCH: "Velocidad de Movimiento",
  T_18_B_THROWINGKNIFE_NAME: "Cuchillo FF",
  T_18_C_DUMMY_NAME: "Granada Señuelo",
  T_18_C_SKILL_DESC_DJMALE: "Crea un aura de [FFB300]{1}m[-] que aumenta la velocidad de movimiento en [FFB300]{3}%[-] y restaura [FFB300]{2} PV/s[-] por [FFB300]{0}s[-]. Los efectos no pueden acumularse. Enfriamiento: [FFB300]{4}s[-]",
  T_18_C_SKILL_NAME_DJMALE: "Ritmo Brutal",
  T_18_C_SKILL_NAME_JUNKENGINEER: "Equipo de Reparación",
  T_18_L_COS_INDIANEWYEAR: "Dino Diwali",
  T_18_L_HAIR_COS_HALLOWEEN2019: "Pequeño Espectro",
  T_18_L_MALE_ACCESSORY_COS_BJD2_MAGMA: "Fuego Escarlata (Máscara)",
  T_18_O_FOX_NAME: "Zorrito Espiritual",
  T_18_O_PETSKIN_BLACKFOX_NAME: "Aspecto de Mascota: Zorrito de Batalla",
  T_18_O_PETSKIN_BLUEFOX_NAME: "Aspecto de Mascota: Zorrito Azul",
  T_18_O_PETSKIN_HALLOWEEN_SHIBA_NAME: "Aspecto de Mascota: Calabacín del Terror",
  T_18_O_PETSKIN_PINKFOX_NAME: "Aspecto de Mascota: Zorrojito",
  T_18_O_PETSKIN_SPIRIT_PANTHER_NAME: "Aspecto de Mascota: Pantera Cazadora",
  T_18_U_WEAPON_M1887_NAME: "M1887",
  T_18_W_M4A1_FIRESKELETON_N: "M4A1- Heraldo del Inframundo",
  T_18_W_UMP_GEISHA_N: "UMP - Emperatriz de Loto",
  T_18_Y_CHARACTER_DJMALE_N: "Alok",
  T_18_Y_CHARACTER_JUNKENGINEER_N: "Shani",
  T_19_B_HB_NAME: "Tabla Eléctrica",
  T_19_C_ICE_GUN_NAME: "Pistola de Hielo",
  T_19_C_SKILL_DESC_DEMOLITIONIST: "El daño de arma explosiva aumenta en [FFB300]{0}%[-], el rango de daño aumenta en [FFB300]{1}%[-].",
  T_19_C_SKILL_DESC_TOMBOY: "Al manejar, recupera [FFB300]{1}PV[-] cada [FFB300]{0}s[-], para todos los pasajeros del vehículo. Máximo [FFB300]{2}[-] PV.",
  T_19_C_SKILL_NAME_DEMOLITIONIST: "Arte Demoledor",
  T_19_C_SKILL_NAME_TOMBOY: "Bendición de Carrera",
  T_19_I_EVENT_INFI_ITEM: "Ilimitado",
  T_19_L_A_ICEFESTIVAL19_B: "Sonrisa Helada",
  T_19_L_F_S_ICEFESTIVAL: "Doncella Navideña (Zapatos)",
  T_19_L_MALE_BOTTOM_COS_DISCOMAN: "Fiesta Disco (Inferior)",
  T_19_L_MALE_HAIR_COS_DISCOMAN: "Fiesta Disco (Cabeza)",
  T_19_L_MALE_TOP_COS_DISCOMAN: "Fiesta Disco (Superior)",
  T_19_O_PETSKIN_NAME: "Aspecto de Mascota: Predeterminado",
  T_19_O_PETSKIN_PANDA_TRAPRAP_NAME: "Aspecto de Mascota: Panda Hip Hop",
  T_19_O_PETSKIN_PANDA_WINTERFELL_NAME: "Aspecto de Mascota: Pandita Polar",
  T_19_O_PETSKIN_ROBOT_PHARAOH_NAME: "Aspecto de Mascota: Robo Faraón",
  T_19_O_PETSKIN_ROBOT_SPRING_NAME: "Aspecto de Mascota: Robo Festival de Primavera",
  T_19_O_PETSKIN_ROBOT_WINTERFELL_NAME: "Aspecto de Mascota: Robo Invernal",
  T_19_O_PETSKIN_SHIBA_TRAPRAP_NAME: "Aspecto de Mascota: Shiba Hip Hop",
  T_19_O_ROBOT_NAME: "Robo",
  T_19_O_TDM_NAME: "Combate a Muerte",
  T_19_R_EMOTE_MIGUEL_NAME: "Break Dance",
  T_19_S_SECOND_WEAPON_TITLE: "Arma Secundaria",
  T_19_S_VEST_TITLE: "Chaleco Antibalas",
  T_19_U_DOUBLEMAGEZINE_ATTACHMENT_NAME: "Doble Cargador",
  T_19_W_GROZA_TAGGERCREW_N: "Groza - Revuelta Grafiti",
  T_19_W_M60_ICEFESTIVAL_N: "M60- Felices Fiestas",
  T_19_W_MP40_PARK_N: "MP40- Pesadillas Desesperadas",
  T_19_W_SCAR_CNNEWYEAR19_N: "SCAR- Ascensión del Dragón",
  T_19_X_PVE_SAMURAINAME: "Samurái guardián",
  T_19_Y_CHARACTER_DEMOLITIONIST_N: "Alvaro",
  T_19_Y_CHARACTER_TOMBOY_N: "Notora",
  T_20_C_INHALER_NAME: "Inhalador",
  T_20_C_SKILL_DESC_PARKOURGUY: "Al usar armas, golpear a un enemigo recupera algo de PV para el usuario, derribar a un enemigo recupera un [FFB300]{0}% de PV[-].",
  T_20_C_SKILL_NAME_GRAFFITIST: "Refugio de Pintura",
  T_20_C_SKILL_NAME_KELLY_AWAKENING: "Velocidad Mortal",
  T_20_C_SKILL_NAME_PARKOURGUY: "Caza Sostenida",
  T_20_L_A_APRILFOOL2020: "Perricasquito",
  T_20_L_F_A_METALHEAD_RED: "Diablilla Ardiente (Máscara)",
  T_20_L_F_B_THAIGIRL: "Ascensión del Fénix (Inferior)",
  T_20_L_F_H_KILLERCUPID: "Neocariño (Cabeza)",
  T_20_L_F_H_THAIGIRL: "Ascensión del Fénix (Cabeza)",
  T_20_L_F_S_THAIGIRL: "Ascensión del Fénix (Zapatos)",
  T_20_L_F_T_METALHEAD_RED: "Diablilla Ardiente (Superior)",
  T_20_L_F_T_THAIGIRL: "Ascensión del Fénix (Superior)",
  T_20_L_JEANDINO: "Dinozclilla",
  T_20_L_M_A_METALHEAD_RED: "Diablillo Ardiente (Máscara)",
  T_20_L_M_T_METALHEAD_RED: "Diablillo Ardiente (Superior)",
  T_20_L_M_T_STOCKING: "Caballero Gallardo (Superior)",
  T_20_O_PETSKIN_LOVERFOX_NAME: "Aspecto de Mascota: Zorrito Valentín",
  T_20_P_CHANNEL_G: "Clan",
  T_20_P_WORLD_SSPEAKER: "Altavoz",
  T_20_S_CSROOM_COIN: "Moneda Predeterminada",
  T_20_U_SHIELD_GUN_NAME: "Arma Escudo",
  T_20_W_AN94_METALHEAD_N: "AN94- Diablillo Escarabajo",
  T_20_W_P90_EVILBONE_N: "P90- Castigadores",
  T_20_Y_CHARACTER_GRAFFITIST_N: "Steffie",
  T_20_Y_CHARACTER_KELLY_AWAKENING_N: 'Kelly "La Veloz"',
  T_20_Y_CHARACTER_PARKOURGUY_N: "Jota",
  T_21_B_SMOKEGRENADE_DESC: "Genera humo, ideal para maniobras de filtrado y  flanqueo",
  T_21_B_SMOKEGRENADE_NAME: "Granada de Humo",
  T_21_C_AUTOPICKUP_AVERAGE: "Predeterminado",
  T_21_C_SKILL_DESC_KPOPSINGER: "Mientras ayudas a un compañero de equipo, le otorga un escudo de [FFB300]{0} PV[-]  y un aumento de [FFB300]{1}%[-]  en la velocidad de movimiento. Los efectos de impulso se reducen dentro de [FFB300]{2}s[-]  después de ayudar con éxito. Reduce [FFB300]{3}%[-] la velocidad de sangrado de los compañeros derribados. Los efectos no se acumulan.",
  T_21_C_SKILL_DESC_SOCCERSTAR: "Cada eliminación aumenta el máximo de PV por [FFB300]{0}[-]. Aumento máx.:[FFB300]{1}[-].",
  T_21_C_SKILL_NAME_KPOPSINGER: "Canción Curativa",
  T_21_C_SKILL_NAME_SOCCERSTAR: "Sombrerito",
  T_21_L_ANGELICAL: "Dino Angelical",
  T_21_L_S_VNSLIPPER: "Sandalias Vietnam",
  T_21_O_OTTER_NAME: "Lutrino",
  T_21_O_PETSKIN_OTTER_GREY_NAME: "Aspecto de Mascota: Lutrino Radioactivo",
  T_21_O_PETSKIN_OTTER_PINK_NAME: "Aspecto de Mascota: Lutrino Sakura",
  T_21_O_PETSKIN_OTTER_PURPLE_NAME: "Aspecto de Mascota: Lutrino Neón",
  T_21_O_PETSKIN_ROBOT_DEATH_NAME: "Aspecto de Mascota: Robo Maestro de la Muerte",
  T_21_O_PETSKIN_SPINE_PANTHER_NAME: "Aspecto de Mascota: Pantera Rayo",
  T_21_R_EMOTE_SORROW_NAME: "¿Por qué? ¿Por qué?",
  T_21_U_WEAPON_THOMPSON_NAME: "Thompson",
  T_21_W_BACKPACK_SPINE_N: "Mochila Punk",
  T_21_W_BASEBALLPOLE_DEATH2020_N: "Ataque Final de la Muerte",
  T_21_W_M79_RABBITKILLER_N: "M79 - Conejo Feroz",
  T_21_W_PAN_VOLCANO_N: "Sartén- Furia Volcánica",
  T_21_W_XM8_RAINBOW_N: "XM8 - Verano",
  T_21_Y_CHARACTER_KPOPSINGER_N: "Kapella",
  T_21_Y_CHARACTER_SOCCERSTAR_N: "Luqueta",
  T_22_C_BLT_NAME: "M82B",
  T_22_C_SKILL_DESC_DETECTIVE: "Localiza la posición de enemigos que no estén agachados o boca abajo dentro de un área de [FFB300]{0}m[-]. Duración [FFB300]{1}s[-]. La posición de los enemigos se comparte con los compañeros de equipo. Enfriamiento: [FFB300]{2}s[-].",
  T_22_C_SKILL_NAME_DETECTIVE: "Rastreo de Pasos",
  T_22_C_SKILL_NAME_STREAMERGUY: "Vistas",
  T_22_L_F_H_COLLEGE: "Universitaria Sangrienta (Cabello)",
  T_22_L_F_S_SUMMER20: "Verano Peligroso (Zapatos)",
  T_22_L_M_A_GREENCOAT: "El Alma de la Noche (Máscara)",
  T_22_L_M_A_PINKFUR: "Sakura de la Noche (Máscara)",
  T_22_L_M_A_PLAGUE2: "Plaga Fantasma (Máscara)",
  T_22_L_M_B_FAIM2: "Fuego Nocturno (Inferior)",
  T_22_L_M_B_GREENCOAT: "El Alma de la Noche (Inferior)",
  T_22_L_M_B_PINKFUR: "Sakura de la Noche (Inferior)",
  T_22_L_M_B_PLAGUE2: "Plaga Fantasma (Inferior)",
  T_22_L_M_B_REDPANTS: "El Rey de la Noche (Inferior)",
  T_22_L_M_B_TIGERSTRIPE: "Tigre de la Noche (Inferior)",
  T_22_L_M_H_COLLEGE: "Universitario Sangriento (Cabello)",
  T_22_L_M_H_FAIM2: "Fuego Nocturno (Cabello)",
  T_22_L_M_H_GREENCOAT: "El Alma de la Noche (Cabello)",
  T_22_L_M_H_PINKFUR: "Sakura de la Noche (Cabello)",
  T_22_L_M_H_PLAGUE2: "Plaga Fantasma (Cabello)",
  T_22_L_M_H_REDPANTS: "El Rey de la Noche (Cabello)",
  T_22_L_M_H_TIGERSTRIPE: "Tigre de la Noche (Cabello)",
  T_22_L_M_S_FAIM2: "Fuego Nocturno (Zapatos)",
  T_22_L_M_S_PLAGUE2: "Plaga Fantasma (Zapatos)",
  T_22_L_M_T_FAIM2: "Fuego Nocturno (Superior)",
  T_22_L_M_T_GREENCOAT: "El Alma de la Noche (Superior)",
  T_22_L_M_T_PINKFUR: "Sakura de la Noche (Superior)",
  T_22_L_M_T_PLAGUE2: "Plaga Fantasma (Superior)",
  T_22_L_M_T_REDPANTS: "El Rey de la Noche (Superior)",
  T_22_L_M_T_TIGERSTRIPE: "Tigre de la Noche (Superior)",
  T_22_LC_KAR98K_COLLEGE_N: "Kar98K- Academia Rebelde",
  T_22_LC_PAN_CAPTAINBUBBLE_N: "Sartén- Sandía Fresca",
  T_22_LC_SCAR_HERMIT_N: "SCAR- Rastreador Místico",
  T_22_LC_TREATMENTGUN_APOCALYPSE2_N: "Pistola Curativa- Rayo de Vida",
  T_22_O_HAWK_NAME: "Falco",
  T_22_O_PETSKIN_FOX_APOCALYPSE_NAME: "Aspecto de Mascota: Zorrito Apocalíptico",
  T_22_O_PETSKIN_HAWK_FIRE_NAME: "Aspecto de Mascota: Falco Infernal",
  T_22_O_PETSKIN_HAWK_NATURE_NAME: "Aspecto de Mascota: Falco Natural",
  T_22_O_PETSKIN_SHIBA_SUMMER_NAME: "Aspecto de Mascota: Shiba Brillo Solar",
  T_22_Q_BOMB_PLIERS: "Alicate de Desactivación",
  T_22_R_EMOTE_SHIMMY_NAME: "Abaniqueo",
  T_22_U_GOLD_AWM_N: "AWM-Y",
  T_22_U_WPNSKN_BITE: "Penetración de armadura",
  T_22_U_WPNSKN_SPEED_RUN: "Velocidad de movimiento",
  T_22_Y_CHARACTER_DETECTIVE_N: "Clu",
  T_22_Y_CHARACTER_STREAMERGUY_N: "Wolfrahh",
  T_23_B_CARDIAC_NAME: "Horizonalina",
  T_23_C_SKILL_NAME_HAYATO_AWAKENING: "Arte con Espadas",
  T_23_C_SKILL_NAME_SWATGUY: "Recarga Furiosa",
  T_23_D_CHARACTER_HAYATO_AWAKENING_N: 'Hayato "Rebelde"',
  T_23_D_CHARACTER_SWATGUY_N: "Jai",
  T_23_L_F_B_GANGSTERRAP_GOLD: "Pandillera Burguesa (Inferior)",
  T_23_L_F_B_MIKOGIRL: "Sacerdotisa del Ártico (Inferior)",
  T_23_L_F_B_NAVYGIRL: "Marinerita (Inferior)",
  T_23_L_F_H_GANGSTERRAP_GOLD: "Pandillera Burguesa (Cabeza)",
  T_23_L_F_H_MIKOGIRL: "Sacerdotisa del Ártico (Cabeza)",
  T_23_L_F_H_NAVYGIRL: "Marinerita (Cabeza)",
  T_23_L_F_S_MIKOGIRL: "Sacerdotisa del Ártico (Zapatos)",
  T_23_L_F_S_ORDERCHALLENGER: "Atraco Feroz (Zapatos)",
  T_23_L_F_T_GANGSTERRAP_GOLD: "Pandillera Burguesa (Superior)",
  T_23_L_F_T_MIKOGIRL: "Sacerdotisa del Ártico (Superior)",
  T_23_L_F_T_NAVYGIRL: "Marinerita (Superior)",
  T_23_L_M_A_GANGSTERRAP_GOLD: "Pandillero Burgués (Máscara)",
  T_23_L_M_B_FOXGUY: "Sacerdote del Ártico (Inferior)",
  T_23_L_M_B_GANGSTERRAP_GOLD: "Pandillero Burgués (Inferior)",
  T_23_L_M_H_FOXGUY: "Sacerdote del Ártico (Cabeza)",
  T_23_LC_SKS_GEMINI_N: "SKS- Histeria",
  T_23_O_PENGUIN_NAME: "Sr. Wagger",
  T_23_O_PETSKIN_PENGUIN_A_NAME: "Aspecto de Mascota: Wagger Fiesta",
  T_23_O_PETSKIN_PENGUIN_C_NAME: "Aspecto de Mascota: Wagger Eléctrico",
  T_23_O_PETSKIN_PENGUIN_G_NAME: "Aspecto de Mascota: Wagger Bling Bling",
  T_23_T_ANNI3_LOBBY_NODENAME20: "Duelo de Escuadras",
  T_23_T_ANNI3_LOBBY_NODENAME5: "Personaje",
  T_23_U_AUG: "AUG",
  T_23_Z_R_UID: "ID",
  T_24_AD_ADSPACE_WARNING: "PRECAUCIÓN",
  T_24_C_FLAMETHROWER_NAME: "Lanzallamas",
  T_24_C_SKILL_DESC_PROFESSOR: "PE máximo aumenta a [FFB300]{0}[-]. Modo Jiu-jitsu: Los aliados dentro de [FFB300]{2}m[-] obtienen un [FFB300]{1}%[-] de aumento en el porcentaje de conversión de PE. Modo Psicología: Recupera [FFB300]{5} PE[-] cada [FFB300]{4}s[-], hasta [FFB300]{6} PE[-]. Enfriamiento de cambio de modo: [FFB300]{3}s[-].",
  T_24_C_SKILL_NAME_PARTYGIRL: "Modo Fiesta",
  T_24_C_SKILL_NAME_PROFESSOR: "Profesor de Todo",
  T_24_D_CHARACTER_PARTYGIRL_N: "Dasha",
  T_24_D_CHARACTER_PROFESSOR_N: "K",
  T_24_L_B_MAXPANTS: "Pantalones MAX",
  T_24_L_H_PUMPKIN2020_A: "Calabaza Retorcida (Cabeza)",
  T_24_L_T_TSHIRT_COMEDIAN: "Playera Last Shot Hero",
  T_24_LC_MP5_RICHBOXER_N: "MP5- Campeón de Boxeo",
  T_24_LC_SCAR_PARTYGIRL_N: "SCAR- Diversión Infinita",
  T_24_LC_SVD_WARRINGSTATES_N: "SVD- Guerreros Legendarios",
  T_24_U_M21A5: "Woodpecker",
  T_24_U_PARAFAL: "PARAFAL",
  T_24_V_TRAINING_AIMBOT_GAMESCORE: "Puntuación Total",
  T_24_V_TRAINING_BOX_ATTACH: "Accesorios",
  T_24_V_TRAINING_BOX_WEAPON: "Armas",
  T_24_W_ARMORY: "Armas",
  T_24_W_ARMOTY_MELEE: "Cuerpo a Cuerpo",
  T_24_W_ARMOTY_PISTOL: "Pistolas",
  T_24_W_ARMOTY_RIFLE: "Rifles",
  T_24_W_ARMOTY_SHOTGUN: "Escopetas",
  T_24_W_ARMOTY_SNIPER: "Rifles de Francotirador",
  T_24_W_ARMOTY_SPECIAL: "Otros",
  T_24_W_ARMOTY_SUBMACHINE: "Subfusil",
  T_24_W_PETSKIN_PANDA_BOOYAHDAY_N: "Aspecto de Mascota: Pandita Booyah",
  T_24_W_PETSKIN_RACCOON_BRIGHT_N: "Aspecto de Mascota: Rockie Esqueleto",
  T_24_W_PETSKIN_RACCOON_MECH_N: "Aspecto de Mascota: Rockie de Fiesta",
  T_24_W_PETSKIN_RACCOON_UNDEAD_N: "Aspecto de Mascota: Rockie Fiesta de Disfraces",
  T_24_W_RACCOON_N: "Rockie",
  T_25_C_SKILL_NAME_BOUNTYHUNTER: "Campo de Fuerza",
  T_25_D_CHARACTER_BOUNTY_N: "Chrono",
  T_25_E_HUD_01: "Preset 1",
  T_25_E_HUD_02: "Preset 2",
  T_25_L_F_B_DEMONKILLER: "Pilar de Fuego (Inferior)",
  T_25_L_F_H_DEMONKILLER: "Pilar de Fuego (Cabeza)",
  T_25_L_F_S_DEMONKILLER: "Pilar de Fuego (Zapatos)",
  T_25_L_F_T_DEMONKILLER: "Pilar de Fuego (Superior)",
  T_25_L_HA_FP_EVIL: "Malvado (Maquillaje)",
  T_25_L_M_H_ANIMEHAIR: "Despreocupado (Cabello)",
  T_25_L_S_MAXSNEAKERS: "Tenis MAX",
  T_25_LC_BASEBALLBAT_BOUNTY_N: "Bate- Movimiento Cibernético",
  T_25_LC_GLOO_WINTERFEST2020_N: "Pared Gloo- Felices Fiestas 2020",
  T_25_LC_M1887_WINTERFEST2020_N: "M1887- Felices Fiestas 2020",
  T_25_LC_MACHETE_BOUNTY_N: "Machete Cibernético",
  T_25_LC_P90_MUSICFALL_GREEN_N: "P90 - Ritmo Desintegrador Verde",
  T_25_LC_P90_MUSICFALL_RED_N: "P90- Ritmo Desintegrador Rojo",
  T_25_LC_PAN_BOUNTY_N: "Sartén- Cazarrecompensas Cibernético",
  T_25_R_LEGEND_REMIND: "Recordatorio",
  T_25_U_MAG7: "MAG-7",
  T_25_U_SICKLE: "Hoz",
  T_25_U_VECTOR: "Vector",
  T_25_W_BABOON_N: "Bestión",
  T_25_W_PETSKIN_BABOON_FROZEN_N: "Aspecto de Mascota: Bestión de Hielo",
  T_25_W_PETSKIN_BABOON_HELL_N: "Aspecto de Mascota: Bestión de Fuego",
  T_25_W_PETSKIN_BABOON_PURE_N: "Aspecto de Mascota: Bestión Blanco",
  T_25_W_PETSKIN_PANTHER_WINTERFEST2020_N: "Aspecto de Mascota: Pantera Invernal",
  T_25_Z_R_SIMULATOR_OFF: "Rechazar",
  T_26_C_SKILL_DESC_SUPERSTAR: "Libera una onda sónica hacia delante por [FFB300]{0}m[-]. La onda explota e inflige daño a las paredes gloo dentro de un radio de [FFB300]{1}m[-] por [FFB300]{2}s[-]. Enfriamiento: [FFB300]{3}s[-].",
  T_26_C_SKILL_NAME_SUPERSTAR: "Ritmo Alto",
  T_26_D_CHARACTER_DELIVERY_N: "Shirou",
  T_26_D_CHARACTER_SUPERSTAR_N: "Skyler",
  T_26_ET_CELLPHONE_NAME: "UAV-Lite",
  T_26_L_A_FLAMING_PREM: "Guardia Infernal (Máscara)",
  T_26_L_A_SANTAMODE: "Muñeco de Nieve (Máscara)",
  T_26_L_B_SANTAMODE: "Muñeco de Nieve (Inferior)",
  T_26_L_F_B_WATERFEST21_A: "Brisa de Verano (Inferior)",
  T_26_L_F_H_WATERFEST21_A: "Brisa de Verano (Cabeza)",
  T_26_L_F_S_WATERFEST21_A: "Brisa de Verano (Zapatos)",
  T_26_L_F_T_WATERFEST21_A: "Brisa de Verano (Superior)",
  T_26_L_M_A_EGGDAY2021: "Liebre Futurista (Máscara)",
  T_26_L_M_B_EGGDAY2021: "Liebre Futurista (Inferior)",
  T_26_L_M_B_PAIRING: "Dúo Dinámico (Hombre) (Inferior)",
  T_26_L_M_B_WATERFEST21_A: "Ola de Verano (Inferior)",
  T_26_L_M_H_EGGDAY2021: "Liebre Futurista (Cabeza)",
  T_26_L_M_H_PAIRING: "Dúo Dinámico (Hombre) (Cabeza)",
  T_26_L_M_H_WATERFEST21_A: "Ola de Verano (Cabeza)",
  T_26_L_M_S_EGGDAY2021: "Liebre Futurista (Zapatos)",
  T_26_L_M_S_PAIRING: "Dúo Dinámico (Hombre) (Zapatos)",
  T_26_L_M_S_WATERFEST21_A: "Ola de Verano (Zapatos)",
  T_26_L_M_T_EGGDAY2021: "Liebre Futurista (Superior)",
  T_26_L_M_T_PAIRING: "Dúo Dinámico (Hombre) (Superior)",
  T_26_L_M_T_WATERFEST21_A: "Ola de Verano (Superior)",
  T_26_L_S_SANTAMODE: "Muñeco de Nieve (Zapatos)",
  T_26_L_T_SANTAMODE: "Muñeco de Nieve (Superior)",
  T_26_LC_AWM_KOICARP_N: "AWM- Koi de la Suerte",
  T_26_LC_KATANA_VALENTINE2021_N: "Katana- Temporada de Amor",
  T_26_LC_VEHICLE_ROADSTER_COBRA_N: "Auto Deportivo- Cobra",
  T_26_P_SKILL_NAME_DELIVERY: "Daño Entregado",
  T_26_V_TRAINING_BHH: "Martillo de Lujo",
  T_26_V_TRAINING_DICE: "Dado Gigante",
  T_26_W_DRAGON_N: "Draki",
  T_26_W_PETSKIN_DRAGON_EVIL_N: "Aspecto de Mascota: Draki de Agua",
  T_26_W_PETSKIN_DRAGON_GOLDEN_N: "Aspecto de Mascota: Draki de Fuego",
  T_26_W_PETSKIN_DRAGON_PURPLE_N: "Aspecto de Mascota: Draki de la Galaxia",
  T_26_W_PETSKIN_PENGUIN_VALENTINE2021_N: "Aspecto de Mascota: Wagger de Amor",
  T_26_XL_SETTING_TEAMMATE_INFO: "Inf. del Compañero de Equipo",
  T_26_YP_HISTORY_WIN: "Victoria",
  T_26_YP_SOCIAL_GENDER_FEMALE: "Femenino",
  T_26_YP_SOCIAL_GENDER_MALE: "Masculino",
  T_26_YP_SOCIAL_NAME: "Apodo",
  T_27_C_SKILL_DESC__RACERGIRL: "La velocidad al manejar aumenta [FFB300]{0}%[-]. Mientras el personaje está en el vehículo, es más difícil apuntarle y el daño recibido disminuye en [FFB300]{1}%[-].",
  T_27_C_SKILL_DESC_BOUNTYHUNTER: "Crea un campo de fuerza impenetrable que bloquea [FFB300]{0} de daño[-]. No permite atacar a enemigos fuera del campo desde dentro. Duración de todos los efectos [FFB300]{1}s[-]. Enfriamiento [FFB300]{2}s[-].",
  T_27_C_SKILL_DESC_FALCONER: "El daño aumenta con la distancia, hasta [FFB300]{0}%[-]. El daño a los enemigos marcados aumenta un [FFB300]{1}%[-].",
  T_27_C_SKILL_DESC_HAYATO_AWAKENING: "Renacimiento: Reduce el [FFB300]{1}%[-] de daño frontal por cada [FFB300]{0}%[-] de PV perdidos.",
  T_27_C_SKILL_DESC_KELLY_AWAKENING: "Habilidad Renacida: Activada después de [FFB300]{0}s[-] de correr, los primeros [FFB300]{2}[-] disparos al objetivo infligen [FFB300]{1}%[-] de daño. Duración [FFB300]{3}s[-].",
  T_27_C_SKILL_NAME_FALCONER: "Fervor de Halcón",
  T_27_C_SKILL_NAME_XTREME: "Encuentro Extremo",
  T_27_D_CHARACTER_ANDREW_AWAKENING_N: 'Andrew "El Imparable"',
  T_27_D_CHARACTER_FALCONER_N: "Maro",
  T_27_D_CHARACTER_XTREME_N: "Xayne",
  T_27_F_EAP_PKG3_D: "El Estilo de la Batalla",
  T_27_HYL_SKILLBOARD_HP: "PV",
  T_27_L_A_CARDBOARD_MID2: "Cartonigre (Máscara)",
  T_27_L_B_CARDBOARD_REG: "Cartonosito (Inferior)",
  T_27_L_M_S_KAZAKHSTAN: "Caballero del Oriente (Zapatos)",
  T_27_L_S_CARDBOARD_REG: "Cartonosito (Zapatos)",
  T_27_L_T_CARDBOARD_REG: "Cartonosito (Superior)",
  T_27_LC_VECTOR_FFWS2021_N: "Vector- FFWS 2021",
  T_27_LC_VEHICLE_MONSTER_FFWS2021_N: "Camioneta Monster- FFWS 2021",
  T_27_LC_VEHICLE_MOTOBIKE_BOXER_N: "Motocicleta- Noche de K.O.",
  T_27_LC_VEHICLE_ROADSTER_FASTBREAKING_N: "Auto Deportivo- Flash Esmeralda",
  T_27_LC_VEHICLE_SUV_DRAGON_N: "Camioneta Pickup- Dragón de Fuego",
  T_27_P_SKILL_NAME_HITMAN_RE: "Muerte Silenciosa",
  T_27_R_EMOTE_GREETING_NAME: "Gracias",
  T_27_R_VEHICLE_ACCELERATION: "Aceleración",
  T_27_R_VEHICLE_HP: "Durabilidad",
  T_27_R_VEHICLE_SPEED: "Velocidad máxima",
  T_27_U_KORD: "Kord",
  T_27_U_M1917: "M1917",
  T_27_U_SKILL_DESC_ANDREW_AWAKENING: "Renacer: Reducción de daño de armadura aumentada en [FFB300]{0}%[-]. [FFB300]{1}%[-] adicional de reducción de daño por cada compañero que esté a [FFB300]{2}m[-].",
  T_27_U_SKILL_NAME_ANDREW_AWAKENING: "Manada de Lobos",
  T_27_U_WSP: "USP-2",
  T_27_W_ALIEN_N: "Moony",
  T_27_W_ARMOTY_DMR: "Rifle de Tirador",
  T_27_W_PETSKIN_ALIEN_CRYSTAL_N: "Aspecto de Mascota: Moony Cristal",
  T_27_W_PETSKIN_ALIEN_GAMER_N: "Aspecto de Mascota: Moony Gamer",
  T_27_W_PETSKIN_ALIEN_HIPSTER_N: "Aspecto de Mascota: Moony Hipster",
  T_27_W_PETSKIN_DOG_FFWS2021_N: "Aspecto de Mascota: Perrito FFWS 2021",
  T_27_W_PETSKIN_PANDA_FFWS2021_N: "Aspecto de Mascota: Pandita FFWS 2021",
  T_27_XC_REPLAY_DIE: "Muerte",
  T_27_XC_REPLAY_KILL: "Eliminación",
  T_27_XL_WEREWOLVES_INGAME_REPAIR: "Reparar",
  T_28_C_G_ICE_NAME: "Destello de Hielo",
  T_28_C_SKILL_DESC_STREETBEAT: "Al disparar mientras se mueve, la velocidad de movimiento aumenta [FFB300]{0}%[-], la precisión aumenta en un [FFB300]{1}%[-].",
  T_28_C_SKILL_NAME_STREETBEAT: "Balas con Ritmo",
  T_28_D_CHARACTER_STREETBEAT_N: "Di-Bee",
  T_28_HI_UZI: "Mini Uzi",
  T_28_L_B_BRJERSEY_A: "Uniforme de Fútbol N.º 23 (Inferior)",
  T_28_L_B_BRJERSEY_B: "Uniforme de Fútbol N.º 10 (Inferior)",
  T_28_L_B_BRJERSEY_C: "Uniforme de Fútbol N.º 24 (Inferior)",
  T_28_L_B_BRJERSEY_D: "Uniforme de Fútbol N.º 30 (Inferior)",
  T_28_L_B_BRJERSEY_E: "Uniforme de Fútbol N.º 1 (Inferior)",
  T_28_L_B_BRJERSEY_F: "Uniforme de Fútbol N.º 20 (Inferior)",
  T_28_L_F_B_FOURSYMBOLS_C: "Fénix Rubí (Inferior)",
  T_28_L_F_H_FOURSYMBOLS_C: "Fénix Rubí (Cabeza)",
  T_28_L_F_HA_FOURSYMBOLS_C: "Fénix Rubí (Maquillaje)",
  T_28_L_F_S_FOURSYMBOLS_C: "Fénix Rubí (Zapatos)",
  T_28_L_F_T_FOURSYMBOLS_C: "Fénix Rubí (Superior)",
  T_28_L_HA_THUNDER: "Ojo Relámpago (Maquillaje)",
  T_28_L_M_A_SPORTSUIT: "Skater Nocturno (Máscara)",
  T_28_L_M_B_FOURSYMBOLS_D: "Tortuga Esmeralda (Inferior)",
  T_28_L_M_B_SPORTSUIT: "Skater Nocturno (Inferior)",
  T_28_L_M_H_FOURSYMBOLS_D: "Tortuga Esmeralda (Cabeza)",
  T_28_L_M_H_SPORTSUIT: "Skater Nocturno (Cabeza)",
  T_28_L_M_S_FOURSYMBOLS_D: "Tortuga Esmeralda (Zapatos)",
  T_28_L_M_S_SPORTSUIT: "Skater Nocturno (Zapatos)",
  T_28_L_M_T_FALLWINTER: "Ego Peligroso (Superior)",
  T_28_L_M_T_FOURSYMBOLS_D: "Tortuga Esmeralda (Superior)",
  T_28_L_M_T_SPORTSUIT: "Skater Nocturno (Superior)",
  T_28_L_T_BRJERSEY_A: "Uniforme de Fútbol N.º 23 (Superior)",
  T_28_L_T_BRJERSEY_B: "Uniforme de Fútbol N.º 10 (Superior)",
  T_28_L_T_BRJERSEY_C: "Uniforme de Fútbol N.º 24 (Superior)",
  T_28_L_T_BRJERSEY_D: "Uniforme de Fútbol N.º 30 (Superior)",
  T_28_L_T_BRJERSEY_E: "Uniforme de Fútbol N.º 1 (Superior)",
  T_28_L_T_BRJERSEY_F: "Uniforme de Fútbol N.º 20 (Superior)",
  T_28_LC_AN94_CRIMSONBRIDE_N: "AN94- Promesa de Amor",
  T_28_LC_GLOO_FALLWINTER_N: "Pared Gloo- Ego Peligroso",
  T_28_LC_GLOO_FOURSYMBOLS_N: "Pared Gloo- Dragón",
  T_28_LC_KORD_SHINOBI_N: "Kord- Estrellas Ninjas",
  T_28_LC_M21A5_FANTASYEYE_N: "Woodpecker- Hechizo Despiadado",
  T_28_LC_MAG7_WHITESHARK_N: "MAG-7 - Mordida Letal",
  T_28_LC_PAN_FOURSYMBOLS_N: "Sartén- Tortuga Esmeralda",
  T_28_LC_VEHICLE_JEEP_FOURSYMBOLS_N: "Jeep- Dragón",
  T_28_T_WS_ITEM1: "Caja Cuadrada",
  T_28_T_WS_ITEM10: "Cabaña",
  T_28_T_WS_ITEM11: "Torre de Guardia",
  T_28_T_WS_ITEM12: "Puesto Militar",
  T_28_T_WS_ITEM13: "Casa A",
  T_28_T_WS_ITEM14: "Casa B",
  T_28_T_WS_ITEM15: "Casa C",
  T_28_T_WS_ITEM16: "Estructura de Arena",
  T_28_T_WS_ITEM17: "Fuente",
  T_28_T_WS_ITEM18: "Flor de Cerezo",
  T_28_T_WS_ITEM19: "Platanera",
  T_28_T_WS_ITEM2: "Caja Larga",
  T_28_T_WS_ITEM20: "Inodoro",
  T_28_T_WS_ITEM21: "Valla",
  T_28_T_WS_ITEM3: "Arbusto",
  T_28_T_WS_ITEM4: "Paca de Paja",
  T_28_T_WS_ITEM5: "Carro",
  T_28_T_WS_ITEM6: "Autobús",
  T_28_T_WS_ITEM7: "Contenedor A",
  T_28_T_WS_ITEM8: "Contenedor B",
  T_28_T_WS_ITEM9: "Contenedor C",
  T_28_T_WS_TYPE1: "Objetos",
  T_28_T_WS_TYPE4: "Decoraciones",
  T_28_W_DUCK_N: "Don Cuack",
  T_28_W_PETSKIN_DRAGON_FOURSYMBOLS_N: "Aspecto de Mascota: Draki Mítico",
  T_28_W_PETSKIN_DUCK_ARMY_N: "Aspecto de Mascota: Don Cuack Pistolero",
  T_28_W_PETSKIN_DUCK_BLACK_N: "Aspecto de Mascota: Don Cuack Gánster",
  T_28_W_PETSKIN_DUCK_SHINY_N: "Aspecto de Mascota: Don Cuack DJ",
  T_28_YF_AR15: "Kingfisher",
  T_29_C_SKILL_DESC_MOCO_AWAKENING: "Habilidad Renacida: Las marcas de los enemigos impactados duran más cuando los enemigos se mueven, hasta [FFB300]{0}s[-].",
  T_29_C_SKILL_NAME_MOCO_AWAKENING: "Vista Enigmática",
  T_29_C_SKILL_NAME_MUSICBRO_BLACK: "Vibraciones Vitales",
  T_29_C_SKILL_NAME_MUSICBRO_WHITE: "Latido Curativo",
  T_29_D_CHARACTER_AMOCO_N: 'Moco "Enigma"',
  T_29_D_CHARACTER_MUSICBRO1_N: "Dimitri",
  T_29_D_CHARACTER_MUSICBRO2_N: "Thiva",
  T_29_HI_MINI14: "AC80",
  T_29_L_B_TRJERSEY: "Uniforme de Fútbol Rayas (Inferior)",
  T_29_L_M_A_FALCONER_C: "Príncipe Jaguar (Máscara)",
  T_29_L_M_A_JUNGLE_GREEN: "Tortuga de Guerra (Máscara)",
  T_29_L_M_B_FALCONER_C: "Príncipe Jaguar (Inferior)",
  T_29_L_M_B_JUNGLE_GREEN: "Tortuga de Guerra (Inferior)",
  T_29_L_M_H_FALCONER_C: "Príncipe Jaguar (Cabeza)",
  T_29_L_M_H_JUNGLE_GREEN: "Tortuga de Guerra (Cabeza)",
  T_29_L_M_S_FALCONER_C: "Príncipe Jaguar (Zapatos)",
  T_29_L_M_S_JUNGLE_GREEN: "Tortuga de Guerra (Zapatos)",
  T_29_L_M_T_FALCONER_C: "Príncipe Jaguar (Superior)",
  T_29_L_M_T_JUNGLE_GREEN: "Tortuga de Guerra (Superior)",
  T_29_L_T_TRJERSEY: "Uniforme de Fútbol Rayas (Superior)",
  T_29_M_WS_ITEM22: "Contenedor Resistente",
  T_29_M_WS_ITEM23: "Valla Rugosa",
  T_29_M_WS_ITEM24: "Punto de Inicio A",
  T_29_M_WS_ITEM25: "Punto de Inicio B",
  T_29_M_WS_TYPE5: "Interactivos",
  T_29_W_PETSKIN_BROWN_TIGER_N: "Aspecto de Mascota: Tigri Sensei de Tierra",
  T_29_W_PETSKIN_FIRE_TIGER_N: "Aspecto de Mascota: Tigri Sensei de Fuego",
  T_29_W_PETSKIN_HAWK_MOCOMONTH_N: "Aspecto de Mascota: Falco Cibernético",
  T_29_W_PETSKIN_PANDA_MUSICFEST_N: "Aspecto de Mascota: Pandita de Fiesta",
  T_29_W_PETSKIN_WHITE_TIGER_N: "Aspecto de Mascota: Tigri Sensei de Hielo",
  T_29_W_TIGER_NINJA_N: "Tigri Sensei",
  T_29_YF_MACHETE_MUSICFEST_N: "Machete- Ondas Sonoras",
  T_29_YF_MAGEZINE_CHAIN_N: "Cargador RA",
  T_29_YF_MUZZLE_CRASH_N: "Boquilla de subfusil",
  T_29_YF_MUZZLE_WIDE_N: "Boquilla de Escopeta",
  T_29_YF_SPAS12_MOCOMONTH_N: "SPAS12- Navegadora Cósmica",
  T_29_YF_UZI_GOLDENWING_N: "Mini Uzi- Operación Gravedad",
  T_29_YF_VEHICLE_MONSTER_SKELETONTRUCK_N: "Camioneta Monster- Mordedura Loca",
  T_30_AD_RP_ROUNDEND: "FIN DE LA RONDA",
  T_30_AD_TRAINING_SNOWBALL: "Bola de Nieve",
  T_30_AD_TRAINING_SNOWBALL_DES: "¡Tengamos una pelea de bolas de nieve!",
  T_30_C_SKILL_DESC_BOOYAHGUY: "[FFB300]{0}s[-] después de haber sido atacado, recupera [FFB300]{1}PV[-]/s durante [FFB300]{2}s[-].",
  T_30_C_SKILL_NAME_BOOYAHGUY: "Tiro Ganador",
  T_30_C_SKILL_NAME_MUERTOGUY: "Memoria Fotográfica",
  T_30_D_CHARACTER_BOOYAHGUY_N: "Leon",
  T_30_D_CHARACTER_MUERTOGUY_N: "Otho",
  T_30_JMF_SKILLCHIP_NAME_SWATGUY: "Microchip de Jai",
  T_30_L_A_BRMASCOT_ADULT: "Cabeza de pollito enojado",
  T_30_L_A_BRMASCOT_KIDS: "Cabeza de pollito adorable",
  T_30_L_A_SUGARSKULL21_BANDANA: "Mandíbula de Oro",
  T_30_L_B_BRFOOTBALL_BLACK: "Uniforme de Fútbol Negro CBF (Inferior)",
  T_30_L_B_BRFOOTBALL_GREEN: "Uniforme de Fútbol Verde CBF (Inferior)",
  T_30_L_B_BRFOOTBALL_GREY: "Uniforme de Fútbol Gris CBF (Inferior)",
  T_30_L_B_BRUNIFORM: "Pequeño Canario (Inferior)",
  T_30_L_F_A_SUGARSKULL21: "Catrina de Oro (Máscara)",
  T_30_L_F_B_SUGARSKULL21: "Catrina de Oro (Inferior)",
  T_30_L_F_B_THASIAN: "Irreverencia Coral (Inferior)",
  T_30_L_F_H_CATEARS: "Orejas Kawaii",
  T_30_L_F_H_SUGARSKULL21: "Catrina de Oro (Cabeza)",
  T_30_L_F_H_THASIAN: "Irreverencia Coral (Cabeza)",
  T_30_L_F_S_SUGARSKULL21: "Catrina de Oro (Zapatos)",
  T_30_L_F_S_THASIAN: "Irreverencia Coral (Zapatos)",
  T_30_L_F_T_SUGARSKULL21: "Catrina de Oro (Superior)",
  T_30_L_F_T_THASIAN: "Irreverencia Coral (Superior)",
  T_30_L_H_CHILDRENSDAY_BLUE: "Cabeza de Delfín",
  T_30_L_H_CHILDRENSDAY_RED: "Cabeza de Elefante",
  T_30_L_H_CLOWNHAT: "Sombrero de Circo - Amarillo",
  T_30_L_H_ZASCARF: "Bufanda Oro Audaz",
  T_30_L_M_A_LIGHTFEST_GANGSTER: "Gánster de la Luz (Máscara)",
  T_30_L_M_A_SUGARSKULL21: "Catrín de Oro (Máscara)",
  T_30_L_M_B_LIGHTFEST_GANGSTER: "Gánster de la Luz (Inferior)",
  T_30_L_M_B_PKCRICKET: "Críquet Verde (Inferior)",
  T_30_L_M_B_SUGARSKULL21: "Catrín de Oro (Inferior)",
  T_30_L_M_B_SUGARSKULL21_CASUAL: "Papel Picado (Inferior)",
  T_30_L_M_B_THASIAN: "Rebeldía Coral (Inferior)",
  T_30_L_M_H_LIGHTFEST_GANGSTER: "Gánster de la Luz (Cabeza)",
  T_30_L_M_H_SUGARSKULL21: "Catrín de Oro (Cabeza)",
  T_30_L_M_H_SUGARSKULL21_CASUAL: "Papel Picado (Cabeza)",
  T_30_L_M_H_THASIAN: "Rebeldía Coral (Cabeza)",
  T_30_L_M_HA_BOOYAHDAY21_YELLOW: "Esqueleto Alfa (Maquillaje)",
  T_30_L_M_S_LIGHTFEST_GANGSTER: "Gánster de la Luz (Zapatos)",
  T_30_L_M_S_PKCRICKET: "Críquet Verde (Zapatos)",
  T_30_L_M_S_SUGARSKULL21: "Catrín de Oro (Zapatos)",
  T_30_L_M_S_SUGARSKULL21_CASUAL: "Papel Picado (Zapatos)",
  T_30_L_M_S_THASIAN: "Rebeldía Coral (Zapatos)",
  T_30_L_M_T_LIGHTFEST_GANGSTER: "Gánster de la Luz (Superior)",
  T_30_L_M_T_PKCRICKET: "Críquet Verde (Superior)",
  T_30_L_M_T_SUGARSKULL21: "Catrín de Oro (Superior)",
  T_30_L_M_T_SUGARSKULL21_CASUAL: "Papel Picado (Superior)",
  T_30_L_M_T_THASIAN: "Rebeldía Coral (Superior)",
  T_30_L_S_BRUNIFORM: "Pequeño Canario (Zapatos)",
  T_30_L_T_BRFOOTBALL_BLACK: "Uniforme de Fútbol Negro CBF (Superior)",
  T_30_L_T_BRFOOTBALL_GREEN: "Uniforme de Fútbol Verde CBF (Superior)",
  T_30_L_T_BRFOOTBALL_GREY: "Uniforme de Fútbol Gris CBF (Superior)",
  T_30_L_T_BRUNIFORM: "Pequeño Canario (Superior)",
  T_30_M_WS_PARTY_MODE: "Campo de Juegos",
  T_30_R_EMOTE_BATTLEINSTYLE_NAME: "BATTLE IN STYLE",
  T_30_R_EMOTE_BOOYAHDAY21_PROVOCATION_NAME: "El Retador",
  T_30_R_EMOTE_MAX_NAME: "El Rapero",
  T_30_R_LEGEND_HALO_NAME: "Círculo de Calor",
  T_30_T_WS_DEFAULTDESCRIPTION: "Un mapa emocionante en Crea Tu Mapa de Free Fire",
  T_30_T_WS_ITEM26: "Llantas",
  T_30_T_WS_ITEM27: "Llantas A",
  T_30_T_WS_ITEM28: "Llantas B",
  T_30_T_WS_ITEM29: "Llantas C",
  T_30_T_WS_ITEM30: "Autos Chocones",
  T_30_T_WS_ITEM31: "Auto Anfibio",
  T_30_T_WS_ITEM32: "Jeep",
  T_30_T_WS_ITEM33: "Bote de Basura",
  T_30_T_WS_ITEM34: "Parador",
  T_30_T_WS_ITEM35: "Carpa Médica",
  T_30_T_WS_ITEM36: "Garaje",
  T_30_T_WS_ITEM37: "Paredes Pintadas",
  T_30_T_WS_ITEM38: "Torii",
  T_30_T_WS_ITEM39: "Plataforma de Hierro",
  T_30_T_WS_ITEM40: "Cabaña Alta",
  T_30_T_WS_ITEM41: "Camper",
  T_30_T_WS_ITEM42: "Pared A",
  T_30_T_WS_ITEM43: "Pared B",
  T_30_T_WS_ITEM44: "Pared C",
  T_30_T_WS_ITEM45: "Pared D",
  T_30_T_WS_ITEM46: "Pared E",
  T_30_T_WS_ITEM47: "Pared F",
  T_30_U_ATTACHMENT_1: "Potenciador de Escudo",
  T_30_U_ATTACHMENT_4: "Chaleco con protección completa",
  T_30_U_ATTACHMENT_5: "Casco con Protección de Cabeza",
  T_30_U_ATTACHMENT_6: "Chaleco con Reducción de Explosiones",
  T_30_W_PETSKIN_BABOON_SUGARSKULL21_N: "Aspecto de Mascota: Bestión Calavera",
  T_30_W_PETSKIN_PENGUIN_EVILRHYTHM_N: "Aspecto de Mascota: Wagger Punk",
  T_30_W_PETSKIN_RABBIT_BULLSEYE_N: "Aspecto de Mascota: Agente C Tiro al Blanco",
  T_30_W_PETSKIN_RABBIT_CLOWN_N: "Aspecto de Mascota: Agente C Carnaval",
  T_30_W_PETSKIN_RABBIT_URBAN_N: "Aspecto de Mascota: Agente C Cibernética",
  T_30_W_PETSKIN_ROBOT_TRNAZAR_N: "Aspecto de Mascota: Robo Nazar",
  T_30_W_PETSKIN_ROBOT_VNDRINK_N: "Aspecto de Mascota: Robo Congelado",
  T_30_W_RABBIT_N: "Agente C",
  T_30_XH_PCMAP_P17: "Factory",
  T_30_YF_GLOO_BOOYAHDAY21_N: "Pared Gloo- DÍA BOOYAH 2021",
  T_30_YF_GRENADE_BOOYAHDAY21_N: "Granada- DÍA BOOYAH 2021",
  T_30_YF_Healinggun_Sniper_N: "Rifle Curativo",
  T_30_YF_MINI_LIGHTFEST_N: "AC80- Príncipe de la Luz",
  T_30_YF_PARAFAL_ZATRIBAL_N: "PARAFAL- Heredero Carmín",
  T_30_YF_SCAR_LIGHTFEST_N: "SCAR- Príncipe de la Luz",
  T_30_YF_THOMPSON_SUGARSKULL21_N: "Thompson- Tributo de Oro",
  T_30_YF_VEHICLE_ROADSTER_EVILRHYTHM_N: "Auto Deportivo- Cráneo Tóxico",
  T_31_C_SKILL_NAME_WINTERGUY: "Hierro de Hielo",
  T_31_HQ_BASEBALLBAT_WINTERFEST21_N: "Bate- Golpe Invernal",
  T_31_HQ_GLOO_EAGLE_N: "Pared Gloo- Desierto y Calor",
  T_31_HQ_HEALINGSNIPER_WINTERFEST21_N: "Rifle Curativo- Huesos de Hielo",
  T_31_HQ_KATANA_WINTERFEST21_N: "Katana - Domo de Nieve",
  T_31_HQ_PAN_WINTERFEST21_N: "Sartén - Domo de Nieve",
  T_31_HQ_PETSKIN_OTTER_WINTERFEST21_N: "Aspecto de Mascota: Lutrino de Nieve",
  T_31_HQ_PETSKIN_PENGUIN_WINTERFEST21_N: "Aspecto de Mascota: Sr. Wagger en Hielo",
  T_31_HQ_PETSKIN_YETI_GREEN_N: "Aspecto de Mascota: Yeti Tribal",
  T_31_HQ_PETSKIN_YETI_RED_N: "Aspecto de Mascota: Yeti en Llamas",
  T_31_HQ_SICKLE_WINTERFEST21_N: "Hoz de la Nieve",
  T_31_HQ_VEHICLE_MOTOBIKE_NEWYEAR21_N: "Motocicleta- Flores de Hielo",
  T_31_HQ_YETI_N: "Yeti",
  T_31_KK_WINTER_BUJIX: "Caja de Suministros",
  T_31_KK_WINTER_SANJITOU: "Casco",
  T_31_L_A_BDCRICKET: "Críquet y Victoria (Máscara)",
  T_31_L_A_WINTERFEST21: "Reno Infernal",
  T_31_L_B_BDCRICKET: "Críquet y Victoria (Inferior)",
  T_31_L_B_MEJERSEY_10: "Uniforme Rubí N.º 10 (Inferior)",
  T_31_L_B_MEJERSEY_11: "Uniforme Rojo N.º 11 (Inferior)",
  T_31_L_B_MEJERSEY_13: "Uniforme Blanco N.º 13 (Inferior)",
  T_31_L_B_MEJERSEY_18G: "Uniforme Verde N.º 18 (Inferior)",
  T_31_L_B_MEJERSEY_18R: "Uniforme Marrón N.º 18 (Inferior)",
  T_31_L_B_MEJERSEY_7: "Uniforme Verde N.º 7 (Inferior)",
  T_31_L_F_B_RUMUSICIAN: "Realidad Atada (Inferior)",
  T_31_L_F_B_THAGENT: "Capitana del Anochecer (Inferior)",
  T_31_L_F_H_REGGAETON_HEADWEAR: "Acá Arriba (Mujer)",
  T_31_L_F_H_RUMUSICIAN: "Realidad Atada (Cabeza)",
  T_31_L_F_H_THAGENT: "Capitana del Anochecer (Cabeza)",
  T_31_L_F_HA_RUMUSICIAN: "Realidad Atada (Maquillaje)",
  T_31_L_F_S_RUMUSICIAN: "Realidad Atada (Zapatos)",
  T_31_L_F_S_THAGENT: "Capitana del Anochecer (Zapatos)",
  T_31_L_F_T_RUMUSICIAN: "Realidad Atada (Superior)",
  T_31_L_F_T_THAGENT: "Capitana del Anochecer (Superior)",
  T_31_L_HA_RUMUSICIAN_MU: "Trance Atado (Maquillaje)",
  T_31_L_HA_WINTERFEST21_BLUE: "Payaso Congelado (Maquillaje)",
  T_31_L_HA_WINTERFEST21_PINK: "Chispas de Fuego Rosa (Maquillaje)",
  T_31_L_M_A_REGGAETON_B: "Aquí Todo Se Vale (Máscara)",
  T_31_L_M_A_REGGAETON_P: "Energía Prismática (Máscara)",
  T_31_L_M_A_RUMUSICIAN: "Trance Atado (Máscara)",
  T_31_L_M_A_THAGENT: "Capitán del Anochecer (Máscara)",
  T_31_L_M_B_PKCOSTUME: "Inteligencia Esmeralda (Inferior)",
  T_31_L_M_B_REGGAETON_B: "Aquí Todo Se Vale (Inferior)",
  T_31_L_M_B_REGGAETON_P: "Energía Prismática (Inferior)",
  T_31_L_M_B_RUMUSICIAN: "Trance Atado (Inferior)",
  T_31_L_M_B_THAGENT: "Capitán del Anochecer (Inferior)",
  T_31_L_M_H_GREENCAP: "Gorra de Ganador",
  T_31_L_M_H_PKCOSTUME: "Inteligencia Esmeralda (Cabeza)",
  T_31_L_M_H_REGGAETON_B: "Aquí Todo Se Vale (Cabeza)",
  T_31_L_M_H_REGGAETON_HEADWEAR: "Acá Arriba (Hombre)",
  T_31_L_M_H_REGGAETON_P: "Energía Prismática (Cabeza)",
  T_31_L_M_H_RUMUSICIAN: "Trance Atado (Cabeza)",
  T_31_L_M_H_THAGENT: "Capitán del Anochecer (Cabeza)",
  T_31_L_M_S_PKCOSTUME: "Inteligencia Esmeralda (Zapatos)",
  T_31_L_M_S_REGGAETON_B: "Aquí Todo Se Vale (Zapatos)",
  T_31_L_M_S_REGGAETON_P: "Energía Prismática (Zapatos)",
  T_31_L_M_S_RUMUSICIAN: "Trance Atado (Zapatos)",
  T_31_L_M_S_THAGENT: "Capitán del Anochecer (Zapatos)",
  T_31_L_M_T_PKCOSTUME: "Inteligencia Esmeralda (Superior)",
  T_31_L_M_T_REGGAETON_B: "Aquí Todo Se Vale (Superior)",
  T_31_L_M_T_REGGAETON_P: "Energía Prismática (Superior)",
  T_31_L_M_T_REGGAETON_TATOO: "Mi Historia (Tatuaje)",
  T_31_L_M_T_RUMUSICIAN: "Trance Atado (Superior)",
  T_31_L_M_T_THAGENT: "Capitán del Anochecer (Superior)",
  T_31_L_S_BDCRICKET: "Críquet y Victoria (Zapatos)",
  T_31_L_T_BDCRICKET: "Críquet y Victoria (Superior)",
  T_31_L_T_BRBANK: "Chamarra Marrón",
  T_31_L_T_MEJERSEY_10: "Uniforme Rubí N.º 10 (Superior)",
  T_31_L_T_MEJERSEY_11: "Uniforme Rojo N.º 11 (Superior)",
  T_31_L_T_MEJERSEY_13: "Uniforme Blanco N.º 13 (Superior)",
  T_31_L_T_MEJERSEY_18G: "Uniforme Verde N.º 18 (Superior)",
  T_31_L_T_MEJERSEY_18R: "Uniforme Marrón N.º 18 (Superior)",
  T_31_L_T_MEJERSEY_7: "Uniforme Verde N.º 7 (Superior)",
  T_31_L_T_PKMOBILE: "Playera Infinix",
  T_31_L_T_REGGAETON_HOOD: "Sudadera Pa' Mi Gente",
  T_31_MF_CHARACTER_WINTERGUY_N: "Nairi",
  T_31_R_EMOTE_FALCONER_NAME: "Número 1",
  T_31_RW_COMBINEMACHINE_2: "Activador Akimbo (Avanzado)",
  T_31_RW_VIBRATION_EXPLOSION: "Explosiones",
  T_31_RW_VIBRATION_MELEEWEAPONS: "Armas cuerpo a cuerpo",
  T_31_RW_VIBRATION_OTHERWEAPONS: "Otras armas",
  T_31_T_WS_1PLAYERTEAM: "Solo",
  T_31_T_WS_2PLAYERTEAM: "Dúo",
  T_31_T_WS_3PLAYERTEAM: "Trío",
  T_31_T_WS_4PLAYERTEAM: "Escuadra",
  T_31_T_WS_5PLAYERTEAM: "Contra 5",
  T_31_T_WS_6PLAYERTEAM: "Contra 6",
  T_31_T_WS_BUFFTIME_TITLE: "Tiempo de actualización (s)",
  T_31_T_WS_BUFFTYPE_AMMO: "Munición",
  T_31_T_WS_BUFFTYPE_ARMOR: "Armadura",
  T_31_T_WS_BUFFTYPE_HP: "PV",
  T_31_T_WS_BUFFTYPE_RANDOM: "Aleatorio",
  T_31_T_WS_BUFFTYPE_TITLE: "Tipo de mejora",
  T_31_T_WS_DESC48: "Te lleva a otro lugar, en milisegundos",
  T_31_T_WS_DESC49: "Crea el sonido de un piano",
  T_31_T_WS_DESC51: "Crea el sonido de un tambor",
  T_31_T_WS_DESC53: "Crea el sonido de un sintetizador",
  T_31_T_WS_DESC59: "Un dispositivo que periódicamente genera un beneficio. Recógelo para obtener la mejora correspondiente",
  T_31_T_WS_DRUMTYPE_CLAPS: "Aplauso",
  T_31_T_WS_DRUMTYPE_HIHATS: "Plato Hi-hat",
  T_31_T_WS_DRUMTYPE_KICK: "Bombo",
  T_31_T_WS_DRUMTYPE_OPENHIHATS: "Plato Crash",
  T_31_T_WS_DRUMTYPE_RIDES: "Plato Ride",
  T_31_T_WS_DRUMTYPE_SNARES: "Tambor de Caja",
  T_31_T_WS_EARLYSHRINK: "Reducción rápida",
  T_31_T_WS_ITEM48: "Portal",
  T_31_T_WS_ITEM49: "Llave de piano",
  T_31_T_WS_ITEM51: "Llave de tambor",
  T_31_T_WS_ITEM53: "Combo A",
  T_31_T_WS_ITEM55: "Combo B",
  T_31_T_WS_ITEM57: "Combo C",
  T_31_T_WS_ITEM59: "Generador de Mejoras",
  T_31_T_WS_LATESHRINK: "Reducción tardía",
  T_31_T_WS_ME_DAMAGE: "Daño infligido",
  T_31_T_WS_ME_DAMAGED: "Daño recibido",
  T_31_T_WS_ME_DEFAULTEPPERCENT: "Proporción inicial de PE",
  T_31_T_WS_ME_DEFAULTSAFERADIUS: "Radio de la primera zona segura",
  T_31_T_WS_ME_EPQUICKRESTORE: "Conversión rápida de EP",
  T_31_T_WS_ME_FLOW: "Modo",
  T_31_T_WS_ME_GENERALSETTING: "General",
  T_31_T_WS_ME_INRANDOMSPAWN: "Punto de Inicio Aleatorio",
  T_31_T_WS_ME_KILLSCORE: "Bonus de Eliminación",
  T_31_T_WS_ME_MAXEP: "PE Máximo",
  T_31_T_WS_ME_MAXHP: "PV Máximo",
  T_31_T_WS_ME_NEARTEAM: "Compañeros de equipo cercanos",
  T_31_T_WS_ME_REBIRTH: "Tiempo de espera de reaparición",
  T_31_T_WS_ME_REBIRTHLOCATION: "Ubicación de reaparición",
  T_31_T_WS_ME_SAFEZONESHRINKTIME: "Hora de inicio de la reducción de zona",
  T_31_T_WS_ME_WINSCORE: "Puntuación Ganadora",
  T_31_T_WS_MINIZONE: "Mini Zona",
  T_31_T_WS_MUSICTYPE_TITLE: "Tipo de música",
  T_31_T_WS_UNLIMITEDAMMO: "Munición ilimitada",
  T_31_WT_WS_DESC1: "Una caja de madera cuadrada que se puede apilar",
  T_31_WT_WS_DESC10: "Una cabaña destartalada con escaleras de madera para subir",
  T_31_WT_WS_DESC11: "Construida con múltiples ventanas para disparar",
  T_31_WT_WS_DESC12: "Fabricada en metal, contiene puertas y ventanas.",
  T_31_WT_WS_DESC13: "Contiene puertas y ventanas",
  T_31_WT_WS_DESC14: "Una casa de dos pisos con terraza",
  T_31_WT_WS_DESC15: "Una casa de dos pisos con techo",
  T_31_WT_WS_DESC16: "Decoración: Una estatua de arena en forma de corazón",
  T_31_WT_WS_DESC17: "Decoración: Una fuente de agua cristalina",
  T_31_WT_WS_DESC18: "Decoración: Un árbol de flores rosadas",
  T_31_WT_WS_DESC19: "Decoración: Un pequeño árbol de plátano sin plátanos",
  T_31_WT_WS_DESC2: "Una caja de madera rectangular que se puede apilar",
  T_31_WT_WS_DESC20: "Un mueble de baño blanco que se puede colocar en interiores",
  T_31_WT_WS_DESC21: "Una pequeña valla que se puede usar para dividir áreas",
  T_31_WT_WS_DESC22: "La tabla de madera lateral de este contenedor se puede romper con fuerza",
  T_31_WT_WS_DESC23: "La tabla de madera lateral de este contenedor se puede romper con fuerza",
  T_31_WT_WS_DESC24: "Zona de inicio del equipo A (Solo válido en Duelo de Escuadras, Combate a Muerte y Campo de Juegos)",
  T_31_WT_WS_DESC25: "Zona de inicio del equipo B (Solo válido en Duelo de Escuadras, Combate a Muerte y Campo de Juegos)",
  T_31_WT_WS_DESC26: "Envía a los jugadores en la dirección en la que miran, por una distancia corta",
  T_31_WT_WS_DESC27: "Envía a los jugadores en la dirección preestablecida, por una distancia corta",
  T_31_WT_WS_DESC28: "Envía a los jugadores en la dirección preestablecida, a una distancia media",
  T_31_WT_WS_DESC29: "Envía a los jugadores en la dirección preestablecida, a larga distancia",
  T_31_WT_WS_DESC3: "Adornado con flores rojas y amarillas que pueden iluminar tu campo de batalla",
  T_31_WT_WS_DESC30: "Un auto chocón que se puede conducir",
  T_31_WT_WS_DESC31: "Un automóvil anfibio que se puede conducir",
  T_31_WT_WS_DESC32: "Un jeep que se puede conducir",
  T_31_WT_WS_DESC33: "Lleno de basura. Más bajo que un humano, pero puede proporcionar cierta cobertura",
  T_31_WT_WS_DESC34: "Cobertura metálica para pista de carreras al aire libre",
  T_31_WT_WS_DESC35: "Una carpa mediana con dos puertas pero sin ventanas",
  T_31_WT_WS_DESC36: "Un gran garaje construido con ladrillos",
  T_31_WT_WS_DESC37: "Una gran pared de ladrillos que se puede usar para dividir áreas",
  T_31_WT_WS_DESC38: "Un punto destacado útil",
  T_31_WT_WS_DESC39: "Una gran plataforma metálica que se puede usar como principal campo de combate",
  T_31_WT_WS_DESC4: "Más alto que un humano, puede actuar como cubierta",
  T_31_WT_WS_DESC40: "Parece un vehículo recreativo y tiene varias puertas y ventanas",
  T_31_WT_WS_DESC41: "Parece un vehículo recreativo y tiene una puerta y varias ventanas",
  T_31_WT_WS_DESC42: "Una pared de un solo lado con una entrada",
  T_31_WT_WS_DESC43: "Una pared normal de un solo lado",
  T_31_WT_WS_DESC44: "Una pared de esquina",
  T_31_WT_WS_DESC45: "Una pared de esquina irregular",
  T_31_WT_WS_DESC46: "Una pared de esquina irregular",
  T_31_WT_WS_DESC47: "Una pared de esquina con ventanas",
  T_31_WT_WS_DESC5: "Un automóvil abandonado que es un poco más pequeño que un humano, pero que puede proporcionar cierta cobertura",
  T_31_WT_WS_DESC6: "Más alto que un humano, puede funcionar como cubierta",
  T_31_WT_WS_DESC7: "Se abre en ambos extremos y se puede organizar para formar caminos o dividir áreas",
  T_31_WT_WS_DESC8: "Se abre de un extremo y se puede utilizar para dividir áreas",
  T_31_WT_WS_DESC9: "Sellado en ambos extremos y se puede usar para dividir áreas",
  T_31_YF_MAC10_N: "MAC10",
  T_31_YM_PIN_VEHICLE: "Vehículo",
  T_31_Z_OB_UAV: "UAV",
  T_32_C_SKILL_DESC_YAKUZA: "Avanza a gran velocidad durante [FFB300]{0}s[-]. Esta habilidad se puede acumular hasta por [FFB300]{2} usos[-], con un enfriamiento de [FFB300]{3}s[-] entre cada uso. Tiempo de reposición: [FFB300]{1}s.[-]",
  T_32_C_SKILL_NAME_YAKUZA: "Ataque Rebelde",
  T_32_HQ_AUG_VNSTREET_N: "AUG- Felina de Agua",
  T_32_HQ_BACKPACK_REDDRAGON_N: "Mochila Luz del Amanecer",
  T_32_HQ_BLT_VALENTINE2022_N: "M82B- Vampiro Infernal",
  T_32_HQ_GLOO_DUNHUANG_N: "Pared Gloo- Platino Oriental",
  T_32_HQ_GLOO_HURRICANE_2_N: "Pared Gloo- Núcleo de Aurora",
  T_32_HQ_GRENADE_HURRICANE_N: "Granada- Mic Gato Metálico",
  T_32_HQ_MAC10_DUNHUANG_N: "MAC10- Platino Oriental",
  T_32_HQ_PETSKIN_DUCK_RED_N: "Aspecto de Mascota: Don Cuack Rojo",
  T_32_HQ_PETSKIN_TORTOISE_BLUE_N: "Aspecto de Mascota: Flash Cibérnetico",
  T_32_HQ_PETSKIN_TORTOISE_GREEN_N: "Aspecto de Mascota: Flash Gamer",
  T_32_HQ_PETSKIN_TORTOISE_RED_N: "Aspecto de Mascota: Flash en Festival",
  T_32_HQ_TORTOISE_N: "Flash",
  T_32_HQ_VEHICLE_ROADSTER_UNDERTAKER_N: "Auto Deportivo- Espíritu Desterrado",
  T_32_L_F_A_PHARAOH: "Reina Faraona (Máscara)",
  T_32_L_F_B_PHARAOH: "Reina Faraona (Inferior)",
  T_32_L_F_H_PHARAOH: "Reina Faraona (Cabeza)",
  T_32_L_F_HA_PHARAOH: "Reina Faraona (Maquillaje)",
  T_32_L_F_S_PHARAOH: "Reina Faraona (Zapatos)",
  T_32_L_F_T_PHARAOH: "Reina Faraona (Superior)",
  T_32_L_M_A_JUNKFOOD: "Chico Pizza (Máscara)",
  T_32_L_M_A_PHARAOH: "Rey Momia (Máscara)",
  T_32_L_M_B_JUNKFOOD: "Chico Pizza (Inferior)",
  T_32_L_M_B_PHARAOH: "Rey Momia (Inferior)",
  T_32_L_M_H_JUNKFOOD: "Chico Pizza (Cabeza)",
  T_32_L_M_H_PHARAOH: "Rey Momia (Cabeza)",
  T_32_L_M_S_JUNKFOOD: "Chico Pizza (Zapatos)",
  T_32_L_M_S_PHARAOH: "Rey Momia (Zapatos)",
  T_32_L_M_T_JUNKFOOD: "Chico Pizza (Superior)",
  T_32_L_M_T_PHARAOH: "Rey Momia (Superior)",
  T_32_L_T_WHITESWEATER: "Cuello de Tortuga Blanco",
  T_32_LC_NEWVAULT_EMOTE: "Emote",
  T_32_LO_WS_IMMORTAL: "Zona Inmortal",
  T_32_LO_WS_ITEM60: "Tubería",
  T_32_LO_WS_ITEM60_DESC: "Un túnel transitable",
  T_32_LO_WS_ITEM61: "Tubería T",
  T_32_LO_WS_ITEM61_DESC: "Un túnel en T transitable",
  T_32_LO_WS_ITEM62: "Intersección de tubería",
  T_32_LO_WS_ITEM62_DESC: "Un túnel transitable que se cruza",
  T_32_LO_WS_ITEM63: "Esquina de tubería",
  T_32_LO_WS_ITEM63_DESC: "Un túnel en ángulo transitable",
  T_32_LO_WS_ITEM64: "Food Truck",
  T_32_LO_WS_ITEM64_DESC: "Detente aquí para comer algo",
  T_32_LO_WS_ITEM65: "Hongote",
  T_32_LO_WS_ITEM65_DESC: "Un hongo grande que puede transportar a un humano",
  T_32_LO_WS_ITEM66: "Percha",
  T_32_LO_WS_ITEM66_DESC: "Comúnmente visto en áreas residenciales",
  T_32_LO_WS_ITEM67: "Tablón de madera",
  T_32_LO_WS_ITEM67_DESC: "Úsalo para hacer un simple puente de madera",
  T_32_LO_WS_ITEM68: "Pantalla de Celosía",
  T_32_LO_WS_ITEM68_DESC: "Una sensación oriental",
  T_32_LO_WS_ITEM69: "Pilar",
  T_32_LO_WS_ITEM69_DESC: "Comúnmente visto en sitios de construcción",
  T_32_LO_WS_ITEM70: "Cactus",
  T_32_LO_WS_ITEM70_DESC: "Poderoso y grande pero no pica",
  T_32_LO_WS_ITEM71: "Árbol Sin Hojas",
  T_32_LO_WS_ITEM71_DESC: "Un árbol que ha vivido durante siglos",
  T_32_LO_WS_ITEM72: "Linterna de Piedra",
  T_32_LO_WS_ITEM72_DESC: "Decoración escénica en jardines imperiales",
  T_32_LO_WS_ITEM73: "Farola",
  T_32_LO_WS_ITEM73_DESC: "Comúnmente visto en las calles",
  T_32_LO_WS_ITEM74: "Panel Solar",
  T_32_LO_WS_ITEM74_DESC: "Absorbe la energía de la luz solar",
  T_32_LO_WS_ITEM75: "Aire Acondicionado A",
  T_32_LO_WS_ITEM75_DESC: "Mantente fresco en el calor",
  T_32_LO_WS_ITEM76: "Ventilador",
  T_32_LO_WS_ITEM77: "Sartén Volador",
  T_32_LO_WS_ITEM78: "Cubo",
  T_32_LO_WS_ITEM79: "Anillo",
  T_32_LO_WS_ITEM80: "Martillo",
  T_32_LO_WS_ITEM81: "Tablero",
  T_32_LO_WS_ITEM82: "Objetivo de Tiro",
  T_32_LO_WS_ITEM83: "Pared Flexible",
  T_32_LO_WS_ITEM84AMMO: "Punto de Municiones",
  T_32_LO_WS_ITEM84AMMO_DESC: "Cuando se colocan, los tipos de municiones seleccionados aparecerán ahí",
  T_32_LO_WS_ITEM84AR: "Punto de Armaduras",
  T_32_LO_WS_ITEM84AR_DESC: "Cuando se colocan, los tipos de armaduras seleccionados aparecerán ahí",
  T_32_LO_WS_ITEM84ARLV1: "Armadura Nvl. 1",
  T_32_LO_WS_ITEM84ARLV2: "Armadura Nvl. 2",
  T_32_LO_WS_ITEM84ARLV3: "Armadura Nvl. 3",
  T_32_LO_WS_ITEM84CO: "Punto de Consumibles",
  T_32_LO_WS_ITEM84CO_DESC: "Cuando se colocan, los tipos de consumibles seleccionados aparecerán ahí",
  T_32_LO_WS_ITEM84JA: "Punto de Objetos Lanzables",
  T_32_LO_WS_ITEM84JA_DESC: "Cuando se colocan, los tipos de lanzables seleccionados aparecerán ahí",
  T_32_LO_WS_ITEM84TE: "Punto de Miras",
  T_32_LO_WS_ITEM84TE_DESC: "Cuando se colocan, los tipos de miras seleccionados aparecerán ahí",
  T_32_LO_WS_ITEM84W: "Punto de Armas",
  T_32_LO_WS_ITEM84W_DESC: "Cuando se colocan, los tipos de armas seleccionados aparecerán ahí",
  T_32_LO_WS_ITEM85: "Zona inmortal/fatal",
  T_32_LO_WS_ITEM85_DESC: "Cuando se colocan, los jugadores que lo toquen experimentarán un efecto específico inmortal o fatal. (No válido en Duelo de Escuadras, Combate a Muerte y Campo de Juegos)",
  T_32_LO_WS_ITEM85CP: "Punto de Control",
  T_32_LO_WS_ITEM85CP_DESC: "Un elemento obligatorio en el modo Parkour. Los jugadores deben pasar por cada punto de control, uno por uno. Cuando es noqueado, el jugador reaparecerá en el último punto de control que haya pasado. (No válido en Duelo de Escuadras, Combate a Muerte y Campo de Juegos)",
  T_32_LO_WS_ITEM85TM: "Punto Final",
  T_32_LO_WS_ITEM85TM_DESC: "Un elemento obligatorio en el modo Parkour. Los jugadores deben llegar dentro del área de este elemento para completar la partida. (No válido en Duelo de Escuadras, Combate a Muerte y Campo de Juegos)",
  T_32_LO_WS_ITEM86: "Punto de Inicio",
  T_32_LO_WS_ITEM86_DESC: "No se asignará a ningún equipo en específico a este punto. Cuando se coloque, un equipo aleatorio aparecerá ahí. (No válido en Duelo de Escuadras, Combate a Muerte y Campo de Juegos)",
  T_32_LO_WS_ITEM86L: "Punto de Inicio Principal",
  T_32_LO_WS_ITEM86L_DESC: "El punto de inicio principal del modo Parkour, es el punto donde todos los jugadores aparecerán. (No válido en Duelo de Escuadras, Combate a Muerte y Campo de Juegos)",
  T_32_LO_WS_ITEM87: "Bloque",
  T_32_LO_WS_ITEM87_DESC: "Permite la personalización del tamaño",
  T_32_LO_WS_ITEM88: "Cuboide o pendiente",
  T_32_LO_WS_ITEM88_DESC: "Un cuboide o pendiente cuyo tamaño se puede ajustar.",
  T_32_LO_WS_ITEMLINE: "Cambio",
  T_32_LO_WS_ITEMMOVE: "Ajuste de Puntos P.",
  T_32_LO_WS_ITEMROT: "Transformar",
  T_32_LO_WS_ITEMSCALE: "Escala",
  T_32_LO_WS_KILLZONE: "Zona de Condena",
  T_32_LO_WS_LOOT_AMMOTYPE: "Munición",
  T_32_LO_WS_LOOT_ARTYPE: "Armadura",
  T_32_LO_WS_LOOT_COTYPE: "Consumible",
  T_32_LO_WS_LOOT_JATYPE: "Lanzables",
  T_32_LO_WS_LOOT_RANDOM: "Aleatorio",
  T_32_LO_WS_LOOT_TETYPE: "Mira",
  T_32_LO_WS_LOOT_WEAPONTYPE: "Arma",
  T_32_LO_WS_SCALEX: "Longitud",
  T_32_LO_WS_SCALEY: "Altura",
  T_32_LO_WS_SCALEZ: "Ancho",
  T_32_LO_WS_TRIGGERH: "Ocultar",
  T_32_LO_WS_TRIGGERHORP: "Mostrar/Ocultar Puntos P.",
  T_32_LO_WS_TRIGGERP: "Mostrar",
  T_32_LO_WS_TRIGGERTYPE: "Tipo de Puntos P.",
  T_32_M_WS_MODE_ANNIHILATE: "Exterminio",
  T_32_M_WS_MODE_SCORE: "Puntos",
  T_32_M_WS_MODE_SPEED: "Parkour",
  T_32_M_WS_MULTIPLETEAMS: "Combate de Varios Equipos",
  T_32_M_WS_ROUNDS: "Rondas",
  T_32_R_EMOTE_HURRICANE_BLUE_NAME: "Pasos Intercalados",
  T_32_RW_WEAPON_M1887TD_NAME: "M1887-X",
  T_32_T_WS_ME_BLUECIRCLE: "Zona de Peligro",
  T_32_T_WS_ME_BLUECIRCLEDAMAGE: "Daño",
  T_32_T_WS_ME_BLUECIRCLESETTING: "Zona de Peligro",
  T_32_T_WS_ME_CUSTOM: "Personalizar",
  T_32_T_WS_ME_ENDTYPE1: "Exterminio",
  T_32_T_WS_ME_ENDTYPE2: "Puntos",
  T_32_T_WS_ME_ENDTYPE3: "Parkour",
  T_32_T_WS_ME_ENDTYPEDESC1: "Sean el último equipo en sobrevivir",
  T_32_T_WS_ME_ENDTYPEDESC2: `Un modo basado en puntos en el que gana el primer equipo que alcance la puntuación objetivo.
Puedes establecer las reglas de juego y editar los parámetros de juego como quieras, incluyendo la configuración de la puntuación que se otorga por eliminar a un jugador.`,
  T_32_T_WS_ME_ENDTYPEDESC3: `Un modo parkour en el que gana el primer equipo cuyos miembros lleguen a la meta.
Puedes establecer las reglas del juego, los objetos que atravesar y la meta como prefieras.`,
  T_32_T_WS_ME_MATCHTIME: "Tiempo de la partida",
  T_32_T_WS_ME_MECHANIC: "Mecánica",
  T_32_T_WS_ME_NEARCHECKPOINT: "Punto de control cercano",
  T_32_T_WS_ME_PLAYERNUMLIMIT: "No disponible para tener más de 12 jugadores en total",
  T_32_T_WS_ME_PREGAMETIME: "Tiempo de Preparación",
  T_32_T_WS_ME_RESPAWN: "Reaparición",
  T_32_T_WS_ME_RESPAWNSETTING: "Reaparición",
  T_32_T_WS_ME_ROUNDNUM: "Número de rondas",
  T_32_T_WS_ME_ROUNDOPEN: "Habilitar múltiples rondas",
  T_32_T_WS_ME_ROUNDRESET: "Restablecer equipamiento",
  T_32_T_WS_ME_ROUNDSETTING: "Rondas",
  T_32_T_WS_ME_SAFEZONESHRINKTIME2: "Duración de reducción de zona",
  T_32_T_WS_ME_SCORESETTING: "Puntuación",
  T_32_T_WS_ME_TEAMMATENUM: "Miembros por equipo",
  T_32_T_WS_ME_TEAMNUM: "Número de equipos",
  T_32_T_WS_ME_TEAMSETTING: "Equipo",
  T_32_U_ATTACHMENT_8: "Capacidad Extra",
  "T_32_U_GOLD_FAMAS-I": "Famas-I",
  "T_32_U_GOLD_FAMAS-II": "Famas-II",
  "T_32_U_GOLD_FAMAS-III": "Famas-III",
  T_32_U_GOLD_HEATGUN_I: "PLASMA-I",
  T_32_U_GOLD_HEATGUN_II: "PLASMA-II",
  T_32_U_GOLD_HEATGUN_III: "PLASMA-III",
  T_32_U_GOLD_KAR98K_I: "Kar98K-I",
  T_32_U_GOLD_KAR98K_II: "Kar98K-II",
  T_32_U_GOLD_KAR98K_III: "Kar98K-III",
  T_32_U_GOLD_M14_I: "M14-I",
  T_32_U_GOLD_M14_II: "M14-II",
  T_32_U_GOLD_M14_III: "M14-III",
  "T_32_U_GOLD_M4A1-I": "M4A1-I",
  "T_32_U_GOLD_M4A1-II": "M4A1-II",
  "T_32_U_GOLD_M4A1-III": "M4A1-III",
  T_32_U_GOLD_M60_I: "M60-I",
  T_32_U_GOLD_M60_II: "M60-II",
  T_32_U_GOLD_M60_III: "M60-III",
  T_32_U_GOLD_MP5_I: "MP5-I",
  T_32_U_GOLD_MP5_II: "MP5-II",
  T_32_U_GOLD_MP5_III: "MP5-III",
  T_32_U_GOLD_VSS_I: "VSS-I",
  T_32_U_GOLD_VSS_II: "VSS-II",
  T_32_U_GOLD_VSS_III: "VSS-III",
  T_32_U_REPLACER: "Chip de mejora",
  T_32_WT_WS_BARRIER: "Barreras",
  T_32_WT_WS_BDS: "Edificios",
  T_32_WT_WS_MMINVALIDERROR: "Código de mapa no válido",
  T_32_WT_WS_TRGS: "Puntos Principales",
  T_32_YF_CHARGESHOT_N: "Charge Buster",
  T_32_YF_GOLD_GROZA_N: "GROZA-X",
  T_32_YF_GOLD_M249_N: "M249-X",
  T_32_YF_GOLD_SVD_N: "SVD-Y",
  T_32_YS_WEAPON_TAG_18: "Daño Extra",
  T_32_YS_WEAPON_TAG_3: "Velocidad de Disparo",
  T_32_YS_WEAPON_TAG_36: "Destructor de Armaduras",
  T_32_YS_WEAPON_TAG_39: "Resiste Akimbo",
  T_32_YS_WEAPON_TAG_42: "Pared de Hielo",
  T_33_C_SKILL_DESC_GRAFFITIST: "Crea un área de [FFB300]{0}m[-] en donde los objetos lanzables no son válidos. Los aliados en el área restaurarán la durabilidad de la armadura [FFB300]{1}%[-] cada segundo y el daño de munición se reducirá [FFB300]{2}%[-]. Duración: [FFB300]{3}s[-]. Los efectos no se acumulan. Enfriamiento: [FFB300]{4}s[-].",
  T_33_C_SKILL_DESC_HITMAN: "Cuando se usan rifles de francotirador y tirador, el sonido de los disparos se silencia y los disparos exitosos pueden hacer que los enemigos derribados sangren [FFB300]{0}%[-] más rápido.",
  T_33_C_SKILL_DESC_KENTA: "Forma un escudo de [FFB300]{0}m[-] de ancho que reduce [FFB300]{1}%[-] del daño del arma proveniente del frente. Al disparar, la reducción de daño se reduce [FFB300]{2}%[-]. Duración: [FFB300]{3}s[-]. Enfriamiento: [FFB300]{4}s[-].",
  T_33_C_SKILL_DESC_MADEMANA: "Libera una onda electromagnética de [FFB300]{0}m[-] que inhabilita la activación de habilidades de los enemigos, inflige [FFB300]{3} de DAÑ[-] e interrumpe la cuenta regresiva de su habilidad. Duración: [FFB300]{1} s[-] Enfriamiento: [FFB300]{2} s[-].",
  T_33_C_SKILL_NAME_BODYGUARD: "Experta en Armas",
  T_33_C_SKILL_NAME_KENTA: "Ira de la Espada",
  T_33_C_SKILL_NAME_MADEMANA: "Emoción de Batalla",
  T_33_DY_AXOLOTL_N: "Zasil",
  T_33_DY_PETSKIN_AXOLOTL_GREY_N: "Aspecto de Mascota: Zasil Fiesta de Verano",
  T_33_DY_PETSKIN_DUCK_FFWS03_N: "Aspecto de Mascota: Don Cuack FFWS",
  T_33_DY_PETSKIN_HAWK_FASTBREAKING22_N: "Aspecto de Mascota: Falco Floreciente",
  T_33_HQ_BASEBALLBAT_APRILFOOL22_N: "Bate- Baguette Mortal",
  T_33_HQ_EMOTE_SONGKRAN_N: "Ven y Baila",
  T_33_HQ_G18_CYBERTHIEF_N: "G18- Inteligencia Artificial",
  T_33_HQ_GRENADE_CYBERTHIEF_N: "Granada- Inteligencia Artificial",
  T_33_HQ_M14_SPIDERLILY_N: "M14- Lirio Ardiente",
  T_33_HQ_MAG7_FFUNIT2_N: "MAG-7- Villano de las Sombras",
  T_33_HQ_MP40_FFWS03_N: "MP40- Guardián Esmeralda",
  T_33_HQ_SCAR_FFWS03_N: "SCAR- Guardián Esmeralda",
  T_33_HQ_SICKLE_FASTBREAKING22_N: "Hoz- Poder Esmeralda",
  T_33_HQ_THROWINGKNIFE_FFWS03_N: "Cuchillo - Guardián Esmeralda",
  T_33_HQ_VECTOR_CYBERTHIEF_N: "Vector- Inteligencia Artificial",
  T_33_HQ_VEHICLE_JEEP_FASTBREAKING22_N: "Jeep- Brillo Esmeralda",
  T_33_HQ_VEHICLE_MONSTER_LION_RED_N: "Camioneta Truck- Fuego Destructor",
  T_33_HQ_VEHICLE_SUV_FFWS03_N: "Camioneta Pickup- Guardiana Esmeralda",
  T_33_LO_WS_BHPARA_A: "Activo",
  T_33_LO_WS_BHPARA_ATKMODE: "Tipo de Ataque",
  T_33_LO_WS_BHPARA_GROUP: "Equipo",
  T_33_LO_WS_BHPARA_NA: "Sin ataque",
  T_33_LO_WS_BHPARA_P: "Pasivo",
  T_33_LO_WS_DICE_DESC: "Un dado que mejora tus saltos y se puede usar en varios juegos.",
  T_33_LO_WS_DICEVXZ: "Velocidad Horizontal",
  T_33_LO_WS_DICEVY: "Velocidad Vertical",
  T_33_LO_WS_DTOWER: "Torre",
  T_33_LO_WS_DTOWER_DESC: "Ataca automáticamente a los enemigos que se encuentran a cierta distancia de la estructura defensiva. Deshabilitado si su PV llega a cero. (No válido en Duelo de Escuadras, Combate a Muerte y Campo de Juegos)",
  T_33_LO_WS_FORT: "Fortaleza",
  T_33_LO_WS_FORT_DESC: "Ataca automáticamente a los enemigos que se encuentran a cierta distancia de la estructura crítica. Deshabilitado si su PV llega a cero. (No válido en Duelo de Escuadras, Combate a Muerte y Campo de Juegos)",
  T_33_LO_WS_ITEM89: "Tanque de refinería",
  T_33_LO_WS_ITEM89_DESC: "Una estructura de almacenamiento de agua",
  T_33_LO_WS_ITEM90: "Casa de Perro",
  T_33_LO_WS_ITEM90_DESC: "Un hogar para cachorros",
  T_33_LO_WS_ITEM91: "Parada de autobús",
  T_33_LO_WS_ITEM91_DESC: "Una parada de autobús común",
  T_33_LO_WS_ITEM92: "Pared de grafiti",
  T_33_LO_WS_ITEM92_DESC: "Una pared adornada con pintura en aerosol",
  T_33_LO_WS_ITEM93: "Estable",
  T_33_LO_WS_ITEM93_DESC: "Estructura básica hecha de heno",
  T_33_LO_WS_ITEM94: "Mesa de trabajo",
  T_33_LO_WS_ITEM94_DESC: "Un banco del parque",
  T_33_LO_WS_ITEM95: "Puente de Piedra",
  T_33_LO_WS_ITEM95_DESC: "Un puente construido con piedras",
  T_33_LO_WS_ITEM96: "Sombrilla",
  T_33_LO_WS_ITEM96_DESC: "Evita las quemaduras solares cubriéndote con la sombrilla",
  T_33_LO_WS_ITEM97: "Arco de meta",
  T_33_LO_WS_ITEM97_DESC: "Indica la línea final",
  T_33_LO_WS_ITEM98: "Tablero de Anuncios",
  T_33_LO_WS_ITEM98_DESC: "Un banner regular para anuncios",
  T_33_LO_WS_PARA_DM: "Daño",
  T_33_LO_WS_PARA_HP: "PV",
  T_33_LO_WS_PARA_RANGE: "Escaneo a distancia del enemigo",
  T_33_LO_WS_PARA_SP: "Velocidad",
  T_33_LO_WS_ZBPARA_AMOUNT: "Zombis por ola",
  T_33_LO_WS_ZBPARA_INTERVAL: "Intervalo de ola (s)",
  T_33_LO_WS_ZBPARA_ROUND: "# de olas",
  T_33_LO_WS_ZBSPAWNER: "Generación de zombis",
  T_33_LO_WS_ZBSPAWNER_DESC: "Genera automáticamente zombis, cuyo comportamiento se puede configurar. (No válido en Duelo de Escuadras, Combate a Muerte y Campo de Juegos)",
  T_33_MF_CHARACTER_BLACKSMITH_N: "Kenta",
  T_33_PD_ZOMBIE_LEVELUP: "Sube de nivel",
  T_33_RW_SKILL_DESC_GANGGIRL: "Aumenta [FFB300]{0}%[-] la velocidad de disparo. Cuando el usuario le da a un enemigo, máximo [FFB300]{1}%[-] de la velocidad de disparo se convierte en velocidad de movimiento y la conversión se reinicia al sobrevivir al combate.",
  T_33_RW_SKILL_NAME_GANGGIRL: "Pelea o Vuela",
  T_33_WT_WS_BASICSET1: "Básico",
  T_33_WT_WS_QCEPRTIP: "Convierte PE en PV más rápido",
  T_33_WT_WS_SKILLSET_TAG: "Habilidad Ilimitada",
  T_33_WT_WS_SKILLSET1: "Configuración de habilidades",
  T_33_WT_WS_SKILLSET10: "Campo de Fuerza (Chrono)",
  T_33_WT_WS_SKILLSET11: "Ritmo Alto (Skyler)",
  T_33_WT_WS_SKILLSET12: "Encuentro Extremo (Xayne)",
  T_33_WT_WS_SKILLSET13: "Latido Curativo (Dimitri)",
  T_33_WT_WS_SKILLSET2: "Habilidades Pasivas",
  T_33_WT_WS_SKILLSET2_TIP: "Activar/desactivar habilidades pasivas",
  T_33_WT_WS_SKILLSET3: "Habilidades Activas (activar para ajustar el tiempo de enfriamiento)",
  T_33_WT_WS_SKILLSET3_TIP: "Activar/desactivar habilidades activas. Si está activado, el tiempo de enfriamiento de varias habilidades activas se puede configurar a continuación.",
  T_33_WT_WS_SKILLSET4: "Ilusión (Wukong)",
  T_33_WT_WS_SKILLSET5: "Emoción de Batalla (A124)",
  T_33_WT_WS_SKILLSET6: "Ritmo Brutal (Alok)",
  T_33_WT_WS_SKILLSET7: "Refugio de Pintura (Steffie)",
  T_33_WT_WS_SKILLSET8: "Rastreo de Pasos (Clu)",
  T_33_WT_WS_SKILLSET9: "Profesor de Todo (K)",
  T_33_WT_WS_UNIT_HPSECOND: "PV/s",
  T_33_WT_WS_UNIT_METER: "m",
  T_33_WT_WS_UNIT_SECOND: "seg",
  T_33_YF_G36_N: "G36",
  T_33_YS_B_RAINCOAT: "Patito de Lluvia (Inferior)",
  T_33_YS_H_ONIGIRI: "Gorro Onigiri",
  T_33_YS_H_RAINCOAT: "Patito de Lluvia (Cabeza)",
  T_33_YS_HA_CRYINGFACE: "Lágrimas (Maquillaje)",
  T_33_YS_M_H_FROGKING: "Gorro Rey Sapo",
  T_33_YS_S_RAINCOAT: "Patito de Lluvia (Zapatos)",
  T_33_YS_T_BLACKHOLE: "Sudadera Efecto Doppler",
  T_33_YS_T_RAINCOAT: "Patito de Lluvia (Superior)",
  T_33_YS_T_SOCCER_GREEN: "Patada Electrificada (Superior)",
  T_33_YS_T_SOCCER_YELLOW: "Patada Enérgica (Superior)",
  T_33_YS_T_WIFI: "Playera Wi-Fi",
  T_34_C_SKILL_DESC_STREAMERGUY: "Cada eliminación o espectador agregará una acumulación del efecto. Cada acumulación reducirá el daño recibido por disparos a la cabeza [FFB300]{0}%[-] (máx. [FFB300]{1}%[-] en total) y aumentará el daño a los enemigos por disparos a la cabeza [FFB300]{2}%[-] (máx. [FFB300]{3}%[-] en total).",
  T_34_C_SKILL_DESC_TRACKER: "Lanza un dron hacia el enemigo más cercano dentro de una distancia frontal de [FFB300]100m[-], creando una explosión de pulso de [FFB300]{5}m de diámetro[-] que reduce en [FFB300]{0}%[-] la velocidad de movimiento y en [FFB300]{1}%[-] la velocidad de disparo. Duración: [FFB300]{3}s[-]. Inflige [FFB300]{2} de DAÑ[-]. Enfriamiento: [FFB300]{4}s[-].",
  T_34_C_SKILL_NAME_TRACKER: "Sentidos de Choque",
  T_34_DY_PETSKIN_SURFSHARK_ENERGY_N: "Aspecto de Mascota: Tiburoncín Surfista Ogro",
  T_34_DY_PETSKIN_SURFSHARK_SEA_N: "Aspecto de Mascota: Tiburoncín Océano Profundo",
  T_34_DY_PETSKIN_SURFSHARK_STORM_N: "Aspecto de Mascota: Tiburoncín Tormenta Eléctrica",
  T_34_DY_PETSKIN_TIGER_BIS_N: "Aspecto de Mascota: Tigri Sensei Digital",
  T_34_DY_SURFSHARK_N: "Tiburoncín",
  T_34_HQ_EMOTE_BIS_COMMAND_N: "Gran Director",
  T_34_HQ_EMOTE_RAMPAGE4_BLUE_N: "Enérgico",
  T_34_HQ_EMOTE_RIDICULE_N: "Ridículo",
  T_34_HQ_VEHICLE_SUV_CRAZYSCIENTIST_N: "Camioneta Pickup- Ingeniero Infame",
  T_34_HQ_VEHICLE_TUTU_WINTERDOG_N: "Tuk Tuk- Rey Patitas",
  T_34_JL_EAGLE_RAMPAGE4_N: "Desert Eagle- Explosión Híbrida",
  T_34_JL_G36_MADBIONIC_N: "G36- Llama Biónica",
  T_34_JL_GRENADE_BIS_N: "Granada- Soldado Píxel",
  T_34_JL_MACHETE_RAMPAGE4_N: "Machete- Filo Nocturno",
  T_34_JL_THROWINGKNIFE_BANANA_N: "Cuchillo - Plátano",
  T_34_JL_UMP45_BIS_N: "UMP- FF Digital",
  T_34_LY_WS_ABS_DESC: "Obtén el valor absoluto de este número",
  T_34_LY_WS_ADD_DESC: "Agregar un nuevo elemento al final de una lista",
  T_34_LY_WS_AUTO_A: "Escaneo automático de enemigos",
  T_34_LY_WS_BOT: "Regular",
  T_34_LY_WS_BOT_PATH: "Ruta",
  T_34_LY_WS_BOT_TYPE: "Tipo",
  T_34_LY_WS_BOT4: "Con hacha",
  T_34_LY_WS_BOT5: "Lanzador",
  T_34_LY_WS_BOT6: "Autoexplotador",
  T_34_LY_WS_BOT8: "Protegido",
  T_34_LY_WS_COL_DESC: "Seleccionar color",
  T_34_LY_WS_DEL_DESC: "Eliminar el elemento correspondiente de un índice designado en una lista",
  T_34_LY_WS_DF_PER: "% de defensa",
  T_34_LY_WS_FORT_INTERVAL: "Tiempo de intervalo de ataque (s)",
  T_34_LY_WS_GET: "Obtener",
  T_34_LY_WS_GET_DESC: "Obtener el elemento correspondiente de un índice designado en una lista",
  T_34_LY_WS_GLEN_ARR_DESC: "Obtener el número de elementos en la lista actual",
  T_34_LY_WS_GLEN_DESC: "Obtén la longitud de esta cadena de texto",
  T_34_LY_WS_GVX: "Obtener el componente del vector X",
  T_34_LY_WS_GVX_DESC: "Obtén el primer componente de un vector",
  T_34_LY_WS_GVY: "Obtener el componente del vector Y",
  T_34_LY_WS_GVY_DESC: "Obtén el segundo componente de un vector",
  T_34_LY_WS_GVZ: "Obtener el componente del vector Z",
  T_34_LY_WS_GVZ_DESC: "Obtén el tercer componente de un vector",
  T_34_LY_WS_INDEX: "Índice",
  T_34_LY_WS_JOIN: "Conectar",
  T_34_LY_WS_NEG_DESC: "Obtén el valor negativo de este número",
  T_34_LY_WS_PATH: "Rutas de Viaje",
  T_34_LY_WS_PATH_DESC: "Úsalo para agregar/eliminar la ruta de viaje de objetos vivos especiales. (No válido en Duelo de Escuadras, Combate a Muerte y Campo de Juegos)",
  T_34_LY_WS_POINT: "Marcador",
  T_34_LY_WS_POINT_DESC: "Úsalo para marcar la ubicación de la posición actual. (No válido en Duelo de Escuadras, Combate a Muerte y Campo de Juegos)",
  T_34_LY_WS_RANGE_F: "Lejos",
  T_34_LY_WS_RANGE_M: "Medio",
  T_34_LY_WS_RANGE_N: "Cerca",
  T_34_LY_WS_RNDF_DESC: "Genera un decimal aleatorio a partir de un intervalo",
  T_34_LY_WS_RNDI_DESC: "Genera un entero aleatorio a partir de un intervalo",
  T_34_LY_WS_SET: "Modificar",
  T_34_LY_WS_SET_DESC: "Establece el elemento correspondiente de un índice designado en una lista",
  T_34_LY_WS_SQRT_DESC: "Obtén la raíz cuadrada de este número",
  T_34_LY_WS_STRC_DESC: "Conecta dos cadenas de textos",
  T_34_LY_WS_SVX: "Establecer componente del vector X",
  T_34_LY_WS_SVX_DESC: "Establece el primer componente de un vector",
  T_34_LY_WS_SVY: "Establecer componente del vector Y",
  T_34_LY_WS_SVY_DESC: "Establece el segundo componente de un vector",
  T_34_LY_WS_SVZ: "Establecer componente del vector Z",
  T_34_LY_WS_SVZ_DESC: "Establece el tercer componente de un vector",
  T_34_LY_WS_VADD: "Suma de vectores",
  T_34_LY_WS_VADD_DESC: "Agregar dos vectores",
  T_34_LY_WS_VAL_DESC: "Ingresa un número entero o decimal de acuerdo con el escenario",
  T_34_LY_WS_VANG_DESC: "Calcula el ángulo entre dos vectores",
  T_34_LY_WS_VCP: "Producto cruzado",
  T_34_LY_WS_VCP_DESC: "Calcula el producto cruzado de dos vectores",
  T_34_LY_WS_VDIS_DESC: "Calcula la distancia entre dos vectores",
  T_34_LY_WS_VDP: "Producto interno",
  T_34_LY_WS_VDP_DESC: "Calcula el producto interno de dos vectores",
  T_34_LY_WS_VFX1: "Esférico",
  T_34_LY_WS_VFX2: "Cilíndrico",
  T_34_LY_WS_VFX3: "Anillo",
  T_34_LY_WS_VFX4: "Boom",
  T_34_LY_WS_VFX5: "Píxeles",
  T_34_LY_WS_VFX6: "Chispas",
  T_34_LY_WS_VMOD_DESC: "Calcula la magnitud de un vector",
  T_34_LY_WS_VMUL: "Multiplicación de vectores",
  T_34_LY_WS_VMUL_DESC: "Multiplica dos vectores",
  T_34_LY_WS_VNOR_DESC: "Normaliza un vector",
  T_34_LY_WS_VSUB: "Resta de vectores",
  T_34_LY_WS_VSUB_DESC: "Resta dos vectores",
  T_34_M_WS_ANGLE: "Girar ángulo",
  T_34_M_WS_ARRAY: "Lista",
  T_34_M_WS_ATT: "Propiedad",
  T_34_M_WS_BOOL: "Booleano",
  T_34_M_WS_COLORARRAY: "Matriz de color",
  T_34_M_WS_COLOUR: "Color",
  T_34_M_WS_CONFRONBANNER: "Fondo de Batalla",
  T_34_M_WS_COORDINATE: "Coordenadas",
  T_34_M_WS_CUSTOMINF: "Personalizar HUD",
  T_34_M_WS_CUSTOMMODEDESC: `Un modo vacío y totalmente personalizable, sin presets, en el que puedes crear y jugar según tus propias reglas.
Un poco complicado para los creadores de mapas sin tanta experiencia.`,
  T_34_M_WS_DAMAGETYPE: "Tipo de daño",
  T_34_M_WS_DAMAGETYPEDESC: "Tipo de daño establecido actualmente por el sistema",
  T_34_M_WS_DESCTEXT: "Texto descriptivo",
  T_34_M_WS_DURACTION: "Duración",
  T_34_M_WS_ECAMODE: "Modo Personalizar",
  T_34_M_WS_ENDPHASEDESC: "Finalizar inmediatamente la etapa actual y pasar a la siguiente",
  T_34_M_WS_ENTITY: "Entidad",
  T_34_M_WS_FLOAT: "Float",
  T_34_M_WS_GAME: "Juego",
  T_34_M_WS_GAMERESULTS: "Resultado de la partida",
  T_34_M_WS_GETCONTROL2: "Obtén una entidad de control de la interfaz de los jugadores para editar las propiedades de la entidad (incluido el diseño, el color, el contenido, etc.)",
  T_34_M_WS_HEIGHT: "Altura",
  T_34_M_WS_HUDBUTTONWIDGET: "Control de botón",
  T_34_M_WS_HUDEMPTYWIDGET: "Pivote vacío",
  T_34_M_WS_HUDIMAGEWIDGET: "Control de imagen",
  T_34_M_WS_HUDINPUTWIDGET: "Control de cuadro de texto",
  T_34_M_WS_HUDLABELWIDGET: "Control de texto",
  T_34_M_WS_ICON: "Ícono",
  T_34_M_WS_ICON_AIM: "Mira",
  T_34_M_WS_ICON_ARROW: "Flecha",
  T_34_M_WS_ICON_BLAST: "Explosión",
  T_34_M_WS_ICON_CIRCULAR: "Círculo",
  T_34_M_WS_ICON_CLOTH: "Mano",
  T_34_M_WS_ICON_COLLIMATION: "Punto de Mira",
  T_34_M_WS_ICON_CORPSE: "Zombi",
  T_34_M_WS_ICON_CROSS: "Cruz",
  T_34_M_WS_ICON_DAY: "Sol",
  T_34_M_WS_ICON_DEFENSE: "Escudo",
  T_34_M_WS_ICON_DIALOGUE: "Diálogo",
  T_34_M_WS_ICON_DIAMONDS: "Diamante",
  T_34_M_WS_ICON_EXCLAMATIONMARK: "Signo de Exclamación",
  T_34_M_WS_ICON_FLAG: "Bandera",
  T_34_M_WS_ICON_FOLDER: "Carpeta",
  T_34_M_WS_ICON_GLASSES: "Ojo",
  T_34_M_WS_ICON_GUN: "Arma",
  T_34_M_WS_ICON_HEART: "Corazón",
  T_34_M_WS_ICON_HEXAGON: "Hexágono",
  T_34_M_WS_ICON_HOURGLASS: "Reloj de Arena",
  T_34_M_WS_ICON_HOUSE: "Casa",
  T_34_M_WS_ICON_KEY: "Llave",
  T_34_M_WS_ICON_LIGHTNING: "Rayo",
  T_34_M_WS_ICON_LOCK: "Candado",
  T_34_M_WS_ICON_LOOP: "Repetir",
  T_34_M_WS_ICON_MAGNIFIER: "Lupa",
  T_34_M_WS_ICON_MONEY: "Dinero",
  T_34_M_WS_ICON_MONTH: "Luna",
  T_34_M_WS_ICON_OPENFOLDER: "Carpeta Abierta",
  T_34_M_WS_ICON_PLUS: "Más",
  T_34_M_WS_ICON_QUADRI: "Cuadrilátero",
  T_34_M_WS_ICON_QUESTIONMARK: "Signo de Interrogación",
  T_34_M_WS_ICON_RECYCLING: "Reciclar",
  T_34_M_WS_ICON_REFRESH: "Actualizar",
  T_34_M_WS_ICON_REST: "Paz",
  T_34_M_WS_ICON_RETURN: "Atrás",
  T_34_M_WS_ICON_RIGHTTRAPEZOID: "Trapezoide Derecho",
  T_34_M_WS_ICON_SCISSORS: "Tijeras",
  T_34_M_WS_ICON_SETUP: "Ajustes",
  T_34_M_WS_ICON_SIGN: "Marca",
  T_34_M_WS_ICON_SIGNOUT: "Apagar",
  T_34_M_WS_ICON_SQUARE: "Cuadrado",
  T_34_M_WS_ICON_STAR: "Estrella",
  T_34_M_WS_ICON_STONE: "Piedra",
  T_34_M_WS_ICON_SWIMMINGCIRCLE: "Salvavidas",
  T_34_M_WS_ICON_TAGGING: "Pin",
  T_34_M_WS_ICON_THESWORD: "Espada",
  T_34_M_WS_ICON_TRAPEZOID: "Trapezoide",
  T_34_M_WS_ICON_TRASHCAN: "Bote de basura",
  T_34_M_WS_ICON_TRIANGLE: "Triángulo",
  T_34_M_WS_ICON_TROPHY: "Trofeo",
  T_34_M_WS_ICON_UP: "Pulgar Arriba",
  T_34_M_WS_ICON_WRONG: "Tache",
  T_34_M_WS_ICON_YES: "Palomita",
  T_34_M_WS_ICONNAME: "Nombre del icono",
  T_34_M_WS_INT: "Entero",
  T_34_M_WS_KILLZONE: "Zona de perdición",
  T_34_M_WS_LEFTCOLOR: "Color izquierdo",
  T_34_M_WS_LEFTTEAMINDEX: "Índice del Equipo Izquierdo",
  T_34_M_WS_LEFTTEAMSCORE: "Puntuación del Equipo Izquierdo",
  T_34_M_WS_LOCSWITCH: "Cambiar ubicación",
  T_34_M_WS_MAX: "Máximo",
  T_34_M_WS_MIN: "Mínimo",
  T_34_M_WS_NUMBER: "Número",
  T_34_M_WS_OBJECT: "Entidad",
  T_34_M_WS_OPEN: "Encendido",
  T_34_M_WS_OPENSATUS: "Activar estatus",
  T_34_M_WS_PICTURE: "Gráficos",
  T_34_M_WS_RANKARRAY: "Matriz de clasificación",
  T_34_M_WS_RESULTS: "Resultados",
  T_34_M_WS_RIGHTCOLOR: "Color derecho",
  T_34_M_WS_RIGHTTEAMINDEX: "Índice del Equipo Derecho",
  T_34_M_WS_RIGHTTEAMSCORE: "Puntuación del Equipo Derecho",
  T_34_M_WS_ROUNDBANNER: "Fondo de ronda",
  T_34_M_WS_ROUNDDESC: "Descripción de la ronda",
  T_34_M_WS_ROUNDHUD: "Número de ronda",
  T_34_M_WS_ROUNDPARAMS: "Matriz de número de ronda",
  T_34_M_WS_SAME_NAME: "Nombre repetido. Intenta con uno nuevo.",
  T_34_M_WS_SCOREARRAY: "Matriz de puntuación",
  T_34_M_WS_SCORINGTYPE: "Tipo de puntuación",
  T_34_M_WS_SCORINGTYPEDECS: "El tipo de puntuación que los jugadores podrían obtener. Soporta personalización de puntuación.",
  T_34_M_WS_SCUFFLESCORING: "Puntuación de varios equipos",
  T_34_M_WS_SETATTRIBUTES: "Ajustes de propiedad",
  T_34_M_WS_SHUT: "Apagado",
  T_34_M_WS_SOUND: "Efectos de sonido",
  T_34_M_WS_SOUNDCLICK: "Clic",
  T_34_M_WS_SOUNDDD: "Cuenta Regresiva",
  T_34_M_WS_SOUNDFEMALEA: "Herida",
  T_34_M_WS_SOUNDM: "Tiroteo",
  T_34_M_WS_SOUNDMALEA: "Herido",
  T_34_M_WS_SOUNDUAV: "Explosión",
  T_34_M_WS_ST_ASSISTCOUNT: "Asistencias",
  T_34_M_WS_ST_CHECKPROGRESS: "Progreso del punto de control",
  T_34_M_WS_ST_DAMAGESUM: "Daño",
  T_34_M_WS_ST_FINISHCOUNT: "Cantidad de metas alcanzadas",
  T_34_M_WS_ST_FINISHORDER: "Orden de metas alcanzadas",
  T_34_M_WS_ST_FINISHTIME: "Tiempo de metas alcanzadas",
  T_34_M_WS_ST_KILLCOUNT: "Eliminaciones",
  T_34_M_WS_ST_MAINSCORE: "Puntuación de objetivo",
  T_34_M_WS_ST_RANKSCORE: "RANK SCORE",
  T_34_M_WS_ST_SURVIVALDURACTION: "Tiempo de sobrevivencia",
  T_34_M_WS_ST_UNKOWN: "Desconocido",
  T_34_M_WS_STARTBANNER: "Fondo de inicio",
  T_34_M_WS_STARTTIME: "Hora de inicio",
  T_34_M_WS_STRING: "Texto",
  T_34_M_WS_STUDIO: "ESTUDIO",
  T_34_M_WS_TEAMARRAY: "Matriz de equipo",
  T_34_M_WS_TEXTCONTENT: "Contenido",
  T_34_M_WS_THEMECOLOR: "Color del tema",
  T_34_M_WS_TIME: "Cuenta regresiva HUD",
  T_34_M_WS_TITLETEXT: "Texto del título",
  T_34_M_WS_TYPE: "Tipo",
  T_34_M_WS_UODATETYPE: "Tipo de actualización",
  T_34_M_WS_VARNAME: "Nombre de la variable",
  T_34_M_WS_VECTOR: "Vector",
  T_34_M_WS_VFX: "Efectos visuales",
  T_34_M_WS_WIDTH: "Ancho",
  T_34_MF_CHARACTER_TRACKER_N: "Homero",
  T_34_PD_FlagBattle_HYPE_1: "Fuego",
  T_34_SP_WS_BLOCK1_NAME: "Cambiar etapa",
  T_34_SP_WS_BLOCK1_NAMEDESC: "Cambia la etapa de una partida para entrar en la etapa deseada (o ronda). Las rondas también tienen índices de etapa y son un tipo especial de etapa.",
  T_34_SP_WS_BLOCK1_PARAM1_NAMEDESC: "El índice de la etapa objetivo",
  T_34_SP_WS_BLOCK10_NAME: "Crear efectos visuales",
  T_34_SP_WS_BLOCK10_NAMEDESC: "Crea un ícono usando los efectos visuales designados. Se pueden configurar más propiedades del efecto visual ajustando los atributos de la entidad de efectos visuales.",
  T_34_SP_WS_BLOCK10_PARAM3_NAME: "Efecto visual",
  T_34_SP_WS_BLOCK10_PARAM3_NAMEDESC: "Los tipos de efectos visuales que se pueden aplicar",
  T_34_SP_WS_BLOCK12_NAME: "Eliminar efectos visuales",
  T_34_SP_WS_BLOCK12_NAMEDESC: "Elimina el efecto visual designado",
  T_34_SP_WS_BLOCK12_PARAM1_NAME: "Entidad de efectos visuales",
  T_34_SP_WS_BLOCK12_PARAM1_NAMEDESC: "La entidad de efectos visuales que se eliminará",
  T_34_SP_WS_BLOCK13_NAMEDESC: "Ordena al cliente que reproduzca el efecto visual",
  T_34_SP_WS_BLOCK13_PARAM1_NAME: "Lista de jugadores",
  T_34_SP_WS_BLOCK13_PARAM1_NAMEDESC: "Los jugadores que recibirán el mensaje",
  T_34_SP_WS_BLOCK13_PARAM2_NAME: "Ruta del recurso",
  T_34_SP_WS_BLOCK13_PARAM2_NAMEDESC: "La ruta del recurso del sistema está en:ruta. La ruta del recurso personalizado está fuera: ruta. Vacío por defecto.",
  T_34_SP_WS_BLOCK13_PARAM3_NAMEDESC: "Canal RGBA, con cada canal tomando un valor entre 0 y 255 guardado en int32. El color predeterminado es blanco (255,255,255,255).",
  T_34_SP_WS_BLOCK13_PARAM4_NAME: "Zoom",
  T_34_SP_WS_BLOCK13_PARAM4_NAMEDESC: "Escala de zoom; el valor predeterminado es 1",
  T_34_SP_WS_BLOCK13_PARAM5_NAMEDESC: "Posición de la pantalla en coordenadas globales. Vector3(0) por defecto.",
  T_34_SP_WS_BLOCK14_NAME: "Reproducir efecto de sonido",
  T_34_SP_WS_BLOCK14_NAMEDESC: "Ordena al cliente que reproduzca el efecto de sonido",
  T_34_SP_WS_BLOCK15_NAME: "Registro de salida",
  T_34_SP_WS_BLOCK15_NAMEDESC: "Salida de contenido en la interfaz de registro",
  T_34_SP_WS_BLOCK2_NAMEDESC: "Actívalo para habilitar el daño a los jugadores fuera de la Zona Segura",
  T_34_SP_WS_BLOCK2_PARAM1_NAMEDESC: "El punto central de la zona segura",
  T_34_SP_WS_BLOCK2_PARAM2_NAME: "Radio",
  T_34_SP_WS_BLOCK2_PARAM2_NAMEDESC: "El radio de la zona segura",
  T_34_SP_WS_BLOCK2_PARAM3_NAMEDESC: "La cuenta regresiva para que la Zona Segura comience a reducirse",
  T_34_SP_WS_BLOCK2_PARAM4_NAMEDESC: "La duración de la reducción de la Zona Segura",
  T_34_SP_WS_BLOCK2_PARAM5_NAMEDESC: "La cantidad de daño recibido cuando estás fuera de la Zona Segura",
  T_34_SP_WS_BLOCK3_NAMEDESC: "Cuando la Zona de Peligro está desactivada, los jugadores fuera de la Zona Segura no recibirán daño",
  T_34_SP_WS_BLOCK4_NAMEDESC: "Úsalo para retrasar una acción posterior durante un tiempo designado",
  T_34_SP_WS_BLOCK4_PARAM1_NAMEDESC: "La duración de la espera, medida en milisegundos",
  T_34_SP_WS_BLOCK5_NAMEDESC: "Úsalo para posponer una acción subsecuente al siguiente cuadro",
  T_34_SP_WS_BLOCK6_NAME: "Crear HUD personalizado",
  T_34_SP_WS_BLOCK6_NAMEDESC: "Crea un HUD personalizado designado",
  T_34_SP_WS_BLOCK6_PARAM1_NAMEDESC: "Un nombre que se utiliza para crear una entidad HUD. La variable local a la que corresponde es la entidad HUD que se está creando.",
  T_34_SP_WS_BLOCK6_PARAM2_NAME: "Jugador",
  T_34_SP_WS_BLOCK6_PARAM2_NAMEDESC: "La entidad de un jugador específico. Solo visible para dicho jugador.",
  T_34_SP_WS_BLOCK6_PARAM3_NAMEDESC: "El índice único de un HUD",
  T_34_SP_WS_BLOCK7_NAMEDESC: "Crea un HUD predeterminado, que solo es visible para los jugadores designados",
  T_34_SP_WS_BLOCK8_NAMEDESC: "Cuando se elimina, el HUD predeterminado no se verá en el cliente (oculto o descartado)",
  T_34_SP_WS_BLOCK8_PARAM1_NAME: "Entidad HUD",
  T_34_SP_WS_BLOCK8_PARAM1_NAMEDESC: "La entidad HUD que se eliminará",
  T_34_SP_WS_BLOCK9_NAMEDESC: "Cuando se elimina, el HUD personalizado no se verá en el cliente (oculto o descartado)",
  T_34_T_WS_BLOCK1_NAMEDESC: "El incidente se activa cuando inicia la partida",
  T_34_T_WS_BLOCK10_NAMEDESC: "El incidente se activa cuando un jugador es eliminado",
  T_34_T_WS_BLOCK10_PARAM1_DESC: "El jugador eliminado que activará el incidente",
  T_34_T_WS_BLOCK13_NAMEDESC: "El incidente se activa cuando un jugador asiste a otro jugador",
  T_34_T_WS_BLOCK13_PARAM2_DESC: "El jugador que es eliminado",
  T_34_T_WS_BLOCK14_NAMEDESC: "El incidente se activa cuando un jugador inflige daño",
  T_34_T_WS_BLOCK14_PARAM2_DESC: "El jugador que recibe el daño",
  T_34_T_WS_BLOCK14_PARAM3_DESC: "El tipo de daño que se inflige",
  T_34_T_WS_BLOCK14_PARAM4_DESC: "La cantidad de daño infligido",
  T_34_T_WS_BLOCK15_NAMEDESC: "El incidente se activa cuando un jugador elimina a otro jugador",
  T_34_T_WS_BLOCK15_PARAM2_DESC: "El jugador que es eliminado",
  T_34_T_WS_BLOCK15_PARAM3_DESC: "El tipo de daño que causa la eliminación",
  T_34_T_WS_BLOCK16_NAMEDESC: "El incidente se activa cuando un jugador se une a la partida",
  T_34_T_WS_BLOCK17_NAMEDESC: "El incidente se activa cuando un jugador revive",
  T_34_T_WS_BLOCK18_NAMEDESC: "El incidente se activa cuando se elimina un equipo",
  T_34_T_WS_BLOCK19_NAMEDESC: "El incidente se activa cuando se agrega un equipo",
  T_34_T_WS_BLOCK2_NAMEDESC: "El incidente se activa cuando finaliza la partida",
  T_34_T_WS_BLOCK20_NAMEDESC: "El incidente se activa cuando un equipo es anulado",
  T_34_T_WS_BLOCK3_NAMEDESC: "El incidente se activa cuando inicia cada ronda",
  T_34_T_WS_BLOCK3_PARAM1_DESC: "El número de ronda inicia en 0",
  T_34_T_WS_BLOCK3_PARAM1_NAME: "Índice de ronda",
  T_34_T_WS_BLOCK4_NAMEDESC: "El incidente se activa cuando finaliza cada ronda",
  T_34_T_WS_BLOCK5_NAMEDESC: "El incidente se activa cuando inicia la etapa",
  T_34_T_WS_BLOCK5_PARAM1_DESC: "El número de etapa inicia en 0",
  T_34_T_WS_BLOCK5_PARAM1_NAME: "Entidad de Etapa",
  T_34_T_WS_BLOCK6_NAMEDESC: "El incidente se activa cuando finaliza la etapa",
  T_34_T_WS_BLOCK7_NAMEDESC: "El incidente se activa cuando un jugador sale de la partida",
  T_34_T_WS_BLOCK7_PARAM1_DESC: "El jugador que activará el incidente",
  T_34_T_WS_BLOCK7_PARAM1_NAME: "Jugador desencadenante",
  T_34_T_WS_BLOCK8_NAMEDESC: "El incidente se activa cuando cambia la puntuación de un jugador",
  T_34_T_WS_BLOCK8_PARAM2_DESC: "El tipo de puntuación cambiada",
  T_34_T_WS_BLOCK8_PARAM3_DESC: "El valor de la puntuación después del cambio",
  T_34_T_WS_BLOCK9_NAMEDESC: "El incidente se activa cuando cambia la puntuación de un equipo",
  T_34_T_WS_BLOCK9_PARAM1_DESC: "El equipo que activará el incidente",
  T_34_WT_WS_BORNENTITY_PARAM1: "Punto de Inicio",
  T_34_WT_WS_BORNENTITY_PARAM2: "Coordenadas disponibles",
  T_34_WT_WS_BORNENTITY_PARAM3: "Establecer como punto de inicio predeterminado",
  T_34_WT_WS_BORNENTITY_PARAM4: "Límites brillantes",
  T_34_WT_WS_BORNENTITY_PARAM5: "En uso o no",
  T_34_WT_WS_CHECKPOINTENTITY_PARAM1: "Control HUD",
  T_34_WT_WS_CHECKPOINTENTITY_PARAM2: "Estatus abierto",
  T_34_WT_WS_DEADTRIGGERNTITY_PARAM1: "Estatus de disparador",
  T_34_WT_WS_DEADTRIGGERNTITY_PARAM2: "Disparador de eliminación o no",
  T_34_WT_WS_ENTITY_PARAM1: "Entidad de juego",
  T_34_WT_WS_ENTITY_PARAM10: "# de equipos",
  T_34_WT_WS_ENTITY_PARAM11: "# de miembros del equipo",
  T_34_WT_WS_ENTITY_PARAM12: "El equipo se reinicia cada ronda",
  T_34_WT_WS_ENTITY_PARAM13: "Habilitar daño fuera de zona",
  T_34_WT_WS_ENTITY_PARAM14: "Tamaño de la zona",
  T_34_WT_WS_ENTITY_PARAM15: "Hora de inicio de reducción de zona",
  T_34_WT_WS_ENTITY_PARAM16: "Duración de reducción de zona",
  T_34_WT_WS_ENTITY_PARAM17: "Daño fuera de zona",
  T_34_WT_WS_ENTITY_PARAM18: "Puntuación objetivo",
  T_34_WT_WS_ENTITY_PARAM19: "Puntuación de eliminación",
  T_34_WT_WS_ENTITY_PARAM2: "Estatus no válido",
  T_34_WT_WS_ENTITY_PARAM20: "Tipo de resurrección",
  T_34_WT_WS_ENTITY_PARAM21: "Criterios de clasificación de ronda (jugador)",
  T_34_WT_WS_ENTITY_PARAM22: "Importancia de criterio (jugador)",
  T_34_WT_WS_ENTITY_PARAM23: "Criterios de clasificación de ronda (equipo)",
  T_34_WT_WS_ENTITY_PARAM24: "Importancia de criterio (equipo)",
  T_34_WT_WS_ENTITY_PARAM25: "Criterios de clasificación (MVP)",
  T_34_WT_WS_ENTITY_PARAM26: "Importancia de criterio (MVP)",
  T_34_WT_WS_ENTITY_PARAM27: "Clasificación de ronda",
  T_34_WT_WS_ENTITY_PARAM28: "Mostrar criterios en la página de resultados",
  T_34_WT_WS_ENTITY_PARAM29: "Total de rondas",
  T_34_WT_WS_ENTITY_PARAM3: "Tiempo de juego",
  T_34_WT_WS_ENTITY_PARAM4: "Índice de la ronda actual",
  T_34_WT_WS_ENTITY_PARAM5: "Índice de la etapa actual",
  T_34_WT_WS_ENTITY_PARAM6: "ID de plantilla de modo",
  T_34_WT_WS_ENTITY_PARAM7: "Habilitar la resurrección del jugador",
  T_34_WT_WS_ENTITY_PARAM8: "Habilitar la resurrección de bots",
  T_34_WT_WS_ENTITY_PARAM9: "Tiempo de resurrección",
  T_34_WT_WS_ENTITY1_NAME: "Entidad actual",
  T_34_WT_WS_ENTITY1_NAMEDESC: "Vuelve a la entidad actual",
  T_34_WT_WS_ENTITY10_NAME: "Eliminar icono",
  T_34_WT_WS_ENTITY10_NAMEDESC: "Elimina un icono designado",
  T_34_WT_WS_ENTITY10_PARAM1DESC: "Selecciona el icono que deseas eliminar",
  T_34_WT_WS_ENTITY11_NAME: "Eliminar texto",
  T_34_WT_WS_ENTITY11_NAMEDESC: "Elimina una entidad de texto",
  T_34_WT_WS_ENTITY11_PARAM2ESC: "Selecciona el texto que deseas eliminar",
  T_34_WT_WS_ENTITY12_NAMEDESC: "Agrega un objeto para jugadores designados",
  T_34_WT_WS_ENTITY12_PARAM1DESC: "Jugador(es) que recibirá(n) el objeto",
  T_34_WT_WS_ENTITY12_PARAM2DESC: "El ID del objeto específico que se va a obtener",
  T_34_WT_WS_ENTITY12_PARAM2DESC3: "Cantidad de objetos a entregar",
  T_34_WT_WS_ENTITY12_PARAM3: "Cantidad",
  T_34_WT_WS_ENTITY13_PARAM1: "Tipo",
  T_34_WT_WS_ENTITY13_PARAM2: "Ubicación",
  T_34_WT_WS_ENTITY13_PARAM2DESC: "Coordenadas de la ubicación de generación del objeto",
  T_34_WT_WS_ENTITY13_PARAM4: "Objeto",
  T_34_WT_WS_ENTITY14_NAME: "Eliminar objeto",
  T_34_WT_WS_ENTITY14_NAMEDESC: "Elimina un objeto designado",
  T_34_WT_WS_ENTITY14_PARAM1DESC: "Eliminar el objeto",
  T_34_WT_WS_ENTITY15_NAMEDESC: "Obtiene todas las entidades de jugador",
  T_34_WT_WS_ENTITY16_NAMEDESC: "Obtiene todas las entidades del equipo",
  T_34_WT_WS_ENTITY17_NAMEDESC: "Recupera una cantidad designada de PV para jugadores designados. Si la cantidad de recuperación excede el PV máximo, el PV solo se recuperará al máximo.",
  T_34_WT_WS_ENTITY17_PARAM1DESC: "Jugador(es) cuya(s) fluctuación(es) de PV se está(n) configurando",
  T_34_WT_WS_ENTITY17_PARAM2DESC: "La cantidad designada de PV que se recuperará",
  T_34_WT_WS_ENTITY18_NAME: "Obtén coordenadas aleatorias de inicio",
  T_34_WT_WS_ENTITY18_NAMEDESC: "Configura la ubicación para que los jugadores designados aparezcan y regresen",
  T_34_WT_WS_ENTITY18_PARAM1DESC: "Jugador(es) que aparecerá(n) aleatoriamente desde esta ubicación",
  T_34_WT_WS_ENTITY18_RETURNDESC: "Coordenadas de la ubicación donde se asignará al jugador",
  T_34_WT_WS_ENTITY19_NAME: "Obtener la puntuación del jugador",
  T_34_WT_WS_ENTITY19_NAMEDESC: "Obtiene ciertas puntuaciones de jugadores designados",
  T_34_WT_WS_ENTITY19_PARAM1DESC: "Obtener la entidad de puntuación de este(os) jugador(es)",
  T_34_WT_WS_ENTITY19_PARAM2DESC: "Obtener el tipo de puntuación",
  T_34_WT_WS_ENTITY19_RETURNDESC: "Puntuación específica que se va a obtener",
  T_34_WT_WS_ENTITY2_NAME: "Establecer propiedad",
  T_34_WT_WS_ENTITY2_NAMEDESC: "Configura el valor de una propiedad, donde el tipo de propiedad ya ha sido seleccionado",
  T_34_WT_WS_ENTITY2_PARAM1: "Entidad",
  T_34_WT_WS_ENTITY2_PARAM1DESC: "El valor de la propiedad de la entidad de juego",
  T_34_WT_WS_ENTITY2_PARAM3: "Propiedad",
  T_34_WT_WS_ENTITY2_PARAM3DESC: "Cierta propiedad de esta entidad de juego",
  T_34_WT_WS_ENTITY2_PARAM4: "Valor",
  T_34_WT_WS_ENTITY2_PARAM4DESC: "Un valor específico de una propiedad. Asegúrate de que el tipo de propiedad se alinee con el seleccionado y coincida con el tipo configurado en los bloques relacionados.",
  T_34_WT_WS_ENTITY20_NAMEDESC: "Configura ciertas puntuaciones de jugadores designados",
  T_34_WT_WS_ENTITY20_PARAM1DESC: "Configurar la entidad de puntuación de este(os) jugador(es)",
  T_34_WT_WS_ENTITY20_PARAM2DESC: "Configurar el tipo de puntuación",
  T_34_WT_WS_ENTITY20_PARAM3: "Puntuación",
  T_34_WT_WS_ENTITY20_PARAM3DESC: "Puntuación específica que se establece",
  T_34_WT_WS_ENTITY21_NAME: "Obtener puntuación total del equipo",
  T_34_WT_WS_ENTITY21_NAMEDESC: "Obtiene ciertas puntuaciones totales de equipos designados",
  T_34_WT_WS_ENTITY21_PARAM1: "Equipo",
  T_34_WT_WS_ENTITY21_PARAM1DESC: "Obtener la entidad de puntuación de este(os) equipo(s)",
  T_34_WT_WS_ENTITY22_NAME: "Establecer puntuación de la ronda actual del equipo",
  T_34_WT_WS_ENTITY22_NAMEDESC: "Configura ciertos tipos de puntuaciones de la ronda actual de equipos designados",
  T_34_WT_WS_ENTITY22_PARAM1DESC: "Configurar la(s) puntuación(es) de este(os) equipo(s)",
  T_34_WT_WS_ENTITY23_NAME: "Obtener la puntuación de la ronda del jugador",
  T_34_WT_WS_ENTITY23_NAMEDESC: "Obtiene ciertas puntuaciones de una determinada ronda para jugadores designados",
  T_34_WT_WS_ENTITY23_PARAM1DESC: "Obtener la(s) puntuación(es) de la ronda de este(os) jugador(es)",
  T_34_WT_WS_ENTITY23_PARAM2: "Ronda",
  T_34_WT_WS_ENTITY23_PARAM2DESC: "Obtener la puntuación de esta ronda",
  T_34_WT_WS_ENTITY24_NAME: "Obtener la puntuación del equipo en esta ronda",
  T_34_WT_WS_ENTITY24_NAMEDESC: "Obtiene ciertas puntuaciones de una determinada ronda para equipos designados",
  T_34_WT_WS_ENTITY25_NAME: "Teletransportación",
  T_34_WT_WS_ENTITY25_NAMEDESC: "Teletransporta jugadores designados a una ubicación designada",
  T_34_WT_WS_ENTITY25_PARAM1DESC: "Jugador(es) que será(n) teletransportado(s)",
  T_34_WT_WS_ENTITY25_PARAM2DESC: "Coordenadas de dónde serán teletransportados los jugadores",
  T_34_WT_WS_ENTITY26_NAMEDESC: "Permite que los jugadores designados causen daño a los objetivos designados. Si no se selecciona ningún jugador atacante, los objetivos designados recibirán daño del sistema.",
  T_34_WT_WS_ENTITY26_PARAM2DESC: "Entidades que recibirán el daño",
  T_34_WT_WS_ENTITY26_PARAM4DESC: "Cantidad de daño infligido",
  T_34_WT_WS_ENTITY28_NAMEDESC: "Revive jugadores designados",
  T_34_WT_WS_ENTITY28_PARAM1DESC: "Entidades de jugador que pueden ser revividas",
  T_34_WT_WS_ENTITY3_NAMEDESC: "Configura el tipo de bloque",
  T_34_WT_WS_ENTITY3_PARAM1: "como",
  T_34_WT_WS_ENTITY4_NAME: "Obtener propiedad",
  T_34_WT_WS_ENTITY4_NAMEDESC: "Obtiene una propiedad específica de una entidad",
  T_34_WT_WS_ENTITY4_PARAM1DESC: "Obtener la entidad de juego específica del valor de la propiedad",
  T_34_WT_WS_ENTITY4_RETURNDESC: "Valor de la propiedad específica que se desea obtener",
  T_34_WT_WS_ENTITY5_NAMEDESC: "Configura la habilidad de moverse para todos los jugadores",
  T_34_WT_WS_ENTITY6_NAME: "Crear icono",
  T_34_WT_WS_ENTITY6_PARAM1: "Ícono",
  T_34_WT_WS_ENTITY6_PARAM1DESC: "Imagen mostrada en el HUD. Selecciona entre varios diseños.",
  T_34_WT_WS_ENTITY6_PARAM4DESC: "Selecciona el icono sobre el que se debe aplicar el diseño.",
  T_34_WT_WS_ENTITY7_NAMEDESC: "Crea un icono de HUD para jugadores designados. Si no se selecciona ninguna entidad de jugador, se creará el HUD para todos los jugadores.",
  T_34_WT_WS_ENTITY7_PARAM1: "Jugador",
  T_34_WT_WS_ENTITY7_PARAM1DESC: "Crear un icono de HUD para jugadores seleccionados",
  T_34_WT_WS_ENTITY8_NAME: "Agregar texto",
  T_34_WT_WS_ENTITY8_PARAM1: "Texto",
  T_34_WT_WS_ENTITY8_PARAM1DESC: "El contenido de texto específico que se creará a partir de este comando",
  T_34_WT_WS_ENTITY8_PARAM3DESC: "Entidad de texto que se está creando actualmente",
  T_34_WT_WS_ENTITY9_NAMEDESC: "Agrega una línea de texto HUD para los jugadores designados. Si no se selecciona ninguna entidad de jugador, el texto se creará en el HUD de todos los jugadores.",
  T_34_WT_WS_ENTITY9_PARAM1DESC: "Agregar un texto de HUD para jugadores seleccionados",
  T_34_WT_WS_ICONENTITY_PARAM1: "Entidad de icono",
  T_34_WT_WS_ICONENTITY_PARAM2: "Diseño",
  T_34_WT_WS_ICONENTITY_PARAM3: "Color",
  T_34_WT_WS_ICONENTITY_PARAM4: "Escala",
  T_34_WT_WS_ICONENTITY_PARAM5: "Posición de la pantalla",
  T_34_WT_WS_ICONENTITY_PARAM6: "Sigue el objetivo",
  T_34_WT_WS_ICONENTITY_PARAM7: "Visible a través de las paredes",
  T_34_WT_WS_ICONENTITY_PARAM8: "Siempre en pantalla",
  T_34_WT_WS_ONETEAM_TAG: "Equipo Único",
  T_34_WT_WS_PHASEENTITY_PARAM1: "Entidad de Etapa",
  T_34_WT_WS_PHASEENTITY_PARAM2: "Índice de etapa",
  T_34_WT_WS_PHASEENTITY_PARAM3: "Hora de inicio",
  T_34_WT_WS_PHASEENTITY_PARAM4: "Hora de finalización",
  T_34_WT_WS_PHASEENTITY_PARAM5: "Duración",
  T_34_WT_WS_PLAYERENTITY_PARAM1: "Entidad de jugador",
  T_34_WT_WS_PLAYERENTITY_PARAM10: "Punto de resurrección",
  T_34_WT_WS_PLAYERENTITY_PARAM12: "Tasa de daño",
  T_34_WT_WS_PLAYERENTITY_PARAM13: "Modelo de personaje 3D",
  T_34_WT_WS_PLAYERENTITY_PARAM17: "Identidad",
  T_34_WT_WS_PLAYERENTITY_PARAM18: "PV actual",
  T_34_WT_WS_PLAYERENTITY_PARAM2: "PV máximo",
  T_34_WT_WS_PLAYERENTITY_PARAM3: "IA",
  T_34_WT_WS_PLAYERENTITY_PARAM4: "Estado del jugador",
  T_34_WT_WS_PLAYERENTITY_PARAM5: "Tiempo de sobrevivencia",
  T_34_WT_WS_PLAYERENTITY_PARAM6: "Invulnerable",
  T_34_WT_WS_PLAYERENTITY_PARAM7: "Equipo",
  T_34_WT_WS_PLAYERENTITY_PARAM8: "ID del punto de control de destino",
  T_34_WT_WS_PLAYERENTITY_PARAM9: "Punto de Inicio",
  T_34_WT_WS_PROCIRCLE_ICON: "Ícono",
  T_34_WT_WS_PVEDESC1: "Si al menos un jugador llega a la meta antes de que acabe el tiempo, el equipo gana. Si todos los jugadores son eliminados al mismo tiempo, el juego termina.",
  T_34_WT_WS_PVEDESC2: "Sobrevive durante un tiempo designado para ganar. Si todos los jugadores son eliminados al mismo tiempo, el juego termina.",
  T_34_WT_WS_PVENAME1: "Carrera",
  T_34_WT_WS_PVENAME2: "Resistencia",
  T_34_WT_WS_RUNCHECKENTITY_PARAM1: "ID del punto de control actual",
  T_34_WT_WS_RUNCHECKENTITY_PARAM2: "Número de punto de control del Modo Parkour",
  T_34_WT_WS_SKILLSET14: "Ira de la Espada (Kenta)",
  T_34_WT_WS_TEAMENTITY_PARAM1: "Entidad de equipo",
  T_34_WT_WS_TEAMENTITY_PARAM2: "As",
  T_34_WT_WS_TEAMENTITY_PARAM3: "Todos los miembros",
  T_34_WT_WS_TRIGGERNTITY_PARAM1: "Disparador regular",
  T_34_WT_WS_TRIGGERNTITY_PARAM2: "Tipo de apariencia",
  T_34_WT_WS_TXTENTITY_PARAM1: "Entidad de texto",
  T_34_WT_WS_TXTENTITY_PARAM2: "Contenido",
  T_34_WT_WS_VFXENTITY_PARAM1: "Entidad de efectos visuales",
  T_34_WZ_WS_LOGIC10_NAME: "Continuar al siguiente",
  T_34_WZ_WS_LOGIC10_NAMEDESC: "Omite la iteración del bucle actual y ejecuta el siguiente",
  T_34_WZ_WS_LOGIC11_NAME: "Regresar",
  T_34_WZ_WS_LOGIC11_NAMEDESC: "Finaliza la ejecución actual y regresa al programa principal. Permite enviar datos al regresar.",
  T_34_WZ_WS_LOGIC11_PARAM1_NAME: "Valor de retorno",
  T_34_WZ_WS_LOGIC11_PARAM1_NAMEDESC: "Los datos que se enviarán de vuelta al programa principal",
  T_34_WZ_WS_LOGIC2_NAME: "Comparar",
  T_34_WZ_WS_LOGIC2_NAMEDESC: "Compara 2 valores usando un operador designado",
  T_34_WZ_WS_LOGIC2_PARAM1_NAME: "Valor izquierdo",
  T_34_WZ_WS_LOGIC2_PARAM1_NAMEDESC: "El valor del lado izquierdo utilizado para la comparación",
  T_34_WZ_WS_LOGIC2_PARAM2_NAME: "Función de comparación",
  T_34_WZ_WS_LOGIC2_PARAM2_NAMEDESC: "Selecciona cómo deseas que se comparen los valores. Los operadores admitidos son: >, ≥, ==, ≠, ≤, < Y (solo booleano), O (solo booleano)",
  T_34_WZ_WS_LOGIC2_PARAM3_NAME: "Valor derecho",
  T_34_WZ_WS_LOGIC2_PARAM3_NAMEDESC: "El valor del lado derecho utilizado para la comparación",
  T_34_WZ_WS_LOGIC2_PARAM4_NAMEDESC: "Resultado de la comparación",
  T_34_WZ_WS_LOGIC3_NAME: "NO",
  T_34_WZ_WS_LOGIC3_NAMEDESC: "Contrarresta un valor lógico",
  T_34_WZ_WS_LOGIC3_PARAM1_NAMEDESC: "El valor en el que deseas utilizar el operador NO",
  T_34_WZ_WS_LOGIC3_PARAM2_NAMEDESC: "Resultado de la operación NO",
  T_34_WZ_WS_LOGIC4_NAME: "Revisión vacía",
  T_34_WZ_WS_LOGIC4_NAMEDESC: "Revisa si una entidad está vacía/nula",
  T_34_WZ_WS_LOGIC4_PARAM1_NAME: "Entidad",
  T_34_WZ_WS_LOGIC4_PARAM1_NAMEDESC: "La entidad para revisar el vacío",
  T_34_WZ_WS_LOGIC4_PARAM2_NAMEDESC: "Si la entidad está vacía o no",
  T_34_WZ_WS_LOGIC5_NAME: "Si",
  T_34_WZ_WS_LOGIC5_NAMEDESC: "Se ejecuta según se cumplan o no las condiciones. Los subprocesos son los mismos que las ramas lógicas posteriores.",
  T_34_WZ_WS_LOGIC5_PARAM1_NAME: "Valor",
  T_34_WZ_WS_LOGIC5_PARAM1_NAMEDESC: "El número de condiciones y el número de subprocesos (ramas lógicas) deben ser iguales",
  T_34_WZ_WS_LOGIC6_NAME: "Bucle de rango de enteros",
  T_34_WZ_WS_LOGIC6_NAMEDESC: "Bucle de x a y por un paso de z. El subproceso es el bucle mismo.",
  T_34_WZ_WS_LOGIC6_PARAM1_NAMEDESC: "El nombre del índice de bucle que se puede utilizar para extraer el valor del índice de bucle de una variable local.",
  T_34_WZ_WS_LOGIC6_PARAM2_NAME: "Valor inicial",
  T_34_WZ_WS_LOGIC6_PARAM2_NAMEDESC: "El valor en el que inicia el bucle",
  T_34_WZ_WS_LOGIC6_PARAM3_NAME: "Valor final",
  T_34_WZ_WS_LOGIC6_PARAM3_NAMEDESC: "El valor en el que finaliza el bucle",
  T_34_WZ_WS_LOGIC6_PARAM4_NAME: "Paso",
  T_34_WZ_WS_LOGIC6_PARAM4_NAMEDESC: "El paso de cada bucle. Cuando el valor inicial es menor que el valor final, el paso debe ser mayor que 0. Cuando el valor inicial es mayor que el valor final, el paso debe ser menor que 0.",
  T_34_WZ_WS_LOGIC7_NAME: "Bucle de cada elemento",
  T_34_WZ_WS_LOGIC7_NAMEDESC: "Permite atravesar un contenedor de datos para extraer cada subelemento que contiene. El subproceso es el bucle mismo.",
  T_34_WZ_WS_LOGIC7_PARAM1_NAME: "Elemento",
  T_34_WZ_WS_LOGIC7_PARAM1_NAMEDESC: "Pasar a este nombre extraerá el valor del subelemento de la variable local.",
  T_34_WZ_WS_LOGIC7_PARAM3_NAME: "Contenedor de datos",
  T_34_WZ_WS_LOGIC7_PARAM3_NAMEDESC: "El contenedor de datos a recorrer. Actualmente, admite tipos de lista.",
  T_34_WZ_WS_LOGIC8_NAME: "Bucle condicional",
  T_34_WZ_WS_LOGIC8_NAMEDESC: "Un bucle condicional se repite hasta que se cumple una condición. El bucle se detiene cuando la condición es Falsa.",
  T_34_WZ_WS_LOGIC8_PARAM1_NAME: "Condición",
  T_34_WZ_WS_LOGIC8_PARAM1_NAMEDESC: "Repite el bucle si la condición es verdadera y se detiene hasta que la condición es falsa",
  T_34_WZ_WS_LOGIC9_NAME: "Romper bucle",
  T_34_WZ_WS_LOGIC9_NAMEDESC: "Detiene el proceso de bucle actual y sale del bucle",
  T_34_Y_B_DINOSAURS: "Dino Ilusión (Inferior)",
  T_34_YF_M24_N: "M24",
  T_34_YS_F_B_ANGEL_BW: "Ángel Puro (Mujer)",
  T_34_YS_F_B_PANDACATTLE: "Batita Muu (Inferior)",
  T_34_YS_F_B_RAMPAGE4_RAIN: "Agente del Agua (Inferior)",
  T_34_YS_F_H_RAMPAGE4_RAIN: "Agente del Agua (Cabeza)",
  T_34_YS_F_HA_RAMPAGE4_RAIN: "Agente del Agua (Maquillaje)",
  T_34_YS_F_S_PANDACATTLE: "Batita Muu (Zapatos)",
  T_34_YS_F_S_RAMPAGE4_RAIN: "Agente del Agua (Zapatos)",
  T_34_YS_F_T_PANDACATTLE: "Batita Muu (Superior)",
  T_34_YS_F_T_RAMPAGE4_RAIN: "Agente del Agua (Superior)",
  T_34_YS_M_B_ANGEL_BW: "Ángel Puro (Hombre)",
  T_34_YS_M_B_PANDACATTLE: "Pijama de Panda (Inferior)",
  T_34_YS_M_H_PANDACATTLE: "Pijama de Panda (Cabeza)",
  T_34_YS_M_S_PANDACATTLE: "Pijama de Panda (Zapatos)",
  T_34_YS_M_T_PANDACATTLE: "Pijama de Panda (Superior)",
  T_34_YZY_CHARACTER_RHYTHMGIRL_N: "La Patrona",
  T_35_C_SKILL_DESC_BRAZILSOLDIER: "Gana [FFB300]{0} PE[-] al derribar a un enemigo.",
  T_35_DY_PET_OWL_N: "Bubo",
  T_35_DY_PETSKIN_ALIEN_DIGITALUNIVERSE_N: "Aspecto de Mascota: Moony Espacial",
  T_35_DY_PETSKIN_CATEAM_AXOLOTL_N: "Aspecto de Mascota: Zasil Estela Azulcrema",
  T_35_DY_PETSKIN_CATEAM_HAWK_N: "Aspecto de Mascota: Agui Celeste",
  T_35_DY_PETSKIN_OWL_FIRE_N: "Aspecto de Mascota: Bubo Llamarada",
  T_35_DY_PETSKIN_OWL_NIGHT_N: "Aspecto de Mascota: Bubo Cósmico",
  T_35_DY_PETSKIN_OWL_STORM_N: "Aspecto de Mascota: Bubo Escarcha",
  T_35_JL_KNOCKEDDOWN: "ha sido derribado",
  T_35_JL_SKILL_DESC_CRAZYGIRL: "Dentro de los [FFB300]{1}s[-] después de activar la habilidad, el usuario de la habilidad puede disparar con éxito a una pared gloo para marcar a los enemigos a [FFB300]{3}m[-] de ella y penetrar la pared gloo para causar daño a dichos enemigos (el daño infligido será menor de lo habitual). Efectivo en un máximo de [FFB300]{0}[-] paredes gloo. Enfriamiento: [FFB300]{2}s[-].",
  T_35_JL_SKILL_NAME_CRAZYGIRL: "Rompehielos",
  T_35_KY_INFECTION_MAPNAME: "Páramo",
  T_35_M_WS_BUTTONCLICKDESC: "Activa este incidente cuando se toca el botón correspondiente. El activador puede obtenerse mediante parámetros.",
  T_35_M_WS_GETTEAMMATEPOS: "Obtener ubicaciones de compañeros cercanos",
  T_35_M_WS_ROUND2: "Ola actual",
  T_35_PD_Infection_HUMANSELECT: "Selecciona un arma",
  T_35_PD_INFECTION_MODENAME: "Apocalipsis Androide",
  T_35_QX_WS_ICONTYPE_ITEM: "Objeto",
  T_35_QX_WS_ICONTYPE_NATURE: "Formas Naturales",
  T_35_QX_WS_ICONTYPE_SHAPE: "Geométrico",
  T_35_QX_WS_ICONTYPE_SYMBOL: "Símbolo",
  T_35_QX_WS_SOUNDTYPE_WEAPON: "Arma",
  T_35_R_EMOTE_TAG_MUSIC_N: "Musical",
  T_35_RW_SKILL_DESC_Singers: "El usuario y los aliados dentro de [FFB300]{0}m[-] pueden bloquear [FFB300]{1}%[-] de daño usando PE. En este caso, la cantidad de PE deducida de los aliados se agregará a los PE del usuario de la habilidad.",
  T_35_RW_SKILL_NAME_Singers: "Voz Centinela",
  T_35_SP_WS_COMMENTKEY_01: "Dificultad adecuada",
  T_35_SP_WS_COMMENTKEY_02: "Creativo",
  T_35_SP_WS_COMMENTKEY_03: "Jugabilidad interesante",
  T_35_SP_WS_COMMENTKEY_04: "Se puede repetir",
  T_35_SP_WS_COMMENTKEY_05: "Historia intrigante",
  T_35_SP_WS_COMMENTKEY_06: "Buen balance",
  T_35_SP_WS_COMMENTKEY_07: "Experiencia agradable",
  T_35_SP_WS_COMMENTKEY_08: "Flexible",
  T_35_SP_WS_COMMENTKEY_09: "Estéticamente agradable",
  T_35_SP_WS_COMMENTKEY_10: "Muy difícil",
  T_35_SP_WS_COMMENTKEY_11: "Muy fácil",
  T_35_SP_WS_COMMENTKEY_12: "Aburrido",
  T_35_SP_WS_COMMENTKEY_13: "Muy largo",
  T_35_SP_WS_COMMENTKEY_14: "Desequilibrado",
  T_35_SP_WS_COMMENTKEY_15: "Experiencia desagradable",
  T_35_SP_WS_IMAGE03: "Textura",
  T_35_SP_WS_IMAGE04: "Cuadro",
  T_35_SY_CHARGESHOT_TEARS_N: "Charge Buster- Lava Letal",
  T_35_SY_GRENADE_DIGITALUNIVERSE_01_N: "Granada- Cristal Digital",
  T_35_SY_GRENADE_PIRATES_N: "Granada- Corsario Futurista",
  T_35_SY_GRENADE_RIDERS_N: "Granada- Corredor Sombrío",
  T_35_SY_M24_KUN_N: "M24- Acuario Celeste",
  T_35_SY_SCAR_PARKOUR_N: "SCAR- Valor Atlético",
  T_35_SY_VEHICLE_JEEP_PANTOMIME_N: "Jeep- Rompecabezas Cromático",
  T_35_SY_VEHICLE_MONSTER_DIGITALUNIVERSE_D: "¡Disfruta de la celebración!",
  T_35_SY_VEHICLE_MOTOBIKE_DIGITALUNIVERSE_N: "Motocicleta- Simetría de Cristal",
  T_35_WT_WS_PREFAB_MENUBAR_1: "Estructura y Decoración",
  T_35_WT_WS_PREFAB_MENUBAR_1_1: "Estructuras",
  T_35_WT_WS_PREFAB_MENUBAR_1_6: "Otros",
  T_35_WT_WS_PREFAB_MENUBAR_2: "Arquitectura",
  T_35_WT_WS_PREFAB_MENUBAR_2_1: "Edificios Grandes",
  T_35_WT_WS_PREFAB_MENUBAR_2_2: "Edificios Medianos",
  T_35_WT_WS_PREFAB_MENUBAR_3: "Objetos funcionales",
  T_35_WT_WS_PREFAB_MENUBAR_3_1: "Esenciales del Modo",
  T_35_WT_WS_PREFAB_MENUBAR_3_6: "Música",
  T_35_WT_WS_PVEMODE_TAG: "Sobrevivencia",
  T_35_WZY_WS_BECRE_NAMEDESC: "Se activa cuando se crea esta entidad",
  T_35_WZY_WS_BEKILL_NAMEDESC: 'Se activa cuando se elimina esta entidad. La fuente del ataque se puede identificar utilizando "Entidad Desencadenante" y el tipo de ataque se puede identificar mediante "Tipo de daño".',
  T_35_WZY_WS_BEKILL_PARAM1_NAMEDESC: "La entidad que desencadena el incidente",
  T_35_WZY_WS_CREPROP_NAMEDESC: "Crea un tipo de objeto o un conjunto de objetos en una ubicación específica. Al crear un tipo de objeto, la cantidad es el número de ese objeto. Al crear un conjunto de objetos, la cantidad es la lista de cantidades que corresponde a la lista de objetos. Los objetos creados dependerán de las unidades del mapa.",
  T_35_WZY_WS_CREPROP_PARAM1_NAMEDESC: "Una lista que contiene los objetos que se crearán. También puede consistir en un solo objeto.",
  T_35_WZY_WS_CREPROP_PARAM2_NAMEDESC: "Una lista de cantidades que corresponde a la lista de objetos. Solo puede contener la cantidad de un tipo de objeto.",
  T_35_WZY_WS_DAMTYPE_CAR: "Vehículo",
  T_35_WZY_WS_DAMTYPE_FALL: "Caída",
  T_35_WZY_WS_DAMTYPE_FIREARMS: "Arma",
  T_35_WZY_WS_DAMTYPE_GRENADE: "Granada",
  T_35_WZY_WS_DAMTYPE_MELEE: "Cuerpo a cuerpo",
  T_35_WZY_WS_DAMTYPE_ZONE: "Fuera de zona",
  T_35_WZY_WS_DELPROP_NAMEDESC: "Eliminar un número específico de objetos de jugadores específicos",
  T_35_WZY_WS_ENTERTRIGGER_NAME: "Entrar en el área desencadenante",
  T_35_WZY_WS_ENTERTRIGGER_NAMEDESC: 'Se activa cuando una "Entidad Desencadenante" entra en un área desencadenante',
  T_35_WZY_WS_ENTITYPLAYER_DESC: "El jugador para obtener la entidad. Cuando se vincula con el jugador, la información de la entidad solo se actualizará para dicho jugador. Cuando no hay ningún jugador vinculado, todos los jugadores recibirán la información de la entidad.",
  T_35_WZY_WS_FIGHTENTITY_NAME: "Entidad de Batalla",
  T_35_WZY_WS_GETALLOB_NAMEDESC: "Obtener todos los objetos de un tipo en específico. El resultado es una lista.",
  T_35_WZY_WS_GETALLOB_PARAM1_NAMEDESC: "Tipo de objeto",
  T_35_WZY_WS_HUDWIDGET_NAME: "Control de interfaz",
  T_35_WZY_WS_HURT_NAMEDESC: 'Se activa cuando esta entidad recibe daño. La fuente del ataque se puede identificar usando la "Entidad Desencadenante".',
  T_35_WZY_WS_ITEMSTYPE_NAMEDESC: "El tipo de objeto",
  T_35_WZY_WS_LEVELOBJECT_NAME: "Objeto de Etapa",
  T_35_WZY_WS_OBKILL_NAMEDESC: 'Se activa cuando esta entidad elimina a otra entidad. El tipo de entidad que se elimina se puede identificar utilizando la "Entidad Eliminada".',
  T_35_WZY_WS_OBKILL_PARAM1_NAMEDESC: "La entidad que es eliminada",
  T_35_WZY_WS_ONHURT_NAMEDESC: "Se activa cuando una entidad causa daño",
  T_35_WZY_WS_ONHURT_PARAM1_DESC: "La entidad que está haciendo daño",
  T_35_WZY_WS_ONHURT_PARAM1_NAME: "Entidad objetivo",
  T_35_WZY_WS_PREFABID_NAME: "Plantilla de ID",
  T_35_WZY_WS_PROPERTY_EPNOW: "PE actual",
  T_35_WZY_WS_PROPERTY_JUMP: "Altura de salto",
  T_35_WZY_WS_QUITTRIGGER_NAME: "Salir de área desencadenante",
  T_35_WZY_WS_QUITTRIGGER_NAMEDESC: 'Se activa cuando una "Entidad Desencadenante" sale de un área desencadenante',
  T_35_WZY_WS_REMOVEELEMENT_NAMEDESC: "Eliminar un elemento específico de una lista. [Lista] es la lista en la que se encuentra el elemento. [Elemento] es el elemento que se eliminará.",
  T_35_WZY_WS_REMOVEELEMENT_PARAM1_NAME: "Valor del elemento",
  T_35_WZY_WS_REMOVEELEMENT_PARAM1_NAMEDESC: "El valor del elemento a eliminar",
  T_35_WZY_WS_ROUNDENTITY_NAME: "Entidad de Ronda",
  T_35_WZY_WS_TOWER_PARAM1: "Torre y Fortaleza",
  T_35_WZY_WS_TOWER_PARAM2: "ID del equipo",
  T_35_WZY_WS_TOWER_PARAM3: "PV actual",
  T_35_WZY_WS_TOWER_PARAM4: "PV máximo",
  T_35_WZY_WS_TOWER_PARAM5: "Daño",
  T_35_WZY_WS_TOWER_PARAM6: "Intervalo de ataque",
  T_35_WZY_WS_TOWER_PARAM7: "Rango de ataque",
  T_35_WZY_WS_TOWER_PARAM8: "Defensa %",
  T_35_XYL_PDM_REVENGE: "Vengado",
  T_35_XYL_WS_BISPARTERRE: "Jardinera",
  T_35_XYL_WS_BISPARTERRE_DESC: "Una jardinera con temática de Battle-In-Style",
  T_35_XYL_WS_BISWALL: "Pared de Grafiti",
  T_35_XYL_WS_BISWALL_DESC: "Una pared con temática de Battle-In-Style",
  T_35_XYL_WS_BOTDROP: "Activar/desactivar botín",
  T_35_XYL_WS_CUSTOMTRIGGER: "Generador personalizado",
  T_35_XYL_WS_CUSTOMTRIGGER_DESC: "Coloca un objeto que active un efecto especial personalizado cuando un jugador lo active. El efecto debe configurarse en el script. (Solo para el Modo Personalizar)",
  T_35_XYL_WS_DOUBLEDOOR: "Puerta",
  T_35_XYL_WS_DOUBLEDOOR_DESC: "Una puerta que está entreabierta",
  T_35_XYL_WS_RESET: "Restablecer cada ronda",
  T_35_XYL_WS_RESETN: "No",
  T_35_XYL_WS_RESETY: "Sí",
  T_35_XYL_WS_ROADBLOCK: "Barricada A",
  T_35_XYL_WS_ROADBLOCK_DESC: "Impide el paso",
  T_35_XYL_WS_STAIRS: "Escaleras",
  T_35_XYL_WS_STAIRS_DESC: "Escaleras que se pueden combinar con plataformas",
  T_35_XYL_WS_STAIRSL: "Plataforma B",
  T_35_XYL_WS_STAIRSL_DESC: "Una plataforma que se puede combinar con escaleras",
  T_35_XYL_WS_STAIRSZ: "Plataforma A",
  T_35_XYL_WS_STAIRSZ_DESC: "Una plataforma que se puede combinar con escaleras",
  T_35_XYL_WS_TBOOTH: "Cabina Telefónica",
  T_35_XYL_WS_TBOOTH_DESC: "Comúnmente vista en las calles",
  T_35_YF_PP19_N: "Bizon",
  T_35_YS_A_CATEAM_HW: "Agui",
  T_35_YS_A_CUBBY: "Pañuelo de Oso",
  T_35_YS_F_A_PANTOMIME: "Expresión Cromática (Máscara)",
  T_35_YS_F_A_RIDERS: "Corredora Mortal (Máscara)",
  T_35_YS_F_B_DIGITALUNIVERSE2: "Capitana Galáctica (Inferior)",
  T_35_YS_F_B_GOLDCHAIN: "Armadura de la Victoria (Inferior)",
  T_35_YS_F_B_PANTOMIME: "Expresión Cromática (Inferior)",
  T_35_YS_F_B_RIDERS: "Corredora Mortal (Inferior)",
  T_35_YS_F_H_BEAR_HW: "Gorro Osito (Mujer)",
  T_35_YS_F_H_DIGITALUNIVERSE2: "Capitana Galáctica (Cabeza)",
  T_35_YS_F_H_GOLDCHAIN: "Armadura de la Victoria (Cabeza)",
  T_35_YS_F_H_PANTOMIME: "Expresión Cromática (Cabeza)",
  T_35_YS_F_H_RIDERS: "Corredora Mortal (Cabeza)",
  T_35_YS_F_HA_GOLDCHAIN: "Armadura de la Victoria (Maquillaje)",
  T_35_YS_F_S_DIGITALUNIVERSE2: "Capitana Galáctica (Zapatos)",
  T_35_YS_F_S_GOLDCHAIN: "Armadura de la Victoria (Zapatos)",
  T_35_YS_F_S_PANTOMIME: "Expresión Cromática (Zapatos)",
  T_35_YS_F_S_RIDERS: "Corredora Mortal (Zapatos)",
  T_35_YS_F_T_DIGITALUNIVERSE2: "Capitana Galáctica (Superior)",
  T_35_YS_F_T_GOLDCHAIN: "Armadura de la Victoria (Superior)",
  T_35_YS_F_T_PANTOMIME: "Expresión Cromática (Superior)",
  T_35_YS_F_T_RIDERS: "Corredora Mortal (Superior)",
  T_35_YS_ITEM_SUPERFAK: "Superbotiquín",
  T_35_YS_M_A_GOLDCHAIN: "Cadenas de la Victoria (Máscara)",
  T_35_YS_M_A_RIDERS: "Corredor Sombrío (Máscara)",
  T_35_YS_M_B_GOLDCHAIN: "Cadenas de la Victoria (Inferior)",
  T_35_YS_M_B_RIDERS: "Corredor Sombrío (Inferior)",
  T_35_YS_M_H_BEAR_HW: "Gorro Osito (Hombre)",
  T_35_YS_M_H_GOLDCHAIN: "Cadenas de la Victoria (Cabeza)",
  T_35_YS_M_H_RIDERS: "Corredor Sombrío (Cabeza)",
  T_35_YS_M_S_GOLDCHAIN: "Cadenas de la Victoria (Zapatos)",
  T_35_YS_M_S_RIDERS: "Corredor Sombrío (Zapatos)",
  T_35_YS_M_T_GOLDCHAIN: "Cadenas de la Victoria (Superior)",
  T_35_YS_M_T_RIDERS: "Corredor Sombrío (Superior)",
  T_35_YS_T_CHAMPION: "Campeón FFWS 2022",
  T_35_YS_T_PAINTING: "Playera Squeeze",
  T_35_YZY_CHARACTER_CRAZYGIRL_N: "Iris",
  T_35_YZY_CHARACTER_SINGERS_N: "J.Biebs",
  T_36_JH_WS_BASEMONEY: "Obtén monedas al iniciar la partida",
  T_36_JH_WS_CESAYCLOSE: "Deshabilitar el cierre manual o no",
  T_36_JH_WS_CHOOSEEDITSHOP: "Selecciona una tienda para editar",
  T_36_JH_WS_CHOOSESHOP: "Selecciona una tienda",
  T_36_JH_WS_COINCOUNT: "Cantidad de dinero",
  T_36_JH_WS_COINHUD: "Mostrar cantidad de monedas o no",
  T_36_JH_WS_CRAFTSHOP: "Editar tienda",
  T_36_JH_WS_CREATEGOLD: "Generador de Monedas",
  T_36_JH_WS_CSHOPENTITY: "Vincular entidad de tienda",
  T_36_JH_WS_CSHOPHUD: "Interfaz de la tienda",
  T_36_JH_WS_CURRENTLIMIT: "Límite de compra restante",
  T_36_JH_WS_ECONOMIC: "Economía",
  T_36_JH_WS_INGAMEECONOMI: "Economía del juego",
  T_36_JH_WS_ITEMINDEXID: "Número de mercancías",
  T_36_JH_WS_KILLMONEY: "Obtén monedas por eliminación",
  T_36_JH_WS_KILLMONEYTIP: "La cantidad de monedas a ganar por eliminar zombis en los modos Carrera y Resistencia",
  T_36_JH_WS_LISTINDEX: "Lista de los tipos de mercancías",
  T_36_JH_WS_NULL: "Nulo",
  T_36_JH_WS_NUMBER: "Cantidad",
  T_36_JH_WS_OPTIONNAME: "Modo Exclusivo Apocalipsis Androide",
  T_36_JH_WS_REALSHOPENTITY: "Entidad de tienda",
  T_36_JH_WS_SEEORHIDE: "Exhibición de Máquinas Expendedoras",
  T_36_JH_WS_SHOPFRONT: "Tienda",
  T_36_JH_WS_SHOPITEMLIST: "Tipo de mercancía",
  T_36_JH_WS_SHOPOPENCON: "Estatus abierto",
  T_36_JH_WS_SSHOPNAME: "Nombre de la tienda",
  T_36_JH_WS_TOTALLIMIT: "Límite de compra",
  T_36_JH_WS_TRIGGERWIDE: "Rango de disparo",
  T_36_JH_WS_VENDMACHINE: "Máquina Expendedora",
  T_36_JH_WS_WINMONEY: "Obtén monedas por victoria",
  T_36_JH_WS_WORTH: "Valor",
  T_36_JL_FOREGRIP_MR_N: "Astil de Tirador",
  T_36_JL_GOLD_SCAR_I_N: "SCAR-I",
  T_36_JL_GOLD_SCAR_II_N: "SCAR-II",
  T_36_JL_GOLD_SCAR_III_N: "SCAR-III",
  T_36_JL_STOCK_SG_N: "Culata de Escopeta",
  T_36_JL_STOCK_SR_N: "Culata de Francotirador",
  T_36_KK_WS_MONTSTERDES: "Un camión de 4 plazas con alta durabilidad y puede viajar a través de terrenos difíciles",
  T_36_M_WS_SETTEMPVAR: "Establecer variable temporal",
  T_36_M_WS_TEMPVAR: "Variable temporal",
  T_36_SY_AK47_MAMBAS_N: "AK47- Veneno Letal",
  T_36_SY_AN94_MAMBAS_N: "AN94- Veneno Letal",
  T_36_SY_AR15_MAMBAS_N: "Kingfisher- Veneno Letal",
  T_36_SY_AUG_MAMBAS_N: "AUG- Veneno Letal",
  T_36_SY_AWM_MAMBAS_N: "AWM- Veneno Letal",
  T_36_SY_BLT_MAMBAS_N: "M82B- Veneno Letal",
  T_36_SY_CHARGESHOT_MAMBAS_N: "Charge Buster- Veneno Letal",
  T_36_SY_EAGLE_MAMBAS_N: "Desert Eagle- Veneno Letal",
  T_36_SY_FAMAS_MAMBAS_N: "FAMAS- Veneno Letal",
  T_36_SY_G18_MAMBAS_N: "G18- Veneno Letal",
  T_36_SY_G36_MAMBAS_N: "G36- Veneno Letal",
  T_36_SY_GRENADE_FESTIVAL_TU_N: "Granada - Fiesta de la Marina",
  T_36_SY_GROZA_MAMBAS_N: "Groza- Veneno Letal",
  T_36_SY_HAND_CANNON_MAMBAS_N: "Cañón de Mano- Veneno Letal",
  T_36_SY_HEALINGSNIPER_MAMBAS_N: "Rifle Curativo- Veneno Letal",
  T_36_SY_ICE_GUN_MAMBAS_N: "Pistola de Hielo- Veneno Letal",
  T_36_SY_KAR98K_MAMBAS_N: "Kar98k- Veneno Letal",
  T_36_SY_KORD_MAMBAS_N: "Kord- Veneno Letal",
  T_36_SY_M1014_MAMBAS_N: "M1014- Veneno Letal",
  T_36_SY_M14_MAMBAS_N: "M14- Veneno Letal",
  T_36_SY_M1873_MAMBAS_N: "M1873- Veneno Letal",
  T_36_SY_M1887_MAMBAS_N: "M1887- Veneno Letal",
  T_36_SY_M1917_MAMBAS_N: "M1917- Veneno Letal",
  T_36_SY_M21A5_MAMBAS_N: "Woodpecker- Veneno Letal",
  T_36_SY_M24_MAMBAS_N: "M24- Veneno Letal",
  T_36_SY_M249_MAMBAS_N: "M249- Veneno Letal",
  T_36_SY_M4A1_MAMBAS_N: "M4A1- Veneno Letal",
  T_36_SY_M500_MAMBAS_N: "M500- Veneno Letal",
  T_36_SY_M60_MAMBAS_N: "M60- Veneno Letal",
  T_36_SY_M79_MAMBAS_N: "M79- Veneno Letal",
  T_36_SY_MAC10_MAMBAS_N: "MAC10- Veneno Letal",
  T_36_SY_MAG7_MAMBAS_N: "MAG-7- Veneno Letal",
  T_36_SY_MINI_MAMBAS_N: "AC80- Veneno Letal",
  T_36_SY_MP40_MAMBAS_N: "MP40- Veneno Letal",
  T_36_SY_MP5_MAMBAS_N: "MP5- Veneno Letal",
  T_36_SY_P90_MAMBAS_N: "P90- Veneno Letal",
  T_36_SY_PARAFAL_MAMBAS_N: "PARAFAL- Veneno Letal",
  T_36_SY_PP19_MAMBAS_N: "Bizon- Veneno Letal",
  T_36_SY_PP19_POLICEMAN_N: "Bizon - Guardián de los Hechizos",
  T_36_SY_SCAR_MAMBAS_N: "SCAR- Veneno Letal",
  T_36_SY_SKS_MAMBAS_N: "SKS- Veneno Letal",
  T_36_SY_SPAS12_MAMBAS_N: "SPAS12- Veneno Letal",
  T_36_SY_SUPERHEAT_GUN_MAMBAS_N: "PLASMA- Veneno Letal",
  T_36_SY_SVD_MAMBAS_N: "SVD- Veneno Letal",
  T_36_SY_THOMPSON_MAMBAS_N: "Thompson- Veneno Letal",
  T_36_SY_THROWINGKNIFE_MAMBAS_N: "Cuchillo - Veneno Letal",
  T_36_SY_THROWINGKNIFE_MENA_N: "Cuchillo - Boho",
  T_36_SY_TREATMENTGUN_MAMBAS_N: "Pistola Curativa- Veneno Letal",
  T_36_SY_UMP45_MAMBAS_N: "UMP- Veneno Letal",
  T_36_SY_USP45_MAMBAS_N: "USP- Veneno Letal",
  T_36_SY_UZI_MAMBAS_N: "Mini Uzi- Veneno Letal",
  T_36_SY_VECTOR_MAMBAS_N: "Vector- Veneno Letal",
  T_36_SY_VEHICLE_MONSTER_TRUCK_BDK_N: "Camioneta Monster- Oro Deslumbrante",
  T_36_SY_VEHICLE_MOTOBIKE_SUGARSKULL22_N: "Motocicleta- Paseo Espectral",
  T_36_SY_VEHICLE_ROADSTER_BDK_N: "Auto Deportivo- Velocidad Elegante",
  T_36_SY_VEHICLE_TUTU_POLICEMAN_N: "Tuk Tuk- Paseo del Inframundo",
  T_36_SY_VSS_MAMBAS_N: "VSS- Veneno Letal",
  T_36_SY_XM8_MAMBAS_N: "XM8- Veneno Letal",
  T_36_WZY_AFTERACCUMULATOR: "Acumulador trasero",
  T_36_WZY_AVAILAB: "Activado",
  T_36_WZY_BACKANDFORTH: "Viaje ida y vuelta",
  T_36_WZY_BASEMULTIPLIER: "Multiplicador básico",
  T_36_WZY_BASIC: "Tipo básico",
  T_36_WZY_BEFORACCUMULATOR: "Acumulador delantero",
  T_36_WZY_CYLIC: "Viaje de vuelta",
  T_36_WZY_GUNPRO_PARAM1: "Daño básico",
  T_36_WZY_GUNPRO_PARAM10: "Inicio de propagación de balas",
  T_36_WZY_GUNPRO_PARAM11: "Área de propagación máx.",
  T_36_WZY_GUNPRO_PARAM12: "Ráfaga",
  T_36_WZY_GUNPRO_PARAM2: "Balas en el cargador",
  T_36_WZY_GUNPRO_PARAM3: "Número de cargador inicial",
  T_36_WZY_GUNPRO_PARAM4: "Intervalo de disparo",
  T_36_WZY_GUNPRO_PARAM7: "Distancia para daño máximo",
  T_36_WZY_GUNPRO_PARAM8: "Distancia para daño mínimo",
  T_36_WZY_GUNPRO_PARAM9: "Daño mínimo",
  T_36_WZY_MULTIPLIR: "Multiplicador",
  T_36_WZY_PRICE: "Precio",
  T_36_WZY_SUMMULTIPLIER: "Acumulador multiplicador",
  T_36_WZY_WS_3DZOOM: "Zoom 3D",
  T_36_WZY_WS_ABSRES: "Resultado de valor absoluto",
  T_36_WZY_WS_ADDALLELE_NAMEDESC: "Agrega todos los elementos de la [Lista de origen] al final de la [Lista de Objetivos]",
  T_36_WZY_WS_ADDALLELE_PARAM1_DESC: "La Lista de Objetivos para agregar los elementos",
  T_36_WZY_WS_ADDALLELE_PARAM2_DESC: "La Lista de Origen que contiene los elementos que se agregarán",
  T_36_WZY_WS_ADDCURR_NAMEDESC: "Agrega una cierta cantidad de dinero designada en una cartera designada",
  T_36_WZY_WS_ADDCURR_PARAM1_NAME: "Cartera",
  T_36_WZY_WS_ADDCURR_PARAM1_NAMEDESC: "La cartera para agregar dinero",
  T_36_WZY_WS_ADDSUB: "Sumar o restar valores",
  T_36_WZY_WS_AIENTITY: "Entidad de IA",
  T_36_WZY_WS_ALLSHOP_DESC: "Una lista que consta de entidades de tienda",
  T_36_WZY_WS_ANGLE_DESC: "La medida del ángulo",
  T_36_WZY_WS_ANYTYPE: "Cualquier tipo",
  T_36_WZY_WS_ARILEFT: "Valor izquierdo en la operación",
  T_36_WZY_WS_ARIRES: "Resultado de la operación",
  T_36_WZY_WS_ARIRIGHT: "Valor derecho en la operación",
  T_36_WZY_WS_ARITHMETIC_NAME: "4 operaciones aritméticas",
  T_36_WZY_WS_ARITHMETIC_NAMEDESC: "Las operaciones básicas con enteros admiten la suma, la resta, la multiplicación, la división y el resto. Las operaciones flotantes admiten sumas, restas, multiplicaciones y divisiones.",
  T_36_WZY_WS_ARRAY_DESC: "La Lista de Objetivos",
  T_36_WZY_WS_ARRCONELE_NAMEDESC: "Comprueba si una lista contiene un elemento designado. El valor devuelto es booleano.",
  T_36_WZY_WS_ARRCONELE_PARAM1_DESC: "La lista designada",
  T_36_WZY_WS_ARRCONELE_PARAM2_DESC: "El elemento a buscar en la lista",
  T_36_WZY_WS_ARRCONELERES: "Si el resultado de un elemento designado existe en una lista. El valor es booleano.",
  T_36_WZY_WS_ATTACK: "Patrullaje y ataque",
  T_36_WZY_WS_BEKNODOWN_NAMEDESC: "Se activa cuando el jugador es derribado",
  T_36_WZY_WS_BIGFLOAT: "Decimal Mayor",
  T_36_WZY_WS_BIGTOYBALL: "Dado",
  T_36_WZY_WS_BOOLLIST: "Lista de booleanos",
  T_36_WZY_WS_CEIL_NAME_DESC: "Redondea un valor al entero más pequeño mayor que sí mismo",
  T_36_WZY_WS_CEIL_PARAM1_NAMEDESC: "El valor a redondear",
  T_36_WZY_WS_CEILRES: "Resultado de redondear",
  T_36_WZY_WS_CHASEENT_NAMEDESC: "La IA seleccionada perseguirá a esta entidad sin importar la distancia. La [Entidad Perseguida] puede ser cualquier entidad. Cuando la [Entidad Perseguida] no tiene una propiedad de PV, entonces la entidad AI no infligirá ningún daño.",
  T_36_WZY_WS_CHASEENT_PARAM1_NAMEDESC: "La entidad que está persiguiendo",
  T_36_WZY_WS_CHASEENT_PARAM2_NAMEDESC: "La entidad objetivo que está siendo perseguida. Puede ser cualquier entidad.",
  T_36_WZY_WS_CLONEOBJ_PARAM1_DESC: "La plantilla para clonar objetos. Selecciona usando los cursores. La propiedad y el script del clon serán los mismos que los del objeto elegido.",
  T_36_WZY_WS_CLONEOBJ_PARAM2_DESC: "La entidad del objeto que se va a clonar",
  T_36_WZY_WS_CONDITION: "Condición",
  T_36_WZY_WS_CONDITIONLIST: "Lista de condiciones",
  T_36_WZY_WS_CONOFHUD: "La entidad de HUD en la que existe el control",
  T_36_WZY_WS_CONTROL_DESC: "El único índice de un control",
  T_36_WZY_WS_COS_NAMEDESC: "Hallar el coseno de un ángulo",
  T_36_WZY_WS_COSRES: "Coseno del ángulo",
  T_36_WZY_WS_CREABLEOB: "Objeto creable",
  T_36_WZY_WS_CREOBJ_NAMEDESC: "Crea una entidad del objeto en una ubicación designada. (Versión de prueba)",
  T_36_WZY_WS_CREOBJ_PARAM1_DESC: "Las coordenadas del objeto a crear",
  T_36_WZY_WS_CREOBJ_PARAM2_DESC: "El tipo de objeto a crear",
  T_36_WZY_WS_CREOBJ_PARAM3_DESC: "La entidad del objeto que se va a crear",
  T_36_WZY_WS_CREPROD_PARAM2_NAME: "Divisa",
  T_36_WZY_WS_CREPROD_PARAM4_NAME: "Entidad de Mercancías",
  T_36_WZY_WS_CREPROD_PARAM4_NAMEDESC: "Crear una entidad de mercancías",
  T_36_WZY_WS_CREWALL_NAMEDESC: "Crea una entidad de cartera. El [Jugador Enlazado] es el jugador que puede ver esta cartera. [Propietario] es el jugador al que pertenece la cartera. No es válido si ya existe una cartera.",
  T_36_WZY_WS_CREWALL_PARAM1_NAME: "Jugador Enlazado",
  T_36_WZY_WS_CREWALL_PARAM1_NAMEDESC: "El jugador para el que la cartera es visible. Si no se configuran ajustes, la cartera será visible para todos.",
  T_36_WZY_WS_CREWALL_PARAM2_NAMEDESC: "El propietario de la cartera",
  T_36_WZY_WS_CREWALL_PARAM3_NAME: "Entidad de la cartera",
  T_36_WZY_WS_CREWALL_PARAM3_NAMEDESC: "La entidad de cartera creada",
  T_36_WZY_WS_CURRAMT: "Cantidad de dinero",
  T_36_WZY_WS_DATA_TYPE1: "Parámetro añadido",
  T_36_WZY_WS_DATA_TYPE2: "Cálculo básico y lógico",
  T_36_WZY_WS_DATA_TYPE3: "Manipulación de listas",
  T_36_WZY_WS_DATA_TYPE4: "Cálculo vectorial",
  T_36_WZY_WS_DESTITEM_NAME: "Destruir objeto del jugador",
  T_36_WZY_WS_DESTITEM_NAMEDESC: "Destruye un tipo de objeto designado para un jugador designado",
  T_36_WZY_WS_DESTITEM_PARAM1_NAMEDESC: "Los objetos que se pueden destruir son armas, chalecos y cascos",
  T_36_WZY_WS_DESTITEM_PARAM2_NAMEDESC: "El índice del espacio del tipo de objeto seleccionado. El índice de armas es [1,3] y el chaleco y el casco es 1 por defecto.",
  T_36_WZY_WS_DESTITEM_WHELOSTEQU: "Pierdes equipamiento al ser eliminado",
  T_36_WZY_WS_DESTOBJ: "Objetos destruibles",
  T_36_WZY_WS_DIRPOINT: "Punto de dirección",
  T_36_WZY_WS_DIRPOINTDESC: "El punto de dirección que se creará",
  T_36_WZY_WS_ELEFINDRES: "Índice de la primera posición de un elemento",
  T_36_WZY_WS_ELEFIRINDEX_NAMEDESC: 'Obtiene el índice de la primera posición de un elemento en una lista. Si el elemento de destino no existe en la lista, el resultado devolverá "-1".',
  T_36_WZY_WS_ELEFIRINDEX_PARAM2_DESC: "El elemento a buscar en la lista",
  T_36_WZY_WS_ELELASINDEX_NAMEDESC: 'Obtiene el índice de la última posición de un elemento en una lista. Si el elemento de destino no existe en la lista, el resultado devolverá "-1".',
  T_36_WZY_WS_ELELINDRES: "Índice de la última posición de un elemento",
  T_36_WZY_WS_ELEMENTSNUM: "# de elementos en la lista",
  T_36_WZY_WS_ENTCOLLIDE_NAMEDESC: "Se activa cuando la [Entidad desencadenante] choca con este disparador",
  T_36_WZY_WS_ENTCOLLIDE_PARAM1_NAMEDESC: "La entidad con la que choca este disparador",
  T_36_WZY_WS_ENTDRIVEH_NAMEDESC: "Se activa cuando una [Entidad desencadenante] conduce el vehículo",
  T_36_WZY_WS_ENTDRIVEH_PARAM1_NAMEDESC: "La entidad que conduce el vehículo",
  T_36_WZY_WS_ENTERTRI_NAMEDESC: "Se activa cuando el jugador ingresa el disparador",
  T_36_WZY_WS_ENTERTRI_PARAM1_DESC: "El disparador para entrar",
  T_36_WZY_WS_ENTGETOFFVEH_NAMEDESC: "Se activa cuando una [Entidad desencadenante] sale del vehículo",
  T_36_WZY_WS_ENTGETOFFVEH_PARAM1_NAMEDESC: "La entidad que sale del vehículo",
  T_36_WZY_WS_ENTGETONVEH_NAMEDESC: "Se activa cuando una [entidad desencadenante] ingresa al vehículo",
  T_36_WZY_WS_ENTGETONVEH_PARAM1_NAMEDESC: "La entidad que ingresa al vehículo",
  T_36_WZY_WS_ENTITY_TYPE1: "Comúnmente usado",
  T_36_WZY_WS_ENTITY_TYPE2: "Propiedades",
  T_36_WZY_WS_ENTITY_TYPE3: "Objetos",
  T_36_WZY_WS_ENTITY_TYPE4: "IA",
  T_36_WZY_WS_ENTITY2_PARAM4_DESC: "El valor del elemento a cambiar",
  T_36_WZY_WS_ENTITY7_PARAM1_DESC: "Jugador Objetivo",
  T_36_WZY_WS_ENTITYLIST: "Lista de entidades",
  T_36_WZY_WS_ENTKNOFLY_NAMEDESC: "Se activa cuando una [Entidad desencadenante] rebota en el neumático",
  T_36_WZY_WS_ENTKNOFLY_PARAM1_NAMEDESC: "La entidad que rebota en el neumático",
  T_36_WZY_WS_ENTTP_NAMEDESC: "Se activa cuando una [Entidad desencadenante] ingresa al portal y es teletransportada",
  T_36_WZY_WS_ENTTP_PARAM1_NAMEDESC: "La entidad que es teletransportada",
  T_36_WZY_WS_EQUARMOR_PARAM2_DESC: "El tipo de armadura equipada, incluyendo chaleco, casco y mochila.",
  T_36_WZY_WS_EQUWEAP_NAMEDESC: "Se activa cuando un jugador equipa con éxito un arma. [Jugador desencadenante] es el jugador que equipa con éxito un arma. [Tipo de arma] es la entidad de arma que equipó el jugador.",
  T_36_WZY_WS_EQUWEAP_PARAM2_DESC: "La entidad de arma equipada",
  T_36_WZY_WS_EQUWEAP_PARAM2_NAME: "Tipo de arma",
  T_36_WZY_WS_EULERANGLE: "Ángulos de Euler",
  T_36_WZY_WS_FACECAMERA: "Siempre frente a la cámara",
  T_36_WZY_WS_FLOATLIST: "Lista de float",
  T_36_WZY_WS_FLOOR_NAME_DESC: "Redondea un valor al entero más grande menor que sí mismo",
  T_36_WZY_WS_FLOOR_PARAM1_NAMEDESC: "El valor a redondear hacia abajo",
  T_36_WZY_WS_FLOORRES: "Resultado de redondear hacia abajo",
  T_36_WZY_WS_FORMUENT: "Entidad formulable de propiedad",
  T_36_WZY_WS_FORMUFACT: "Tipo de factor de fórmula de propiedad",
  T_36_WZY_WS_GAME_TYPE2: "Jugabilidad",
  T_36_WZY_WS_GAME_TYPE3: "Efectos especiales",
  T_36_WZY_WS_GENENT_NAMEDESC: "Se activa cuando un generador produce unidades. [Lista de la entidad de unidad] es la lista de unidades producidas por el generador. [Número de olas] es el número de olas producidas por la generación.",
  T_36_WZY_WS_GENENT_PARAM1_NAME: "Entidad de unidad",
  T_36_WZY_WS_GENENT_PARAM1_NAMEDESC: "Una lista que consta de entidades de unidades producidas por un generador",
  T_36_WZY_WS_GENENT_PARAM2_NAMEDESC: "El número de olas que produce un generador",
  T_36_WZY_WS_GETALLSHOP_NAMEDESC: "Obtiene todas las tiendas de la partida. El valor devuelto es una lista que consta de entidades de tienda.",
  T_36_WZY_WS_GETCOLOR_NAMEDESC: "Usa el RGB para obtener un color",
  T_36_WZY_WS_GETCURRAMT_NAMEDESC: "Obtiene la cantidad de cierta moneda en una cartera específica",
  T_36_WZY_WS_GETCURRAMT_PARAM1_NAMEDESC: "La cartera de la cual se obtiene el dinero",
  T_36_WZY_WS_GETCURRAMT_PARAM2_NAMEDESC: "El tipo de moneda de la cantidad de dinero a obtener",
  T_36_WZY_WS_GETENTTYPE_NAMEDESC: "Obtener el tipo de entidad de una entidad de destino",
  T_36_WZY_WS_GETENTTYPE_PARAM1_DESC: "La entidad cuyo tipo a obtener",
  T_36_WZY_WS_GETENTTYPERES: "Tipo de entidad de la entidad de destino",
  T_36_WZY_WS_GETFOR_NAME: "Obtener coordenadas de dirección",
  T_36_WZY_WS_GETFOR_NAMEDESC: "Obtiene el vector de un punto de dirección designado",
  T_36_WZY_WS_GETFORRES: "Vector de punto de dirección",
  T_36_WZY_WS_GETMONEYENT_NAMEDESC: "Obtiene la entidad de dinero de un determinado tipo de moneda en la cartera",
  T_36_WZY_WS_GETMONEYENT_PARAM1_DESC: "La cartera en la que se encuentra la entidad de dinero",
  T_36_WZY_WS_GETPOS_NAME: "Obtener coordenadas",
  T_36_WZY_WS_GETPOS_NAMEDESC: "Obtiene las coordenadas de un punto de dirección designado",
  T_36_WZY_WS_GETPOS_PARAM1_DESC: "El punto de dirección designado",
  T_36_WZY_WS_GETPROP_PARAM2_NAME: "Tipo de equipamiento",
  T_36_WZY_WS_GETWALLET_NAME: "Obtener cartera",
  T_36_WZY_WS_GETWALLET_NAMEDESC: "Obtiene la cartera del propietario seleccionado",
  T_36_WZY_WS_GETWALLET_PARAM2_NAMEDESC: "Si existe una cartera enlazada",
  T_36_WZY_WS_GETWALLETRES: "Entidad de cartera del propietario",
  T_36_WZY_WS_HUDCONTROL_DESC: "La entidad de control de un HUD",
  T_36_WZY_WS_HUDTYPE: "Tipo de HUD",
  T_36_WZY_WS_INCIDENT_TYPE1: "Incidente de toda la partida",
  T_36_WZY_WS_INCIDENT_TYPE2: "Incidente de entidad",
  T_36_WZY_WS_INDEX_DESC: "Un valor de índice de una lista. Comienza desde 0.",
  T_36_WZY_WS_INTLIST: "Lista de enteros",
  T_36_WZY_WS_JENTSUBCL_NAMEDESC: "Comprueba si un tipo de entidad pertenece a una determinada subcategoría. El resultado devuelto es booleano.",
  T_36_WZY_WS_JENTSUBCL_PARAM2_NAMESESC: "La categoría principal para comprobar si la entidad pertenece a ella",
  T_36_WZY_WS_JENTSUBCLRES: "Resultado de la comprobación de categoría principal",
  T_36_WZY_WS_JENTTYPE_NAMEDESC: "Comprueba si una entidad pertenece a un determinado tipo de entidad. El resultado devuelto es booleano.",
  T_36_WZY_WS_JENTTYPE_PARAM1_NAMEDESC: "La entidad a comprobar",
  T_36_WZY_WS_JENTTYPE_PARAM2_NAMEDESC: "Significa que es el mismo que el tipo de entidad",
  T_36_WZY_WS_JENTTYPERES: "Resultado de la comprobación de la entidad",
  T_36_WZY_WS_JUSTPATROL: "Solo patrullaje",
  T_36_WZY_WS_LEAVETRI_NAMEDESC: "Se activa cuando el jugador sale del disparador",
  T_36_WZY_WS_LEAVETRI_PARAM1_DESC: "El disparador para salir",
  T_36_WZY_WS_LEVELOBLIST: "Lista de objetos",
  T_36_WZY_WS_LEVOBJSLIST: "Una lista de todos los objetos del mapa en esta partida",
  T_36_WZY_WS_LEVOBTYPE: "Tipo de objeto",
  T_36_WZY_WS_LISTT: "Cualquier lista",
  T_36_WZY_WS_LOGCONTEXT_DESC: "El contenido a imprimir",
  T_36_WZY_WS_LOGIC2_PARAM1_NAMEDESC: "La cadena izquierda que se conectará",
  T_36_WZY_WS_LOGIC2_PARAM3_NAMEDESC: "La cadena correcta para ser conectada",
  T_36_WZY_WS_LOGIC5_PARAM1_NAMEDESC: "El valor del elemento que se agregará",
  T_36_WZY_WS_LOGOPER: "Al realizar operaciones lógicas (y/o): si usar la operación y y los dos valores booleanos son VERDADEROS, el resultado es VERDADERO, y si usar la operación o y los dos valores booleanos no son FALSO, el resultado es VERDADERO.",
  T_36_WZY_WS_LOOTPOINT: "Punto de botín",
  T_36_WZY_WS_MAINWEAP: "Arma actual",
  T_36_WZY_WS_MAX_DESC: "El rango superior del entero generado (intervalo abierto)",
  T_36_WZY_WS_MIN_DESC: "El rango inferior del entero generado (intervalo cerrado)",
  T_36_WZY_WS_MODGUNPRO_PARAM1_NAME: "Entidad de arma",
  T_36_WZY_WS_MONENT: "Entidad de dinero",
  T_36_WZY_WS_MONTYPE: "Tipo de moneda",
  T_36_WZY_WS_MOVETO_NAMEDESC: "Hace que la IA se mueva hacia un punto objetivo. Usa [Volver o no] para seleccionar si la IA volverá a su posición original. Usa [Atacar o no] para seleccionar si la IA buscará enemigos en su camino.",
  T_36_WZY_WS_MOVETO_PARAM1_NAMEDESC: "La entidad de IA que viajará",
  T_36_WZY_WS_MOVETO_PARAM2_NAMEDESC: "El destino",
  T_36_WZY_WS_MOVETO_PARAM3_NAMEDESC: "Úsalo para establecer si la IA volverá a la ubicación original después de llegar al destino. VERDADERO significa volver; FALSO significa no volver.",
  T_36_WZY_WS_MOVETO_PARAM4_NAME: "Atacar o no",
  T_36_WZY_WS_MOVETO_PARAM4_NAMEDESC: "Úsalo para establecer si la IA atacará a los enemigos cercanos en el camino. VERDADERO significa buscar enemigos; FALSO significa que no busca enemigos.",
  T_36_WZY_WS_MULVALUE: "Escalar",
  T_36_WZY_WS_MULVEC: "Vector de multiplicación escalar",
  T_36_WZY_WS_NEGRES: "Resultado de valor negativo",
  T_36_WZY_WS_NEUTRAL: "Neutral",
  T_36_WZY_WS_NEXTVAWE_NAMEDESC: "Obliga al generador designado a producir la siguiente ola. Los generadores incluyen generación de zombis y objetos.",
  T_36_WZY_WS_NEXTVAWE_PARAM1_NAME: "Entidad de Generador",
  T_36_WZY_WS_NEXTVAWE_PARAM1_NAMEDESC: "La entidad de generador designada, como generación de zombis y objetos",
  T_36_WZY_WS_OBJENT: "Entidad del objeto",
  T_36_WZY_WS_OBTITEM_NAMEDESC: "Se activa cuando se obtiene un objeto. [Tipo de objeto] es el tipo de objeto que se obtiene.",
  T_36_WZY_WS_OBTWEAP_NAMEDESC: "Se activa cuando se obtiene un arma. [Entidad de arma] es el arma obtenida.",
  T_36_WZY_WS_ONEWAY: "Viaje de ida",
  T_36_WZY_WS_OPENSTATE: "Estatus",
  T_36_WZY_WS_OPERMETHOD_NAME: "Operación",
  T_36_WZY_WS_OPERMETHOD_NAMEDESC: "Las operaciones aritméticas básicas. Actualmente, las operaciones con enteros incluyen suma, resta, multiplicación, división y resto, y las operaciones flotantes incluyen suma, resta, multiplicación y división.",
  T_36_WZY_WS_OWNERENT_DESC: "La entidad cuya cartera hay que obtener",
  T_36_WZY_WS_PERCENTAGE: "Ajuste de porcentaje",
  T_36_WZY_WS_PLACOLLIDE_NAME: "Cuando el jugador choca con el disparador",
  T_36_WZY_WS_PLACOLLIDE_NAMEDESC: "Se activa cuando el [jugador disparador] choca con el disparador",
  T_36_WZY_WS_PLACOLLIDE_PARAM1_NAMEDESC: "El jugador que choca con el disparador",
  T_36_WZY_WS_PLACOLLIDE_PARAM2_NAMEDESC: "La entidad del objeto con la que choca el jugador",
  T_36_WZY_WS_PLADRIVEH_NAME: "Cuando el jugador conduce un vehículo",
  T_36_WZY_WS_PLADRIVEH_NAMEDESC: "Se activa cuando el [jugador desencadenante] conduce un vehículo",
  T_36_WZY_WS_PLADRIVEH_PARAM1_NAMEDESC: "El jugador que conduce el vehículo",
  T_36_WZY_WS_PLADRIVEH_PARAM2_NAMEDESC: "La entidad de vehículo que conduce el jugador",
  T_36_WZY_WS_PLAGETOFFVEH_NAME: "Cuando el jugador sale del vehículo",
  T_36_WZY_WS_PLAGETOFFVEH_NAMEDESC: "Se activa cuando el [jugador desencadenante] sale de un vehículo",
  T_36_WZY_WS_PLAGETOFFVEH_PARAM1_NAMEDESC: "El jugador que está saliendo del vehículo",
  T_36_WZY_WS_PLAGETOFFVEH_PARAM2_NAMEDESC: "La entidad de vehículo de la que sale el jugador",
  T_36_WZY_WS_PLAGETONVEH_NAME: "Cuando el jugador ingresa al vehículo",
  T_36_WZY_WS_PLAGETONVEH_NAMEDESC: "Se activa cuando el [jugador desencadenante] ingresa a un vehículo",
  T_36_WZY_WS_PLAGETONVEH_PARAM2_NAMEDESC: "La entidad de vehículo a la que ingresa el jugador",
  T_36_WZY_WS_PLAKNOFLY_NAME: "Cuando el jugador rebota en un neumático",
  T_36_WZY_WS_PLAKNOFLY_NAMEDESC: "Se activa cuando el [jugador desencadenante] rebota en un neumático",
  T_36_WZY_WS_PLAKNOFLY_PARAM1_NAMEDESC: "El jugador que rebota en un neumático",
  T_36_WZY_WS_PLAKNOFLY_PARAM2_NAMEDESC: "La entidad del objeto en la que rebota el jugador",
  T_36_WZY_WS_PLATP_NAME: "Después de que el jugador es teletransportado",
  T_36_WZY_WS_PLATP_PARAM1_NAMEDESC: "El jugador que usa un portal",
  T_36_WZY_WS_PLATP_PARAM2_NAMEDESC: "La entidad del portal que usó el jugador",
  T_36_WZY_WS_PLAYERLIST_DESC: "Una lista de todos los jugadores en esta partida",
  T_36_WZY_WS_POINTPICKER: "Pivote de ruta",
  T_36_WZY_WS_PORTALENT: "Entidad del portal",
  T_36_WZY_WS_PREFAB: "Plantilla",
  T_36_WZY_WS_PRODLIST: "Lista de mercancías",
  T_36_WZY_WS_PRODSORT_PARAM3_NAME: "Orden de clasificación",
  T_36_WZY_WS_PROPMOD: "Método de cambio de propiedad",
  T_36_WZY_WS_RANKABLEE: "Entidad clasificable",
  T_36_WZY_WS_REDCURR_NAMEDESC: "Consume una cierta cantidad de dinero designada en una cartera designada",
  T_36_WZY_WS_REDCURR_PARAM1_NAMEDESC: "La cartera que gasta el dinero",
  T_36_WZY_WS_REDCURR_PARAM2_NAMEDESC: "El tipo de moneda consumida",
  T_36_WZY_WS_REDCURR_PARAM3_NAMEDESC: "La cantidad de dinero consumida",
  T_36_WZY_WS_RNDFRES: "Flotación generada aleatoria",
  T_36_WZY_WS_RNDIRES: "Resultado de la generación de enteros aleatorios",
  T_36_WZY_WS_ROUND_NAME_DESC: "Redondea un valor al entero más cercano",
  T_36_WZY_WS_ROUND_PARAM1_NAMEDESC: "El valor a redondear",
  T_36_WZY_WS_ROUNDRES: "Resultado del redondeo",
  T_36_WZY_WS_RUNAI_NAMEDESC: "El árbol de comportamiento que ejecutará la IA seleccionada",
  T_36_WZY_WS_RUNAI_PARAM1_NAMEDESC: "La entidad de unidad que detiene/ejecuta un árbol de comportamiento predeterminado",
  T_36_WZY_WS_SCOREABLEE: "Entidad puntuable",
  T_36_WZY_WS_SCORECHANGE_NAMEDESC: "Se activa cuando cambia la puntuación. [Tipo de puntuación] es el tipo de puntuación que cambió. [Puntuación] es la nueva puntuación.",
  T_36_WZY_WS_SETDIRPOINT_NAME: "Crear un punto de dirección",
  T_36_WZY_WS_SETDIRPOINT_NAMESESC: "Obtiene un punto de dirección recién creado. Usa [Ubicación] para establecer las coordenadas del punto y [Dirección] para establecer el vector de la dirección.",
  T_36_WZY_WS_SETDIRPOINT_PARAM1_NAMEDESC: "Las coordenadas del punto de dirección",
  T_36_WZY_WS_SETDIRPOINT_PARAM2_NAME: "Dirección",
  T_36_WZY_WS_SETDIRPOINT_PARAM2_NAMEDESC: "El vector del punto de dirección",
  T_36_WZY_WS_SETPATH_NAMEDESC: "Las entidades de IA viajarán según el orden establecido aquí. Los tipos de viaje disponibles son de vuelta, de ida y de ida y vuelta. También puede seleccionar si la IA buscará enemigos en su camino.",
  T_36_WZY_WS_SETPATH_PARAM2_NAMEDESC: "Una lista que consta de los puntos a los que debe viajar la IA",
  T_36_WZY_WS_SETPATH_PARAM3_NAME: "Tipo de viaje",
  T_36_WZY_WS_SETPATH_PARAM3_NAMEDESC: "Estos son los tipos de viaje. El viaje de ida es que la IA deje de viajar una vez que llegue al destino. El viaje de vuelta es para que la IA busque un camino de regreso una vez que llega al destino. El viaje de ida y vuelta es para la IA regrese a la ubicación original de acuerdo con el orden inverso de la lista de rutas.",
  T_36_WZY_WS_SHOPECON: "Tienda y economía",
  T_36_WZY_WS_SHOWFLO_NAMEDESC: "Úsalo para mostrar notificaciones que flotan en la pantalla. Configura el contenido usando [Texto], el color del texto usando [Color] y la duración de visualización usando [Duración] (la unidad es milésimas de segundo).",
  T_36_WZY_WS_SHOWFLO_PARAM1_DESC: "El contenido de la notificación flotante",
  T_36_WZY_WS_SHOWFLO_PARAM2_DESC: "El color de la notificación flotante",
  T_36_WZY_WS_SHOWFLO_PARAM3_DESC: "La duración de visualización de la notificación flotante, en milésimas de segundo",
  T_36_WZY_WS_SIN_NAMEDESC: "Hallar el seno de un ángulo",
  T_36_WZY_WS_SINRES: "Seno del ángulo",
  T_36_WZY_WS_SKIPKNODOWN: "Eliminado al derribar",
  T_36_WZY_WS_SQRTRES: "Resultado de raíz cuadrada",
  T_36_WZY_WS_STRCONRES: "Resultado de la conexión de cadenas",
  T_36_WZY_WS_STRINGLIST: "Lista de cadenas",
  T_36_WZY_WS_STRLEN: "Longitud de la cadena",
  T_36_WZY_WS_STRVAL: "Resultado de la cadena",
  T_36_WZY_WS_TAN_NAMEDESC: "Hallar la tangente de un ángulo",
  T_36_WZY_WS_TANRES: "Tangente del ángulo",
  T_36_WZY_WS_TEAMLIST: "Lista de equipos",
  T_36_WZY_WS_TEAMLIST_DESC: "Una lista de todos los equipos en esta partida",
  T_36_WZY_WS_TIMETWEENTIPS: "Entidad de notificación de cuenta regresiva",
  T_36_WZY_WS_TOSTRING_NAMEDESC: "Convierte el valor objetivo en una cadena",
  T_36_WZY_WS_TOSTRING_PARAM1_DESC: "El valor objetivo para convertir en una cadena",
  T_36_WZY_WS_TOSTRINGRES: "Resultado de la conversión de cadenas",
  T_36_WZY_WS_TOWERCAMP_DESC: "El número de lado y el número de equipo son los mismos. Las torres y fortalezas neutrales atacan a todos los jugadores e IA dentro del alcance.",
  T_36_WZY_WS_TRACURR_NAMEDESC: "Transfiere una cantidad de dinero designada de una cartera a otra",
  T_36_WZY_WS_TRACURR_PARAM1_NAMEDESC: "La cartera para sacar el dinero",
  T_36_WZY_WS_TRACURR_PARAM2_NAMEDESC: "El tipo de moneda en la transacción",
  T_36_WZY_WS_TRACURR_PARAM3_NAMEDESC: "La cantidad de dinero en la transacción",
  T_36_WZY_WS_TRACURR_PARAM4_NAMEDESC: "La cartera para transferir la moneda",
  T_36_WZY_WS_TWEENTIPS: "Entidad de notificación flotante",
  T_36_WZY_WS_TYPEENUM: "Tipo de enumeración",
  T_36_WZY_WS_USEPROP_NAMEDESC: "Se activa cuando un jugador usa un objeto. [Jugador desencadenante] es el jugador que usa un objeto. [Tipo de objeto] es el que usó el jugador.",
  T_36_WZY_WS_USEPROP_PARAM2_DESC: "El tipo de objeto que usa el jugador",
  T_36_WZY_WS_VECADDLEFT: "Valor izquierdo de la suma de vectores",
  T_36_WZY_WS_VECADDRES: "Resultado de la suma de vectores",
  T_36_WZY_WS_VECADDRIGHT: "Valor derecho de la suma de vectores",
  T_36_WZY_WS_VECANGLEFT: "Valor izquierdo del ángulo de los vectores",
  T_36_WZY_WS_VECANGRES: "Ángulo entre 2 vectores",
  T_36_WZY_WS_VECANGRIGHT: "Valor derecho del ángulo de los vectores",
  T_36_WZY_WS_VECCROLEFT: "Valor izquierdo del producto cruzado",
  T_36_WZY_WS_VECCRORES: "Resultado del producto cruzado",
  T_36_WZY_WS_VECCRORIGHT: "Valor derecho del producto cruzado",
  T_36_WZY_WS_VECDISLEFT: "Valor izquierdo de la distancia de los vectores",
  T_36_WZY_WS_VECDISRES: "Distancia entre 2 vectores",
  T_36_WZY_WS_VECDISRIGHT: "Valor derecho de la distancia de los vectores",
  T_36_WZY_WS_VECDOCLEFT: "Valor izquierdo del producto escalar",
  T_36_WZY_WS_VECDOCRES: "Resultado del producto escalar",
  T_36_WZY_WS_VECDOCRIGHT: "Valor derecho del producto escalar",
  T_36_WZY_WS_VECMULRES: "Resultado de la multiplicación escalar",
  T_36_WZY_WS_VECNORRES: "Vector normalizado",
  T_36_WZY_WS_VECSIZERES: "Magnitud de un vector",
  T_36_WZY_WS_VECSUBLEFT: "Valor izquierdo de la resta de vectores",
  T_36_WZY_WS_VECSUBRES: "Resultado de resta de vectores",
  T_36_WZY_WS_VECSUBRIGHT: "Valor derecho de la resta de vectores",
  T_36_WZY_WS_VECTORLIST: "Lista de vectores",
  T_36_WZY_WS_VECX: "Componente x",
  T_36_WZY_WS_VECY: "Componente y",
  T_36_WZY_WS_VECZ: "Componente z",
  T_36_WZY_WS_VEHENT: "Entidad del vehículo",
  T_36_WZY_WS_WALLCONT: "Contenido de la cartera",
  T_36_WZY_WS_ZOMBIESPERWAVE: "Continuo",
  T_36_XYL_WS_AIBOT: "Unidad",
  T_36_XYL_WS_AIGENERATOR: "Generador de unidades",
  T_36_XYL_WS_AIGENERATOR_DESC: "Un generador que puede generar continuamente unidades designadas (por ejemplo, zombis)",
  T_36_XYL_WS_AIWAVE: "# de unidades por ola",
  T_36_XYL_WS_ARROW: "Señal de dirección",
  T_36_XYL_WS_ARROW_DESC: "Una señal que apunta a una dirección",
  T_36_XYL_WS_BREAKBOX: "Caja Rompible",
  T_36_XYL_WS_BREAKBOX_DESC: "Una caja de madera que se puede romper cuando es atacada",
  T_36_XYL_WS_FENCE: "Valla de Hierro",
  T_36_XYL_WS_FENCE_DESC: "Una valla que permite que las balas vuelen",
  T_36_XYL_WS_STAIRI: "Plataforma C",
  T_36_XYL_WS_STAIRI_DESC: "Una plataforma que se puede combinar con escaleras",
  T_36_XYL_WS_ZOMBIEAI: "Zombi",
  T_36_XYL_WS_ZOMBIEAI_DESC: "Un zombi que se puede personalizar y ser un sujeto obtenido y duplicado en el Generador de Unidades",
  T_36_YF_CORRODE_GRENADE_N: "Granada Gloo",
  T_36_YF_SETTING_TYPE3: "Preset 3",
  T_36_YS_B_BRFOOTBALL_BLUE01: "Uniforme de Fútbol Océano CBF (Inferior)",
  T_36_YS_B_BRFOOTBALL_YELLOW01: "Uniforme de Fútbol CBF Amanecer (Inferior)",
  T_36_YS_F_A_GHOSTHUNTER: "Felina Yin (Máscara)",
  T_36_YS_F_B_GHOSTHUNTER: "Felina Yin (Inferior)",
  T_36_YS_F_H_GHOSTHUNTER: "Felina Yin (Cabeza)",
  T_36_YS_F_S_GHOSTHUNTER: "Felina Yin (Zapatos)",
  T_36_YS_SETTING_GRENADE: "Lanzables",
  T_36_YS_SETTING_MOVE: "Movimiento",
  T_36_YS_T_BRFOOTBALL_BLUE01: "Uniforme de Fútbol Océano CBF (Superior)",
  T_36_YS_T_BRFOOTBALL_YELLOW01: "Uniforme de Fútbol Amanecer CBF (Superior)",
  T_36_YZY_CHARACTER_GANGGIRL_N: "Luna",
  T_36_YZY_CHARACTER_YAKUZA_N: "Tatsuya",
  T_36_YZY_PET_WOLF_N: "Colmillo",
  T_36_YZY_PETSKIN_AXOLOTL_GRIZA_N: "Aspecto de Mascota: Zasil Púrpura",
  T_36_YZY_PETSKIN_HAWK_BDK_N: "Aspecto de Mascota: Falco Relámpago",
  T_36_YZY_PETSKIN_WOLF_FIRE_N: "Aspecto de Mascota: Colmillo de Lava",
  T_36_YZY_PETSKIN_WOLF_SUGARSKULL22_N: "Aspecto de Mascota: Colmillo Guía Espectral",
  T_36_YZY_PETSKIN_WOLF_WINTER_N: "Aspecto de Mascota: Colmillo del Ártico",
  T_37_B_WS_HIDE: "Escondite",
  T_37_HZ_WS_CATMODEDESC1: "Escondite",
  T_37_JH_WS_CREATEGOLD_DESC: "Una Máquina Expendedora desde la que los jugadores pueden comprar objetos. (No es válido en los modos Duelo de Escuadra, Combate a Muerte, Campo de Juegos y Apocalipsis Androide)",
  T_37_JH_WS_NAME1: "Cuchillo FF (Apocalipsis Androide)",
  T_37_JH_WS_NAME10: "M1887-X (Apocalipsis Androide)",
  T_37_JH_WS_NAME11: "SPAS12 (Apocalipsis Androide)",
  T_37_JH_WS_NAME12: "M1014 (Apocalipsis Androide)",
  T_37_JH_WS_NAME13: "MP40 (Apocalipsis Androide)",
  T_37_JH_WS_NAME14: "MP5-III (Apocalipsis Androide)",
  T_37_JH_WS_NAME15: "P90 (Apocalipsis Androide)",
  T_37_JH_WS_NAME16: "M60-III (Apocalipsis Androide)",
  T_37_JH_WS_NAME17: "Thompson (Apocalipsis Androide)",
  T_37_JH_WS_NAME18: "UMP (Apocalipsis Androide)",
  T_37_JH_WS_NAME19: "SVD (Apocalipsis Androide)",
  T_37_JH_WS_NAME2: "GROZA (Apocalipsis Androide)",
  T_37_JH_WS_NAME20: "AWM (Apocalipsis Androide)",
  T_37_JH_WS_NAME21: "M82B (Apocalipsis Androide)",
  T_37_JH_WS_NAME22: "M249-X (Apocalipsis Androide)",
  T_37_JH_WS_NAME23: "Kar98k-III (Apocalipsis Androide)",
  T_37_JH_WS_NAME3: "AK47 (Apocalipsis Androide)",
  T_37_JH_WS_NAME4: "M4A1-III (Apocalipsis Androide)",
  T_37_JH_WS_NAME5: "SCAR (Apocalipsis Androide)",
  T_37_JH_WS_NAME6: "M14-III (Apocalipsis Androide)",
  T_37_JH_WS_NAME7: "PARAFAL (Apocalipsis Androide)",
  T_37_JH_WS_NAME8: "XM8 (Apocalipsis Androide)",
  T_37_JH_WS_NAME9: "MAG-7 (Apocalipsis Androide)",
  T_37_JH_WS_VENDMACHINE_DESC: "Oro que se puede recoger por el mapa. (No es válido en los modos Duelo de Escuadra, Combate a Muerte, Campo de Juegos y Apocalipsis Androide)",
  T_37_JH_WS_X: "Eje X",
  T_37_JH_WS_Y: "Eje Y",
  T_37_JH_WS_Z: "Eje Z",
  T_37_JL_FOOTBALL_TIE: "Empate",
  T_37_JL_GOLD_M1014_I_N: "M1014-I",
  T_37_JL_GOLD_M1014_II_N: "M1014-II",
  T_37_JL_GOLD_M1014_III_N: "M1014-III",
  T_37_JL_M1216_N: "Trogón",
  T_37_KK_WS_SNOWMAN: "Sr. Wagger de Nieve",
  T_37_LC_BP_ENTRANCE_GIFT: "¡Regalo!",
  T_37_M_WS_MISSING: "Recurso faltante",
  T_37_M_WS_NAMEERROR: "Contiene caracteres sensibles. Cámbialos.",
  T_37_PD_HuntingGround_BOSSTITLE: "El Carnicero",
  T_37_QL_JUMPPAD_DES: "Crea una plataforma de salto en el suelo. Se puede usar para saltar alto en el aire y permite disparar desde el aire.",
  T_37_QL_JUMPPAD_NAME: "Trampolín",
  T_37_R_TAILOR_LIMIT: "Tiempo limitado",
  T_37_RW_LOADOUT_BORNFIRETAG: "Obtén 2 fogatas al inicio de la partida. La fogata [FFBA00]regenera 5 PV y 20 PE por segundo[-] (hasta 10 segundos) para ti y tus compañeros de equipo dentro del área. Los efectos de la fogata no se acumulan.",
  T_37_RW_PROPCATAPULT_DESC: "Cuando está inflada, la plataforma de lanzamiento se puede usar para proyectar a un jugador en el aire. ¡Pero asegúrate de permanecer en la zona segura!",
  T_37_RW_PROPCATAPULT_NAME: "Plataforma de Lanzamiento",
  T_37_SP_WS_COLOR_02: "Color",
  T_37_SP_WS_COLOR_03: "Apariencia",
  T_37_SP_WS_LOG_ENTITY_IS_EMPTY: "La entidad es nula al obtener o fijar su propiedad",
  T_37_SP_WS_LOG_PHASE_END: "Etapa {0} finalizada",
  T_37_SP_WS_LOG_PHASE_START: "Inicia etapa {0}",
  T_37_SP_WS_LOG_ROUND_END: "Ronda {0} finalizada",
  T_37_SP_WS_LOG_ROUND_START: "Ronda {0} iniciada",
  T_37_SP_WS_LOG_VAR_ASSIGNMENT_OPERATOR_MISMATCH: "El tipo no coincide al asignar un valor a la variable. Tipo requerido: {0}. Tipo actual: {1}.",
  T_37_SP_WS_LOG_VAR_UNDEFINED_OR_OUT_OF_SCOPE: "Variable local no definida o fuera de alcance {0}",
  T_37_SP_WS_MAPACCESS_08: "Editar",
  T_37_SP_WS_RACEMODE_01: "Modo Cuenta Regresiva",
  T_37_SP_WS_RACEMODE_02: "Tiempo de cuenta regresiva",
  T_37_SP_WS_RACEMODE_04: "Cuando está activado y un equipo completo llegue al punto final, iniciará una cuenta regresiva. El juego termina cuando termina la cuenta regresiva.",
  T_37_SY_AR15_KABUKI_N: "Kingfisher- Alma Sagrada",
  T_37_SY_BACKPACK_STRAW_N: "Mochila Sombrero de Agricultor",
  T_37_SY_GRENADE_FFWS2022_01_N: "Granada- Explorador de Galaxias",
  T_37_SY_GROUPANIM_BLACKHOLE_N: "Agujero Negro",
  T_37_SY_M1216_MAMBAS_N: "Trogón - Veneno Letal",
  T_37_SY_PET_FLYINGCREATURE_N: "Dragoncito",
  T_37_SY_PETSKIN_DUCK_WINTERFEST22_N: "Aspecto de Mascota: Don Cuack Estrella Glam",
  T_37_SY_PETSKIN_FLYINGCREATURE_BLUE_N: "Aspecto de Mascota: Dragoncito Ceniza",
  T_37_SY_PETSKIN_FLYINGCREATURE_ORANGE_N: "Aspecto de Mascota: Dragoncito de la Galaxia",
  T_37_SY_PETSKIN_FLYINGCREATURE_PURPLE_N: "Aspecto de Mascota: Dragoncito de Fuego",
  T_37_SY_PETSKIN_TORTOISE_SOCCER22_N: "Aspecto de Mascota: Flash Futbolista",
  T_37_SY_PETSKIN_YETI_NEWYEAR22_N: "Aspecto de Mascota: Yeti Felices Fiestas",
  T_37_SY_VEHICLE_JEEP_WINTERFEST22_N: "Jeep- Festival del Rock",
  T_37_SY_VEHICLE_SUV_FFWS2022_N: "Camioneta Pickup- Bestia Estelar",
  T_37_WT_WS_PVE2DESC: `Un modo de supervivencia zombi en el que los jugadores eliminan a un número determinado de zombis dentro de un límite de tiempo o sobreviven hasta el final.
Puedes establecer las reglas del juego y ajustar los ajustes de los zombis como prefieras, incluido el número objetivo de zombis a eliminar.`,
  T_37_WT_WS_RULEDESC: "EliminaR el número objetivo de zombis para ganar.",
  T_37_WT_WS_RULETITLE: "Objetivo",
  T_37_WT_WS_TXT1: "Eliminar zombis",
  T_37_WT_WS_TXT1DESC: "Cuando está activado, los jugadores ganan al eliminar el número especificado de zombis. Cuando está desactivado, los jugadores ganan al sobrevivir hasta el final.",
  T_37_WT_WS_TXT2: "Cantidad de eliminación",
  T_37_WZY_FRIDPLA: "Jugador amigo",
  T_37_WZY_FRIDSIDE: "Facción amiga",
  T_37_WZY_FRIDTEAM: "Equipo amigo",
  T_37_WZY_HOSTPLA: "Jugador enemigo",
  T_37_WZY_HOSTSIDE: "Facción enemiga",
  T_37_WZY_WS_ACCFRAMES: "Marcos acumulados",
  T_37_WZY_WS_ADDITEMTOPROD_NAMEDESC: "Agrega objetos a una mercancía. Puedes agregar un solo objeto o un grupo de objetos. La cantidad puede ser el número de objetos individuales o una lista que consta de objetos de esta cantidad.",
  T_37_WZY_WS_ADDITEMTOPROD_PARAM1_DESC: "La entidad de mercancías para agregar objetos",
  T_37_WZY_WS_ADDITEMTOPROD_PARAM2_DESC: "Los objetos a agregar. Puede agregar un solo objeto o un grupo de objetos.",
  T_37_WZY_WS_ADDITEMTOPROD_PARAM3_DESC: "La cantidad de los objetos individuales que se van a agregar o una lista que consta de objetos de esta cantidad.",
  T_37_WZY_WS_ADDLABEL_NAMEDESC: "Agregar una etiqueta para la entidad seleccionada",
  T_37_WZY_WS_ADDLABEL_PARAM1_DESC: "La entidad a la que agregar la etiqueta",
  T_37_WZY_WS_ADDLABEL_PARAM2_DESC: "El contenido de texto para agregar",
  T_37_WZY_WS_AIMABLEENT: "Entidad a apuntar",
  T_37_WZY_WS_AIMASSISTTYPE: "Tipo de asistencia de puntería",
  T_37_WZY_WS_ALLOWDROP_NAME: "Habilitar/deshabilitar si soltar objetos",
  T_37_WZY_WS_ALLOWDROP_NAMEDESC: "Si un jugador puede soltar objetos",
  T_37_WZY_WS_ALLOWDROP_PARAM1_DESC: "La entidad de jugador para configurar si soltar objetos",
  T_37_WZY_WS_ALLOWDROP_PARAM2_DESC: "Si un jugador puede soltar objetos. Este es un valor booleano.",
  T_37_WZY_WS_ALLOWPICKUP_NAME: "Habilitar/deshabilitar recoger objetos",
  T_37_WZY_WS_ALLOWPICKUP_NAMEDESC: "Si un jugador puede recoger objetos",
  T_37_WZY_WS_ALLOWPICKUP_PARAM1_DESC: "La entidad de jugador para configurar si recoge objetos",
  T_37_WZY_WS_ALLOWPICKUP_PARAM2_DESC: "Si un jugador puede recoger objetos. Este es un valor booleano.",
  T_37_WZY_WS_AMBIENTCOLOR: "Color de luz del ambiente",
  T_37_WZY_WS_AMRORTOOL: "Armadura de reparación",
  T_37_WZY_WS_ATTACK: "Ataque",
  T_37_WZY_WS_BACKTONOR_NAMEDESC: "Cancela el disfraz del jugador para que vuelva a su apariencia normal",
  T_37_WZY_WS_BACKTONOR_PARAM1_DESC: "La entidad de jugador cuyo disfraz se debe cancelar",
  T_37_WZY_WS_BALLADDV_NAMEDES: "Aumenta la velocidad de un balón de fútbol",
  T_37_WZY_WS_BALLADDV_PARAM1_DESC: "El balón de fútbol que aumentará de velocidad",
  T_37_WZY_WS_BALLADDV_PARAM2_DESC: "El vector de velocidad del impulso",
  T_37_WZY_WS_BALLKICKED_NAMEDESC: "Se activa cuando el Tirador de Fútbol tira la pelota. [Entidad de jugador] es el jugador que posee el Tirador de Fútbol. [Impulso de Velocidad] es la velocidad añadida del balón después de ser golpeado.",
  T_37_WZY_WS_BALLKICKED_PARAM1_DESC: "El jugador que posee al Tirador de Fútbol",
  T_37_WZY_WS_BALLKICKED_PARAM2_DESC: "El vector de velocidad del balón de fútbol después de haber sido golpeado",
  T_37_WZY_WS_BALLKNOCKED_NAMEDESC: "Se activa cuando el balón de fútbol choca con una entidad y aumenta la velocidad del balón. [Entidad en colisión] es la entidad que choca con el balón. [Impulso de velocidad] es la velocidad adicional del balón de fútbol después de la colisión.",
  T_37_WZY_WS_BALLKNOCKED_PARAM1_DESC: "La entidad que choca con el balón de fútbol",
  T_37_WZY_WS_BALLKNOCKED_PARAM2_DESC: "El vector de velocidad que se agrega al balón de fútbol tras la colisión",
  T_37_WZY_WS_BEAIMED_NAMEDESC: "Se activa cuando un jugador apunta a la entidad",
  T_37_WZY_WS_BEAIMED_PARAM1_DESC: "El jugador que está apuntando a la entidad",
  T_37_WZY_WS_BEHAVIORSTAT: "Estatus de comportamiento del jugador",
  T_37_WZY_WS_BEHIT_PARAM1_DESC: "La entidad de arma que golpea a esta entidad",
  T_37_WZY_WS_BLOODBARENT: "Entidad de la barra de salud",
  T_37_WZY_WS_BOMBEND: "Antes de la explosión",
  T_37_WZY_WS_BOMBSTART: "Indicador de bomba",
  T_37_WZY_WS_CHANENT: "Entidad del canal",
  T_37_WZY_WS_CHEER: "Alegría",
  T_37_WZY_WS_CHELABEL_NAMEDESC: "Comprobar si una entidad seleccionada contiene etiquetas designadas",
  T_37_WZY_WS_CHELABEL_PARAM1_DESC: "La entidad para revisar si contiene etiquetas",
  T_37_WZY_WS_CHELABEL_PARAM2_DESC: "La etiqueta a revisar",
  T_37_WZY_WS_CHELABELRES: "El resultado de la revisión de etiquetas. Este es un valor booleano.",
  T_37_WZY_WS_CJERSEY_NAME: "Cambiar uniforme",
  T_37_WZY_WS_CJERSEY_PARAM1_DESC: "El jugador cuyo uniforme se va a cambiar",
  T_37_WZY_WS_CJERSEY_PARAM2: "Diseño del Uniforme",
  T_37_WZY_WS_CJERSEY_PARAM2_DESC: "El diseño a cambiar",
  T_37_WZY_WS_CJERSEY_PARAM3_DESC: "El color de la parte 1 en el uniforme",
  T_37_WZY_WS_CJERSEY_PARAM4_DESC: "El color de la parte 2 en el uniforme",
  T_37_WZY_WS_CJERSEY_PARAM5_DESC: "El color de la parte 3 en el uniforme",
  T_37_WZY_WS_CJERSEYTYPE1: "Diseño 1",
  T_37_WZY_WS_CJERSEYTYPE2: "Diseño 2",
  T_37_WZY_WS_CJERSEYTYPE3: "Diseño 3",
  T_37_WZY_WS_CLEAR_ARR_DESC: "Borra todos los elementos de la lista",
  T_37_WZY_WS_CREABLEOB_DESC: "El tipo de objeto que se puede crear utilizando bloques",
  T_37_WZY_WS_CREPROD_NAMEDESC: "Crea una mercancía personalizable y devuelve una entidad de mercancía. El contenido de la mercancía se puede configurar a través de la configuración de la propiedad.",
  T_37_WZY_WS_CRESHELVES_NAMEDESC: "Crea una lista de mercancías personalizable y devuelve una entidad de lista de mercancías. El contenido de esta lista se puede cambiar a través de la configuración de propiedades.",
  T_37_WZY_WS_CRESHELVES_PARAM1_DESC: "La entidad de la lista de mercancías que se va a crear",
  T_37_WZY_WS_CRESIDE_NAMEDESC: "Crear una entidad de facción",
  T_37_WZY_WS_CRESIDE_PARAM1_DESC: "La entidad de facción que se creará",
  T_37_WZY_WS_CRESTORE_NAMEDESC: "Crea una tienda personalizable y devuelve una entidad de tienda. El contenido de la tienda se puede cambiar a través de la configuración de propiedades.",
  T_37_WZY_WS_CRESTORE_PARAM2_DESC: "La entidad de tienda creada",
  T_37_WZY_WS_CSKYBOX_NAMEDESC: "Cambia el entorno del cielo en el juego. Las opciones incluyen día, tarde y noche.",
  T_37_WZY_WS_CSKYBOX_PARAM1_DESC: "El tipo de cielo al que cambiar. Las opciones incluyen día, tarde y noche.",
  T_37_WZY_WS_DARKNESS: "Oscuridad general",
  T_37_WZY_WS_DELENT_NAMEDESC: "Eliminar una entidad designada. Actualmente, admite entidades de iconos, entidades de texto, entidades de HUD, entidades de efectos visuales, entidades de armas y otras entidades de objetos.",
  T_37_WZY_WS_DELENT_PARAM1_DESC: "La entidad a eliminar",
  T_37_WZY_WS_DROP: "Error",
  T_37_WZY_WS_DROPITEMS_NAMEDESC: "Se activa cuando el jugador suelta un objeto. [Tipo de objeto] es el ID del tipo de objeto soltado.",
  T_37_WZY_WS_DROPITEMS_PARAM1_DESC: "El ID de tipo del objeto soltado",
  T_37_WZY_WS_DROPWEAP_NAMEDESC: "Se activa cuando el jugador suelta un arma. [Tipo de objeto] es el ID del tipo del arma soltada.",
  T_37_WZY_WS_DROPWEAP_PARAM1_DESC: "El arma que se suelta",
  T_37_WZY_WS_DUMMYLEOBJ: "Objeto de etapa regular",
  T_37_WZY_WS_DUST: "Tarde",
  T_37_WZY_WS_EMPTYCH: "Canal vacío predeterminado",
  T_37_WZY_WS_EMPTYCH1: "Canal vacío 1",
  T_37_WZY_WS_EMPTYCH2: "Canal vacío 2",
  T_37_WZY_WS_EMPTYCH3: "Canal vacío 3",
  T_37_WZY_WS_EMPTYCH4: "Canal vacío 4",
  T_37_WZY_WS_EMPTYCH5: "Canal vacío 5",
  T_37_WZY_WS_EMPTYCH6: "Canal vacío 6",
  T_37_WZY_WS_ENTFILTER_NAMEDESC: 'Obtener una lista que contenga todas las entidades que cumplan las 3 condiciones. El contenido insertado para "Incluye todo", "Excluye" e "Incluye" es un solo tipo de componente o una lista de tipos de componentes. El resultado devuelto es una lista de entidades que cumplen las condiciones.',
  T_37_WZY_WS_ENTFILTER_PARAM1_DESC: "Las entidades filtradas deben contener todos los componentes de esta matriz",
  T_37_WZY_WS_ENTFILTER_PARAM2_DESC: "Las entidades filtradas no deben contener componentes designados de esta matriz",
  T_37_WZY_WS_ENTFILTER_PARAM3_DESC: "Las entidades filtradas deben contener al menos un componente de esta matriz",
  T_37_WZY_WS_ENTITY2_PARAM3_DESC: "El tipo de propiedad de esta entidad a cambiar",
  T_37_WZY_WS_ENTITY2_PARAM4_DESC: "El valor de la propiedad a cambiar",
  T_37_WZY_WS_EXITCHAN_NAMEDESC: "Permite que el jugador deje el canal actual para que no esté en ningún canal",
  T_37_WZY_WS_EXITCHAN_PARAM1_DESC: "El jugador que sale del canal",
  T_37_WZY_WS_FAKEENT: "Entidad del disfraz",
  T_37_WZY_WS_FIND_STR_DESC: "Encuentra la ubicación de un texto designado dentro de una cadena.",
  T_37_WZY_WS_FINDSTR_PARAM1DESC: "El personaje a encontrar",
  T_37_WZY_WS_FINDSTR_PARAM2DESC: "Encuentra una cadena desde la ubicación inicial, que comienza desde 0.",
  T_37_WZY_WS_FINDSTRRES: "La primera ubicación en la que aparece la cadena. Comienza desde 0.",
  T_37_WZY_WS_FOGCOLOR: "Color de niebla",
  T_37_WZY_WS_FRICTIONCON: "Multiplicador de fricción regular",
  T_37_WZY_WS_FRICTIONIMP: "Multiplicador de fricción de colisión",
  T_37_WZY_WS_FROMDEATH: "Resurrección",
  T_37_WZY_WS_FROMKNODOWN: "Ayudar a levantarse",
  T_37_WZY_WS_GETCHAN_NAMEDESC: "Obtiene el canal en el que se encuentra el jugador designado",
  T_37_WZY_WS_GETCHAN_PARAM1_DESC: "La entidad de jugador cuyo canal hay que obtener",
  T_37_WZY_WS_GETCHANRES: "El canal en el que se encuentra actualmente el jugador",
  T_37_WZY_WS_GETEMPTYCH_NAMEDES: "Según el ID del canal 1 al 8, obtiene el canal vacío que se creó por defecto al comienzo del juego",
  T_37_WZY_WS_GETEMPTYCH_PARAM1_DESC: "ID del canal vacío predeterminado",
  T_37_WZY_WS_GETEMPTYCH_RES: "La entidad de canal obtenida",
  T_37_WZY_WS_GETFAKEENT_NAMEDESC: "Obtiene la entidad del disfraz de un jugador",
  T_37_WZY_WS_GETFAKEENT_PARAM1_DESC: "Obtiene el objeto de la entidad del disfraz",
  T_37_WZY_WS_GETGAMEENT_NAME: "Obtener global",
  T_37_WZY_WS_GETGAMEENT_NAMEDESC: "Obtiene la entidad de juego de esta partida",
  T_37_WZY_WS_GETHOSTPLA_NAME: "Obtener jugador atacable",
  T_37_WZY_WS_GETHOSTSIDE_PARAM1: "Entidad de facción",
  T_37_WZY_WS_GOAL_NAMEDESC: "Se activa cuando un balón de fútbol entra en la portería. [Portería] es donde se anota el gol. El [goleador] es el último jugador en haber tocado el balón. El [asistente] es el penúltimo jugador en haber tocado el balón.",
  T_37_WZY_WS_GOAL_PARAM1_DESC: "La portería donde se anota el gol",
  T_37_WZY_WS_GOAL_PARAM2_DESC: "El último jugador en haber tocado el balón",
  T_37_WZY_WS_GOAL_PARAM3_DESC: "El penúltimo jugador en haber tocado el balón",
  T_37_WZY_WS_HEARTBEAT: "Latido del corazón",
  T_37_WZY_WS_HEAVYWEAPON: "Arma pesada",
  T_37_WZY_WS_HIHGSHOOTANGLE: "Ángulo de voleo más pequeño",
  T_37_WZY_WS_HOSTPLA: "Una lista de jugadores atacables",
  T_37_WZY_WS_HOSTSIDE: "Una lista de facciones atacables",
  T_37_WZY_WS_HOSTTEAM: "Una lista de equipos atacables",
  T_37_WZY_WS_ICON_CLOCK: "Cuenta Regresiva",
  T_37_WZY_WS_ICON_CLOTHES: "Ropa",
  T_37_WZY_WS_ICON_QUIT: "Salir",
  T_37_WZY_WS_INSERT_ARR_DESC: "Inserta un nuevo elemento en una ubicación designada en la lista",
  T_37_WZY_WS_INTERCEPT_STR_DESC: "Extrae una cadena de una longitud designada, comenzando desde la ubicación del índice. Si la longitud de extracción excede la longitud de la cadena, extraerá el contenido hasta el final de la cadena.",
  T_37_WZY_WS_INTERCEPTSTR_PARAM1DESC: "Longitud de la extración",
  T_37_WZY_WS_INTERCEPTSTRRES_DESC: "La cadena que se extrajo",
  T_37_WZY_WS_INTORINTL: "Entero o lista de enteros",
  T_37_WZY_WS_JOINSIDE_NAMEDESC: "Permite que un jugador se una a una facción designada",
  T_37_WZY_WS_JOINSIDE_PARAM2_DESC: "La facción a la que se unirá el jugador",
  T_37_WZY_WS_JUMP: "Salto",
  T_37_WZY_WS_LABEL: "Etiqueta",
  T_37_WZY_WS_LENSFLARE: "Destello de lente",
  T_37_WZY_WS_LENTH: "Longitud",
  T_37_WZY_WS_LIGHTATTACK: "Golpe exitoso",
  T_37_WZY_WS_LIGHTCOLOR: "Color de la fuente de luz",
  T_37_WZY_WS_LIGHTINTENSITY: "Brillo de la fuente de luz",
  T_37_WZY_WS_LOADSCENE_NAMEDESC: "Cargar un nuevo escenario",
  T_37_WZY_WS_LOADSCENE_PARAM1_DESC: "El nombre del escenario a cargar",
  T_37_WZY_WS_MOROBJECT: "Disfrazar objeto",
  T_37_WZY_WS_MOVEAXISX: "Mover a lo largo del eje x",
  T_37_WZY_WS_MOVEAXISY: "Mover a lo largo del eje y",
  T_37_WZY_WS_MOVEAXISZ: "Mover a lo largo del eje z",
  T_37_WZY_WS_MOVEDISTITLE: "Distancia de movimiento",
  T_37_WZY_WS_MUTEQUICKCHAT_NAME: "Activar o desactivar mensajes rápidos",
  T_37_WZY_WS_MUTEQUICKCHAT_NAMEDESC: "Activa o desactiva los mensajes rápidos. Cuando está desactivado, el HUD de mensajes rápido no se puede usar y los jugadores no podrán enviar ni recibir mensajes rápidos.",
  T_37_WZY_WS_MUTEQUICKCHAT_PARAM1_DESC: "El jugador puede activar/desactivar los mensajes rápidos",
  T_37_WZY_WS_MUTEVOICE_NAME: "Activar o desactivar el chat de voz",
  T_37_WZY_WS_MUTEVOICE_NAMEDESC: "Activa o desactiva el chat de voz. Cuando está desactivado, el HUD de voz no se puede usar y los jugadores no podrán enviar ni recibir mensajes de voz.",
  T_37_WZY_WS_MUTEVOICE_PARAM1_DESC: "El jugador puede activar/desactivar el chat de voz",
  T_37_WZY_WS_MUTEVOICE_PARAM2_DESC: "Booleano. Verdadero significa desactivado; Falso significa activado.",
  T_37_WZY_WS_NIGHTMODE: "Modo nocturno",
  T_37_WZY_WS_ONAIM_NAMEDESC: "Se activa cuando el jugador está apuntando a una entidad a la que se puede apuntar. [Entidad de destino] es la entidad a la que se dirige. Cuando no se apunta a ninguna entidad, el valor de retorno es nulo.",
  T_37_WZY_WS_ONAIM_PARAM1_NAME: "Entidad apuntada",
  T_37_WZY_WS_ONHIT_PARAM1_DESC: "La entidad que el arma ha golpeado",
  T_37_WZY_WS_ONSCENELOADING_NAMEDESC: "Se activa cuando el escenario se carga con éxito.",
  T_37_WZY_WS_ONSCENELOADING_PARAM1_DESC: "El nombre del escenario a cargar. Esta es una cadena.",
  T_37_WZY_WS_ONSCENESWITCH_NAMEDESC: "Se activa cuando el escenario cambia con éxito",
  T_37_WZY_WS_ONSCENESWITCH_PARAM1_DESC: "El nombre del nuevo escenario. Esta es una cadena.",
  T_37_WZY_WS_OUTJERSEY_NAMEDESC: "Restaura la ropa del jugador a su apariencia predeterminada",
  T_37_WZY_WS_OUTJERSEY_PARAM1_DESC: "El jugador cuya ropa predeterminada se debe restaurar",
  T_37_WZY_WS_PETSET: "Configuración de mascota",
  T_37_WZY_WS_PETSKILL: "Habilidades de mascotas",
  T_37_WZY_WS_PETSWITCH2: "Si se pueden usar habilidades de mascotas",
  T_37_WZY_WS_PLAMOVE_PARAM2_DESC: "Ya sea para habilitar el movimiento del jugador. Este es un valor booleano.",
  T_37_WZY_WS_PLAYERBEHAVIOR: "Tipo de comportamiento del jugador",
  T_37_WZY_WS_PRESS: "Clic suave",
  T_37_WZY_WS_PROGRESS: "Progreso actual",
  T_37_WZY_WS_PROGRESSBAR: "Entidad de HUD de progreso",
  T_37_WZY_WS_RANKDOWN: "Bajar de rango",
  T_37_WZY_WS_REMLABEL_NAMEDESC: "Remueve una etiqueta para la entidad seleccionada",
  T_37_WZY_WS_REMLABEL_PARAM1_DESC: "El contenido de texto a remover",
  T_37_WZY_WS_REPLACE_STR_DESC: "Reemplaza el contenido de una cadena con un contenido designado",
  T_37_WZY_WS_REPLACESTR_PARAM1DESC: "El personaje a reemplazar",
  T_37_WZY_WS_REPLACESTR_PARAM2DESC: "El nuevo personaje a reemplazar",
  T_37_WZY_WS_REVERSE_ARR_DESC: "Invierte todos los elementos de esta lista",
  T_37_WZY_WS_REVIVEHERE: "El jugador que está reviviendo a sus compañeros de equipo en este punto de resurrección.",
  T_37_WZY_WS_REVIVEHERE_NAMEDESC: "Se activa cuando un jugador está reviviendo a sus compañeros de equipo en este punto de resurrección.",
  T_37_WZY_WS_REVIVEWAYDESC: "El método por el cual un jugador es revivido o ayudado a ser eliminado o derribado.",
  T_37_WZY_WS_SATBEHAVIOR_NAMEDESC: "Configura el estatus de los diferentes comportamientos de los jugadores. Cuando está deshabilitado, no se pueden usar los botones correspondientes en el HUD y no se permiten movimientos manuales ni automáticos. Cuando están ocultos, los botones correspondientes no se mostrarán en el HUD y los movimientos manuales no están permitidos mientras que los movimientos automáticos sí. Cuando está habilitado, los botones correspondientes se mostrarán en el HUD y se permitirán movimientos manuales y automáticos.",
  T_37_WZY_WS_SATBEHAVIOR_PARAM1_DESC: "El jugador para establecer el estatus de comportamiento",
  T_37_WZY_WS_SATBEHAVIOR_PARAM2_DESC: "El comportamiento del jugador, incluidos moverse, atacar, saltar y correr.",
  T_37_WZY_WS_SATBEHAVIOR_PARAM3_DESC: "El estatus incluye deshabilitado, oculto y habilitado. Cuando están ocultos, los botones correspondientes no se mostrarán en el HUD y los movimientos manuales no están permitidos mientras que los movimientos automáticos sí. Cuando está habilitado, los botones correspondientes se mostrarán en el HUD y se permitirán movimientos manuales y automáticos.",
  T_37_WZY_WS_SETBALL_PARAM2_DESC: "Las coordenadas del balón",
  T_37_WZY_WS_SETBALL_PARAM3_DESC: "Si el balón debe mantener su velocidad preconfigurada. Este es un valor booleano.",
  T_37_WZY_WS_SETPLAHOST_NAME: "Configuración de ataque del jugador",
  T_37_WZY_WS_SETPLAHOST_NAMEDESC: "Configura si [Jugador Configurado] puede atacar [Jugador Objetivo]. La configuración predeterminada se basa en si el jugador objetivo pertenece a un equipo y facción que puede ser atacado. Esta configuración tiene una prioridad más alta que la configuración de equipo/facción.",
  T_37_WZY_WS_SETPLAHOST_PARAM1_DESC: "El jugador para configurar enemigos",
  T_37_WZY_WS_SETPLAHOST_PARAM2_DESC: "El jugador que es el enemigo",
  T_37_WZY_WS_SETPLAHOST_PARAM3: "Atacable o no",
  T_37_WZY_WS_SETPLAHOST_PARAM3_DESC: '"Sí" significa atacable; "No" significa no atacable. La configuración predeterminada se basa en si el jugador objetivo pertenece a un equipo y facción que puede ser atacado.',
  T_37_WZY_WS_SETSIDEHOST_PARAM3_DESC: '"Sí" significa atacable; "No" significa no atacable',
  T_37_WZY_WS_SHADOWSTRENGTH: "Sombras",
  T_37_WZY_WS_SHOOTANGLE: "Ángulo de disparo más pequeño",
  T_37_WZY_WS_SKYBOX: "Cielo",
  T_37_WZY_WS_SKYBOXENT: "Entidad de cielo",
  T_37_WZY_WS_SKYBOXTYPE: "Tipos básicos de cielo",
  T_37_WZY_WS_STEPPED: "Pisa el gatillo",
  T_37_WZY_WS_SWCHAN_NAMEDESC: "Cambiar el canal de chat de voz del jugador",
  T_37_WZY_WS_SWCHAN_PARAM1_DESC: "El jugador a cambiar de canal",
  T_37_WZY_WS_SWCHAN_PARAM2_DESC: "El canal a cambiar",
  T_37_WZY_WS_SWITCHSCENE_NAMEDESC: "Cambiar a un escenario designado",
  T_37_WZY_WS_SWITCHSCENE_PARAM1_DESC: "El nombre del escenario por cambiar",
  T_37_WZY_WS_TARGETSTR_DESC: "Cadena de destino",
  T_37_WZY_WS_TEAMASIDE: "Equipo y Facción",
  T_37_WZY_WS_TELEPORTN_AUTO: "Automático",
  T_37_WZY_WS_TELEPORTN_AVAILABLE: "Teletransportátil o no",
  T_37_WZY_WS_TELEPORTN_MANUAL: "Manual",
  T_37_WZY_WS_TELEPORTN_NO: "No",
  T_37_WZY_WS_TELEPORTN_TITLE: "Método de teletransportación",
  T_37_WZY_WS_TELEPORTN_YES: "Sí",
  T_37_WZY_WS_TERRAINWET: "Humedad del terreno",
  T_37_WZY_WS_TRANSFORM_NAMEDESC: "Sustituye la apariencia de una [Entidad de jugador] por la apariencia de un [Objeto del escenario]",
  T_37_WZY_WS_TRANSFORM_PARAM1_DESC: "La entidad de jugador cuya apariencia cambiará",
  T_37_WZY_WS_TRANSFORM_PARAM2_DESC: "El jugador cuya entidad del disfraz se debe obtener",
  T_37_WZY_WS_TRANSP: "Transparencia",
  T_37_WZY_WS_UNLOADSCENE_NAMEDESC: "Desinstalar un escenario designado",
  T_37_WZY_WS_UNLOADSCENE_PARAM1_DESC: "El nombre del escenario a desinstalar",
  T_37_WZY_WS_VFX1: "Simbólico",
  T_37_WZY_WS_VFX2: "Ahumado",
  T_37_WZY_WS_VFX3: "Explosión de maldición",
  T_37_WZY_WS_VFX5: "Congelado",
  T_37_WZY_WS_VFX6: "Destacado",
  T_37_WZY_WS_VFX7: "Turbulencia ascendente",
  T_37_WZY_WS_VFX8: "Explosión de la atmósfera",
  T_37_WZY_WS_VISABLE: "Visibilidad",
  T_37_WZY_WS_WEAOPEN: "Mostrar o no",
  T_37_WZY_WS_WEAPONENT: "Entidad de arma",
  T_37_WZY_WS_WEATARGETED: "Si puede ser apuntado con la asistencia de puntería",
  T_37_XYL_CUSTOMJERSEY: "Máquina de Uniformes",
  T_37_XYL_CUSTOMJERSEY_DESC: "Usa la Máquina de Uniformes para crear tu uniforme ideal",
  T_37_XYL_FOOTGUN: "Tirador de Fútbol",
  T_37_XYL_SOCCER: "Fútbol",
  "T_37_XYL_SOCCER_ RADIUS": "Radio",
  T_37_XYL_SOCCER_DESC: "Un balón de fútbol cuyas propiedades se pueden personalizar",
  T_37_XYL_SOCCER_HIGHT1: "Ángulo regular",
  T_37_XYL_SOCCER_HIGHT2: "Ángulo de voleo",
  T_37_XYL_SOCCER_RESET: "Restablecer el tiempo después de un gol (s)",
  T_37_XYL_SOCCER_RESIST1: "Fricción (Modo Patada)",
  T_37_XYL_SOCCER_RESIST2: "Fricción (Modo Pistola)",
  T_37_XYL_SOCCERGOAL: "Gol",
  T_37_XYL_SOCCERGOAL_DESC: "Este es el gol. Tira el balón de fútbol a la portería para marcar. (Solo válido en Puntos)",
  T_37_XYL_SOCCERITEM: "Generación de objeto",
  T_37_XYL_SOCCERITEM_DESC: "Cuando se coloca, generará el objeto seleccionado",
  T_37_XYL_SPAWN_PEOPLE: "# de jugadores",
  T_37_XYL_WS_AIRCONDITIONER001: "Aire Acondicionado B",
  T_37_XYL_WS_AMMUCHEST: "Cofre de Guerra A",
  T_37_XYL_WS_BAFFLE001: "Barrera A",
  T_37_XYL_WS_BARREL001: "Barriles",
  T_37_XYL_WS_BARREL001_DES: "Barriles de madera circulares comúnmente vistos",
  T_37_XYL_WS_BOARD001: "Tablero de Anuncios B",
  T_37_XYL_WS_BOOK001: "Pila de Libros A",
  T_37_XYL_WS_BOOK002: "Juego de Mesa A",
  T_37_XYL_WS_BOUGAINVILLEA: "Buganvilia",
  T_37_XYL_WS_BOUGAINVILLEA_DES: "Decoración: ¡Ilumina el lugar!",
  T_37_XYL_WS_BOX001: "Pila de Cajas A",
  T_37_XYL_WS_BOX002: "Caja Pequeña",
  T_37_XYL_WS_BUSHCOVER: "Arbusto",
  T_37_XYL_WS_BUSHCOVER_DES: "Un arbusto que se puede usar para esconderse",
  T_37_XYL_WS_CABINET001: "Cajones A",
  T_37_XYL_WS_CHAIR001: "Silla A",
  T_37_XYL_WS_COCONUTTREE: "Palmera",
  T_37_XYL_WS_COCONUTTREE_DES: "Decoración - ¡Para un modo playero!",
  T_37_XYL_WS_COMPUTER001: "Computadora A",
  T_37_XYL_WS_DAMAGERATIO: "Ratio de Daño",
  T_37_XYL_WS_FIREEX: "Extintor de incendios",
  T_37_XYL_WS_GUIDEPOSE: "Puesto de dirección",
  T_37_XYL_WS_HUGEHOUSE001: "Casa de 3 Pisos",
  T_37_XYL_WS_HUGEHOUSE002: "Casa de 2 Pisos",
  T_37_XYL_WS_JACKSTRAW: "Espantapájaros",
  T_37_XYL_WS_LADDER001: "Escaleras A",
  T_37_XYL_WS_OILDRUM: "Recipiente",
  T_37_XYL_WS_ORNAMENT001: "Jarrón A",
  T_37_XYL_WS_PACKBOX: "Contenedor de suministro",
  T_37_XYL_WS_PILLA001: "Pilar de concreto",
  T_37_XYL_WS_PRESENT: "Caja Regalo",
  T_37_XYL_WS_PRESENT_DES: "Contiene regalos de temporada",
  T_37_XYL_WS_PUMPKIN: "Cuadro Calabaza de Halloween",
  T_37_XYL_WS_PUMPKINCUT: "Calabaza de Halloween",
  T_37_XYL_WS_PUMPKINCUT_DES: "Una decoración común para un festival espeluznante",
  T_37_XYL_WS_ROADBLOCK001: "Barricada B",
  T_37_XYL_WS_SHELF001: "Estantería A",
  T_37_XYL_WS_SOFA001: "Sofá A",
  T_37_XYL_WS_SPAWNTEAM: "Todos los equipos",
  T_37_XYL_WS_SUPPLYBOX: "Caja de Munición",
  T_37_XYL_WS_TABLE001: "Tabla A",
  T_37_XYL_WS_TABLE002: "Tabla B",
  T_37_XYL_WS_TARGET001: "Objetivo",
  T_37_XYL_WS_TEAMID_1: "1",
  T_37_XYL_WS_TEAMID_10: "10",
  T_37_XYL_WS_TEAMID_11: "11",
  T_37_XYL_WS_TEAMID_12: "12",
  T_37_XYL_WS_TEAMID_2: "2",
  T_37_XYL_WS_TEAMID_3: "3",
  T_37_XYL_WS_TEAMID_4: "4",
  T_37_XYL_WS_TEAMID_5: "5",
  T_37_XYL_WS_TEAMID_6: "6",
  T_37_XYL_WS_TEAMID_7: "7",
  T_37_XYL_WS_TEAMID_8: "8",
  T_37_XYL_WS_TEAMID_9: "9",
  T_37_XYL_WS_TELEPORTEND: "Punto final del portal",
  T_37_XYL_WS_TELEPORTNEW: "Portal A",
  T_37_XYL_WS_TELEPORTNEW_DESC: "Un portal que puede teletransportar al jugador al punto final del portal.",
  T_37_XYL_WS_TIRES001: "Llanta A",
  T_37_XYL_WS_TOOLRACK: "Estante de herramientas",
  T_37_XYL_WS_WALL001: "Pared",
  T_37_XYL_WS_WOOD001: "Madera picada",
  T_37_XYL_WS_YELLOWDUCK001: "Flotador patito",
  T_37_XYL_WS_YELLOWDUCK001_DES: "Un salvavidas en forma de pato",
  T_37_YM_BOMBSQUAD_DEFUSER: "Desactivador",
  T_37_YS_B_BRFOOTBALL_WHITE: "Uniforme Blanco CBF (Inferior)",
  T_37_YS_F_B_VN_STREET: "Auspicio Carmesí (Inferior)",
  T_37_YS_F_H_VN_STREET: "Auspicio Carmesí (Cabeza)",
  T_37_YS_F_S_VN_STREET: "Auspicio Carmesí (Zapatos)",
  T_37_YS_F_T_VN_STREET: "Auspicio Carmesí (Superior)",
  T_37_YS_M_A_CRICKET_BLACK: "Críquet Insigne (Máscara)",
  T_37_YS_M_A_THKOL: "Influencia del Fuego (Máscara)",
  T_37_YS_M_B_CRICKET_BLACK: "Críquet Insigne (Inferior)",
  T_37_YS_M_B_SILVERERA: "Guardián León Blanco (Inferior)",
  T_37_YS_M_B_THKOL: "Influencia del Fuego (Inferior)",
  T_37_YS_M_H_SILVERERA: "Guardián León Blanco (Cabeza)",
  T_37_YS_M_H_THKOL: "Influencia del Fuego (Cabeza)",
  T_37_YS_M_S_CRICKET_BLACK: "Críquet Insigne (Zapatos)",
  T_37_YS_M_S_SILVERERA: "Guardián León Blanco (Zapatos)",
  T_37_YS_M_S_THKOL: "Influencia del Fuego (Zapatos)",
  T_37_YS_M_T_CRICKET_BLACK: "Críquet Insigne (Superior)",
  T_37_YS_M_T_SILVERERA: "Guardián León Blanco (Superior)",
  T_37_YS_M_T_THKOL: "Influencia del Fuego (Superior)",
  T_37_YS_T_BRFOOTBALL_WHITE: "Uniforme Blanco CBF (Superior)",
  T_37_ZF_ROOM_UGC_MINPLAYER: "Mínimo de jugadores",
  T_38_BQ_SKILL_NAME_DUMMY1: "Doble de acción",
  T_38_BQ_SKILL_NAME_DUMMY2: "División de Formas",
  T_38_CJ_F_B_STREAMER_MUSIC: "Streamer de Corazón (Inferior)",
  T_38_CJ_F_H_STREAMER_MUSIC: "Streamer de Corazón (Cabeza)",
  T_38_CJ_F_S_STREAMER_MUSIC: "Streamer de Corazón (Zapatos)",
  T_38_CJ_F_T_STREAMER_MUSIC: "Streamer de Corazón (Superior)",
  T_38_JH_WS_CM1: "Reglas claras",
  T_38_JH_WS_CM2: "Reglas no claras",
  T_38_JH_WS_CM3: "Salidas frecuentes",
  T_38_JL_M79_AMMO_N: "Munición M79",
  T_38_JMF_SKILLCHIP_NAME_SINGER: "Microchip de J.Biebs",
  T_38_M_WS_VECTOR2: "Vector 2D",
  T_38_R_TACTICS_N: "Preset",
  T_38_RW_NIW_NIWNAME: "Creador Gloo",
  T_38_SP_WS_LOG_EXCEED_LIMIT_CALLSTACKCOUNTMAX: "Demasiadas capas de bloques. Actual: {0}. Máx.: {1}.",
  T_38_SP_WS_LOG_EXCEED_LIMIT_CREATEITEMCOUNTMAXPERMATCHKEY: "El número de objetos que has creado ({0}) ha excedido el límite de ({1}).",
  T_38_SP_WS_LOG_EXCEED_LIMIT_DISPATCHEVENTMAXCOUNTPERFRAME: "El número de incidentes recibidos dentro del mismo marco ({0}) ha excedido el límite ({1}).",
  T_38_SP_WS_LOG_EXCEED_LIMIT_ENTITIESCREATEDPERFRAMEMAX: "Se ha alcanzado el límite de creación dinámica de entidades por fotograma ({0}); se ha rechazado {1} intento(s) de creación.",
  T_38_SP_WS_LOG_EXCEED_LIMIT_LISTINITLENGTHMAX: "La longitud de la lista inicializada ({0}) ha excedido el límite ({1}). Crea automáticamente una lista de capacidad máxima.",
  T_38_SP_WS_LOG_EXCEED_LIMIT_LOOPTIMESMAX: "El número de bucles ({0}) ha excedido el límite ({1}). Bucle interrumpido.",
  T_38_SP_WS_LOG_EXCEED_LIMIT_PERSCOPECOROUTINECONCURRENCYMAX: "El número de rutinas simultáneas ({0}) en el alcance ha excedido el límite ({1}).",
  T_38_SP_WS_LOG_LIST_APPEND_IS_NIL: "No se pudo agregar el elemento a la lista. La lista {0} está vacía.",
  T_38_SP_WS_LOG_VAR_ARITHMETIC_FAILED: "Tipos de valores no coincidentes al ejecutar la operación aritmética básica. El tipo de valor de la izquierda es {0} y el tipo de valor de la derecha es {1}.",
  T_38_SP_WS_LOG_VAR_REPEATED_DEF_IN_SCOPE: "Definición de variable temporal repetida. Nombre de la variable: {0}.",
  T_38_SP_WS_REVIEW_01: "Tóxico",
  T_38_SP_WS_REVIEW_02: "Vulgar",
  T_38_SP_WS_REVIEW_03: "Insultante",
  T_38_SP_WS_REVIEW_04: "Extremadamente Tóxico",
  T_38_SP_WS_REVIEW_05: "Amenazante",
  T_38_SP_WS_REVIEW_06: "Irrespetuoso",
  T_38_SP_WS_REVIEW_07: "Bajo revisión",
  T_38_SP_WS_REVIEW_08: "Nombre {0}, {1} no cumple con las reglas. {2}.",
  T_38_SP_WS_REVIEW_09: "Cadena",
  T_38_SP_WS_REVIEW_10: "Tienda",
  T_38_SP_WS_REVIEW_11: "Variable",
  T_38_SP_WS_REVIEW_12: "Función",
  T_38_SP_WS_REVIEW_13: "Objeto",
  T_38_SP_WS_REVIEW_14: "Ir a definición.",
  T_38_SP_WS_REVIEW_15: "Vaya a Administrar Objetos.",
  T_38_SP_WS_REVIEW_16: "Sin redirección.",
  T_38_SP_WS_REVIEW_17: "Nombre del mapa",
  T_38_SP_WS_REVIEW_18: "Descripción",
  T_38_SP_WS_REVIEW_19: "Imagen de portada",
  T_38_SP_WS_REVIEW_20: "El texto contiene palabras sensibles.",
  T_38_SP_WS_REVIEW_21: "Error al guardar. No es posible revisar.",
  T_38_SP_WS_REVIEW_22: "Revisión en enfriamiento.",
  T_38_SY_BASEBALLBAT_KITCHEN_N: "Bate- Caos y Sueño",
  T_38_SY_CHARACTER_DESIGNER_N: "Santino",
  T_38_SY_PET_CACTUS_N: "Kactus",
  T_38_SY_PETSKIN_CACTUS_BLACK_N: "Aspecto de Mascota: Kactus Fantasma",
  T_38_SY_PETSKIN_CACTUS_PINK_N: "Aspecto de Mascota: Kactus Neón",
  T_38_SY_PETSKIN_CACTUS_YELLOW_N: "Aspecto de Mascota: Kactus Verano de Ensueño",
  T_38_SY_PETSKIN_FLYINGCREATURE_ES_N: "Aspecto de Mascota: Dragoncito de Fiesta",
  T_38_SY_PETSKIN_RACCOON_MO_N: "Aspecto de Mascota: Rockie a la Moda",
  T_38_SY_SCAR_ELDERGODS_N: "SCAR- Kami de la Furia",
  T_38_SY_SICKLE_ES_N: "Hoz- Bang Fire",
  T_38_SY_VEHICLE_SUV_KITCHEN_N: "Camioneta Pickup- Comida Mochi",
  T_38_WT_WS_MUITLEVEL: "Multinivel",
  T_38_WT_WS_SKILLSET15: "Emoción de Batalla (A124)",
  T_38_WT_WS_SKILLSET16: "Sentidos de Choque (Homero)",
  T_38_WT_WS_SKILLSET17: "Rompehielos (Iris)",
  T_38_WT_WS_SKILLSET18: "Ataque Rebelde (Tatsuya)",
  T_38_WZY_WS_ACTIVEA: "Se puede usar en el escenario o no",
  T_38_WZY_WS_ACTIVEB: "Activar actualización lógica o no",
  T_38_WZY_WS_ACTIVEVALUE: "Estatus de actividad",
  T_38_WZY_WS_AIR: "Aire",
  T_38_WZY_WS_ALLOWMOVE: "Movible o no",
  T_38_WZY_WS_AMMOAMOUNT: "Cantidad de munición",
  T_38_WZY_WS_AMMONAME: "Entidad de munición",
  T_38_WZY_WS_ARMOR_DAMRED: "Multiplicador de reducción de daño",
  T_38_WZY_WS_ARMOR_DAMRED_EXP: "Multiplicador de reducción de daño de explosión",
  T_38_WZY_WS_ARMOR_DURABILITY: "Durabilidad actual",
  T_38_WZY_WS_ARMOR_DURABILITYMAX: "Durabilidad máxima",
  T_38_WZY_WS_ARMOR_ISDAMAGE: "Dañable o no",
  T_38_WZY_WS_ARMOR_ISDESTROY: "Destruible o no",
  T_38_WZY_WS_ARMOR_LEVEL: "Nivel",
  T_38_WZY_WS_ASSCONZOM: "Asistencia de eliminación de zombis",
  T_38_WZY_WS_BAGNAME: "Entidad de mochila",
  T_38_WZY_WS_BAGSPACEEX: "Espacio adicional en la mochila",
  T_38_WZY_WS_BRIDGING: "Componente de puente",
  T_38_WZY_WS_BUBBLE: "Burbuja",
  T_38_WZY_WS_CLEARBAG_NAMEDESC: "Limpia todos los objetos de la mochila de la [entidad de jugador]",
  T_38_WZY_WS_CLEARMAP_NAMEDESC: "Borrar los objetos no deseados que se encuentran alrededor del mapa, como botines, residuos lanzables y cajas de botín",
  T_38_WZY_WS_CLEARPRO: "Borrar factor de propiedad única",
  T_38_WZY_WS_CLONEOBJ_NAMEDESC: "Clona una entidad [objeto del escenario] en la ubicación de una [entidad de jugador] y devuelve la [entidad del disfraz]",
  T_38_WZY_WS_COMPONENT: "Componente",
  T_38_WZY_WS_COSTAMMO: "Consumir munición",
  T_38_WZY_WS_CRECREMA_NAMEDESC: "Crea una cámara y devuelve una [entidad de cámara], cuyas propiedades se pueden modificar a través de la configuración de propiedades.",
  T_38_WZY_WS_CYCLES: "Reproducciones",
  T_38_WZY_WS_CYLINDERJUD_NAMEDESC: "Verifica si una [entidad] está dentro del alcance de un polo circular. El [centro] es el centro del poste, el [radio] es el radio de la superficie circular, la [altura] es la altura del poste, los [ángulos de Euler] son los ángulos de la orientación 3D del poste.",
  T_38_WZY_WS_CYLINDERJUD_RES: "El resultado de la verificación del alcance del polo circular. Este es un valor booleano.",
  T_38_WZY_WS_DAMSUMZOM: "Daño a zombis",
  T_38_WZY_WS_DARKNESS: "Oscuridad",
  T_38_WZY_WS_DIFCOLOR: "Color de la superficie",
  T_38_WZY_WS_DIFTEXTURE: "Textura de superficie",
  T_38_WZY_WS_DRUMMUSIC: "Tipo de componente: tambores",
  T_38_WZY_WS_ENTITY_PLAYERDISDESC: "El jugador que fue desconectado",
  T_38_WZY_WS_ENTITY_PLAYERRECDESC: "El jugador que se está reconectando",
  T_38_WZY_WS_EUIANCHOR: "Enumeración del tipo de anclaje HUD",
  T_38_WZY_WS_FEATHER: "Pluma",
  T_38_WZY_WS_FLAMEAMMO: "Munición de lanzallamas",
  T_38_WZY_WS_FLOWER: "Flor",
  T_38_WZY_WS_FOLLOW_NAMEDESC: "Establece la [entidad] para que siga siempre a la [entidad seguida]. [Coordenadas compensadas] es la distancia entre las dos entidades.",
  T_38_WZY_WS_FOLLOWENT: "Entidad seguida",
  T_38_WZY_WS_GETCURCAM_NAMEDESC: "Obtiene la entidad de la cámara que está siendo utilizada actualmente por una [entidad de jugador]",
  T_38_WZY_WS_GETCURCAMDESC: "La cámara que está siendo utilizada actualmente por el jugador.",
  T_38_WZY_WS_GETITEMNUM_NAMEDESC: "Obtiene la cantidad de un objeto en el [tipo de objeto designado] que posee un [jugador]",
  T_38_WZY_WS_GETITEMNUM_RES: "La cantidad del objeto designado que posee el jugador.",
  T_38_WZY_WS_GETVEC_NAME: "Obtener vector",
  T_38_WZY_WS_GETVEC_NAMEDESC: "Obtiene un vector utilizando las componentes x, y y z de un conjunto de coordenadas",
  T_38_WZY_WS_GETVECRES: "El vector obtenido a partir de las componentes x, y y z",
  T_38_WZY_WS_GHOST: "Fantasma",
  T_38_WZY_WS_GRENADEFROZENNAME: "Entidad de destello de hielo",
  T_38_WZY_WS_GRENADEFROZENPARAM1: "Radio de la zona de congelación",
  T_38_WZY_WS_GRENADEFROZENPARAM2: "Duración de la congelación",
  T_38_WZY_WS_GRENADENAME: "Entidad de la granada",
  T_38_WZY_WS_GRENADEPARAM1: "Daño Mín.",
  T_38_WZY_WS_GRENADEPARAM2: "Daño Máx.",
  T_38_WZY_WS_GRENADEPARAM4: "Rango de explosión",
  T_38_WZY_WS_GRENADEPARAM5: "Velocidad de lanzamiento",
  T_38_WZY_WS_GRENADEPARAM6: "Retraso de explosión",
  T_38_WZY_WS_GRENADEPARAM7: "Multiplicador de daño propio",
  T_38_WZY_WS_GRENADEPARAM8: "Multiplicador de daño de aliado",
  T_38_WZY_WS_GRENADEPARAM9: "Multiplicador de daño del vehículo",
  T_38_WZY_WS_GUNFIRE: "Tiroteo",
  T_38_WZY_WS_GUNPRO_PARAM2: "Velocidad de recarga",
  T_38_WZY_WS_GUNPRO_PARAM3: "Daño con golpes al cuerpo",
  T_38_WZY_WS_GUNPRO_PARAM4: "Daño de disparos a la cabeza",
  T_38_WZY_WS_GUNPRO_PARAM5: "Daño de disparos a las extremidades",
  T_38_WZY_WS_GUNPRO_PARAM7: "Daño extra",
  T_38_WZY_WS_HELMET_NAME: "Entidad de casco",
  T_38_WZY_WS_ICON1: "Corona",
  T_38_WZY_WS_ICON2: "Duelo",
  T_38_WZY_WS_INITPOS: "Ubicación inicial",
  T_38_WZY_WS_ISRESET: "Movimiento recíproco",
  T_38_WZY_WS_KILLCONZOM: "Nº de zombis eliminados",
  T_38_WZY_WS_KILLENT_NAMEDESC: "Elimina la [entidad] elegida, que debe ser de tipo entidad de batalla. Ignora el estado invulnerable.",
  T_38_WZY_WS_LABELPARAM: "Lista de parámetros de contenido de texto",
  T_38_WZY_WS_LEADMUSICA: "Tipo de componente: piano (agudos)",
  T_38_WZY_WS_LEADMUSICB: "Tipo de componente: piano (alto)",
  T_38_WZY_WS_LEADMUSICC: "Tipo de componente: piano (bajo)",
  T_38_WZY_WS_LINE: "Línea",
  T_38_WZY_WS_LIQUID: "Líquido",
  T_38_WZY_WS_LOCALKEY: "Key localizada",
  T_38_WZY_WS_LOCALPOS: "Ubicación relativa",
  T_38_WZY_WS_LOOKAT_NAMEDESC: "Establece una [entidad] para que siempre mire a la [entidad apuntada]. [Coordenadas compensadas] es la diferencia en las coordenadas del punto objetivo y la posición de la entidad.",
  T_38_WZY_WS_MAINWEAPONA: "Arma Principal 1",
  T_38_WZY_WS_MAINWEAPONB: "Arma Principal 2",
  T_38_WZY_WS_MOTIONTIME: "Duración del movimiento",
  T_38_WZY_WS_MOTIONTYPE: "Método de movimiento",
  T_38_WZY_WS_MUSHROOM_EPMODIFY: "PE modificado",
  T_38_WZY_WS_MUSHROOMNAME: "Entidad de hongo",
  T_38_WZY_WS_OBFACTION: "Facción de espectadores",
  T_38_WZY_WS_OBGLOBAL: "Espectar todo",
  T_38_WZY_WS_OBSERVER: "Opciones de espectador",
  T_38_WZY_WS_OBTEAM: "Equipo espectador",
  T_38_WZY_WS_OFFSETVEC: "Coordenadas compensadas",
  T_38_WZY_WS_ONBUY_NAMEDESC: "Se activa cuando un jugador compra objetos de esta máquina expendedora. [Entidad de jugador] es el jugador que realiza la compra. [Entidad de mercancía] es el objeto comprado.",
  T_38_WZY_WS_ONEQUIPED_NAMEDESC: "Se activa cuando está equipado por una [entidad de jugador]",
  T_38_WZY_WS_ONJUMP_NAMEDESC: "Se activa cuando el jugador completa la acción de saltar",
  T_38_WZY_WS_ONLIE_NAMEDESC: "Se activa cuando el jugador completa la posición boca abajo",
  T_38_WZY_WS_ONRELOAD_NAMEDESC: "Se activa cuando el arma se recarga",
  T_38_WZY_WS_ONSPRINT_NAMEDESC: "Se activa cuando el jugador completa la acción de correr",
  T_38_WZY_WS_ONSQUAT_NAMEDESC: "Se activa cuando el jugador completa la acción de agacharse",
  T_38_WZY_WS_ONWAEPKILL_NAMEDESC: "Se activa cuando el arma elimina una unidad. [Entidad eliminada] es la unidad que fue eliminada.",
  T_38_WZY_WS_ONWEAPDAMAGE_NAMEDESC: "Se activa cuando el arma inflige daño a una entidad de batalla. [Objetivo golpeado] es la entidad de batalla a la que se infligió el daño. [Daño] es el daño que se inflige.",
  T_38_WZY_WS_OWNER: "Dueño",
  T_38_WZY_WS_PARAMLIST: "Lista de parámetros",
  T_38_WZY_WS_PARTICALMAP: "Mapeo de Partículas",
  T_38_WZY_WS_PAUSEMOTE_NAMEDESC: 'Pausa o reanuda el emote actual para una [entidad de jugador]. [Pausa o no] es un valor booleano. "Sí" significa pausa. "No" significa reanudar.',
  T_38_WZY_WS_PLAENTTRI_DESC: "Activado por el jugador que ingresa el disparador",
  T_38_WZY_WS_PLAQUITTRI_DESC: "Activado por el jugador que deja el disparador",
  T_38_WZY_WS_PLAYEMOTE_NAMEDESC: "Forzar a la [entidad de jugador] a reproducir el [emote] designado una vez y volver a la posición original cuando termine",
  T_38_WZY_WS_PLAYSPEED: "Porcentaje de velocidad de reproducción",
  T_38_WZY_WS_PREHUD_NAME: "Icono preestablecido",
  T_38_WZY_WS_QUITFACTION_NAMEDESC: "Permitir que la [entidad de jugador] deje su facción actual",
  T_38_WZY_WS_RESETENT: "Restablecer componentes cada ronda",
  T_38_WZY_WS_RESUUID: "Recurso UUID",
  T_38_WZY_WS_RIMCOLOR: "Color del borde",
  T_38_WZY_WS_RIMTEXTURE: "Textura de borde",
  T_38_WZY_WS_SECTORJUD_NAMEDESC: "Verifica si una [entidad] está dentro de un cono. El [centro] y el [radio] son el centro y el radio del cono. El [radio extraído] es el radio del sector más pequeño dentro del cono. La altura es la altura de la estructura 3D. El [ángulo] es el ángulo central del cono. El [ángulo de dirección] es el vector de dirección del eje central.",
  T_38_WZY_WS_SECTORJUD_RES: "El resultado de la verificación del alcance en forma de abanico. Este es un valor booleano.",
  T_38_WZY_WS_SETACTIVE_NAMEDESC: "Establece el estado de actividad de una [entidad de destino]. [Estado de la actividad] es un valor booleano y afecta la disponibilidad, la visibilidad y la capacidad de colisión de la entidad.",
  T_38_WZY_WS_SETROUNDSCORE: "Establece la puntuación de la ronda del jugador",
  T_38_WZY_WS_SHOOTANGMAX: "Ángulo máximo de disparo",
  T_38_WZY_WS_SHOWMAPINFO: "Mostrar información del mapa para la misma facción",
  T_38_WZY_WS_SHOWNAMEHUD: "Mostrar nombre HUD para la misma facción",
  T_38_WZY_WS_SOUND1: "Aceleración",
  T_38_WZY_WS_SOUND10: "Etapa de inicio",
  T_38_WZY_WS_SOUND11: "Zombis",
  T_38_WZY_WS_SOUND12: "Horror",
  T_38_WZY_WS_SOUND13: "Transformación",
  T_38_WZY_WS_SOUND14: "Corazón Palpitante",
  T_38_WZY_WS_SOUND15: "Latido Medio",
  T_38_WZY_WS_SOUND16: "Latido del corazón lento",
  T_38_WZY_WS_SOUND17: "Último Momento",
  T_38_WZY_WS_SOUND18: "Clic",
  T_38_WZY_WS_SOUND19: "Recuperación de habilidad",
  T_38_WZY_WS_SOUND2: "Notificación de desaparición",
  T_38_WZY_WS_SOUND20: "Únete a un juego",
  T_38_WZY_WS_SOUND3: "Efectos visuales",
  T_38_WZY_WS_SOUND4: "Sonido nocturno",
  T_38_WZY_WS_SOUND5: "Golpe (Contundente)",
  T_38_WZY_WS_SOUND6: "Reacción",
  T_38_WZY_WS_SOUND7: "Hallazgo sorpresa",
  T_38_WZY_WS_SOUND8: "Aparición",
  T_38_WZY_WS_SOUNDENT: "Entidad musical",
  T_38_WZY_WS_SPAWNPOS: "Punto de inicio anterior",
  T_38_WZY_WS_SPHERENAME: "Esfera básica",
  T_38_WZY_WS_SPHERERADIUS: "Radio de la esfera",
  T_38_WZY_WS_SPHERICALJUD_NAMEDESC: "Verifica si una [entidad] está dentro de un alcance esférico. El [centro] y el [radio] es el centro y el radio de la estructura esférica.",
  T_38_WZY_WS_SPHERICALJUD_RES: "El resultado de la verificación del alcance esférico. Este es un valor booleano.",
  T_38_WZY_WS_SQUAREJUD_NAMEDESC: "Verifica si una [entidad] está dentro del alcance de un cubo. El [centro] es el centro del cubo, el [largo], el [ancho] y el [alto] son el largo, ancho y alto del cubo, y los [ángulos de Euler] son los ángulos de la orientación 3D del cubo.",
  T_38_WZY_WS_SQUAREJUD_RES: "El resultado de la verificación del alcance cúbico. Este es un valor booleano.",
  T_38_WZY_WS_STARTGENTIME: "Hora de inicio de generación",
  T_38_WZY_WS_STAYTIME: "Duración de la pausa",
  T_38_WZY_WS_SWITCHCAM_NAMEDESC: "Cambia la cámara de un jugador a la [entidad de la cámara]. [Modo de cambio] puede ser sin animación o movimiento progresivo. [Tiempo de cambio] es el tiempo de cambio durante el modo progresivo.",
  T_38_WZY_WS_SWITCHCAM_PARAM3_DESC: "Cambia el modo de la cámara. Puedes seleccionar entre sin animación y movimiento progresivo.",
  T_38_WZY_WS_SWITCHCAM_PARAM4_DESC: 'El tiempo de cambio durante el modo de movimiento progresivo. Cuando se selecciona "sin animación", esta configuración es nula.',
  T_38_WZY_WS_TEXTHUD: "Componente de texto HUD",
  T_38_WZY_WS_TEXTTYPE: "Tamaño de fuente",
  T_38_WZY_WS_TEXTUREID: "Tipo de textura",
  T_38_WZY_WS_TRANDIST: "Distancia máx.",
  T_38_WZY_WS_TWEENERENABLED: "Activar o no el script UITweener",
  T_38_WZY_WS_TYPELIST: "Lista de tipos",
  T_38_WZY_WS_TYPELISTORLIST: "Tipo o lista de tipos",
  T_38_WZY_WS_VEST_NAME: "Entidad del chaleco",
  T_38_WZY_WS_VFX1: "Eliminación oculta",
  T_38_WZY_WS_VFX10: "Combustión cíclica",
  T_38_WZY_WS_VFX11: "Gas venenoso",
  T_38_WZY_WS_VFX13: "Corazón",
  T_38_WZY_WS_VFX15: "Puerta",
  T_38_WZY_WS_VFX2: "Revolución",
  T_38_WZY_WS_VFX3: "Eliminación de clones",
  T_38_WZY_WS_VFX4: "Visualización de daño",
  T_38_WZY_WS_VFX5: "Clon",
  T_38_WZY_WS_VFX6: "Disfraz",
  T_38_WZY_WS_VFX7: "Chispas de Granada Cegadora",
  T_38_WZY_WS_VFX8: "Rastro de movimiento",
  T_38_WZY_WS_VFX9: "Carga de fuego",
  T_38_WZY_WS_VFXENT: "Instancia de efectos visuales",
  T_38_WZY_WS_VFXTYPEA_NAME: "Mapeo personalizable de efectos visuales",
  T_38_WZY_WS_VFXTYPEB_NAME: "Mapeo no personalizable de efectos visuales",
  T_38_WZY_WS_VISIBILITY: "Tipo de visibilidad",
  T_38_WZY_WS_VOLUME: "Volumen",
  T_38_WZY_WS_WEAPONGEN: "Generador de armas",
  T_38_WZY_WS_WHECYCLE: "Repetir",
  T_38_XXJ_WS_BLOCKMODE: "Modo bloqueado",
  T_38_XXJ_WS_CUSTOMCAMARA: "Cámara personalizada",
  T_38_XXJ_WS_FFCLASSIC: "FF Clásico (Disparos)",
  T_38_XXJ_WS_FOV: "Campo de visión",
  T_38_XXJ_WS_FOVDESC: "El campo de visión es el rango observable de la cámara.",
  T_38_XXJ_WS_FPS: "Primera Persona (Disparos)",
  T_38_XXJ_WS_HORIZONTALANGLE: "Ángulo Horizontal",
  T_38_XXJ_WS_INVISICAM: "Semitransparente",
  T_38_XXJ_WS_OFFSET: "Compensación",
  T_38_XXJ_WS_ORTHOGRAPHIC: "Ortográfico",
  T_38_XXJ_WS_PERSPECTIVE: "Perspectiva",
  T_38_XXJ_WS_PROJECTIONMODE: "Modo Proyección",
  T_38_XXJ_WS_STABLE: "Fijada",
  T_38_XXJ_WS_STARTCAMERA: "Cámara predeterminada",
  T_38_XXJ_WS_STARTCAMERAMODE: "Modo de cámara predeterminado",
  T_38_XXJ_WS_THIRD: "Cámara de persecución",
  T_38_XXJ_WS_TOPVIEW: "Ángulo Alto",
  T_38_XXJ_WS_TPS: "Tercera Persona",
  T_38_XXJ_WS_TRANSVERSE: "Movimiento Horizontal",
  T_38_XXJ_WS_VERTICALANGLE: "Ángulo Vertical",
  T_38_XXJ_WS_ZOOM: "Zoom",
  T_38_XYL_WS_AISTARTTIME: "Hora de inicio (s)",
  T_38_XYL_WS_ARMORDESTROY: "Multiplicador de daño de armadura",
  T_38_XYL_WS_BONFIRE: "Fogata",
  T_38_XYL_WS_CANDLE01: "Vela A",
  T_38_XYL_WS_CANNON01: "Cañón Mecánico",
  T_38_XYL_WS_CLIPAMMOSIZE: "Almacenamiento",
  T_38_XYL_WS_DAMAGEDTRUCK: "Camión Dañado",
  T_38_XYL_WS_DOLL01: "Muñeca Espeluznante",
  T_38_XYL_WS_ENTERANCEHOUSE01: "Casa de Ladrillo A",
  T_38_XYL_WS_FENCE002: "Valla de Hierro B",
  T_38_XYL_WS_FIREWORK01: "Fuegos Artificiales A",
  T_38_XYL_WS_GENERATOR: "Generador",
  T_38_XYL_WS_GRAVITY: "Aceleración Gravitacional",
  T_38_XYL_WS_GRAVITYAREA: "Zona de Gravedad Anormal",
  T_38_XYL_WS_GRAVITYAREA_DESC: "Una zona donde los jugadores pueden cambiar la gravedad.",
  T_38_XYL_WS_HOLDWEAPON: "Sostener arma",
  T_38_XYL_WS_INDOORFURNITURE: "Muebles de Interior",
  T_38_XYL_WS_LIGHTTUBE001: "Tubo de Luz A",
  T_38_XYL_WS_LOVEBALLOON01: "Globo de San Valentín A",
  T_38_XYL_WS_LOVELAMP01: "Lámpara de Corazón",
  T_38_XYL_WS_LOVESIGN01: "Luces de Neón Love",
  T_38_XYL_WS_OILDRUM_DAMAGE: "Daño del Barril de Aceite",
  T_38_XYL_WS_OUTDOORPROPS: "Objetos Exteriores",
  T_38_XYL_WS_PIPEANDBOX: "Tuberías y Contenedores",
  T_38_XYL_WS_PLANT: "Plantas",
  T_38_XYL_WS_ROSE01: "Rosa",
  T_38_XYL_WS_ROSEN: "Buqué de Rosas",
  T_38_XYL_WS_SMALLBUILDING: "Edificios Pequeños",
  T_38_XYL_WS_SOFA002: "Sofá B",
  T_38_XYL_WS_TOWNHOUSE01: "Casa Antigua de 2 Pisos",
  T_38_XYL_WS_TV001: "TV Antigua",
  T_38_ZP_CC_EXCHANGESTATUS: "Estatus",
  T_39_BQ_SKILL_NAME_VILLAIN: "Golpe Carmesí",
  T_39_CJ_A_BURN: "Victoria Dorada",
  T_39_HJ_WS_Arrow002: "Flecha 2",
  T_39_HJ_WS_LIKERATE2: "{0} min",
  T_39_HJ_WS_LIKERATE3: "{0} - {1} min",
  T_39_HJ_WS_SOUND10: "Paso",
  T_39_HJ_WS_SOUND11: "Misión Cumplida 1",
  T_39_HJ_WS_SOUND13: "Alerta de Peligro 1",
  T_39_HJ_WS_SOUND14: "Alerta de Peligro 2",
  T_39_HJ_WS_SOUND15: "Cuenta Regresiva 3",
  T_39_HJ_WS_SOUND16: "Consejos de Sonido",
  T_39_HJ_WS_SOUND17: "Graznido de Cuervo",
  T_39_HJ_WS_SOUND18: "Sonido de teletransportación a un área equivocada",
  T_39_HJ_WS_SOUND19: "Sonido de teletransportación a un área correcta",
  T_39_HJ_WS_SOUND2: "Cuenta Regresiva 1",
  T_39_HJ_WS_SOUND20: "Teletransportación",
  T_39_HJ_WS_SOUND21: "Descarga Eléctrica",
  T_39_HJ_WS_SOUND23: "Obtener objeto",
  T_39_HJ_WS_SOUND24: "Electrónica y Bonita BMG",
  T_39_HJ_WS_SOUND25: "Juego Casual BGM",
  T_39_HJ_WS_SOUND4: "Eco Dispositivo Mecánico",
  T_39_HJ_WS_SOUND5: "Mosquito",
  T_39_HJ_WS_SOUND6: "Ding Ding Ding 1",
  T_39_HJ_WS_SOUND7: "Ding Ding Ding 2",
  T_39_HJ_WS_SOUND8: "Equipo Conectado",
  T_39_HJ_WS_SOUND9: "Carga 1",
  T_39_HJ_WS_UNLIMITEDGLOOWALL: "Paredes gloo ilimitadas",
  T_39_HJ_WS_UNLIMITEDTHROWABLES: "Lanzables ilimitados",
  T_39_HQ_EVOGUN2_SOUNDEQUIP3: "Sonido de Disparo Especial",
  T_39_HQ_UGC_CUSTOMRES: "Recursos personalizados",
  T_39_M_ACCOUNTID: "Cuenta",
  T_39_M_WS_BUTTON_DOUBLECLICKDESC: "Ejecutar con doble clic",
  T_39_MF_SKILLTAG_4: "Movimiento",
  T_39_PD_HuntingGroundSnow_MYNAME: "Sr. V",
  T_39_QL_SKILL_OTHO_DES: "Después de derribar a un enemigo, marca dentro de [FFB300]{0}m[-] a los compañeros del enemigo derribado y reduce en [FFB300]{1}%[-] su velocidad de movimiento. Dura [FFB300]{2}s[-]. Cuando lo derriba un enemigo cercano, marca y ralentiza al atacante y a sus compañeros.",
  T_39_QL_SKILL_WOLFRAHH_DES: "Después de derribar a un enemigo, entra en el modo Destacado, que aumenta [FFB300]{0}%[-] la velocidad de disparo y [FFB300]{1}%[-] la velocidad de movimiento, pero luego decae rápidamente. Duración: [FFB300]{2}s[-]. Durante el modo Destacado, derribar enemigos consecutivamente reiniciará la cuenta regresiva y aumentará [FFB300]{3}%[-] más la velocidad de disparo y [FFB300]{4}%[-] la velocidad de movimiento.",
  T_39_QL_SKILL_XAYNE_DES1: "Modo Extremo: Obtén [FFB300]{0} PV temporales[-] durante [FFB300]{1}s[-]. Durante este tiempo, los efectos de curación de PV aumentan [FFB300]{2}%[-]. Enfriamiento: [FFB300]{3}s[-].",
  T_39_RW_GM_DEFEAT: "Error",
  T_39_RW_SKILL_DESC_FORD: "Cuando recibes daño, ganas [FFB300]{1} PV/s[-] durante [FFB300]{0}s[-]. Después de liberar una habilidad activa, esta habilidad pasiva se restablecerá inmediatamente. Enfriamiento: [FFB300]{2}s[-].",
  T_39_SP_WS_ITEMENTITY_01: "Entidad de objeto",
  T_39_SY_CHARACTER_ALVARO_AWAKENING_N: 'Alvaro "El Explosivo"',
  T_39_SY_CHARACTER_VILLAIN_N: "Orión",
  T_39_SY_KATANA_FASTBREAKING23_N: "Katana- 1001 Noches",
  "T_39_SY_PETSKIN_FLYINGCREATURE_FB23 _N": "Aspecto de Mascota: Dragoncito Esmeralda",
  "T_39_SY_PETSKIN_TIGER_BDFEST _N": "Aspecto de Mascota: Tigri Sensei Royal",
  "T_39_SY_PETSKIN_WOLF_SCARLET _N": "Aspecto de Mascota: Colmillo Escorpión",
  T_39_SY_VEHICLESKIN_MONSTER_TRUCK_FASTBREAKING23_N: "Camioneta Monster- Gigante Verde",
  T_39_SY_VEHICLESKIN_TUTU_BDFEST_N: "Tuk Tuk - Carroza Floral",
  T_39_WH_SKILL_DESC_GRENADESPLIT: "Habilidad Renacida: [FFB300]{0}s[-] antes de detonar, la granada produce [FFB300]{1} [-] granadas extras, que pueden causar [FFB300]{2}%[-] de daño de la original.",
  T_39_WH_SKILL_NAME_GRENADESPLIT: "Bombardeo Dividido",
  T_39_WT_WS_EMPTYMAP_TAG: "Espacio vacío",
  T_39_WT_WS_FEMAPMODE: "Título del modo",
  T_39_WT_WS_FEMAPTAG: "Etiqueta del mapa",
  T_39_WT_WS_MAPPLAYER: "Número de jugadores",
  T_39_WT_WS_MEDENTERNUM: "Límite de jugadores que se unen a media partida",
  T_39_WT_WS_MIDENTER: "Unirse a mitad de partida",
  T_39_WT_WS_MIDENTERCOUNT: "Cuota de unión a media partida",
  T_39_WT_WS_MIDENTERTIME1: "Límite de tiempo para unirse a media partida",
  T_39_WT_WS_MIDENTERTIME2: "Duración de la unión a mitad de la partida",
  T_39_WT_WS_MIDENTERTIMETIP: "Cuando no se alcanza el límite de jugadores del mapa, permite a los jugadores unirse en los primeros N segundos de la partida. Los jugadores no pueden unirse después del seg N.",
  T_39_WT_WS_MIDENTERTIP: "Cuando está activado, los jugadores pueden unirse a este mapa a media partida",
  T_39_WT_WS_PLAYERCOUNT: "Número inicial de jugadores",
  T_39_WT_WS_PLAYERCOUNTTIP: "El número de jugadores cuando empieza la partida. Se pueden unir más jugadores a media partida hasta alcanzar el límite del mapa.",
  T_39_WT_WS_TAG1: "Todos contra todos",
  T_39_WT_WS_TAG10: "Fácil",
  T_39_WT_WS_TAG11: "Medio",
  T_39_WT_WS_TAG12: "Difícil",
  T_39_WT_WS_TAG13: "Muy difícil",
  T_39_WT_WS_TAG14: "Escape",
  T_39_WT_WS_TAG16: "VIP",
  T_39_WT_WS_TAG17: "Recursos personalizados",
  T_39_WT_WS_TAG18: "Rompecabezas",
  T_39_WT_WS_TAG19: "Carreras",
  T_39_WT_WS_TAG2: "Pelea de Armas",
  T_39_WT_WS_TAG20: "Musical",
  T_39_WT_WS_TAG21: "MOBA",
  T_39_WT_WS_TAG22: "Aventura",
  T_39_WT_WS_TAG23: "Caza de Zombis",
  T_39_WT_WS_TAG24: "PvP",
  T_39_WT_WS_TAG25: "Juego de Fiesta",
  T_39_WT_WS_TAG26: "Combate a Muerte",
  T_39_WT_WS_TAG27: "Defensa de torreta",
  T_39_WT_WS_TAG28: "Entrenamiento",
  T_39_WT_WS_TAG3: "Rey de las Armas",
  T_39_WT_WS_TAG4: "Reaparición",
  T_39_WT_WS_TAG5: "Francotirador",
  T_39_WT_WS_TAG6: "Sobrevivencia",
  T_39_WT_WS_TAG7: "Solo",
  T_39_WT_WS_TAG8: "Terror",
  T_39_WT_WS_TAG9: "Casual",
  T_39_WT_WS_TAGMAXTIP: "Selecciona hasta {0} etiquetas",
  T_39_WT_WS_TAGTYPE1: "Tipo de jugabilidad",
  T_39_WT_WS_TAGTYPE2: "Tipo de mapa",
  T_39_WT_WS_TAGTYPE3: "Tipo de modo",
  T_39_WT_WS_TAGTYPE4: "Tamaño del equipo",
  T_39_WZY_WS_ACCSPEED: "Aceleración",
  T_39_WZY_WS_ADDSCRIPT_NAMEDESC: "Añadir script [Nombre del script] para [Entidad]",
  T_39_WZY_WS_ASC: "Ascendente",
  T_39_WZY_WS_ASCIGZERO: "Ignorar cero usando Ascendente",
  T_39_WZY_WS_BALLISTMOVENT: "Entidad de movimiento balístico",
  T_39_WZY_WS_BEUSED_NAMEDESC: "Se activa un incidente cuando el objeto es usado por una [entidad de jugador].",
  T_39_WZY_WS_BODYSCALE: "Escala de cuerpos",
  T_39_WZY_WS_BRAKETORQUE: "Potencia de frenado",
  T_39_WZY_WS_CAMTRANTYPE: "Tipo de transición de cámara",
  T_39_WZY_WS_CARVEHICLE: "4 ruedas",
  T_39_WZY_WS_CHECKSCRIPT_NAMEDESC: "Comprueba si un script especificado [Nombre del script] existe en [Entidad]. (El valor devuelto debe ser Booleano)",
  T_39_WZY_WS_CHECKSCRIPT_RES: "Comprueba si la entidad tiene un resultado del script especificado (Booleano)",
  T_39_WZY_WS_COMBINEALL: "Doble empuñadura (Diferentes armas)",
  T_39_WZY_WS_COMBINESELF: "Doble empuñadura (Misma arma)",
  T_39_WZY_WS_CONENAME: "Cono básico",
  T_39_WZY_WS_COORSYS: "Sistema de coordenadas",
  T_39_WZY_WS_CRASHMAXD: "Daño máximo por impacto",
  T_39_WZY_WS_CRASHMIND: "Daño mínimo por impacto",
  T_39_WZY_WS_CRAWLSPEED: "Porcentaje de velocidad de movimiento (Boca abajo)",
  T_39_WZY_WS_CREBALLISTMOV_NAMEDESC: "Crea un Movimiento Balístico para la [entidad objetivo]. Puede editar [velocidad inicial], [aceleración], y [distancia máxima] acumulada en la dirección de la velocidad inicial para la entidad objetivo, y devolver [entidad de movimiento balístico].",
  T_39_WZY_WS_CRETWEEN_NAME: "Crear movimiento de interpolación",
  T_39_WZY_WS_CRETWEEN_NAMEDESC: "Crea un Movimiento de Interpolación para [entidad], con [atributos] de la entidad moviéndose suavemente desde el [valor inicial] hasta [valor objetivo] dentro del [tiempo]. [Método] representa la forma de movimiento, incluyendo [Unidireccional], [PingPong], [Ciclo]. [Curva] es la curva de movimiento. Y la [entidad de movimiento de interpolación] será devuelta después de crear el movimiento.",
  T_39_WZY_WS_CURVE: "Curva",
  T_39_WZY_WS_CUSTRESULT: "Resultado de partida personalizada",
  T_39_WZY_WS_CYLINDERNAME: "Cilindro básico",
  T_39_WZY_WS_DEFAULT: "Sin animación (Predeterminado)",
  T_39_WZY_WS_DESC: "Descendente",
  T_39_WZY_WS_DIFFUSEALPHA: "Transparencia de la superficie",
  T_39_WZY_WS_DISCONNECT: "Desconexión",
  T_39_WZY_WS_DOUBLEJUMPSHOE_ENERGYRECOVERY: "Energía recuperada por segundo",
  T_39_WZY_WS_DOUBLEJUMPSHOE_JUMCONSUME: "Consumir energía",
  T_39_WZY_WS_DOUBLEJUMPSHOE_MAXJUMPH: "Altura máxima del segundo salto",
  T_39_WZY_WS_ENABLEJOIN: "Permitir unirse a mitad de camino",
  T_39_WZY_WS_ENDPOS: "Coordenadas del punto final",
  T_39_WZY_WS_ENGINETORQUE: "Potencia del motor",
  T_39_WZY_WS_EXPLODED: "Daño por explosión",
  T_39_WZY_WS_FEELDSPEED: "Porcentaje de velocidad de movimiento (Derribado)",
  T_39_WZY_WS_FLASH_CFLASHTIME: "Tiempo de flash central",
  T_39_WZY_WS_FLASH_CRANGE: "Alcance central",
  T_39_WZY_WS_FLASH_EFLASHTIME: "Tiempo de destello del filo",
  T_39_WZY_WS_FLASH_HITEFFECTSWITCH: "Efecto de golpe de la bomba flash",
  T_39_WZY_WS_FLASH_RANGE: "Alcance de la explosión",
  T_39_WZY_WS_FOLDWINGS_FALLSPEED: "Reduciendo velocidad",
  T_39_WZY_WS_FOLDWINGS_FLYMAXH: "Altitud máxima",
  T_39_WZY_WS_FOLDWINGS_FLYSPEEDH: "Velocidad de planeo horizontal",
  T_39_WZY_WS_FOLDWINGS_FLYSPEEDV: "Velocidad de planeo vertical",
  T_39_WZY_WS_FOLDWINGS_MINENDH: "Altura final mínima",
  T_39_WZY_WS_FOLDWINGS_MINFLYH: "Altura mínima de despegue",
  T_39_WZY_WS_FOLDWINGS_OVERHFALLSPEED: "Velocidad de descenso después de alta velocidad",
  T_39_WZY_WS_FOLDWINGS_TURNSPEED: "Velocidad de giro",
  T_39_WZY_WS_FOLMOVENT: "Entidad de movimiento de seguimiento de posición",
  T_39_WZY_WS_GETSKILLLIST_NAMEDESC: "Obtener lista de habilidades de [entidad de jugador]",
  T_39_WZY_WS_HB_BOOSTCD: "Enfriamiento al correr",
  T_39_WZY_WS_HB_BOOSTDURATION: "Duración al correr",
  T_39_WZY_WS_HB_BOOSTINITIAL: "Enfriamiento al correr en tabla",
  T_39_WZY_WS_HB_BOOSTINITIALSWITCH: "Enfriamiento al correr en tabla",
  T_39_WZY_WS_HB_BOOSTSPEED: "Velocidad al correr",
  T_39_WZY_WS_HB_HOVERBCD: "Enfriamiento de tabla",
  T_39_WZY_WS_HB_JUMPCD: "Enfriamiento de salto",
  T_39_WZY_WS_HB_JUMPH: "Altura de salto con tabla",
  T_39_WZY_WS_HEADSCALE: "Escala de cabezas",
  T_39_WZY_WS_HEADSHOTDESCALE: "Reducción del daño por disparo a la cabeza",
  T_39_WZY_WS_INTITALSPEED: "Velocidad inicial",
  T_39_WZY_WS_INVENTORYBASE: "Tipos de objetos básicos",
  T_39_WZY_WS_JETSHOE_BASEENERGYCOST: "Costo de energía por segundo",
  T_39_WZY_WS_JETSHOE_BASEHSPEED: "Velocidad horizontal básica",
  T_39_WZY_WS_JETSHOE_BASEVSPEED: "Velocidad vertical básica",
  T_39_WZY_WS_JETSHOE_DASHENERGYCOST: "Costo de energía por segundo",
  T_39_WZY_WS_JETSHOE_DASHHSPEED: "Velocidad horizontal al correr",
  T_39_WZY_WS_JETSHOE_RUSHDIS: "Distancia al correr",
  T_39_WZY_WS_JETSHOE_RUSHENERGYCOST: "Costo de energía por segundo",
  T_39_WZY_WS_JETSHOE_RUSHVSPEED: "Velocidad vertical al correr",
  T_39_WZY_WS_JETSHOE_UPENERGYCOST: "Costo de energía ascendente por segundo",
  T_39_WZY_WS_LANDMINE_CANBEATTACK: "Atacable",
  T_39_WZY_WS_LANDMINE_CANSELFTRIGGER: "Autoactivable",
  T_39_WZY_WS_LANDMINE_CANTEAMTRIGGER: "Si puede ser activado por los aliados",
  T_39_WZY_WS_LANDMINE_CANVEHICLETRIGGER: "Activable por vehículo",
  T_39_WZY_WS_LANDMINE_LIFETIME: "Duración",
  T_39_WZY_WS_LANDMINE_STARTTIME: "Tiempo de activación",
  T_39_WZY_WS_LANDMINE_TRIGGERRADIUS: "Radio de activación",
  T_39_WZY_WS_LANDMINE_TRIGGERTIME: "Tiempo de activación",
  T_39_WZY_WS_LEAVE: "Salir",
  T_39_WZY_WS_LIMBSCALE: "Escala de extremidades",
  T_39_WZY_WS_LISTLOCSTR: "Lista de texto localizado",
  T_39_WZY_WS_LOADRESULT_NAME: "Cargar resultado de la batalla",
  T_39_WZY_WS_LOADRESULT_NAMEDESC: "Cargar el resultado de la batalla del [jugador], incluyendo [rango], [resultado], [nombre de la puntuación], [valor de la puntuación]. El tipo de resultado es 1 para victoria, 2 para derrota, 3 para Booyah y 4 para empate.",
  T_39_WZY_WS_LOOKMOVENT: "Entidad de movimiento de seguimiento",
  T_39_WZY_WS_MAXCOUNT: "Cantidad máxima",
  T_39_WZY_WS_MAXDISTANCE: "Distancia máxima",
  T_39_WZY_WS_MINISENTRY_ANGELDOWN: "Ángulo de depresión de la torreta",
  T_39_WZY_WS_MINISENTRY_ANGELSPEED: "Velocidad angular de la torreta",
  T_39_WZY_WS_MINISENTRY_ANGELUP: "Ángulo de elevación de la torreta",
  T_39_WZY_WS_MINISENTRY_DAM: "Daño de la torreta",
  T_39_WZY_WS_MINISENTRY_DEFENSE: "Índice de reducción de daños",
  T_39_WZY_WS_MINISENTRY_FIREANGLE: "Ángulo de disparo",
  T_39_WZY_WS_MINISENTRY_HITCHANCE: "Tasa de impacto de la torreta",
  T_39_WZY_WS_MINISENTRY_INTERVAL: "Intervalo de ataque de la torreta",
  T_39_WZY_WS_MINISENTRY_MAXCOUNT: "Número máximo de torretas",
  T_39_WZY_WS_MINISENTRY_RANGE: "Alcance de ataque de la torreta",
  T_39_WZY_WS_MOVEENT: "Entidad de movimiento",
  T_39_WZY_WS_NOCOMBINE: "Sin doble empuñadura",
  T_39_WZY_WS_ONCE: "Una vez",
  T_39_WZY_WS_ONDROP_NAMEDESC: "Se activa un incidente cuando el objeto es descartado por una [entidad de jugador].",
  T_39_WZY_WS_ONEQUIP_NAMEDESC: "Se activa un incidente cuando el objeto es equipado por una [entidad de jugador]",
  T_39_WZY_WS_ONGRAPFIRE_NAMEDESC: "Se activa incidente cuando la Pistola de Gancho dispara",
  T_39_WZY_WS_ONLANDSTART_NAMEDESC: "Se activa un incidente cuando se activa la mina terrestre",
  T_39_WZY_WS_ONLANDTRIGGER_NAMEDESC: "Se activa un incidente cuando la mina terrestre es activada por una [entidad de jugador]",
  T_39_WZY_WS_ONMOTIONPAUSE_NAMEDESC: "Se activa cuando la entidad hace una pausa en el movimiento",
  T_39_WZY_WS_ONMOTIONREATART_NAMEDESC: "Se activa cuando la entidad reinicia el movimiento tras una pausa",
  T_39_WZY_WS_ONMOTIONSTART_NAMEDESC: "Se activa cuando la entidad inicia a moverse",
  T_39_WZY_WS_ONPICKUP_NAMEDESC: "Se activa un incidente cuando el objeto es recogido por [entidad de jugador].",
  T_39_WZY_WS_ONTHROWHIT_NAMEDESC: "Se activa un incidente cuando el objeto lanzable alcanza al objetivo",
  T_39_WZY_WS_OPENATTACK: "Permitir o no el ataque",
  T_39_WZY_WS_PAUSEMOV_NAMEDESC: "Pausar entidad de movimiento o lista de entidades de movimiento",
  T_39_WZY_WS_PAUSESOUND_NAME: "Pausar efecto de sonido",
  T_39_WZY_WS_PAUSESOUND_NAMEDESC: "Pausar entidad de sonido o lista de entidades de sonido",
  T_39_WZY_WS_PIANOTYPE: "Tipo de componente musical",
  T_39_WZY_WS_PINGPONG: "PingPong",
  T_39_WZY_WS_PLAYABLELIST: "Lista de Entidad de Movimiento",
  T_39_WZY_WS_PLAYINGSTATUE: "Estatus",
  T_39_WZY_WS_PLAYMOV_NAMEDESC: "Restaurar la Entidad de Movimiento o la Lista de Entidades de Movimiento en pausa. Puedes elegir reanudar o reiniciar.",
  T_39_WZY_WS_PLAYSOUND_NAME: "Reproducir efecto de sonido",
  T_39_WZY_WS_PLAYSOUND_NAMEDESC: "Restaurar la Entidad de Sonido o la Lista de Entidades de Sonido en pausa. Puedes elegir reanudar o reiniciar.",
  T_39_WZY_WS_PROCIRCLE_NAME: "Círculo de Progreso",
  T_39_WZY_WS_RAYINSPCON_NAMEDESC: "Emite un rayo a lo largo de la [dirección] desde las [coordenadas iniciales], detecta la primera entidad golpeada dentro de [distancia] y devuelve la [lista de entidades golpeadas] y la [lista de coordenadas de golpe].",
  T_39_WZY_WS_RAYINSPSIN_NAMEDESC: "Emite un rayo a lo largo de la [dirección] desde las [coordenadas iniciales], detecta la primera entidad golpeada dentro de [distancia] y devuelve la [entidad golpeada] y las [cordenadas de golpe].",
  T_39_WZY_WS_REAHEALHP: "Valor de recuperación de la armadura",
  T_39_WZY_WS_REAHEALTIME: "Intervalo de tiempo de efecto",
  T_39_WZY_WS_RELATCOORSYS: "Sistema de coordenadas relativo",
  T_39_WZY_WS_REPAIRARM: "Kit de reparación",
  T_39_WZY_WS_REVERSE: "Reversa",
  T_39_WZY_WS_RIMALPHA: "Transparencia del borde",
  T_39_WZY_WS_SCORENAME: "Nombre de la puntuación",
  T_39_WZY_WS_SENDSIGN_NAMEDESC: "Envía una señal a la Entidad Destino, los parámetros cargados están definidos por parámetros de señal predefinidos. La selección del tipo de entidad en el momento de la definición generará el evento de aceptación de señal correspondiente.",
  T_39_WZY_WS_SETFOLMOV_NAMEDESC: "Cree un movimiento de seguimiento de posición para la [entidad objetivo]. La [entidad objetivo] sigue a la [entidad seguidora]. [Coordenadas de desplazamiento] es el desplazamiento de coordenadas entre la [entidad objetivo] y la [entidad seguidora]. [Sistema de Coordenadas] puede seleccionar el Sistema de Coordenadas Mundiales y el Sistema de Coordenadas Relativas basado en la orientación de la entidad seguidora. La [entidad de movimiento de seguimiento de posición] será devuelta después de crear el movimiento.",
  T_39_WZY_WS_SETLOOKMOV_NAMEDESC: "Crea un movimiento de seguimiento de mirada para la [entidad objetivo]. La [entidad objetivo] sigue a la [entidad seguidora]. [Coordenadas de desplazamiento] es el desplazamiento de coordenadas entre [entidad objetivo] y [entidad seguidora]. El [Sistema de Coordenadas] puede seleccionar el Sistema de Coordenadas Mundiales y el Sistema de Coordenadas Relativas basado en la orientación de la entidad seguidora. La [entidad de movimiento de seguimiento] será devuelta después de crear el movimiento.",
  T_39_WZY_WS_SHOE_FALLDAMSCALE: "Porcentaje de daño de caída",
  T_39_WZY_WS_SHOE_MAXENERGY: "Energía máxima",
  T_39_WZY_WS_SKILLLIST: "Lista de habilidades",
  T_39_WZY_WS_SKILLTYPE: "Habilidad del personaje",
  T_39_WZY_WS_SMOKEG_EFFECTTIME: "Duración del efecto de humo",
  T_39_WZY_WS_SMOOTH: "Cambio de cámara",
  T_39_WZY_WS_SOUNDENTL: "Lista de entidades de efectos de sonido",
  T_39_WZY_WS_SOUNDENTLORSENT: "Lista o entidad de efectos de sonido",
  T_39_WZY_WS_SPRINTSPEED: "Porcentaje de la velocidad al correr",
  T_39_WZY_WS_SQUATSPEED: "Porcentaje de velocidad de movimiento (En cuclillas)",
  T_39_WZY_WS_STARTCOO: "Coordenadas iniciales",
  T_39_WZY_WS_STATE: "Estado del juego",
  T_39_WZY_WS_TARGETVAL: "Valor objetivo",
  T_39_WZY_WS_THROWSPEED: "Velocidad de vuelo",
  T_39_WZY_WS_TOWER_PARAM10: "Ángulo de rotación",
  T_39_WZY_WS_TOWER_PARAM11: "Estatus de la torreta",
  T_39_WZY_WS_TOWER_PARAM12: "ID de la entidad",
  T_39_WZY_WS_TOWER_PARAM9: "Objetivo de ataque",
  T_39_WZY_WS_TOWSPEED: "Velocidad de viaje del jugador",
  T_39_WZY_WS_TWEENCURVE_NAME: "Curva personalizada",
  T_39_WZY_WS_TWEENCURVE_NAMEDESC: "La curva personalizada se puede utilizar para el movimiento de interpolación",
  T_39_WZY_WS_TWEENENT: "Entidad de movimiento de interpolación",
  T_39_WZY_WS_TWEENPLAYST_NAME: "Métodos de movimiento",
  T_39_WZY_WS_TWEENPLAYST_NAMEDESC: "Métodos de Movimiento de Interpolación",
  T_39_WZY_WS_TWEENSTYLE: "Método",
  T_39_WZY_WS_UNLOADSCRIPT_NAMEDESC: "Eliminar script [Nombre del script] para [entidad]",
  T_39_WZY_WS_UPSET_NAMEDESC: "Aleatorizar elementos de la lista",
  T_39_WZY_WS_VISIBLEONBACK: "Visible al reverso",
  T_39_WZY_WS_WEAPCOMBINET: "Tipo de arma con doble empuñadura",
  T_39_WZY_WS_WEAPON_KNOCKDOWNDAM: "Daño extra al derribado",
  T_39_WZY_WS_WEAPON_ONCEAMMO: "Número de Disparo Único",
  T_39_WZY_WS_WEAREPLAY: "¿Reiniciar movimiento?",
  T_39_WZY_WS_WORLDCOORSYS: "Sistema de Coordenadas del Mundo",
  T_39_XXJ_WS_ADDFRIEND: "Agregar a amigos",
  T_39_XXJ_WS_ALLOWZ: "Activar el movimiento del eje x del jugador",
  T_39_XXJ_WS_BLOCKMODEDESC: "Movimiento de la cámara cuando hay un objeto entre la cámara y el objetivo.",
  T_39_XXJ_WS_CAMERADISTANCE: "Distancia del objetivo",
  T_39_XXJ_WS_CAMERATYPEDESC: "Se proporcionan varios tipos de ajustes preestablecidos y personalizados",
  T_39_XXJ_WS_CAMERAUSER: "Usuario de la cámara",
  T_39_XXJ_WS_CURENTCAMERA: "Cámara usada",
  T_39_XXJ_WS_DETAILS: "Detalles de la partida",
  T_39_XXJ_WS_FFECONOMY: "Economía",
  T_39_XXJ_WS_FOCUSTARGET: "Objetivo observado",
  T_39_XXJ_WS_FOLLOWTARGET: "Objetivo seguido",
  T_39_XXJ_WS_GAMERESULT: "Resultado de la partida",
  T_39_XXJ_WS_GAMETITLE1: "Partida 1",
  T_39_XXJ_WS_GAMETITLE2: "Partida 2",
  T_39_XXJ_WS_GIFT: "Regalo",
  T_39_XXJ_WS_HORIZONTALANGLEDESC: "Ángulo de rotación horizontal de la cámara",
  T_39_XXJ_WS_INVISICAM: "Translúcido",
  T_39_XXJ_WS_INVISICAMDESC: "El objeto entre la cámara y el objetivo se vuelve translúcido.",
  T_39_XXJ_WS_LEFTSCORE: "Puntuación del Equipo Izquierdo",
  T_39_XXJ_WS_LIKE: "Me Gusta",
  T_39_XXJ_WS_LOBBY: "Lobby",
  T_39_XXJ_WS_MAINSCORENAME: "Nombre de la Puntuación Total",
  T_39_XXJ_WS_MAINSCORENUM: "Número Puntuación Total",
  T_39_XXJ_WS_MAPEVALUATE: "Valoración del mapa",
  T_39_XXJ_WS_MULTITEAMRESULTHUD: "Resultado de varios equipos",
  T_39_XXJ_WS_MVP1: "MVP 1",
  T_39_XXJ_WS_MVP2: "MVP 2",
  T_39_XXJ_WS_OFFSET2: "Desplazamiento del punto de observación",
  T_39_XXJ_WS_OFFSET2DESC: "Normalmente, se refiere al desplazamiento del punto de enfoque de la cámara con respecto a la posición original del jugador. (El significado varía según el tipo de cámara)",
  T_39_XXJ_WS_OFFSETDESC: "Normalmente, se refiere al desplazamiento de la posición de la cámara con respecto a la posición original del jugador. (El significado varía según el tipo de cámara)",
  T_39_XXJ_WS_ORTHOGONAL: "Ortogonal",
  T_39_XXJ_WS_ORTHOGONALDESC: "La cámara representa objetivos lejanos y cercanos del mismo tamaño.",
  T_39_XXJ_WS_PERSPECTIVE: "Perspectiva",
  T_39_XXJ_WS_PERSPECTIVEDESC: "La cámara usa la proyección en perspectiva para observar el objetivo.",
  T_39_XXJ_WS_PROJECTIONMODEDESC: "Formación de la imagen de la cámara al renderizar.",
  T_39_XXJ_WS_RANK1: "Rango del Equipo",
  T_39_XXJ_WS_RANK2: "Rango del Jugador",
  T_39_XXJ_WS_REPORT: "Reporte",
  T_39_XXJ_WS_REVIEW: "Volver a reproducir",
  T_39_XXJ_WS_RIGHTSCORE: "Puntuación del Equipo Derecho",
  T_39_XXJ_WS_SCORENUM1: "Puntuación 1",
  T_39_XXJ_WS_SCORENUM2: "Puntuación 2",
  T_39_XXJ_WS_SCORENUM3: "Puntuación 3",
  T_39_XXJ_WS_SCORENUM4: "Puntuación 4",
  T_39_XXJ_WS_SCORENUM5: "Puntuación 5",
  T_39_XXJ_WS_SCORETITLELIST: "Lista de Nombres de la Puntuación",
  T_39_XXJ_WS_SHARE: "Compartir",
  T_39_XXJ_WS_SPECTATORSWITCH: "Espectador",
  T_39_XXJ_WS_STABLE: "Estable",
  T_39_XXJ_WS_STABLEDESC: "La cámara permanece estable si hay un objeto entre la cámara y la entidad seguida.",
  T_39_XXJ_WS_TEAMNAME1: "Nombre del Equipo Izquierdo",
  T_39_XXJ_WS_TEAMNAME2: "Nombre del Equipo Derecho",
  T_39_XXJ_WS_TEAMRANK: "Rango del Equipo",
  T_39_XXJ_WS_TRANSITIONTIME: "Tiempo de transición de la cámara",
  T_39_XXJ_WS_TRANSITIONTYPE: "Tipo de transición de la cámara",
  T_39_XXJ_WS_TWOTEAMRESULTHUD: "Resultado de 2 equipos",
  T_39_XXJ_WS_VERTICALANGLEDESC: "Ángulo de rotación vertical de la cámara",
  T_39_XXJ_WS_ZOOM: "Zoom",
  T_39_XXJ_WS_ZOOMDESC: "La cámara se acerca si hay un objeto entre la cámara y la entidad seguida.",
  T_39_XYL_WS_LIGHTINTENSITY: "Intensidad de la luz",
  T_39_XYL_WS_LIGHTRANGE: "Alcance de la luz",
  T_39_XYL_WS_POINTLIGHT: "Punto luminoso",
  T_39_XYL_WS_WATERZONE: "Zona de agua personalizada",
  T_40_B_DISABLE_RECONNECT: "Desactivar la reconexión automática",
  T_40_CJ_T_SHUTTLECOCK_BLACK: "Uniforme Medianoche (Superior)",
  T_40_CJ_T_SHUTTLECOCK_RED2: "Uniforme Fuego Ártico (Superior)",
  T_40_CJ_T_SHUTTLECOCK_REDBLACK: "Uniforme Rojinegro (Superior)",
  T_40_CJ_T_SHUTTLECOCK_YELLOW: "Uniforme Cielo Soleado (Superior)",
  T_40_CJ_T_SPORTSWEAR_FIRE: "Uniforme Fuego Encendido (Superior)",
  T_40_DYEING_CLEAR: "Estado de coloreado claro",
  T_40_HJ_WS_EFFECT32: "Calzado Deportivo",
  T_40_HJ_WS_EFFECT33: "Explosión",
  T_40_HJ_WS_EFFECT34: "Punto de Inicio",
  T_40_HJ_WS_EFFECT35: "Láser",
  T_40_HJ_WS_EFFECT36: "Munición",
  T_40_HJ_WS_EFFECT37: "Efecto de Golpe",
  T_40_HJ_WS_EFFECT38: "Efecto de Disparo",
  T_40_HJ_WS_EFFECT43: "Telaraña",
  T_40_HJ_WS_EFFECT44: "Liberar una habilidad",
  T_40_HJ_WS_SOUND69: "Abrir una caja",
  T_40_HJ_WS_SOUND70: "Subir de nivel",
  T_40_HJ_WS_SOUND71: "Nivel máximo",
  T_40_HJ_WS_SOUND72: "Pulsar un botón",
  T_40_HJ_WS_SOUND73: "Cuenta Regresiva 1",
  T_40_HJ_WS_SOUND74: "Silbato",
  T_40_HJ_WS_SOUND75: "Fin del juego",
  T_40_HJ_WS_SOUND76: "Adelante",
  T_40_HJ_WS_SOUND77: "Booyah",
  T_40_HJ_WS_SOUND78: "Punto de Control",
  T_40_HJ_WS_SOUND79: "Cuenta Regresiva 2",
  T_40_HJ_WS_SOUND80: "Inicio del juego",
  T_40_HJ_WS_SOUND81: "Muchas monedas obtenidas",
  T_40_HJ_WS_SOUND82: "Monedas obtenidas",
  T_40_HJ_WS_SOUND83: "Algunas monedas obtenidas",
  T_40_HJ_WS_SOUND84: "Unido al juego",
  T_40_HJ_WS_SOUND85: "Abrir Suministros del Clan",
  T_40_HJ_WS_SOUND86: "Claxón",
  T_40_HJ_WS_SOUND87: "Eliminar un Jefe",
  T_40_HJ_WS_SOUND88: "Abrir Cofre de Guerra",
  T_40_HJ_WS_SOUND89: "Habilidad de Pintura Explosiva",
  T_40_HJ_WS_SOUND90: "Golpe de bala",
  T_40_HJ_WS_SOUND91: "Habilidad de Escudo de Pintura",
  T_40_HJ_WS_SOUND92: "Tocar un botón deshabilitado",
  T_40_HJ_WS_SOUND93: "Carga de habilidades completada",
  T_40_HJ_WS_SOUND95: "Habilidad Láser",
  T_40_HJ_WS_SOUND96: "Obtener objeto 2",
  T_40_HJ_WS_SOUND97: "Fin del Juego 2",
  T_40_HJ_WS_SOUND98: "Notificación de Eliminación",
  T_40_HJ_WS_SOUNDTYPE_BMG: "Música de fondo",
  T_40_HJ_WS_SOUNDTYPE_INGAME: "Efecto de sonido en la partida",
  T_40_HJ_WS_SOUNDTYPE_UI: "Efecto de sonido del widget de IU",
  T_40_JH_WS_MAPTAG1: "Juego de color",
  T_40_JH_WS_MAPTAG10: "Escondite colorido",
  T_40_JH_WS_MAPTAG11: "Aniversario",
  T_40_JH_WS_MAPTAG12: "Juegos de rol",
  T_40_JH_WS_MAPTAG13: "Simulación",
  T_40_JH_WS_MAPTAG14: "Arena asimétrica",
  T_40_JH_WS_MAPTAG15: "Batalla de recursos",
  T_40_JH_WS_MAPTAG16: "Escolta de carros",
  T_40_JH_WS_MAPTAG17: "Mapa oficial",
  T_40_JH_WS_MAPTAG18: "Minijuego",
  T_40_JH_WS_MAPTAG19: "Desafío de rapidez",
  T_40_JH_WS_MAPTAG2: "Spray de Color",
  T_40_JH_WS_MAPTAG20: "Juegos de rol",
  T_40_JH_WS_MAPTAG3: "Pelea de color",
  T_40_JH_WS_MAPTAG4: "Disparos en color",
  T_40_JH_WS_MAPTAG5: "Juegos de Colores",
  T_40_JH_WS_MAPTAG6: "Área de juegos",
  T_40_JH_WS_MAPTAG7: "Fiesta de color",
  T_40_JH_WS_MAPTAG8: "Parkour de color",
  T_40_JH_WS_MAPTAG9: 'Parkour "Spider-Verso"',
  T_40_JH_WS_TAG30: "Magnate",
  T_40_JH_WS_TAG31: "Naufragio en casa",
  T_40_JH_WS_TAG32: "Pueblo Misterioso",
  T_40_JH_WS_TAG33: "Crisis del Amanecer",
  T_40_JH_WS_TAG34: "Insurrección Mortal",
  T_40_JH_WS_TAG35: "Pelea con puños",
  T_40_JH_WS_TAG36: "Techo de la fábrica",
  T_40_JH_WS_UGCTOKENNAME: "Token Crea Tu Mapa",
  T_40_L_QUICKMESSAGE_MODE2: "Duelo de Escuadras",
  T_40_M_WS_HIS: "de",
  T_40_SP_WS_DYEING: "Color",
  T_40_SP_WS_DYEING_AREA: "Coloreado de área",
  T_40_SP_WS_DYEING_COLOR: "Número de color",
  T_40_SP_WS_DYEING_COUNT: "Recuento de coloreado",
  T_40_SP_WS_DYEING_DIR: "Dirección de coloreado",
  T_40_SP_WS_DYEING_DIS: "Distancia de coloreado",
  T_40_SP_WS_DYEING_FIXEDDYEINGRANGE: "Área de coloreado fija",
  T_40_SP_WS_DYEING_NORMAL: "Normal",
  T_40_SP_WS_DYEING_PLANE: "Coloreado de área de avión",
  T_40_SP_WS_DYEING_POSITION: "Coordinar",
  T_40_SP_WS_DYEING_RANDOMDECAY: "Decadencia de la tasa de coloreado aleatorio",
  T_40_SP_WS_DYEING_RANDOMRATIO: "Tasa de coloreado aleatorio",
  T_40_SP_WS_DYEING_RANGE: "Área de Coloreado",
  T_40_SP_WS_DYEING_STATE: "Estado de coloreado",
  T_40_SP_WS_FACTIONTIPS_11: "Morado",
  T_40_SP_WS_SHOE_CURENERGY: "Energía actual",
  T_40_SW_SKILL_Name_Nanoscientist: "Nanoescudo de Vida",
  T_40_SY_AK47_PENGUIN_W_N: "AK47- Maravilla de Wagger",
  T_40_SY_CHARACTER_DJMALE_AWAKENING_N: "Alok Renacido",
  T_40_SY_CHARACTER_NANOSCIENTIST_N: "Sonia",
  T_40_SY_FAMAS_PENGUIN_W_N: "FAMAS - Maravilla de Wagger",
  T_40_SY_M1014_PENGUIN_W_N: "M1014- Maravilla de Wagger",
  T_40_SY_M24_PENGUIN_W_N: "M24- Maravilla de Wagger",
  T_40_SY_MINI_PENGUIN_W_N: "AC80- Maravilla de Wagger",
  T_40_SY_PET_PUG_N: "Carlino, el Pug",
  T_40_SY_PETSKIN_ALIEN_TIGHTGUY_N: 'Aspecto de Mascota: Moony  "Spider-Verso"',
  T_40_SY_PETSKIN_FLYINGCREATURE_ME_N: "Aspecto de Mascota: Dragoncito Eléctrico",
  T_40_SY_PETSKIN_PUG_BLACK_N: "Aspecto de Mascota: Carlino, el Pug con Láser",
  T_40_SY_PETSKIN_PUG_GREEN_N: "Aspecto de Mascota: Carlino, el Pug en Verano",
  T_40_SY_PETSKIN_PUG_ORANGE_N: "Aspecto de Mascota: Carlino, el Pug de Tigre",
  T_40_SY_SCAR_PENGUIN_W_N: "SCAR- Maravilla de Wagger",
  T_40_SY_THOMPSON_PENGUIN_W_N: "Thompson- Maravilla de Wagger",
  T_40_SY_UMP45_PENGUIN_W_N: "UMP- Maravilla de Wagger",
  T_40_SY_USP45_PENGUIN_W_N: "USP - Maravilla de Wagger",
  T_40_SY_UZI_PENGUIN_W_N: "Mini Uzi- Maravilla de Wagger",
  T_40_V_WS_INPUT_TEXT_ACTIVE: "Activar contenido de texto",
  T_40_V_WS_INPUT_TEXT_DEFAULT: "Contenido de texto de marcador de posición",
  T_40_W_DJMALE_AWAKENING_D: "Habilidad Renacida: Mientras el aura esté activa, se dejarán caer notas musicales que duran [FFB300]{2}s[-] a [FFB300]{1}m[-] detrás del usuario de la habilidad cada [FFB300]{0}s[-]. Los compañeros de equipo que recojan las notas musicales recibirán el mismo efecto que el aura.",
  T_40_W_DJMALE_AWAKENING_N: "Fiesta Remix",
  T_40_W_NURSE_D: "Distribuye [FFB300]{0}%[-] de tus efectos curativos de un solo objetivo (habilidad, botiquín, arma curativa, etc.) a tus compañeros en un radio de [FFB300]{1}m[-] de ti.",
  T_40_WH_MP_BOXING_NAME: "Combate de Boxeo",
  T_40_WH_MP_C_PACK: "Mochila Ilegal",
  T_40_WH_MP_EXCH_COIN: "Dinero en Efectivo",
  T_40_WH_MP_EXCH_TEMPCOIN: "Dinero Ilegal",
  T_40_WH_MP_PAYCHECK: "Salarios",
  T_40_WT_SKILL_DESC_MUSICBRO_BLACK: "La velocidad de ayuda a los compañeros de equipo aumenta [FFB300]{0}%[-]. Enfriamiento: [FFB300]{3}s[-]. El compañero ayudado recupera [FFB300]{2} PV[-] en [FFB300]{1}s[-].",
  T_40_WT_SKILL_DESC_MUSICBRO_WHITE2: "Crea una zona de curación de [FFB300]{0}m de radio[-]. En el interior, el usuario y los aliados recuperan [FFB300]{1} PV/s[-]. La ayuda se activará automáticamente cuando sea necesario. La zona dura [FFB300]{2}s[-]. Los efectos de ayudar a los compañeros de equipo se pueden mejorar con otras habilidades. Enfriamiento: [FFB300]{3}s[-].",
  T_40_WT_WS_ICONENTITY_PARAM6: "Método de visualización",
  T_40_WZY_WS_CUSTOMTRIGGER_CAPSULE: "Cápsula",
  T_40_WZY_WS_CUSTOMTRIGGER_HEIGHT: "Altura",
  T_40_WZY_WS_CUSTOMTRIGGER_RADIUS: "Radio",
  T_40_WZY_WS_CUSTOMTRIGGER_SPHERE: "Esfera",
  T_40_WZY_WS_FONT_FF_CN_T: "FZLanTingHei-R-BIG5",
  T_40_WZY_WS_FONT_HINDSILIGURI: "Hind Siliguri",
  T_40_WZY_WS_FONT_NOTONASTALIQURDU: "Noto Nastaliq Urdu",
  T_40_WZY_WS_FONT_NOTOSANS: "GFF Devanagari",
  T_40_WZY_WS_FONT_SIMPBDO: "Simplified Arabic",
  T_40_WZY_WS_FONT_SUPERMARKET: "Supermercado",
  T_40_WZY_WS_ICONENTITY_COLOR: "Color",
  T_40_WZY_WS_ICONENTITY_FILLED: "Progresiva",
  T_40_WZY_WS_ICONENTITY_ICONTYPE: "Recursos de imagen",
  T_40_WZY_WS_ICONENTITY_NAME: "Objeto icono",
  T_40_WZY_WS_ICONENTITY_RENDERTYPE: "Método de visualización",
  T_40_WZY_WS_ICONENTITY_SIMPLE: "Simple",
  T_40_WZY_WS_ICONENTITY_SLICED: "9-Grid",
  T_40_WZY_WS_ICONENTITY_TILED: "Mosaico",
  T_40_WZY_WS_NEWMAPTAG: "Icono de Nuevo Mapa",
  T_40_WZY_WS_NEWVFX1: "Halo",
  T_40_WZY_WS_NEWVFX10: "Maldición",
  T_40_WZY_WS_NEWVFX11: "Zona de congelación",
  T_40_WZY_WS_NEWVFX12: "Aire frío",
  T_40_WZY_WS_NEWVFX13: "Copo de nieve",
  T_40_WZY_WS_NEWVFX14: "Flama",
  T_40_WZY_WS_NEWVFX15: "Haz de Luz",
  T_40_WZY_WS_NEWVFX16: "Propagación de gas venenoso",
  T_40_WZY_WS_NEWVFX17: "Gas Venenoso",
  T_40_WZY_WS_NEWVFX18: "Fuego Explosivo",
  T_40_WZY_WS_NEWVFX19: "Efecto de luz",
  T_40_WZY_WS_NEWVFX2: "Burbuja",
  T_40_WZY_WS_NEWVFX20: "Estrella",
  T_40_WZY_WS_NEWVFX3: "Ceniza",
  T_40_WZY_WS_NEWVFX4: "Salpicadura de Piedra",
  T_40_WZY_WS_NEWVFX5: "Línea",
  T_40_WZY_WS_NEWVFX6: "Destello",
  T_40_WZY_WS_NEWVFX7: "Anillo",
  T_40_WZY_WS_NEWVFX8: "Partícula ascendente",
  T_40_WZY_WS_NEWVFX9: "Humo",
  T_40_WZY_WS_PRESENTTXT_FONTSIZE: "Tamaño de letra",
  T_40_WZY_WS_PRESENTTXT_FONTSTYLE: "Estilo de letra",
  T_40_WZY_WS_TEXTENTITY_FONTTYPE: "Letra",
  T_40_WZY_WS_TEXTENTITY_NAME: "Objeto de texto",
  T_40_WZY_WS_UIFONT_LATIN: "Agency FB",
  T_40_WZY_WS_UIFONT_LATIN_BOLD: "GFF Latin",
  T_40_XXJ_WS_ACTIONHUD: "Componente HUD del botón de interacción",
  T_40_XXJ_WS_ACTIVEINHIERARCHY_DESCKEY: 'Si se puede usar en el escenario. Esto es solo de lectura y depende de "Padre disponible o no" y "Estado de actividad".',
  T_40_XXJ_WS_ACTIVEPARENT_DESCKEY: "Si todos los padres están activos. Esto es solo lectura y no es visible para los jugadores.",
  T_40_XXJ_WS_ACTIVEPARENT_NAMEKEY: "Padre disponible o no",
  T_40_XXJ_WS_ACTIVESELF_DESCKEY: "Mostrar cuando el estado abierto es verdadero, en caso contrario cerrado",
  T_40_XXJ_WS_ACTIVESELF1_DESCKEY: 'Si puede ser activo en sí mismo. Para utilizar en el escenario, debe utilizar "Activo en el escenario o no". Esto es de solo lectura y se configura mediante una API.',
  T_40_XXJ_WS_ADDORREMOVECAMERACULLINGMASK_DESCKEY: "Si la máscara culling de la cámara es visible para una capa determinada",
  T_40_XXJ_WS_ADDTOKENATPOSITION_DESCKEY: "Generar tokens en un lugar determinado",
  T_40_XXJ_WS_ADDTOKENTOPLAYER_DESCKEY: "El objeto de botín que se entregará al jugador",
  T_40_XXJ_WS_AFORWARD_DESCKEY: "Orientación actual del jugador",
  T_40_XXJ_WS_AFORWARD_NAMEKEY: "Dirección",
  T_40_XXJ_WS_AIREALATTACKENTITY_DESCKEY: "La IA está atacando a la entidad",
  T_40_XXJ_WS_AITARGET_DESCKEY: "La IA atacante",
  T_40_XXJ_WS_ALIGNMENT_DESCKEY: "El estilo de alineación",
  T_40_XXJ_WS_ALIGNMENT_NAMEKEY: "Alineación horizontal",
  T_40_XXJ_WS_ALIGNMENTVERTICAL_NAMEKEY: "Alineación vertical",
  T_40_XXJ_WS_ALPHA_DESCKEY: "Transparencia",
  T_40_XXJ_WS_AMMOINCLIP_DESCKEY: "El recuento de munición restante",
  T_40_XXJ_WS_AMMOINCLIP_NAMEKEY: "Munición restante",
  T_40_XXJ_WS_ANCHORMAX: "Anclaje máximo",
  T_40_XXJ_WS_ANCHORMIN: "Anclaje mínimo",
  T_40_XXJ_WS_APOSITION_DESCKEY: "Posición actual del jugador",
  T_40_XXJ_WS_APOSITION_NAMEKEY: "Posición",
  T_40_XXJ_WS_ARMORHUD_NAMEKEY: "Cambio del HUD de la armadura",
  T_40_XXJ_WS_ASSETCONFIGID_NAMEKEY: "ID de activo configurado",
  T_40_XXJ_WS_ASSETID_NAMEKEY: "ID de activos",
  T_40_XXJ_WS_ATTACKENTITY_NAMEKEY: "Objetivo del ataque",
  T_40_XXJ_WS_ATTACKGRENADE_NAMEKEY: "Atacar lanzables",
  T_40_XXJ_WS_ATTACKTARGET_DESCKEY: "La entidad que está siendo atacada por la IA",
  T_40_XXJ_WS_ATTACKTARGET_NAMEKEY: "Objetivo atacado",
  T_40_XXJ_WS_AVAILABLEPOSVEC3_DESCKEY: "Las coordenadas disponibles de los puntos de inicio",
  T_40_XXJ_WS_AVAILABLEPOSVEC3_NAMEKEY: "Coordenadas disponibles",
  T_40_XXJ_WS_BACKGROUND_DESCKEY: "La imagen inferior",
  T_40_XXJ_WS_BACKGROUND_NAMEKEY: "Fondo",
  T_40_XXJ_WS_BAGHUD_NAMEKEY: "Mochila",
  T_40_XXJ_WS_BGALPHA_NAMEKEY: "Transparencia de fondo",
  T_40_XXJ_WS_BGCOLOR_DESCKEY: "Color de fondo",
  T_40_XXJ_WS_BGCOLOR_NAMEKEY: "Color de fondo",
  T_40_XXJ_WS_BGFILL_DESCKEY: "Llenar o no el fondo",
  T_40_XXJ_WS_BGFILL_NAMEKEY: "Fondo de relleno",
  T_40_XXJ_WS_BGNAME_DESCKEY: "Nombre de fondo",
  T_40_XXJ_WS_BGNAME_NAMEKEY: "Nombre de fondo",
  T_40_XXJ_WS_BGSIZEDELTA_DESCKEY: "Tamaño del fondo delta",
  T_40_XXJ_WS_BGSIZEDELTA_NAMEKEY: "Tamaño del fondo delta",
  T_40_XXJ_WS_BLUE: "Azul",
  T_40_XXJ_WS_BODY_DESCKEY: "Torso",
  T_40_XXJ_WS_BODY_NAMEKEY: "Torso",
  T_40_XXJ_WS_BONESCALE_NAMEKEY: "Escala del esqueleto",
  T_40_XXJ_WS_BORNPOSITIONVEC3_DESCKEY: "Punto de inicio del jugador",
  T_40_XXJ_WS_BORNPOSITIONVEC3_NAMEKEY: "Punto de Inicio",
  T_40_XXJ_WS_BOTH: "O",
  T_40_XXJ_WS_BUTTONNAME: "Nombre del componente del botón",
  T_40_XXJ_WS_CAMERA_DESCKEY: "Cámara",
  T_40_XXJ_WS_CAMERADIR_DESCKEY: "La dirección en la que está orientada la cámara del cliente",
  T_40_XXJ_WS_CAMERAPOS_DESCKEY: "La ubicación de la cámara cliente",
  T_40_XXJ_WS_CAMERARAYCASTHUD_DESCKEY: "Detectar la línea de cámara del cliente",
  T_40_XXJ_WS_CAMERARAYCASTHUD_NAMEKEY: "Detección de rayos de cámara",
  T_40_XXJ_WS_CANCELDRAGIFFITS_DESCKEY: "Detener el arrastre cuando coincide con la ventana gráfica",
  T_40_XXJ_WS_CANCELDRAGIFFITS_NAMEKEY: "Salir del arrastre tras el ajuste",
  T_40_XXJ_WS_CAPSULEHEIGHT_DESCKEY: "La distancia entre los centros de los semicírculos de la forma de píldora. No puede ser inferior al doble del radio de la esfera.",
  T_40_XXJ_WS_CELLSIZE_DESCKEY: "Tamaño de la celda",
  T_40_XXJ_WS_CELLSIZE_NAMEKEY: "Altura de la celda hija",
  T_40_XXJ_WS_CELLVALUE: "Lee el contenido de una celda determinada y devuelve un objeto",
  T_40_XXJ_WS_CENTER_DESCKEY: "Las coordenadas mundiales que corresponden al centro del minimapa. 0 por defecto.",
  T_40_XXJ_WS_CENTER_NAMEKEY: "Centro del minimapa",
  T_40_XXJ_WS_CENTEROFFSET_DESCKEY: "Desplazamiento de la posición del botón",
  T_40_XXJ_WS_CENTEROFFSET_NAMEKEY: "Desplazamiento de posición",
  T_40_XXJ_WS_CENTEROFMASS_DESCKEY: "El centro de masa relativo a las coordenadas locales",
  T_40_XXJ_WS_CENTEROFMASS_NAMEKEY: "Centro de masa",
  T_40_XXJ_WS_CENTRALLINEACTIVE_DESCKEY: "Mostrar o no la línea central",
  T_40_XXJ_WS_CENTRALLINEACTIVE_NAMEKEY: "Mostrar o no la línea central",
  T_40_XXJ_WS_CENTRALLINEPOS_DESCKEY: "Posición de la línea central [0,1]",
  T_40_XXJ_WS_CENTRALLINEPOS_NAMEKEY: "Posición de la línea central",
  T_40_XXJ_WS_CHASERANGE: "Alcance de la persecución",
  T_40_XXJ_WS_CHASETARGET_DESCKEY: "La entidad perseguida por la IA",
  T_40_XXJ_WS_CHASETARGET_NAMEKEY: "Objetivo perseguido",
  T_40_XXJ_WS_CHILD_DESCKEY: "Entidad del hijo",
  T_40_XXJ_WS_CHILDINDEX_NAMEKEY: "Hijos de los padres",
  T_40_XXJ_WS_CHITPOS_DESCKEY: "El punto alcanzado por la línea de la cámara",
  T_40_XXJ_WS_CHOOSECARHUD: "Seleccionar tarjeta entidad HUD",
  T_40_XXJ_WS_CLAMP_DESCKEY: "Si el parámetro se encuentra dentro del rango numérico comprendido entre los valores mínimo y máximo, la función devolverá el valor del parámetro; si el parámetro es mayor que el rango, la función devolverá el valor máximo; si el argumento es menor que el rango, la función devolverá el valor mínimo",
  T_40_XXJ_WS_CLEARALLCHILDREN_DESCKEY: "Solo admite entidades que tengan el componente Transformar. Actualmente restringido a todos los objetos.",
  T_40_XXJ_WS_CLICKSIZE_DESCKEY: "El tamaño del área de clic",
  T_40_XXJ_WS_CLICKSIZE_NAMEKEY: "Tamaño del clic",
  T_40_XXJ_WS_CLIPPINGTYPE_DESCKEY: "Tipo de recorte",
  T_40_XXJ_WS_CLIPPINGTYPE_NAMEKEY: "Tipo de recorte",
  T_40_XXJ_WS_CLONEENT_D: "Clona la entidad seleccionada y sus atributos manteniendo el padre original. Si se selecciona Objeto de Nivel, se basará en Crear Objeto de Nivel.",
  T_40_XXJ_WS_CLOTHES_DESCKEY: "La lista de atuendos",
  T_40_XXJ_WS_CLOTHID_DESCKEY: "El ID del atuendo",
  T_40_XXJ_WS_CLOTHID_NAMEKEY: "ID del atuendo",
  T_40_XXJ_WS_CLOTHID1_DESCKEY: "El ID del atuendo",
  T_40_XXJ_WS_COL_DESC: "La columna que hay que leer",
  T_40_XXJ_WS_COLNAME_DESC: "El nombre de la columna a leer",
  T_40_XXJ_WS_COLOR_DESCKEY: "Color",
  T_40_XXJ_WS_COLOR_NAMEKEY: "Valor",
  T_40_XXJ_WS_COLOR1_DESCKEY: "Agrega capas de color usando el canal de color RGBA. El valor de un canal está entre 0 y 255 y se almacena en un Int32. Blanco (255, 255, 255, 255) por defecto.",
  T_40_XXJ_WS_COLOR2_DESCKEY: "Color de la barra de progreso",
  T_40_XXJ_WS_COLOR3_DESCKEY: "El tipo de canal de color RGBA, que va de 0 a 255",
  T_40_XXJ_WS_COLOR4_DESCKEY: "El color del texto",
  T_40_XXJ_WS_COLOR5_DESCKEY: "El color del HUD",
  T_40_XXJ_WS_COLOR6_DESCKEY: "El color de la iluminación",
  T_40_XXJ_WS_COLORA_DESCKEY: "El valor del color A",
  T_40_XXJ_WS_COLORB_DESCKEY: "El valor del color B",
  T_40_XXJ_WS_COLORBAR_NAMEKEY: "Color de la barra de progreso",
  T_40_XXJ_WS_COLORDRUM_DESCKEY: "Barril de Color",
  T_40_XXJ_WS_COLORDRUM_NAMEKEY: "Barril de Color",
  T_40_XXJ_WS_COLORG_DESCKEY: "El valor del color G",
  T_40_XXJ_WS_COLORGETCHANNEL_DESCKEY: "Obtiene el canal RGBA",
  T_40_XXJ_WS_COLORGUN: "Rifle en Spray Arcoíris",
  T_40_XXJ_WS_COLORGUN_01: "Rifle en Spray Arcoíris (Rojo)",
  T_40_XXJ_WS_COLORGUN_02: "Rifle en Spray Arcoíris (Amarillo)",
  T_40_XXJ_WS_COLORGUN_03: "Rifle en Spray Arcoíris (Azul)",
  T_40_XXJ_WS_COLORGUN_04: "Rifle en Spray Arcoíris (Verde)",
  T_40_XXJ_WS_COLORGUN_05: "Rifle en Spray Arcoíris (Púrpura)",
  T_40_XXJ_WS_COLORR_DESCKEY: "El valor del color R",
  T_40_XXJ_WS_COLORTEXT_NAMEKEY: "Color del texto",
  T_40_XXJ_WS_COLVALUE: "Contenido de la columna",
  T_40_XXJ_WS_COMMONHUDSWITCHCONTROLLER_DESCKEY: "La entidad HUD de un interruptor general HUD",
  T_40_XXJ_WS_COMMONHUDSWITCHCONTROLLER_NAMEKEY: "Entidad HUD de un interruptor general HUD",
  T_40_XXJ_WS_CONSTRAINT_DESCKEY: "Restricción",
  T_40_XXJ_WS_CONSTRAINT_NAMEKEY: "Restricción",
  T_40_XXJ_WS_CONSTRAINTCOUNT_DESCKEY: "El número de restricciones",
  T_40_XXJ_WS_CONSTRAINTCOUNT_NAMEKEY: "Recuento de restricciones",
  T_40_XXJ_WS_CONTENTORIGIN_DESCKEY: "Contenido original",
  T_40_XXJ_WS_CONTENTORIGIN_NAMEKEY: "Dirección predeterminada",
  T_40_XXJ_WS_CONTENTORIGIN2_DESCKEY: "El punto de inicio del desplazamiento. Esquina superior izquierda por defecto.",
  T_40_XXJ_WS_CREATEMAPBITENTITY_DESCKEY: "Genera un píxel estático para un determinado objeto del mapa. El píxel no se moverá con el objeto.",
  T_40_XXJ_WS_CREATEMAPICONENTITY_DESCKEY: "Crear un icono de minimapa",
  T_40_XXJ_WS_CREATETIMESTAMPLOCSTRING_DESCKEY: "Definir una cadena localizada para un periodo de tiempo",
  T_40_XXJ_WS_CREATEUIWIDGET_D: "Crear un componente personalizado de la interfaz de usuario en el HUD personalizado designado y en el componente principal",
  T_40_XXJ_WS_CREEP_NAMEKEY: "Arrastrarse",
  T_40_XXJ_WS_CROUCH_DESCKEY: "Mostrar cuando es verdadero, si no, cerrado",
  T_40_XXJ_WS_CROUCH_NAMEKEY: "Agacharse",
  T_40_XXJ_WS_CULLINGMASK_DESCKEY: "Esta es la capa de renderizado de la máscara culling de la cámara. Puede filtrar la entidad de renderizado utilizando el nivel de la capa visible.",
  T_40_XXJ_WS_CULLINGMASK_NAMEKEY: "Máscara Culling",
  T_40_XXJ_WS_CUSTOMCLOTHCHESTID_DESCKEY: "El ID de la parte superior",
  T_40_XXJ_WS_CUSTOMCLOTHCHESTID_NAMEKEY: "Superior",
  T_40_XXJ_WS_CUSTOMCLOTHFACEID_DESCKEY: "Maquillaje ID",
  T_40_XXJ_WS_CUSTOMCLOTHFEETID_DESCKEY: "El ID de los zapatos",
  T_40_XXJ_WS_CUSTOMCLOTHFEETID_NAMEKEY: "Zapatos",
  T_40_XXJ_WS_CUSTOMCLOTHHAIRID_DESCKEY: "El ID de la cabeza",
  T_40_XXJ_WS_CUSTOMCLOTHHAIRID_NAMEKEY: "Cabeza",
  T_40_XXJ_WS_CUSTOMCLOTHHEADADDITIVEID_DESCKEY: "El ID del maquillaje",
  T_40_XXJ_WS_CUSTOMCLOTHHEADADDITIVEID_NAMEKEY: "Máscara",
  T_40_XXJ_WS_CUSTOMCLOTHLEGSID_DESCKEY: "El ID de la parte inferior",
  T_40_XXJ_WS_CUSTOMCLOTHLEGSID_NAMEKEY: "Inferior",
  T_40_XXJ_WS_CUSTOMCLOTHMAKEUP_NAMEKEY: "Maquillaje",
  T_40_XXJ_WS_CUSTOMCLOTHSETID_DESCKEY: "El ID del paquete",
  T_40_XXJ_WS_CUSTOMCLOTHSETID_NAMEKEY: "Mono",
  T_40_XXJ_WS_CUSTOMXY_DESCKEY: "La cantidad de arrastre en la dirección xy",
  T_40_XXJ_WS_CUSTOMXY_NAMEKEY: "Arrastre XY",
  T_40_XXJ_WS_DB: "Leer valor de tabla",
  T_40_XXJ_WS_DB_DESC: "Leer el valor correspondiente de un determinado identificador en una determinada tabla de la base de datos.",
  T_40_XXJ_WS_DBDELETE_DESC: "Elimina un valor correspondiente de un determinado identificador en una determinada tabla de la base de datos.",
  T_40_XXJ_WS_DBKEY_DESCKEY: "Nombre personalizado usado para identificar los datos",
  T_40_XXJ_WS_DBKEY_NAMEKEY: "Identificador",
  T_40_XXJ_WS_DBTABLENAME: "Nombre de la tabla de la base de datos",
  T_40_XXJ_WS_DBTABLENAME_DESC: "El nombre de una tabla de una base de datos",
  T_40_XXJ_WS_DBVALUE_DESCKEY: "El valor a escribir",
  T_40_XXJ_WS_DBWRITE: "Escribir valor de tabla",
  T_40_XXJ_WS_DBWRITE_DESC: "Escribe el valor correspondiente de un determinado identificador en una determinada tabla de la base de datos.",
  T_40_XXJ_WS_DEFENCEGRENADE_NAMEKEY: "Defensa de lanzables",
  T_40_XXJ_WS_DEFULT: "Por defecto",
  T_40_XXJ_WS_DELETELEADERBOARD_DESC: "Elimina el valor correspondiente de una determinada clave en una determinada tabla de clasificación de la base de datos.",
  T_40_XXJ_WS_DELETELEADERBOARD2_DESC: "Elimina el valor correspondiente a un determinado rango en una tabla de clasificación concreta de la base de datos.",
  T_40_XXJ_WS_DEPTH: "Capa de HUD",
  T_40_XXJ_WS_DEPTH_D: "La capa básica del HUD",
  T_40_XXJ_WS_DICTANDLIST: "Lista y Diccionario",
  T_40_XXJ_WS_DICVALUE_DESCKEY: "El valor del diccionario objetivo",
  T_40_XXJ_WS_DIFFUSEALPHA_DESCKEY: "La transparencia de la superficie",
  T_40_XXJ_WS_DIR_DESCKEY: "Vector",
  T_40_XXJ_WS_DIRECTPOSVEC3_DESCKEY: "Un punto que se proporciona y se puede utilizar como puntos de resurrección, etc.",
  T_40_XXJ_WS_DIRECTPOSVEC3_NAMEKEY: "Coordenadas",
  T_40_XXJ_WS_DISABLEALL: "Desmarcar todo",
  T_40_XXJ_WS_DISABLECOLOR_NAMEKEY: "Color desactivado",
  T_40_XXJ_WS_DISTANT_DESCKEY: "La distancia de la línea de detección de la cámara",
  T_40_XXJ_WS_DISTANT_NAMEKEY: "Distancia de proyección",
  T_40_XXJ_WS_DRAGEFFECT_DESCKEY: "Admite varias direcciones de arrastre",
  T_40_XXJ_WS_DRAGEFFECT_NAMEKEY: "Efecto de arrastre",
  T_40_XXJ_WS_DRIVER_DESCKEY: "El conductor del vehículo",
  T_40_XXJ_WS_DRIVER_NAMEKEY: "Conductor",
  T_40_XXJ_WS_EDITVALUE_DESCKEY: "Modifica un valor",
  T_40_XXJ_WS_EFFECTACTIVE_DESCKEY: "Mostrar efectos especiales",
  T_40_XXJ_WS_EFFECTACTIVE_NAMEKEY: "Mostrar efectos especiales",
  T_40_XXJ_WS_EFFECTCOLOR_NAMEKEY: "Efectos de color",
  T_40_XXJ_WS_EFFECTENTITY_DESCKEY: "La entidad de efectos especiales representa el efecto especial que se mostrará",
  T_40_XXJ_WS_EFFECTENTITYGENERATOR_DESCKEY: "El objeto de efectos especiales",
  T_40_XXJ_WS_EMOTIONHUD_NAMEKEY: "Interruptor Emoji HUD",
  T_40_XXJ_WS_ENABLEALL: "Marcar todo",
  T_40_XXJ_WS_ENABLELOGIC_DESCKEY: "Si se activa la actualización lógica. Cuando está desactivado, los bloques de esta entidad dejarán de actualizarse cada fotograma.",
  T_40_XXJ_WS_ENABLEWEAPONSKINPROP_DESCKEY: "Cuando se escriba en los atributos del arma, las estadísticas básicas del arma se verán afectadas por el aspecto de arma.",
  T_40_XXJ_WS_ENABLEWEAPONSKINPROP_NAMEKEY: "Escribir atributo del aspecto de arma",
  T_40_XXJ_WS_ENTITY_DESCKEY: "Una entidad es un recipiente que contiene todos los componentes, que deben añadirse a las entidades para poder activarse",
  T_40_XXJ_WS_ENTITY_NAMEKEY: "Tipo de entidad",
  T_40_XXJ_WS_ENTITY1_DESCKEY: "El componente básico de una entidad. Todos los componentes combinarán este componente.",
  T_40_XXJ_WS_ENTITYVARNAME_DESCKEY: "La entidad a transformar en",
  T_40_XXJ_WS_ENTITYVARNAME11_DESCKEY: "El nombre del parámetro utilizado en el código para representar la entidad del control de IU personalizado recién añadido. Su valor de variable local correspondiente es la entidad del control de IU personalizado recién añadido.",
  T_40_XXJ_WS_ENTITYVARNAME12_DESCKEY: "El nombre de la variable de entidad",
  T_40_XXJ_WS_ENTITYVARNAME13_DESCKEY: "El nombre del parámetro utilizado en el código para representar la entidad del icono creado. Su valor de variable local correspondiente es la entidad del icono creado.",
  T_40_XXJ_WS_EPITEMHUD_NAMEKEY: "Barra EP Interruptor HUD",
  T_40_XXJ_WS_EULERANGLES_DESCKEY: "Ángulos de Euler",
  T_40_XXJ_WS_FACINFECTION: "Facción (Apocalipsis Androide)",
  T_40_XXJ_WS_FACINFECTION_DESC: "Facción del jugador. 1 = Humano, 2= Androide",
  T_40_XXJ_WS_FEMALE: "Femenino",
  T_40_XXJ_WS_FILLDIRECTION_DESCKEY: "Dirección de llenado",
  T_40_XXJ_WS_FILLDIRECTION_NAMEKEY: "Dirección de clasificación",
  T_40_XXJ_WS_FIRE_NAMEKEY: "Fuego",
  T_40_XXJ_WS_FLOATVALUE_DESCKEY: "El valor del flotador",
  T_40_XXJ_WS_FOLLOWTARGET_DESCKEY: "La entidad de destino a seguir. Vacía por defecto.",
  T_40_XXJ_WS_FONTSIZE_DESCKEY: "El tamaño del texto",
  T_40_XXJ_WS_FONTSIZE_NAMEKEY: "Tamaño de letra",
  T_40_XXJ_WS_FONTSTYLE_DESCKEY: "El estilo de la letra",
  T_40_XXJ_WS_FOOTBALLGLOOWALL: "Pared Gloo de Fútbol",
  T_40_XXJ_WS_FORMATSTYLE_DESCKEY: "El estilo de formato",
  T_40_XXJ_WS_FORWARD_DESCKEY: "La dirección del jugador",
  T_40_XXJ_WS_FORWARD1_DESCKEY: "La dirección de la teletransportación",
  T_40_XXJ_WS_FREE_DESCKEY: "Una cámara controlable por el jugador y que puede moverse libremente",
  T_40_XXJ_WS_FREE_NAMEKEY: "Cámara 360°",
  T_40_XXJ_WS_GENDER: "Género",
  T_40_XXJ_WS_GENDER_DESCKEY: "Género",
  T_40_XXJ_WS_GENDERTYPE_DESCKEY: "Género",
  T_40_XXJ_WS_GETCAMERACULLINGMASK_DESCKEY: "Obtiene la máscara culling de la cámara",
  T_40_XXJ_WS_GETCHILDBYINDEX_DESCKEY: "Solo admite entidades que tengan el componente Transformar. Actualmente restringido a todos los objetos.",
  T_40_XXJ_WS_GETCHILDREN_DESCKEY: "Solo admite entidades que tengan el componente Transformar. Actualmente restringido a todos los objetos.",
  T_40_XXJ_WS_GETPARENT_DESCKEY: "Solo admite entidades que tengan el componente Transformar. Actualmente restringido a todos los objetos.",
  T_40_XXJ_WS_GETPLAYERCLOTHIDBYWARDROBETYPE_DESCKEY: "Obtiene el ID del atuendo del jugador",
  T_40_XXJ_WS_GETPLAYERRANK: "Obtener rango de jugador",
  T_40_XXJ_WS_GETPLAYERRANK_D: "Obtener rango total de un jugador",
  T_40_XXJ_WS_GETPLAYERROUNDRANK: "Obtener rango de ronda de un jugador",
  T_40_XXJ_WS_GETPLAYERROUNDRANK_D: "Obtener rango de ronda de un jugador específico",
  T_40_XXJ_WS_GETPLAYERTOKENNUM_DESCKEY: "Búsqueda de datos del token del jugador",
  T_40_XXJ_WS_GETPLAYERWEAPONSKINIDBYWEAPONID_DESCKEY: "Obtiene el aspecto de arma del jugador",
  T_40_XXJ_WS_GETRANDOMSPAWNPOSVEC3_DESCKEY: "Obtiene un conjunto de coordenadas que no haya sido ocupado por puntos de inicio aleatorios.",
  T_40_XXJ_WS_GETSCENESKYBOX_DESCKEY: "Obtiene la caja del cielo de un escenario",
  T_40_XXJ_WS_GETSERVERREGION_DESCKEY: "Obtiene la región del servidor",
  T_40_XXJ_WS_GETSERVERTIME_DESCKEY: "Obtener la fecha y hora de un servidor",
  T_40_XXJ_WS_GETTEAMMATENEARPOSVEC3_DESCKEY: "Obtiene una ubicación cerca del compañero de equipo, evitando zonas en las que los jugadores no puedan permanecer de pie.",
  T_40_XXJ_WS_GETTEAMRANK: "Obtener rango de equipo",
  T_40_XXJ_WS_GETTEAMRANK_D: "Obtener rango total de equipo",
  T_40_XXJ_WS_GETTEAMROUNDRANK: "Obtener rango de ronda de un equipo",
  T_40_XXJ_WS_GETTEAMROUNDRANK_D: "Obtener rango de ronda de un equipo específico",
  T_40_XXJ_WS_GREEN: "Verde",
  T_40_XXJ_WS_HALFEXTENTS_DESCKEY: "La mitad de las dimensiones de una forma tridimensional",
  T_40_XXJ_WS_HEAD_DESCKEY: "Cabeza",
  T_40_XXJ_WS_HEAD_NAMEKEY: "Cabeza",
  T_40_XXJ_WS_HEARTBEATEFFECTHUD_DESCKEY: "La entidad del efecto de latido",
  T_40_XXJ_WS_HEARTBEATEFFECTHUD_NAMEKEY: "Entidad de efecto de latido",
  T_40_XXJ_WS_HEIGHT_DESCKEY: "La altura",
  T_40_XXJ_WS_HINTBUTTONHUD_DESCKEY: "Botón de pista",
  T_40_XXJ_WS_HINTBUTTONHUD_NAMEKEY: "Botón de consejos",
  T_40_XXJ_WS_HITPOINTEFFECT_DESCKEY: "La entidad que se mostrará en la ubicación de destino",
  T_40_XXJ_WS_HITPOINTEFFECT_NAMEKEY: "Entidad objetivo",
  T_40_XXJ_WS_HITPOS_DESCKEY: "El punto que se golpea",
  T_40_XXJ_WS_HORIZONTALBAR_DESCKEY: "El tipo de visualización horizontal",
  T_40_XXJ_WS_HORIZONTALBAR_NAMEKEY: "Tipo de visualización horizontal",
  T_40_XXJ_WS_HOSTENTITYFOLLOW_DESCKEY: "La entidad que sigue a otra entidad",
  T_40_XXJ_WS_HOSTENTITYLOOK_DESCKEY: "La entidad que mira a otra entidad",
  T_40_XXJ_WS_HPITEMHUD_NAMEKEY: "Interruptor HUD de la barra de salud",
  T_40_XXJ_WS_HUDEMPTYPANEL_DESCKEY: "La entidad de inserción del HUD. Es el HUD que los jugadores modifican desde el editor.",
  T_40_XXJ_WS_HUDEMPTYPANEL_NAMEKEY: "Componente vacío del panel HUD",
  T_40_XXJ_WS_HUDENTITY_DESCKEY: "La entidad HUD a la que pertenece",
  T_40_XXJ_WS_HUDGRID_DESCKEY: "La entidad de inserción del HUD. Es el HUD que el jugador edita utilizando el editor.",
  T_40_XXJ_WS_HUDGRID_NAMEKEY: "Componente de cuadrícula HUD",
  T_40_XXJ_WS_HUDPANEL_DESCKEY: "La entidad de inserción del HUD. Es el HUD que el jugador edita utilizando el editor.",
  T_40_XXJ_WS_HUDPANEL_NAMEKEY: "Componente del panel HUD",
  T_40_XXJ_WS_HUDSCROLLVIEW_DESCKEY: "La entidad de inserción del HUD. Es el HUD que el jugador edita utilizando el editor.",
  T_40_XXJ_WS_HUDSCROLLVIEW_NAMEKEY: "Componente de vista de desplazamiento HUD",
  T_40_XXJ_WS_HUMANMODELID_NAMEKEY: "ID del modelo humano",
  T_40_XXJ_WS_ICON_DESCKEY: "Nombre del recurso del icono",
  T_40_XXJ_WS_ICON_NAMEKEY: "Ícono",
  T_40_XXJ_WS_ICON1_DESCKEY: "Selecciona un icono",
  T_40_XXJ_WS_ICONENTITY_DESCKEY: "La entidad icono representa el icono que se mostrará",
  T_40_XXJ_WS_ICONPATH_DESCKEY: "Una ruta de recurso. El recurso incorporado es in:path. El recurso personalizado es out:path. Vacío por defecto.",
  T_40_XXJ_WS_ICONSPRITENAME_DESCKEY: "Nombre del icono",
  T_40_XXJ_WS_ICONSPRITENAME_NAMEKEY: "Nombre del icono",
  T_40_XXJ_WS_ICONTYPE_DESCKEY: "La ruta del recurso. Vacía por defecto.",
  T_40_XXJ_WS_INCLUDETRIGGER_DESCKEY: "Si puede escanear desencadenantes",
  T_40_XXJ_WS_INDEX_DESCKEY: "El índice del niño bajo el padre",
  T_40_XXJ_WS_INITIALVALUE_NAMEKEY: "Valor inicial [0, 1]",
  T_40_XXJ_WS_INTVALUE_DESCKEY: "El valor del entero",
  T_40_XXJ_WS_IS3D: "Efecto de sonido 3D",
  T_40_XXJ_WS_ISBILLBOARD_DESCKEY: "Siempre de cara a la cámara",
  T_40_XXJ_WS_ISBOLD_NAMEKEY: "Negrita",
  T_40_XXJ_WS_ISBYORDER_D: "Detectar si los jugadores deben activar los objetos del nivel en orden cronológico",
  T_40_XXJ_WS_ISFEBUTTON_NAMEKEY: "Botón FirEditor",
  T_40_XXJ_WS_ISHIT_DESCKEY: "Si la línea de la cámara ha alcanzado la entidad",
  T_40_XXJ_WS_ISINCULLINGMASK_DESCKEY: "Si es visible para una capa determinada",
  T_40_XXJ_WS_ISITALIC_NAMEKEY: "Itálica",
  T_40_XXJ_WS_ISSHOWSCAN_DESCKEY: "Si está marcado por escáner",
  T_40_XXJ_WS_ISSHOWSCAN_NAMECKEY: "Escaneado o no",
  T_40_XXJ_WS_ISSHOWTAG_DESCKEY: "Si está marcado con el botón de pin",
  T_40_XXJ_WS_ISTRIGGER: "Activador",
  T_40_XXJ_WS_ISUNDERLINE_NAMEKEY: "Subrayado",
  T_40_XXJ_WS_ITEMID_DESCKEY: "ID del objeto correspondiente a la entidad",
  T_40_XXJ_WS_ITEMID_NAMEKEY: "ID del objeto",
  T_40_XXJ_WS_ITEMID1_DESCKEY: "El ID del objeto (solo el ID del arma está disponible en la versión actual)",
  T_40_XXJ_WS_ITEMID2_DESCKEY: "El ID del arma",
  T_40_XXJ_WS_ITEMID3_DESCKEY: "ID del objeto",
  T_40_XXJ_WS_JAILBREAKAREA_DESCKEY: "Área Metropolitana",
  T_40_XXJ_WS_JAILBREAKAREA_NAMEKEY: "Área Metropolitana",
  T_40_XXJ_WS_JUMP_NAMEKEY: "Salto",
  T_40_XXJ_WS_KEY_DESCKEY: "El valor de la clave",
  T_40_XXJ_WS_KEY_NAMEKEY: "Clave",
  T_40_XXJ_WS_KEYNAME_DESCKEY: "El nombre de la llave a recorrer. Se puede utilizar para obtener el valor de una llave en una variable local.",
  T_40_XXJ_WS_KILLINGTIPS_NAMEKEY: "Anuncio de eliminación",
  T_40_XXJ_WS_LABELCOLOR_NAMEKEY: "Color de texto",
  T_40_XXJ_WS_LANDMINEOBJ: "Entidad tras la creación de la mina terrestre",
  T_40_XXJ_WS_LAYERMASK_DESCKEY: "La máscara de la capa de colisión. Las capas no seleccionadas no se incluirán en el escaneado. Si está vacía, todas las capas se incluirán en el escaneado.",
  T_40_XXJ_WS_LAYERSEDIT: "Editar capas",
  T_40_XXJ_WS_LAYERSETTING: "Ajustes de capa visible",
  T_40_XXJ_WS_LAYERTYPE_DESCKEY: "La capa de colisión de la detección de líneas de cámara",
  T_40_XXJ_WS_LAYERTYPE_NAMEKEY: "Capa",
  T_40_XXJ_WS_LAYOUTTYPE_DESCKEY: "Tipo de diseño",
  T_40_XXJ_WS_LAYOUTTYPE_NAMEKEY: "Tipo de diseño",
  T_40_XXJ_WS_LEADERBOARDBUTTONHUD: "Componente HUD de la puntuación",
  T_40_XXJ_WS_LEADERBOARDBUTTONHUD_D: "La entidad HUD del marcador. Modificar las propiedades de la entidad afectará el contenido que se mostrará en la interfaz de usuario correspondiente",
  T_40_XXJ_WS_LEADERBOARDNAME: "Nombre de la tabla de clasificación",
  T_40_XXJ_WS_LEADERBOARDNAME_DESC: "El nombre de la tabla de clasificación en la base de datos.",
  T_40_XXJ_WS_LEAVEACCELERATION_DESCKEY: "La aceleración del balanceo",
  T_40_XXJ_WS_LEAVEACCELERATION_NAMEKEY: "Dejar la aceleración",
  T_40_XXJ_WS_LEFTARM_DESCKEY: "Brazo izquierdo",
  T_40_XXJ_WS_LEFTARM_NAMEKEY: "Brazo izquierdo",
  T_40_XXJ_WS_LEFTCOLOR_DESCKEY: "El color izquierdo",
  T_40_XXJ_WS_LEFTCOLOR_NAMEKEY: "Color izquierdo",
  T_40_XXJ_WS_LEFTEFFECTACTIVE_DESCKEY: "Mostrar o no los efectos especiales a la izquierda",
  T_40_XXJ_WS_LEFTEFFECTACTIVE_NAMEKEY: "Mostrar o no el efecto de la izquierda",
  T_40_XXJ_WS_LEFTFOOT_DESCKEY: "Pie izquierdo",
  T_40_XXJ_WS_LEFTFOOT_NAMEKEY: "Pie izquierdo",
  T_40_XXJ_WS_LEFTHAND_DESCKEY: "Mano izquierda",
  T_40_XXJ_WS_LEFTHAND_NAMEKEY: "Mano izquierda",
  T_40_XXJ_WS_LEFTICON_DESCKEY: "Icono izquierdo",
  T_40_XXJ_WS_LEFTICON_NAMEKEY: "Icono izquierdo",
  T_40_XXJ_WS_LEFTLEG_DESCKEY: "Pierna izquierda",
  T_40_XXJ_WS_LEFTLEG_NAMEKEY: "Pierna izquierda",
  T_40_XXJ_WS_LEFTSCORETEXT_DESCKEY: "Texto de puntuación izquierdo",
  T_40_XXJ_WS_LEFTSCORETEXT_NAMEKEY: "Texto de puntuación izquierdo",
  T_40_XXJ_WS_LEFTTEXT_DESCKEY: "Texto izquierdo",
  T_40_XXJ_WS_LEFTTEXT_NAMEKEY: "Texto izquierdo",
  T_40_XXJ_WS_LERP_DESCKEY: 't está comprendido entre 0 y 1. Cuando t=0, devuelve "desde". Cuando t=1, devuelve "a". Cuando t=0,5, devuelve la media de los valores de "desde" y "hasta".',
  T_40_XXJ_WS_LEVELOBJECT: "Objeto de etapa",
  T_40_XXJ_WS_LINESPACING_NAMEKEY: "Espacio entre líneas",
  T_40_XXJ_WS_LISTFINDMAX_DESCKEY: "Compara los valores de una lista y devuelve el mayor",
  T_40_XXJ_WS_LISTFINDMIN_DESCKEY: "Compara los valores de una lista y devuelve el más pequeño",
  T_40_XXJ_WS_LISTORMAP_NAMEKEY: "Lista o Diccionario",
  T_40_XXJ_WS_LOCALPOSITION: "Posición local",
  T_40_XXJ_WS_LOCALROTA: "Ángulos de Euler locales",
  T_40_XXJ_WS_LOCALROTATIONQ: "Rotación local de cuaterniones",
  T_40_XXJ_WS_LOCALSACLE: "Escala local",
  T_40_XXJ_WS_LOCSWITCH_NAMEKEY: "Interruptor de localización",
  T_40_XXJ_WS_LOOPRANGE_DESCKEY: "El contenedor a atravesar",
  T_40_XXJ_WS_MALE: "Masculino",
  T_40_XXJ_WS_MAPCLEAR_DESCKEY: "Eliminar el diccionario",
  T_40_XXJ_WS_MAPGETLENGTH_DESCKEY: "Obtiene la longitud del diccionario",
  T_40_XXJ_WS_MAPGETVALUE_DESCKEY: "Obtiene el valor de la clave designada en el elemento del diccionario",
  T_40_XXJ_WS_MAPREMOVEVALUE_DESCKEY: "Elimina el par clave-valor designado en el diccionario",
  T_40_XXJ_WS_MAPSETVALUE_DESCKEY: "Configura el valor de una clave designada en el diccionario",
  T_40_XXJ_WS_MAPSIZE_DESCKEY: "El tamaño del minimapa. Su anchura y altura son iguales.",
  T_40_XXJ_WS_MAPSIZE_NAMEKEY: "Tamaño del mapa",
  T_40_XXJ_WS_MAPT: "Plantilla de diccionario",
  T_40_XXJ_WS_MAPT_D: "El modelo de datos para dict. Puede designar el tipo de contenido mediante T1 y T2.",
  T_40_XXJ_WS_MAPVALUE_D: "Un contenedor de datos para el diccionario. El elemento es un par que consta de una clave y un valor.",
  T_40_XXJ_WS_MAPVALUE_DESCKEY: "El diccionario de destino",
  T_40_XXJ_WS_MAPVALUE_NAMEKEY: "Dict",
  T_40_XXJ_WS_MASKNAME_DESCKEY: "El tipo de máscara es el nombre de la imagen que se utiliza al enmascarar",
  T_40_XXJ_WS_MASKNAME_NAMEKEY: "Nombre de la máscara",
  T_40_XXJ_WS_MASS_DESCKEY: "Masa (en kg)",
  T_40_XXJ_WS_MASS_NAMEKEY: "Masa (en kg)",
  T_40_XXJ_WS_MAX_DESCKEY: "Compara 2 valores y devuelve el mayor",
  T_40_XXJ_WS_MAXLENGTH_NAMEKEY: "Longitud máxima",
  T_40_XXJ_WS_MAXNUM_DESCKEY: "El valor máximo",
  T_40_XXJ_WS_MAXWIDGETID_DESCKEY: "El ID del mayor componente",
  T_40_XXJ_WS_MAXWIDGETID_NAMEKEY: "ID del complemento máximo",
  T_40_XXJ_WS_MEDICALPROPSHUD_NAMEKEY: "Artículos curativos",
  T_40_XXJ_WS_MIN_DESCKEY: "Compara 2 valores y devuelve el menor",
  T_40_XXJ_WS_MINIMAP_NAMEKEY: "Componente del minimapa",
  T_40_XXJ_WS_MINIMAPBIT_NAMEKEY: "Píxel del minimapa",
  T_40_XXJ_WS_MINIMAPICON_NAMEKEY: "Icono del minimapa",
  T_40_XXJ_WS_MINMAPHUD_NAMEKEY: "Minimapa",
  T_40_XXJ_WS_MINNUM_DESCKEY: "El valor mínimo",
  T_40_XXJ_WS_MOMENTUMAMOUNT_DESCKEY: "El factor del impulso. Cuanto mayor sea el valor, mayor será el impulso durante el desplazamiento.",
  T_40_XXJ_WS_MOMENTUMAMOUNT_NAMEKEY: "Factor de impulso",
  T_40_XXJ_WS_MOVINGJOYSTICK_NAMEKEY: "Joystick de movimiento",
  T_40_XXJ_WS_MRESULT_DESCKEY: "Resultado de la partida",
  T_40_XXJ_WS_NEWENTITY_D: "La nueva entidad de objeto después de ser creada",
  T_40_XXJ_WS_NEWMAP_DESCKEY: "Crea un nuevo diccionario",
  T_40_XXJ_WS_NEWMAP_NAMEKEY: "Nuevo dict",
  T_40_XXJ_WS_NORMAL1_DESCKEY: "Lo normal del golpe",
  T_40_XXJ_WS_NORMALIZEDPOSITION_DESCKEY: "Posición HUD [0,1]",
  T_40_XXJ_WS_NORMALIZEDPOSITION_NAMEKEY: "Posición HUD",
  T_40_XXJ_WS_NUMLIST_DESCKEY: "La lista para convertir índices en números",
  T_40_XXJ_WS_OBJECT_DESCKEY: "El objeto que el arma en spray golpea",
  T_40_XXJ_WS_OBSOLETE: "Eliminado, por razones de seguridad, sustituye este bloque.",
  T_40_XXJ_WS_OFFSET_DESCKEY: "La posición de visualización. Cuando hay un objetivo seguido, es el desplazamiento entre la nueva posición y la posición original. Cuando no hay un objetivo seguido, son las coordenadas de la pantalla (por defecto es Vector3(0)).",
  T_40_XXJ_WS_OFFSET2_DESCKEY: "Las coordenadas de la pantalla (por defecto es Vector3(0)).",
  T_40_XXJ_WS_OFFSET3_DESCKEY: "La posición de visualización. Cuando hay un objetivo seguido, es el desplazamiento entre la nueva posición y la posición original. Cuando no hay un objetivo seguido, son las coordenadas de la pantalla (por defecto es Vector3(0)).",
  T_40_XXJ_WS_OFFSET4_DESCKEY: "Posición de la pantalla (el ancla está en la esquina superior derecha)",
  T_40_XXJ_WS_OFFSETLEFTRIGHT_DESCKEY: "Desplazamiento horizontal",
  T_40_XXJ_WS_OFFSETLEFTRIGHT_NAMEKEY: "Desplazamiento horizontal",
  T_40_XXJ_WS_OFFSETUPDOWN_DESCKEY: "El desplazamiento vertical",
  T_40_XXJ_WS_OFFSETUPDOWN_NAMEKEY: "Desplazamiento vertical",
  T_40_XXJ_WS_OK_DESCKEY: "Conversión con éxito",
  T_40_XXJ_WS_ONAISTARTATTACK_DESCKEY: "Dispara este evento cuando la entidad entra en las inmediaciones del ataque",
  T_40_XXJ_WS_ONAISTARTCHASE_DESCKEY: "Activa este evento cuando la entidad entra en las inmediaciones de la persecución",
  T_40_XXJ_WS_ONAISTOPATTACK_DESCKEY: "Activa este evento cuando la entidad abandona las inmediaciones del ataque",
  T_40_XXJ_WS_ONAISTOPCHASE_DESCKEY: "Activa este evento cuando la entidad abandona las inmediaciones de la persecución",
  T_40_XXJ_WS_ONCLIENTCAMERARAYCAST_DESCKEY: "Activa una detección de línea de cámara a través del cliente",
  T_40_XXJ_WS_ONCOLLISION_D: "Solo las entidades con el componente Colisionador adjunto admiten este evento",
  T_40_XXJ_WS_ONSPRAYENTITY_DESCKEY: "Activa este evento cuando el arma en spray golpea una entidad",
  T_40_XXJ_WS_ONSTOPFIRE_DESCKEY: "Cuando se detiene el disparo",
  T_40_XXJ_WS_ONSWITCHPLAYERAREA_DESCKEY: "Cuando un jugador cambia la zona del escenario",
  T_40_XXJ_WS_OPENSTATE_DESCKEY: "Mostrar cuando el estatus abierto es verdadero, en caso contrario cerrado",
  T_40_XXJ_WS_OPENSTATE_NAMEKEY: "Estatus abierto",
  T_40_XXJ_WS_ORANGE: "Naranja",
  T_40_XXJ_WS_ORDER_DESC: "La posición en la clasificación",
  T_40_XXJ_WS_ORDER1: "Rango inicial",
  T_40_XXJ_WS_ORDER2: "Rango final",
  T_40_XXJ_WS_ORIGINAL: "Mantener la lógica original",
  T_40_XXJ_WS_OVERFLOW_NAMEKEY: "Método de desbordamiento",
  T_40_XXJ_WS_OVERLOADPLAYERWEAPONSKIN_DESCKEY: "Cuando se priorizan, los atributos del arma del jugador sustituyen a los atributos originales del arma.",
  T_40_XXJ_WS_OVERLOADPLAYERWEAPONSKIN_NAMEKEY: "Priorizar el aspecto del arma del jugador",
  T_40_XXJ_WS_OWNER_DESCKEY: "El jugador propietario de esta entidad",
  T_40_XXJ_WS_OWNERSUBLEVELGUID_DESCKEY: "El ID global del escenario infantil al que pertenece",
  T_40_XXJ_WS_OWNERSUBLEVELGUID_NAMEKEY: "ID del escenario infantil",
  T_40_XXJ_WS_PARENT_DESCKEY: "Entidad del padre",
  T_40_XXJ_WS_PARENT_NAMEKEY: "Padre",
  T_40_XXJ_WS_PARENTENTITYID_NAMEKEY: "ID de la entidad componente de padres",
  T_40_XXJ_WS_PARENTWIDGETFILEID_DESCKEY: "El ID de archivo del componente de padres",
  T_40_XXJ_WS_PASSENGERS_DESCKEY: "Todos los pasajeros del vehículo",
  T_40_XXJ_WS_PASSENGERS_NAMEKEY: "Pasajero",
  T_40_XXJ_WS_PHYSICALLAYER: "Capa Física",
  T_40_XXJ_WS_PHYSICALLAYERMATRIX: "Matriz de Capas Físicas",
  T_40_XXJ_WS_PHYSICALTIP1: "El nombre ya existe",
  T_40_XXJ_WS_PHYSICALTIP2: "Elimina el nombre de una capa y la hace invisible en la Matriz de Capas Físicas y en la Enumeración de Capas, pero los objetos entidad dentro de esa capa no se verán afectados.",
  T_40_XXJ_WS_PHYSICS: "Física",
  T_40_XXJ_WS_PICKUPLISTHUD_NAMEKEY: "Cambio de HUD de la lista de botín",
  T_40_XXJ_WS_PLAYABLE_DESCKEY: "Una entidad jugable",
  T_40_XXJ_WS_PLAYABLELOOKAT_DESCKEY: "Una entidad siempre se enfrenta a otra entidad",
  T_40_XXJ_WS_PLAYABLEPOSFOLLOW_DESCKEY: "Una entidad sigue a otra",
  T_40_XXJ_WS_PLAYABLETRAJECTORY_DESCKEY: "La animación del camino de bala es una animación simulada de un camino de bala",
  T_40_XXJ_WS_PLAYER1_DESCKEY: "El jugador que recibirá el mensaje",
  T_40_XXJ_WS_PLAYERAVATAR_DESCKEY: "El avatar utilizado por el jugador",
  T_40_XXJ_WS_PLAYERAVATARINFO_DESCKEY: "El atuendo equipado por el jugador",
  T_40_XXJ_WS_PLAYERAVATARINFO_NAMEKEY: "Atuendo del jugador",
  T_40_XXJ_WS_PLAYERHUDSWITCHTYPE_DESCKEY: "El tipo HUD del jugador",
  T_40_XXJ_WS_PLAYERHUDSWITCHTYPE_NAMEKEY: "Tipo HUD del jugador",
  T_40_XXJ_WS_PLAYERIDINFAC: "N° de la facción",
  T_40_XXJ_WS_PLAYERLOG_DESCKEY: "El jugador que debe inscribirse en el registro",
  T_40_XXJ_WS_PLAYERREMOVETOKEN_DESCKEY: "Consume el token de un determinado jugador",
  T_40_XXJ_WS_PLAYERSKILLS_DESCKEY: "La lista de habilidades del jugador",
  T_40_XXJ_WS_PLAYERSTATETYPE_DESCKEY: "El estado de un jugador: vivo, derribado o eliminado.",
  T_40_XXJ_WS_PLAYSPEED_DESCKEY: "Velocidad de reproducción",
  T_40_XXJ_WS_PLAYSPEED_NAMEKEY: "Velocidad de reproducción",
  T_40_XXJ_WS_PLAYSPEED1_DESCKEY: "Por ejemplo, 1,25 significa un 25% más rápido que la velocidad original",
  T_40_XXJ_WS_POS_DESCKEY: "Las coordenadas de la teletransportación",
  T_40_XXJ_WS_PRESENTEFFECTTEXTYPE_DESCKEY: "El tipo de sticker con efectos especiales",
  T_40_XXJ_WS_PRESSEDCOLOR_NAMEKEY: "Color al presionar",
  T_40_XXJ_WS_PROCESSCTLFORLOOPRANGE_DESCKEY: "Ejecuta un recorrido de un contenedor para obtener el par clave-valor. Incluye un proceso bucle.",
  T_40_XXJ_WS_PROCESSCTLFORLOOPRANGE_NAMEKEY: "Visita al dict del bucle",
  T_40_XXJ_WS_PROGRESS_DESCKEY: "Progreso [0,1]",
  T_40_XXJ_WS_PROGRESS_NAMEKEY: "Progreso [0,1]",
  T_40_XXJ_WS_PROGRESSSKILLBUTTONHUD_DESCKEY: "El botón para el progreso de la habilidad",
  T_40_XXJ_WS_PROGRESSSKILLBUTTONHUD_NAMEKEY: "Botón de progreso de la habilidad",
  T_40_XXJ_WS_QUATERNION: "Rotación de cuaterniones",
  T_40_XXJ_WS_QUICKCHATHUD_NAMEKEY: "Interruptor de mensaje rápido HUD",
  T_40_XXJ_WS_QUICKCHATSHOWHUD_NAMEKEY: "Mensajes junto a la lista de equipos",
  T_40_XXJ_WS_RADIUS_DESCKEY: "El radio de los dos semicírculos de una forma de píldora",
  T_40_XXJ_WS_READCELL: "Leer una celda",
  T_40_XXJ_WS_READCSV: "Leer el contenido de la tabla",
  T_40_XXJ_WS_READCSV_DESC: "Lee el contenido de toda la tabla. Devuelve una matriz bidimensional.",
  T_40_XXJ_WS_READCSVCELL: "Lectura por número de fila y nombre de columna",
  T_40_XXJ_WS_READCSVCOL_DESC: "Lee el contenido de una determinada columna de la tabla. Devuelve una matriz.",
  T_40_XXJ_WS_READCSVROW_DESC: "Lee el contenido de una determinada fila de la tabla. Devuelve una matriz.",
  T_40_XXJ_WS_READLEADERBOARD: "Leer el valor de la tabla de clasificación",
  T_40_XXJ_WS_READLEADERBOARD_DESC: "Lee el valor correspondiente de un determinado identificador en una tabla de clasificación de la base de datos.",
  T_40_XXJ_WS_READLEADERBOARD2: "Leer por rango",
  T_40_XXJ_WS_READLEADERBOARD2_DESC: "Lee el valor de la diferencia entre un cierto rango a un cierto rango en la tabla de clasificación en una base de datos.",
  T_40_XXJ_WS_RED: "Rojo",
  T_40_XXJ_WS_RELOAD: "Recarga",
  T_40_XXJ_WS_RENDERTYPE_DESCKEY: "Método de visualización",
  T_40_XXJ_WS_RESETPLAYERCLOTHES_DESCKEY: "Restaura el atuendo predeterminado del jugador",
  T_40_XXJ_WS_RESETPLAYERWEAPONSKINBYWEAPONID_DESCKEY: "Restaura el aspecto de arma predeterminado",
  T_40_XXJ_WS_RESTRICTWITHINPANEL_DESCKEY: "Si el arrastre se limita a la ventana gráfica. Seleccionado por defecto.",
  T_40_XXJ_WS_RESTRICTWITHINPANEL_NAMEKEY: "Limitar o no el arrastre",
  T_40_XXJ_WS_RESULT_DESCKEY: "El resultado de la lectura",
  T_40_XXJ_WS_RESULT_NAMEKEY: "Resultado",
  T_40_XXJ_WS_RESULT1_DESCKEY: "Si se busca el número mayor de la lista",
  T_40_XXJ_WS_RESULT2_DESCKEY: "Si se busca el número menor de la lista",
  T_40_XXJ_WS_RESULTVALUE_DESCKEY: "Encontrar el número menor de una lista",
  T_40_XXJ_WS_RESULTVALUE1_DESCKEY: "Encontrar el número mayor de una lista",
  T_40_XXJ_WS_REVIVEPOSITIONVEC3_DESCKEY: "El punto de resurrección de un jugador. Si no hay puntos de control, usa un punto de inicio. Si no, usa puntos de control.",
  T_40_XXJ_WS_REVIVEPOSITIONVEC3_NAMEKEY: "Punto de Resurrección",
  T_40_XXJ_WS_RIGHTARM_DESCKEY: "Brazo derecho",
  T_40_XXJ_WS_RIGHTARM_NAMEKEY: "Brazo derecho",
  T_40_XXJ_WS_RIGHTCOLOR_DESCKEY: "El color derecho",
  T_40_XXJ_WS_RIGHTCOLOR_NAMEKEY: "Color derecho",
  T_40_XXJ_WS_RIGHTEFFECTACTIVE_DESCKEY: "Mostrar o no los efectos especiales a la derecha",
  T_40_XXJ_WS_RIGHTEFFECTACTIVE_NAMEKEY: "Mostrar el efecto derecho o no",
  T_40_XXJ_WS_RIGHTFOOT_DESCKEY: "Pie derecho",
  T_40_XXJ_WS_RIGHTFOOT_NAMEKEY: "Pie derecho",
  T_40_XXJ_WS_RIGHTHAND_DESCKEY: "Mano derecha",
  T_40_XXJ_WS_RIGHTHAND_NAMEKEY: "Mano derecha",
  T_40_XXJ_WS_RIGHTICON_DESCKEY: "Icono derecho",
  T_40_XXJ_WS_RIGHTICON_NAMEKEY: "Icono derecho",
  T_40_XXJ_WS_RIGHTLEG_DESCKEY: "Pierna derecha",
  T_40_XXJ_WS_RIGHTLEG_NAMEKEY: "Pierna derecha",
  T_40_XXJ_WS_RIGHTSCORETEXT_DESCKEY: "Texto de puntuación derecho",
  T_40_XXJ_WS_RIGHTSCORETEXT_NAMEKEY: "Texto de puntuación derecho",
  T_40_XXJ_WS_RIGHTTEXT_DESCKEY: "Texto derecho",
  T_40_XXJ_WS_RIGHTTEXT_NAMEKEY: "Texto derecho",
  T_40_XXJ_WS_RIGIDBODY_DESCKEY: "El componente del tipo de cuerpo rígido",
  T_40_XXJ_WS_RIGIDBODY_NAMEKEY: "Componente de cuerpo rígido",
  T_40_XXJ_WS_RIGIDBODYTYPE_DESCKEY: "La enumeración del tipo de cuerpo rígido",
  T_40_XXJ_WS_RIGIDBODYTYPE_NAMEKEY: "Enumeración del tipo de cuerpo rígido",
  T_40_XXJ_WS_ROW_DECS: "La fila que hay que leer",
  T_40_XXJ_WS_ROWVALUE: "Contenido de la fila",
  T_40_XXJ_WS_SCALE_DESCKEY: "Configura la escala de zoom del objeto",
  T_40_XXJ_WS_SCALE_NAMEKEY: "Escala",
  T_40_XXJ_WS_SCALE0_DESCKEY: "La escala de zoom de la serie de coordenadas en el mundo",
  T_40_XXJ_WS_SCALE1_DESCKEY: "La escala del zoom. 1 por defecto.",
  T_40_XXJ_WS_SCALECALUE_DESCKEY: "El valor de la escala",
  T_40_XXJ_WS_SCENENAME_DESCKEY: "El nombre del área",
  T_40_XXJ_WS_SCOREBARHUD_DESCKEY: "Barra de puntuación",
  T_40_XXJ_WS_SCOREBARHUD_NAMEKEY: "Barra de puntuación",
  T_40_XXJ_WS_SCROLLDIRECTION_DESCKEY: "Admite varias direcciones de desplazamiento",
  T_40_XXJ_WS_SCROLLDIRECTION_NAMEKEY: "Dirección de desplazamiento",
  T_40_XXJ_WS_SCROLLWHEELFACTOR_DESCKEY: "El factor de desplazamiento. Cuanto mayor sea el valor, más rápido será el desplazamiento.",
  T_40_XXJ_WS_SCROLLWHEELFACTOR_NAMEKEY: "Factor de desplazamiento",
  T_40_XXJ_WS_SETCAMERACULLINGMASK_DESCKEY: "Configura la máscara culling de la cámara",
  T_40_XXJ_WS_SETGLOBAL: "Establecer global",
  T_40_XXJ_WS_SETPARENT_D: "Sólo admite entidades que tengan el componente Transformar",
  T_40_XXJ_WS_SETPLAYERCLOTHIDBYWARDROBETYPE_DESCKEY: "Configura el ID del atuendo del jugador",
  T_40_XXJ_WS_SETPLAYERCLOTHIDS_DESCKEY: "Modificar los aspectos de varios jugadores",
  T_40_XXJ_WS_SETPLAYERFORWAR: "Establecer la dirección del jugador",
  T_40_XXJ_WS_SETPLAYERHUBSWITCH_DESCKEY: "Configura el interruptor HUD de un jugador",
  T_40_XXJ_WS_SETPLAYERWEAPONSKINIDBYWEAPONID_DESCKEY: "Configura el aspecto de arma del jugador",
  T_40_XXJ_WS_SHOWHITPOINTEFFECT_DESCKEY: "Si mostrar entidades en la ubicación de destino",
  T_40_XXJ_WS_SHOWHITPOINTEFFECT_NAMEKEY: "Mostrar entidad en el objetivo",
  T_40_XXJ_WS_SHOWPLAYER: "Mostrar entidad",
  T_40_XXJ_WS_SINGLELEADERBOARDHUD: "Detalles de la partida para un jugador entidad HUD",
  T_40_XXJ_WS_SINGLELEADERBOARDHUD_D: "Una entidad de HUD para partidas para un solo jugador. Modificar las propiedades de la entidad afectará el contenido que se muestra en la interfaz de usuario correspondiente",
  T_40_XXJ_WS_SIZEDELTA: "Tamaño delta de la caja de anclaje y el componente",
  T_40_XXJ_WS_SKELETON: "Esqueleto",
  T_40_XXJ_WS_SKELETON_D: "El pivote usado para acceder a la máscara del esqueleto",
  T_40_XXJ_WS_SKELETONPART_NAMEKEY: "Parte del esqueleto",
  T_40_XXJ_WS_SKILLBUTTONHUD: "Botón de habilidad entidad HUD",
  T_40_XXJ_WS_SLOT_DESCKEY: "El espacio de arma",
  T_40_XXJ_WS_SMOOTHDRAGSTART_DESCKEY: "Cuando esté seleccionado, se producirá un movimiento lento al arrastrar. Cuando no está seleccionado, el arrastre corresponde a la velocidad del ratón.",
  T_40_XXJ_WS_SMOOTHDRAGSTART_NAMEKEY: "Movimiento suave o no",
  T_40_XXJ_WS_SOFTNESS_DESCKEY: "Suavidad",
  T_40_XXJ_WS_SOFTNESS_NAMEKEY: "Suavidad",
  T_40_XXJ_WS_SOUNDNTITY_NAMEKEY: "Entidad de sonido",
  T_40_XXJ_WS_SPACE_DESCKEY: "Espacio",
  T_40_XXJ_WS_SPACE_NAMEKEY: "Espaciado entre celdas hijas",
  T_40_XXJ_WS_SPAWNPOSVEC3_DESCKEY: "Las coordenadas del punto de inicio de la IA",
  T_40_XXJ_WS_SPAWNPOSVEC3_NAMEKEY: "Coordenadas del punto de inicio",
  T_40_XXJ_WS_SPEED_DESCKEY: "Velocidad",
  T_40_XXJ_WS_SPEED_NAMEKEY: "Velocidad",
  T_40_XXJ_WS_SPEEDUP_NAMEKEY: "Aceleración",
  T_40_XXJ_WS_SPHERERADIUS_DESCKEY: "El radio de la esfera",
  T_40_XXJ_WS_SPRAYCOLOR_DESCKEY: "El color del spray",
  T_40_XXJ_WS_SPRAYCOLOR_NAMEKEY: "Color del spray",
  T_40_XXJ_WS_SPRAYRESULTHUD_DESCKEY: "El resultado del spray",
  T_40_XXJ_WS_SPRAYRESULTHUD_NAMEKEY: "Resultado del spray",
  T_40_XXJ_WS_SPRAYRIFLE_DESCKEY: "El arma en spray (rifle de asalto)",
  T_40_XXJ_WS_SPRAYRIFLE_NAMEKEY: "Rifle en Spray",
  T_40_XXJ_WS_SPRAYRIFLE_NAMEKEY_01: "Velocidad Inicial",
  T_40_XXJ_WS_SPRITEFLIP_NAMEKEY: "Voltear sticker",
  T_40_XXJ_WS_SPRITEID: "ID de activo sprite",
  T_40_XXJ_WS_SPRITEID_D: "El ID utilizado para describir el recurso del sprite",
  T_40_XXJ_WS_SPRITETYPE_NAMEKEY: "Tipo de sticker",
  T_40_XXJ_WS_STARGETENTITY_DESCKEY: "La entidad de destino para generar en un píxel estático",
  T_40_XXJ_WS_STARTPOSITION_D: "Las coordenadas del centro geométrico de la forma",
  T_40_XXJ_WS_STAY_D: "¿Mantener la posición actual del mundo, la rotación y la escala del niño? Generalmente se establece como verdadero, y los ajustes de interfaz no son efectivos para esta opción.",
  T_40_XXJ_WS_STRING_NAMEKEY: "Cadena",
  T_40_XXJ_WS_STRING2FLOAT_DESCKEY: "Convertir una cadena en un flotador",
  T_40_XXJ_WS_STRING2INT_DESCKEY: "Convertir una cadena en un número entero",
  T_40_XXJ_WS_STYLE_DESCKEY: "El método de reproducción de la interpolación. Las opciones incluyen reproducir una vez, bucle y reproducir de nuevo.",
  T_40_XXJ_WS_SWITCHPLAYERAREA_DESCKEY: "Cambiar la zona del jugador",
  T_40_XXJ_WS_SWITCHVALUE_DESCKEY: "Cambiar valor",
  T_40_XXJ_WS_SWITCHWEAPONBYSLOT_DESCKEY: "Cambia de arma según el espacio del jugador",
  T_40_XXJ_WS_SWITCHWEAPONEQUIPSLOT_DESCKEY: "Cambiar el espacio del objeto",
  T_40_XXJ_WS_SWITCHWEAPONEQUIPSLOT_NAMEKEY: "Interruptor de objetos",
  T_40_XXJ_WS_TABLENAME_DESC: "Se muestra como el nombre de la tabla, pero en realidad es el UID",
  T_40_XXJ_WS_TABLEVALUE: "Contenido de la tabla",
  T_40_XXJ_WS_TAGSLIST_DESCKEY: "La lista de etiquetas",
  T_40_XXJ_WS_TARGET_DESCKEY: "La entidad de destino para generar el píxel del mapa. Vacío por defecto.",
  T_40_XXJ_WS_TARGET_NAMEKEY: "Entidad para crear el píxel del mapa",
  T_40_XXJ_WS_TARGETATK_DESCKEY: "Atacar objetivo",
  T_40_XXJ_WS_TARGETENTITY_DESCKEY: "La entidad de destino",
  T_40_XXJ_WS_TARGETENTITY_NAMEKEY: "Entidad",
  T_40_XXJ_WS_TARGETENTITY1_DESCKEY: "La entidad en la que se encuentra la función personalizada",
  T_40_XXJ_WS_TARGETENTITYAPLAYER_DESCKEY: "La entidad atacada por la IA",
  T_40_XXJ_WS_TARGETENTITYFOLLOW_DESCKEY: "La entidad del objetivo a seguir",
  T_40_XXJ_WS_TARGETENTITYITEM_DESCKEY: "La entidad del objeto (puede estar vacía)",
  T_40_XXJ_WS_TARGETENTITYLOOK_DESCKEY: "La entidad de destino que hay que consultar",
  T_40_XXJ_WS_TARGETENTITYSOUND_DESCKEY: "La entidad de sonido en pausa",
  T_40_XXJ_WS_TARGETENTITYSOUND2_DESCKEY: "La entidad de sonido para reproducir después de la pausa",
  T_40_XXJ_WS_TARGETENTITYSOUND3_DESCKEY: "La entidad de sonido a eliminar",
  T_40_XXJ_WS_TEAMMATESINFO_NAMEKEY: "Información de compañeros de equipo",
  T_40_XXJ_WS_TELEPORTA_D: "Teletransporta al jugador a un punto designado con una dirección establecida",
  T_40_XXJ_WS_TEXT_NAMEKEY: "Texto del consejo",
  T_40_XXJ_WS_TEXTCOLOR_NAMEKEY: "Color del texto de notificación",
  T_40_XXJ_WS_TEXTENTITY_DESCKEY: "La entidad texto representa el texto que se mostrará",
  T_40_XXJ_WS_TEXTKEY_DESCKEY: "Las teclas de texto para visualizar",
  T_40_XXJ_WS_TEXTKEY_NAMEKEY: "Tecla de texto",
  T_40_XXJ_WS_TIMESTAMP_DESCKEY: "El periodo de tiempo",
  T_40_XXJ_WS_TIMESTAMPFORMATSTYLE_DESCKEY: "Estilo de visualización de una cadena localizada",
  T_40_XXJ_WS_TIMESTAMPFORMATSTYLE_NAMEKEY: "Estilo de visualización de la marca de tiempo",
  T_40_XXJ_WS_TIMESTAMPLOCSTRING_DESCKEY: "La cadena localizada para un periodo de tiempo",
  T_40_XXJ_WS_TIMESTAMPLOCSTRING_NAMEKEY: "Cadena localizada para un periodo de tiempo",
  T_40_XXJ_WS_TIPHUD_DESCKEY: "Pista",
  T_40_XXJ_WS_TIPHUD_NAMEKEY: "Consejo",
  T_40_XXJ_WS_TOKENCOUNT_DESCKEY: "La cantidad de objetos saqueables",
  T_40_XXJ_WS_TOKENID_DESCKEY: "El ID de un objeto saqueable",
  T_40_XXJ_WS_TOWSPEED_DESCKEY: "La velocidad de remolque de un jugador",
  T_40_XXJ_WS_TRANSITIONTYPE_NAMEKEY: "Tipo de traducción",
  T_40_XXJ_WS_TWEENENTITY_DESCKEY: "La entidad de animación de interpolación",
  T_40_XXJ_WS_TYPE_DESCKEY: 'Este es el tipo de la descripción. Uso de "tipo de" devolverá su tipo.',
  T_40_XXJ_WS_TYPE_NAMEKEY: "Tipo de cuerpo rígido",
  T_40_XXJ_WS_TYPE2_DESCKEY: "Diferentes tipos de cuerpos rígidos tienen funciones diferentes",
  T_40_XXJ_WS_TYPE3_DESCKEY: "La versión actual sólo admite las divisas básicas",
  T_40_XXJ_WS_USEDEPTHMAP_DESCKEY: "Activa o no la visualización de la profundidad del minimapa",
  T_40_XXJ_WS_USEDEPTHMAP_NAMEKEY: "Usar profundidad del minimapa",
  T_40_XXJ_WS_USEGRAVITY_DESCKEY: "Si sigue la ley gravitacional",
  T_40_XXJ_WS_USEGRAVITY_NAMEKEY: "Gravitacional o no",
  T_40_XXJ_WS_UUID_DESCKEY: "El identificador único de un jugador",
  T_40_XXJ_WS_UUID_NAMEKEY: "UUID",
  T_40_XXJ_WS_VALUE_DESCKEY: "El valor",
  T_40_XXJ_WS_VALUE_NAMEKEY: "Valor",
  T_40_XXJ_WS_VALUE01_NAMEKEY: "Valor [0, 1]",
  T_40_XXJ_WS_VALUE1_DESCKEY: "El primer valor",
  T_40_XXJ_WS_VALUE2_DESCKEY: "El segundo valor",
  T_40_XXJ_WS_VALUE6_DESCKEY: "Valor [0,1]",
  T_40_XXJ_WS_VALUEA_DESCKEY: "El valor iniciall",
  T_40_XXJ_WS_VALUEB_DESCKEY: "El valor objetivo",
  T_40_XXJ_WS_VALUENAME_DESCKEY: "El nombre del valor a recorrer. Puede usarlo para obtener el valor de una variable local.",
  T_40_XXJ_WS_VALUET_DESCKEY: "El progreso de la interpolación. Entre 0 y 1.",
  T_40_XXJ_WS_VARTYPE_NAMEKEY: "Tipo variable",
  T_40_XXJ_WS_VERTICALBAR_DESCKEY: "El tipo de visualización vertical",
  T_40_XXJ_WS_VERTICALBAR_NAMEKEY: "Tipo de visualización vertical",
  T_40_XXJ_WS_VISIBILITYLAYER_DESCKEY: "Nivel de visibilidad de un objeto",
  T_40_XXJ_WS_VISIBILITYLAYER_NAMEKEY: "Capa visible",
  T_40_XXJ_WS_WARDROBETYPE_DESCKEY: "Los atuendos incluyen el paquete, cabeza, máscara, maquillaje, parte superior, parte inferior y zapatos",
  T_40_XXJ_WS_WARDROBETYPE_NAMEKEY: "Tipo de atuendo",
  T_40_XXJ_WS_WARDROBETYPE6_DESCKEY: "Espacio de atuendo",
  T_40_XXJ_WS_WEAPONHUD_NAMEKEY: "Armas",
  T_40_XXJ_WS_WEAPONSKINID_DESCKEY: "El ID del aspecto del arma",
  T_40_XXJ_WS_WEAPONSKINID_NAMEKEY: "ID del aspecto de arma",
  T_40_XXJ_WS_WEAPONSKINID1_DESCKEY: "El ID del aspecto de arma",
  T_40_XXJ_WS_WEAPONSKINID6_DESCKEY: "El aspecto de arma del jugador",
  T_40_XXJ_WS_WIDGETTYPEENUM: "Componente tipo enum",
  T_40_XXJ_WS_WIDTH_DESCKEY: "La anchura",
  T_40_XXJ_WS_WORDWRAP_NAMEKEY: "Ajuste de línea",
  T_40_XXJ_WS_WRITELEADERBOARD: "Escribir el valor de la tabla de clasificación",
  T_40_XXJ_WS_WRITELEADERBOARD_DESC: "Escribe el valor correspondiente de una determinada llave en una determinada tabla de clasificación de la base de datos.",
  T_40_XYL_WS_BUMPERFACTORY: "Fábrica de Autos Chocones",
  T_40_XYL_WS_BURNDAMAGE: "Daños por combustión",
  T_40_XYL_WS_BURNINTERVAL: "Intervalo de daño por combustión (s)",
  T_40_XYL_WS_BURNTIME: "Tiempo de combustión después de la explosión",
  T_40_XYL_WS_COLORFULSKY: "Cielo Colorido",
  T_40_XYL_WS_CRANEMACHINE: "Grúa de Uña",
  T_40_XYL_WS_CRASHMAXDAMAGE: "Daño máximo por colisión",
  T_40_XYL_WS_CRASHMAXSPEED: "Límite de velocidad de daño por colisión máximo",
  T_40_XYL_WS_CRASHMESS: "Parámetro de masa durante el choque",
  T_40_XYL_WS_CRASHMINDAMAGE: "Daños mínimos por colisión",
  T_40_XYL_WS_DISPLAYBOARD: "Cartelera",
  T_40_XYL_WS_EXPLODEDAMAGE: "Daño de Explosión",
  T_40_XYL_WS_EXPLODEDELAY: "Tiempo de retraso de la explosión",
  T_40_XYL_WS_EXPLODERANGE: "Rango de Explosión",
  T_40_XYL_WS_FERRISWHEEL: "Rueda de la Fortuna",
  T_40_XYL_WS_FOODTRUCK002: "Food Truck B",
  T_40_XYL_WS_GEARSHIFTDELAY: "Tiempo de cambio de equipamiento (s)",
  T_40_XYL_WS_ICAROUSEL001: "Carrusel Componente A",
  T_40_XYL_WS_ICAROUSEL002: "Carrusel Componente B",
  T_40_XYL_WS_ICAROUSEL003: "Carrusel",
  T_40_XYL_WS_ICEDANCEDOOL: "Muñeca Azul",
  T_40_XYL_WS_IDLEBRAKEINPUT: "Ratio de potencia de estacionamiento no controlado",
  T_40_XYL_WS_LOLLIPOP: "Paleta Gigante",
  T_40_XYL_WS_NEWHOOKGUN: "Superpistola de Gancho",
  T_40_XYL_WS_OPENSWING: "Botón de giro",
  T_40_XYL_WS_OPENTRACTION: "Botón de remolque",
  T_40_XYL_WS_PODIUM: "Podio",
  T_40_XYL_WS_SKYCITY: "Ciudad",
  T_40_XYL_WS_SKYSCRAPER_A001: "Rascacielos A Componente A",
  T_40_XYL_WS_SKYSCRAPER_A002: "Rascacielos A Componente B",
  T_40_XYL_WS_SKYSCRAPER_A003: "Rascacielos A Componente C",
  T_40_XYL_WS_SKYSCRAPER_B001: "Rascacielos B Componente A",
  T_40_XYL_WS_SKYSCRAPER_B002: "Rascacielos B Componente B",
  T_40_XYL_WS_SKYSCRAPER_B003: "Rascacielos B Componente C",
  T_40_XYL_WS_SKYSCRAPER_C001: "Rascacielos C Componente A",
  T_40_XYL_WS_SKYSCRAPER_C002: "Rascacielos C Componente B",
  T_40_XYL_WS_SKYSCRAPER_C003: "Rascacielos C Componente C",
  T_40_XYL_WS_SKYSCRAPER_D001: "Rascacielos D Componente A",
  T_40_XYL_WS_SKYSCRAPER_D002: "Rascacielos D Componente B",
  T_40_XYL_WS_SKYSCRAPER_D003: "Rascacielos D Componente C",
  T_40_XYL_WS_SKYSCRAPER_E001: "Rascacielos E Componente A",
  T_40_XYL_WS_SKYSCRAPER_E002: "Rascacielos E Componente B",
  T_40_XYL_WS_SKYSCRAPER_E003: "Rascacielos E Componente C",
  T_40_XYL_WS_STEERANGLE: "Radio de giro a alta velocidad",
  T_40_XYL_WS_STEERSPEED: "Velocidad máxima al girar a alta velocidad",
  T_40_XYL_WS_SWINGSPEED: "Velocidad de giro",
  T_40_XYL_WS_TARGETOBJECT: "Ancla de movimiento",
  T_40_XYL_WS_TRACTIONSPEED: "Velocidad de remolque",
  T_40_XYL_WS_TRIGGERCAPSULE: "Activador de cápsulas personalizado",
  T_40_XYL_WS_TRIGGERSPHERE: "Activador de esferas personalizado",
  T_40_ZQ_WS_COMPONENT_CUSTOMOBJECT: "Objeto personalizado",
  T_40_ZQ_WS_COMPONENT_CUSTOMOBJECT_DESC: "Un componente de objeto vacío que puedes usarse con el componente de renderizado y el componente de colisión.",
  T_40_ZQ_WS_COMPONENT_CUSTOMRENDER: "Componente de renderizado personalizado",
  T_40_ZQ_WS_COMPONENT_CUSTOMRENDER_DESC: "Un componente de renderizado personalizado, usado para renderizar con recursos de modelos personalizados.",
  T_41_B_SKILL_DESC_ASSASSINGIRL: "Las marcas de tus enemigos tienen valor de recompensa. Cualquiera del equipo aliado que elimine a un enemigo marcado ganará [FFB300]{0} de dinero[-]. Ganarás [FFB300]100[-] extra por eliminar a un enemigo. Recibe [FFB300]{1}monedas FF[-] de las Máquinas de monedas en las partidas de BR.",
  T_41_B_SKILL_NAME_ASSASSINGIRL: "Dinero Marcado",
  T_41_CJ_A_ESPORTS_TH: "Jugador Pro (Máscara)",
  T_41_CJ_B_ESPORTS_TH: "Jugador Pro (Inferior)",
  T_41_CJ_H_ESPORTS_TH: "Jugador Pro (Cabeza)",
  T_41_CJ_S_ESPORTS_TH: "Jugador Pro (Zapatos)",
  T_41_CJ_T_ESPORTS_TH: "Jugador Pro (Superior)",
  T_41_CJ_T_FFSI: "Campeón FFSI (Superior)",
  T_41_CJ_T_FOOTBALL_EU01: "Uniforme Águila Solar",
  T_41_CJ_T_FOOTBALL_EU02: "Uniforme Caballo de Fuego",
  T_41_CJ_T_FOOTBALL_EU03: "Uniforme Gallo Majestuoso",
  T_41_CJ_T_FOOTBALL_EU04: "Uniforme Titán Real",
  T_41_H_CHARACTER_ASSASSINGIRL_N: "Suzy",
  T_41_LXW_TabName_Items: "Objeto",
  T_41_R_CD_COIL: "Reducción de Zona",
  T_41_SJ_WS_SPECIALITEM_ENABLE_DES: "Si deseas activar este dispositivo",
  T_41_SJ_WS_SPECIALITEM_NAME: "Dispositivo",
  T_41_SW_SKILL_DESC_DELIVERY: "Al ser golpeado por un enemigo a menos de [FFB300]{0}m[-], dicho atacante quedará marcado por [FFB300]{1}s[-] (la información se comparte con los compañeros de equipo). Máximo [FFB300]{2} marcas[-].",
  T_41_SW_SKILL_DESC_GANGLEADER: "Obtén [FFB300]{0}[-] Puntos de Escudo extras al inicio de la partida. Recupera Puntos de Escudo tras sobrevivir a un combate.",
  T_41_SW_SKILL_DESC_JUNKENGINEER: "Cuando se use una habilidad activa, proporciona [FFB300]{1}[-] puntos de escudo al usuario y a los compañeros de equipo hasta a [FFB300]{0}m[-]. Los puntos de escudo disminuyen después de [FFB300]{2}s[-], tras lo cual los jugadores pueden obtener los efectos de nuevo. Enfriamiento: [FFB300]{3}s[-].",
  T_41_SW_SKILL_DESC_WINTERGUY: "Las paredes gloo desplegadas restauran [FFB300]{0}[-] de durabilidad por segundo al ser golpeadas, mientras los compañeros de equipo en un radio de [FFB300]{1}m[-] restauran [FFB300]{2} PV/s[-]. Máximo [FFB300]{3} PV[-] por compañero de equipo por cada pared gloo.",
  T_41_SY_PETSKIN_CACTUS_SUGARSKULL23_N: "Aspecto de Mascota: Kaktus del Recuerdo",
  T_41_SY_PETSKIN_HAWK_INKPAINTING_N: "Aspecto de Mascota: Falco Filoso",
  T_41_WCL_CREDITSCORE_PENALTY_HISTORY_TYPE: "Tipo",
  T_41_WT_SKILL_DESC_FIREBOY: "Despliega un muro de llamas de [FFB300]{1}m[-]- de ancho que dura [FFB300]{0}s[-] y avanza a [FFB300]{2}m/s[-] durante un máximo de [FFB300]{3}s[-]. Mientras esté activo, vuelve a usar la habilidad para detener el muro. [FFB300]Los enemigos (o las Paredes Gloo)[-] que entren en contacto con él recibirán al instante [FFB300]{4} (o {5}) de DAÑO[-], y luego recibirán [FFB300]{6} (o {7}) de DAÑO[-] por s. Dura [FFB300]{8}s[-]. Enfriamiento: [FFB300]{9}s[-]. Se pueden almacenar hasta [FFB300]{10}[-] usos de la habilidad, con un enfriamiento de [FFB300]{11}s[-] entre cada uso.",
  T_41_WT_SKILL_NAME_FIREBOY: "Espejismo Ardiente",
  T_41_WZY_WS_CHARGEMAX: "Carga máx. del Creador Gloo",
  T_41_WZY_WS_CROSSBOWNAME: "Ballesta",
  T_41_WZY_WS_DECELERATIONRATIO: "Desaceleración % en agua",
  T_41_WZY_WS_DEICEWALLPARAM1: "Radio del área de fusión",
  T_41_WZY_WS_DEICEWALLPARAM2: "Duración de la fusión",
  T_41_WZY_WS_EXPPERCHIP: "EXP del Chip Gloo",
  T_41_WZY_WS_EXPPERDAMAGE: "EXP por infligir daño",
  T_41_WZY_WS_EXPPERMOVEMILE: "EXP de cada metro recorrido",
  T_41_WZY_WS_EXPPERSECOND: "EXP por segundo",
  T_41_WZY_WS_GRENADEEXPTIME: "Retraso de explosión",
  T_41_WZY_WS_GRENADELAUNCHNAME: "Explosivos",
  T_41_WZY_WS_GRENADEMAX: "Daño máximo",
  T_41_WZY_WS_GRENADEMIN: "Daño mínimo",
  T_41_WZY_WS_GRENADERANGE: "Rango de explosión",
  T_41_WZY_WS_GRENADERATIOCEHICLE: "Coeficiente de daño en vehículos",
  T_41_WZY_WS_GRENADERATIOSELF: "Coeficiente de daño sobre uno mismo",
  T_41_WZY_WS_GRENADERATIOTEAMMATE: "Coeficiente de daño en compañeros",
  T_41_WZY_WS_GRENADTHROWSPEED: "Velocidad de viaje explosivo",
  T_41_WZY_WS_HANDCANNONNAME: "Cañón de Mano",
  T_41_XXJ_WS_ACCELERATION: "Aceleración",
  T_41_XXJ_WS_ACCELERATION_D: "Crear un efecto de aceleración designado",
  T_41_XXJ_WS_ACTION: "Nodo de acción",
  T_41_XXJ_WS_ACTION_D: "Pivote de acción",
  T_41_XXJ_WS_ADDHP: "Objetos curativos",
  T_41_XXJ_WS_ADDPLAYERMAXHP: "Agregar PV máx.",
  T_41_XXJ_WS_AICASTSKILL_D: "Habilidad de lanzamiento de IA",
  T_41_XXJ_WS_AIMASSISTCENTEROFFSET: "Desfase del centro de la asistencia de puntería",
  T_41_XXJ_WS_AIMASSISTDISTANCE: "Distancia de la asistencia de puntería",
  T_41_XXJ_WS_AIMASSISTENTITY: "Entidad de asistencia de puntería",
  T_41_XXJ_WS_AIMASSISTENTITY_D: "Entidad que puede ser asistida por el objetivo",
  T_41_XXJ_WS_AISKILLTYPE: "Tipo de habilidad de zombi",
  T_41_XXJ_WS_AISKILLTYPE_D: "Tipo de habilidad de zombi",
  T_41_XXJ_WS_ALLITEMGOODSTYPE: "Todos los objetos",
  T_41_XXJ_WS_ALLITEMGOODSTYPE_D: "Todos los objetos",
  T_41_XXJ_WS_AMMOCLIPSIZE: "Modificar tamaño de cargador",
  T_41_XXJ_WS_AMMOCLIPSIZE_D: "Balas en el cargador",
  T_41_XXJ_WS_ANCHORPOSITION_D: "Las coordenadas del anclaje en relación con el padre",
  T_41_XXJ_WS_ANGLE_D: "El ángulo de rotación del eje z",
  T_41_XXJ_WS_ANGULARDRAG: "Resistencia angular",
  T_41_XXJ_WS_ANGULARVELOCITY: "Velocidad angular",
  T_41_XXJ_WS_ANIMATIONCLIP: "Estado de animación",
  T_41_XXJ_WS_ANIMATIONCONTROLLER: "Controlador de animación",
  T_41_XXJ_WS_ANIMATIONCONTROLLERABLE: "Entidad de animación",
  T_41_XXJ_WS_ANIMATIONCONTROLLERABLE_D: "El archivo y el recurso usados para gestionar el controlador de animación",
  T_41_XXJ_WS_ANIMATIONCONTROLLERRESUUID: "UUID de recurso de controlador de animación",
  T_41_XXJ_WS_ANIMATIONOVERRIDELOOPTYPE: "Tipo de bucle enum",
  T_41_XXJ_WS_ANIMATIONSTATE: "Estado de animación",
  T_41_XXJ_WS_ARITHMETICTYPE_D: "Operación, en la que se admiten todos los tipos de asignación de valores, y los tipos digitales también admiten autoincremento, autosustracción, automultiplicación y autodivisión",
  T_41_XXJ_WS_ATTACHMENT: "Adjunto",
  T_41_XXJ_WS_ATTACHMENT_D: "Adjunto",
  T_41_XXJ_WS_ATTACHTARGET: "Entidad vinculada",
  T_41_XXJ_WS_BAG: "Mochila",
  T_41_XXJ_WS_BAG_D: "Componente de mochila",
  T_41_XXJ_WS_BANNERID: "ID del fondo",
  T_41_XXJ_WS_BANNERID_D: "ID del fondo",
  T_41_XXJ_WS_BEHAVIOURTREE: "Árbol de comportamiento",
  T_41_XXJ_WS_BEHAVIOURTREE_D: "Árbol de comportamiento",
  T_41_XXJ_WS_BEHAVIOURTREEATTACHABLE: "Entidad de árbol de comportamiento montable",
  T_41_XXJ_WS_BEHAVIOURTREEATTACHABLE_D: "Una entidad de árbol de comportamiento que se puede montar",
  T_41_XXJ_WS_BEHAVIOURTREENODE: "Nodo personalizado del árbol de comportamiento",
  T_41_XXJ_WS_BEHAVIOURTREENODE_D: "Pivote personalizado del árbol de comportamiento",
  T_41_XXJ_WS_BODY: "Cuerpo",
  T_41_XXJ_WS_BORDERLR: "Borde (izquierda y derecha)",
  T_41_XXJ_WS_BORDERLR_D: "El borde izquierdo y derecho",
  T_41_XXJ_WS_BORDERTB: "Borde (superior e inferior)",
  T_41_XXJ_WS_BORDERTB_D: "El borde superior e inferior",
  T_41_XXJ_WS_BRPEAKRANK: "Rango BR más alto",
  T_41_XXJ_WS_BRPEAKRANK_D: "Rango BR más alto",
  T_41_XXJ_WS_BRRANK: "Rango BR",
  T_41_XXJ_WS_BRRANK_D: "Rango BR",
  T_41_XXJ_WS_BTCUSTOMNODETYPE: "Tipo de nodo del árbol de comportamiento",
  T_41_XXJ_WS_BTCUSTOMNODETYPE_D: "Tipo de pivote del árbol de comportamiento",
  T_41_XXJ_WS_BTREE: "Árbol de comportamiento",
  T_41_XXJ_WS_BTREENODESTATE: "Estado del nodo del árbol de comportamiento",
  T_41_XXJ_WS_BTREENODESTATE_D: "Estatus de operación del pivote del árbol de comportamiento",
  T_41_XXJ_WS_BUFFABLEENTITY: "Entidad habilitada para beneficio",
  T_41_XXJ_WS_BUFFABLEENTITY_D: "Permite agregar beneficios, eliminar beneficios y obtener listas de beneficios agregados.",
  T_41_XXJ_WS_BUILDINGICEWALL: "Pared Gloo",
  T_41_XXJ_WS_CAMOUFLAGE: "Objetos funcionales",
  T_41_XXJ_WS_CAMOUFLAGE_D: "Tabla, camuflaje...",
  T_41_XXJ_WS_CAPICITY_D: "Capacidad Inicial",
  T_41_XXJ_WS_CENTERINVISIBLE: "Invisible al centro",
  T_41_XXJ_WS_CENTERINVISIBLE_D: "No visible al centro",
  T_41_XXJ_WS_COLOR: "Color",
  T_41_XXJ_WS_COLOR_D: "El color",
  T_41_XXJ_WS_CONDITION: "Nodo de condición",
  T_41_XXJ_WS_CONDITION_D: "Las condiciones son un tipo booleano especial",
  T_41_XXJ_WS_CONDITION1_D: "Pivote de condición",
  T_41_XXJ_WS_CONSTRAIN: "Restricción RigidBody",
  T_41_XXJ_WS_CONSTRAIN_D: "Agrega restricciones al RigidBody. Esta es una compilación de tipo de restricción RigidBody.",
  T_41_XXJ_WS_COUNT_D: "Cantidad",
  T_41_XXJ_WS_CROSSBOW_D: "Ballesta",
  T_41_XXJ_WS_CSPEAKRANK: "Rango DE más alto",
  T_41_XXJ_WS_CSPEAKRANK_D: "Rango DE más alto",
  T_41_XXJ_WS_CSRANK: "Rango DE",
  T_41_XXJ_WS_CSRANK_D: "Rango DE",
  T_41_XXJ_WS_CSVNAME_D: "El archivo csv en SceneData que corresponde al modo. Termina en .csv. Las cabeceras se escriben en minúsculas.",
  T_41_XXJ_WS_CURCAPACITY: "Capacidad usada",
  T_41_XXJ_WS_CURPROGRESS: "Progreso actual",
  T_41_XXJ_WS_CURRENTCLIP: "Clip actual",
  T_41_XXJ_WS_CURRENTCLIPPROGRESS: "Progreso del clip actual",
  T_41_XXJ_WS_CURRENTSTATE: "Estado actual",
  T_41_XXJ_WS_CUSTOMHUDID: "ID de HUD personalizado",
  T_41_XXJ_WS_CUSTOMHUDID_D: "El ID usado para describir un activo HUD personalizado",
  T_41_XXJ_WS_DASHATTACK: "Ataque rápido",
  T_41_XXJ_WS_DEBUG: "Inicio de depuración",
  T_41_XXJ_WS_DEBUG_D: "Fijar",
  T_41_XXJ_WS_DECELERATIONRATIO_D: "% de desaceleración: La deceleración cuando un objeto está en el agua (rango establecido temporalmente como 0-100).",
  T_41_XXJ_WS_DEPTH_D: "La ruta",
  T_41_XXJ_WS_DRAG: "Coeficiente de arrastre",
  T_41_XXJ_WS_DRAG_D: "Cuanto mayor sea el coeficiente, más rápida será la deceleración de la velocidad de movimiento",
  T_41_XXJ_WS_DUMMY: "Maniquí",
  T_41_XXJ_WS_ENABLEENERGYSAVINGMODE: "Activar el modo de gráficos bajos",
  T_41_XXJ_WS_ENABLEENERGYSAVINGMODE_D: "Si está activada la opción de baja velocidad, el juego funcionará a 15 fps o a 30 fps",
  T_41_XXJ_WS_ENTITYLIST: "Devolver lista de entidades creadas",
  T_41_XXJ_WS_ENTITYNAME: "Nombre del objeto",
  T_41_XXJ_WS_ENTITYNAME_D: "El nombre del objeto personalizado por el jugador",
  T_41_XXJ_WS_ENTITYORPREFABID_D: "Entidad lógica o ID de prefabricado",
  T_41_XXJ_WS_EQUIPANDBAG: "Armadura y mochila",
  T_41_XXJ_WS_EQUIPMENTSLOT: "Espacio de equipo enum",
  T_41_XXJ_WS_EQUIPMENTSLOT_D: "Espacio de equipo enum",
  T_41_XXJ_WS_EXPLODE: "Autoexplosión",
  T_41_XXJ_WS_EXPLOSIVEWEAPON_D: "Arma Explosiva",
  T_41_XXJ_WS_FASTAUTORELOADSPEED: "Velocidad de recarga automática",
  T_41_XXJ_WS_FILEID: "ID Interno",
  T_41_XXJ_WS_FILEID_D: "El ID interno del control en el prefabricado",
  T_41_XXJ_WS_FILLAMOUNT: "Llenar cantidad",
  T_41_XXJ_WS_FILLAMOUNT_D: "El valor de llenado",
  T_41_XXJ_WS_FILLDIR: "Llenar dirección",
  T_41_XXJ_WS_FILLDIR_D: "La dirección del llenado",
  T_41_XXJ_WS_FILLDIR_D1: "Llenar dirección enum",
  T_41_XXJ_WS_FILLTYPE: "Llenar tipo",
  T_41_XXJ_WS_FILLTYPE_D: "El tipo de llenado",
  T_41_XXJ_WS_FILLTYPE_D1: "Llenar tipo enum",
  T_41_XXJ_WS_FINDSTRAIGHTPATH_D: "Encontrar ruta",
  T_41_XXJ_WS_FINISH: "Completar",
  T_41_XXJ_WS_FIREINTERVAL: "Intervalo de disparo",
  T_41_XXJ_WS_FIREINTERVAL_D: "Intervalo de ataque",
  T_41_XXJ_WS_FLIP: "Voltear método",
  T_41_XXJ_WS_FLIP_D: "El método de llenado",
  T_41_XXJ_WS_FLYBOMBBEE: "Zombi volador",
  T_41_XXJ_WS_FORCE: "Fuerza",
  T_41_XXJ_WS_FORCE_D: "Crear una fuerza de una intensidad determinada",
  T_41_XXJ_WS_FORCETYPE: "Tipo de fuerza",
  T_41_XXJ_WS_FORCETYPE_D: "Los diferentes tipos de fuerzas sobre el RigidBody. P.D. Solo es efectivo en tipos de RigidBody dinámicos.",
  T_41_XXJ_WS_FREEZEALL: "Congelar movimiento y rotación",
  T_41_XXJ_WS_FREEZEPOSITION: "Congelar movimiento lineal",
  T_41_XXJ_WS_FREEZEPOSITIONX: "Congelar eje x",
  T_41_XXJ_WS_FREEZEPOSITIONY: "Congelar eje y",
  T_41_XXJ_WS_FREEZEPOSITIONZ: "Congelar eje z",
  T_41_XXJ_WS_FREEZEROTATION: "Congelar toda la rotación",
  T_41_XXJ_WS_FREEZEROTATIONX: "Congelar rotación x",
  T_41_XXJ_WS_FREEZEROTATIONY: "Congelar rotación y",
  T_41_XXJ_WS_FREEZEROTATIONZ: "Congelar rotación z",
  T_41_XXJ_WS_FULLDAMAGEDISTANCE: "Distancia para daño máximo",
  T_41_XXJ_WS_FULLDAMAGEDISTANCE_D: "Distancia para daño máximo",
  T_41_XXJ_WS_GAMEID_D: "ID de la misión",
  T_41_XXJ_WS_GIVEJAILBREAKITEM_D: "Dar un objeto del modo Sin Control",
  T_41_XXJ_WS_GRADIENT: "Gradiente",
  T_41_XXJ_WS_GRADIENT_D: "El gradiente",
  T_41_XXJ_WS_GRADIENTBOTTOM: "Gradiente en la parte inferior",
  T_41_XXJ_WS_GRADIENTBOTTOM_D: "El gradiente en la parte inferior",
  T_41_XXJ_WS_GRADIENTBOTTOMALPHA: "Transparencia en la parte inferior",
  T_41_XXJ_WS_GRADIENTBOTTOMALPHA_D: "Transparencia del fondo",
  T_41_XXJ_WS_GRADIENTTOP: "Gradiente en la parte superior",
  T_41_XXJ_WS_GRADIENTTOP_D: "El gradiente en la parte superior",
  T_41_XXJ_WS_GRADIENTTOPALPHA: "Transparencia en la parte superior",
  T_41_XXJ_WS_GRADIENTTOPALPHA_D: "Transparencia superior",
  T_41_XXJ_WS_GRAPHID: "ID del script",
  T_41_XXJ_WS_GRAPHID_D: "El ID usado para describir un activo de script",
  T_41_XXJ_WS_GRENADEDEICEWALL_D: "Componente de la Granada Gloo",
  T_41_XXJ_WS_GRENADEEXPLOSIONTIME_D: "Retraso de explosión",
  T_41_XXJ_WS_GRENADELAUNCHER_D: "Lanzable",
  T_41_XXJ_WS_GRENADEMAXDAMAGE_D: "Daño máximo",
  T_41_XXJ_WS_GRENADEMINDAMAGE_D: "Daño mínimo",
  T_41_XXJ_WS_GRENADERANGE_D: "Rango de explosión",
  T_41_XXJ_WS_GRENADERATIOSELF_D: "Multiplicador de daño propio",
  T_41_XXJ_WS_GRENADERATIOTEAMMATE_D: "Multiplicador de daño de aliado",
  T_41_XXJ_WS_GRENADERATIOVEHICLE_D: "Multiplicador de daño de vehículo",
  T_41_XXJ_WS_GRENADETHROWSPEED_D: "Velocidad de lanzamiento",
  T_41_XXJ_WS_GRENADEWEAPON: "Categoría Lanzables",
  T_41_XXJ_WS_GRENADEWEAPON_D: "Tipos de lanzables básicos",
  T_41_XXJ_WS_HANDCANNON_D: "Lanzables",
  T_41_XXJ_WS_HEAD: "Cabeza",
  T_41_XXJ_WS_HEADID: "ID del icono",
  T_41_XXJ_WS_HEADID_D: "ID del icono",
  T_41_XXJ_WS_HEAVYWEAPON_D: "Arma pesada",
  T_41_XXJ_WS_HELMET_D: "El casco actual",
  T_41_XXJ_WS_HELMET1_D: "Casco",
  T_41_XXJ_WS_HELMET2_D: "Entidad del casco",
  T_41_XXJ_WS_HITBODYPART_D: "La parte del cuerpo golpeada",
  T_41_XXJ_WS_HITBPDYPART: "Golpear una parte del cuerpo",
  T_41_XXJ_WS_HITENTITY_D: "Entidad de golpe",
  T_41_XXJ_WS_HOSTHUDENTITY_D: "La entidad HUD a la que pertenece",
  T_41_XXJ_WS_HUD3DCONTAINER: "Contenedor de contenidos 3D",
  T_41_XXJ_WS_HUD3DCONTAINER_D: "La entidad contenedora del HUD 3D. Este es el HUD que los jugadores modifican desde el editor.",
  T_41_XXJ_WS_HUDGRID: "Control de diseño personalizado (panel)",
  T_41_XXJ_WS_HUDLAYOUT: "Control de la disposición",
  T_41_XXJ_WS_HUDLAYOUT_D: "La entidad de inserción del HUD. Es el HUD que los jugadores modifican desde el editor.",
  T_41_XXJ_WS_HUDPROFILEINFO: "Control de icono personalizado",
  T_41_XXJ_WS_HUDPROFILEINFO_D: "La entidad de información del perfil HUD. Este es el HUD que los jugadores modifican desde el editor.",
  T_41_XXJ_WS_HUDTEXTURE: "Control de textura",
  T_41_XXJ_WS_HUDTEXTURE_D: "La entidad de textura del HUD. Este es el HUD que los jugadores modifican desde el editor.",
  T_41_XXJ_WS_HUDTRANSFORM: "Componente de control UITransform",
  T_41_XXJ_WS_HUDTRANSFORM_D: "La entidad de control UITransform",
  T_41_XXJ_WS_IMPULSE: "Golpe",
  T_41_XXJ_WS_IMPULSE_D: "Crear un golpe de una intensidad determinada",
  T_41_XXJ_WS_INITIALWORLDPOS: "Coordenadas mundiales iniciales",
  T_41_XXJ_WS_INTERNALBUFFTYPE: "Beneficio enum",
  T_41_XXJ_WS_INTERNALBUFFTYPE_D: "Corresponde a la columna ID en el BuffData.csv. Antes de añadir nuevos contenidos, comprueba la compatibilidad con GPP.",
  T_41_XXJ_WS_INVERTFILL: "Invertir llenado",
  T_41_XXJ_WS_INVERTFILL_D: "Invertir el llenado",
  T_41_XXJ_WS_ISLOOP: "Es bucle",
  T_41_XXJ_WS_ISLOOP_D: "Si se crea o no un bucle. Por defecto es falso.",
  T_41_XXJ_WS_ISNAVMESHSTATIC: "Generación de NavMesh estáticos",
  T_41_XXJ_WS_ISNAVMESHSTATIC_D: "Solo se usa para comprobar la generación de NavMesh estáticos cuando se cargan objetos estáticos",
  T_41_XXJ_WS_ISSUCCESS_D: "Destruido o no",
  T_41_XXJ_WS_ITEMENTITY_D: "Entidad de objeto",
  T_41_XXJ_WS_ITEMID: "ID de objeto",
  T_41_XXJ_WS_ITEMID_D: "ID de objeto",
  T_41_XXJ_WS_ITEMID_D1: "El ID del objeto correspondiente del archivo adjunto",
  T_41_XXJ_WS_ITEMLIST: "Lista de objetos",
  T_41_XXJ_WS_ITEMTYPE_D: "Tipo de objeto",
  T_41_XXJ_WS_JUMPATTACK: "Ataque con salto",
  T_41_XXJ_WS_LANDMINE: "Mina terrestre",
  T_41_XXJ_WS_LENGTH: "Longitud del clip",
  T_41_XXJ_WS_LENGTH_D: "La longitud de la barra de progreso. El valor predeterminado es la longitud en la interfaz de usuario prefabricada.",
  T_41_XXJ_WS_LIMB: "Extremidades",
  T_41_XXJ_WS_LISTLENGTHOVERLIMIT: "Fallo al agregar un elemento porque la longitud de la lista ha superado su capacidad",
  T_41_XXJ_WS_LISTT_INTERNALBUFFTYPE: "Lista de beneficios",
  T_41_XXJ_WS_LOOP: "Bucle",
  T_41_XXJ_WS_LOOP_D: "Bucle",
  T_41_XXJ_WS_MAXCAPACITY: "Capacidad",
  T_41_XXJ_WS_MAXCAPACITY_D: "La capacidad de la mochila",
  T_41_XXJ_WS_MAXPROGRESS: "Progreso máx.",
  T_41_XXJ_WS_MELEEWEAPON_D: "Arma Cuerpo a Cuerpo",
  T_41_XXJ_WS_MINDAMAGEDISTANCE: "Distancia para daño mínimo",
  T_41_XXJ_WS_MINDAMAGEDISTANCE_D: "Distancia para daño mínimo",
  T_41_XXJ_WS_MINISENTRY: "Torreta Automática",
  T_41_XXJ_WS_NAME: "Nombre",
  T_41_XXJ_WS_NAME_D: "El nombre del botón de habilidad. Se utiliza para el envío de parámetros durante los incidentes OnClick, por lo que debe garantizarse la unicidad.",
  T_41_XXJ_WS_NAME1_D: "Nombre de la mercancía",
  T_41_XXJ_WS_NAME2_D: "Lista de nombres de la mercancía",
  T_41_XXJ_WS_NAME3_D: "Nombre de la Máquina Expendedora",
  T_41_XXJ_WS_NICKNAME: "Apodo",
  T_41_XXJ_WS_NICKNAME_D: "Nombre del jugador",
  T_41_XXJ_WS_NOCHANGE: "Sin cambios",
  T_41_XXJ_WS_NONE: "Sin restricciones",
  T_41_XXJ_WS_NONE1: "Ninguno",
  T_41_XXJ_WS_OFFSET: "Desplazamiento",
  T_41_XXJ_WS_OFFSET_D: "Desplazamiento",
  T_41_XXJ_WS_OFFSET1_D: "Escribir valor de desplazamiento",
  T_41_XXJ_WS_ONCE: "Una vez",
  T_41_XXJ_WS_ONCE_D: "Una vez",
  T_41_XXJ_WS_ONHIDE: "Cuando la interfaz está cerrada",
  T_41_XXJ_WS_ONHIDE_D: "Cuando la interfaz está cerrada",
  T_41_XXJ_WS_ONNODEENTER_D: "Cuando el pivote está entrando",
  T_41_XXJ_WS_ONSHOW: "Cuando la interfaz está abierta",
  T_41_XXJ_WS_ONSHOW_D: "Cuando la interfaz está abierta",
  T_41_XXJ_WS_ONSYNCINPUTTEXT_D: "Se activa cuando el cuadro de texto ha cambiado",
  T_41_XXJ_WS_PERSONALUAV: "UAV-Lite",
  T_41_XXJ_WS_PINID: "ID del pin",
  T_41_XXJ_WS_PINID_D: "ID del pin",
  T_41_XXJ_WS_PLAYERBAG: "Entidad de la mochila del jugador",
  T_41_XXJ_WS_PLAYERBAG_D: "La entidad de la mochila del jugador",
  T_41_XXJ_WS_PLAYERBAGENTITY: "Mochila del jugador",
  T_41_XXJ_WS_PLAYERBAGENTITY_D: "Mochila del jugador",
  T_41_XXJ_WS_PLAYERSPEEDFACTORAIMING: "Coeficiente modificado de la velocidad al apuntar",
  T_41_XXJ_WS_PLAYERSPEEDFACTORFIRING: "Impacto de la velocidad de movimiento al disparar",
  T_41_XXJ_WS_PLAYERSPEEDFACTORFIRING_D: "Impacto de la velocidad de movimiento al disparar",
  T_41_XXJ_WS_PREFABID: "ID prefabricado",
  T_41_XXJ_WS_PREFABID_D: "El ID usado para describir un activo prefabricado",
  T_41_XXJ_WS_PREFABID1_D: "La entidad de plantilla HUD que representa este ID",
  T_41_XXJ_WS_PRIMARYWEAPON1_D: "Arma principal 1",
  T_41_XXJ_WS_PRIMARYWEAPON2_D: "Arma principal 2",
  T_41_XXJ_WS_PROFILEINFO: "Perfil del jugador",
  T_41_XXJ_WS_PROFILEINFO_D: "Biografía del jugador",
  T_41_XXJ_WS_PROGRESSICON_D: "El icono de progreso",
  T_41_XXJ_WS_PROGRESSICONSPRITENAME: "Nombre del ícono de progreso",
  T_41_XXJ_WS_QUITJAILBREAKMINIGAME_D: "Salir del minijuego Sin Control",
  T_41_XXJ_WS_RANGE: "Rango de disparo",
  T_41_XXJ_WS_RANGE_D: "Rango de ataque",
  T_41_XXJ_WS_RANGE_D1: "Rango de explosión",
  T_41_XXJ_WS_RANGE_D2: "Rango de la Torreta",
  T_41_XXJ_WS_READCSVDATAALLOVERMODE_D: "Lee el contenido de toda la tabla. Devuelve una matriz bidimensional.",
  T_41_XXJ_WS_READCSVDATACELLOVERMODE_D: "Lee el contenido de una celda determinada.",
  T_41_XXJ_WS_READCSVDATACOLOVERMODE_D: "Lee el contenido de una columna determinada. Devuelve una matriz.",
  T_41_XXJ_WS_READCSVDATAROWOVERMODE_D: "Lee el contenido de una fila determinada. Devuelve una matriz.",
  T_41_XXJ_WS_READDBACCUMULATEDDATA: "Leer base de datos acumulada",
  T_41_XXJ_WS_READDBACCUMULATEDDATA_D: "Leer el valor correspondiente a una clave de una tabla de la base de datos acumulada",
  T_41_XXJ_WS_RECOVERPLAYERHP: "Recupera PV continuamente",
  T_41_XXJ_WS_RELOADSPEED: "Velocidad de recarga",
  T_41_XXJ_WS_RELOADSPEED_D: "Velocidad de recarga (velocidad básica x multiplicador)",
  T_41_XXJ_WS_RESOURCEID: "UUID del recurso",
  T_41_XXJ_WS_RESOURCEID_D: "UUID del recurso",
  T_41_XXJ_WS_RESUUID: "ID del recurso",
  T_41_XXJ_WS_RESUUID_D: "UUID del recurso designado que se va a representar",
  T_41_XXJ_WS_RIGIDBODYCONSTRAINTYPE: "Tipo de restricción RigidBody",
  T_41_XXJ_WS_RIGIDBODYCONSTRAINTYPE_D: "Cada restricción se define mediante una marca de bits y puede usarse como una combinación",
  T_41_XXJ_WS_ROTATION: "Rotación",
  T_41_XXJ_WS_ROTATION_D: "El ángulo de rotación en las coordenadas mundiales. x, y, z se refiere a la guiñada, cabeceo y balanceo, respectivamente.",
  T_41_XXJ_WS_ROTATION1_D: "La rotación",
  T_41_XXJ_WS_RUNNING: "Ejecutar",
  T_41_XXJ_WS_SCALE: "Escala",
  T_41_XXJ_WS_SCALE_D: "Escala",
  T_41_XXJ_WS_SCALE1_D: "Escala a lo largo de un eje determinado. Puede ser una combinación de tres ejes.",
  T_41_XXJ_WS_SCATTERMAX: "Dispersión máx. de bala",
  T_41_XXJ_WS_SCATTERMAX_D: "El valor en el que comienza la dispersión de la bala",
  T_41_XXJ_WS_SCATTERMOVE1: "Tamaño de la dispersión en movimiento",
  T_41_XXJ_WS_SCATTERRECOVERSPEED: "Recuperación de la velocidad de dispersión",
  T_41_XXJ_WS_SCATTERRECOVERSPEED_D: "Recuperación de la velocidad de dispersión",
  T_41_XXJ_WS_SCATTERSPEED: "Aumento de la velocidad de dispersión",
  T_41_XXJ_WS_SCATTERSPEED_D: "Velocidad de aumento de la dispersión (0.1 = El punto de mira se agranda un 10% por cada ráfaga)",
  T_41_XXJ_WS_SCATTERSPEEDCROUCHCREEP: "Menos dispersión boca abajo y agachado",
  T_41_XXJ_WS_SECONDARYWEAPON_D: "Arma Secundaria",
  T_41_XXJ_WS_SHADERNAME: "Nombre del sombreador",
  T_41_XXJ_WS_SHADERNAME_D: "El nombre del sombreador",
  T_41_XXJ_WS_SHIELDBROKEN: "Ataque de destrucción de escudos",
  T_41_XXJ_WS_SHIELDUP: "Ataque de Escudo",
  T_41_XXJ_WS_SHOCKWAVE: "Onda de choque",
  T_41_XXJ_WS_SHOWNAME: "Mostrar apodo",
  T_41_XXJ_WS_SHOWNAME_D: "Mostrar apodo",
  T_41_XXJ_WS_SHOWPIN: "Mostrar pin",
  T_41_XXJ_WS_SHOWPIN_D: "Mostrar pin",
  T_41_XXJ_WS_SHOWRANK: "Mostrar rango",
  T_41_XXJ_WS_SHOWRANK_D: "Mostrar rango",
  T_41_XXJ_WS_SHOWTYPE: "Diseño",
  T_41_XXJ_WS_SHOWTYPE_D: "Tipo",
  T_41_XXJ_WS_SHRINKSPEED: "Velocidad de reducción",
  T_41_XXJ_WS_SIGHTAIMASSIST: "Activar la asistencia de puntería en la mira",
  T_41_XXJ_WS_SIGHTAIMASSISTDISTFALLOFF: "Sensibilidad de la asistencia de puntería con distancia (0-1)",
  T_41_XXJ_WS_SIGHTAIMASSISTDISTPRIOCOEF: "Coeficiente al dar prioridad a la distancia de asistencia de puntería (≥ 1)",
  T_41_XXJ_WS_SIGHTAIMASSISTDISTPRIOMAX: "Distancia máxima para dar prioridad a la distancia de asistencia de puntería",
  T_41_XXJ_WS_SIGHTAIMASSISTDISTPRIOMIN: "Distancia mínima para dar prioridad a la distancia de asistencia de puntería",
  T_41_XXJ_WS_SIGHTAIMASSISTDISTPRIORITY: "Dar prioridad a la distancia de asistencia de puntería",
  T_41_XXJ_WS_SIGHTAIMASSISTSNAPRANGE: "Sensibilidad de la asistencia de puntería (0-1)",
  T_41_XXJ_WS_SIGHTAMPLIFYRATIO: "Factor de zoom de la mira",
  T_41_XXJ_WS_SIGHTFOVAMPLIFYRATIO: "Factor de zoom FOV",
  T_41_XXJ_WS_SIGHTROTSENSITIVENESS: "Coeficiente de sensibilidad a la rotación de la mira",
  T_41_XXJ_WS_SIGHTSHOOTMINDAMAGE: "Coeficiente x modificado en daño mínimo",
  T_41_XXJ_WS_SIGHTUIACTIONEXPAND: "Tiempo del zoom de la interfaz al disparar",
  T_41_XXJ_WS_SIGHTUIACTIONRATIO: "Factor del zoom de la interfaz al disparar",
  T_41_XXJ_WS_SIGHTUIACTIONRECOVERY: "Tiempo de reanudación de la interfaz al disparar",
  T_41_XXJ_WS_SPEED: "Velocidad de reproducción",
  T_41_XXJ_WS_SPEEQUIP: "Equipamiento funcional",
  T_41_XXJ_WS_SPEITEM: "Dispositivos",
  T_41_XXJ_WS_STATICGRAPHID: "ID de script estático",
  T_41_XXJ_WS_STATICGRAPHID_D: "El ID usado para describir un activo de script estático",
  T_41_XXJ_WS_STATICWAINING: "Error al modificar el tipo estático Rigidbody",
  T_41_XXJ_WS_TARGETTREE: "Entidad del árbol de comportamiento",
  T_41_XXJ_WS_TARGETTREE_D: "La ruta del árbol de comportamiento",
  T_41_XXJ_WS_TEAMINDEX: "Nº de serie del equipo",
  T_41_XXJ_WS_TEAMINDEX_D: "El índice del equipo, que coincide con el índice del equipo en la sala",
  T_41_XXJ_WS_TEAMINDEX_D1: "Número de facción del equipo",
  T_41_XXJ_WS_TEMPLATEPREFABID: "ID de plantilla prefabricada",
  T_41_XXJ_WS_TEXT_D: "Contenido",
  T_41_XXJ_WS_TEXTURENAME: "Nombre de textura",
  T_41_XXJ_WS_TEXTURENAME_D: "El nombre de la textura",
  T_41_XXJ_WS_THROWATTACK: "Granada",
  T_41_XXJ_WS_TICKINTERVAL: "Intervalo de actualización",
  T_41_XXJ_WS_TICKINTERVAL_D: "Intervalo de actualización. Cuanto mayor sea el número, más tardará la actualización.",
  T_41_XXJ_WS_TOGGLESPECIALITEMSTATE_D: "Habilitar dispositivos especiales en la mochila del jugador",
  T_41_XXJ_WS_UVRECTWH: "Ancho y alto UV",
  T_41_XXJ_WS_UVRECTWH_D: "La anchura y la altura UV",
  T_41_XXJ_WS_UVRECTXY: "Desplazamiento UV",
  T_41_XXJ_WS_UVRECTXY_D: "El desplazamiento UV",
  T_41_XXJ_WS_VELOCITY: "Velocidad",
  T_41_XXJ_WS_VELOCITY_D: "No modifiques directamente la velocidad de RigidBody. Puedes cambiarla usando las APIs relacionadas.",
  T_41_XXJ_WS_VEST_D: "El chaleco actual",
  T_41_XXJ_WS_VEST1_D: "Chaleco",
  T_41_XXJ_WS_WIDGETID: "ID de control",
  T_41_XXJ_WS_WIDGETID_D: "El ID usado para describir un control en los activos de la interfaz. Debe emparejarse con un ID de HUD personalizado para garantizar que se corresponde con un ID de control único.",
  T_41_XXJ_WS_WINDATTACK: "Ataque de Tornado",
  T_41_XXJ_WS_WRITEDBACCUMULATEDDATAOFFSET: "Escribir desplazamiento de base de datos acumulado",
  T_41_XXJ_WS_WRITEDBACCUMULATEDDATAOFFSET_D: "Escriba el desplazamiento correspondiente a una clave de una tabla de la base de datos acumulada",
  T_41_XXJ_WS_ZONEDURATION_D: "Congelar duración",
  T_41_XXJ_WS_ZONEDURATION1_D: "Duración de la Granada Gloo",
  T_41_XXJ_WS_ZONERADIUS_D: "Congelar radio de zona",
  T_41_XXJ_WS_ZONERADIUS1_D: "Radio de la Granada Gloo",
  T_41_XYL_WS_BOT12: "Perforador de la Tierra",
  T_41_XYL_WS_BOT9: "Zombi Mutante Lanzador",
  T_41_XYL_WS_ITEM262: "Panel de Acero Congelado A",
  T_41_XYL_WS_ITEM263: "Contenedor Congelado A",
  T_41_XYL_WS_ITEM264: "Contenedor de Suministros Congelado",
  T_41_XYL_WS_ITEM265: "Puerta de Metal Congelada",
  T_41_XYL_WS_ITEM266: "Contenedor Congelado B",
  T_41_XYL_WS_ITEM267: "Piedra Congelada A",
  T_41_XYL_WS_ITEM268: "Piedra Congelada B",
  T_41_XYL_WS_ITEM269: "Piedra Congelada C",
  T_41_XYL_WS_ITEM270: "Piedra Congelada D",
  T_41_XYL_WS_ITEM271: "Vagón Abandonado",
  T_41_XYL_WS_MODELMATCHNAME: "Lienzo del Concurso",
  T_41_XYL_WS_NAVMESH: "NavMesh dinámico",
  T_41_XYL_WS_REFCUBE: "Cubo Reflectante",
  T_41_XYL_WS_SNOWSKY: "Galaxia Helada",
  T_41_XYL_WS_TOYCUBE: "Jugar al Cubo",
  T_42_CJ_F_B_VOCATIONAL: "Planos de Engranaje (Inferior)",
  T_42_CJ_F_H_VOCATIONAL: "Planos de Engranaje (Cabeza)",
  T_42_CJ_F_S_VOCATIONAL: "Planos de Engranaje (Zapatos)",
  T_42_CJ_F_T_VOCATIONAL: "Planos de Engranaje (Superior)",
  T_42_CJ_HA_THUNDER_GOLD: "Maquillaje de relámpago",
  T_42_CJ_M_B_VOCATIONAL: "Plan Maestro Mecánico (Inferior)",
  T_42_CJ_M_H_VOCATIONAL: "Plan Maestro Mecánico (Cabeza)",
  T_42_CJ_M_S_VOCATIONAL: "Plan Maestro Mecánico (Zapatos)",
  T_42_CJ_M_T_VOCATIONAL: "Plan Maestro Mecánico (Superior)",
  T_42_H_CHARACTER_SUPERTEEN_N: "Ignis",
  T_42_H_GLOO_EVOTIGER_N: "Pared Gloo - Furia del Tigre",
  T_42_H_GRENADE_SMUDGE_N: "Granada- Sombra Felina",
  T_42_H_M1917_EMPIRE_N: "M1917 - Conquistador Coronado",
  T_42_HJ_WS_VFX_INK: "Filo",
  T_42_JH_WS_BANMATCHMAKING: "No está disponible el emparejamiento en este mapa",
  T_42_JH_WS_BANROOMCREATE: "No fue posible crear una sala",
  T_42_JH_WS_FPS: "DPP",
  T_42_JH_WS_SKILLSETALOKAWAKEN: "Fiesta Remix (Alok)",
  T_42_JH_WS_SKILLSETFIREWALL: "Muro ígneo (Ignis)",
  T_42_JH_WS_SKILLSETSANTINO: "División de Formas (Santino)",
  T_42_JH_WS_SKILLSETSONIA: "Nanoescudo de Vida (Sonia)",
  T_42_JH_WS_TAG1: "Riña Escarcha",
  T_42_JH_WS_TAG10: "Corredor infinito",
  T_42_JH_WS_TAG11: "Carrera desenfrenada",
  T_42_JH_WS_TAG12: "Carreras de autos",
  T_42_JH_WS_TAG13: "Excluir de Populares",
  T_42_JH_WS_TAG14: "Vanguardia",
  T_42_JH_WS_TAG15: "Guerra zombi",
  T_42_JH_WS_TAG16: "Legado Legendario",
  T_42_JH_WS_TAG2: "Isla Social 1.0",
  T_42_JH_WS_TAG3: "Isla Social 2.0",
  T_42_JH_WS_TAG4: "Juguemos juntos",
  T_42_JH_WS_TAG5: "Ruina evitada",
  T_42_JH_WS_TAG6: "Tiempo de Caza",
  T_42_JH_WS_TAG7: "Tiempo de Caza",
  T_42_JH_WS_TAG8: "Fuertes 2.0",
  T_42_JH_WS_TAG9: "Cazatesoros",
  T_42_RW_PORTALSFORPERSONAL_DESC: "¡Coloca un portal en cualquier sitio y teletranspórtate!",
  T_42_RW_PORTALSPERSONAL_NAME: "Portal Go",
  T_42_SJ_WS_ACCESSORIESITEM: "Equipar accesorio",
  T_42_SJ_WS_AUTOPLAY: "Auto juego",
  T_42_SJ_WS_CLIMB: "Trepar",
  T_42_SJ_WS_CLOCK_EVENTS: "Compilación de evento",
  T_42_SJ_WS_CLOCK_IS_COUNTDOWN: "Conteo regresivo o no",
  T_42_SJ_WS_CLOCK_LOOP_COUNT: "Bucles",
  T_42_SJ_WS_CLOCK_PAUSE_EVENT: "Pausar evento",
  T_42_SJ_WS_CLOCK_START_EVENT: "Iniciar evento",
  T_42_SJ_WS_CLOCK_START_TIME: "Tiempo de inicio del conteo regresivo",
  T_42_SJ_WS_CLOCK_STATE: "Estatus del cronómetro",
  T_42_SJ_WS_CLOCK_STOP_EVENT: "Detener evento",
  T_42_SJ_WS_DAMRATIOHEAD: "Cambio de coeficiente de Daño por Tiro a la Cabeza",
  T_42_SJ_WS_DAMRATIOLIMB: "Cambio del coeficiente de DAÑ en extremidades",
  T_42_SJ_WS_DAMREDUCEXPLODE: "Coeficiente de reducción de DAÑ explosivo",
  T_42_SJ_WS_DRIVE: "Conducir",
  T_42_SJ_WS_ENTITYITEXT_DEPTH: "Monstrar capas",
  T_42_SJ_WS_EXTRABAGCAPACITY: "Capacidad adicional de la mochila",
  T_42_SJ_WS_EXTRAHPRATIO: "Taza de PV",
  T_42_SJ_WS_GETOFF_DRIVE: "Salir del vehículo",
  T_42_SJ_WS_GETON_DRIVE: "Abordar vehículo",
  T_42_SJ_WS_KNIFEITEM: "Cuchillo",
  T_42_SJ_WS_KNIFEITEMPICK: "Cuchillo (botín terrestre)",
  T_42_SJ_WS_MARKBTNHUD: "El botón de fijado en el HUD",
  T_42_SJ_WS_MARKBTNHUD_D: "Puedes activar o desactivar el botón de fijado",
  T_42_SJ_WS_MAXDISTANCE: "Distancia Máxima",
  T_42_SJ_WS_MAXDURARATIO: "Tasa de durabilidad máxima",
  T_42_SJ_WS_MICBTNHUD: "El",
  T_42_SJ_WS_MICBTNHUD_D: "Puedes activar o desactivar el botón del micrófono",
  T_42_SJ_WS_MINDISTANCE: "Distancia mínima",
  T_42_SJ_WS_OPE_VEHICLE: "Operar Vehículo",
  T_42_SJ_WS_PLANE_DESC: "Una malla básica cuyo tamaño puede ajustarse libremente",
  T_42_SJ_WS_PLANENAME: "Avión básico",
  T_42_SJ_WS_PRIORITY: "Prioridad",
  T_42_SJ_WS_REPLACEPRIORITY: "Reemplazar prioridad",
  T_42_SJ_WS_SETBTNHUD: "El botón de ajustes en el HUD",
  T_42_SJ_WS_SETBTNHUD_D: "Puedes activar o desactivar el botón de ajustes",
  T_42_SJ_WS_SIGNALBTNHUD: "El botón de conexión a la red en el HUD",
  T_42_SJ_WS_SIGNALBTNHUD_D: "Puedes activar o desactivar el botón de conexión a la red",
  T_42_SJ_WS_SPEAKERBTNHUD: "El botón de claxon en el HUD",
  T_42_SJ_WS_SPEAKERBTNHUD_D: "Puedes activar o desactivar el botón del claxon",
  T_42_SJ_WS_START_TIME: "Hora de inicio (s)",
  T_42_SW_SKILL_DESC_ARMSDEALER: "Obtén más [FFB300]{0}[-] capacidad de munición en la mochila, no incluye el lanzagranadas. ([FFB300]{1}[-] Munición de RA, [FFB300]{2}[-] Munición de subfusil, [FFB300]{3}[-] Munición de francotirador, [FFB300]{4}[-] Munición de escopeta).",
  T_42_SW_SKILL_DESC_Bodyguard: "La velocidad de recarga aumenta en [FFB300]{0}%[-]. Cada vez que el usuario de la habilidad le da a un enemigo, dicho enemigo obtendrá una deducción de curación de [FFB300]{1}%[-] que dura por [FFB300]{3}s[-] (deducción máxima. : [FFB300]{2}%[-]).",
  T_42_SW_SKILL_DESC_Playboy: "Hazte inmune a efectos disruptivos (ej. alentamientos, marcado, silencio de habilidades) y obten un [FFB300]{1}%[-] potenciador de velocidad de movimiento por [FFB300]{2}s[-].Enfriamiento:[FFB300]{0}s[-].",
  T_42_SW_SKILL_DESC_SwatGuy: "Tras derribar a un enemigo o usar una habilidad activa, [FFB300]{0}%[-] del cargador del arma se recargará automáticamente",
  T_42_SW_SKILL_NAME_Playboy: "Cuchara de Plata",
  T_42_SY_BACKPACK_EMPIRE_N: "Mochila - Rugido Coronado",
  T_42_SY_PETSKIN_RABBIT_WINTERFEST23_N: "Aspecto de mascota: Brinquito gélido",
  T_42_SY_VEHICLESKIN_MOTOBIKE_URBAN_BW_N: "Motocicleta - Scooter Urbano",
  T_42_SY_VEHICLESKIN_ROADSTER_BULL_AFF_N: "Aventador Ultimae Booyah",
  T_42_SY_VEHICLESKIN_ROADSTER_BULL_ASILVER_N: "Aventador Ultimae Grigio Nimbus",
  T_42_SY_VEHICLESKIN_ROADSTER_BULL_VBLACK_N: "Veneno negro némesis",
  T_42_SY_VEHICLESKIN_ROADSTER_BULL_VRED_N: "Veneno rojo Hefesto",
  T_42_TYC_CST_LOSE_MONEY_1: "Cantidad de dinero DE conseguido tras perder una ronda",
  T_42_TYC_CST_LOSE_MONEY_2: "Cantidad de dinero DE conseguido tras una racha de 2 derrotas",
  T_42_TYC_CST_LOSE_MONEY_3: "Cantidad de dinero DE conseguido tras una racha de 3 derrotas",
  T_42_WH_ITEM_HEALUAV: "UAV-lite curativo",
  T_42_WH_ITEM_HEALUAV_DESC: "Despliega un UAV-Lite que vuela hacia delante y cura continuamente a los compañeros de equipo dentro del alcance",
  T_42_WH_ITEM_SKILLCARD: "Habilidad: {0}",
  T_42_WH_ITEM_SKILLCARD_DESC: `Utiliza para liberar la habilidad activa de [ffba00]{0}[-]: [ffba00]{1}[-].
{2}`,
  T_42_XXJ_WS_AMMOTYPE: "Tipo de munición",
  T_42_XXJ_WS_AMMOTYPE_D: "Tipo de munición",
  T_42_XXJ_WS_ASSETCONFIGID: "ID de Aspecto",
  T_42_XXJ_WS_ASSETCONFIGID_D: "Aspecto",
  T_42_XXJ_WS_ATTACKSTATUS: "Estado de Ataque",
  T_42_XXJ_WS_AUTOPLAY: "Auto juego",
  T_42_XXJ_WS_AUTOPLAY_D: "Auto juego",
  T_42_XXJ_WS_AVATARABLE: "Componente de apariencia modificable",
  T_42_XXJ_WS_AVATARABLE_D: "Cambiar apariencia según las partes",
  T_42_XXJ_WS_AVATARRESUUID: "Recurso de Apariencia UUID",
  T_42_XXJ_WS_AXISANGLETOQUATERNION_D: "Convertir la representación eje-ángulo de una rotación en cuaterniones",
  T_42_XXJ_WS_B_D: "El valor del color B",
  T_42_XXJ_WS_BASEVALUE_D: "Base del logaritmo",
  T_42_XXJ_WS_BEZIERCURVE: "Curva de Béizer",
  T_42_XXJ_WS_BEZIERCURVE_D: "La curva de Béizer",
  T_42_XXJ_WS_BOTDIFFICULTY: "Dificultad del bot",
  T_42_XXJ_WS_BOUNCE_COMBINE: "Método de combinación de rebotabilidad",
  T_42_XXJ_WS_BOUNCINES: "Rebotabilidad",
  T_42_XXJ_WS_BTREEID: "ID de árbol de comportamiento",
  T_42_XXJ_WS_BTREEID_D: "ID de árbol de comportamiento",
  T_42_XXJ_WS_CANPURCHAS: "Se puede comprar o no",
  T_42_XXJ_WS_CANPURCHAS_D: "Se puede comprar o no",
  T_42_XXJ_WS_CLIMBSTATUS: "Actitud escaladora",
  T_42_XXJ_WS_CLOCK: "Cronómetro",
  T_42_XXJ_WS_CLOCK_D: "Cronómetro",
  T_42_XXJ_WS_CLOCK_D1: "Cronómetro",
  T_42_XXJ_WS_CONTAINER: "Contenedor",
  T_42_XXJ_WS_CONTROLPOINTS: "Puntos de control",
  T_42_XXJ_WS_CONTROLPOINTS_D: "Los puntos de control",
  T_42_XXJ_WS_COROUTINEID: "Identificador de la corrutina",
  T_42_XXJ_WS_COROUTINEID_D: "El ID de la corrutina se refiere al identificador de una corrutina en específico. Permite realizar diversas operaciones sobre el identificador.",
  T_42_XXJ_WS_CREATESELFRELATIVE_D: "Crear un autorrelativo",
  T_42_XXJ_WS_CREATESELFRELATIVEFRAME_D: "Crear un autorrelativo",
  T_42_XXJ_WS_CREATESOUND: "Crear efecto de sonido",
  T_42_XXJ_WS_CREATESOUND_D: "Reproduce el efecto de sonido designado. Si hay más propiedades por establecer, puedes configurar las propiedades de la entidad.",
  T_42_XXJ_WS_CUSTOMMISSIONCOMPLETE_D: "Completar misión personalizada",
  T_42_XXJ_WS_DAMAGELIST_D: "Lista de aumento de DAÑ",
  T_42_XXJ_WS_DAMAGERATIOHEAD_D: "Tasa de DAÑ por tiro a la cabeza",
  T_42_XXJ_WS_DAMAGEREDUCTIONFACTOREXPLODE_D: "Multiplicador de reducción de DAÑ por explosión",
  T_42_XXJ_WS_DEFAULT_PHYMAT: "Material físico predeterminado",
  T_42_XXJ_WS_DEFAULTFIST_D: "Puño predeterminado",
  T_42_XXJ_WS_DELTA: "Delta",
  T_42_XXJ_WS_DELTA_D: "Delta",
  T_42_XXJ_WS_DELTATIME: "Intervalo de marco lógico",
  T_42_XXJ_WS_DELTATIME_D: "El intervalo entre las 2 actualizaciones de marcos lógicos de GS",
  T_42_XXJ_WS_DEPTH: "Capa",
  T_42_XXJ_WS_DEPTH_D: "Mostrar capas en el ícono",
  T_42_XXJ_WS_DISABLEPICKUPITEMS: "Lista de botín terrestre desactivado",
  T_42_XXJ_WS_DISABLEPICKUPITEMS_D: "La lista de objetos que no son botín terrestre",
  T_42_XXJ_WS_DRIVER: "Asiento de Piloto",
  T_42_XXJ_WS_DRIVINGSTATUS: "Conducir",
  T_42_XXJ_WS_DURATION_D1: "La duración del conteo regresivo en segundos",
  T_42_XXJ_WS_DURATION_D2: "La duración en segundos",
  T_42_XXJ_WS_DURATION_D3: "La duración",
  T_42_XXJ_WS_DURATION_D4: "La duración de invulnerabilidad en segundos",
  T_42_XXJ_WS_DURATIONTIMES: "Duración del cronómetro",
  T_42_XXJ_WS_DURATIONTIMES_D: "La duración en segundos",
  T_42_XXJ_WS_DYNAMIC_FRICTION: "Fricción dinámica",
  T_42_XXJ_WS_EASY: "Muy fácil",
  T_42_XXJ_WS_ENDTIMES: "Tiempo de finalización",
  T_42_XXJ_WS_ENDTIMES_D: "El tiempo final del cronómetro en segundos",
  T_42_XXJ_WS_ENERGYTHRESHOLD: "Umbral de energía global",
  T_42_XXJ_WS_ENTITYVARNAME_D: "La entidad relatva a sí misma",
  T_42_XXJ_WS_EQUIPMENTATTACHMENT_D: "Equipar accesorio",
  T_42_XXJ_WS_EULERANGLETOQUATERNION_D: "Convierte los ángulos de Euler en cuaterniones",
  T_42_XXJ_WS_EXPONENTIATION_D: "Potenciación",
  T_42_XXJ_WS_EXTRABAGCAPACITY_D: "Capacidad adicional para la mochila",
  T_42_XXJ_WS_FIST: "Puño",
  T_42_XXJ_WS_FONTTYPE: "Num de Fuente",
  T_42_XXJ_WS_FONTTYPE_D: "Num de Fuente",
  T_42_XXJ_WS_FORCESYNCVALUE: "Estatus de GS de sincronización de Fuerza",
  T_42_XXJ_WS_FORCESYNCVALUE_D: "El valor de sincronización de fuerza",
  T_42_XXJ_WS_FORCESYNCVALUE_D1: "La información de ubicación de la sinc",
  T_42_XXJ_WS_FORCESYNCVALUE1: "Información de ubicación de sincronización de fuerza",
  T_42_XXJ_WS_FORMULABLEENTITY_D: "Una entidad que puede formulas propiedades",
  T_42_XXJ_WS_FORWARD_D: "Vector de dirección",
  T_42_XXJ_WS_FRICTION_COMBINE: "Método de combinación de fricción",
  T_42_XXJ_WS_FUNCPOINT: "Función de puntero",
  T_42_XXJ_WS_FUNCPOINT_D: "Puntero que apunta a una instancia de una función. Se utiliza para implementar funciones virtuales o mecanismos de delegación.",
  T_42_XXJ_WS_GETMAPID_D: "Obtener ID del mapa",
  T_42_XXJ_WS_GETOFFVEHICLESTATUS: "Salir del vehículo",
  T_42_XXJ_WS_GETONASDRIVERSTATUS: "Abordar vehículo (Conductor)",
  T_42_XXJ_WS_GETONASPASSENGERSTATUS: "Abordar vehículo (Pasajero)",
  T_42_XXJ_WS_GETPLAYERTOKENCOUNTTODAY_D: "Buscar los datos de token de jugador de hoy",
  T_42_XXJ_WS_GRAVITY: "Gravedad global",
  T_42_XXJ_WS_HANDHELDITEM: "Objeto en mano actual",
  T_42_XXJ_WS_HANDHELDITEM_D: "El objeto actual de mano",
  T_42_XXJ_WS_HARD: "Difícil",
  T_42_XXJ_WS_HASCOMPONENT_D: "Si acaso existe un componente",
  T_42_XXJ_WS_HEIGHTLIST_D: "Lista de aumento de altura",
  T_42_XXJ_WS_INDEXLIST_D: "Acceder a la lista de índices de la cadena",
  T_42_XXJ_WS_INSCENE: "En escena",
  T_42_XXJ_WS_INSCENE_D: "En escena",
  T_42_XXJ_WS_IS3D_D: "Es o no es música 3D",
  T_42_XXJ_WS_ISCOUNTDOWN_D: "Conteo regresivo o cronómetro",
  T_42_XXJ_WS_ISLOOP: "Bucle o no",
  T_42_XXJ_WS_ISLOOP_D: "El comando de Bucle",
  T_42_XXJ_WS_ISREPLAY_D: "Comenzar o no por el principio",
  T_42_XXJ_WS_ISSWITCH_D: "Cuando el valor cambia a verdadero, puede combinarse con movimiento relativo. Cuando cambia a falso, puede combinarse con movimiento absoluto.",
  T_42_XXJ_WS_JEEP: "Jeep",
  T_42_XXJ_WS_JUMPSTATUS: "Estado de salto",
  T_42_XXJ_WS_LEFTVALUE: "Left Value",
  T_42_XXJ_WS_LEFTVALUE_D: "Base",
  T_42_XXJ_WS_LOGARITHM_D: "Logaritmo",
  T_42_XXJ_WS_LOOPABLE: "En Bucle",
  T_42_XXJ_WS_LOOPABLE_D: "En Bucle",
  T_42_XXJ_WS_MAPGETALLKEYS_D: "Obtener todas las keys del diccionario",
  T_42_XXJ_WS_MAPVALUE_D: "Diccionario objetivo",
  T_42_XXJ_WS_MARKBTNHUD: "El botón de fijado en el HUD",
  T_42_XXJ_WS_MATHE: "e",
  T_42_XXJ_WS_MATHPI: "pi",
  T_42_XXJ_WS_MAXDISTANCE_D: "La distancia máxima",
  T_42_XXJ_WS_MICROPHONEBTNHUD: "El interruptor del micrófono en el HUD",
  T_42_XXJ_WS_MINDISTANCE_D: "La distancia mínima",
  T_42_XXJ_WS_MISSIONID_D: "ID de la misión",
  T_42_XXJ_WS_MISSIONPROGRESS_D: "Progreso (no puede ser un número negativo)",
  T_42_XXJ_WS_MODERATE: "Moderado",
  T_42_XXJ_WS_MONSTERTRUCK: "Camión monstruo",
  T_42_XXJ_WS_MOTORBIKE: "Motocicleta",
  T_42_XXJ_WS_MOVEMENTSTATUS: "Estado de movimiento",
  T_42_XXJ_WS_MULTIPLYQUATERNION_D: "Multiplicación de dos cuaterniones (representa la superposición de rotaciones)",
  T_42_XXJ_WS_NORMAL: "Normal",
  T_42_XXJ_WS_OBSOLETE: "Descartado",
  T_42_XXJ_WS_OPENPLAYERVIEW: "Habilitar perspectiva de jugador",
  T_42_XXJ_WS_OPENPLAYERVIEW_D: "Habilitar perspectiva de jugador",
  T_42_XXJ_WS_ORIGINWEAPONTYPE: "Tipo de arma",
  T_42_XXJ_WS_ORIGINWEAPONTYPE_D: "Tipo de arma",
  T_42_XXJ_WS_OVERLOADPLAYERSKIN: "Priorizar la config. del jugador",
  T_42_XXJ_WS_PARAMSARRAY: "Matriz de parámetros",
  T_42_XXJ_WS_PARAMSARRAY_D: "La matriz de parámetros es una lista de los parámetros que intervienen en la salida. Debe coincidir con el número de %v en la descripción del formato.",
  T_42_XXJ_WS_PARAMSARRAY_D1: "La lista de los parámetros actuales pasaron a las funciones personalizadas.",
  T_42_XXJ_WS_PARTVISABLEMASK1: "Máscara de visibilidad parcial 1",
  T_42_XXJ_WS_PARTVISABLEMASK2: "Máscara de visibilidad parcial 2",
  T_42_XXJ_WS_PARTVISABLEMASK3: "Máscara de visibilidad parcial 3",
  T_42_XXJ_WS_PARTVISABLEMASK4: "Máscara de visibilidad parcial 4",
  T_42_XXJ_WS_PASSENGER1: "Asiento de pasajero 1",
  T_42_XXJ_WS_PASSENGER2: "Asiento de pasajero 2",
  T_42_XXJ_WS_PASSENGER3: "Asiento de pasajero 3",
  T_42_XXJ_WS_PHYMAT: "Materiales físicos",
  T_42_XXJ_WS_PLAYABLEENTITIES_D: "Entidad",
  T_42_XXJ_WS_PLAYABLERELATIVEFRAME: "Movimiento autorrelativo en cada fotograma",
  T_42_XXJ_WS_PLAYABLERELATIVEFRAME_D: "Movimiento autorrelativo en todos los fotogramas",
  T_42_XXJ_WS_PLAYABLESELFRELATIVE: "Movimiento relativo",
  T_42_XXJ_WS_PLAYABLESELFRELATIVE_D: "Movimiento relativo a sí mismo",
  T_42_XXJ_WS_PLAYER_D: "El jugador que necesita entrar al vehículo",
  T_42_XXJ_WS_PLAYERBEHAVIOR: "Comportamiento de jugador Sincronización de propiedad",
  T_42_XXJ_WS_PLAYERBEHAVIOR_D: "La entidad de propiedad de sincronización de comportamiento de jugador",
  T_42_XXJ_WS_PRIORITY_D: "Prioridad",
  T_42_XXJ_WS_PROPID_D: "ID de la propiedad",
  T_42_XXJ_WS_QUATERNION: "Cuaternión",
  T_42_XXJ_WS_QUATERNION_D: "El cuaternión es un vector especial de cuatro dimensiones que solo se usa para representar una rotación",
  T_42_XXJ_WS_QUATERNIONTOAXISANGLE_D: "Convertir los cuaterniones a la representación eje-ángulo",
  T_42_XXJ_WS_QUATERNIONTOEULERANGLE_D: "Convertir los cuaterniones en ángulos de Euler. Si los cuaterniones no cumplen la norma, mostrar (0,0,0).",
  T_42_XXJ_WS_REPEATTIMES_D: "El número de veces jugado. El Predeterminado es 1.",
  T_42_XXJ_WS_RESETPLAYABLE_D: "Restablecer",
  T_42_XXJ_WS_RIGHTVALUE: "Valor correcto",
  T_42_XXJ_WS_RIGHTVALUE_D: "Poder",
  T_42_XXJ_WS_SEATTYPE: "Número de asiento del Vehículo",
  T_42_XXJ_WS_SEPSTR_D: "Cadena usada para separar",
  T_42_XXJ_WS_SETPLAYERFALLINGDAMAGE_D: "Establecer el DAÑ por caída del jugador",
  T_42_XXJ_WS_SETTINGSBTNHUD: "El botón de configuración en el HUD",
  T_42_XXJ_WS_SHOWPOSITION: "Mostrar ubicación",
  T_42_XXJ_WS_SHOWPOSITION_D: "Mostrar ubicación",
  T_42_XXJ_WS_SIGNALICOHUD: "El botón de la conexión a la red en el HUD",
  T_42_XXJ_WS_SIMPLE: "Fácil",
  T_42_XXJ_WS_SLERPQUATERNION_D: "Interpolación de cuaterniones esféricos de A a B",
  T_42_XXJ_WS_SOUNDENTITY_D: "La entidad de efecto de sonido representa un efecto de sonido reproduciéndose",
  T_42_XXJ_WS_SPEAKERBTNHUD: "El botón del claxon en el HUD",
  T_42_XXJ_WS_SPLITSTRING_D: "Usa una cadena específica como delimitador para dividir la cadena en una subcadena",
  T_42_XXJ_WS_SPORTSCAR: "Auto deportivo",
  T_42_XXJ_WS_SPRINTSTATUS: "Estatus de correr",
  T_42_XXJ_WS_SRCVAL_D: "El valor fuente",
  T_42_XXJ_WS_STARTTICKCOUNT: "El momento en el que el GS comienza el ciclo",
  T_42_XXJ_WS_STARTTICKCOUNT_D: "El momento en el que el GS comienza el ciclo",
  T_42_XXJ_WS_STARTTIME_D: "Hora de comenzar",
  T_42_XXJ_WS_STARTTIME_D1: "Hora de comenzar",
  T_42_XXJ_WS_STATE_D: "El estado de un jugador: activo, derribado o eliminado",
  T_42_XXJ_WS_STATE_D1: "Verificar si este efecto sonido se está reproduciendo",
  T_42_XXJ_WS_STATIC_FRICTION: "Fricción estática",
  T_42_XXJ_WS_STRELEMS_D: "Conjunto objetivo de cadenas",
  T_42_XXJ_WS_STRINGFINDAT_D: "Devuelve la cadena final combinada según la lista de índices",
  T_42_XXJ_WS_STRINGJOIN_D: "Unir cadenas con un identificador en específico",
  T_42_XXJ_WS_STRINGLOWER_D: "Convertir todos los caracteres de la cadena a minúsculas",
  T_42_XXJ_WS_STRINGSTRIP_D: "Quitar caracteres de espacios en blanco de ambos lados de la cadena",
  T_42_XXJ_WS_STRINGUPPER_D: "Convertir todos los caracteres de la cadena a mayúsculas",
  T_42_XXJ_WS_STYLE_D: "Como se juega",
  T_42_XXJ_WS_SUV: "Camioneta pickup",
  T_42_XXJ_WS_SWITCH: "Interruptor",
  T_42_XXJ_WS_SWITCH_D: "Cuando el valor cambia a verdadero, puede combinarse con movimiento relativo. Cuando cambia a falso, debe combinarse con movimiento absoluto, de lo contrario, las propiedades no se aplicarán correctamente.",
  T_42_XXJ_WS_TARGETENTITY_D: "La entidad objetivo",
  T_42_XXJ_WS_TEAMROUNDSCOREBANNERHUD: "Fondo de puntuación por ronda del equipo",
  T_42_XXJ_WS_TEAMSEQ_D: "El número de serie del equipo que corresponde con el número de serie propiedad de la entidad del equipo",
  T_42_XXJ_WS_TEMPORARYSHIELD: "Puntos de escudo temporales",
  T_42_XXJ_WS_TEMPORARYSHIELD_D: "Puntos de escudo temporales",
  T_42_XXJ_WS_TEXT_D: "El texto original para realizar un filtro de obcenidad",
  T_42_XXJ_WS_THREESTATESWITCH: "Interruptor de 3 estados",
  T_42_XXJ_WS_THROWINGKNIFE_D: "Cuchillo (botín terrestre)",
  T_42_XXJ_WS_THROWINGKNIFEBR_D: "Cuchillo",
  T_42_XXJ_WS_TUKTUK: "Tuk tuk",
  T_42_XXJ_WS_TWOTEAMLEADERBOARDHUD: "Detalles de la partida por equipos",
  T_42_XXJ_WS_UNIQUEID: "ID único",
  T_42_XXJ_WS_UNIQUEID_D: "ID único",
  T_42_XXJ_WS_VALUE_D: "El valor",
  T_42_XXJ_WS_VECTOR3TOEULERANGLES_D: "Vector de dirección a ángulos de Euler",
  T_42_XXJ_WS_VEHICLEID: "ID del vehículo",
  T_42_XXJ_WS_VEHICLESKINID: "ID de aspecto de vehículo",
  T_42_XXJ_WS_VERYHARD: "Muy difícil",
  T_42_XXJ_WS_VOLUME_D: "El volumen de sonido. 50 es el predeterminado.",
  T_42_XXJ_WS_WEAPONTYPE_D: "Tipo principal de arma",
  T_42_XXJ_WS_WORKSHOPCODE: "Código de mapa",
  T_42_XXJ_WS_WORKSHOPCODE_D: "El código del mapa que corresponde a la información en la base de datos",
  T_42_XXJ_WS_WORLDPOSITION: "Coordenadas de Mundo",
  T_42_XXJ_WS_WORLDPOSITION_D: "Coordenadas del mundo",
  T_42_XYL_WS_ITEM275: "Tanque de combustible",
  T_42_XYL_WS_ITEM276: "Saco de arena A",
  T_42_XYL_WS_ITEM277: "Saco de arena B",
  T_42_XYL_WS_ITEM278: "Saco de arena C",
  T_42_XYL_WS_ITEM279: "Saco de arena",
  T_42_XYL_WS_ITEM280: "Casa de dos pisos",
  T_42_XYL_WS_ITEM281: "Fábrica de armas",
  T_42_XYL_WS_ITEM282: "Pared de piedra A",
  T_42_XYL_WS_ITEM283: "Pared de piedra B",
  T_42_XYL_WS_ITEM284: "Pared de piedra C",
  T_42_XYL_WS_ITEM285: "Pared de piedra D",
  T_42_XYL_WS_ITEM286: "Caja de Abastecimiento militar A",
  T_42_XYL_WS_ITEM287: "Moneda de cobre",
  T_42_XYL_WS_ITEM288: "Moneda de plata",
  T_42_XYL_WS_ITEM289: "Moneda de oro",
  T_42_XYL_WS_ITEM290: "Diamante",
  T_42_XYL_WS_ITEM291: "Fragmentos de diamante",
  T_42_XYL_WS_ITEM292: "Rubí",
  T_42_XYL_WS_ITEM293: "Esmeralda",
  T_42_XYL_WS_ITEM294: "Zafiro",
  T_42_XYL_WS_ITEM295: "Señal de advertencia",
  T_42_XYL_WS_ITEM297: "Ruina",
  T_42_XYL_WS_ITEM297TRUE: "Dispositivo de control",
  T_42_XYL_WS_ITEM298: "Contenedor de suministro B",
  T_42_XYL_WS_ITEM299: "Montón de nieve",
  T_42_XYL_WS_ITEM300: "Pared supertecnológica A",
  T_42_XYL_WS_ITEM301: "Pared supertecnológica B",
  T_42_XYL_WS_ITEM302: "Piedra Congelada F",
  T_42_XYL_WS_ITEM303: "Piedra Congelada E",
  T_42_XYL_WS_ITEM304: "Plataforma supertecnológica A",
  T_42_XYL_WS_ITEM305: "Escalera supertecnológica A",
  T_42_XYL_WS_ITEM306: "Lámpara de exploración A",
  T_42_XYL_WS_ITEM307: "Deflector en ruinas A",
  T_42_XYL_WS_ITEM308: "Deflector en ruinas B",
  T_42_XYL_WS_ITEM309: "Abrazadera de acero en ruinas A",
  T_42_XYL_WS_ITEM310: "Piedra en ruinas A",
  T_42_XYL_WS_ITEM311: "Piedra en ruinas B",
  T_42_XYL_WS_ITEM312: "Piedra en ruinas C",
  T_42_XYL_WS_ITEM313: "Linterna A",
  T_42_XYL_WS_ITEM314: "Barra de refuerzo en ruinas A",
  T_42_XYL_WS_LOGICALOBJECT: "Lógico",
  T_42_XYL_WS_THEMEHIGHTECH: "Futurista",
  T_42_XYL_WS_THEMEICE: "Gélido",
  T_42_XYL_WS_THEMEMILITARY: "Militar",
  T_42_XYL_WS_THEMEOBJECTS: "Objeto temático",
  T_42_XYL_WS_TIMERCONTINUE: "Incidente al continuar el cronómetro",
  T_42_XYL_WS_TIMERCYCLE: "Conteo de bucles",
  T_42_XYL_WS_TIMERDOWN: "Cuenta regresiva",
  T_42_XYL_WS_TIMEREND: "Incidente al terminar el cronómetro",
  T_42_XYL_WS_TIMEREVENT: "Incidente personalizado del cronómetro",
  T_42_XYL_WS_TIMEREVENT1: "Controlar cronómetro",
  T_42_XYL_WS_TIMEREVENT2: "Incidentes al establecer cronómetro",
  T_42_XYL_WS_TIMERORDER: "Método de cronometraje",
  T_42_XYL_WS_TIMERPAUSE: "Incidente al pausar el cronómetro",
  T_42_XYL_WS_TIMERSTART1: "Hora de inicio del cronómetro",
  T_42_XYL_WS_TIMERSTART2: "Incidente de inicio del cronómetro",
  T_42_XYL_WS_TIMERUP: "Ponte a contar",
  T_42_XYL_WS_TRIGGERTIME_MS: "Tiempo de activación (en milisegundos)",
  T_42_ZZ_GUILDWAR_AIRCRAFTDESC: "Un ala delta que puede sostener a varios jugadores.",
  T_42_ZZ_GUILDWAR_PERSONALSCORE: "Puntuación Individual",
  T_42_ZZ_GUILDWAR_SCORE: "Puntuación",
  T_43_B_SKILL_DESC_MONKEYGOD: "Se transforma en un arbusto que dura [FFB300]{1}s[-]. Enfriamiento: [FFB300]{0}s[-]. La transformación termina cuando Wukong ataca. Se restablece cuando Wukong derriba a un enemigo.",
  T_43_B_SKILL_DESC_Nanoscientist: "Tras recibir daño mortal, entra en estado de invulnerabilidad y queda inmóvil durante [FFB300]{0} s[-]. Después, obtienes un escudo de [FFB300]{1} PV[-] que dura [FFB300]{2} s[-]. El usuario de la habilidad será eliminado cuando desaparezca el escudo. Enfriamiento: [FFB300]{3} s[-].",
  T_43_B_SKILL_DESC_ORION: "Sustituye PE por [FFB300]{0} de Energía Carmesí[-]. Consume [FFB300]{1} Energía Carmesí[-] para activar su protección, durante la cual no podrás recibir daño ni atacar a enemigos, y absorberás [FFB300]{4} PV[-] (se ignorarán los puntos de escudo enemigos) de los enemigos en un radio de [FFB300]{3} m[-]. Dura [FFB300]{2} s[-], durante los cuales tu velocidad de movimiento disminuirá un [FFB300]{6}%[-]. Enfriamiento: [FFB300]{5} s[-].",
  T_43_CJ_F_A_RACER: "Amante de la velocidad (máscara)",
  T_43_CJ_F_B_RACER: "Amante de la velocidad (inferior)",
  T_43_CJ_F_H_RACER: "Amante de la velocidad (cabeza)",
  T_43_CJ_F_HA_RACER: "Amante de la velocidad (maquillaje)",
  T_43_CJ_F_S_RACER: "Amante de la velocidad (zapatos)",
  T_43_CJ_F_T_RACER: "Amante de la velocidad (superior)",
  T_43_CJ_M_A_RACER: "Fan de la velocidad (máscara)",
  T_43_CJ_M_B_MACHINERY: "Tecnoturquesa (inferior)",
  T_43_CJ_M_B_RACER: "Fan de la velocidad (inferior)",
  T_43_CJ_M_H_MACHINERY: "Tecnoturquesa (cabeza)",
  T_43_CJ_M_H_RACER: "Fan de la velocidad (cabeza)",
  T_43_CJ_M_HA_MACHINERY: "Tecnoturquesa (maquillaje)",
  T_43_CJ_M_S_MACHINERY: "Tecnoturquesa (zapatos)",
  T_43_CJ_M_S_RACER: "Fan de la velocidad (zapatos)",
  T_43_CJ_M_T_MACHINERY: "Tecnoturquesa (superior)",
  T_43_CJ_M_T_RACER: "Fan de la velocidad (superior)",
  T_43_H_CHARACTER_GEEK_N: "Ryden",
  T_43_H_VSK94_MAMBAS_N: "VSK94 - Colmillos de mamba",
  T_43_HJ_WS_OPTION8: "Otro",
  T_43_HJ_WS_TEXTURE_BAMBOO: "Bambú",
  T_43_HJ_WS_TEXTURE_BEACH: "Playa",
  T_43_HJ_WS_TEXTURE_BRICK1: "Pared de ladrillos A",
  T_43_HJ_WS_TEXTURE_BRICK2: "Pared de ladrillos B",
  T_43_HJ_WS_TEXTURE_BRICK3: "Pared de ladrillos C",
  T_43_HJ_WS_TEXTURE_CEMENT: "Piso de concreto",
  T_43_HJ_WS_TEXTURE_CEMENT2: "Concreto",
  T_43_HJ_WS_TEXTURE_CRYSTAL: "Cristal",
  T_43_HJ_WS_TEXTURE_GLASSLAND1: "Césped A",
  T_43_HJ_WS_TEXTURE_GLASSLAND2: "Césped B",
  T_43_HJ_WS_TEXTURE_ICE: "Bloque de hielo",
  T_43_HJ_WS_TEXTURE_IRON: "Piso de metal",
  T_43_HJ_WS_TEXTURE_IRON2: "Contenedor",
  T_43_HJ_WS_TEXTURE_LAVA: "Lava",
  T_43_HJ_WS_TEXTURE_MARBLE: "Suelo de mármol",
  T_43_HJ_WS_TEXTURE_NONE: "Vacío",
  T_43_HJ_WS_TEXTURE_STONE: "Piedra",
  T_43_HJ_WS_TEXTURE_TEXTILE1: "Mantel A",
  T_43_HJ_WS_TEXTURE_TEXTILE2: "Mantel B",
  T_43_HJ_WS_TEXTURE_WOOD: "Madera",
  T_43_HJ_WS_TEXTURE_WOODEN: "Piso de madera B",
  T_43_HJ_WS_TEXTURE_WOODEN2: "Piso de madera B",
  T_43_JH_WS_MAPTAG1: "Amigable con novatos",
  T_43_JH_WS_MAPTAG10: "Contenido nuevo aburrido",
  T_43_JH_WS_MAPTAG11: "No se siente que dé muchas recompensas",
  T_43_JH_WS_MAPTAG12: "Recompensa desbalanceadas",
  T_43_JH_WS_MAPTAG13: "No se siente el progreso",
  T_43_JH_WS_MAPTAG14: "No amigable con novatos",
  T_43_JH_WS_MAPTAG15: "Tutorial confuso",
  T_43_JH_WS_MAPTAG16: "Faltan tutoriales",
  T_43_JH_WS_MAPTAG17: "Los jugadores abandonan mucho",
  T_43_JH_WS_MAPTAG18: "Controles complicados",
  T_43_JH_WS_MAPTAG19: "IU desordenada",
  T_43_JH_WS_MAPTAG2: "Nuevo contenido preferido",
  T_43_JH_WS_MAPTAG20: "Diseño de mapa pobre",
  T_43_JH_WS_MAPTAG21: "Tiroteo intenso",
  T_43_JH_WS_MAPTAG22: "Combate frontal",
  T_43_JH_WS_MAPTAG23: "Mundo abierto",
  T_43_JH_WS_MAPTAG24: "Buena trama",
  T_43_JH_WS_MAPTAG25: "Progresión",
  T_43_JH_WS_MAPTAG26: "Deportes",
  T_43_JH_WS_MAPTAG27: "Cooperativo",
  T_43_JH_WS_MAPTAG28: "Social",
  T_43_JH_WS_MAPTAG29: "Diverso",
  T_43_JH_WS_MAPTAG3: "Jugadores activos",
  T_43_JH_WS_MAPTAG30: "Exploración libre",
  T_43_JH_WS_MAPTAG31: "Desafío de rango",
  T_43_JH_WS_MAPTAG32: "Desafío de logro",
  T_43_JH_WS_MAPTAG33: "Canje de dinero",
  T_43_JH_WS_MAPTAG4: "Mapa bien diseñado",
  T_43_JH_WS_MAPTAG40: "Muchas recompensas",
  T_43_JH_WS_MAPTAG41: "Progreso satisfactorio",
  T_43_JH_WS_MAPTAG42: "Campos de entrenamiento populares",
  T_43_JH_WS_MAPTAG43: "Torre en solitario popular",
  T_43_JH_WS_MAPTAG44: "Zona de guerra popular",
  T_43_JH_WS_MAPTAG5: "Tiene intermitencia",
  T_43_JH_WS_MAPTAG6: "Cooperativo difícil",
  T_43_JH_WS_MAPTAG7: "Tiene fallas",
  T_43_JH_WS_MAPTAG8: "Pocas actualizaciones",
  T_43_JH_WS_MAPTAG9: "Eventos aburridos en las partidas",
  T_43_JH_WS_SKILLSETAUTOPATHBOMB: "Trampa arácnida (Ryden)",
  T_43_SJ_WS_AIRDROP_ITEMS: "Objetos",
  T_43_SJ_WS_AIRDROP_NAME: "Airdrop",
  T_43_SJ_WS_AIRDROP_TIME: "Tiempo",
  T_43_SJ_WS_AIRDROP_UI_ITEM: "Objeto de airdrop",
  T_43_SJ_WS_ANITRIGGER_AUTO: "Está en autojugar",
  T_43_SJ_WS_ANITRIGGER_CENTER: "Juega con otro punto de anclaje",
  T_43_SJ_WS_ANITRIGGER_CLIP: "Nombre de la animación",
  T_43_SJ_WS_ANITRIGGER_LOOP: "Bucle",
  T_43_SJ_WS_ANITRIGGER_NAME: "Activador de animación del HUD",
  T_43_SJ_WS_RESET_ROUND: "Reiniciar tras cada ronda",
  T_43_SJ_WS_START_DROPTIME: "Tiempo de inicio de caída (ms)",
  T_43_SJ_WS_TRIGGER_ANIMA: "Activador de animación",
  T_43_SY_PETSKIN_AXOLOTL_WATERFEST24_N: "Aspecto de mascota: Zasil miau miau",
  T_43_SY_VEHICLESKIN_MOTOBIKE_FIGHTER_N: "Motocicleta - La velocidad personificada",
  T_43_WH_ITEM_SUPPLYBOX_DESC: "Contiene suministros esenciales de batalla, como munición y objetos médicos.",
  T_43_WH_ITEM_SUPPLYBOX_NAME: "Caja de suministros",
  T_43_WT_SKILL_DESC_DUMMY_REWORK: "Crea un maniquí de [FFB300]{1} PV[-] que se desplaza de forma autónoma durante [FFB300]{0}s[-]. Cuando el maniquí esté a [FFB300]{3}m[-], vuelve a utilizar la habilidad para cambiar de posición con él. Solo puedes cambiar una vez dentro de [FFB300]{4}s[-] y hasta en [FFB300]{2} ocasión(es)[-] en total. El jugador que destruya al maniquí quedará marcado durante [FFB300]{5}s[-]. Enfriamiento: [FFB300]{6}s[-].",
  T_43_WT_W_VSK94: "VSK94",
  T_43_XXJ_WS_ACTIVITYSKILL: "Habilidad activa",
  T_43_XXJ_WS_AIRDROP: "Airdrop y zombi",
  T_43_XXJ_WS_ALPHA: "Alfa",
  T_43_XXJ_WS_ALPHA_D: "La transparencia general del HUD, en un rango de 0 a 1.",
  T_43_XXJ_WS_ANIMATIONCTRLID: "ID del controlador de la animación",
  T_43_XXJ_WS_ANIMATIONCTRLID_D: "El ID usado para describir un recurso de animación de controlador.",
  T_43_XXJ_WS_AUDIOID: "ID de audio",
  T_43_XXJ_WS_AUDIOID_D: "El ID usado para describir un recurso de audio.",
  T_43_XXJ_WS_BACKGRCOLOR: "Color del fondo",
  T_43_XXJ_WS_BACKGRCOLOR_D: "El color del borde de la barra de salud y el fondo difuminado",
  T_43_XXJ_WS_BURNING: "Quemando",
  T_43_XXJ_WS_CSVID: "ID del CSV",
  T_43_XXJ_WS_CSVID_D: "El ID usado para describir un recurso de tabla de configuración.",
  T_43_XXJ_WS_CURRENTHP: "PV actuales",
  T_43_XXJ_WS_CURRENTHP_D: "Valor actual de los PV.",
  T_43_XXJ_WS_DAMAGEMAKER_D: "La entidad del juego que inflige daño.",
  T_43_XXJ_WS_DAMAGEZONE: "Zona de daño",
  T_43_XXJ_WS_DEFAULT: "Predeterminado",
  T_43_XXJ_WS_DEFAULT_D: "Predeterminado",
  T_43_XXJ_WS_EFFECTID: "ID de efecto",
  T_43_XXJ_WS_EFFECTID_D: "El ID usado para describir un recurso de efecto especial.",
  T_43_XXJ_WS_FIGHTINGENTITY_D: "Una entidad que puede luchar (por ejemplo, lanzar ataques, ser atacada o ser eliminada).",
  T_43_XXJ_WS_FOLLOWTARGET: "Seguir objetivo",
  T_43_XXJ_WS_FOLLOWTARGET_D: "Debe seguir a una entidad con un componente de transformar.",
  T_43_XXJ_WS_GAINHPCOLOR: "Obtener color de PV",
  T_43_XXJ_WS_GAINHPCOLOR_D: "Se mostrará de este color la parte aumentada de PV por un corto tiempo.",
  T_43_XXJ_WS_ISNOFALLDAMAGE: "Sin daño por caída",
  T_43_XXJ_WS_ISOPENTWEEN: "Tiene interpolación abierta",
  T_43_XXJ_WS_ISOPENTWEEN_D: "Activa esta opción para mostrar los cambios de PV en diferentes colores.",
  T_43_XXJ_WS_KNOCKDOWN_D1: "El jugador está en estado de derribo.",
  T_43_XXJ_WS_KNOCKDOWN_D2: "Ajustes para la respuesta al estado de derribo cuando haya una eliminación.",
  T_43_XXJ_WS_KNOCKDOWN_D3: "El tipo de fuente para revivir. Un jugador puede ser revivido mientras está derribado.",
  T_43_XXJ_WS_KNOCKDOWNSTATE: "Estado de derribo",
  T_43_XXJ_WS_KNOCKDOWNSTATETYPE: "Tipo de estado de derribo",
  T_43_XXJ_WS_KNOCKDOWNSTATETYPE_D: "La respuesta al estado de derribo: mantener la lógica por defecto, omitir el estado de derribo o forzar el derribo.",
  T_43_XXJ_WS_LEVEL: "Nivel",
  T_43_XXJ_WS_LEVEL_D: "Nivel",
  T_43_XXJ_WS_LEVEL_D1: "El nivel actual del zombi.",
  T_43_XXJ_WS_LINESPACING: "Espaciado entre líneas",
  T_43_XXJ_WS_LINESPACING_D: "No se muestra cuando los PV segmentados entre dos divisores ≤ 0",
  T_43_XXJ_WS_LOSEHPCOLOR: "Perder color de PV",
  T_43_XXJ_WS_LOSEHPCOLOR_D: "La parte reducida de PV se mostrará en este color durante un breve periodo de tiempo.",
  T_43_XXJ_WS_MAINCOLOR: "Color principal",
  T_43_XXJ_WS_MAINCOLOR_D: "El color de los PV, los niveles y los contornos.",
  T_43_XXJ_WS_MINISENTRY: "Torreta",
  T_43_XXJ_WS_MINISENTRYATTACKTARGETTYPE_D: "La enum. para los tipos de objetivos que puede atacar una torreta.",
  T_43_XXJ_WS_MISSILEEXPLODE: "Explosión de misil",
  T_43_XXJ_WS_MUSTKNOCKDOWN: "Se debe derribar",
  T_43_XXJ_WS_MUSTKNOCKDOWN_D: "Derribo forzado",
  T_43_XXJ_WS_OFFSET: "Desplazamiento",
  T_43_XXJ_WS_OFFSET_D: "Desfase relativo al objetivo seguido",
  T_43_XXJ_WS_OILDRUMEXPLODE: "Explosión de contenedor de petróleo",
  T_43_XXJ_WS_ONCONTROLLERCOLLIDERHIT_D: "Solo se activa cuando el controlador inicia el movimiento.",
  T_43_XXJ_WS_PLAYER_D: "La entidad de jugador dentro del juego. Cada jugador tiene una.",
  T_43_XXJ_WS_PLAYERHEADHUD: "HUD de la cabeza del jugador",
  T_43_XXJ_WS_PLAYERHEADHUD_D: "La información mostrada por encima de la cabeza del jugador.",
  T_43_XXJ_WS_PLAYERNAME: "Nombre del jugador",
  T_43_XXJ_WS_PLAYERNAME_D: "Muestra el nombre del usuario actual de la barra de salud.",
  T_43_XXJ_WS_PLAYERORVEHICLE: "Jugador o vehículo",
  T_43_XXJ_WS_PLAYERORVEHICLE_D: "El alias del tipo de entidad de jugador/vehículo.",
  T_43_XXJ_WS_SCALE: "Escala",
  T_43_XXJ_WS_SCALE_D: "Determina el tamaño general de la escala del HUD, con la fuente en escala para que coincida.",
  T_43_XXJ_WS_SHOWDAMAGENUMBER: "Mostrar cantidad de daño",
  T_43_XXJ_WS_SHOWDAMAGENUMBER_D: "Verdadero por defecto. Muestra la cantidad de daño.",
  T_43_XXJ_WS_SKIPKNOCKDOWN: "Saltar derribo",
  T_43_XXJ_WS_SKIPKNOCKDOWN_D: "Saltarse el estado de derribo y quedar eliminado al instante.",
  T_43_XXJ_WS_SKIPSTAGGERANIMATION: "Se salta la animación escalonada.",
  T_43_XXJ_WS_TEAM_D: "(Obsoleto. Por favor, utiliza el ID de equipo).",
  T_43_XXJ_WS_TERRAIN: "Terreno",
  T_43_XXJ_WS_TERRAIN_D: "Componente del terreno cuyos atributos no pueden modificarse. Se utiliza únicamente para probar funciones.",
  T_43_XXJ_WS_TOTALHP: "PV en total",
  T_43_XXJ_WS_TOTALHP_D: "Valor total de PV",
  T_43_XXJ_WS_TWEENENTITY: "Entidad de interpolación",
  T_43_XXJ_WS_VEHICLEEXPLODE: "Explosión de vehículo",
  T_43_XXJ_WS_WIDTH: "Ancho",
  T_43_XXJ_WS_WIDTH_D: "El ancho de la barra de salud mostrada.",
  T_43_XXJ_WS_ZOMBIE: "Zombi",
  T_43_XYL_WS_DROIDFIST: "Puño (Apocalipsis Androide)",
  T_43_XYL_WS_DROIDFLAME: "Lanzallamas (Apocalipsis Androide)",
  T_43_XYL_WS_JAPANESE: "Estilo japonés",
  T_43_YU_WS_ADDGAMEEVENTLOGMAP_D: "Personalizar los registros de eventos de partidas. Se utiliza para analizar la experiencia del usuario.",
  T_43_YU_WS_AIRDROPSTATE: "Estado del airdrop",
  T_43_YU_WS_AIRDROPSTATE_D: "Estado del airdrop (1: listo, 2: cayendo, 3: aterrizó).",
  T_43_YU_WS_ANIMATIONCLIPID: "ID del clip de animación",
  T_43_YU_WS_ANIMATIONCLIPID_D: "Personalizar ID del clip de animación.",
  T_43_YU_WS_ASKBUYTARGET: "Solicitar compra del objetivo.",
  T_43_YU_WS_ASKBUYTARGET_D: "Especifica el objetivo y envía una solicitud de compra.",
  T_43_YU_WS_ASKEDLIST: "Lista solicitada",
  T_43_YU_WS_ASKEDLIST_D: "La lista de objetos solicitados.",
  T_43_YU_WS_BACKGROUNDCOLOR1: "Color del fondo 1",
  T_43_YU_WS_BACKGROUNDCOLOR1_D: "El color del fondo superior.",
  T_43_YU_WS_BACKGROUNDCOLOR2: "Color del fondo 2",
  T_43_YU_WS_BACKGROUNDCOLOR2_D: "El color del fondo de la parte inferior.",
  T_43_YU_WS_BATCHCOMBINERENDER: "Renderizado combinado por lotes",
  T_43_YU_WS_BINDMONEYENTITYLIST: "Vincular lista de entidades de dinero.",
  T_43_YU_WS_BINDMONEYENTITYLIST_D: "La lista de entidades monetarias vinculadas.",
  T_43_YU_WS_BINDWALLETENTITYID: "Vincular ID de la entidad de la billetera.",
  T_43_YU_WS_BINDWALLETENTITYID_D: "El ID del la entidad de cartera vinculada.",
  T_43_YU_WS_CENTEROFFSET: "Desplazamiento del centro",
  T_43_YU_WS_CENTEROFFSET_D: "El valor del desfase del colisionador de cápsulas.",
  T_43_YU_WS_COLLECTIONID: "ID de la colección",
  T_43_YU_WS_COLLECTIONID_D: "El ID de la colección que se usa para la recolección de la información del recurso.",
  T_43_YU_WS_CREATEAIRDROPENTITY_D: "Crear un airdrop.",
  T_43_YU_WS_CREATEUGCDAMAGENUM_D: "Crear un número de daño.",
  T_43_YU_WS_CROSSPLATFORM_D: "Cuando se seleccione, enviar al cliente si se solicita en el servidor y viceversa.",
  T_43_YU_WS_CSROUNDRESULTHUD: "HUD de resultados en ronda de DE",
  T_43_YU_WS_CSROUNDRESULTHUD_D: "Resultados mostrados al final de cada ronda.",
  T_43_YU_WS_CURRENTEMOTECLIP: "Clip actual de emote",
  T_43_YU_WS_CURRENTEMOTECLIP_D: "ID del clip emote actual.",
  T_43_YU_WS_DAMAGE_D: "Daño fuera de la zona",
  T_43_YU_WS_DICTIONARY: "Diccionario",
  T_43_YU_WS_DIRECTIONRULERHUD: "Parámetro de dirección del HUD.",
  T_43_YU_WS_DIRECTIONRULERHUD_D: "La brújula en la parte superior.",
  T_43_YU_WS_DOTWEEN_D: "Realizar o no animación de interpolación",
  T_43_YU_WS_DROPITEMS_D: "Objetos en el airdrop",
  T_43_YU_WS_DURATION: "Duración",
  T_43_YU_WS_ENERGY: "Energía",
  T_43_YU_WS_ENERGY_D: "Modificación del valor de los PE",
  T_43_YU_WS_EPHYSXPOSE_CREEPING: "Boca abajo",
  T_43_YU_WS_EPHYSXPOSE_CROUCHING: "Agacharse",
  T_43_YU_WS_EPHYSXPOSE_DASHING: "Correr",
  T_43_YU_WS_EPHYSXPOSE_STANDING: "De pie",
  T_43_YU_WS_EVENTID: "ID del evento",
  T_43_YU_WS_EVENTID_D: "Representa un evento",
  T_43_YU_WS_FACTION: "Facción",
  T_43_YU_WS_FACTION_D: "La entidad de facción.",
  T_43_YU_WS_FACTION_D1: "Solicita ayuda a la facción para la compra.",
  T_43_YU_WS_FINALRADIUS_D: "El radio final de la zona segura.",
  T_43_YU_WS_FIRSTAIDKIT: "Botiquín",
  T_43_YU_WS_FIRSTAIDKIT_D: "Botiquín",
  T_43_YU_WS_FIRSTPERSONMODEL: "Modelo en primera persona",
  T_43_YU_WS_FIRSTPERSONMODEL_D: "La cámara en primera persona.",
  T_43_YU_WS_FONTCOLOR_D: "El color de la fuente.",
  T_43_YU_WS_FONTSIZE_D: "El tamaño de la fuente.",
  T_43_YU_WS_FORBIDEN: "Prohibido",
  T_43_YU_WS_FORBIDEN_D: "Desactivar el HUD para solicitud de compra.",
  T_43_YU_WS_FREEZINGTIME: "Tiempo de congelado",
  T_43_YU_WS_FREEZINGTIME_D: "La duración durante la cual el objetivo golpeado permanece congelado.",
  T_43_YU_WS_GRAVITY: "Gravedad",
  T_43_YU_WS_GRAVITY_D: "La aceleración gravitacional. Solo afecta al controlador del jugador.",
  T_43_YU_WS_HANDCATAPULT: "Plataforma de lanzamiento",
  T_43_YU_WS_HANDCATAPULT_D: "Plataforma de lanzamiento",
  T_43_YU_WS_HEALTH: "Vida",
  T_43_YU_WS_HEALTH_D: "El valor de recuperación de la durabilidad del blindaje.",
  T_43_YU_WS_HEIGHT: "Altura",
  T_43_YU_WS_HELPEDPLAYER_D: "El jugador que se ayudó.",
  T_43_YU_WS_HELPPLAYER_D: "El jugador que ayuda con las compras.",
  T_43_YU_WS_HORIZONTALMAXANGLE: "Ángulo horizontal máx.",
  T_43_YU_WS_HORIZONTALMINANGLE: "Ángulo horizontal mín.",
  T_43_YU_WS_HUDTOGGLE: "Alternar el HUD",
  T_43_YU_WS_HUDTOGGLE_D: "La entidad HudToggle que los jugadores pueden editar en el editor del HUD.",
  T_43_YU_WS_INHALER: "Inhalador",
  T_43_YU_WS_INHALER_D: "Inhalador",
  T_43_YU_WS_INITRADIUS_D: "El radio inicial de la zona segura.",
  T_43_YU_WS_INT64: "Int64",
  T_43_YU_WS_INT64_D: "Un entero con signo de 64 bits.",
  T_43_YU_WS_ISAPPLYSHADOW: "Se aplica sombra.",
  T_43_YU_WS_ISBOTTOMCOLLIDING: "Hace colisión por abajo.",
  T_43_YU_WS_ISCURRENTEMOTELOOP: "Está en bucle el emote actual.",
  T_43_YU_WS_ISCURRENTEMOTELOOP_D: "Establecer en bucle la animación del emote actual o no.",
  T_43_YU_WS_ISSIDECOLLIDING: "Hace colisión lateral.",
  T_43_YU_WS_ISSLIDING: "Se desliza.",
  T_43_YU_WS_ISTOPCOLLIDING: "Hace colisión por arriba.",
  T_43_YU_WS_ITEM331: "Dispositivo futurista A",
  T_43_YU_WS_ITEM332: "Roca brillante A",
  T_43_YU_WS_ITEM333: "Pantalla futurista A",
  T_43_YU_WS_ITEM334: "Contenedor futurista A",
  T_43_YU_WS_ITEM335: "Contenedor futurista A",
  T_43_YU_WS_ITEM336: "Sofá de piedra A",
  T_43_YU_WS_ITEM337: "Interruptor futurista A",
  T_43_YU_WS_ITEM338: "Tubería futurista A",
  T_43_YU_WS_ITEM339: "Plataforma de metal A",
  T_43_YU_WS_ITEM340: "Mesa futurista A",
  T_43_YU_WS_ITEM341: "Mesa futurista A",
  T_43_YU_WS_ITEM342: "Mesa futurista C",
  T_43_YU_WS_ITEM343: "Computadora futurista A",
  T_43_YU_WS_ITEM344: "Piedra A",
  T_43_YU_WS_ITEM345: "Piedra B",
  T_43_YU_WS_ITEM346: "Piedra C",
  T_43_YU_WS_ITEM347: "Piedra D",
  T_43_YU_WS_ITEM348: "Piedra E",
  T_43_YU_WS_ITEM349: "Piedra F",
  T_43_YU_WS_ITEM350: "Piedra G",
  T_43_YU_WS_ITEM351: "Cortinas de estilo japonés A",
  T_43_YU_WS_ITEM352: "Cortinas de estilo japonés B",
  T_43_YU_WS_ITEM353: "Cortina estilo japonesa C",
  T_43_YU_WS_ITEM354: "Escaleras de estilo japonés A",
  T_43_YU_WS_ITEM355: "Cerca estilo japonesa A",
  T_43_YU_WS_ITEM356: "Cerca de estilo japonés B",
  T_43_YU_WS_ITEM357: "Cerca estilo japonesa C",
  T_43_YU_WS_ITEM358: "Plataforma de estilo japonés A",
  T_43_YU_WS_ITEM359: "Cerca estilo japonesa B",
  T_43_YU_WS_ITEM360: "Puerta de estilo japonés B",
  T_43_YU_WS_ITEM361: "Pared D futurista",
  T_43_YU_WS_ITEM362: "Pared B futurista",
  T_43_YU_WS_ITEM363: "Placa base angulada futurista",
  T_43_YU_WS_LEFTCOLOR: "Color izquierdo",
  T_43_YU_WS_LEFTCOLOR_D: "El color del lado izquierdo.",
  T_43_YU_WS_LEFTPLAYERARRAY: "Matriz de jugador izquierda",
  T_43_YU_WS_LEFTPLAYERARRAY_D: "La disposición de jugador izquierda",
  T_43_YU_WS_LEFTSCORE: "Puntuación izquierda",
  T_43_YU_WS_LEFTSCORE_D: "La puntuación del lado izquierdo.",
  T_43_YU_WS_LEFTSCOREAFTER: "Puntuación izquierda posterior",
  T_43_YU_WS_LEFTSCOREAFTER_D: "La puntuación final en el lado izquierdo. Se usa en animaciones de transición de puntuación.",
  T_43_YU_WS_LEVELOBJECTID: "ID del nivel de objeto",
  T_43_YU_WS_LEVELOBJECTID_D: "Describe el tipo de objeto. Requiere analizar la tabla de configuración SceneEditPrefab antes de cargarlo.",
  T_43_YU_WS_LOCALPOSITION_D: "Coordenadas en el sistema de coordenadas local.",
  T_43_YU_WS_LOCALPOSITION_D1: "La posición relativa.",
  T_43_YU_WS_LOCALPOSITION_D2: "La posición relativa al anclaje derecho inferior.",
  T_43_YU_WS_LOCALPOSITION_D3: "La posición relativa al anclaje.",
  T_43_YU_WS_LOCALROTATION_D: "Ángulos de rotación en el sistema de coordenadas local (X: orientación, Y: inclinación y Z: giro).",
  T_43_YU_WS_LOCALROTATIONQ_D: "El cuaternión en el sistema de coordenadas local.",
  T_43_YU_WS_LOCALSCALE_D: "El tamaño de la escala en el sistema de coordenadas global.",
  T_43_YU_WS_MASS: "Masa",
  T_43_YU_WS_MATERIALS: "Materiales",
  T_43_YU_WS_MATERIALS_D: "Lista de los materiales usados para renderizar.",
  T_43_YU_WS_MAXSPEED: "Velocidad máx.",
  T_43_YU_WS_MAXSPEED_D: "No se generarán más caballos cuando se alcance la velocidad máxima, pero la velocidad del vehículo puede superar el límite (por ejemplo, por la aceleración al bajar una pendiente).",
  T_43_YU_WS_MESHID: "ID de malla",
  T_43_YU_WS_MESHID_D: "Describe el tipo de malla.",
  T_43_YU_WS_MESHID1: "ID de malla",
  T_43_YU_WS_MESHID1_D: "La partícula a usarse para renderizar.",
  T_43_YU_WS_MINMOVEDISTANCE: "Distancia de movimiento mín.",
  T_43_YU_WS_MINMOVEDISTANCE_D: "Movimiento con una distancia más corta",
  T_43_YU_WS_MODULE_AI: "IA",
  T_43_YU_WS_MODULE_AIRDROP: "Airdrop",
  T_43_YU_WS_MODULE_ANIMATION: "Animación",
  T_43_YU_WS_MODULE_AVATAR: "Ícono",
  T_43_YU_WS_MODULE_BASEATTRIBUTES: "Atributos básicos",
  T_43_YU_WS_MODULE_BEHAVIOURTREE: "Árbol de comportamiento",
  T_43_YU_WS_MODULE_BUFF: "Potenciador",
  T_43_YU_WS_MODULE_CAMERA: "Cámara",
  T_43_YU_WS_MODULE_CHATCHANNEL: "Canal del chat",
  T_43_YU_WS_MODULE_CHECKPOINT: "Punto de control",
  T_43_YU_WS_MODULE_COLLECTION: "Colección",
  T_43_YU_WS_MODULE_COMBAT: "Combate",
  T_43_YU_WS_MODULE_COMPONENT: "Componente",
  T_43_YU_WS_MODULE_CONVERT: "Convertir",
  T_43_YU_WS_MODULE_CUSTOMIZEROOMPARAMETERS: "Personalizar parámetros de la sala.",
  T_43_YU_WS_MODULE_DATABASE: "Almacenamiento de datos",
  T_43_YU_WS_MODULE_DYEING: "Teñido",
  T_43_YU_WS_MODULE_DYNAMICNAVMESH: "NavMesh dinámico",
  T_43_YU_WS_MODULE_ECONOMY: "Economía",
  T_43_YU_WS_MODULE_FF_PLATFORM: "Plataforma FF",
  T_43_YU_WS_MODULE_FOOTBALL: "Fútbol",
  T_43_YU_WS_MODULE_FRAMERATEMODE: "Modo de frecuencia de cuadros",
  T_43_YU_WS_MODULE_GAMERESULT: "Resultados del juego",
  T_43_YU_WS_MODULE_GLOBAL: "Global",
  T_43_YU_WS_MODULE_GLOBALSCRIPTS: "Comandos globales",
  T_43_YU_WS_MODULE_HANGUPANDCHEAT: "AFK & trampa",
  T_43_YU_WS_MODULE_HUD: "HUD",
  T_43_YU_WS_MODULE_INPUTSYSTEM: "Entrada del sistema",
  T_43_YU_WS_MODULE_ITEMS: "Objetos",
  T_43_YU_WS_MODULE_LEVELOBJECT: "Nivel de objeto",
  T_43_YU_WS_MODULE_LIST: "Lista",
  T_43_YU_WS_MODULE_MAP: "Mapa",
  T_43_YU_WS_MODULE_MATCHING: "Partida",
  T_43_YU_WS_MODULE_MATH: "Matemáticas",
  T_43_YU_WS_MODULE_MECHANISM: "Parámetros de mecanismo",
  T_43_YU_WS_MODULE_MINIMAP: "Minimapa",
  T_43_YU_WS_MODULE_MORPH: "Transformar",
  T_43_YU_WS_MODULE_OTHER: "Otro",
  T_43_YU_WS_MODULE_PET: "Mascota",
  T_43_YU_WS_MODULE_PHYSICS: "Física",
  T_43_YU_WS_MODULE_PLAYABLE: "Jugable",
  T_43_YU_WS_MODULE_PLAYER: "Jugador",
  T_43_YU_WS_MODULE_PLAYERSCRIPTS: "Comandos del jugador",
  T_43_YU_WS_MODULE_PRESETCHARACTER: "Personaje preset",
  T_43_YU_WS_MODULE_PROFILE: "Perfil",
  T_43_YU_WS_MODULE_PROPERTYFORMULA: "Propiedades de la fórmula",
  T_43_YU_WS_MODULE_SAFEZONE: "Zona segura",
  T_43_YU_WS_MODULE_SCENE: "Escenario",
  T_43_YU_WS_MODULE_SKILL: "Habilidad",
  T_43_YU_WS_MODULE_STATICSCRIPTS: "Comandos estáticos",
  T_43_YU_WS_MODULE_STATISTICALREPORT: "Reporte",
  T_43_YU_WS_MODULE_STDLIBRARY: "Librería est.",
  T_43_YU_WS_MODULE_STRINGS: "Cadenas",
  T_43_YU_WS_MODULE_TEAM: "Equipo",
  T_43_YU_WS_MODULE_WORKFLOW: "Flujo de trabajo",
  T_43_YU_WS_MONEYICON: "Ícono del dinero",
  T_43_YU_WS_MONEYICON_D: "El ícono del dinero.",
  T_43_YU_WS_MONEYICONCOLOR: "Color del ícono del dinero",
  T_43_YU_WS_MONEYICONCOLOR_D: "El color del ícono del dinero.",
  T_43_YU_WS_MOVESAFEZONE_D: "Mueve fluidamente la zona segura desde su posición inicial hasta la posición final. Los jugadores que estén fuera de la zona recibirán una cierta cantidad de daño.",
  T_43_YU_WS_NEWVECTOR2: "Nuevo Vector2",
  T_43_YU_WS_NEWVECTOR2_D: "Obtiene un nuevo vector 2D",
  T_43_YU_WS_OFFSET_D: "El desplazamiento de la posición del mundo respecto a la entidad objetivo",
  T_43_YU_WS_ONSHOPREQUESTFILLED_D: "Cuando la solicitud de compra del jugador se cumple.",
  T_43_YU_WS_ONSHOPREQUESTPURCHASE_D: "Cuando un jugador solicita ayuda para comprar en la tienda.",
  T_43_YU_WS_ONTOGGLECHANGE_D: "Activar cuando el componente de estado alternable cambie.",
  T_43_YU_WS_OPENSTATE: "Estado inicial",
  T_43_YU_WS_OPENSTATE_D: "Se muestra cuando esté en verdadero y se oculta de lo contrario.",
  T_43_YU_WS_PACEMAKER: "Horizonalina",
  T_43_YU_WS_PACEMAKER_D: "Horizonalina",
  T_43_YU_WS_PARAMS_D: "La lista de parámetros.",
  T_43_YU_WS_PARENT_D: "La entidad grabada durante la seriación.",
  T_43_YU_WS_PHYSICALCCT: "TCC física",
  T_43_YU_WS_PHYSICALCCT_D: "El control del jugador para los efectos físicos.",
  T_43_YU_WS_PLAYER_D: "El jugador comprador.",
  T_43_YU_WS_PLAYERDATAID: "ID de los datos del jugador",
  T_43_YU_WS_PLAYERDATAID_D: "Personalizar ID del recurso del personaje.",
  T_43_YU_WS_PLAYERPHYSXPOSETYPE: "Tipo de posición de Physx del jugador",
  T_43_YU_WS_POSITION: "Posición",
  T_43_YU_WS_POSITION_D: "Coordenadas en el sistema de coordenadas globales.",
  T_43_YU_WS_POSITION_D1: "Coordenadas en el sistema de coordenadas globales. Solo es efectivo para la música en 3D.",
  T_43_YU_WS_PRESSEDSPRITE: "Sprite presionado",
  T_43_YU_WS_PRESSEDSPRITE_D: "El sprite presionado.",
  T_43_YU_WS_PRESSEDSPRITETYPE: "Tipo de sprite presionado",
  T_43_YU_WS_PRESSEDSPRITETYPE_D: "El tipo de sprite pulsado.",
  T_43_YU_WS_PRETIME: "Tiempo previo",
  T_43_YU_WS_RADIUS: "Radio",
  T_43_YU_WS_RANDOMRANGE_D: "Corregir la posición establecida con base en un rango aleatorio.",
  T_43_YU_WS_REQUESTPURCHASETYPE: "Tipo de solicitud de compra",
  T_43_YU_WS_REQUESTPURCHASETYPE_D: "Solicitud de compra en la tienda.",
  T_43_YU_WS_REQUESTTYPE: "Tipo de solicitud",
  T_43_YU_WS_REQUESTTYPE_D: "El tipo de objetivo solicitado por el HUD actual del jugador.",
  T_43_YU_WS_RESPLAYERUUID: "Tipo de jugador preset.",
  T_43_YU_WS_RESPLAYERUUID_D: "El ID del recurso del jugador",
  T_43_YU_WS_RESUUID: "ID del recurso",
  T_43_YU_WS_RESUUID_D: "Especifica el ID del recurso del lote a renderizar.",
  T_43_YU_WS_RIGHTCOLOR: "Color derecho",
  T_43_YU_WS_RIGHTCOLOR_D: "El color del lado derecho.",
  T_43_YU_WS_RIGHTPLAYERARRAY: "Matriz de jugador derecha",
  T_43_YU_WS_RIGHTPLAYERARRAY_D: "La disposición derecha del jugador.",
  T_43_YU_WS_RIGHTSCORE: "Puntuación de la derecha",
  T_43_YU_WS_RIGHTSCORE_D: "La puntuación del lado derecho.",
  T_43_YU_WS_RIGHTSCOREAFTER: "Puntuación derecha posterior",
  T_43_YU_WS_RIGHTSCOREAFTER_D: "La puntuación final en el lado derecho. Se usa en animaciones de transición de puntuación.",
  T_43_YU_WS_ROTATIONQ_D: "El cuaternión en el sistema de coordenadas globales.",
  T_43_YU_WS_ROUNDINFOHUD: "HUD de info. de la ronda",
  T_43_YU_WS_ROUNDINFOHUD_D: "Información mostrada al inicio de una ronda.",
  T_43_YU_WS_SELECTEDCOLOR: "Color seleccionado",
  T_43_YU_WS_SELECTEDCOLOR_D: "El color del sprite seleccionado",
  T_43_YU_WS_SELECTEDSPRITE: "Sprite seleccionado",
  T_43_YU_WS_SELECTEDSPRITE_D: "El sprite seleccionado.",
  T_43_YU_WS_SELECTEDTYPE: "Tipo seleccionado",
  T_43_YU_WS_SELECTEDTYPE_D: "El tipo de sprite seleccionado.",
  T_43_YU_WS_SHADOWCOLOR: "Color de sombra",
  T_43_YU_WS_SHADOWOFFSET: "Desfase de sombra",
  T_43_YU_WS_SHOWTAG: "Mostrar etiqueta",
  T_43_YU_WS_SHOWTAG_D: "Mostrar marcas del equipo/facción.",
  T_43_YU_WS_SHRINKDURATION_D: "La duración de la reducción de la zona segura.",
  T_43_YU_WS_SIMPLERENDER_D: "El componente de renderizado de puente utilizado para renderizar con modelos incorporados.",
  T_43_YU_WS_SKINWIDTH: "Ancho de piel (skin width)",
  T_43_YU_WS_SKINWIDTH_D: "La profundidad de penetración en la cápsula para evitar que el personaje se atore o se tambalee.",
  T_43_YU_WS_SLOPELIMIT: "Límite de pendiente",
  T_43_YU_WS_SLOPELIMIT_D: "Los objetos colocados en la pendiente que superen este ángulo se deslizarán hacia abajo.",
  T_43_YU_WS_SPEED: "Velocidad",
  T_43_YU_WS_STARTDROPTIME_D: "El tiempo de llegada del airdrop en milisegundos.",
  T_43_YU_WS_STARTPOS_D: "La posición inicial de la zona segura.",
  T_43_YU_WS_STATICICONCOLORS: "Colores del ícono estático",
  T_43_YU_WS_STATICICONCOLORS_D: "Colores de los íconos mostrados en el parámetro.",
  T_43_YU_WS_STATICICONS: "Íconos estáticos",
  T_43_YU_WS_STATICICONS_D: "Los íconos mostrados en los parámetros.",
  T_43_YU_WS_STEPOFFSET: "Desfase de paso",
  T_43_YU_WS_STEPOFFSET_D: "Solo los obstáculos que superen esta altura tendrán un efecto de bloqueo.",
  T_43_YU_WS_SUBTITLE: "SubTítulo",
  T_43_YU_WS_SUBTITLE_D: "El subtítulo.",
  T_43_YU_WS_TARGET: "Objetivo",
  T_43_YU_WS_TARGET_D: "La entidad objetivo para el número de daño mostrado.",
  T_43_YU_WS_TARGETICONCOLORS: "Colores del ícono del objetivo",
  T_43_YU_WS_TARGETICONCOLORS_D: "Colores del ícono que muestra el objetivo marcado.",
  T_43_YU_WS_TARGETICONS: "Íconos del objetivo",
  T_43_YU_WS_TARGETICONS_D: "Los íconos mostrados en los objetivos marcados.",
  T_43_YU_WS_TARGETPOS_D: "La posición final objetivo de la zona segura.",
  T_43_YU_WS_TEAM: "Equipo",
  T_43_YU_WS_TEAM_D: "La entidad del equipo en el juego. Cada equipo tiene una entidad.",
  T_43_YU_WS_TEAM_D1: "Solicita ayuda al equipo para la compra.",
  T_43_YU_WS_TIMEOFSTAY_D: "La duración de aparición en  milisegundos.",
  T_43_YU_WS_TITLE: "Título",
  T_43_YU_WS_TITLE_D: "El título principal",
  T_43_YU_WS_TRANSFORM_D: "Rotación, escalado y",
  T_43_YU_WS_UNSELECTEDCOLOR: "Color no seleccionado.",
  T_43_YU_WS_UNSELECTEDCOLOR_D: "El color del sprite no seleccionado.",
  T_43_YU_WS_UNSELECTEDSPRITE: "Sprite no seleccionado.",
  T_43_YU_WS_UNSELECTEDSPRITE_D: "El sprite no seleccionado.",
  T_43_YU_WS_UNSELECTEDTYPE: "Tipo no seleccionado.",
  T_43_YU_WS_UNSELECTEDTYPE_D: "Tipo de sprite no seleccionado.",
  T_43_YU_WS_USEPHYSICALCCT: "Usar TCC",
  T_43_YU_WS_VALUE_D: "El contenido mostrado.",
  T_43_YU_WS_VECTOR2ADD: "Añadir Vector2",
  T_43_YU_WS_VECTOR2GETX: "Vector2 a X",
  T_43_YU_WS_VECTOR2GETY: "Vector2 a Y",
  T_43_YU_WS_VECTOR2SCALE: "Escala de vector2",
  T_43_YU_WS_VECTOR2SETX: "Vector2 establece X",
  T_43_YU_WS_VECTOR2SETY: "Vector2 establece Y",
  T_43_YU_WS_VECTOR2SUB: "Subvector2",
  T_43_YU_WS_VELOCITY: "Velocidad",
  T_43_YU_WS_VERTICALMAXANGLE: "Ángulo vertical máx.",
  T_43_YU_WS_VERTICALMINANGLE: "Ángulo vertical mín.",
  T_43_YU_WS_VISIBILITY_D: "Indica si se puede fijar la visibilidad.",
  T_43_YU_WS_VISIBLE_D: "La configuración de la visibilidad. Si se establece en invisible, el cliente deja de renderizar el objetivo.",
  T_43_YU_WS_X: "X",
  T_43_YU_WS_X_D: "X",
  T_43_YU_WS_Y: "Y",
  T_43_YU_WS_Y_D: "Y",
  T_43_ZY_WS_ITEM319: "Pared supertecnológica A",
  T_43_ZY_WS_ITEM320: "Pared futurista C",
  T_43_ZY_WS_ITEM321: "Ventana futurista",
  T_43_ZY_WS_ITEM322: "Puerta futurista",
  T_43_ZY_WS_ITEM323: "Techo futurista con inclinación a la derecha",
  T_43_ZY_WS_ITEM324: "Techo circular futurista",
  T_43_ZY_WS_ITEM325: "Placa base futurista",
  T_43_ZY_WS_ITEM326: "Placa base circular futurista",
  T_43_ZY_WS_ITEM327: "Escalera futurista",
  T_43_ZY_WS_ITEM328: "Decoración futurista A",
  T_43_ZY_WS_ITEM329: "Edificio futurista A",
  T_43_ZY_WS_ITEM330: "Edificio futurista B",
  T_44_CJ_M_B_SPORT_TH: "Uniforme deportivo (inferior)",
  T_44_CJ_M_H_SPORT_TH: "Uniforme deportivo (cabeza)",
  T_44_CJ_M_S_SPORT_TH: "Uniforme deportivo (zapatos)",
  T_44_CJ_M_T_SPORT_TH: "Uniforme deportivo (superior)",
  T_44_CJ_W_AIRBURST: "M590",
  T_44_H_CHARACTER_DUALMAN_N: "Kairos",
  T_44_H_M24_ONIMUSHA_N: "M24 - Fuego Fatuo",
  T_44_H_USP45_CARNIVORE_N: "USP - Flora devoradora",
  T_44_H_VEHICLESKIN_MOTOBIKE_COLLAGE_N: "Motocicleta - Carrera callejera",
  "T_44_HH_GOLD_AUG-I": "AUG-I",
  "T_44_HH_GOLD_AUG-II": "AUG-II",
  "T_44_HH_GOLD_AUG-III": "AUG-III",
  T_44_JH_WS_CLHALF1: "Forzar inicio con mín. de jugadores",
  T_44_JH_WS_HALFWAYKEY1: "Prioriza iniciar con un equipo completo.",
  T_44_PD_PVE_DRAGON_NAME: "Mecadragón",
  T_44_QL_GRENADE_DRAGON: "Congelación Dracónica",
  T_44_QL_GRENADE_DRAGON_DES: "Un Destello de Hielo mejorado que detonará tres veces consecutivas tras el impacto.",
  T_44_QL_JUMPSHOESX: "Ráfaga dracónica",
  T_44_QL_JUMPSHOESX_DES: "Un par especial de zapatos para saltar que permiten correr en el aire después de un doble salto.",
  T_44_SJ_WS_SAFEZONE_CLOSE_TIME: "Tiempo de cierre de la zona segura",
  T_44_SJ_WS_SAFEZONE_CLOSE_TIME_D: "Tiempo para que desaparezca la zona segura. Si la hora de cierra de la zona segura es menor que la hora de inicio de la zona segura, no se generará ninguna zona segura.",
  T_44_SJ_WS_SAFEZONE_COLOR: "Color de la zona segura",
  T_44_SJ_WS_SAFEZONE_DAMAGE_TIME: "Intervalo de daño",
  T_44_SJ_WS_SAFEZONE_DAMAGE_TIME_D: "Intervalo de daño",
  T_44_SJ_WS_SAFEZONE_DAMAGE_VALUE: "Valor del daño",
  T_44_SJ_WS_SAFEZONE_DAMAGE_VALUE_D: "El daño infligido a un jugador fuera de la zona segura en una sola instancia.",
  T_44_SJ_WS_SAFEZONE_DESC: "Un objeto colocable fuera de la zona",
  T_44_SJ_WS_SAFEZONE_END_RADIUS: "Radio final fuera de la zona",
  T_44_SJ_WS_SAFEZONE_END_RADIUS_D: "Radio final del área fuera de la zona segura",
  T_44_SJ_WS_SAFEZONE_LIVE_PLAYERS: "Lista de jugadores en la zona segura",
  T_44_SJ_WS_SAFEZONE_LIVE_PLAYERS_D: "Obtener la lista de jugadores en la zona segura",
  T_44_SJ_WS_SAFEZONE_NAME: "La zona fuera del área segura",
  T_44_SJ_WS_SAFEZONE_SHRINKTIME: "Duración de la reducción (s)",
  T_44_SJ_WS_SAFEZONE_SHRINKTIME_D: "Tiempo que tarda en reducirse la zona segura",
  T_44_SJ_WS_SAFEZONE_START_RADIUS: "Radio inicial fuera de la zona",
  T_44_SJ_WS_SAFEZONE_START_RADIUS_D: "Radio inicial del área fuera de la zona segura",
  T_44_SJ_WS_SAFEZONE_START_SHRINKTIME: "Tiempo de inicio de reducción",
  T_44_SJ_WS_SAFEZONE_START_SHRINKTIME_D: "Tiempo de inicio de reducción de la zona",
  T_44_SJ_WS_SAFEZONE_STARTTIME: "Tiempo de inicio de la zona segura",
  T_44_SJ_WS_SAFEZONE_STARTTIME_D: "Tiempo para que aparezca la zona segura en la partida en cada ronda. Predeterminado: 0",
  T_44_WT_W_FGG: "FGL-24",
  T_44_WT_W_REWORKHEAT_NAME_X: "PLASMA-X",
  T_44_XXJ_WS_ACTIVATEDALPHA: "Alfa activado",
  T_44_XXJ_WS_ACTIVATEDALPHA_D: "Alfa activado",
  T_44_XXJ_WS_ACTIVESKILLBTNHUD: "Botón del HUD de habilidad activa",
  T_44_XXJ_WS_ADDCOMPONENT_D: "Añade un componente a una entidad. Solo soporta componentes personalizados. (Un componente no se añadirá otra vez si ya existe).",
  T_44_XXJ_WS_ALLMEMBERS: "Todos los miembros",
  T_44_XXJ_WS_ALLOWPRESSEDOUTSIDE: "Permitir presionar afuera",
  T_44_XXJ_WS_ALLOWPRESSEDOUTSIDE_D: "Permitir activación fuera del área designada.",
  T_44_XXJ_WS_ARROWIMAGE: "Imagen de flecha",
  T_44_XXJ_WS_ARROWIMAGE_D: "Imagen de la flecha",
  T_44_XXJ_WS_ARROWOFFSET: "Desfase de flecha",
  T_44_XXJ_WS_ARROWOFFSET_D: "Desfase de flecha",
  T_44_XXJ_WS_ARROWSIZE: "Tamaño de flecha",
  T_44_XXJ_WS_ARROWSIZE_D: "Tamaño de flecha",
  T_44_XXJ_WS_AUTOPLAY_D: "Jugar automáticamente tras crearlo.",
  T_44_XXJ_WS_BACKGROUNDIMAGE: "Imagen del fondo",
  T_44_XXJ_WS_BACKGROUNDIMAGE_D: "Base de la imagen",
  T_44_XXJ_WS_BACKGROUNDRADIUS: "Radio del fondo",
  T_44_XXJ_WS_BACKGROUNDRADIUS_D: "Radio de la base",
  T_44_XXJ_WS_BAGSKINID: "ID de aspecto de mochila",
  T_44_XXJ_WS_BAGSKINID_D: "El ID de aspecto de la mochila",
  T_44_XXJ_WS_BONEPOSITION: "Posición del hueso",
  T_44_XXJ_WS_BONEPOSITION_D: "Coordenadas del mundo del nódulo del hueso",
  T_44_XXJ_WS_CCTMOVE: "Mover TCC",
  T_44_XXJ_WS_COLLIDER: "Colisionador",
  T_44_XXJ_WS_COLLIDERCOLLECTION: "Efecto de colisión",
  T_44_XXJ_WS_COLLIDERCOLLECTION_D: "El componente usado para describir la forma de colisión.",
  T_44_XXJ_WS_COLOR: "Color",
  T_44_XXJ_WS_CONTENT: "Contenido",
  T_44_XXJ_WS_CONTENT_D: "El contenido de la billetera es un conjunto de monedas.",
  T_44_XXJ_WS_CONTEXT_D: "Contenido para impresión",
  T_44_XXJ_WS_CROSSHAIRSHUD: "HUD de la mira",
  T_44_XXJ_WS_CURVE_D: "Curva",
  T_44_XXJ_WS_EFFECTCOLOR_D: "Color de la textura de la superficie.",
  T_44_XXJ_WS_ENABLE: "Activar",
  T_44_XXJ_WS_ENTITY_D: "Entidad",
  T_44_XXJ_WS_GETBAGSKINID_D: "Obtener la configuración de aspecto del jugador",
  T_44_XXJ_WS_GETFACTION_D: "Obtener facción",
  T_44_XXJ_WS_GETLOADEDSCENE_D: "Obtener los escenarios cargados que no han sido desinstalados.",
  T_44_XXJ_WS_GETLOCALPLAYER_D: "Obtener al jugador local",
  T_44_XXJ_WS_GROUPID: "ID del grupo",
  T_44_XXJ_WS_GROUPID_D: "Para lógica interna",
  T_44_XXJ_WS_HUDJOYSTICK: "Widget del HUD de joystick",
  T_44_XXJ_WS_HUDJOYSTICK_D: "Entidad del joystick. Los jugadores pueden editar el HUD a través del editor del HUD.",
  T_44_XXJ_WS_HUDTOUCHPAD: "Widget del HUD del touchpad",
  T_44_XXJ_WS_HUDTOUCHPAD_D: "El widget del panel táctil del HUD que los jugadores pueden editar en el editor del HUD.",
  T_44_XXJ_WS_HUDWIDGETORCUSTOMHUD: "HUD o widget personalizado",
  T_44_XXJ_WS_ICON: "Ícono",
  T_44_XXJ_WS_ICONISALWAYSSHOWN: "Siempre mostrar marca",
  T_44_XXJ_WS_ICONISALWAYSSHOWN_D: "Siempre muestra marcas en la brújula.",
  T_44_XXJ_WS_INACTIVATEDALPHA: "Alpha desactivado",
  T_44_XXJ_WS_INACTIVATEDALPHA_D: "Alpha desactivado",
  T_44_XXJ_WS_INVOKE_ARGS_MISMATCH: "Tras invocar, el número de parámetros reales no coincide con el de parámetros formales. El número esperado es {0}, mientras que el real es {1}.",
  T_44_XXJ_WS_ISDYNAMICOBSTACLE: "Es obstáculo dinámico",
  T_44_XXJ_WS_ISDYNAMICOBSTACLE_D: "Es un obstáculo para NavMesh.",
  T_44_XXJ_WS_ISEND: "Es término",
  T_44_XXJ_WS_ISEND_D: "IsEnd",
  T_44_XXJ_WS_ISSERVERDRIVEN: "Es impulsado por servidor",
  T_44_XXJ_WS_ISSERVERDRIVEN_D: "Si es falso, los objetos personalizados no podrán ser controlados por la API.",
  T_44_XXJ_WS_ISSUC_D: "Regresar resultado de la ejecución",
  T_44_XXJ_WS_JOYSTICKCAPDRAGRADIUS: "Radio de arrastre del joystick",
  T_44_XXJ_WS_JOYSTICKCAPDRAGRADIUS_D: "Radio de arrastre el joystick",
  T_44_XXJ_WS_JOYSTICKCAPIMAGE: "Imagen el joystick",
  T_44_XXJ_WS_JOYSTICKCAPIMAGE_D: "Imagen del joystick",
  T_44_XXJ_WS_JOYSTICKCAPRADIUS: "Radio del joystick",
  T_44_XXJ_WS_JOYSTICKCAPRADIUS_D: "Radio del joystick",
  T_44_XXJ_WS_LISTT_PLAYERSKILLID: "Lista de ID de habilidad de personaje",
  T_44_XXJ_WS_LOOPTYPE_D: "Tipo de bucle",
  T_44_XXJ_WS_MIDGAMEEXITCONFIG: "Salir y abandonar la config.",
  T_44_XXJ_WS_MOUNTABLE: "Jerárquico",
  T_44_XXJ_WS_MOUNTABLE_D: "Entidad capaz de montar nodos hijo",
  T_44_XXJ_WS_MOVEMENT: "Movimiento",
  T_44_XXJ_WS_NAME_D: "Nombre",
  T_44_XXJ_WS_NATURALCONST: "Constante natural",
  T_44_XXJ_WS_NATURALCONST_D: "Enumeración de constantes naturales para reducir las definiciones redundantes.",
  T_44_XXJ_WS_NOTIFYICONANIMATION_D: "Animación del ícono de juego",
  T_44_XXJ_WS_OFFSET_D: "Desplazamiento predeterminado de la base",
  T_44_XXJ_WS_ONFIRE_D: "Activa el evento cada vez que el jugador dispare, ataque con puños o si ataca con armas cuerpo a cuerpo.",
  T_44_XXJ_WS_ONPLAYERSTANDUP_D: "Activa el evento cuando el jugador se pare después de estar  agachado o boca abajo.",
  T_44_XXJ_WS_ONSTARTFIRE_D: "Activa el evento cuando el jugador toca sobre el botón de disparar.",
  T_44_XXJ_WS_OPTION: "Opciones",
  T_44_XXJ_WS_PASSIVESKILLHUD: "HUD de habilidad pasiva",
  T_44_XXJ_WS_PHYSICALMOVER: "Desplazador físico",
  T_44_XXJ_WS_PHYSICALMOVER_D: "Los jugadores en esta plataforma seguirán automáticamente el movimiento y la rotación.",
  T_44_XXJ_WS_PHYSICALOBJECT: "Objeto físico",
  T_44_XXJ_WS_PHYSICALOBJECT_D: "Se le puede aplicar fuerza",
  T_44_XXJ_WS_PI: "Pi",
  T_44_XXJ_WS_PI_D: "La constante matemática π (Pi)",
  T_44_XXJ_WS_PLAYERS: "Lista de jugadores",
  T_44_XXJ_WS_PLAYERS_D: "Lista de jugadores",
  T_44_XXJ_WS_PLAYERSKILLID: "ID de habilidad de personaje",
  T_44_XXJ_WS_PLAYERSKILLID_D: "El ID de la habilidad de personaje en AvatarSkill.csv",
  T_44_XXJ_WS_PREPHYSXPOSE_D: "La pose anterior antes de que el jugador se levante.",
  T_44_XXJ_WS_PRINT: "Imprimir",
  T_44_XXJ_WS_PRINTERROR: "Error de impresión",
  T_44_XXJ_WS_PRINTERROR_D: "Imprimir datos como un error de la consola.",
  T_44_XXJ_WS_PRINTWARNING: "Aviso impreso",
  T_44_XXJ_WS_PRINTWARNING_D: "Imprimir los datos como advertencia a la consola.",
  T_44_XXJ_WS_PRIORITIZEPLAYERSKIN: "Priorizar config. de aspecto de habilidad",
  T_44_XXJ_WS_PRIORITIZEPLAYERSKIN_D: "Prioriza la configuración de aspectos de jugador fuera de la partida.",
  T_44_XXJ_WS_READCSVROWBYKEY_D: "Lee el contenido de las celdas en una fila por número de columna y unidad.",
  T_44_XXJ_WS_REMOVEBAGSKINID_D: "Limpiar configuración de aspecto de la mochila del jugador.",
  T_44_XXJ_WS_REMOVECOMPONENT_D: "Quita un componente de una entidad. Solo soporta componentes personalizados.",
  T_44_XXJ_WS_RESETBAGSKINID_D: "Reiniciar configuración de aspecto de la mochila del jugador a su configuración fuera de la partida.",
  T_44_XXJ_WS_SETBAGSKINID_D: "Establecer configuración de aspecto de mochila.",
  T_44_XXJ_WS_SETPARENTCLIENT_D: "Entidad compatible con los componentes Transform, SkeletonPart, Player y MountPoint.",
  T_44_XXJ_WS_SHOWBACKGROUND: "Mostrar fondo",
  T_44_XXJ_WS_SKINID_D: "ID del aspecto de mochila y configuración de aspecto.",
  T_44_XXJ_WS_SPEED_D: "Velocidad de reproducción",
  T_44_XXJ_WS_TARGET: "Objetivo",
  T_44_XXJ_WS_TARGET_D: "Objetivo",
  T_44_XXJ_WS_TITLE: "Título",
  T_44_XXJ_WS_TYPEID_D: "ID del tipo de componente. Solo soporta componentes personalizados.",
  T_44_XXJ_WS_UPLOADMATCHRESULT_D: "Subir resultados personalizados de la partida",
  T_44_XXJ_WS_WARNINGCSVTYPE: "No coincide el tipo. No se puede leer el contenido de la tabla.",
  T_44_XXJ_WS_X_D: "Coordinar eje X",
  T_44_XXJ_WS_Y_D: "Coordinar eje Y",
  T_44_XYL_WS_CTZSAFEZONE: "Zona segura personalizada",
  T_44_XYL_WS_CTZSAFEZONEDESC: "Genera el punto de inicio y de final de la zona segura con base en las posiciones y propiedades establecidas.",
  T_44_XYL_WS_HEMISPHERICALSHELL: "Caparazón hemisférico",
  T_44_XYL_WS_QUARTERCYLINDER: "Cuarto de cilindro",
  T_44_XYL_WS_SQUAREPYRAMID: "Pirámide cuadrangular",
  T_44_XYL_WS_TORUS: "Forma de anillo",
  T_44_XYL_WS_TRIANGULARPYRAMID: "Pirámide triangular",
  T_44_YU_WS_ADDGAMEEVENTLOGMAP: "Añadir mapa de registro de eventos del juego.",
  T_44_YU_WS_ADDUSEREVENTLOGMAP: "Añadir registro de usuarios del evento",
  T_44_YU_WS_ADDUSEREVENTLOGMAP_D: "El registro de eventos en partidas personalizadas para datos de análisis de experiencia del usuario.",
  T_44_YU_WS_ITEM366: "Pared militar A",
  T_44_YU_WS_ITEM367: "Pared militar B",
  T_44_YU_WS_ITEM368: "Pared militar C",
  T_44_YU_WS_ITEM369: "Pared militar D",
  T_44_YU_WS_ITEM370: "Ventana Militar A",
  T_44_YU_WS_ITEM371: "Ventana Militar B",
  T_44_YU_WS_ITEM372: "Ventana Militar C",
  T_44_YU_WS_ITEM373: "Puerta militar A",
  T_44_YU_WS_ITEM374: "Puerta  militar B",
  T_44_YU_WS_ITEM375: "Techo militar inclinado A",
  T_44_YU_WS_ITEM376: "Techo militar inclinado B",
  T_44_YU_WS_ITEM377: "Escaleras militares A",
  T_44_YU_WS_ITEM378: "Escaleras militares B",
  T_44_YU_WS_ITEM379: "Pilar militar A",
  T_44_YU_WS_ITEM380: "Pasamanos militar A",
  T_45_C_WEAPON_CUST_ENTRANCE: "Personalizar",
  T_45_CJ_TREATMENTGUN_Y_N: "Pistola curativa-Y",
  T_45_H_CHARACTER_ELECTRICGIRL_N: "Kassie",
  T_45_H_EMOTE_MVPDANCE_N: "El baile del campeón",
  "T_45_HH_GOLD_MAC10-I": "MAC10-I",
  "T_45_HH_GOLD_MAC10-II": "MAC10-II",
  "T_45_HH_GOLD_MAC10-III": "MAC10-III",
  T_45_HJ_CAMERA_INSPECTOR: "Inspeccionar",
  T_45_HL_Moderation_fail_1: "Por desgracia, el proyecto que enviaste no pasó la revisión.",
  T_45_HL_Moderation_fail_2: "abarca",
  T_45_HL_Moderation_fail_3: "Por estas razones:",
  T_45_HL_Moderation_fail_Location_1: "Contenido del juego",
  T_45_HL_Moderation_fail_reason_1: "Contenido tóxico",
  T_45_HL_Moderation_fail_reason_10: "Infracción a las reglas de la comunidad",
  T_45_HL_Moderation_fail_reason_11: "Impactos negativos en la economía del juego e infracciones a la propiedad virtual.",
  T_45_HL_Moderation_fail_reason_2: "Contenido inapropiado",
  T_45_HL_Moderation_fail_reason_3: "Temas políticos",
  T_45_HL_Moderation_fail_reason_4: "Información falsa",
  T_45_HL_Moderation_fail_reason_5: "Infracción a derechos de autor",
  T_45_HL_Moderation_fail_reason_6: "Infracción de privacidad",
  T_45_HL_Moderation_fail_reason_7: "Problemas de seguridad",
  T_45_HL_Moderation_fail_reason_8: "Discurso de odio",
  T_45_HL_Moderation_fail_reason_9: "Spam",
  T_45_HL_Moderation_fail_reason_999: "Otros problemas",
  T_45_JH_WS_CLEMPTYOBJECT: "Grupo de objeto",
  T_45_JH_WS_PETSWITCH1: "Mostrar las mascotas en la partida o no.",
  T_45_QL_CSFPP_DES: "¡Elimina a todos los oponentes con la perspectiva en primera persona del modo especial en DE!",
  T_45_QL_CSFPP_NAME: "Duelo de Escuadras: PPP",
  T_45_QL_CSFPP_RANKNAME: "Primera persona",
  T_45_SJ_WS_REVIEW_23: "Contenido del juego",
  T_45_SJ_WS_REVIEW_24: "{0} abarca {1}",
  T_45_SJ_WS_REVIEW_25: "{0} {1} abarca {2}",
  T_45_SJ_WS_REVIEW_26: "[FFBA00]Toca para ver los detalles >>[-]",
  T_45_SJ_WS_REVIEW_27: "No aprobado",
  T_45_SJ_WS_REVIEW_28: "Comentarios de revisión",
  T_45_SJ_WS_REVIEW_29: "El contenido abarca {0} infracción(es)",
  T_45_SJ_WS_REVIEW_31: "No aprobado",
  T_45_SJ_WS_REVIEW_32: "La revisión falló debido a excepciones del servidor.",
  T_45_SJ_WS_REVIEW_TITLE: "Detalles de la infracción",
  T_45_SJ_WS_VAULTTRIGGER_DES: "Activa el salto sobre obstáculos",
  T_45_SJ_WS_VAULTTRIGGER_DISTANCE: "Distancia del inventario",
  T_45_SJ_WS_VAULTTRIGGER_DISTANCE_DES: "Modifica la distancia de salto.",
  T_45_SJ_WS_VAULTTRIGGER_HEIGHT: "Altura del inventario",
  T_45_SJ_WS_VAULTTRIGGER_HEIGHT_DES: "Controla la altura del movimiento hacia arriba y abajo cuando pases obstáculos.",
  T_45_SJ_WS_VAULTTRIGGER_NAME: "Activador del salto",
  T_45_TYC_CL_TEMPLATE_WS: `Un modo de eliminación en el que los jugadores eliminan a todos los equipos contrarios en una intensa batalla para obtener la victoria.
Puedes establecer las reglas del juego y editar los parámetros del juego como prefieras.`,
  T_45_W_SPEEDMODE_FLIGHT_N: "Rompecielos",
  T_45_XXJ_WS_ACTIONTYPE_D: "0 = autoataque, 1 = ataque defensivo, 2 = no atacar",
  T_45_XXJ_WS_ADDFRIEND: "Añadir amigo",
  T_45_XXJ_WS_API: "API",
  T_45_XXJ_WS_AUTO: "Automático",
  T_45_XXJ_WS_BASEDATA: "Data base",
  T_45_XXJ_WS_BOTH: "Ambos",
  T_45_XXJ_WS_BYHIERARCHY: "Por jerarquía",
  T_45_XXJ_WS_BYPRIORITYHIGHTOLOW: "Por prioridad alta a baja",
  T_45_XXJ_WS_BYPRIORITYLOWTOHIGH: "Por prioridad baja a alta",
  T_45_XXJ_WS_CAMERA: "Cámara",
  T_45_XXJ_WS_CAMERATYPE: "Tipo de cámara",
  T_45_XXJ_WS_CENTERINVISIBLE: "Centro invisible",
  T_45_XXJ_WS_CLIENT: "Cliente",
  T_45_XXJ_WS_COLLIDERID: "ID del colisionador",
  T_45_XXJ_WS_COLLIDERID_D: "El ID del colisionador",
  T_45_XXJ_WS_COMPONENT: "Componente",
  T_45_XXJ_WS_CURRENTCAMERA: "Cámara actual",
  T_45_XXJ_WS_CUSTOMPUSHFORCE: "Fuerza de empuje personalizada",
  T_45_XXJ_WS_DOUBLE: "Doble",
  T_45_XXJ_WS_DUMP: "Arrojar",
  T_45_XXJ_WS_ENABLEMOVEINMIDAIR: "Activar movimiento a mitad del aire",
  T_45_XXJ_WS_ENABLEROTATEWITHGRAVITY: "Activar rotación con gravedad",
  T_45_XXJ_WS_ENUM: "Enumerar",
  T_45_XXJ_WS_EVENT: "Evento",
  T_45_XXJ_WS_FILLAMOUNT: "Cantidad de relleno",
  T_45_XXJ_WS_FILLDIR: "Dirección del relleno",
  T_45_XXJ_WS_FIRETYPE: "Tipo de disparo",
  T_45_XXJ_WS_FIRETYPE_D: "El tipo de disparo",
  T_45_XXJ_WS_FIXEDDELTATIME: "Tiempo delta fijo",
  T_45_XXJ_WS_FIXEDDELTATIME_D: "El intervalo de tiempo fijo para las actualizaciones de cuadros en milisegundos.",
  T_45_XXJ_WS_FORWARD: "Enviar",
  T_45_XXJ_WS_FORWARD_D: "La dirección del eje z en el sistema de coordenadas local.",
  T_45_XXJ_WS_FUNCTIONTYPE: "Tipo de función",
  T_45_XXJ_WS_FUNCTIONTYPE_D: "El tipo de función",
  T_45_XXJ_WS_GETLOCALAIMDIRECTION_D: "La dirección de apuntado del jugador local",
  T_45_XXJ_WS_GETLOCALTIMESTAMP_D: "Obtener la marca de tiempo local",
  T_45_XXJ_WS_GRADIENT: "Gradiente",
  T_45_XXJ_WS_GRADIENTBOTTOM: "Gradiente inferior",
  T_45_XXJ_WS_GRADIENTBOTTOMALPHA: "Gradiente inferior alfa",
  T_45_XXJ_WS_GRADIENTTOP: "Gradiente superior",
  T_45_XXJ_WS_GRADIENTTOPALPHA: "Gradiente superior alfa",
  T_45_XXJ_WS_HITPOSITION_D: "La posición del mundo del objetivo impactado por las balas.",
  T_45_XXJ_WS_HUDSOCIALBUTTONWIDGET: "Widget de botón social de la IU",
  T_45_XXJ_WS_INVERTFILL: "Invertir relleno",
  T_45_XXJ_WS_ISGROUNDED: "Está anclado",
  T_45_XXJ_WS_ISSILENCE: "Es silencio",
  T_45_XXJ_WS_ISSILENCE_D: "Si está silenciado o no",
  T_45_XXJ_WS_ISSINGLESHOT: "Es un solo disparo",
  T_45_XXJ_WS_ISSINGLESHOT_D: "Si es un solo disparo o no",
  T_45_XXJ_WS_JUMPHEIGHT: "Altura del salto",
  T_45_XXJ_WS_JUMPHEIGHT_D: "La altura del salto",
  T_45_XXJ_WS_LAYOUTSORTTYPE: "Tipo de disposición de clase",
  T_45_XXJ_WS_LIGHT_D: "Luces",
  T_45_XXJ_WS_LOCAL: "Local",
  T_45_XXJ_WS_MAXMULTIJUMPNUM: "Conteo máx. de saltos",
  T_45_XXJ_WS_MODULE: "Módulo",
  T_45_XXJ_WS_NONE: "Ninguno",
  T_45_XXJ_WS_ONBEFOREHURT_D: "Ejecuta el comando cada vez antes de que la entidad inflija daño.",
  T_45_XXJ_WS_ONDISABLE_D: "Ejecutar cuando la entidad esté desactivada.",
  T_45_XXJ_WS_ONEACHLOOP_D: "Ejecutar cada vez. La jugabilidad está en bucle. Solo es efectivo del lado del cliente para entidades tales como los efectos de sonido y especiales.",
  T_45_XXJ_WS_ONENABLE_D: "Ejecutar cuando la entidad esté activada.",
  T_45_XXJ_WS_ONFIXEDUPDATE_D: "Cuando se entre a un cuadro a una velocidad de cuadros de 30 FPS",
  T_45_XXJ_WS_ONFRIENDRELATIONCHANGE_D: "Activar el cliente del evento cuando el jugador añada o elimine a un amigo.",
  T_45_XXJ_WS_ONGAMEPAUSE_D: "Activa el evento cuando el juego se pause debido a la solicitud de la API.",
  T_45_XXJ_WS_ONGAMERESUME_D: "Activa el evento cuando el juego se reanude debido a la solicitud de la API.",
  T_45_XXJ_WS_ONPLAYERSTOPDASH_D: "Cuando el jugador deje de esprintar",
  T_45_XXJ_WS_ONPLAYERSTOPSWIMSURFING_D: "Cuando el jugador deje de surfear",
  T_45_XXJ_WS_ONPLAYERSWIMSURFING_D: "Cuando el jugador esté surfeando",
  T_45_XXJ_WS_PHYSICALLAYER_D: "La capa física personalizada dentro de un rango de 0 a 31.",
  T_45_XXJ_WS_PLATFORMTYPE: "Tipo de plataforma",
  T_45_XXJ_WS_PLATFORMTYPE_D: "El tipo de plataforma",
  T_45_XXJ_WS_PLAYER: "Jugador",
  T_45_XXJ_WS_PLAYERCCT: "TCC del jugador",
  T_45_XXJ_WS_PLAYERCCT_D: "Un controlador de personajes con efectos físicos y utilizado solo para personajes de Free Fire.",
  T_45_XXJ_WS_PRIORITY: "Prioridad",
  T_45_XXJ_WS_REMAINMULTINUM: "Número restante de saltos",
  T_45_XXJ_WS_REPORT: "Reportar",
  T_45_XXJ_WS_RIGHT: "Derecha",
  T_45_XXJ_WS_RIGHT_D: "La dirección del eje x en el sistema de coordenadas local.",
  T_45_XXJ_WS_SERVER: "Servidor",
  T_45_XXJ_WS_SINGLE: "Individual",
  T_45_XXJ_WS_SOCIALBUTTONSTYLETYPE: "Tipo de estilo de botón social",
  T_45_XXJ_WS_SOCIALBUTTONSTYLETYPE_D: "El estilo del botón social",
  T_45_XXJ_WS_SOCIALBUTTONTYPE: "Tipo de botón social",
  T_45_XXJ_WS_SOCIALBUTTONTYPE_D: "El tipo de botón social",
  T_45_XXJ_WS_SORTTYPE_D: "Tipos de ordenación: ascendente no nula, descendente y ascendente.",
  T_45_XXJ_WS_SPEEDWHILEAIMING: "Velocidad de movimiento al apuntar",
  T_45_XXJ_WS_SPEEDWHILEAIMING_D: "La velocidad de movimiento cuando apuntes hacia abajo.",
  T_45_XXJ_WS_STRINGORLOCSTRING: "Cadena o cadena localizada",
  T_45_XXJ_WS_TRIPLE: "Triple",
  T_45_XXJ_WS_UP: "Arriba",
  T_45_XXJ_WS_UP_D: "La dirección del eje y en el sistema de coordenadas local.",
  T_45_XXJ_WS_USECUSTOMPUSHFORCE: "Utilizar la fuerza de empuje personalizada",
  T_45_XXJ_WS_Z: "Z",
  T_45_XXJ_WS_Z_D: "Z",
  T_45_ZD_VEHICLEDROP_R_DESC: "Lanza una bengala que señalará la zona designada para invocar a un vehículo al azar.",
  T_45_ZD_VEHICLEDROP_R_NAME: "Vehículo misterioso",
  T_46_H_CHARACTER_MISCHIEFGIRL_N: "Lila",
  T_46_HJ_SHARE_GAMEDURATION: "Tiempo jugado",
  T_46_HJ_WS_SHAREBY: "Por {0}",
  T_46_HJ_WS_SHAREGAMEMODE: "Modo de juego",
  T_46_HJ_WS_SHARETEAM: "Equipo",
  T_46_HJ_WS_SHARETEAMVS: "{0} vs {1}",
  T_46_HX_B_SCHOOL_VN: "El mejor de la clase (inferior)",
  T_46_HX_H_SCHOOL_VN: "El mejor de la clase (cabeza)",
  T_46_HX_S_SCHOOL_VN: "El mejor de la clase (zapatos)",
  T_46_HX_T_SCHOOL_VN: "El mejor de la clase (superior)",
  T_46_JH_WS_CLGUIDE_TUTORIAL: "Tutorial",
  T_46_LYF_RANKBOARD_TIPS_OTHERS: "Otros",
  T_46_XXJ_WS_ACTUALPOSITION: "Posición actual",
  T_46_XXJ_WS_ADDSPECIALFOLLOW_D: "Añade el objeto a vigilar con sincronización AOI más allá de la línea de visión.",
  T_46_XXJ_WS_APPEARANCE: "Apariencia",
  T_46_XXJ_WS_APPEARANCERES: "Recurso de apariencia",
  T_46_XXJ_WS_BECOME: "Activar",
  T_46_XXJ_WS_BRAKETORQUE_D: "La potencia que se da al vehículo cuando se utiliza el freno o la reversa.",
  T_46_XXJ_WS_CAMERAVIEWINGANGLERESTRICTIONTYPE: "Tipo de restricción del ángulo de giro de la cámara",
  T_46_XXJ_WS_CLEANSPECIALFOLLOW_D: "Borra todos los objetos monitorizados del objetivo.",
  T_46_XXJ_WS_CRASHMAXDAMAGE_D: "El daño máximo por choque usado en el cálculo de daño.",
  T_46_XXJ_WS_CRASHMAXSPEED: "Velocidad máx. de choque",
  T_46_XXJ_WS_CRASHMAXSPEED_D: "Se usa para calcular el daño por choque. Cuando se supere esta velocidad, no se añadirá más daño.",
  T_46_XXJ_WS_CRASHMESSFACTOR: "Factor de masa de choque",
  T_46_XXJ_WS_CRASHMESSFACTOR_D: "Un parámetro utilizado en la fórmula de daños para el cálculo de daños por colisión.",
  T_46_XXJ_WS_CRASHMINDAMAGE_D: "El mínimo de daño por choque usado para cálculo.",
  T_46_XXJ_WS_DB_OVERLIMIT_D: "Se ha superado el límite de lectura y escritura del almacenamiento de datos.",
  T_46_XXJ_WS_DB_PARAMERROR_D: "Excepción del parámetro",
  T_46_XXJ_WS_DB_TIMEOUT_D: "Tiempo de espera de almacenamiento de datos. Ahora se aplica principalmente a la lectura y escritura.",
  T_46_XXJ_WS_DELTA: "Delta",
  T_46_XXJ_WS_EDITNPCCOLLIDERTIPS: "Editar apariencia",
  T_46_XXJ_WS_ENDVALUE_D: "El valor de destino",
  T_46_XXJ_WS_ENGINETORQUE_D: "Los caballos de fuerza otorgados al vehículo cuando se usa el acelerador.",
  T_46_XXJ_WS_ERRORCODE_D: "Enumeración del código de error",
  T_46_XXJ_WS_EULARANGLETOVECTOR3: "Ángulo de Euler a Vector3",
  T_46_XXJ_WS_EULARANGLETOVECTOR3_D: "Convierte el ángulo Euler a un vector 3D.",
  T_46_XXJ_WS_EXPIRE: "Caduca",
  T_46_XXJ_WS_FEMALEAVATAR: "Personaje femenino",
  T_46_XXJ_WS_GETPREMIUMEXPIREDATE: "Obtener fecha de término de la membresía",
  T_46_XXJ_WS_HASSPECIALFOLLOW_D: "Si el observador está vigilando un objeto o no.",
  T_46_XXJ_WS_HELICOPTER: "Rompecielos",
  T_46_XXJ_WS_HELICOPTER_D: "Un tipo de vehículo volador",
  T_46_XXJ_WS_HIGHSPEEDSTEERANGLE: "Restricción de la dirección a alta velocidad",
  T_46_XXJ_WS_HIGHSPEEDSTEERANGLE_D: "El ángulo máximo de giro a alta velocidad.",
  T_46_XXJ_WS_HIGHSPEEDSTEERANGLEATSPEED: "Ángulo de giro a alta velocidad acelerando",
  T_46_XXJ_WS_HIGHSPEEDSTEERANGLEATSPEED_D: "El umbral de velocidad para el ángulo máximo de giro a alta velocidad.",
  T_46_XXJ_WS_IDLE: "Animación inactiva",
  T_46_XXJ_WS_IDLEBRAKEINPUT: "Entrada del freno",
  T_46_XXJ_WS_IDLEBRAKEINPUT_D: "Cuando no conduzcas un vehículo, deceléralo con (Entrada de freno) x (Frenar con freno y acelerador).",
  T_46_XXJ_WS_INTTOFLOAT: "Int a Flotante",
  T_46_XXJ_WS_INTTOFLOAT_D: "Convertir un número entero en un número de coma flotante.",
  T_46_XXJ_WS_ISPREMIUM: "Es Membresía",
  T_46_XXJ_WS_LEADERBOARDNAME_D: "El nombre de la clasificación en la base de datos.",
  T_46_XXJ_WS_MALEAVATAR: "Personaje masculino",
  T_46_XXJ_WS_MODULE_AICHARACTOR: "Persona con IA",
  T_46_XXJ_WS_NEWUMAAPPEARANCE: "Nuevo aspecto de UMA",
  T_46_XXJ_WS_NONE_D: "Sin errores",
  T_46_XXJ_WS_NPC: "NPC",
  T_46_XXJ_WS_NPC_D: "El objeto NPC",
  T_46_XXJ_WS_NPCCOLLIDERTIPS: "Consejos: Los PNJ (NPCs) humanoides suelen tener un modelo de colisión con una cápsula de 1.4 m de altura y 0.25 m de radio. Los PNJ de mascota suelen tener un modelo de colisión con una cápsula de 1 m de altura y 0.4 m de radio.",
  T_46_XXJ_WS_OBSERVER_D: "El observador que está monitoreando objetos.",
  T_46_XXJ_WS_ONPLAYERENTERPREMIUMCENTER: "Al entrar a la membresía de Crea Tu Mapa",
  T_46_XXJ_WS_ONPLAYERLEAVEPREMIUMCENTER: "Al abandonar la membresía de Crea Tu Mapa",
  T_46_XXJ_WS_OPENPREMIUMCENTER: "Abrir Membresía de Crea Tu Mapa",
  T_46_XXJ_WS_PERSONA: "Sobreviviente",
  T_46_XXJ_WS_PERSONACENTER: "Centro del sobreviviente",
  T_46_XXJ_WS_PET: "Mascota",
  T_46_XXJ_WS_PLAYERORTRANSFORM: "Jugador o transformación",
  T_46_XXJ_WS_PLAYERORTRANSFORM_D: "Un alias para la entidad jugador y transformar.",
  T_46_XXJ_WS_PREMIUM: "Membresía",
  T_46_XXJ_WS_PREMIUMSTATUS: "Estado de la membresía",
  T_46_XXJ_WS_PROXYOBSERVER: "Observador proxy",
  T_46_XXJ_WS_PROXYOBSERVER_D: "El observador proxy",
  T_46_XXJ_WS_REMOVESPECIALFOLLOW_D: "Retira el objeto monitoreado y cancela la sincronización del AOI más allá de la línea de visión.",
  T_46_XXJ_WS_RENEWAL: "Renovar",
  T_46_XXJ_WS_ROTATEVECTOR: "Rotar vector",
  T_46_XXJ_WS_ROTATEVECTOR_D: "Rota un vector con base en los cuaterniones",
  T_46_XXJ_WS_SKIN: "Equipo",
  T_46_XXJ_WS_STARTVALUE_D: "El valor de la fuente",
  T_46_XXJ_WS_STATUS: "Estado",
  T_46_XXJ_WS_SWITCHUSERPROXYOBSERVER_D: "Cambiar el observador proxy del Usuario",
  T_46_XXJ_WS_TARGET_D: "El objetivo monitoreado",
  T_46_XXJ_WS_USER_D: "El usuario",
  T_46_XXJ_WS_VALUE: "Valor",
  T_46_XXJ_WS_VALUE_D: "Vector",
  T_46_XYL_WS_CTZSAFEZONEEND: "Punto final de la zona segura",
  T_46_XYL_WS_RESOURCETYPE1: "Estructuras básicas",
  T_46_XYL_WS_RESOURCETYPE1_1: "Geometría",
  T_46_XYL_WS_RESOURCETYPE1_2: "Visual y audio",
  T_46_XYL_WS_RESOURCETYPE2: "Objetos de escena",
  T_46_XYL_WS_RESOURCETYPE2_2: "Suministros de batalla",
  T_46_XYL_WS_RESOURCETYPE3: "Naturaleza",
  T_46_XYL_WS_RESOURCETYPE4: "Componente modular",
  T_46_XYL_WS_TYPEOTHERPROP: "Varios",
  T_46_XYL_WS_TYPEOTHERPROPBOX: "Contenedores y cajas",
  T_47_CJ_FOREGRIP_SOFT_N: "Empuñadura Ligera",
  T_47_CJ_MAGEZINE_FAST_N: "Cargador Rápido",
  T_47_CJ_STOCK_FAST_N: "Culata de Poder",
  T_47_GT_WS_USERMANUAL: "Manual de usuario",
  T_47_HJ_WS_VFX_FOG: "VFX de Niebla",
  T_47_HJ_WS_VFX_LIGHTING: "VFX de Iluminación",
  T_47_HJ_WS_VFX_TRAILING: "VFX de seguimiento",
  T_47_HL_CL_CREATOR_LABEL1: "Talento de la comunidad",
  T_47_HL_CL_MAP_LABEL1: "Las obras seleccionadas por talentos de la comunidad",
  T_47_JH_WS_MODERATION_REASON12: "Relacionado con apuestas",
  T_47_RW_NB_GP_GAMEAFFIX_HINT1: "Colaboración con NARUTO SHIPPUDEN",
  T_47_SD_RES_MATERIAL: "Archivo del material",
  T_47_SD_RES_MESH: "Malla",
  T_47_SD_WS_MAPTAG_AI: "Generación de mapa por IA",
  T_47_WT_W_NB_GP_KA_EXPLODE_DESC: "Un cuchillo especial que se clava en el punto de impacto tras ser lanzado y que explota tras un breve retraso para infligir daño por quemadura.",
  T_47_WT_W_NB_GP_KA_EXPLODE_NAME: "Kunai explosivo",
  T_47_WT_W_NB_GP_KA_THUNDER_DESC: "Un cuchillo especial que se clava en el punto de impacto tras ser lanzado que libera un rayo tras un breve retraso para paralizar al objetivo.",
  T_47_WT_W_NB_GP_KA_THUNDER_NAME: "Kunai del rayo",
  T_47_WT_W_NB_GP_KA_WIND_DESC: "Un cuchillo especial que se clava en el punto de impacto tras ser lanzado que desencadena una ráfaga de viento tras un breve retraso que ralentiza al objetivo moviéndose hacia su centro.",
  T_47_WT_W_NB_GP_KA_WIND_NAME: "Kunai de viento",
  T_47_WT_W_NB_GP_SRK_HEAVY_DESC: "Un tipo de shuriken adecuada para el combate a medio y largo alcance. Al lanzarla, se rápidamente una pieza que inflige muchísimo daño.",
  T_47_WT_W_NB_GP_SRK_HEAVY_NAME: "Shuriken pesada",
  T_47_WT_W_NB_GP_SRK_LIGHT_DESC: "Un tipo de shuriken adecuada para el combate a corto y medio alcance con dos modos de ataque. Al lanzarla, se lanzan tres piezas que infligen una pequeña cantidad de daño.",
  T_47_WT_W_NB_GP_SRK_LIGHT_NAME: "Shriken Ligera",
  T_47_XXJ_WS_ACTION: "Acción",
  T_47_XXJ_WS_AOISETTING: "Ajustes de IOA",
  T_47_XXJ_WS_BAGSKINTYPE: "Tipo de aspecto de mochila",
  T_47_XXJ_WS_CLEARMEMORY: "Borrar memoria",
  T_47_XXJ_WS_CLNPC: "NPC avanzado",
  T_47_XXJ_WS_CLOTHTYPE: "Tipo de aspecto",
  T_47_XXJ_WS_COMMON_ERROR: "Error común",
  T_47_XXJ_WS_CONTENT: "Contenido",
  T_47_XXJ_WS_CREATERANDOMSEED: "Crear semilla aleatoria",
  T_47_XXJ_WS_ELAPSEDPERCENTAGE: "Porcentaje transcurrido",
  T_47_XXJ_WS_ENABLEUGCFOGFEATURE: "Activar función de niebla",
  T_47_XXJ_WS_ENABLEUGCLIGHTROTATEFEATURE: "Activar la función de rotación de la luz",
  T_47_XXJ_WS_ERRORCODE: "Código de error",
  T_47_XXJ_WS_EXPONENTIAL: "Exponencial",
  T_47_XXJ_WS_EXPONENTIALSQUARED: "Exponencial al cuadrado",
  T_47_XXJ_WS_FAILED_INVALIDALLIDSONCREATE: "Error al crear sala: no hay ID de jugador válido",
  T_47_XXJ_WS_FOG: "Niebla",
  T_47_XXJ_WS_FOGDENSITY: "Densidad de la niebla",
  T_47_XXJ_WS_FOGENDDISTANCE: "Distancia de término de la niebla",
  T_47_XXJ_WS_FOGMODE: "Modo de neblina",
  T_47_XXJ_WS_FOGMODETYPE: "Tipo de Modo Niebla",
  T_47_XXJ_WS_FOGSTARTDISTANCE: "Distancia de inicio de la niebla",
  T_47_XXJ_WS_HEIGHTSCALE: "Escala de altura",
  T_47_XXJ_WS_ISVISIBLE: "Está visible",
  T_47_XXJ_WS_JOINNEWTEAM: "Unirse a un nuevo equipo",
  T_47_XXJ_WS_JOINTEAM: "Unirse al equipo",
  T_47_XXJ_WS_LIGHTROTATE: "Rotación ligera",
  T_47_XXJ_WS_LINEAR: "Linear",
  T_47_XXJ_WS_LLMCHATHUD: "Chat de IU de persona",
  T_47_XXJ_WS_NEWTEAM: "Nuevo equipo",
  T_47_XXJ_WS_NEXT: "Siguiente",
  T_47_XXJ_WS_NPC_TIP: "Puedes editar la apariencia de los NPC y hacer que los NPC reproduzcan animaciones",
  T_47_XXJ_WS_OBSERVERS: "Observadores",
  T_47_XXJ_WS_ONHUDSENDMESSAGETOPERSONA: "Al mandar mensaje del jugador por una persona del chat de IU",
  T_47_XXJ_WS_ONPREMIUMCHANGE: "Al cambiar el estado de la membresía",
  T_47_XXJ_WS_ONRECEIVEACTIONFROMPERSONA: "Al recibir una acción de una persona",
  T_47_XXJ_WS_ONRECEIVECONTENTFROMPERSONA: "Al recibir contenido de una persona",
  T_47_XXJ_WS_ONRECEIVEFINISHFROMPERSONA: "Al recibir término de la persona",
  T_47_XXJ_WS_ONRECEIVESTATUSFROMPERSONA: "Al recibir un estado de una persona",
  T_47_XXJ_WS_PARTICLESID: "ID de las partículas",
  T_47_XXJ_WS_PERSONAAVATAR: "Ícono de persona",
  T_47_XXJ_WS_PERSONAID: "ID de la persona",
  T_47_XXJ_WS_PERSONANICKNAME: "Apellido de la persona",
  T_47_XXJ_WS_PLAYERORNPC: "Jugador o NPC",
  T_47_XXJ_WS_PREMIUM_CLOSED: "Suscripción cancelada",
  T_47_XXJ_WS_RANDOM: "Aleatorio",
  T_47_XXJ_WS_SEED: "Semilla",
  T_47_XXJ_WS_SENDER: "Remitente",
  T_47_XXJ_WS_SETPERSONAOBSERVER: "Establecer observador de la persona",
  T_47_XXJ_WS_SETPLAYERCANQUITMIDWAY: "El jugador establecido puede abandonar a mitad de la partida",
  T_47_XXJ_WS_SHOULDREPLY: "ShouldReply",
  T_47_XXJ_WS_SHOWSYSTEMREPLY: "Mostrar respuesta del sistema",
  T_47_XXJ_WS_SPOTANGLE: "Ángulo del punto",
  T_47_XXJ_WS_SPOTLIGHT: "Destacado",
  T_47_XXJ_WS_SYSTEMMESSAGETOPERSONA: "Enviar mensaje de sistema a la persona",
  T_47_XXJ_WS_SYSTEMMESSAGETOPERSONASTREAM: "Transmitir mensajes del sistema a la persona",
  T_47_XXJ_WS_TARGETTEAM: "Equipo objetivo",
  T_47_XXJ_WS_THISENTITY: "Esta entidad",
  T_47_XXJ_WS_USERAVATAR: "Ícono del usuario",
  T_47_XXJ_WS_USERMESSAGETOPERSONA: "Enviar mensaje de usuario a la persona",
  T_47_XXJ_WS_USERMESSAGETOPERSONASTREAM: "Transmitir mensajes de usuario a la persona",
  T_47_XXJ_WS_USERNICKNAME: "Apodo del usuario",
  T_47_XXJ_WS_VEHICLESKINTYPE: "Tipo de aspecto de vehículo",
  T_47_XXJ_WS_WEAPONSKINTYPE: "Tipo de aspecto de arma",
  T_47_XYL_NB_UGC_EFFECT001: "Efecto de Rasengan",
  T_47_XYL_NB_UGC_EFFECT002: "Efecto de Chidori",
  T_47_XYL_NB_UGC_EFFECT003: "Efecto del Golpe del cerezo",
  T_47_XYL_NB_UGC_EFFECT004: "Efecto de Jutsu Bola de Fuego",
  T_47_XYL_NB_UGC_EFFECT005: "Efecto de Jutsu Dragón de Agua",
  T_47_XYL_NB_UGC_EFFECT006: "Efecto del Jutsu Gran Ruptura",
  T_47_XYL_NB_UGC_EFFECT007: "Efecto Bola Bestia con Cola",
  T_47_XYL_NB_UGC_EFFECT008: "Marca de Reencarnación del Mundo Impuro",
  T_47_XYL_UGC_CRAFTLANDSHOP: "Tienda de Recursos",
  T_47_XYL_UGC_DONKEYCART: "Carrito Burrito",
  T_47_XYL_UGC_SPOTLIGHT: "Destacado",
  T_47_XYL_UGC_SPOTLIGHTANGLE: "Ángulo de Destacado",
  T_48_H_EMOTE_WATERFEST25_N: "Pasos ligeros",
  T_48_H_VEHICLESKIN_MOTOBIKE_WATERFEST25_N: "Motocicleta - Olas de cristal",
  T_48_HJ_AC_STATENOTEXIST: "El estado {0} no existe en la animación del controlador",
  T_48_HL_CODESCRIPT: "Código del script",
  T_48_HL_GLOBAL_VAR: "Nombre de la variable global",
  T_48_HL_GRAPH: "Bloque",
  T_48_HL_HUD: "HUD",
  T_48_HL_LEADERBOARD_NAME: "Tabla de clasificación",
  T_48_HL_LOCAL_VAR: "Nombre de la variable local",
  T_48_HL_LOCALIZATION: "Nombre localizado",
  T_48_HL_OPEN_ATTRIBUTES: "Nombre del atributo abierto",
  T_48_HX_A_WATERFEST25: "Olas de cristal (máscara)",
  T_48_HX_B_WATERFEST25: "Olas de cristal (inferior)",
  T_48_HX_F_B_BLACKDRESS: "Antimateria (inferior)",
  T_48_HX_F_H_BLACKDRESS: "Antimateria (cabeza)",
  T_48_HX_F_HA_BLACKDRESS: "Antimateria (maquillaje)",
  T_48_HX_F_S_BLACKDRESS: "Antimateria (zapatos)",
  T_48_HX_F_T_BLACKDRESS: "Antimateria (superior)",
  T_48_HX_H_WATERFEST25: "Olas de cristal (cabeza)",
  T_48_HX_HA_WATERFEST25: "Olas de cristal (maquillaje)",
  T_48_HX_M_A_BLACKDRESS: "Materia oscura (máscara)",
  T_48_HX_M_B_BLACKDRESS: "Materia oscura (inferior)",
  T_48_HX_M_H_BLACKDRESS: "Materia oscura (cabeza)",
  T_48_HX_M_HA_BLACKDRESS: "Materia oscura (maquillaje)",
  T_48_HX_M_S_BLACKDRESS: "Materia oscura (zapatos)",
  T_48_HX_M_T_BLACKDRESS: "Materia oscura (superior)",
  T_48_HX_S_WATERFEST25: "Olas de cristal (zapatos)",
  T_48_HX_T_WATERFEST25: "Olas de cristal (superior)",
  T_48_JH_WS_STRINGDESC: 'Introduce un párrafo de texto u otras cadenas. Algunos widgets pueden mostrar texto enriquecido. Añade color al texto con texto enriquecido utilizando el siguiente formato: [#XXXXXX] texto texto [-]. "#XXXXXX" es el color que deseas mostrar. Ten en cuenta que el color del texto del widget relacionado debe ser blanco.',
  T_48_M_WS_P_ICON: "Ícono",
  T_48_META_API_10001: "Hallar entidad por ID",
  T_48_META_API_10001_P0: "ID de la entidad",
  T_48_META_API_1098: "Lectura por lotes del valor de la hoja de la base de datos",
  T_48_META_API_1098_D: "Leer por lotes varias entradas de datos de una hoja especificada de la base de datos, en la que las entradas de la lista de IDs de jugador únicos se correspondan una a una con las de la lista de datos.",
  T_48_META_API_1098_P1: "IDs de cuentas",
  T_48_META_API_1098_P1_D: "La lista de IDs únicos de jugador, que lee los datos correspondientes a las claves en el mismo índice de la lista de claves.",
  T_48_META_API_1098_P2: "Llaves",
  T_48_META_API_1098_P2_D: "La lista de datos, que lee los datos correspondientes a los ID únicos de jugador en el mismo índice de la lista de IDs.",
  T_48_META_API_1098_P5: "Códigos de estado",
  T_48_META_API_1098_P5_D: "La lista de códigos de estado",
  T_48_META_API_1105: "Notificar inicio de la trama",
  T_48_META_API_1105_D: "Inicia la reproducción de la trama especificada para el reproductor desencadenante",
  T_48_META_API_1105_P1_D: "ID de la trama",
  T_48_META_API_1108: "Obtener idioma local",
  T_48_META_API_1500_P0: "Vector",
  T_48_META_API_1505_P1: "Z",
  T_48_META_API_3300: "Establecer peso de parte del cuerpo",
  T_48_META_API_3300_D: "Establecer el peso de la parte del cuerpo de destino cuando se mezcla con otras animaciones de menor prioridad.",
  T_48_META_API_3300_P0_D: "El componente controlador de animación añadible al que pertenece la parte del cuerpo",
  T_48_META_API_3300_P1: "Nombre de parte del cuerpo",
  T_48_META_API_3300_P1_D: "El nombre de la parte del cuerpo",
  T_48_META_API_3300_P2: "Peso",
  T_48_META_API_3300_P2_D: "Peso con un rango de valores de [0, 1], que representa el grado de intercalación con animaciones de menor prioridad.",
  T_48_META_API_3315: "Reproducir clip de animación de personajes Anular",
  T_48_META_API_3315_D: "Reproduce un clip de animación de personaje con la opción de anular la animación predeterminada del juego.",
  T_48_META_API_3315_P3: "Anular control de juego",
  T_48_META_API_3315_P3_D: "Si se anula o no la animación por defecto del juego",
  T_48_META_API_3316: "Detener animación",
  T_48_META_API_3316_D: "Detener la reproducción de la animación para el objetivo en el estado especificado",
  T_48_META_API_90_P1: "Puede abandonar a la mitad",
  T_48_META_API_93: "Crear junto al movimiento de la trayectoria",
  T_48_META_API_93_D: "Crea un movimiento interpolado a lo largo de una trayectoria para hacer que el objeto se mueva a lo largo de la trayectoria especificada.",
  T_48_META_API_93_P1: "Ruta",
  T_48_META_API_93_P1_D: "La trayectoria del movimiento",
  T_48_META_API_93_P3_D: "La magnitud de la velocidad",
  T_48_META_API_93_P4: "Tangente de frente",
  T_48_META_API_93_P4_D: "Si el objeto está orientado en la dirección del movimiento. Esta propiedad permanece invariable aunque la orientación del objeto se modifique a la fuerza por otros medios.",
  T_48_META_API_96: "Instanciar prefabricado",
  T_48_META_API_96_D: "Crea una instancia prefabricada con la opción de procesarla asíncronamente",
  T_48_META_API_96_P2: "Carga asíncrona",
  T_48_META_API_96_P2_D: "Si la carga es asíncrona o no",
  T_48_META_EVT_3140: "Al cambiar equipo",
  T_48_META_EVT_3140_D: "Se activa cuando cambia el equipo de la entidad actual",
  T_48_META_EVT_3140_P0: "Equipo anterior",
  T_48_META_EVT_3140_P0_D: "El equipo al que se pertenecía antes del cambio",
  T_48_META_EVT_3140_P1: "Equipo actual",
  T_48_META_EVT_3140_P1_D: "El equipo en donde se encuentra tras el cambio",
  T_48_META_EVT_3141: "Al inicio de la trama",
  T_48_META_EVT_3141_D: "Se activa cuando se da inicio a la trama",
  T_48_META_EVT_3141_P1: "ID de la trama",
  T_48_META_EVT_3141_P1_D: "ID de la trama",
  T_48_META_EVT_3142: "Al final de la trama",
  T_48_META_EVT_3142_D: "Se activa cuando la trama termina",
  T_48_META_EVT_3142_P0_D: "El jugador desencadenante",
  T_48_META_EVT_3142_P1_D: "ID de la trama",
  T_48_META_EVT_3143: "Opción de trazado al activarse",
  T_48_META_EVT_3143_D: "Se activa cuando se selecciona una opción en la trama",
  T_48_META_EVT_3143_P1_D: "El ID de la trama",
  T_48_META_EVT_3143_P2: "ID de la opción",
  T_48_META_EVT_3143_P2_D: "ID de la opción seleccionada",
  T_48_META_TYP_409_I10: "Cambio de equipo fallido_equipo inválido",
  T_48_META_TYP_409_I11: "Cambio de equipo fallido_Eliminado",
  T_48_META_TYP_409_I12: "Cambio de equipo fallido_en vehículo",
  T_48_META_TYP_409_I7: "Equipo de cambio Fallido_No admitido",
  T_48_META_TYP_409_I8: "Cambio de equipo fallido_ya está en un equipo",
  T_48_META_TYP_409_I9: "Cambio de equipo fallido_EliminadoObjeto inválido",
  T_48_META_TYP_41_I19: "Desactivar colisionador",
  T_48_META_TYP_417: "Partículas",
  T_48_META_TYP_428: "Transformación del jugador o atuendo del NPC",
  T_48_META_TYP_431: "Movimiento a lo largo de la trayectoria",
  T_48_META_TYP_431_I1: "Camino",
  T_48_META_TYP_432: "Guía personalizada de trayectoria curva",
  T_48_META_TYP_432_I0: "Rodar",
  T_48_META_TYP_432_I1: "Tangente",
  T_48_META_TYP_433: "Tipo de trayectoria de curva personalizada",
  T_48_META_TYP_433_I0: "Linear",
  T_48_META_TYP_433_I1: "Suave",
  T_48_META_TYP_433_I2: "Personalizado",
  T_48_META_TYP_434: "Trayectoria curva personalizada",
  T_48_META_TYP_434_I2: "Bucle cerrado",
  T_48_META_TYP_434_I3: "Guías",
  T_48_META_TYP_437_I5: "Nombres de los tipos de puntuación",
  T_48_META_TYP_437_I6: "Contenido del marcador izquierdo",
  T_48_META_TYP_437_I7: "Contenido de la puntuación derecha",
  T_48_META_TYP_438_I1: "Jugadores",
  T_48_META_TYP_438_I2: "Rangos",
  T_48_META_TYP_438_I3: "Puntuación total",
  T_48_META_TYP_438_I4: "Nombres de los tipos de puntuación",
  T_48_META_TYP_438_I5: "Colores",
  T_48_META_TYP_438_I6: "Puntuación",
  T_48_META_TYP_439: "Agrupar",
  T_48_META_TYP_442_I1: "Puntuación restante",
  T_48_META_TYP_442_I10: "Ícono derecho de eliminación",
  T_48_META_TYP_442_I2: "Marcador derecho",
  T_48_META_TYP_442_I3: "Número izquierdo de vivos",
  T_48_META_TYP_442_I4: "Número derecho de vivos",
  T_48_META_TYP_442_I5: "Número izquierdo de eliminación",
  T_48_META_TYP_442_I6: "Número derecho de eliminación",
  T_48_META_TYP_442_I7: "Ícono izquierdo: Vivo",
  T_48_META_TYP_442_I8: "Ícono derecho: Vivo",
  T_48_META_TYP_442_I9: "Icono izquierdo de eliminación",
  T_48_META_TYP_444: "Tipo de lenguaje",
  T_48_META_TYP_444_I0: "Inglés",
  T_48_META_TYP_444_I1: "Chino Simplificado",
  T_48_META_TYP_444_I10: "Francés",
  T_48_META_TYP_444_I11: "Alemán",
  T_48_META_TYP_444_I12: "Turco",
  T_48_META_TYP_444_I13: "Hindi",
  T_48_META_TYP_444_I14: "Japonés",
  T_48_META_TYP_444_I15: "Rumano",
  T_48_META_TYP_444_I16: "Árabe",
  T_48_META_TYP_444_I17: "Birmano",
  T_48_META_TYP_444_I18: "Urdu",
  T_48_META_TYP_444_I19: "Bengalí",
  T_48_META_TYP_444_I2: "Chino Tradicional",
  T_48_META_TYP_444_I3: "Tailandés",
  T_48_META_TYP_444_I4: "Vietnamita",
  T_48_META_TYP_444_I5: "Indonesio",
  T_48_META_TYP_444_I6: "Portugués",
  T_48_META_TYP_444_I7: "Español",
  T_48_META_TYP_444_I8: "Ruso",
  T_48_META_TYP_444_I9: "Corea",
  T_48_SD_ERROR_DIVISOR: "El divisor no puede ser 0",
  T_48_SD_ERROR_KEY_NOTINMAP: "La clave especificada no existe en el mapa: {0}",
  T_48_SD_ERROR_LIST_OUTRANGE: "Índice de la lista fuera de rango: {0}",
  T_48_SD_SK_WARNING: "No se ha encontrado {1} en {0}",
  T_48_TYC_WS_WARNING_SERVER_DRIVEN_DISABLED: 'Como el atributo "IsServerDriven" del controlador {0} de personaje de Crea Tu Mapa está desactivado, la API de servidor relacionada no tiene efecto.',
  T_48_XXJ_WS_PARENTERROR: "Establecimiento de padre fallido",
  T_48_XXJ_WS_PERFORMANCE: "Rendimiento",
  T_48_XXJ_WS_TANGENT: "Tangente",
  T_48_XXJ_WS_WAYPOINT: "Guía",
  T_48_XYL_UGC_COMPOSITEOJBECTLIST: "Lista de objetos",
  T_48_XYL_UGC_CUSTOMIZEMINIMAP: "Usar minimapa personalizado",
  T_48_XYL_UGC_HIDEMINIMAP: "Ocultar el HUD del minimapa",
  T_48_XYL_WS_BASICCUSTOMSURFACE: "Superficie personalizada básica",
  T_48_XYL_WS_BASICCYLINDERCUTOUT: "Recorte de cilindro",
  T_48_XYL_WS_BASICHEMISPHERE: "Hemisferio básico",
  T_48_XYL_WS_BASICQUARTERROUNDEDTORUS: "Cuarto de toro",
  T_48_XYL_WS_BASICQUARTERTORUS: "Cuarto de toro cuadrado",
  T_48_XYL_WS_BASICROUNDEDTORUS: "Toro",
  T_48_XYL_WS_BASICTRIANGLE: "Superficie triangular",
  T_48_XYL_WS_MAPPLAYERSTIPS: "Jugadores en la partida = Número de equipos × Número de jugadores por equipo. Entre más jugadores haya en la partida, mayor será el tiempo de emparejamiento.",
  T_48_XYL_WS_MAPPLAYERSWARNING: "Un número elevado de jugadores en la partida puede alargar el tiempo de emparejamiento.",
  T_49_HL_CL_CREATOR_LABEL2: "Talento comunitario de Crea Tu Mapa",
  T_49_HL_CL_MAPS_LABEL2: "Mapa ganador",
  T_49_HL_CL_MAPS_LABEL3: "Juego ganador",
  T_49_HX_T_TUNG: "Tung Tung Tung",
  T_49_HZY_CONTROLLER_TRAJECTORY: "Trayectoria",
  T_49_JH_WS_SKILLKASSIE: "Electroshock (Kassie)",
  T_49_JH_WS_SKILLKODA: "Energía Aurora (Koda)",
  T_49_JH_WS_SKILLOSCAR: "Embestida Valerosa (Oscar)",
  T_49_LXW_EIGHTHB_EDIT_AITRAIN_ENTRANCE: "Generar con IA",
  T_49_META_API_10065: "Cambiar cámara personalizada",
  T_49_META_API_10067: "Conseguir cámara personalizada actual",
  T_49_META_API_10069: "Crear cámara personalizada",
  T_49_META_API_10070: "Establecer máscara de eliminación selectiva personalizada",
  T_49_META_API_10070_D: "Establece la máscara de eliminación selectiva objetivo para controlar la visibilidad en todas las capas",
  T_49_META_API_10071: "Obtener máscara de eliminación selectiva personalizada",
  T_49_META_API_10071_D: "Obtener la máscara de eliminación selectiva objetivo",
  T_49_META_API_10072: "Establecer capa de máscara de eliminación selectiva personalizada",
  T_49_META_API_10072_D: "Establecer la visibilidad de la cámara objetivo para una capa específica",
  T_49_META_API_10073: "Captura de pantalla",
  T_49_META_API_10073_D: "Captura de pantalla (para pruebas internas)",
  T_49_META_API_106: "Obtener marca de tiempo del servidor (ms)",
  T_49_META_API_106_D: "Obtener la marca de tiempo del servidor con precisión de milisegundos",
  T_49_META_API_107: "Marca de tiempo a cadena localizada (ms)",
  T_49_META_API_107_D: "Convertir marcas de tiempo (en ms) en cadenas basadas en determinados formatos",
  T_49_META_API_107_P0: "Marca de tiempo (ms)",
  T_49_META_API_107_P0_D: "Una marca de tiempo en milisegundos",
  T_49_META_API_108: "Vector3 Lerp",
  T_49_META_API_108_D: "Realiza una interpolación lineal del vector 3D A al vector B",
  T_49_META_API_1089_P2: "Solicitar ID",
  T_49_META_API_109: "Actualizar contexto a persona",
  T_49_META_API_109_D: "Actualiza el contexto del modelo de una persona especificada en la sala actual y sobrescribe el contexto original tras la ejecución. El contexto influirá en la interpretación de la persona sobre el trasfondo, la historia o sobre determinados parámetros del diálogo actual.",
  T_49_META_API_109_P1: "Contexto",
  T_49_META_API_109_P1_D: "Detalles del contexto",
  T_49_META_API_110: "Comentarios sobre la respuesta de persona",
  T_49_META_API_110_D: "Enviar comentarios sobre el contenido de las respuestas de una persona, que se utilizarán para optimizar nuestro modelo.",
  T_49_META_API_110_P1: "Tiene Me gusta",
  T_49_META_API_110_P1_D: "Si la respuesta es me gusta o no. Verdadero = me gusta.",
  T_49_META_API_1109: "Fijar posición del jugador local",
  T_49_META_API_1109_D: "Cuando el jugador utiliza personajes del juego clásico, esta API puede fijar la posición del jugador.",
  T_49_META_API_1109_P0_D: "La posición objetivo",
  T_49_META_API_111: "Vector3 Slerp",
  T_49_META_API_111_D: "Realiza una interpolación esférica del vector 3D A al vector B para una rotación suave",
  T_49_META_API_1110: "Establecer el avance del reproductor local",
  T_49_META_API_1110_D: "Cuando el jugador utiliza personajes del juego clásico, esta API puede establecer la dirección a la que mira el jugador.",
  T_49_META_API_1110_P0_D: "El vector hacia adelante",
  T_49_META_API_112: "Deshacer el recuerdo de persona",
  T_49_META_API_112_D: "Retrocede la memoria de una persona a antes del ID de respuesta específico. Se borrará toda la memoria de los diálogos incluidos y posteriores a la respuesta.",
  T_49_META_API_113: "Reproduce sonido para un único disparo",
  T_49_META_API_113_D: "Reproduce un efecto de sonido para un único disparo con volumen ajustable",
  T_49_META_API_113_P0_D: "El ID del recurso de efecto de sonido que se reproducirá",
  T_49_META_API_113_P1: "Volume",
  T_49_META_API_113_P1_D: "El volumen de reproducción del efecto de sonido, que va de 0 a 1.",
  T_49_META_API_97: "Crear controlador de la vista de la pieza del esqueleto",
  T_49_META_API_97_D: "Tras crear una entidad controladora de la mirada de la parte del esqueleto, puedes utilizar esta entidad para controlar la parte del esqueleto especificada y hacer que siempre mire hacia un objetivo concreto.",
  T_49_META_API_97_P0_D: 'La entidad controladora de "mirar a" de la parte del esqueleto. Si se destruye la entidad, cesará la funcionalidad de mirar.',
  T_49_META_API_97_P1_D: "La parte del esqueleto que se controla",
  T_49_META_API_97_P2_D: "El objetivo que se está observando",
  T_49_META_API_98: "Proyección",
  T_49_META_API_98_D: "Calcula la proyección del vector A sobre el vector B",
  T_49_META_API_99: "Obtener marca de tiempo local (ms)",
  T_49_META_API_99_D: "Obtén la marca de tiempo local con precisión de milisegundos.",
  T_49_META_EVT_16_P1_D: "Empezando desde 0, cada solicitud que sale va a usar un ID numérico en orden, como para crear una sala o borrar la memoria.",
  T_49_META_EVT_16_P2: "ID de respuesta",
  T_49_META_EVT_16_P2_D: "Cada respuesta completa tendrá un ID único",
  T_49_META_TYP_122_I19: "Material personalizado",
  T_49_META_TYP_122_I19_D: "Permite sustituir la textura del cielo por un material personalizado",
  T_49_META_TYP_14_I78_D: "Obtiene o establece la entidad de cámara que está renderizando actualmente la escena en el cliente del jugador. Nota: La entidad de cámara representa esencialmente los datos de configuración para controlar la cámara del lado del cliente",
  T_49_META_TYP_335_I9: "Tiempo transcurrido (ms)",
  T_49_META_TYP_335_I9_D: "La duración de la reproducción del efecto de sonido en milisegundos. Solo se puede acceder a esta propiedad del lado del cliente.",
  T_49_META_TYP_409_I13: "LLM_OK",
  T_49_META_TYP_409_I13_D: "LLM_OK",
  T_49_META_TYP_409_I14: "LLM_Fallido",
  T_49_META_TYP_409_I14_D: "LLM_Fallido",
  T_49_META_TYP_409_I15: "LLM_Se_acabó_el_Tiempo",
  T_49_META_TYP_409_I15_D: "LLM_Se_acabó_el_Tiempo",
  T_49_META_TYP_409_I16: "LLM_Persona_Inválida",
  T_49_META_TYP_409_I16_D: "LLM_Persona_o_sala_inválida",
  T_49_META_TYP_409_I17: "LLM_Límite_de_tokens",
  T_49_META_TYP_409_I17_D: "LLM_Límite_de_tokens",
  T_49_META_TYP_409_I18: "LLM_Violación",
  T_49_META_TYP_409_I18_D: "LLM_Solicitudes_frecuentes",
  T_49_META_TYP_409_I19: "LLM_Solicitud_Frecuente",
  T_49_META_TYP_409_I19_D: "LLM_Solicitudes_frecuentes",
  T_49_META_TYP_441: "ID de rendimiento",
  T_49_META_TYP_445: "ID de controlador jugable",
  T_49_META_TYP_446: "Controlador jugable acoplable",
  T_49_META_TYP_446_I0: "Controlador jugable",
  T_49_META_TYP_447: "Controlador de la pieza del esqueleto",
  T_49_META_TYP_448: "Controlador de la vista de la parte del esqueleto",
  T_49_META_TYP_448_I0: "Objetivo controlado",
  T_49_META_TYP_448_I1: "Mirar el objetivo",
  T_49_META_TYP_449: "Cámara personalizada",
  T_49_META_TYP_449_I2: "Tamaño ortográfico",
  T_49_META_TYP_449_I2_D: "Controla el tamaño del área visible para la cámara",
  T_49_META_TYP_450: "Marca de tiempo en cadena localizada (ms)",
  T_49_META_TYPE_449_D: "Una cámara personalizada es totalmente controlada por el desarrollador y determina lo que ve el jugador durante el juego",
  T_49_META_TYPE_450_D: "Formatear una marca de tiempo con precisión de milisegundos en un formato de texto legible",
  T_49_SD_SEARCH_ICONDESC: "Asociación inteligente",
  T_49_SD_SEARCHKEY_ACTION: "Acción",
  T_49_SD_SEARCHKEY_ANICLIPID: "ID del clip de animación",
  T_49_SD_SEARCHKEY_AS: "Como",
  T_49_SD_SEARCHKEY_ATTACHMENTENUM: "ID del accesorio",
  T_49_SD_SEARCHKEY_AUDIOENUM: "Tipo de efecto de sonido",
  T_49_SD_SEARCHKEY_BAGSKINID: "ID del aspecto de mochila",
  T_49_SD_SEARCHKEY_BEZIER: "Curva de Bézier",
  T_49_SD_SEARCHKEY_BOOL: "Booleano",
  T_49_SD_SEARCHKEY_BREAK: "Segmentar",
  T_49_SD_SEARCHKEY_BTREEID: "ID del Árbol de comportamiento",
  T_49_SD_SEARCHKEY_BUTTONCLICK: "Al hacer clic al botón",
  T_49_SD_SEARCHKEY_BUTTONDOUBLECLICK: "Al hacer doble clic en el botón",
  T_49_SD_SEARCHKEY_BUTTONPRESS: "Al presionar el botón",
  T_49_SD_SEARCHKEY_BUTTONRELEASE: "Al soltar el botón",
  T_49_SD_SEARCHKEY_CLOTHENUM: "Tipo de atuendo",
  T_49_SD_SEARCHKEY_COLOR: "Color",
  T_49_SD_SEARCHKEY_COMMENT: "Nota de comentario",
  T_49_SD_SEARCHKEY_COMPARER: "= > < ≠",
  T_49_SD_SEARCHKEY_COMPONENTENUM: "Enumeración de componente",
  T_49_SD_SEARCHKEY_CONCANT: "Conectar",
  T_49_SD_SEARCHKEY_CONTINUE: "Continuar",
  T_49_SD_SEARCHKEY_CUSTOMHUD: "HUD personalizado",
  T_49_SD_SEARCHKEY_CUSTOMHUDWIDGET: "Widget del HUD personalizado",
  T_49_SD_SEARCHKEY_DYNAMICITEMENUM: "crear tipo de objeto de nivel dinámico",
  T_49_SD_SEARCHKEY_E: "E",
  T_49_SD_SEARCHKEY_EFFECTENUM: "Tipo de efectos visuales",
  T_49_SD_SEARCHKEY_ENTITY: "Seleccionar objeto de escena",
  T_49_SD_SEARCHKEY_FLOAT: "Flotar",
  T_49_SD_SEARCHKEY_FOR: "Para el índice",
  T_49_SD_SEARCHKEY_FOREACH: "Por cada",
  T_49_SD_SEARCHKEY_FUNCTION: "Función",
  T_49_SD_SEARCHKEY_GETCSV: "Obtener CSV",
  T_49_SD_SEARCHKEY_GETREGISTERED: "Obtener recurso registrado por identificador",
  T_49_SD_SEARCHKEY_GETVALUE: "Obtener valor de la propiedad",
  T_49_SD_SEARCHKEY_GLOBALVARGET: "Obtener variable global",
  T_49_SD_SEARCHKEY_GLOBALVARSET: "Establecer variable global",
  T_49_SD_SEARCHKEY_IF: "Si",
  T_49_SD_SEARCHKEY_IFELSE: "Si no",
  T_49_SD_SEARCHKEY_IMGENUM: "Tipo de sprite",
  T_49_SD_SEARCHKEY_INT: "Integral",
  T_49_SD_SEARCHKEY_INTERNALHUD: "Tipo de HUD",
  T_49_SD_SEARCHKEY_ITEMENUM: "Tipo de objeto",
  T_49_SD_SEARCHKEY_LISTAPPEND: "Lista adicional",
  T_49_SD_SEARCHKEY_LISTAPPENDRANGE: "Añadir rango a la lista",
  T_49_SD_SEARCHKEY_LISTCLEAR: "Despejar lista",
  T_49_SD_SEARCHKEY_LISTCLONE: "Clonar lista",
  T_49_SD_SEARCHKEY_LISTCONTAIN: "Contenido de la lista",
  T_49_SD_SEARCHKEY_LISTCREATE: "Crear lista",
  T_49_SD_SEARCHKEY_LISTDELETE: "Eliminar lista",
  T_49_SD_SEARCHKEY_LISTGET: "Obtener lista",
  T_49_SD_SEARCHKEY_LISTINDEXOF: "Índice de lista de",
  T_49_SD_SEARCHKEY_LISTINSERT: "Insertar lista",
  T_49_SD_SEARCHKEY_LISTLASTINDEXOF: "Listar el último índice de",
  T_49_SD_SEARCHKEY_LISTLENGTH: "Largo de la lista",
  T_49_SD_SEARCHKEY_LISTREVERSE: "Lista inversa",
  T_49_SD_SEARCHKEY_LISTSET: "Establecer lista",
  T_49_SD_SEARCHKEY_LISTSHUFFLE: "Lista aleatoria",
  T_49_SD_SEARCHKEY_LOCALKEY: "Llave localizada",
  T_49_SD_SEARCHKEY_LOCALVAR: "Variable local",
  T_49_SD_SEARCHKEY_LOGICAL: "Y, o",
  T_49_SD_SEARCHKEY_LOGINFO: "Imprimir información del registro",
  T_49_SD_SEARCHKEY_MAPALLKEYS: "diccionario obtiene todos los identificadores, el mapa obtiene todos los identificadores",
  T_49_SD_SEARCHKEY_MAPCLEAR: "borrar diccionario, borrar mapa",
  T_49_SD_SEARCHKEY_MAPCONTAIN: "diccionario contiene los identificadores, el mapa contiene los identificadores",
  T_49_SD_SEARCHKEY_MAPCREATE: "crear diccionario, crear mapa",
  T_49_SD_SEARCHKEY_MAPGET: "obtener el valor del diccionario por identificador para obtener el valor del mapa por identificador",
  T_49_SD_SEARCHKEY_MAPLENGTH: "longitud del diccionario, longitud del mapa",
  T_49_SD_SEARCHKEY_MAPREMOVE: "eliminar diccionario, eliminar mapa",
  T_49_SD_SEARCHKEY_MAPSET: "establecer valor del diccionario, establecer valor del mapa",
  T_49_SD_SEARCHKEY_MATH: "sumar restar multiplicar dividir",
  T_49_SD_SEARCHKEY_NEWLIST: "Nueva lista",
  T_49_SD_SEARCHKEY_NULL: "Nulo",
  T_49_SD_SEARCHKEY_NUMTOSTRING: "Número a cadena",
  T_49_SD_SEARCHKEY_PARTICLESENUM: "Propiedades de las partículas",
  T_49_SD_SEARCHKEY_PERSONA: "Persona",
  T_49_SD_SEARCHKEY_PI: "PI",
  T_49_SD_SEARCHKEY_PLAYERDATAID: "ID de datos del jugador",
  T_49_SD_SEARCHKEY_PLAYERSKILLENUM: "Tipo de habilidad del personaje",
  T_49_SD_SEARCHKEY_PREEFFECT: "Tipo especial de sticker",
  T_49_SD_SEARCHKEY_PREFAB: "Prefab",
  T_49_SD_SEARCHKEY_RAWID: "ID bruto",
  T_49_SD_SEARCHKEY_READSTATIS: "Leer datos acumulados",
  T_49_SD_SEARCHKEY_RESOURCEENUM: "UUID del recurso",
  T_49_SD_SEARCHKEY_RETURN: "Regresar",
  T_49_SD_SEARCHKEY_SCENEENUM: "Archivo de la escena",
  T_49_SD_SEARCHKEY_SCRIPTID: "Script",
  T_49_SD_SEARCHKEY_SETVALUE: "Fijar valor de la propiedad",
  T_49_SD_SEARCHKEY_SPECIALITEMENUM: "Tipo de ID de objeto especial",
  T_49_SD_SEARCHKEY_TEXT: "Texto",
  T_49_SD_SEARCHKEY_TEXTUREID: "Tipo de textura",
  T_49_SD_SEARCHKEY_THISENTITY: "Esta Entidad",
  T_49_SD_SEARCHKEY_TIMELINE: "Tiempo",
  T_49_SD_SEARCHKEY_TYPEENUM: "Cualquier tipo",
  T_49_SD_SEARCHKEY_V2VCREATE: "Crear Vector2",
  T_49_SD_SEARCHKEY_V2VGET: "Obtener componentes de Vector2",
  T_49_SD_SEARCHKEY_V2VOPERATION: "Operación del Vector2: suma, resta, multiplicación, producto escalar, distancia, ángulo",
  T_49_SD_SEARCHKEY_V2VSET: "Establecer componentes del Vector2",
  T_49_SD_SEARCHKEY_V3VCREATE: "Crear Vector3",
  T_49_SD_SEARCHKEY_V3VGET: "Obtener componentes del Vector3",
  T_49_SD_SEARCHKEY_V3VOPERATION: "Operación del Vector3: suma, resta, multiplicación, producto escalar, producto vectorial, distancia, ángulo",
  T_49_SD_SEARCHKEY_V3VSET: "Establecer componentes del Vector3",
  T_49_SD_SEARCHKEY_VEHICLEENUM: "ID del aspecto del vehículo",
  T_49_SD_SEARCHKEY_WEAPONSKINENUM: "ID del aspecto de arma",
  T_49_SD_SEARCHKEY_WHILE: "Mientras",
  T_49_SD_SEARCHKEY_WRITESTATIS: "Escribe el desplazamiento de la base de datos acumulado",
  T_49_SD_SEARCHKEY_WRITESTATISCROSS: "Escribe el desplazamiento de la base de datos acumulado por el código de mapa",
  T_49_XXJ_WS_DURATIONS: "Duración (s)",
  T_49_XXJ_WS_EDITPERFORMANCE: "Editar rendimiento",
  T_49_XXJ_WS_PERFORMANCE: "Rendimiento",
  T_49_XXJ_WS_PERFORMANCE_DELETE: "Borrar rendimiento",
  T_49_XXJ_WS_PERFORMANCE_DELETECONFIRM: "El rendimiento eliminado no se puede restaurar, ¿continuar?",
  T_49_XXJ_WS_PERFORMANCE_EDITING: "Edición {0}",
  T_49_XXJ_WS_PERFORMANCE_NAME_EXCEPTION: "Este nombre ya está en uso, cámbialo e intenta de nuevo",
  T_49_XXJ_WS_PERFORMANCENAME: "Nombre del rendimiento",
  T_49_XXJ_WS_TIMELINE_ADD_KEYFRAME: "Añadir cuadro clave",
  T_49_XXJ_WS_TIMELINE_ADD_SUB_TRACK: "Añadir subpista",
  T_49_XXJ_WS_TIMELINE_ADD_TRACK: "Añadir pista",
  T_49_XXJ_WS_TIMELINE_DEL_TRACK: "Borrar pista",
  T_49_XXJ_WS_TIMELINE_ENTITY_TRACK: "Pista de actor",
  T_49_XXJ_WS_TIMELINE_EVENT_TRACK: "Pista del evento",
  T_49_XXJ_WS_TIMELINE_EXISTED_KEYFRAME: "El cuadro clave ya existe",
  T_49_XXJ_WS_TIMELINE_EXISTED_TRACK: "La pista de actor correspondiente ya existe",
  T_49_XXJ_WS_TIMELINE_FRAME_SETTING: "Contenido",
  T_49_XXJ_WS_TIMELINE_NAME_EXCEPTION: "Se han detectado nombres de pista duplicados. Cámbialos e inténtalo de nuevo.",
  T_49_XXJ_WS_TIMELINE_OPEN_RECORD: "Inicia la grabación o elige primero un cuadro clave",
  T_49_XXJ_WS_TIMELINE_RECORDING: "Registrando…",
  T_49_XXJ_WS_TIMELINE_REMOVE_KEYFRAME: "Borrar cuadro clave",
  T_49_XXJ_WS_TIMELINE_SCENE_EDIT_MODE: "Vista de la escena",
  T_49_XXJ_WS_TIMELINE_SELECT_OBJECT_TIP: "Selecciona un objeto para crear una pista o pulsa directamente el botón Añadir pista",
  T_49_XXJ_WS_TIMELINE_SELECT_OBJECT_TIP_1: "Toca el botón de añadir pista para crear una nueva pista",
  T_49_XXJ_WS_TIMELINE_SUB_TRACK_TITLE: "Subpista",
  T_49_XXJ_WS_TIMELINE_TRACK: "Pista",
  T_49_XXJ_WS_TIMELINE_TRACK_EDIT_MODE: "Ver pista",
  T_49_XYL_WS_DAILYPROPS: "Básico",
  T_49_XYL_WS_STOREGAMPLAY: "Modo de juego",
  T_49_YU_QCITEM_ALL_11: "¡Tung Tung Tung Sahur!",
  T_50_H_M4A1_VA_N: "M4A1 - Academia maldita",
  T_50_H_MACHETE_VA_N: "Machete - Academia maldita",
  T_50_HJ_LEADERBOARD_SETTING_HEADER: "Campos de la Tabla de clasificación",
  T_50_HJ_OVERFLOW_RESIZEFREELY: "Se desborda",
  T_50_HJ_OVERFLOW_RESIZEHEIGHT: "Agrupar",
  T_50_HJ_OVERFLOW_SHRINKCONTENT: "Reducir fuente",
  T_50_HJ_SEARCHKEY_TUPLECREATE: "Crear tupla",
  T_50_HJ_SEARCHKEY_TUPLEGET: "Obtener tupla",
  T_50_HJ_SEARCHKEY_TUPLESET: "Establecer tupla",
  T_50_HJ_TEXTOBGJ_H: "Altura",
  T_50_HJ_TEXTOBGJ_OVERFLOW: "Opciones de desbordamiento",
  T_50_HJ_TEXTOBGJ_W: "Ancho",
  T_50_HZY_REVIEW_TEXTOBJ: "Contenido de objeto de texto",
  T_50_JH_WS_HIDEMAPERROR: "No se puede ocultar el minimapa sin una imagen de portada personalizada.",
  T_50_JH_WS_HIDEMAPTIP: "Cuando el minimapa está oculto, ya no se utilizará como imagen de portada",
  T_50_JH_WS_HIDEMINIMAP: "Ocultar minimapa",
  T_50_META_API_10073_P0: "Nombre de archivo",
  T_50_META_API_10073_P0_D: "El nombre del archivo",
  T_50_META_API_10073_P1_D: "El resultado de la ejecución. Comprueba la enumeración del código de estado.",
  T_50_META_API_1102: "Leer valor de columna de la hoja de base de datos",
  T_50_META_API_1102_D: "Lee el valor específico de una columna para una clave de una tabla de base de datos estándar",
  T_50_META_API_1102_P3: "Índice de columna",
  T_50_META_API_1102_P3_D: "El índice de columna de la tabla de la base de datos (0 = la primera columna)",
  T_50_META_API_1106: "Crear escena",
  T_50_META_API_1106_D: "Crear una entidad de rendimiento",
  T_50_META_API_1106_P0_D: "El recurso de rendimiento",
  T_50_META_API_1111: "Leer el valor de asociación de la tabla de clasificación de la base de datos",
  T_50_META_API_1111_D: "Lee la combinación de valores de una tabla de clasificación y su tabla asociada en la base de datos",
  T_50_META_API_1111_P5: "Código de estado de asociación",
  T_50_META_API_1111_P5_D: "Código de error de asociación",
  T_50_META_API_1112: "Leer los valores de asociación de la tabla de clasificación de la base de datos por rango",
  T_50_META_API_1112_D: "Lee los valores de la tabla de clasificación dentro de un rango de clasificación especificado, lee los valores correspondientes mediante las claves recuperadas de la tabla asociada y combínalos.",
  T_50_META_API_1112_P6: "Código de estado de la asociación",
  T_50_META_API_1112_P6_D: "Código de error de asociación",
  T_50_META_API_1113: "Escribir valor de asociación de tabla de clasificación de base de datos",
  T_50_META_API_1113_D: "Escribe el valor de una clave determinada en la tabla de clasificación y en la tabla relacionada de la base de datos",
  T_50_META_API_1113_P5: "Código de estado de la asociación",
  T_50_META_API_1113_P5_D: "Código de error de asociación",
  T_50_META_API_114_D: "Crear IU personalizada",
  T_50_META_API_114_P0_D: "El código se utiliza como nombre de parámetro para crear una entidad de interfaz de usuario, y su valor de variable local correspondiente representa la entidad de interfaz de usuario creada.",
  T_50_META_API_114_P1_D: "La entidad del jugador a la que pertenece, solo es visible para el jugador.",
  T_50_META_API_114_P2: "ID de recurso de la IU",
  T_50_META_API_114_P2_D: "El ID de recurso de la interfaz de usuario personalizada",
  T_50_META_API_115_D: "Crea la IU personalizada especificada",
  T_50_META_API_116: "Establecer nivel de resaltado de objeto",
  T_50_META_API_116_D: "Establece el estado destacado del objeto. Puede verse afectado por otras lógicas del juego.",
  T_50_META_API_116_P0_D: "Objeto objetivo",
  T_50_META_API_116_P1_D: "Resaltar",
  T_50_META_API_117: "Operador a nivel de bits común",
  T_50_META_API_117_D: "Bit a bit y/o/xor/desplazamiento a la izquierda/desplazamiento a la derecha",
  T_50_META_API_117_P0_D: "Valor izquierdo",
  T_50_META_API_117_P1_D: "Valor correcto",
  T_50_META_API_117_P2_D: "Tipo de operación",
  T_50_META_API_118: "Sin operador a nivel de bits",
  T_50_META_API_118_D: "NEGACIÓN bit a bit, también conocida como complemento bit a bit.",
  T_50_META_API_118_P0_D: "Valor",
  T_50_META_API_119: "Operador a nivel de bits de lista a int",
  T_50_META_API_119_D: "Realiza una operación OR a nivel de bits entre todos los elementos de la lista y convierte el resultado en un valor entero.",
  T_50_META_API_119_P0: "Matriz de bits",
  T_50_META_API_119_P0_D: "Matriz bit a bit",
  T_50_META_API_120: "Operador a nivel de bits de int a lista",
  T_50_META_API_120_D: "Convierte los valores decimales representados por bits en la posición 1 de un entero en su forma binaria a una lista",
  T_50_META_API_120_P0_D: "Integral",
  T_50_META_API_121: "Ángulo cuaternión",
  T_50_META_API_121_D: "Calcular el ángulo entre dos cuaterniones",
  T_50_META_API_121_P0_D: "Cuaternión 1",
  T_50_META_API_121_P1_D: "Quaternión 2",
  T_50_META_API_122: "Punto cuaternión",
  T_50_META_API_122_D: "Calcula el producto escalar de dos cuaterniones",
  T_50_META_API_123: "Inversa de un cuaternión",
  T_50_META_API_123_D: "Calcular la inversa de un cuaternión",
  T_50_META_API_123_P0_D: "Cuaternión",
  T_50_META_API_124: "Cuaternión desde hasta rotación",
  T_50_META_API_124_D: 'Calcular el cuaternión de rotación de "desde" a "hasta"',
  T_50_META_API_124_P0_D: "El punto de inicio",
  T_50_META_API_124_P1_D: "El punto final",
  T_50_META_API_125: "Rotar hacia el cuaternión",
  T_50_META_API_125_D: 'Calcula el cuaternión de rotación desde "desde" hasta "hasta". Máx. grados en Delta es el ángulo de rotación máximo.',
  T_50_META_API_125_P0: "De",
  T_50_META_API_125_P0_D: "Cuaternión inicial",
  T_50_META_API_125_P1: "Hacia",
  T_50_META_API_125_P1_D: "El cuaternión objetivo",
  T_50_META_API_125_P2: "Grado máximo Delta",
  T_50_META_API_125_P2_D: "El ángulo de rotación máx.",
  T_50_META_API_126: "Obtener orientación del giroscopio",
  T_50_META_API_126_D: "Orientación del dispositivo en el lugar 3D, que representa los ángulos de rotación alrededor de los tres ejes.",
  T_50_META_API_127: "Obtener gravedad del giroscopio",
  T_50_META_API_127_D: "El componente de gravedad detectado por el sensor de tu dispositivo",
  T_50_META_API_128: "Obtener la velocidad de rotación del giroscopio",
  T_50_META_API_128_D: "Se refiere a la velocidad de rotación de un dispositivo. Es un término relacionado con los sensores giroscópicos que describe la velocidad de movimiento rotatorio del dispositivo en un lugar tridimensional.",
  T_50_META_API_129: "Obtener rotación imparcial del giroscopio",
  T_50_META_API_129_D: "Describe la velocidad de rotación del dispositivo y proporciona un resultado más preciso al compensar el ruido o la predisposición de los sensores del dispositivo.",
  T_50_META_API_130: "Obtener la aceleración del usuario del giroscopio",
  T_50_META_API_130_D: "La parte de la aceleración del dispositivo sin el componente de gravedad, que es la aceleración causada por las acciones del usuario o por fuerzas externas.",
  T_50_META_API_131: "Obtener info de toque",
  T_50_META_API_131_D: "Obtén la información táctil de la pantalla del índice especificado (incluida la posición, el desplazamiento y el tiempo de cambio).",
  T_50_META_API_131_P0_D: "Distribuir ID de puntos de contacto, empezando por 0.",
  T_50_META_API_131_P1_D: "Posición del toque",
  T_50_META_API_131_P2: "Posición Delta",
  T_50_META_API_131_P2_D: "El cambio de posición con respecto al último cuadro",
  T_50_META_API_131_P3: "Hora Delta",
  T_50_META_API_131_P3_D: "Tiempo transcurrido del último cuadro",
  T_50_META_API_132: "Obtener recuento de toques en la pantalla",
  T_50_META_API_132_D: "Obtener el número actual de puntos de toque en la pantalla",
  T_50_META_API_133: "Vibrar dispositivo",
  T_50_META_API_133_D: "Haz que el dispositivo vibre una vez",
  T_50_META_API_134_D: "Notifica al dispositivo del jugador de destino que reproduzca el audio",
  T_50_META_API_134_P0_D: "El jugador objetivo",
  T_50_META_API_134_P1_D: "El recurso de audio",
  T_50_META_API_134_P2_D: "La velocidad de reproducción (rango válido: 0.1~3.0; 1 = normal, <1 = ralentizar, >1 = acelerar)",
  T_50_META_API_135_D: "Reproduce el archivo de audio una sola vez",
  T_50_META_API_135_P0_D: "Recursos de audio",
  T_50_META_API_135_P1_D: "Vel. de reproducción",
  T_50_META_API_136: "Cadena de formato",
  T_50_META_API_136_D: "Dar formato a las líneas",
  T_50_META_API_136_P0_D: "Líneas formateadas que utilizan controles verbales de formateo de Go",
  T_50_META_API_136_P1: "Matriz de parámetros",
  T_50_META_API_136_P1_D: "Lista de parámetros",
  T_50_META_API_137: "Componente de pegado",
  T_50_META_API_137_D: "Copiar o añadir datos de componente",
  T_50_META_API_137_P0: "Fuente",
  T_50_META_API_137_P0_D: "La entidad fuente",
  T_50_META_API_137_P1_D: "Entidad objetivo",
  T_50_META_API_137_P2: "Tipo de componente",
  T_50_META_API_137_P2_D: "Tipo de componente",
  T_50_META_API_137_P3: "Es Éxito",
  T_50_META_API_137_P3_D: "Tanto si tiene éxito como si no",
  T_50_META_API_138: "Revivir en el próximo cuadro",
  T_50_META_API_138_D: "Revive en el próximo marco",
  T_50_META_API_139: "Eliminar en el siguiente cuadro",
  T_50_META_API_139_D: "Elimina la entidad de batalla en el siguiente fotograma",
  T_50_META_API_139_P0_D: "La entidad de combate",
  T_50_META_API_140: "Salir del juego en el siguiente fotograma",
  T_50_META_API_140_D: "Salir del juego en el siguiente cuadro",
  T_50_META_API_141: "Obtener volumen del micrófono",
  T_50_META_API_141_D: "Obtener el volumen del micrófono. Devuelve el estado cuando el micrófono del jugador está apagado o no se ha otorgado acceso.",
  T_50_META_API_141_P0: "Volumen",
  T_50_META_API_141_P0_D: "El volumen del micrófono",
  T_50_META_API_141_P1_D: "El micrófono está activado o desactivado",
  T_50_META_API_142: "Obtener calidad del renderizado",
  T_50_META_API_142_D: "Obtener la calidad de renderizado actual (enúm.: Baja/Media/Alta/Ultra)",
  T_50_META_API_143: "Obtener resolución de renderizado",
  T_50_META_API_143_D: "Obtener la resolución del renderizador actual",
  T_50_META_API_144: "Vincular jugador personalizado",
  T_50_META_API_144_D: 'Establece dinámicamente el objetivo al que se vincula este jugador, lo que anulará las vinculaciones existentes. Devuelve "falso" si falla.',
  T_50_META_API_144_P0: "Jugador personalizado",
  T_50_META_API_144_P0_D: "Después de vincular este Jugador personalizado al jugador, los datos como la posición y la dirección se sincronizarán automáticamente.",
  T_50_META_API_144_P1_D: "Jugador objetivo",
  T_50_META_API_145: "Desvincular jugador personalizado",
  T_50_META_API_145_D: 'Cancela el enlace. Devuelve "falso" si falla.',
  T_50_META_API_145_P0: "Jugador personalizado",
  T_50_META_API_145_P0_D: "Borrar todas las vinculaciones para este destino. Después de desvincular, datos como la posición y la dirección ya no se sincronizarán automáticamente.",
  T_50_META_API_146_P0_D: "Un jugador personalizado",
  T_50_META_API_147: "Establecer estado personalizado del jugador",
  T_50_META_API_147_D: 'Carga automáticamente al servidor y sincroniza con todos los clientes. Devuelve "falso" si falla.',
  T_50_META_API_147_P0: "Jugador personalizado",
  T_50_META_API_147_P1: "Estado",
  T_50_META_API_147_P1_D: "Se utiliza normalmente para guardar los estados de la animación. Obtén el estado sincronizado con Obtener estado personalizado del jugador.",
  T_50_META_API_148: "Obtener estado personalizado del jugador",
  T_50_META_API_148_D: 'Los datos del estado se sincronizan automáticamente con el servidor. Devuelve "falso" si falla.',
  T_50_META_API_148_P0: "Jugador personalizado",
  T_50_META_API_148_P1: "Estado",
  T_50_META_API_148_P1_D: "Establece el estado con Establecer estado personalizado del jugador",
  T_50_META_API_149: "Establecer volúmenes de distancia",
  T_50_META_API_149_D: "Establece los rangos de distancia entre los jugadores para ajustar dinámicamente el volumen del audio.",
  T_50_META_API_149_P0: "Lista de distancia",
  T_50_META_API_149_P0_D: 'Los datos del estado se sincronizan automáticamente con el servidor. Devuelve "falso" si falla.',
  T_50_META_API_149_P1: "Lista de volumen",
  T_50_META_API_149_P1_D: "Una lista de volúmenes, cada uno correspondiente a un elemento de la lista de distancias.",
  T_50_META_API_150: "Obtener amigos",
  T_50_META_API_150_D: "Obtener la lista de los ID de los amigos del jugador",
  T_50_META_API_151: "Obtener información sobre la IU predeterminada",
  T_50_META_API_151_D: "Obtener la ubicación predeterminada de la IU del jugador",
  T_50_META_API_151_P0_D: "La interfaz predeterminada",
  T_50_META_API_151_P1_D: "Estado",
  T_50_META_API_151_P2_D: "Posición de la IU",
  T_50_META_API_151_P3: "Tamaño",
  T_50_META_API_151_P3_D: "Tamaño de la IU",
  T_50_META_API_152: "Transmitir evento personalizado",
  T_50_META_API_152_D: "Transmite un evento personalizado para que cualquier entidad reciba (escuche) este evento",
  T_50_META_API_153: "Enviar evento a entidad",
  T_50_META_API_153_D: "Envía el evento personalizado a la entidad de destino",
  T_50_META_EVT_17: "Al inicio del toque de la pantalla",
  T_50_META_EVT_17_D: "Inicia el evento cuando se toque la pantalla",
  T_50_META_EVT_17_P0: "Índice de toque",
  T_50_META_EVT_17_P0_D: "Índice de puntos de toque",
  T_50_META_EVT_17_P1_D: "Posición del toque",
  T_50_META_EVT_18: "Al final del toque de la pantalla",
  T_50_META_EVT_18_D: "Finaliza el evento cuando se toque la pantalla",
  T_50_META_EVT_18_P0: "Índice de toque",
  T_50_META_EVT_18_P0_D: "Índice de punto de contacto",
  T_50_META_EVT_18_P1_D: "Tocar posiciones en la pantalla",
  T_50_META_EVT_19: "Al recibir resultado al crear sala de persona",
  T_50_META_EVT_19_D: "Recibe el resultado correspondiente cuando no se pueda crear la sala de chat de la persona.",
  T_50_META_EVT_19_P1: "ID de la sala",
  T_50_META_EVT_19_P1_D: "El ID de la sala",
  T_50_META_EVT_20: "Al salir el usuario o al finalizar la partida del usuario",
  T_50_META_EVT_20_D: "Se activa cuando el usuario abandona la partida o cuando esta finaliza",
  T_50_META_TYP_11_I44: "Volúmenes de distancia",
  T_50_META_TYP_11_I44_D: "Ajusta dinámicamente el volumen del audio en función de la distancia entre los jugadores",
  T_50_META_TYP_22_I9_D: "El ID del recurso utilizado para crear la interfaz de usuario",
  T_50_META_TYP_244_I12_D: "El ancho de la caja de texto",
  T_50_META_TYP_244_I13_D: "La altura del cuadro de texto",
  T_50_META_TYP_244_I14_D: "El tipo de desbordamiento",
  T_50_META_TYP_335_I10_D: "La velocidad de reproducción (valor válido > 0, predeterminado = 1)",
  T_50_META_TYP_409_I20: "Creación_de_archivo_E/S_fallido",
  T_50_META_TYP_409_I20_D: "Error en la operación E/S: se ha producido un error al crear el archivo.",
  T_50_META_TYP_409_I21: "Nombre_de_archivo_E/S_vacío",
  T_50_META_TYP_409_I21_D: "Error en la operación E/S. Nombre de archivo inválido.",
  T_50_META_TYP_448_I0_D: "La parte controlada del esqueleto",
  T_50_META_TYP_448_I1_D: "El objetivo al que apunta la parte del esqueleto",
  T_50_META_TYP_451: "Tipo de desbordamiento",
  T_50_META_TYP_451_D: "El método para tratar el desbordamiento de texto",
  T_50_META_TYP_452: "ID de recurso de IU personalizada",
  T_50_META_TYP_452_D: "El ID que describe el recurso personalizado del HUD",
  T_50_META_TYP_453: "Tipo de calidad de renderizado",
  T_50_META_TYP_453_D: "La enumeración de la calidad de renderización",
  T_50_META_TYPE_448_D: "Esta entidad se utiliza para controlar la parte del esqueleto que mira hacia un objetivo",
  T_50_SD_WS_MAPTAG_AI3DGEN: "Generación de mapa por objeto 3D",
  T_50_SD_WS_MAPTAG_AIRACING: "Generación por IA del mapa de carreras",
  T_50_XXJ_WS_ANIMATIONSTATENAME: "Enumeración de nombres de estados de animación",
  T_50_XXJ_WS_DISABLEFOOTSTEP: "Desactivar la vibración de los pasos",
  T_50_XXJ_WS_NOPERFORMANCE: "No hay archivo de rendimiento aún",
  T_50_XXJ_WS_PERFORMANCE_BATETIPS: "Versión beta",
  T_50_XXJ_WS_PERFORMANCE_BATETIPS_DESC: "Estimados creadores, el editor de rendimiento aún se encuentra en la fase de prueba. Es posible que presente errores o que le falten funciones esenciales. Úsenlo con cuidado.",
  T_50_XXJ_WS_PERFORMANCE_NEW: "Añadir rendimiento",
  T_50_XXJ_WS_TIMELINE_ADD_KEYCLIP: "Añadir clip clave",
  T_50_XXJ_WS_TIMELINE_ALONGPATH_TRACK: "Pista a lo largo del camino",
  T_50_XXJ_WS_TIMELINE_ANIMATION_CLIP: "Animación",
  T_50_XXJ_WS_TIMELINE_ANIMATION_TRACK: "Pista de animación",
  T_50_XXJ_WS_TIMELINE_AUDIO_TRACK: "Pista de audio",
  T_50_XXJ_WS_TIMELINE_CLIP_LOOP_TYPE_HOLD: "Mantener",
  T_50_XXJ_WS_TIMELINE_CLIP_LOOP_TYPE_LOOPFOREVER: "Bucle eterno",
  T_50_XXJ_WS_TIMELINE_DURATION: "Duración: {0}s",
  T_50_XXJ_WS_TIMELINE_ERROR_CODE_AVATAR: "Discrepancia entre la animación y el modelo",
  T_50_XXJ_WS_TIMELINE_ERROR_CODE_CLIP_OVERLAP: "Superposición del clip clave",
  T_50_XXJ_WS_TIMELINE_ERROR_CODE_ENTITY_MISSING: "Entidad vinculante faltante",
  T_50_XXJ_WS_TIMELINE_NAME_EMPTY: "No puede ir vacío el nombre de la pista",
  T_50_XXJ_WS_TIMELINE_NPC_TRACK: "Pista del NPC",
  T_50_XXJ_WS_TIMELINE_PROP_TRACK: "Pista de propiedad",
  T_50_XXJ_WS_TIMELINE_REMOVE_KEYCLIP: "Quitar clip clave",
  T_50_XXJ_WS_TIMELINE_TIME_SUFFIX: "{0}s",
  T_50_XXJ_WS_TIMELINE_TRACK_MAX_LIMIT: "Se ha superado el límite de pistas",
  T_50_XYL_WS_AIGETERATESHOW: "Bloques de construcción",
  T_50_YU_F_B_VA_WITCH: "Hechicera maldita (inferior)",
  T_50_YU_F_H_VA_WITCH: "Hechicera maldita (cabeza)",
  T_50_YU_F_HA_VA_WITCH: "Hechicera maldita (maquillaje)",
  T_50_YU_F_S_VA_WITCH: "Hechicera maldita (zapatos)",
  T_50_YU_F_T_VA_WITCH: "Hechicera maldita (superior)",
  T_50_ZCS_CLCUSTOMEVE_CUSTOMEVENT: "Evento personalizado",
  T_51_GT_WS_BASIC: "Básico",
  T_51_GT_WS_GLOBALEVENT: "Evento global",
  T_51_GT_WS_PRIVATEEVENT: "Evento privado",
  T_51_GT_WS_STORY: "Story",
  T_51_GT_WS_UI: "UI",
  T_51_JH_WS_MINTIP1: "",
  T_51_META_API_1114: "User Message To Persona Voice Response",
  T_51_META_API_1114_D: "Send persona user's message and get a voice response from persona",
  T_51_META_API_1114_P2_D: "If true, the voice response will automically play when received; else, an API is required to play it",
  T_51_META_API_1115: "System Message To Persona Voice Response",
  T_51_META_API_1115_D: "Send persona system message and get a voice response from persona",
  T_51_META_API_1116: "Play Stored Voice From Persona",
  T_51_META_API_1116_D: "Play stored voice reponses from persona. Can store up to 10 responses.",
  T_51_META_API_144_P2_D: "Whether the execution is successful",
  T_51_META_API_154: "Get Type Name",
  T_51_META_API_154_D: "Return the name of the target object's type",
  T_51_META_API_154_P0_D: "The target object to get type name for",
  T_51_META_API_155: "Get Bounding Box",
  T_51_META_API_155_D: "Get the Bounding Box of the scene object",
  T_51_META_API_155_P0_D: "The scene object to get the bounding box for",
  T_51_META_API_155_P1_D: "The center of the bounding box",
  T_51_META_API_155_P2: "Size",
  T_51_META_API_155_P2_D: "The size of the bounding box",
  T_51_META_API_156: "Create Entity",
  T_51_META_API_156_D: "Create an entity. You can specify an owner (a specific player client). In combination with the AddComponent API, you can synchronize data targeted to that particular client.",
  T_51_META_API_156_P0_D: "The target entity to be created",
  T_51_META_API_156_P1_D: "The type of the created custom component",
  T_51_META_API_156_P2_D: "The owner of the entity",
  T_51_META_API_156_P3: "Flag",
  T_51_META_API_156_P3_D: "Entity flag. See Entity Flag enum for more details. Can be used in combination.",
  T_51_META_API_157: "Set Material Property",
  T_51_META_API_157_D: "This API allows you to modify certain properties of an object's material.",
  T_51_META_API_157_P0_D: "The target object to get the material property for",
  T_51_META_API_157_P1: "Property Name",
  T_51_META_API_157_P1_D: "Set the name of the property",
  T_51_META_API_157_P2: "Property Value",
  T_51_META_API_157_P2_D: "Set the value of the property",
  T_51_META_API_157_P3: "Success",
  T_51_META_API_157_P3_D: "Set whether it's successful or not",
  T_51_META_API_158: "Clear Material Property",
  T_51_META_API_158_D: "Clear the set properties",
  T_51_META_API_158_P0_D: "The target object to clear the material property for",
  T_51_META_EVT_21: "On Custom Property Change",
  T_51_META_EVT_21_D: "When a monitored custom property changes, this event will trigger. Note: if a custom property is modified multiple times within a single frame, this event is only triggered once. When the server modifies a custom property, the event is sent to both endpoints; when a client modifies a local entity's custom property, the event is only delivered locally.",
  T_51_META_EVT_21_P0: "Property Index",
  T_51_META_EVT_21_P0_D: "The property's index",
  T_51_META_EVT_21_P1_D: "The property's new value",
  T_51_META_EVT_22: "Al cambiar el estado del jugador personalizado",
  T_51_META_EVT_22_D: "Este evento se activará cuando cambie el estado del jugador personalizado",
  T_51_META_EVT_22_P0: "Estado del jugador personalizado",
  T_51_META_EVT_22_P0_D: "Estado del jugador personalizado",
  T_51_META_EVT_23: "On Receive Voice Response From Persona",
  T_51_META_EVT_23_D: "Trigger this event when persona's voice response is received",
  T_51_META_EVT_24: "On Play Voice Finish From Persona",
  T_51_META_EVT_24_D: "Trigger this event when persona's voice response has finished playing",
  T_51_META_TYP_14_I79: "Vincular jugador personalizado",
  T_51_META_TYP_14_I79_D: "Cuando se vincula con un jugador personalizado, el modelo clásico del personaje se oculta y la posición, rotación (orientación) y otros datos del objeto de destino se sincronizan con él.",
  T_51_META_TYP_15_I6: "Is Show Teammate Name",
  T_51_META_TYP_15_I6_D: "Whether to show teammates' names on the top of their heads",
  T_51_META_TYP_247_I31: "Help Up",
  T_51_META_TYP_247_I31_D: "Help Up",
  T_51_META_TYP_247_I32: "Give Up",
  T_51_META_TYP_247_I32_D: "Give Up",
  T_51_META_TYP_247_I33: "Attack 2",
  T_51_META_TYP_247_I33_D: "Attack 2",
  T_51_META_TYP_247_I34: "Combine Weapon",
  T_51_META_TYP_247_I34_D: "Combine Weapon",
  T_51_META_TYP_247_I35: "Surfboard",
  T_51_META_TYP_247_I35_D: "Surfboard",
  T_51_META_TYP_313_I2_D: "Out-of-zone damage per second",
  T_51_META_TYP_409_I22: "Parameter Error",
  T_51_META_TYP_409_I22_D: "Parameter error",
  T_51_META_TYP_440_I1_D: "Performance asset ID",
  T_51_META_TYP_454: "Material Property",
  T_51_META_TYP_454_D: "Use to set the material property for an object",
  T_51_META_TYP_455: "Entity Flag",
  T_51_META_TYP_455_D: "La bandera de propiedad para una entidad específica puede usarse en combinación",
  T_51_META_TYP_455_I0_D: "Default property",
  T_51_META_TYP_455_I1: "Static",
  T_51_META_TYP_455_I1_D: "Static entity",
  T_51_META_TYP_455_I2: "Local",
  T_51_META_TYP_455_I2_D: "Localy entity",
  T_51_META_TYP_455_I3: "Solo renderizado",
  T_51_META_TYP_455_I3_D: "Solo renderizado",
  T_51_MX_WS_ACTION_BITE: "Crispy Bite",
  T_51_MX_WS_ACTION_BOUNCE: "",
  T_51_MX_WS_ACTION_DOOR_CREAK: "",
  T_51_MX_WS_ACTION_FALL_HIT: "Ground Slam",
  T_51_MX_WS_ACTION_GULP: "",
  T_51_MX_WS_ACTION_RUNAWAY_DUST: "",
  T_51_MX_WS_ACTION_RUNNING_STEPS: "",
  T_51_MX_WS_ACTION_SPIN_LOOP: "",
  T_51_MX_WS_ACTION_STOMACH_GROWL: "Stomach Growling",
  T_51_MX_WS_AMBIENT_BIRDS: "Bird Chirping",
  T_51_MX_WS_AMBIENT_CAFE_AMBIENCE: "Cafe Atmosphere",
  T_51_MX_WS_AMBIENT_CLASSROOM_OFFICE: "Classroom Ambience",
  T_51_MX_WS_AMBIENT_NIGHT_CRICKETS: "",
  T_51_MX_WS_AMBIENT_RAIN: "Raining",
  T_51_MX_WS_AMBIENT_STREET_TRAFFIC: "Street Traffic",
  T_51_MX_WS_AMBIENT_WAVES: "",
  T_51_MX_WS_ATMOSPHERE_APPLAUSE_LAUGH: "",
  T_51_MX_WS_ATMOSPHERE_BASS_DRUM: "",
  T_51_MX_WS_ATMOSPHERE_BELL: "Bell Ringing",
  T_51_MX_WS_ATMOSPHERE_JINGLE: "Bell Jingling",
  T_51_MX_WS_ATMOSPHERE_WIND: "Howling Wind",
  T_51_MX_WS_COMEDY_AIR_WHIP: "",
  T_51_MX_WS_COMEDY_CAMERA_CLICK: "Camera Click",
  T_51_MX_WS_COMEDY_FAIL_WAHWAH: "",
  T_51_MX_WS_COMEDY_FART: "Funny Fart",
  T_51_MX_WS_COMEDY_FUNNY_LAUGH: "Laughter",
  T_51_MX_WS_COMEDY_HEAD_SLAP: "",
  T_51_MX_WS_COMEDY_IDEA_DING: "",
  T_51_MX_WS_COMEDY_RECORD_SCRATCH: "",
  T_51_MX_WS_COMEDY_VICTORY_DING: "",
  T_51_MX_WS_EMOTION_AWKWARD: "",
  T_51_MX_WS_EMOTION_BLINK_SWITCH: "",
  T_51_MX_WS_EMOTION_CONFIDENT_VICTORY: "",
  T_51_MX_WS_EMOTION_CONFUSED: "",
  T_51_MX_WS_EMOTION_HAPPY_NOTIFICATION: "",
  T_51_MX_WS_EMOTION_HEARTBEAT_LOVE: "Heart Beating",
  T_51_MX_WS_EMOTION_PHONE_VIBRATION: "",
  T_51_MX_WS_EMOTION_SIGH_SAD: "Sigh",
  T_51_MX_WS_EMOTION_SNORT: "",
  T_51_MX_WS_EMOTION_SPARKLE: "",
  T_51_MX_WS_EMOTION_SURPRISE_SHOCK: "",
  T_51_MX_WS_EMOTION_TEETH_CHATTER: "Teeth Chattering",
  T_51_MX_WS_FANTASY_MAGIC_CAST: "",
  T_51_MX_WS_FANTASY_TRANSFORM: "",
  T_51_MX_WS_FX_EXPLOSION: "Explosion Impace",
  T_51_MX_WS_FX_FIRE_BURN: "Crackling Flames",
  T_51_MX_WS_FX_ICE_CRACK: "",
  T_51_MX_WS_FX_LIGHTNING: "Lightning",
  T_51_MX_WS_FX_SPLASH: "Splash",
  T_51_MX_WS_MECHANIC_BOX_OPEN: "Unboxing",
  T_51_MX_WS_MECHANIC_GEAR_SPIN: "Gear Rotating",
  T_51_MX_WS_MECHANIC_LOCK_UNLOCK: "",
  T_51_MX_WS_MECHANIC_OPEN_CLOSE: "",
  T_51_MX_WS_MECHANIC_POURING: "",
  T_51_MX_WS_RHYTHM_BREAK_BEAT: "",
  T_51_MX_WS_RHYTHM_CLAP: "Clapping",
  T_51_MX_WS_RHYTHM_DRUM_BEAT: "",
  T_51_MX_WS_SOUNDTYPE_INTERACTION: "",
  T_51_MX_WS_TRANSITION_GLITCH: "",
  T_51_MX_WS_TRANSITION_POPUP: "Window Pop-up",
  T_51_MX_WS_TRANSITION_REVERSE_SUCTION: "",
  T_51_MX_WS_TRANSITION_WHOOSH: "",
  T_51_MX_WS_TRANSPORT_AIRCRAFT: "",
  T_51_MX_WS_TRANSPORT_BIKE_SKATE: "",
  T_51_MX_WS_TRANSPORT_CAR_DRIVE: "",
  T_51_MX_WS_TRANSPORT_CAR_ENGINE_HIGHACCEL: "",
  T_51_MX_WS_TRANSPORT_CAR_ENGINE_HIGHDECEL: "",
  T_51_MX_WS_TRANSPORT_CAR_ENGINE_LOOP: "",
  T_51_MX_WS_TRANSPORT_CAR_ENGINE_LOWACCEL: "",
  T_51_MX_WS_TRANSPORT_CAR_ENGINE_LOWDECEL: "",
  T_51_MX_WS_TRANSPORT_STREAM_FLOW: "Rushing Water",
  T_51_MX_WS_TRANSPORT_TRAIN_BEEP: "",
  T_51_MX_WS_UI_ACHIEVEMENT_UNLOCK: "",
  T_51_MX_WS_UI_BUTTON_CLICK: "Button Click",
  T_51_MX_WS_UI_CANCEL: "",
  T_51_MX_WS_UI_CONFIRM: "",
  T_51_MX_WS_UI_LIST_SCROLL: "",
  T_51_MX_WS_UI_LOADING: "Loading Progress",
  T_51_TYC_API_OUTLINE: "Set Entity Outline",
  T_51_TYC_API_OUTLINE_ALPHA: "Outline Transparency",
  T_51_TYC_API_OUTLINE_ALPHA_D: "Value between 0 and 1 (0 = fully transparent,1 = fully opaque)",
  T_51_TYC_API_OUTLINE_COLOR: "Outline Color",
  T_51_TYC_API_OUTLINE_COLOR_D: "The color used for drawing the outline",
  T_51_TYC_API_OUTLINE_D: "Specifies an entity to highlight its edges. Supported types include Player, Custom Render, NPC, Appearance, and Basic Appearance.",
  T_51_TYC_API_OUTLINE_TARGET: "Target Entity",
  T_51_TYC_API_OUTLINE_TARGET_D: "The entity to be outlined",
  T_51_TYC_API_OUTLINE_TOPMOST: "Always on Top",
  T_51_TYC_API_OUTLINE_TOPMOST_D: "Makes the outline render through all objects, always visible on top.",
  T_51_TYC_API_OUTLINE_WIDTH: "Outline Width",
  T_51_TYC_API_OUTLINE_WIDTH_D: "Value between 0 and 1 (0 = no outline, 1 = max. outline thickness)",
  T_51_XJ_WS_BASIC_SETTING: "Ajuste básicos",
  T_51_XJ_WS_GAME_START_TIME_UNIT: "Segundo",
  T_51_XJ_WS_GMSTART_TIME: "Tiempo de preparación antes de que comience el juego",
  T_51_ZCS_SPAWNPOINT_NAME: "",
  T_OB47_M_WS_READ: "Propiedad de solo lectura",
  TXT_AVATAR_FEMALE_JACKET_BLACK: "Chamarra de Cuero Negro (Mujer)",
  TXT_AVATAR_FEMALE_PANTS_MARIO: "Cazador de hongos",
  TXT_AVATAR_FEMALE_SHOE_COS_HOODSHIRT_BLACK: "Black Activewear (Zapatos)",
  TXT_AVATAR_FEMALE_SHORTPANT_COS_GSL_BLACK: "Pant. Corto GW2018 (Mujer)",
  TXT_AVATAR_FEMALE_SKIRT_COS_GSL_BLACK: "Falda GW2018 (Mujer)",
  TXT_AVATAR_FEMALE_TOP_COS_HOODSHIRT_BLACK: "Hoodie Entrenamiento (Negra)",
  TXT_AVATAR_FEMALE_TOP_COS_SONGKRAN_2018: "Top de Verano Negro",
  TXT_AVATAR_FEMALE_TSHIRT_MARIO: "Rosas y hongos",
  TXT_AVATAR_FEMALE_VEST_COS_GSL_BLACK: "Sin Mangas GW2018 (Femenino)",
  TXT_AVATAR_MALE_BOTTOM_COS_CNY_RED: "Prosperidad Blanca (Inferior)",
  TXT_AVATAR_MALE_BOTTOM_COS_GANGS_BLACK: "Pant. Ejercicio Negro (Masculino)",
  TXT_AVATAR_MALE_BOTTOM_COS_MOB_YELLOW: "Cazador",
  TXT_AVATAR_MALE_BOTTOM_COS_OUTDOOR_BLACK: "Pant. Sobreviviente",
  TXT_AVATAR_MALE_PANTS_MARIO: "Mamamía",
  TXT_AVATAR_MALE_SHOE_COS_CANVAS_BLACK: "Tenis Sobreviviente",
  TXT_AVATAR_MALE_SHOE_RED: "Botas Rojas (Hombre)",
  TXT_AVATAR_MALE_TOP_COS_CNY_RED: "Prosperidad Blanca (Superior)",
  TXT_AVATAR_MALE_TOP_COS_GANGS_BLACK: "Jersey Béisbol Negro (Masculino)",
  TXT_AVATAR_MALE_TOP_COS_HOODIE_BRICKR: "Capucha Rebelde",
  TXT_AVATAR_MALE_TOP_COS_HOODSHIRT_BLACK: "Hoodie Entrenamiento",
  TXT_AVATAR_MALE_TOP_COS_MOB_DGREEN: "Rey Calavera",
  TXT_AVATAR_MALE_TOP_COS_OUTDOOR_GREY: "Camiseta Sobreviviente",
  TXT_AVATAR_MALE_TSHIRT_MARIO: "Playera de fontanero",
  TXT_AVATAR_OB10_LZW_FEMALE_TOP_COS_SPONSOR: "Chamarra de Corredora",
  TXT_AVATAR_OB10_LZW_MALE_HAIR_COS_CLOWN: "Payaso nocturno (Cabeza)",
  TXT_AVATAR_OB10_LZW_MALE_TOP_COS_SPONSOR: "Chamarra de Corredor",
  TXT_AVATAR_OB10_LZW_TOP_SLEEVELESS: "Chamarra sin mangas (Verde)",
  TXT_AVATAR_OB11_LZW_COS_NYARUKO: "Señor Calamar",
  TXT_AVATAR_OB11_LZW_MALE_ACCESSORY_COS_ZOMBIE: "Samurái Zombi (Máscara)",
  TXT_AVATAR_OB11_LZW_MALE_TOP_COS_PINK_JAZZ: "Tatuaje completo",
  "TXT_AVATAR_OB7_LZW_FEMALE_A-SKIRT_BLACK": "Falda",
  TXT_AVATAR_OB7_LZW_FEMALE_BOTTOM_COS_CNY_RED_OBT7TH: "Victoria",
  TXT_AVATAR_OB7_LZW_FEMALE_BOTTOM_COS_DOWNJACKET_OBT7TH: "Estilo Retro",
  TXT_AVATAR_OB7_LZW_FEMALE_BOTTOM_COS_JAPANESESTYLE_PINK: "Kitsune (Inferior)",
  TXT_AVATAR_OB7_LZW_FEMALE_SHOE_COS_JAPANESESTYLE_PINK: "Kitsune (Zapatos)",
  TXT_AVATAR_OB7_LZW_FEMALE_SHOE_SPORTS_08: "Tenis (Azul)",
  TXT_AVATAR_OB7_LZW_FEMALE_SHORTPANTS_FLAP_BLUE: "Short de Mezclilla (Mujer)",
  TXT_AVATAR_OB7_LZW_FEMALE_TOP_COS_JAPANESESTYLE_PINK: "Kitsune (Superior)",
  TXT_AVATAR_OB7_LZW_MALE_BOTTOM_COS_BATTLE_BROWN: "Pant. Combate",
  TXT_AVATAR_OB7_LZW_MALE_BOTTOM_COS_DOWNJACKET_OBT7TH: "Pantalones Angelicales",
  TXT_AVATAR_OB7_LZW_MALE_BOTTOM_COS_JAPANESESTYLE_PURPLE: "Bushido",
  TXT_AVATAR_OB7_LZW_MALE_HOODIE_ZIPPER_GREY: "Hoodie Gris",
  TXT_AVATAR_OB7_LZW_MALE_SHOE_COS_CASUAL: "Zapatos Hipster",
  TXT_AVATAR_OB7_LZW_MALE_SHOE_COS_JAPANESESTYLE_PURPLE: "Zapatos Bushido",
  TXT_AVATAR_OB7_LZW_MALE_SHOE_COS_TECHWEAR_OBT7TH: "Zapatos Astro",
  TXT_AVATAR_OB7_LZW_MALE_SHORTPANTS_FLAP_BLUE: "Short de Mezclilla (Hombre)",
  TXT_AVATAR_OB7_LZW_MALE_TOP_COS_BATTLE_BROWN: "Chaleco Comb.",
  TXT_AVATAR_OB7_LZW_MALE_TOP_COS_CASUAL: "Top Hipster",
  TXT_AVATAR_OB7_LZW_MALE_TOP_COS_JAPANESESTYLE_PURPLE: "Bushido",
  TXT_AVATAR_OB8_LZW_BALLPANTS_WHITE: "Peligro Blanco",
  TXT_AVATAR_OB8_LZW_FEMALE_BOTTOM_COS_BASEBALL_GREEN: "Pant. Baseball",
  TXT_AVATAR_OB8_LZW_FEMALE_TOP_ASUS_JACKET: "Chamarra Corredora 2",
  TXT_AVATAR_OB8_LZW_FEMALE_TOP_COS_BASEBALL_GREEN: "Baseball (Chaq)",
  TXT_AVATAR_OB8_LZW_MALE_BOTTOM_COS_BASEBALL_YELLOW: "Capitán Cool (Inferior)",
  "TXT_AVATAR_OB8_LZW_MALE_HAIR_COS_HIP-HOP": "Barrio (Cabeza)",
  TXT_AVATAR_OB8_LZW_MALE_SHOE_COS_BASEBALL_YELLOW: "Capitán Cool (Zapatos)",
  TXT_AVATAR_OB8_LZW_MALE_TOP_ASUS_JACKET: "Chamarra Corredor 2",
  TXT_AVATAR_OB8_LZW_MALE_TOP_COS_BASEBALL_YELLOW: "Capitán Cool (Superior)",
  TXT_AVATAR_OB8_LZW_MALE_TOP_COS_DINOSAUR_GREEN: "Dino",
  TXT_AVATAR_OB8_LZW_SHOE_SOCCER_SILVER: "Zapatos Plateados",
  TXT_AVATAR_OB8_LZW_TSHIRT_ENGLAND_B: "Triple León",
  TXT_AVATAR_OB9_LZW_MALE_ACCESSORY_COS_TUXEDO: "Traje (Máscara)",
  TXT_AVATAR_OB9_LZW_MALE_HAIR_COS_TUXEDO: "Traje (Cabeza)",
  TXT_AVATAR_PARACHUTE_8: "Carita Feliz",
  TXT_AVATAR_SHIRT_PLAID_2: "Camisa de Cuadros (Rojo)",
  TXT_AVATAR_SHOES_1: "Zapatos deportivos (Blanco)",
  TXT_AVATAR_SUIT_FEMALE_TOP_1_2: "Uniforme escolar (Naranja)",
  TXT_AVATAR_SUIT_FEMALE_TOP_1_3: "Uniforme escolar (Rojo)",
  TXT_AVATAR_SUIT_FEMALE_TOP_1_4: "Uniforme escolar (Amarillo)",
  TXT_AVATAR_SUIT_FEMALE_TOP_1_5: "Uniforme escolar (Rosa)",
  TXT_AVATAR_SUIT_FEMALE_TOP_1_6: "Uniforme escolar (Jazmín)",
  TXT_AVATAR_SUIT_FEMALE_TOP_1_7: "Uniforme escolar (Azul)",
  TXT_AVATAR_TSHIRT_WEEK_007: "Domingo Apasionado",
  TXT_BANNER_NAME_MISHA: "Velocidad",
  TXT_CHARACTER_ADAM_NAME: "Adán",
  TXT_CHARACTER_BODYGUARD_NAME: "Nikita",
  TXT_CHARACTER_COP_NAME: "Andrew",
  TXT_CHARACTER_EVA_NAME: "Eva",
  TXT_CHARACTER_NURSE_NAME: "Olivia",
  TXT_CHARACTER_RACERGIRL_NAME: "Misha",
  TXT_CHARACTER_RUNNER_NAME: "Kelly",
  TXT_CHARACTER_SEAMAN_NAME: "Ford",
  TXT_CLAN_NAME: "Nombre",
  TXT_COLLECTION_DESCRIPTION: "Descripción",
  TXT_COLLECTION_HEADPORTRAIT: "Iconos",
  TXT_INVENTORY_TITLE_EQUIPMENT: "Equipo",
  TXT_ITEM_AK: "AK47",
  TXT_ITEM_ARAMMO: "Munición RA",
  TXT_ITEM_AWM: "AWM",
  TXT_ITEM_BAG1: "Mochila Nvl.1",
  TXT_ITEM_BAG2: "Mochila Nvl.2",
  TXT_ITEM_BAG3: "Mochila Nvl.3",
  TXT_ITEM_BASEBALLPOLE: "Bate",
  TXT_ITEM_BOWAMMO: "Flechas",
  TXT_ITEM_CHANGUO: "Sartén",
  TXT_ITEM_CROSSBOW: "Ballesta",
  TXT_ITEM_DESC_FLASH: "Un dispositivo explosivo que desorienta temporalmente al enemigo",
  TXT_ITEM_EAGLE: "Desert Eagle",
  TXT_ITEM_FAK: "Botiquín",
  TXT_ITEM_FAMAS: "FAMAS",
  TXT_ITEM_FIST: "Puño",
  TXT_ITEM_FLASH: "Granada Cegadora",
  TXT_ITEM_FOREGRIP1: "Empuñadura nvl. 1",
  TXT_ITEM_FOREGRIP2: "Empuñadura nvl. 2",
  TXT_ITEM_FOREGRIP3: "Empuñadura nvl. 3",
  TXT_ITEM_G18: "G18",
  TXT_ITEM_GRENADE: "Granada",
  TXT_ITEM_GROZA: "GROZA",
  TXT_ITEM_HANDCANNON: "Cañón de Mano",
  TXT_ITEM_HEATSIGHT: "Mira térmica",
  TXT_ITEM_HELMET1: "Casco Nvl. 1",
  TXT_ITEM_HELMET2: "Casco Nvl. 2",
  TXT_ITEM_HELMET3: "Casco Nvl. 3",
  TXT_ITEM_HGAMMO: "Balas pistola",
  TXT_ITEM_KAR98K: "Kar98k",
  TXT_ITEM_LANUNCHERAMMO: "40mmSR",
  TXT_ITEM_M1014: "M1014",
  TXT_ITEM_M14: "M14",
  TXT_ITEM_M1873: "M1873",
  TXT_ITEM_M249: "M249",
  TXT_ITEM_M4A1: "M4A1",
  TXT_ITEM_M500: "M500",
  TXT_ITEM_M79: "M79",
  TXT_ITEM_MACHETE: "Machete",
  TXT_ITEM_MAGEZINE1: "Cargador Nvl.1",
  TXT_ITEM_MAGEZINE2: "Cargador Nvl.2",
  TXT_ITEM_MAGEZINE3: "Cargador Nvl.3",
  TXT_ITEM_MP40: "MP40",
  TXT_ITEM_MP5: "MP5",
  TXT_ITEM_MUZZLE1: "Boquilla Nvl. 1",
  TXT_ITEM_MUZZLE2: "Boquilla Nvl. 2",
  TXT_ITEM_MUZZLE3: "Boquilla Nvl. 3",
  TXT_ITEM_SCAR: "SCAR",
  TXT_ITEM_SGAMMO: "Balas de escopeta",
  TXT_ITEM_SIGHT2: "Mira 2x",
  TXT_ITEM_SIGHT4: "Mira 4x",
  TXT_ITEM_SILENCER1: "Silenciador",
  TXT_ITEM_SKS: "SKS",
  TXT_ITEM_SMGAMMO: "Munición de subfusil",
  TXT_ITEM_SNAMMO: "Balas Rifle",
  TXT_ITEM_SPAS12: "SPAS12",
  TXT_ITEM_SVD: "SVD",
  TXT_ITEM_UMP: "UMP",
  TXT_ITEM_USP: "USP",
  TXT_ITEM_VEST1: "Chaleco Antibalas Nvl.1",
  TXT_ITEM_VEST2: "Chalecos Antibalas Nvl.2",
  TXT_ITEM_VEST3: "Chalecos Antibalas Nvl.3",
  TXT_ITEM_VSS: "VSS",
  TXT_ITEM_XM8: "XM8",
  TXT_MATCHRESULT_TITLE: "Resultados",
  TXT_MESSAGEBOX_ERROR: "Error",
  TXT_OB10_HQW_ITEM_BIPOD: "Bipode",
  TXT_OB10_HQW_ITEM_M60: "M60",
  TXT_OB10_JRW_CAMOUFLAGE_OILDRUM_NAME: "Barril de Aceite",
  TXT_OB10_JRW_CHARACTER_BRAZILSOLDIER_NAME: "Miguel",
  TXT_OB10_JRW_SKILL_NAME_BRAZILSOLDIER: "Asesino Loco",
  TXT_OB10_ZXR_BASEBALLBAT_CORN_NAME: "Bate- Elote",
  TXT_OB10_ZXR_GRENADESKIN_RANGE: "Rango de la explosión",
  TXT_OB10_ZXR_MACHETE_RANKMASTER_NAME: "Machete - El Verdugo",
  TXT_OB11_HQW_ITEM_MGL140: "MGL140",
  TXT_OB11_HQW_ITEM_P90: "P90",
  TXT_OB11_HQW_LANDMINE: "Mina",
  TXT_OB11_HQW_LANDMINE_DESC: "Una mina que se coloca en el suelo ¡No la vayas a pisar!",
  TXT_OB11_JRW_CHARACTER_RICHGIRL_NAME: "Caroline",
  TXT_OB11_JRW_EMOTE_CLAP_NAME: "Aplauso",
  TXT_OB11_JRW_EMOTE_DAB_NAME: "Dab",
  TXT_OB11_JRW_EMOTE_FUNKYCHICKEN_NAME: "Gallina",
  TXT_OB11_JRW_EMOTE_HELLO_NAME: "¡Hola!",
  TXT_OB11_JRW_EMOTE_LOL_NAME: "LOL",
  TXT_OB11_JRW_EMOTE_PROVOKE_NAME: "Provocación",
  TXT_OB11_JRW_SKILL_DESC_RICHGIRL: "Al usar una escopeta, incrementa la velocidad de movimiento un [FFB300]{0}%[-].",
  TXT_OB11_JRW_SKILL_NAME_RICHGIRL: "Extremadamente ágil",
  TXT_OB11_ZXR_SCAR_CHEETAH_NAME: "Colmillo de Chita",
  TXT_OB11_ZXR_SCAR_TOPGAMER_NAME: "SCAR- Futurista",
  TXT_OB16_Q_ITEM_ARMORREPAIR: "Kit de Reparación",
  TXT_OB5_HISTORY_HEADSHOOT: "Abatidos",
  TXT_OB5_HISTORY_LIVE: "Sobrevive",
  TXT_OB7_JRW_CHARACTER_FOODIEBOY_NAME: "Maxim",
  TXT_OB7_JRW_SKILL_DESC_FOODIEBOY: "Come hongos y usa botiquines [FFB300]{0}%[-] más.",
  TXT_OB7_JRW_SKILL_NAME_FOODIEBOY: "Glotonería",
  TXT_OB7_ZC_CLAN_NICKNAME: "Apodo",
  TXT_OB7_ZJS_HISTORY_TIME: "Tiempo",
  TXT_OB8_HQW_NEWLOADOUT_BONFIRE: "Fogata",
  TXT_OB8_JYF_PARACHUTE_THUNDER_NAME: "Trueno",
  TXT_OB8_SQ_CHARACTER_THAIBOXER_NAME: "Kla",
  TXT_OB8_SQ_SKILL_DESC_THAIBOXER: "Incrementa daño con puño en [FFB300]{0}%[-].",
  TXT_OB8_SQ_SKILL_NAME_THAIBOXER: "Muay Thai",
  TXT_OB8_ZXR_AWM_CAMO_NAME: "Prados Morados",
  TXT_OB8_ZXR_G18_CAMO_NAME: "Divideátomos",
  TXT_OB8_ZXR_M249_CAMO_NAME: "Marchito",
  TXT_OB8_ZXR_M79_CAMO_NAME: "Dividecielos",
  TXT_OB8_ZXR_USP_CAMO_NAME: "Leopardo Nevado",
  TXT_OB9_JRW_CHARACTER_ARMSDEALER_NAME: "Paloma",
  TXT_OB9_JRW_SKILL_NAME_ARMSDEALER: "Traficante",
  TXT_OB9_JYF_SKYBOARD_BOOYAH_NAME: "Estrella verde",
  TXT_OB9_SQ_ITEM_GLOOSHIELD: "Pared Gloo",
  TXT_OB9_ZXR_AK47_DIGI_CAMO_NAME: "Camuflaje digital",
  TXT_OB9_ZXR_FAMAS_RED_NAME: "Bloody Mary",
  TXT_OB9_ZXR_G18_CAMO_02_NAME: "Cazador del desierto",
  TXT_OB9_ZXR_GROZA_CAMO_NAME: "Flama Azul",
  TXT_OB9_ZXR_M1014_CAMO_02_NAME: "Festival púrpura",
  TXT_OB9_ZXR_M14_CAMO_NAME: "Flujo de vida",
  TXT_OB9_ZXR_M1873_NAME: "Océano Azul",
  TXT_OB9_ZXR_MACHETE_FISH_NAME: "Machete- Pez Espada",
  TXT_OB9_ZXR_MP5_CAMO_NAME: "Cosechador",
  TXT_OB9_ZXR_SCAR_CAMO_BLUE_NAME: "Cuarzo púrpura",
  TXT_OB9_ZXR_SKS_CAMO_NAME: "Tierra Perdida",
  TXT_OPTION_HIGH_BRIGHTNESS: "Brillo",
  TXT_PLAYER_RANK: "Ranking",
  TXT_ROOM_LOBBY_ID: "ID",
  TXT_ROOM_MAP_PARADISE: "Bermuda",
  TXT_SETTING_CHANGEWEAPON: "Botón de Cambio rápido de arma",
  TXT_SETTING_OB4_NOTREAL: "Oscuro",
  TXT_SKILL_DESC_COP: "La pérdida de durabilidad de la armadura disminuyó  [FFB300]{0}%[-].",
  TXT_SKILL_DESC_RUNNER: "Velocidad al correr aumentada en [FFB300]{0}%[-].",
  TXT_SKILL_NAME_COP: "Especialista en Armadura",
  TXT_SKILL_NAME_NURSE: "Toque Sanador",
  TXT_SKILL_NAME_RACERGIRL: "Fugacidad",
  TXT_SKILL_NAME_RUNNER: "Carrera",
  TXT_SKILL_NAME_SEAMAN: "Voluntad de Hierro",
  TXT_TUTORIAL_HUD: "Interfaz",
  TXT_TUTORIAL_HUD_LABEL10: "Correr",
  TXT_TUTORIAL_PICKUP_LABEL0: "Armas",
  T_34_M_WS_VFXTYPE: "Tipo de Efecto Visual (VFX)",
  T_40_XXJ_WS_MONSTERATTACKTARGETTYPE_NAMEKEY: "Tipo de Objetivo de Ataque",
  T_40_XXJ_WS_PLAYERUISWITCHTYPE_NAMEKEY: "Tipo de Interfaz de Usuario para Jugadores",
  T_41_XXJ_WS_MONSTERSKILLTYPE: "Tipo de Habilidad de Monstruo",
  T_45_META_WS_DESCRIPTIVECOLOR: "Color descriptivo",
  T_45_META_WS_GAMETIME: "Tiempo de juego",
  T_45_META_WS_PROPERTY: "Propiedad",
  T_45_XXJ_WS_UISOCIALBUTTONSTYLETYPE: "Tipo de estilo de botón",
  T_45_XXJ_WS_UISOCIALBUTTONTYPE: "Tipo de botón",
  T_46_META_WS_A_A: "A",
  T_46_META_WS_A_ACCELERATION: "Aceleración",
  T_46_META_WS_A_ACCOUNTID: "ID de Cuenta",
  T_46_META_WS_A_ACTIONTYPE: "Tipo de Acción",
  T_46_META_WS_A_ACTIVE: "Activo",
  T_46_META_WS_A_ANGLE: "Ángulo",
  T_46_META_WS_A_ANY: "Cualquiera",
  T_46_META_WS_A_APPEARANCEGROUP: "Grupo de Apariencia",
  T_46_META_WS_A_ASSERTIONEXPRESSION: "Expresión de Aserción",
  T_46_META_WS_A_ATTACHMENT: "Adjuntos",
  T_46_META_WS_A_ATTACHMENTS: "Accesorios",
  T_46_META_WS_A_ATTACKABLE: "Atacable",
  T_46_META_WS_A_ATTACKER: "Atacante",
  T_46_META_WS_A_ATTACKTARGET: "Objetivo de Ataque",
  T_46_META_WS_A_AUTOPLAY: "Reproducción Automática",
  T_46_META_WS_A_AXIS: "Eje",
  T_46_META_WS_A_B: "B",
  T_46_META_WS_A_BASE: "Base",
  T_46_META_WS_A_BOUNDTARGET: "Objetivo enlazado",
  T_46_META_WS_A_BTREE: "Árbol de comportamiento",
  T_46_META_WS_A_BUFF: "Buff",
  T_46_META_WS_A_CAMERA: "Cámara",
  T_46_META_WS_A_CAPICITY: "Capacidad",
  T_46_META_WS_A_CENTER: "Centro",
  T_46_META_WS_A_CHANGEROTATION: "Cambiar Rotación",
  T_46_META_WS_A_CHANNEL: "Canal",
  T_46_META_WS_A_CHASEENEMY: "Perseguir Enemigo",
  T_46_META_WS_A_CHILD: "Hijo",
  T_46_META_WS_A_COLOR: "Color",
  T_46_META_WS_A_COLUMN: "Columna",
  T_46_META_WS_A_COLUMNNAME: "Nombre de Columna",
  T_46_META_WS_A_COMEBACK: "Regreso",
  T_46_META_WS_A_COMPONENT: "Componente",
  T_46_META_WS_A_CONTENT: "Contenido",
  T_46_META_WS_A_COORDINATESYSTEM: "Sistema de Coordenadas",
  T_46_META_WS_A_COUNT: "Cantidad",
  T_46_META_WS_A_COUNTS: "Conteo",
  T_46_META_WS_A_CREATEDENTITY: "Entidad Creada",
  T_46_META_WS_A_CROSSPLATFORM: "Plataforma cruzada",
  T_46_META_WS_A_CULLINGMASK: "Máscara de culling",
  T_46_META_WS_A_CURVE: "Curva",
  T_46_META_WS_A_CUSTOMTAG: "Etiqueta Personalizada",
  T_46_META_WS_A_CUTRADIUS: "Radio de Corte",
  T_46_META_WS_A_DAMAGE: "Daño",
  T_46_META_WS_A_DAMAGESEGMENTS: "Segmentos de daño",
  T_46_META_WS_A_DEGREE: "Grado",
  T_46_META_WS_A_DELTA: "Delta",
  T_46_META_WS_A_DEPTH: "Profundidad",
  T_46_META_WS_A_DESTVAL: "Valor de Destino",
  T_46_META_WS_A_DIFFICULTY: "Dificultad",
  T_46_META_WS_A_DIRECTION: "Dirección",
  T_46_META_WS_A_DISABLE: "Está Deshabilitado",
  T_46_META_WS_A_DISPLACEMENT: "Desplazamiento",
  T_46_META_WS_A_DISTANCE: "Distancia",
  T_46_META_WS_A_DIVINGMAXSPEED: "Velocidad máxima al bucear",
  T_46_META_WS_A_DOTWEEN: "Aplicar tween",
  T_46_META_WS_A_DURATION: "Duración (s)",
  T_46_META_WS_A_EMOTE: "Emoticono",
  T_46_META_WS_A_ENABLE: "Habilitar",
  T_46_META_WS_A_ENDAREACENTER: "Centro del área final",
  T_46_META_WS_A_ENDAREARANGE: "Rango del área final",
  T_46_META_WS_A_ENDPOSITION: "Posición final",
  T_46_META_WS_A_ENDRANK: "Rango final",
  T_46_META_WS_A_EQUIPMENTS: "Equipos",
  T_46_META_WS_A_EVENTID: "ID de Evento",
  T_46_META_WS_A_EXPONENT: "Exponente",
  T_46_META_WS_A_FACTION: "Facción",
  T_46_META_WS_A_FACTORTYPE: "Tipo de Factor",
  T_46_META_WS_A_FILTERTYPE: "Tipo de Filtro",
  T_46_META_WS_A_FINALRADIUS: "Radio Final",
  T_46_META_WS_A_FINDVALUE: "Encontrar Valor",
  T_46_META_WS_A_FIXEDRANGE: "Rango Fijo",
  T_46_META_WS_A_FOLLOWTARGET: "Seguir Objetivo",
  T_46_META_WS_A_FONTCOLOR: "Color de fuente",
  T_46_META_WS_A_FONTSIZE: "Tamaño de fuente",
  T_46_META_WS_A_FOOTBALL: "Fútbol",
  T_46_META_WS_A_FORCE: "Fuerza",
  T_46_META_WS_A_FORCEDPARACHUTEHEIGHT: "Altura mínima del paracaídas",
  T_46_META_WS_A_FORCEMODE: "Modo de Fuerza",
  T_46_META_WS_A_FORWARD: "Adelante",
  T_46_META_WS_A_G: "G",
  T_46_META_WS_A_GAMEID: "ID del Juego",
  T_46_META_WS_A_HALFEXTENTS: "Extensiones Medias",
  T_46_META_WS_A_HEIGHT: "Altura",
  T_46_META_WS_A_HEIGHTSEGMENTS: "Segmentos de altura",
  T_46_META_WS_A_HITDISTANCE: "Distancia del impacto",
  T_46_META_WS_A_HITDISTANCES: "Distancias Impactadas",
  T_46_META_WS_A_HITENTITIES: "Entidades Impactadas",
  T_46_META_WS_A_HITENTITY: "Entidad impactada",
  T_46_META_WS_A_HITNORMAL: "Normal del impacto",
  T_46_META_WS_A_HITNORMALS: "Normales Impactadas",
  T_46_META_WS_A_HITPOINTS: "Puntos Impactados",
  T_46_META_WS_A_HITPOSITION: "Posición del impacto",
  T_46_META_WS_A_INCLUDETRIGGER: "Incluir Disparador",
  T_46_META_WS_A_INDEX: "Índice",
  T_46_META_WS_A_INDEXS: "Índices",
  T_46_META_WS_A_INITIALVELOCITY: "Velocidad Inicial",
  T_46_META_WS_A_INITRADIUS: "Radio Inicial",
  T_46_META_WS_A_INWALLET: "Billetera de Entrada",
  T_46_META_WS_A_ISBOTTOMCOLLIDING: "Está Colisionando en la Parte Inferior",
  T_46_META_WS_A_ISEXIST: "Existe",
  T_46_META_WS_A_ISLOOP: "Es Bucle",
  T_46_META_WS_A_ISMAPPEDINSCREEN: "Mapeado en pantalla",
  T_46_META_WS_A_ISPAUSE: "Pausa",
  T_46_META_WS_A_ISSIDECOLLIDING: "Está Colisionando en el Lado",
  T_46_META_WS_A_ISSUCCESS: "Éxito",
  T_46_META_WS_A_ISTOPCOLLIDING: "Está Colisionando en la Parte Superior",
  T_46_META_WS_A_ITEM: "Objeto",
  T_46_META_WS_A_ITEMID: "ID del Artículo",
  T_46_META_WS_A_ITEMS: "Objetos",
  T_46_META_WS_A_ITEMTYPE: "Tipo de Artículo",
  T_46_META_WS_A_JERSEYTYPE: "Tipo de Jersey",
  T_46_META_WS_A_KEEPVELOCITY: "Mantener Velocidad",
  T_46_META_WS_A_KEY: "Clave",
  T_46_META_WS_A_KEYCOLUMN: "Columna Clave",
  T_46_META_WS_A_KEYS: "Claves",
  T_46_META_WS_A_LAYER: "Capa",
  T_46_META_WS_A_LAYERMASK: "Máscara de Capa",
  T_46_META_WS_A_LEFT: "Izquierda",
  T_46_META_WS_A_LEFTVALUE: "Valor Izquierdo",
  T_46_META_WS_A_LENGTH: "Longitud",
  T_46_META_WS_A_LEVELOBJECT: "Objeto de Nivel",
  T_46_META_WS_A_LOG: "Registro",
  T_46_META_WS_A_LOOKATTARGET: "Mirar Hacia el Objetivo",
  T_46_META_WS_A_LOOPTYPE: "Tipo de Bucle",
  T_46_META_WS_A_MAINCOLOR1: "Color Principal1",
  T_46_META_WS_A_MAINCOLOR2: "Color Principal2",
  T_46_META_WS_A_MAPCODE: "Código del Mapa",
  T_46_META_WS_A_MAPPEDPOSITION: "Posición mapeada",
  T_46_META_WS_A_MAX: "Máximo",
  T_46_META_WS_A_MAXDISPLACEMENT: "Desplazamiento Máximo",
  T_46_META_WS_A_MAXDISTANCE: "Distancia Máxima",
  T_46_META_WS_A_MIN: "Mínimo",
  T_46_META_WS_A_MISSIONID: "ID de Misión",
  T_46_META_WS_A_MISSIONPROGRESS: "Progreso de Misión",
  T_46_META_WS_A_MODIFYTYPE: "Tipo de Modificación",
  T_46_META_WS_A_MONEYTYPE: "Tipo de Moneda",
  T_46_META_WS_A_MUST: "Debe",
  T_46_META_WS_A_NAME: "Nombre",
  T_46_META_WS_A_NEWVALUE: "Valor Nuevo",
  T_46_META_WS_A_NODE: "Nodo",
  T_46_META_WS_A_NORMAL: "Normal",
  T_46_META_WS_A_NOT: "No",
  T_46_META_WS_A_OBSERVER: "Observador",
  T_46_META_WS_A_OFFSET: "Desplazamiento",
  T_46_META_WS_A_OLDVALUE: "Valor Antiguo",
  T_46_META_WS_A_OPERATIOMETHOD: "Método de operación",
  T_46_META_WS_A_OPTIONS: "Opciones",
  T_46_META_WS_A_OTHERCOLOR: "Otro Color",
  T_46_META_WS_A_OUTFIT: "Conjunto",
  T_46_META_WS_A_OUTFITS: "Conjuntos",
  T_46_META_WS_A_OUTWALLET: "Billetera de Salida",
  T_46_META_WS_A_OWNER: "Propietario",
  T_46_META_WS_A_PARACHUTINGMAXSPEED: "Velocidad máxima al usar paracaídas",
  T_46_META_WS_A_PARAMS: "Parámetros",
  T_46_META_WS_A_PARENT: "Padre",
  T_46_META_WS_A_PARENTWIDGET: "Widget Padre",
  T_46_META_WS_A_PATH: "Ruta",
  T_46_META_WS_A_PATHPOINTS: "Puntos de ruta",
  T_46_META_WS_A_PHASEINDEX: "Índice de Fase",
  T_46_META_WS_A_PLATFORM: "Plataforma",
  T_46_META_WS_A_PLAYER: "Jugador",
  T_46_META_WS_A_PLAYSPEED: "Velocidad de Reproducción",
  T_46_META_WS_A_POSITION: "Posición",
  T_46_META_WS_A_POSITIONS: "Posiciones",
  T_46_META_WS_A_POSTION: "Posición",
  T_46_META_WS_A_PREFAB: "Prefabricado",
  T_46_META_WS_A_PROPERTY: "Propiedad",
  T_46_META_WS_A_PROPERTYID: "ID de Propiedad",
  T_46_META_WS_A_PURSUITTARGET: "Objetivo de Persecución",
  T_46_META_WS_A_R: "R",
  T_46_META_WS_A_RADIUS: "Radio",
  T_46_META_WS_A_RANDOMDECAY: "Decaimiento Aleatorio",
  T_46_META_WS_A_RANDOMRANGE: "Rango aleatorio",
  T_46_META_WS_A_RANDOMRATIO: "Relación Aleatoria",
  T_46_META_WS_A_RANGE: "Rango",
  T_46_META_WS_A_RANK: "Rango",
  T_46_META_WS_A_REALCOIN: "Moneda Real",
  T_46_META_WS_A_REALNUMBER: "Número real",
  T_46_META_WS_A_RESET: "Restablecer",
  T_46_META_WS_A_RESOURCE: "Recurso",
  T_46_META_WS_A_RESULT: "Resultado",
  T_46_META_WS_A_RIGHT: "Derecha",
  T_46_META_WS_A_RIGHTVALUE: "Valor Derecho",
  T_46_META_WS_A_ROTATION: "Rotación",
  T_46_META_WS_A_ROW: "Fila",
  T_46_META_WS_A_SAMPLEPOINT: "Punto de muestra",
  T_46_META_WS_A_SCALE: "Escala",
  T_46_META_WS_A_SCENEID: "ID de Escena",
  T_46_META_WS_A_SCORE: "Puntuación",
  T_46_META_WS_A_SCORENAME: "Nombre de puntuación",
  T_46_META_WS_A_SCREENPOSITION: "Posición en pantalla",
  T_46_META_WS_A_SCRIPT: "Script",
  T_46_META_WS_A_SEAT: "Asiento",
  T_46_META_WS_A_SEP: "Sep",
  T_46_META_WS_A_SEPSTR: "Separador",
  T_46_META_WS_A_SHEETNAME: "Nombre de Hoja",
  T_46_META_WS_A_SHOPITEM: "Artículo de Tienda",
  T_46_META_WS_A_SHOWBACKGROUND: "Mostrar fondo",
  T_46_META_WS_A_SHOWMATCHRESULT: "Mostrar Resultado del Juego",
  T_46_META_WS_A_SHOWMESSAGEWHENCANCEL: "Mostrar mensaje al cancelar",
  T_46_META_WS_A_SKILL: "Habilidad",
  T_46_META_WS_A_SKILLS: "Habilidades",
  T_46_META_WS_A_SKILLTARGET: "Objetivo de habilidad",
  T_46_META_WS_A_SKIN: "Aspecto de mochila",
  T_46_META_WS_A_SLOT: "Ranura",
  T_46_META_WS_A_SRCVAL: "Valor de Origen",
  T_46_META_WS_A_SRCVALUE: "Valor fuente",
  T_46_META_WS_A_STARTAREACENTER: "Centro del área de inicio",
  T_46_META_WS_A_STARTAREARANGE: "Rango del área de inicio",
  T_46_META_WS_A_STARTINDEX: "Índice de Inicio",
  T_46_META_WS_A_STARTPOSITION: "Posición Inicial",
  T_46_META_WS_A_STARTRANK: "Rango inicial",
  T_46_META_WS_A_STATE: "Estado",
  T_46_META_WS_A_STATUS: "Estado",
  T_46_META_WS_A_STATUSCODE: "Código de estado",
  T_46_META_WS_A_STYLE: "Estilo",
  T_46_META_WS_A_SURFINGMAXSPEED: "Velocidad máxima al surfear",
  T_46_META_WS_A_TARGET: "Objetivo",
  T_46_META_WS_A_TARGETPOSITION: "Posición de Objetivo",
  T_46_META_WS_A_TEAMSEQ: "Secuencia de Equipo",
  T_46_META_WS_A_THRESHOLD: "Umbral",
  T_46_META_WS_A_TIMESTAMP: "Marca de tiempo",
  T_46_META_WS_A_TIPS: "Consejos",
  T_46_META_WS_A_TITLE: "Título",
  T_46_META_WS_A_TOKENCOUNT: "Conteo de Tokens",
  T_46_META_WS_A_TOKENID: "ID de Token",
  T_46_META_WS_A_TORQUE: "Torque",
  T_46_META_WS_A_TOUCHPOINT: "Punto de contacto",
  T_46_META_WS_A_TRANSITIONTIME: "Tiempo de Transición (ms)",
  T_46_META_WS_A_TRANSITIONTYPE: "Tipo de Transición",
  T_46_META_WS_A_TRIGGER: "Disparador",
  T_46_META_WS_A_TYPE: "Tipo",
  T_46_META_WS_A_UI: "Interfaz de Usuario (UI)",
  T_46_META_WS_A_UIID: "ID de UI",
  T_46_META_WS_A_UPWARD: "Hacia Arriba",
  T_46_META_WS_A_VALUE: "Valor",
  T_46_META_WS_A_VALUEA: "Valor A",
  T_46_META_WS_A_VALUEB: "Valor B",
  T_46_META_WS_A_VALUES: "Valores",
  T_46_META_WS_A_VALUET: "ValorT",
  T_46_META_WS_A_VALUETYPE: "Tipo de valor",
  T_46_META_WS_A_VEHICLE: "Vehículo",
  T_46_META_WS_A_VEHICLESKIN: "Skin del vehículo",
  T_46_META_WS_A_VELOCITY: "Velocidad",
  T_46_META_WS_A_VELOCITYXZ: "Velocidad XZ",
  T_46_META_WS_A_VELOCITYY: "Velocidad Y",
  T_46_META_WS_A_VISIBLE: "Visible",
  T_46_META_WS_A_WAITTIME: "Tiempo de Espera (s)",
  T_46_META_WS_A_WALLET: "Billetera",
  T_46_META_WS_A_WEAPON: "Arma",
  T_46_META_WS_A_WEAPONSKIN: "Piel de Arma",
  T_46_META_WS_A_WIDGETID: "ID de Widget",
  T_46_META_WS_A_WIDGETTYPE: "Tipo de Widget",
  T_46_META_WS_A_WIDTH: "Ancho",
  T_46_META_WS_A_WORLDPOSITION: "Posición mundial",
  T_46_META_WS_A_WORLDPOSITIONSTAYS: "Mantener Posición en el Mundo",
  T_46_META_WS_A_X: "X",
  T_46_META_WS_A_Y: "Y",
  T_46_META_WS_ABS: "Valor absoluto",
  T_46_META_WS_ACOS: "Acos",
  T_46_META_WS_ADDAOISPECIALFOLLOW: "Agregar Seguimiento Especial AOI",
  T_46_META_WS_ADDATTACHMENTS: "Añadir Accesorios",
  T_46_META_WS_ADDBUFF: "Añadir Buff",
  T_46_META_WS_ADDCOMPONENT: "Agregar Componente",
  T_46_META_WS_ADDFOOTBALLVELOCITY: "Agregar Velocidad al Balón",
  T_46_META_WS_ADDFORCE: "Añadir Fuerza",
  T_46_META_WS_ADDFORCEATPOSITION: "Añadir Fuerza en Posición",
  T_46_META_WS_ADDFORMULAPROPERTYFACTOR: "Agregar Factor de Propiedad de Fórmula",
  T_46_META_WS_ADDGAMEEVENTLOG: "Añadir Registro de Evento del Juego",
  T_46_META_WS_ADDHP: "Añadir HP",
  T_46_META_WS_ADDITEM: "Añadir ítem",
  T_46_META_WS_ADDITEMINSCENE: "Crear ítem en escena",
  T_46_META_WS_ADDITEMTOSHOPITEM: "Agregar Artículo a Artículo de Tienda",
  T_46_META_WS_ADDMONEY: "Agregar Dinero",
  T_46_META_WS_ADDSCRIPT: "Agregar Script",
  T_46_META_WS_ADDTAG: "Agregar Etiqueta",
  T_46_META_WS_ADDTOKEN: "Añadir token",
  T_46_META_WS_ADDTORQUE: "Añadir Torque",
  T_46_META_WS_ADDUSEREVENTLOG: "Añadir Registro de Evento de Usuario",
  T_46_META_WS_ANGEL: "Ángulo",
  T_46_META_WS_APPEND: "Añadir",
  T_46_META_WS_APPENDRANGE: "Añadir rango",
  T_46_META_WS_APPLYQUITMIDWAYUICONFIG: "Aplicar Configuración de Salida a Medio Camino",
  T_46_META_WS_ASIN: "Asin",
  T_46_META_WS_ASSERT: "Afirmar",
  T_46_META_WS_ASSISTPLAYER: "Jugador asistente",
  T_46_META_WS_ATAN2: "ATan2",
  T_46_META_WS_ATTACKER: "Atacante",
  T_46_META_WS_ATTACKTARGET: "Objetivo de Ataque",
  T_46_META_WS_AXISANGLETOQUATERNION: "Ángulo de Eje a Cuaternión",
  T_46_META_WS_BOXCAST: "Box Cast",
  T_46_META_WS_BOXOVERLAP: "Box Overlap",
  T_46_META_WS_BUTTONNAME: "Nombre del botón",
  T_46_META_WS_C_ACTIONTYPE: "Tipo de Tipo de Ação",
  T_46_META_WS_C_AIMABLE: "Componente que Pode Ser Alvo",
  T_46_META_WS_C_AIMASSISTABLE: "Componente Assistente para Mira",
  T_46_META_WS_C_AIMASSISTTYPE: "Tipo de Tipo de Asistencia para Apuntar",
  T_46_META_WS_C_AIRDROP: "Caída Aérea",
  T_46_META_WS_C_AMMO: "Munición",
  T_46_META_WS_C_AMMOTYPE: "Tipo de Tipo de Munición",
  T_46_META_WS_C_AMPHIBIAN: "Anfibio",
  T_46_META_WS_C_ANIMATIONCLIP: "Clip de Animación",
  T_46_META_WS_C_ANIMATIONCLIPID: "ID de Clip de Animación",
  T_46_META_WS_C_ANIMATIONCONTROLLER: "Controlador de Animación",
  T_46_META_WS_C_ANIMATIONCONTROLLERATTACHABLE: "Controlador de Animación Acoplable",
  T_46_META_WS_C_ANIMATIONCONTROLLERID: "ID de Controlador de Animación",
  T_46_META_WS_C_ANIMATIONSTATE: "Estado de Animación",
  T_46_META_WS_C_ANIMATIONTRIGGER: "Activador de Animación",
  T_46_META_WS_C_APPEARENCE: "Apariencia",
  T_46_META_WS_C_ASSETCONFIGID: "ID de configuración de activo",
  T_46_META_WS_C_ASSETID: "ID de activo",
  T_46_META_WS_C_ATTACHMENT: "Accesorio",
  T_46_META_WS_C_ATTACKABLETYPE: "Tipo de Ataque",
  T_46_META_WS_C_AUDIOID: "ID de Audio",
  T_46_META_WS_C_BACKPACK: "Mochila",
  T_46_META_WS_C_BACKPACKSKINID: "ID de skin de mochila",
  T_46_META_WS_C_BASEDATAALIAS: "Alias de Datos Básicos",
  T_46_META_WS_C_BASICAPPEARANCE: "Apariencia Básica",
  T_46_META_WS_C_BASICCYLINDER: "Cilindro o Cono Básico",
  T_46_META_WS_C_BASICSCALABLE: "Básico Escalable",
  T_46_META_WS_C_BASICSPHERE: "Esfera Básica",
  T_46_META_WS_C_BATCHCOMBINERENDER: "Componente de Combinación por Lote",
  T_46_META_WS_C_BEVTREE: "Árbol de Comportamiento",
  T_46_META_WS_C_BEVTREEATTACHABLE: "Entidad Adjuntable al Árbol de Comportamiento",
  T_46_META_WS_C_BEVTREECUSTOMNODE: "Nodo Personalizado de Árbol de Comportamiento",
  T_46_META_WS_C_BEVTREEID: "ID de Árbol de Comportamiento",
  T_46_META_WS_C_BEVTREENODESTATUS: "Estado del Nodo de Árbol de Comportamiento",
  T_46_META_WS_C_BEVTREENODETYPE: "Tipo de Nodo de Árbol de Comportamiento",
  T_46_META_WS_C_BEZIERCURVE: "Curva Bezier",
  T_46_META_WS_C_BOOL: "Boolean",
  T_46_META_WS_C_BOTDIFFICULTYTYPE: "Tipo de Dificultad del Bot",
  T_46_META_WS_C_BOUNCINGTIRE: "Neumático Rebotador",
  T_46_META_WS_C_BUFFABLE: "Mejora posible",
  T_46_META_WS_C_BUFFGENERATOR: "Generador de Buff",
  T_46_META_WS_C_BUFFTYPE: "Tipo de Buff",
  T_46_META_WS_C_BUILTINRENDER: "Renderizado Incorporado",
  T_46_META_WS_C_BUILTINUI: "UI Incorporada",
  T_46_META_WS_C_BUILTINUITYPE: "Tipo de UI Incorporada",
  T_46_META_WS_C_CAMERA: "Cámara",
  T_46_META_WS_C_CAMERABLOCKMODE: "Modo de Bloqueio da Câmera",
  T_46_META_WS_C_CAMERAPROJECTIONMODE: "Modo de Projeção da Câmera",
  T_46_META_WS_C_CAMERARAYCASTUI: "Interfaz RayCast de la Cámara",
  T_46_META_WS_C_CAMERATRANSITIONTYPE: "Tipo de Tipo de Transição de Câmera",
  T_46_META_WS_C_CAMERATYPE: "Tipo de Tipo de Câmera",
  T_46_META_WS_C_CAMERAVIEWINGANGLERESTRICTIONTYPE: "Tipo de Restricción del Ángulo de Visión de la Cámara",
  T_46_META_WS_C_CAPSULETRIGGER: "Activador de Cápsula",
  T_46_META_WS_C_CAR: "Coche",
  T_46_META_WS_C_CHARACTERCONTROLLER: "Controlador de Personaje",
  T_46_META_WS_C_CHATCHANNEL: "Canal de Chat",
  T_46_META_WS_C_CHATCHANNELTYPE: "Tipo de Canal de Chat",
  T_46_META_WS_C_CHECKPOINTTRIGGER: "Activador de Punto de Control",
  T_46_META_WS_C_COINGENERATOR: "Generador de Monedas",
  T_46_META_WS_C_COLLECTIONID: "ID de colección",
  T_46_META_WS_C_COLLIDER: "Colisionador",
  T_46_META_WS_C_COLLIDERCOLLECTION: "Forma del Colisionador",
  T_46_META_WS_C_COLLIDERCOLLECTIONID: "ID de Colección de Colisionadores",
  T_46_META_WS_C_COLORDRUM: "Tambor de Color",
  T_46_META_WS_C_COMBATABLE: "Combatible",
  T_46_META_WS_C_COMPONENT: "Componente",
  T_46_META_WS_C_CONDITION: "Condición",
  T_46_META_WS_C_CONTAINER: "Contenedor",
  T_46_META_WS_C_COORDINATESYSTEMTYPE: "Tipo de Tipo de Sistema de Coordenadas",
  T_46_META_WS_C_CROSSBOW: "Granada Arco",
  T_46_META_WS_C_CSVID: "ID de CSV",
  T_46_META_WS_C_CUSTOMIZETRIGGER: "Activador Personalizado",
  T_46_META_WS_C_CUSTOMLEVELOBJECT: "Objeto Personalizado",
  T_46_META_WS_C_CUSTOMPATH: "Ruta Personalizada",
  T_46_META_WS_C_CUSTOMUI: "UI Personalizado",
  T_46_META_WS_C_CUSTOMUIID: "ID de UI personalizada",
  T_46_META_WS_C_CUSTOMUIORWIDGET: "UI Personalizado o Widget",
  T_46_META_WS_C_CUSTOMUIWIDGETID: "ID de Widget de UI Personalizado",
  T_46_META_WS_C_DAMAGEDBODYPARTTYPE: "Tipo de Parte del Cuerpo Dañado",
  T_46_META_WS_C_DAMAGETYPE: "Tipo de Daño",
  T_46_META_WS_C_DEATHORINVINCIBILITYTRIGGER: "Activador de Muerte o Invulnerabilidad",
  T_46_META_WS_C_DESTRUCTIBLELEVELOBJECT: "Objeto Destructible",
  T_46_META_WS_C_DICE: "Dado",
  T_46_META_WS_C_DOUBLEJUMPSHOES: "Zapatos de Salto Doble",
  T_46_META_WS_C_DRUMMUSIC: "Música de Tambor",
  T_46_META_WS_C_DUALWIELDWEAPONTYPE: "Tipo de Arma de Doble Empuñadura",
  T_46_META_WS_C_DUMMYLEVELOBJECT: "Objeto de Nivel Común",
  T_46_META_WS_C_DYNAMICCREATELEVELOBJECTTYPE: "Tipo de Objeto Creable Dinámicamente",
  T_46_META_WS_C_DYNAMICFENCE: "Cerca Dinámica",
  T_46_META_WS_C_EFFECT: "Efecto",
  T_46_META_WS_C_EFFECTCONTAINER: "Contenedor de Efectos",
  T_46_META_WS_C_EFFECTID: "ID de Efecto",
  T_46_META_WS_C_EMOTETYPE: "Tipo de Emote",
  T_46_META_WS_C_ENDPOINTTRIGGER: "Activador de Punto Final",
  T_46_META_WS_C_ENTITY: "Entidad",
  T_46_META_WS_C_ENTITYORPREFABID: "Entidad o ID de Prefab",
  T_46_META_WS_C_EQUIPMENTATTACHMENT: "Accesorio de Equipo",
  T_46_META_WS_C_EQUIPMENTSLOTTYPE: "Tipo de Tipo de Ranura de Equipo",
  T_46_META_WS_C_EQUIPMENTTYPE: "Tipo de Tipo de Equipo",
  T_46_META_WS_C_EVENTID: "ID de Evento",
  T_46_META_WS_C_FACTION: "Facción",
  T_46_META_WS_C_FILLDIRECTIONTYPE: "Tipo de Dirección de Relleno",
  T_46_META_WS_C_FILLTYPE: "Tipo de Relleno",
  T_46_META_WS_C_FIRETYPE: "Tipo de Tipo de Fuego",
  T_46_META_WS_C_FLOAT: "Flotante",
  T_46_META_WS_C_FOLDWING: "Alas Plegables",
  T_46_META_WS_C_FOLLOW: "Seguir",
  T_46_META_WS_C_FONTTYPE: "Tipo de Tipo de Fonte",
  T_46_META_WS_C_FOOTBALL: "Fútbol",
  T_46_META_WS_C_FORCETYPE: "Tipo de Fuerza",
  T_46_META_WS_C_FORMULABLE: "Fórmula posible",
  T_46_META_WS_C_FRAMESELFRELATIVE: "Movimiento Relativo a Uno Mismo por Cuadro",
  T_46_META_WS_C_GAMERESULTTYPE: "Tipo de Tipo de Resultado do Jogo",
  T_46_META_WS_C_GENDERTYPE: "Tipo de género",
  T_46_META_WS_C_GENERALSPAWNPOINT: "Punto de Aparición General",
  T_46_META_WS_C_GRENADEDEICEWALL: "Granada DeIce Wall",
  T_46_META_WS_C_GRENADEFLASHBANG: "Granadas de destello",
  T_46_META_WS_C_GRENADEFROZEN: "Granada Congelante",
  T_46_META_WS_C_GRENADELAUNCHER: "Lanzador de Granada",
  T_46_META_WS_C_GRENADESMOKE: "Granada de Humo",
  T_46_META_WS_C_GRENADEWEAPON: "Base de Granada",
  T_46_META_WS_C_GRID: "Cuadrícula",
  T_46_META_WS_C_HANDCANNON: "Granada de Mano",
  T_46_META_WS_C_HELMET: "Casco",
  T_46_META_WS_C_HIERARCHICAL: "Jerárquico",
  T_46_META_WS_C_HOOKGUN: "Arma con Gancho",
  T_46_META_WS_C_HORIZALINE: "Línea Horizontal",
  T_46_META_WS_C_HUDTRANSFORM_DEPRECATED: "Transformador UI",
  T_46_META_WS_C_HUMANMODELID: "ID de modelo humano",
  T_46_META_WS_C_ICEWALL: "Muro de Hielo",
  T_46_META_WS_C_ICEWALLCREATED: "Muro de Hielo Creado",
  T_46_META_WS_C_ICEWALLMAKER: "Creador de Muro de Hielo",
  T_46_META_WS_C_ICON: "Entidad de Icono",
  T_46_META_WS_C_ICONTYPE: "Tipo de Icono",
  T_46_META_WS_C_INHALER: "Inhalador",
  T_46_META_WS_C_INT: "Entero",
  T_46_META_WS_C_INT64: "Entero 64 bits",
  T_46_META_WS_C_INTEGERMAPTEMPLATE: "Plantilla de Mapa de Enteros",
  T_46_META_WS_C_INTORINTLIST: "Entero o Lista de Enteros",
  T_46_META_WS_C_INVENTORYTYPE: "Tipo de Inventario",
  T_46_META_WS_C_ITEMBASE: "Base de Ítem",
  T_46_META_WS_C_ITEMCONTAINER: "Contenedor de Artículos",
  T_46_META_WS_C_ITEMID: "ID de ítem",
  T_46_META_WS_C_ITEMIDTYPE: "Tipo de ID de Ítem",
  "T_46_META_WS_C_JERSEY STYLE": "Estilo de Camiseta",
  T_46_META_WS_C_JERSEYMACHINE: "Máquina de Camisetas",
  T_46_META_WS_C_JETSHOES: "Zapatos con Jet",
  T_46_META_WS_C_KEYBOARD: "Teclado",
  T_46_META_WS_C_KNOCKDOWNTYPE: "Tipo de Caída",
  T_46_META_WS_C_LANDMINE: "Mina Terrestre",
  T_46_META_WS_C_LANDMINECREATED: "Mina Creada",
  "T_46_META_WS_C_LAUNCH PAD LEVEL OBJECT": "Objeto de Nivel de Plataforma de Lanzamiento",
  T_46_META_WS_C_LAUNCHPAD: "Plataforma de Lanzamiento",
  T_46_META_WS_C_LAYOUTSORTTYPE: "Tipo de Ordenación de Diseño",
  T_46_META_WS_C_LEAD1MUSIC: "Música Lead1",
  T_46_META_WS_C_LEAD2MUSIC: "Música Lead2",
  T_46_META_WS_C_LEAD3MUSIC: "Música Lead3",
  T_46_META_WS_C_LEVELOBJECTID: "ID de objeto de nivel",
  T_46_META_WS_C_LEVELOBJECTTYPE: "Tipo de Objeto del Nivel",
  T_46_META_WS_C_LIST: "Lista",
  T_46_META_WS_C_LISTORMAP: "Lista o Mapa",
  T_46_META_WS_C_LISTT: "Plantilla de lista",
  T_46_META_WS_C_LISTT_BOOL: "Lista de Booleanos",
  T_46_META_WS_C_LISTT_CONDITION: "Lista de Condiciones",
  T_46_META_WS_C_LISTT_ENTITY: "Lista de Entidades",
  T_46_META_WS_C_LISTT_FLOAT: "Lista de flotantes",
  T_46_META_WS_C_LISTT_INT: "Lista de Enteros",
  T_46_META_WS_C_LISTT_ITEMGOODSIDTYPE: "Lista de Artículos",
  T_46_META_WS_C_LISTT_LEVELOBJECT: "Lista de Objetos de Nivel",
  T_46_META_WS_C_LISTT_LOCKEY: "Lista de claves de localización",
  T_46_META_WS_C_LISTT_PLAYABLE: "Lista de Elementos Jugables",
  T_46_META_WS_C_LISTT_PLAYER: "Lista de Jugadores",
  T_46_META_WS_C_LISTT_SKILLID: "Lista de ID de habilidades",
  T_46_META_WS_C_LISTT_SOUNDEFFECT: "Lista de Efectos de Sonido",
  T_46_META_WS_C_LISTT_STRING: "Lista de cadenas",
  T_46_META_WS_C_LISTT_TEAM: "Lista de Equipos",
  T_46_META_WS_C_LISTT_TYPE: "Lista de Tipos",
  T_46_META_WS_C_LISTT_VECTOR3: "Lista de Vector3",
  T_46_META_WS_C_LOCKEY: "Clave de Localización",
  T_46_META_WS_C_LOOKAT: "Mirar a",
  T_46_META_WS_C_LOOPABLE: "Repetible",
  T_46_META_WS_C_LOOPTYPE: "Tipo de Bucle",
  T_46_META_WS_C_LOOTAMMOTYPE: "Tipo de Munición de Botín",
  T_46_META_WS_C_LOOTARMOR: "Armadura de Botín",
  T_46_META_WS_C_LOOTARMORTYPE: "Tipo de Armadura de Botín",
  T_46_META_WS_C_LOOTCONSUMABLE: "Consumible de Botín",
  T_46_META_WS_C_LOOTCONSUMABLETYPE: "Tipo de Consumible de Botín",
  T_46_META_WS_C_LOOTIAMMO: "Munición de Botín",
  T_46_META_WS_C_LOOTITEMBOXSOCCER: "Caja de Botín de Fútbol",
  T_46_META_WS_C_LOOTSCOPE: "Visor de Botín",
  T_46_META_WS_C_LOOTSCOPETYPE: "Tipo de Visor de Botín",
  T_46_META_WS_C_LOOTSOCCERTYPE: "Tipo de Tipo de Botín de Fútbol",
  T_46_META_WS_C_LOOTTHROWABLE: "Lanzable de Botín",
  T_46_META_WS_C_LOOTTHROWABLETYPE: "Tipo de Lanzable de Botín",
  T_46_META_WS_C_LOOTWEAPON: "Arma de Botín",
  T_46_META_WS_C_LOOTWEAPONTYPE: "Tipo de Arma de Botín",
  T_46_META_WS_C_LOWGRAVITY: "Área de Baja Gravedad",
  T_46_META_WS_C_MAP: "Mapa",
  T_46_META_WS_C_MAPT: "Plantilla de mapa",
  T_46_META_WS_C_MATERIALID: "ID de Material",
  T_46_META_WS_C_MEDKIT: "Kit de Primeros Auxilios",
  T_46_META_WS_C_MESHID: "ID de Malla",
  T_46_META_WS_C_MIDGAMEEXITCONFIG: "Configuración de Salida a Medida del Juego",
  T_46_META_WS_C_MINIMAP: "Mini Mapa",
  T_46_META_WS_C_MINIMAPICON: "Icono de Mini Mapa",
  T_46_META_WS_C_MINIMAPPIXELRENDERER: "Renderizador de Píxeles para Minimap",
  T_46_META_WS_C_MINISENTRY: "Mini Sentry",
  T_46_META_WS_C_MINISENTRYATTACKRANGETYPE: "Tipo de Rango de Ataque de Mini Sentry",
  T_46_META_WS_C_MINISENTRYCREATED: "Mini Sentry Creado",
  T_46_META_WS_C_MONEY: "Dinero",
  T_46_META_WS_C_MONEYTYPE: "Tipo de Dinero",
  T_46_META_WS_C_MONSTER: "Monstruo",
  T_46_META_WS_C_MONSTERSPAWN: "Generación de Monstruos",
  T_46_META_WS_C_MONSTERTYPE: "Tipo de Tipo de Monstruo",
  T_46_META_WS_C_MORPHABLEOBJECT: "Objeto Morfable",
  T_46_META_WS_C_MORPHOBJECT: "Objeto de Morfosis",
  T_46_META_WS_C_MOTOBIKE: "Motocicleta",
  T_46_META_WS_C_MOVEPLATFORM: "Plataforma de Movimiento",
  T_46_META_WS_C_MOVEPLATFORMTYPE: "Tipo de Plataforma de Movimiento",
  T_46_META_WS_C_MUSHROOM: "Hongo",
  T_46_META_WS_C_NATURALCONSTANTTYPE: "Constante Natural",
  T_46_META_WS_C_NPC: "NPC",
  T_46_META_WS_C_NUMBER: "Número",
  T_46_META_WS_C_OBJECT: "Objeto",
  T_46_META_WS_C_OILDRUM: "Barril de Aceite",
  T_46_META_WS_C_OUTFITID: "ID de traje",
  T_46_META_WS_C_OUTFITSLOTTYPE: "Tipo de Tipo de Ranura de Ropa",
  T_46_META_WS_C_PATHPOINT: "Punto de Ruta",
  T_46_META_WS_C_PATROLSTYLETYPE: "Tipo de Estilo de Patrullaje",
  T_46_META_WS_C_PATROLTYPE: "Tipo de Patrullaje",
  T_46_META_WS_C_PERSONA: "Persona",
  T_46_META_WS_C_PHASE: "Fase",
  T_46_META_WS_C_PHYSICALMOVER: "Movedor Físico",
  T_46_META_WS_C_PHYSICALOBJECT: "Objeto Físico",
  T_46_META_WS_C_PLATFORMTYPE: "Tipo de Plataforma",
  T_46_META_WS_C_PLAYABLE: "Jugable",
  T_46_META_WS_C_PLAYABLEORPLAYABLES: "Jugable o Conjunto de Jugables",
  T_46_META_WS_C_PLAYER: "Jugador",
  T_46_META_WS_C_PLAYERBACKPACK: "Mochila del Jugador",
  T_46_META_WS_C_PLAYERBEHAVIORSTATUSTYPE: "Tipo de Estado de Comportamiento del Jugador",
  T_46_META_WS_C_PLAYERBEHAVIORTYPE: "Tipo de Comportamiento del Jugador",
  T_46_META_WS_C_PLAYERCCT: "CCT del Jugador",
  T_46_META_WS_C_PLAYERDATAID: "Tipo de Personaje Predefinido",
  T_46_META_WS_C_PLAYERORTRANSFORM: "Jugador o Transformación",
  T_46_META_WS_C_PLAYERORVEHICLE: "Jugador o Vehículo",
  T_46_META_WS_C_PLAYEROUTFIT: "Atuendo del jugador",
  T_46_META_WS_C_PLAYERPOSETYPE: "Tipo de pose del jugador",
  T_46_META_WS_C_PLAYERREVIVESOURCETYPE: "Tipo de Fuente de Resurrección de Jugador",
  T_46_META_WS_C_PLAYERSTATETYPE: "Tipo de estado del jugador",
  T_46_META_WS_C_POINTLIGHT: "Luz Puntual",
  T_46_META_WS_C_PORTAL: "Portal",
  T_46_META_WS_C_PREFABID: "ID de Prefab",
  T_46_META_WS_C_PRESENTEFFECTGENERATOR_DEPRECATED: "Generador de Efectos de Presentación",
  T_46_META_WS_C_PRESENTEFFECTTEXTURETYPE_DEPRECATED: "Tipo de Textura de Efecto",
  T_46_META_WS_C_PROFILEPICTUREWIDGET: "Widget de Foto de Perfil",
  T_46_META_WS_C_PROPERTY: "Propiedad",
  T_46_META_WS_C_PROPERTYFORMULA: "Fórmula de Propiedad",
  T_46_META_WS_C_PROPERTYFORMULAFACTORTYPE: "Tipo de Factor de Fórmula de Propiedad",
  T_46_META_WS_C_PROPERTYMODIFYTYPE: "Tipo de Modificación de Propiedad",
  T_46_META_WS_C_QUATERNION: "Cuaternión",
  T_46_META_WS_C_RANKABLE: "Clasificable",
  T_46_META_WS_C_RAYCASTLAYERTYPE: "Tipo de Capa de Ray Cast",
  T_46_META_WS_C_REPAIRKIT: "Kit de Reparación",
  T_46_META_WS_C_RESETABLE: "Restable",
  T_46_META_WS_C_RIGIDBODY: "Cuerpo Rígido",
  T_46_META_WS_C_RIGIDBODYCONSTRAINTYPE: "Tipo de Restricción del Cuerpo Rígido",
  T_46_META_WS_C_RIGIDBODYTYPE: "Tipo de Cuerpo Rígido",
  T_46_META_WS_C_ROUND: "Ronda",
  T_46_META_WS_C_SAFEZONE: "Zona Segura",
  T_46_META_WS_C_SCOREABLE: "Puntuable",
  T_46_META_WS_C_SCRIPTID: "ID de Script",
  T_46_META_WS_C_SEATTYPE: "Tipo de Asiento",
  T_46_META_WS_C_SELFRELATIVE: "Relativo a Uno Mismo",
  T_46_META_WS_C_SHOP: "Tienda",
  T_46_META_WS_C_SHOPITEM: "Artículo de Tienda",
  T_46_META_WS_C_SHOPSHELF: "Estante de Tienda",
  T_46_META_WS_C_SKATEBOARD: "Patineta",
  T_46_META_WS_C_SKELETON: "Esqueleto",
  T_46_META_WS_C_SKELETONPART: "Parte del Esqueleto",
  T_46_META_WS_C_SKILLID: "ID de habilidad",
  T_46_META_WS_C_SKYBLASTER: "Aeronave",
  T_46_META_WS_C_SKYBOX: "Caja de Cielo",
  T_46_META_WS_C_SKYBOXTYPE: "Tipo de Skybox",
  T_46_META_WS_C_SOCIALISLANDSNOWBALL: "Bola de Nieve de Isla Social",
  T_46_META_WS_C_SORTTYPE: "Tipo de Ordenamiento",
  T_46_META_WS_C_SOUNDDRUMTYPE: "Tipo de Sonido de Tambor",
  T_46_META_WS_C_SOUNDEFFECT: "Efecto de Sonido",
  T_46_META_WS_C_SOUNDEFFECTORSOUNDEFFECTLIST: "Efecto de Sonido o Lista de Efectos de Sonido",
  T_46_META_WS_C_SOUNDEFFECTTYPE: "Tipo de Efecto de Sonido",
  T_46_META_WS_C_SOUNDLEAD1TYPE: "Tipo de Sonido Lead1",
  T_46_META_WS_C_SOUNDLEAD2TYPE: "Tipo de Sonido Lead2",
  T_46_META_WS_C_SOUNDLEAD3TYPE: "Tipo de Sonido Lead3",
  T_46_META_WS_C_SOUNDPIANOTYPE: "Tipo de Sonido de Piano",
  T_46_META_WS_C_SPAWN: "Generador",
  T_46_META_WS_C_SPAWNABLE: "Generable",
  T_46_META_WS_C_SPAWNBOX: "Zona de aparición",
  T_46_META_WS_C_SPAWNPOSITION: "Punto de Generación",
  T_46_META_WS_C_SPECIALITEMIDTYPE: "Tipo de ID de Artículo Especial",
  T_46_META_WS_C_SPHERETRIGGER: "Activador Esférico",
  T_46_META_WS_C_SPORTSCAR: "Coche Deportivo",
  T_46_META_WS_C_SPRAYCOLOR: "Color de Aerosol",
  T_46_META_WS_C_SPRAYGUN: "Pistola de Aerosol",
  T_46_META_WS_C_SPRAYRESULTUI: "UI de Resultado de Aerosol",
  T_46_META_WS_C_SPRAYRIFLE: "Rifle de Aerosol",
  T_46_META_WS_C_SPRITEID: "ID de Sprite",
  T_46_META_WS_C_STATICSCRIPTID: "ID de Script Estático",
  T_46_META_WS_C_STRING: "Cadena",
  T_46_META_WS_C_STRINGORLOCSTRING: "Cadena o Cadena Localizada",
  T_46_META_WS_C_SUPPLYBOXTRIGGER: "Activador de Caja de Suministros",
  T_46_META_WS_C_SWINGGUN: "Arma de Balanceo",
  T_46_META_WS_C_SWITCHEQUIPSLOT: "Cambiar Ranura de Equipos",
  T_46_META_WS_C_TEAM: "Equipo",
  T_46_META_WS_C_TERRAIN: "Terreno",
  T_46_META_WS_C_TEXT: "Entidad de Texto",
  T_46_META_WS_C_TEXTUREID: "ID de Textura",
  T_46_META_WS_C_TEXTURETYPE: "Textura del Objeto",
  T_46_META_WS_C_TIMER: "Temporizador",
  T_46_META_WS_C_TIMESTAMPFORMATSTYLETYPE: "Tipo de Estilo de Formato de Marca de Tiempo",
  T_46_META_WS_C_TIMESTAMPLOCSTRING: "Cadena de Localización de Timestamp",
  T_46_META_WS_C_TRAJECTORY: "Trayectoria",
  T_46_META_WS_C_TRANSFORM: "Transformar",
  T_46_META_WS_C_TUKTUK: "Tuk Tuk",
  T_46_META_WS_C_TURRET: "Torre",
  T_46_META_WS_C_TWEEN: "Tween",
  T_46_META_WS_C_TWEENCURVE_DEPRECATED: "Curva Tween",
  T_46_META_WS_C_TWEENSTYLE: "Tipo de Estilo Tween",
  T_46_META_WS_C_TYPE: "Tipo",
  T_46_META_WS_C_TYPEENUM: "Enumeración Tipo",
  T_46_META_WS_C_TYPEORTYPELIST: "Tipo o Lista de Tipos",
  T_46_META_WS_C_UIADDSCORE: "Componente de Interfaz de Usuario de Adición de Puntuación",
  T_46_META_WS_C_UIANITRIGGERHUD: "Componente de Interfaz de Usuario de Activador de Animación",
  T_46_META_WS_C_UIBUILTINSWITCH: "Interruptor Incorporado de Interfaz de Usuario",
  T_46_META_WS_C_UIBUILTINUISWITCHCONTROLLER: "Controlador de Interruptor Incorporado de Interfaz de Usuario",
  T_46_META_WS_C_UICARDSELECTIONPANEL: "Componente de Interfaz de Usuario de Selección de Carta",
  T_46_META_WS_C_UICHECKPOINTINDICATOR: "Componente de Interfaz de Usuario de Indicador de Punto de Control",
  T_46_META_WS_C_UICOMPASS: "Brújula de Interfaz de Usuario",
  T_46_META_WS_C_UICOUNTDOWN5: "Componente de Interfaz de Usuario de Cuenta Regresiva de 5 Segundos",
  T_46_META_WS_C_UICOUNTDOWNHINT: "Componente de Interfaz de Usuario de Consejo de Cuenta Regresiva",
  T_46_META_WS_C_UICOUNTDOWNREMINDER: "Componente de Interfaz de Usuario de Recordatorio de Cuenta Regresiva",
  T_46_META_WS_C_UIFOLLOWHEADLTHBAR: "Barra de salud sobre la cabeza del personaje",
  T_46_META_WS_C_UIHEALTHBAR: "Componente de Interfaz de Usuario de Barra de Salud",
  T_46_META_WS_C_UIHEARTBEAT: "Componente de Interfaz de Usuario de Latidos del Corazón",
  T_46_META_WS_C_UIICONNOTIFICATION: "Componente de Interfaz de Usuario de Notificación con Ícono",
  T_46_META_WS_C_UIIDENTITYNOTIFICATION: "Componente de Interfaz de Usuario de Notificación de Identidad",
  T_46_META_WS_C_UIINTERACTIONBUTTON: "Botón de Interfaz de Usuario de Interacción",
  T_46_META_WS_C_UILEADERBOARDBUTTON: "Botón de Interfaz de Usuario para Tabla de Clasificación",
  T_46_META_WS_C_UIMATCHSUBTITLE: "Componente de Interfaz de Usuario de Subtítulo de Partido",
  T_46_META_WS_C_UIMONSTERLEVEL: "Componente de Interfaz de Usuario de Nivel de Monstruo",
  T_46_META_WS_C_UIMONSTERUI: "Componente de Interfaz de Usuario de Efectos para Monstruo",
  T_46_META_WS_C_UIMULTIPLETEAMLEADERBOARD: "Componente de Interfaz de Usuario de Tabla de Clasificación para Múltiples Equipos",
  T_46_META_WS_C_UIMULTITEAMRESULTPANEL: "Panel de Resultados para Múltiples Equipos de Interfaz de Usuario",
  T_46_META_WS_C_UIOPENINGBANNER: "Componente de Interfaz de Usuario de Banner de Apertura",
  T_46_META_WS_C_UIPANEL: "Panel de Interfaz de Usuario",
  T_46_META_WS_C_UIPANELEMPTY: "Panel Vacío de Interfaz de Usuario",
  T_46_META_WS_C_UIPHASETIMER: "Componente de Interfaz de Usuario de Temporizador de Fase",
  T_46_META_WS_C_UIPROGRESSBAR: "Componente de Interfaz de Usuario de Barra de Progreso",
  T_46_META_WS_C_UIPROGRESSCIRCLE: "Componente de Interfaz de Usuario de Círculo de Progreso",
  T_46_META_WS_C_UIPROGRESSSKILLBUTTON: "Botón de Habilidad de Progreso de Interfaz de Usuario",
  T_46_META_WS_C_UIREQUESTPURCHASETYPE: "Tipo de Solicitud de Compra",
  T_46_META_WS_C_UIROUNDINFOBANNER: "Componente de Interfaz de Usuario de Banner de Información de Ronda",
  T_46_META_WS_C_UIROUNDNUMBER: "Componente de Interfaz de Usuario de Número de Ronda",
  T_46_META_WS_C_UIROUNDRESULTBANNER: "Componente de Interfaz de Usuario de Banner de Resultados de Ronda",
  T_46_META_WS_C_UIROUNDSTARTBANNER: "Componente de Interfaz de Usuario de Banner de Inicio de Ronda para Dos Equipos",
  T_46_META_WS_C_UIROUNDTRANSITION: "Componente de Interfaz de Usuario de Transición de Ronda",
  T_46_META_WS_C_UISCOREBAR: "Componente de Interfaz de Usuario de Barra de Puntuación",
  T_46_META_WS_C_UISCROLLPANEL: "Panel Deslizante de Interfaz de Usuario",
  T_46_META_WS_C_UISIMPLEROUNDSCOREBANNER: "Componente de Interfaz de Usuario de Banner de Puntuación de Ronda para Equipos",
  T_46_META_WS_C_UISIMPLEROUNDSTARTBANNER: "Componente de Interfaz de Usuario de Banner Simple de Inicio de Ronda",
  T_46_META_WS_C_UISIMPLETIP: "Componente de Consejo Simple de Interfaz de Usuario",
  T_46_META_WS_C_UISIMPLEVERSUSBANNER: "Componente de Interfaz de Usuario de Banner Simple de Versus",
  T_46_META_WS_C_UISKILLBUTTON: "Botón de Interfaz de Usuario de Habilidad",
  T_46_META_WS_C_UISOCIALBUTTONWIDGET: "Widget de botón social",
  T_46_META_WS_C_UISOLOLEADERBOARD: "Componente de Interfaz de Usuario de Tabla de Clasificación Individual",
  T_46_META_WS_C_UISTORE: "Componente de Interfaz de Usuario de Tienda",
  T_46_META_WS_C_UITEAMMATCHINFO: "Componente de Interfaz de Usuario de Información de Partido por Equipos",
  T_46_META_WS_C_UITEXTTIP: "Componente de Interfaz de Usuario de Consejo de Texto",
  T_46_META_WS_C_UITIMERINFO: "Componente de Interfaz de Usuario de Temporizador",
  T_46_META_WS_C_UITIPBUTTON: "Botón de Consejo de Interfaz de Usuario",
  T_46_META_WS_C_UITITLEBANNER: "Componente de Interfaz de Usuario de Banner de Título",
  T_46_META_WS_C_UITWEENTIP: "Componente de Interfaz de Usuario de Consejo Animado",
  T_46_META_WS_C_UITWOTEAMBRIEFINFO: "Componente de Interfaz de Usuario de Información Breve para Dos Equipos",
  T_46_META_WS_C_UITWOTEAMINFO: "Componente de Interfaz de Usuario de Información para Dos Equipos",
  T_46_META_WS_C_UITWOTEAMLEADERBOARD: "Componente de Interfaz de Usuario de Tabla de Clasificación para Dos Equipos",
  T_46_META_WS_C_UITWOTEAMRESULTPANEL: "Componente de Interfaz de Usuario de Panel de Resultados para Dos Equipos",
  T_46_META_WS_C_UITWOTEAMROUNDSCOREBANNER: "Componente de Interfaz de Usuario de Banner de Puntuación de Ronda para Dos Equipos",
  T_46_META_WS_C_UITWOTEAMSCOREPANEL: "Panel de Puntuación para Dos Equipos de Interfaz de Usuario",
  T_46_META_WS_C_UIVERSUSBANNER: "Componente de Interfaz de Usuario de Banner de Versus",
  T_46_META_WS_C_UIWIDGET: "Widget de Interfaz de Usuario",
  T_46_META_WS_C_UIWIDGETBUTTON: "Botón de Widget de Interfaz de Usuario",
  T_46_META_WS_C_UIWIDGETCONTAINER: "Contenedor de Widget de Interfaz de Usuario",
  T_46_META_WS_C_UIWIDGETEMPTY: "Widget de Interfaz de Usuario Vacío",
  T_46_META_WS_C_UIWIDGETIMAGE: "Widget de Interfaz de Usuario de Imagen",
  T_46_META_WS_C_UIWIDGETINPUTLABLE: "Etiqueta de Entrada de Widget de Interfaz de Usuario",
  T_46_META_WS_C_UIWIDGETJOYSTICK: "Joystick de Widget de Interfaz de Usuario",
  T_46_META_WS_C_UIWIDGETLABEL: "Widget de Interfaz de Usuario de Etiqueta",
  T_46_META_WS_C_UIWIDGETLAYOUT: "Diseño de Widget de Interfaz de Usuario",
  T_46_META_WS_C_UIWIDGETPROFILE: "Perfil de Widget de Interfaz de Usuario",
  T_46_META_WS_C_UIWIDGETTEXTURE: "Textura de Widget de Interfaz de Usuario",
  T_46_META_WS_C_UIWIDGETTOGGLE: "Conmutador de Widget de Interfaz de Usuario",
  T_46_META_WS_C_UIWIDGETTOUCHPAD: "Panel Táctil de Widget de Interfaz de Usuario",
  T_46_META_WS_C_UIWINORLOSEBANNER: "Componente de Interfaz de Usuario de Banner de Victoria o Derrota",
  T_46_META_WS_C_UNITSPAWN: "Generador de Unidades",
  T_46_META_WS_C_UUID: "UUID",
  T_46_META_WS_C_VAULTTRIGGER: "Objeto de Lógica de Escalada de Ventana",
  T_46_META_WS_C_VECTOR2: "Vector2",
  T_46_META_WS_C_VECTOR3: "Vector3",
  T_46_META_WS_C_VEHICLE: "Vehículo",
  T_46_META_WS_C_VEHICLEIDTYPE: "Tipo de ID del Vehículo",
  T_46_META_WS_C_VEHICLESKINID: "ID de Piel de Vehículo",
  T_46_META_WS_C_VENDINGMACHINE: "Máquina Expendedora",
  T_46_META_WS_C_VEST: "Chaleco",
  T_46_META_WS_C_VFXREPLACETEXTPRESENT: "Entidad de Textura de Efectos Visuales Reemplazable",
  T_46_META_WS_C_VFXTEXTURE: "Textura de Efectos Visuales",
  T_46_META_WS_C_VISIBILITY: "Visibilidad",
  T_46_META_WS_C_WALLET: "Cartera",
  T_46_META_WS_C_WALLETHUD: "UI de Cartera",
  T_46_META_WS_C_WATERZONE: "Zona de Agua",
  T_46_META_WS_C_WAVECOUNTTYPE: "Tipo de Conteo de Olas",
  T_46_META_WS_C_WAVEINTERVALTYPE: "Tipo de Intervalo de Olas",
  T_46_META_WS_C_WEAPON: "Arma",
  T_46_META_WS_C_WEAPONGENERATOR: "Generador de Armas",
  T_46_META_WS_C_WEAPONSKINID: "ID de skin de arma",
  T_46_META_WS_C_WEAPONTYPE: "Tipo de Arma",
  T_46_META_WS_C_WIDGETTYPE: "Tipo de Widget",
  T_46_META_WS_C_ZIPLINE: "Cuerda de Tiro",
  T_46_META_WS_CAMERADIRECTION: "Dirección de la cámara",
  T_46_META_WS_CAMERAPOSITION: "Posición de la cámara",
  T_46_META_WS_CAPSULECAST: "Capsule Cast",
  T_46_META_WS_CAPSULEOVERLAP: "Capsule Overlap",
  T_46_META_WS_CEIL: "Redondear hacia arriba",
  T_46_META_WS_CHATCHANNEL: "Canal de chat",
  T_46_META_WS_CHECKTRIGGERBYORDER: "Verificar desencadenador por orden",
  T_46_META_WS_CLAMP: "Clamp",
  T_46_META_WS_CLEAR: "Limpiar",
  T_46_META_WS_CLEARALLCHILDREN: "Eliminar Todos los Hijos",
  T_46_META_WS_CLEARAOISPECIALFOLLOW: "Limpiar Seguimiento Especial AOI",
  T_46_META_WS_CLEARBACKPACK: "Vaciar Mochila",
  T_46_META_WS_CLEARFORMULAPROPERTYFACTOR: "Limpiar Factor de Propiedad de Fórmula",
  T_46_META_WS_CLEARRESIDUALLEVELOBJECTS: "Limpiar objetos residuales de nivel",
  T_46_META_WS_CLIPNAME: "Nombre del clip",
  T_46_META_WS_CLONE: "Clonar",
  T_46_META_WS_COLLIDEDENTITY: "Entidad colisionada",
  T_46_META_WS_COLORGET: "Obtener color",
  T_46_META_WS_COMPLETECUSTOMMISSION: "Completar misión personalizada",
  T_46_META_WS_CONNECT: "Conectar",
  T_46_META_WS_CONSUMABLEID: "ID del objeto",
  T_46_META_WS_CONTAIN: "Contiene",
  T_46_META_WS_CONTAINKEY: "Contener clave",
  T_46_META_WS_COPYTOMORPH: "Copiar a Transformación",
  T_46_META_WS_COS: "Cos",
  T_46_META_WS_COSTMONEY: "Costar Dinero",
  T_46_META_WS_COSTTOKEN: "Gastar token",
  T_46_META_WS_CREATEAIRDROP: "Crear Caída de Aire",
  T_46_META_WS_CREATEBOT: "Crear Bot",
  T_46_META_WS_CREATEBUILTINUI: "Crear UI incorporada",
  T_46_META_WS_CREATEBUILTINUICLIENT: "Crear UI incorporada",
  T_46_META_WS_CREATECAMERA: "Crear Cámara",
  T_46_META_WS_CREATECURVE: "Crear Curva",
  T_46_META_WS_CREATECUSTOMUI: "Crear UI personalizada",
  T_46_META_WS_CREATECUSTOMUICLIENT: "Crear UI personalizada",
  T_46_META_WS_CREATECUSTOMUIWIDGET: "Crear Widget UI Personalizado",
  T_46_META_WS_CREATEDAMAGENUM: "Crear Número de Daño",
  T_46_META_WS_CREATEEFFECT: "Crear Efecto",
  T_46_META_WS_CREATEEFFECTCLIENT: "Crear Efecto",
  T_46_META_WS_CREATEFACTION: "Crear Facción",
  T_46_META_WS_CREATEFOLLOW: "Crear Seguimiento",
  T_46_META_WS_CREATEFRAMESELFRELATIVE: "Crear Relativo a Sí Mismo por Frame",
  T_46_META_WS_CREATEFROMPREFAB: "Crear desde Prefab",
  T_46_META_WS_CREATELEVELOBJECT: "Crear objeto de nivel",
  T_46_META_WS_CREATELOOKAT: "Crear Mirar a",
  T_46_META_WS_CREATEMINIMAPICON: "Crear Icono de Mini Mapa",
  T_46_META_WS_CREATEMINIMAPPIXEL: "Crear Pixel de Mini Mapa",
  T_46_META_WS_CREATEMONSTER: "Crear Monstruo",
  T_46_META_WS_CREATEMORPH: "Crear Transformación",
  T_46_META_WS_CREATESELFRELATIVE: "Crear Relativo a Sí Mismo",
  T_46_META_WS_CREATESHOP: "Crear Tienda",
  T_46_META_WS_CREATESHOPITEM: "Crear Artículo de Tienda",
  T_46_META_WS_CREATESHOPSHELF: "Crear Estante de Tienda",
  T_46_META_WS_CREATESOUND: "Crear Sonido",
  T_46_META_WS_CREATESOUNDCLIENT: "Crear Sonido",
  T_46_META_WS_CREATETOKENINSCENE: "Crear token en escena",
  T_46_META_WS_CREATETRAJECTORY: "Crear Trayectoria",
  T_46_META_WS_CREATETWEEN: "Crear Tween",
  T_46_META_WS_CREATEWALLET: "Crear Billetera",
  T_46_META_WS_CROSS: "Cruz",
  T_46_META_WS_CSVCOLUMNNAMETOINT: "Nombre de Columna CSV a Entero",
  T_46_META_WS_CURRENTAMMOCOUNT: "Conteo actual de municiones",
  T_46_META_WS_DAMAGE: "Daño",
  T_46_META_WS_DAMAGEDBODYPART: "Parte del cuerpo dañada",
  T_46_META_WS_DAMAGEDPLAYERS: "Jugadores dañados",
  T_46_META_WS_DAMAGETYPE: "Tipo de daño",
  T_46_META_WS_DEALDAMAGE: "Infligir daño",
  T_46_META_WS_DELETE: "Eliminar",
  T_46_META_WS_DELETEAT: "Eliminar en",
  T_46_META_WS_DELETECUSTOMUI: "Eliminar UI personalizada",
  T_46_META_WS_DELETEFROMDATABASE: "Eliminar de la Base de Datos",
  T_46_META_WS_DELETEFROMDATASTORE: "Eliminar del Almacén de Datos",
  T_46_META_WS_DELETEFROMLEADBOARDDATABASEBYKEY: "Eliminar de la Base de Datos de Clasificación por Clave",
  T_46_META_WS_DELETEFROMLEADBOARDDATABASEBYRANK: "Eliminar de la Base de Datos de Clasificación por Rango",
  T_46_META_WS_DELETEFROMLEADBOARDDATASTOREBYKEY: "Eliminar del Almacén de Datos de la Tabla de Clasificación por Clave",
  T_46_META_WS_DELETEFROMLEADBOARDDATASTOREBYRANK: "Eliminar del Almacén de Datos de la Tabla de Clasificación por Rango",
  T_46_META_WS_DELETETAG: "Eliminar Etiqueta",
  T_46_META_WS_DELTA: "Delta",
  T_46_META_WS_DESTROY: "Destruir",
  T_46_META_WS_DESTROYBOT: "Destruir Bot",
  T_46_META_WS_DESTROYBUILTINUI: "Eliminar UI incorporada",
  T_46_META_WS_DESTROYEQUIPMENT: "Destruir Equipo",
  T_46_META_WS_DESTROYITEM: "Destruir ítem",
  T_46_META_WS_DIRECTIONTOEULERANGLE: "Dirección a Ángulo de Euler",
  T_46_META_WS_DISABLESAFEZONE: "Deshabilitar zona segura",
  T_46_META_WS_DISPATCHEVENT: "Despachar Evento",
  T_46_META_WS_DISPATCHEVENTWITHPLATFORM: "Enviar Evento con Plataforma",
  T_46_META_WS_DISTANCE: "Distancia",
  T_46_META_WS_DOT: "Punto",
  T_46_META_WS_DROPITEM: "Soltar Objeto",
  T_46_META_WS_DYEATAREA: "Teñir en Área",
  T_46_META_WS_DYEATPLANE: "Teñir en Plano",
  T_46_META_WS_DYEATPOSITION: "Teñir en Posición",
  T_46_META_WS_E_ABNORMALGRAVZONE: "Área de baja gravedad",
  T_46_META_WS_E_AC80: "AC80",
  T_46_META_WS_E_ACCELERATION: "Aceleración",
  T_46_META_WS_E_ACTIONNODE: "NodoAcción",
  T_46_META_WS_E_ACTIVE: "Activo",
  T_46_META_WS_E_ACTIVESKILL: "Habilidad activa",
  T_46_META_WS_E_ADBOARD: "Cartelera",
  T_46_META_WS_E_ADD: "Añadir",
  T_46_META_WS_E_ADDFRIEND: "Agregar Amigo",
  T_46_META_WS_E_AGENCYFB: "AgencyFB",
  T_46_META_WS_E_AIM: "Apuntar",
  T_46_META_WS_E_AIR: "Aire",
  T_46_META_WS_E_AIRCONDITIONERA: "Aire acondicionado",
  T_46_META_WS_E_AIRDROP: "Caída de Suministros, Suicidio de Zombie",
  T_46_META_WS_E_AK: "AK",
  T_46_META_WS_E_AK2: "AK2",
  T_46_META_WS_E_ALIVE: "Vivo",
  T_46_META_WS_E_AMMO: "Efecto de Bala",
  T_46_META_WS_E_AMPHIBIANCAR: "Vehículo Anfibio",
  T_46_META_WS_E_AN94: "AN94",
  T_46_META_WS_E_APPARITION: "Niños Jugando",
  T_46_META_WS_E_AR: "Rifle",
  T_46_META_WS_E_AR15: "AR15",
  T_46_META_WS_E_ARAMMO: "Munición AR",
  T_46_META_WS_E_ARMAGAZINE: "Cargador para AR",
  T_46_META_WS_E_ARMOR: "Armadura",
  T_46_META_WS_E_ARMORBUFF: "Buff Armadura",
  T_46_META_WS_E_ARMORLV1: "Armadura Lv1",
  T_46_META_WS_E_ARMORLV2: "Armadura Lv2",
  T_46_META_WS_E_ARMORLV3: "Armadura Lv3",
  T_46_META_WS_E_ARMORPIERCING: "Romper Armadura",
  T_46_META_WS_E_ARMORSPECIALIST: "Habilidad 1",
  T_46_META_WS_E_ARROW: "Flecha",
  T_46_META_WS_E_ASC: "Orden Ascendente",
  T_46_META_WS_E_ASCIGNOREZERO: "Orden Ascendente Excluye Ceros",
  T_46_META_WS_E_ATMOSPHEREEXPLOSION: "Explosión de Gas",
  T_46_META_WS_E_ATTACHMENT1FORCOMPATIBILITY: "Accesorio1 para compatibilidad",
  T_46_META_WS_E_ATTACHMENT4FORCOMPATIBILITY: "Accesorio4 para compatibilidad",
  T_46_META_WS_E_ATTACHMENT5FORCOMPATIBILITY: "Accesorio5 para compatibilidad",
  T_46_META_WS_E_ATTACHMENT6FORCOMPATIBILITY: "Accesorio6 para compatibilidad",
  T_46_META_WS_E_ATTACHMENT8FORCOMPATIBILITY: "Accesorio8 para compatibilidad",
  T_46_META_WS_E_ATTACK: "Atacar",
  T_46_META_WS_E_ATTACKGRENADE: "Granada de ataque",
  T_46_META_WS_E_AUG: "AUG",
  T_46_META_WS_E_AUTO: "Automático",
  T_46_META_WS_E_AWM: "AWM",
  T_46_META_WS_E_AWM2: "AWM2",
  T_46_META_WS_E_BACK: "Regresar",
  T_46_META_WS_E_BACKANDFORTH: "Ida y vuelta",
  T_46_META_WS_E_BAG: "Bolsa",
  T_46_META_WS_E_BAG1: "Bolsa1",
  T_46_META_WS_E_BAG2: "Bolsa2",
  T_46_META_WS_E_BAG3: "Bolsa3",
  T_46_META_WS_E_BAMBOOA: "Bambú A",
  T_46_META_WS_E_BANANATREE: "Árbol de Plátano",
  T_46_META_WS_E_BASEBALLPOLE: "BaseballPole",
  T_46_META_WS_E_BASECOEFFICIENT: "Coeficiente Base",
  T_46_META_WS_E_BASIC: "Básico",
  T_46_META_WS_E_BASICCONE: "Cono básico",
  T_46_META_WS_E_BASICCYLINDER: "Cilindro básico",
  T_46_META_WS_E_BASICSPHERE: "Esfera básica",
  T_46_META_WS_E_BATTLEINSTYLE: "Batalla con Estilo",
  T_46_META_WS_E_BELL: "Campana",
  T_46_META_WS_E_BENCH: "Banco",
  T_46_META_WS_E_BIGHEADHAMMER: "BigHeadHammer",
  T_46_META_WS_E_BILLBOARD: "Pantalla grande",
  T_46_META_WS_E_BIPOD: "Bípode",
  T_46_META_WS_E_BISGRAFFITIWALL: "Pared temática BIS",
  T_46_META_WS_E_BIZON: "Bizon",
  T_46_META_WS_E_BLACKHOLE: "Efectos de Explosión de Agujero Negro",
  T_46_META_WS_E_BLACKHOLEBOOM: "Efectos de Bola de Cristal",
  T_46_META_WS_E_BLAST: "Explosión",
  T_46_META_WS_E_BLOCK: "Cuadrado",
  T_46_META_WS_E_BLOODBALL: "Efecto de Agujero Negro",
  T_46_META_WS_E_BLT: "BLT",
  T_46_META_WS_E_BLT2: "BLT2",
  T_46_META_WS_E_BLUE: "Azul",
  T_46_META_WS_E_BLUEDOLL: "Muñeca de hielo",
  T_46_META_WS_E_BOARD: "Plataforma Móvil",
  T_46_META_WS_E_BODY: "Cuerpo",
  T_46_META_WS_E_BOMBINDICATION: "Advertencia de Bomba",
  T_46_META_WS_E_BOMBPLIERS: "Alicates para bombas",
  T_46_META_WS_E_BONFIRE: "Fogata Ardiente",
  T_46_META_WS_E_BOOM: "Explosión",
  T_46_META_WS_E_BOOYAH: "Victoria",
  T_46_META_WS_E_BOTH: "Ambos",
  T_46_META_WS_E_BOUNCETIRE: "Neumático",
  T_46_META_WS_E_BOWAMMO: "Bow Ammo",
  T_46_META_WS_E_BREAKABLEBOX: "Caja de madera destructible",
  T_46_META_WS_E_BREAKABLECONTAINER: "Contenedor Destructible",
  T_46_META_WS_E_BREAKABLEFENCE: "Cercado Destructible",
  T_46_META_WS_E_BRICKA: "Ladrillo A",
  T_46_META_WS_E_BRICKB: "Ladrillo B",
  T_46_META_WS_E_BRICKC: "Ladrillo C",
  T_46_META_WS_E_BRICKHOUSEA: "Casa pequeña A",
  T_46_META_WS_E_BRIGHT: "Claro",
  T_46_META_WS_E_BUBBLE: "Burbuja",
  T_46_META_WS_E_BUFFGENERATOR: "Generador de Buff",
  T_46_META_WS_E_BULLETBUFF: "Buff Bala",
  T_46_META_WS_E_BULLETHITTING: "Impacto de Bala",
  T_46_META_WS_E_BUMPERCAR: "Coche Chocón",
  T_46_META_WS_E_BUMPERCARFACTORY: "Fabricante de autos de choque",
  T_46_META_WS_E_BURNING: "Daño por Incendio en la Explosión de Vehículo",
  T_46_META_WS_E_BUSHES: "Arbustos",
  T_46_META_WS_E_BUSSTOP: "Estación de autobús",
  T_46_META_WS_E_BUTTOM: "Ropa inferior",
  T_46_META_WS_E_BUTTONWIDGET: "Widget de botón",
  T_46_META_WS_E_BYHIERARCHY: "Por jerarquía",
  T_46_META_WS_E_CABINET: "Armario",
  T_46_META_WS_E_CACTUS: "Cactus",
  T_46_META_WS_E_CAMOUFLAGE: "Habilidad 6",
  T_46_META_WS_E_CAPSULETRIGGER: "Disparador de cápsula",
  T_46_META_WS_E_CARDIOTONIC: "Cardiotónico",
  T_46_META_WS_E_CASUALGAMEBGM: "Música de Fondo de Juego Recreativo",
  T_46_META_WS_E_CEMENTA: "Cemento A",
  T_46_META_WS_E_CG15: "CG15",
  T_46_META_WS_E_CHANNELA: "Canal A",
  T_46_META_WS_E_CHANNELB: "Canal B",
  T_46_META_WS_E_CHANNELC: "Canal C",
  T_46_META_WS_E_CHANNELD: "Canal D",
  T_46_META_WS_E_CHANNELE: "Canal E",
  T_46_META_WS_E_CHANNELF: "Canal F",
  T_46_META_WS_E_CHARACTERSKILL: "Habilidad del Personaje",
  T_46_META_WS_E_CHARACTOR: "Personaje",
  T_46_META_WS_E_CHARGE: "Carga 1",
  T_46_META_WS_E_CHARGEBUSTER: "ChargeBuster",
  T_46_META_WS_E_CHECKPOINT: "Punto de control",
  T_46_META_WS_E_CHEER: "Animar",
  T_46_META_WS_E_CHERRYBLOSSOM: "Cerezo",
  T_46_META_WS_E_CIRCLE: "Círculo",
  T_46_META_WS_E_CIRCLEBACK: "Bucle",
  T_46_META_WS_E_CIRCLEOFHEAT: "Rayo de Pie",
  T_46_META_WS_E_CITY: "Ciudad",
  T_46_META_WS_E_CLAPS: "Aplausos",
  T_46_META_WS_E_CLEAR: "Borrar",
  T_46_META_WS_E_CLIENT: "Cliente",
  T_46_META_WS_E_CLONE: "Cambiador de Apariencia",
  T_46_META_WS_E_CLONEKILL: "Muerte de Clon",
  T_46_META_WS_E_CLOSE: "Cerrar",
  T_46_META_WS_E_CLOTHES: "Ropa",
  T_46_META_WS_E_COINGENERATOR: "Generador de oro",
  T_46_META_WS_E_COLDAIR: "Niebla",
  T_46_META_WS_E_COLORBLOCK: "Bloque teñido",
  T_46_META_WS_E_COLOROILBARREL: "Tambor teñido",
  T_46_META_WS_E_COMBINEALL: "Combinar todo",
  T_46_META_WS_E_COMBINESELF: "Combinar con uno mismo",
  T_46_META_WS_E_COMBOKEYA1: "Notas Musicales - Sintetizador A",
  T_46_META_WS_E_COMBOKEYA2: "Notas Musicales - Sintetizador A",
  T_46_META_WS_E_COMBOKEYB1: "Notas Musicales - Sintetizador B",
  T_46_META_WS_E_COMBOKEYB2: "Notas Musicales - Sintetizador B",
  T_46_META_WS_E_COMBOKEYC1: "Notas Musicales - Sintetizador C",
  T_46_META_WS_E_COMBOKEYC2: "Notas Musicales - Sintetizador C",
  T_46_META_WS_E_CONCRETEPILLAR: "Pilar de concreto",
  T_46_META_WS_E_CONDITIONNODE: "NodoCondición",
  T_46_META_WS_E_CONTAINERA: "Contenedor A",
  T_46_META_WS_E_CONTAINERB: "Contenedor B",
  T_46_META_WS_E_CONTAINERC: "Contenedor C",
  T_46_META_WS_E_CONTAINERWIDGET: "Widget contenedor",
  T_46_META_WS_E_CONTINUOUS: "Continuo",
  T_46_META_WS_E_COUNTDOWN: "Cuenta Regresiva",
  T_46_META_WS_E_COUNTDOWNDENGDENG: "Cuenta Regresiva",
  T_46_META_WS_E_COUNTDOWNDIDI: "Sonido de Cuenta Regresiva",
  T_46_META_WS_E_COUNTDOWNMECHANICAL: "Cuenta Regresiva",
  T_46_META_WS_E_COUNTDOWNWITHINGAME: "Cuenta Regresiva 3",
  T_46_META_WS_E_CROSS: "Cruz",
  T_46_META_WS_E_CROSSBOW: "Ballesta",
  T_46_META_WS_E_CROSSHAIR: "Mira",
  T_46_META_WS_E_CROSSHAIRS: "Retícula",
  T_46_META_WS_E_CROUCH: "Agacharse",
  T_46_META_WS_E_CROUCHING: "Agachado",
  T_46_META_WS_E_CROWCAW: "Grazia de Cuervos",
  T_46_META_WS_E_CROWN: "Corona",
  T_46_META_WS_E_CUBE: "Mecanismo de Bloque",
  T_46_META_WS_E_CURSE: "Amuleto",
  T_46_META_WS_E_CURSEEXPLOSION: "Explosión de Amuleto",
  T_46_META_WS_E_CUSTOM: "Cámara personalizada",
  T_46_META_WS_E_CUSTOMTRIGGER: "Activador personalizado",
  T_46_META_WS_E_CUSTOMWATERZONE: "Cuerpo de agua personalizado",
  T_46_META_WS_E_CYCLICCOMBUSTION: "Incendio en Bucle",
  T_46_META_WS_E_CYLIC: "Cíclico",
  T_46_META_WS_E_DAGGER: "Cuchillo arrojadizo",
  T_46_META_WS_E_DAMAGEDTRUCK: "Camión dañado",
  T_46_META_WS_E_DAMAGEZONE: "Zona de Daño",
  T_46_META_WS_E_DANGERALARM: "Peligro 2",
  T_46_META_WS_E_DANGERVIBRATING: "Peligro 1",
  T_46_META_WS_E_DARK: "Oscuro",
  T_46_META_WS_E_DARKNESS: "Oscuridad",
  T_46_META_WS_E_DASHATTACK: "Ataque por Embestida",
  T_46_META_WS_E_DATASTORAGELIMITEXCEEDED: "Límite de Almacenamiento de Datos Excedido",
  T_46_META_WS_E_DATASTORAGEPARAMETERERROR: "Error de Parámetro de Almacenamiento de Datos",
  T_46_META_WS_E_DATASTORAGETIMEOUT: "Tiempo de Espera para Almacenamiento de Datos",
  T_46_META_WS_E_DATETIME: "Fecha y hora",
  T_46_META_WS_E_DAY: "Día",
  T_46_META_WS_E_DEAD: "Muerto",
  T_46_META_WS_E_DEATH: "Muerto",
  T_46_META_WS_E_DEFAULT: "Predeterminado",
  T_46_META_WS_E_DEFAULTFIST: "Puño",
  T_46_META_WS_E_DEFENCEGRENADE: "Granada de defensa",
  T_46_META_WS_E_DESC: "Orden Descendente",
  T_46_META_WS_E_DIALOGUE: "Diálogo",
  T_46_META_WS_E_DIAMOND: "Diamante",
  T_46_META_WS_E_DIRECTIONSIGN: "Señal",
  T_46_META_WS_E_DIRVEVEHICLE: "Conducir vehículo",
  T_46_META_WS_E_DISABLE: "Deshabilitar",
  T_46_META_WS_E_DISABLED: "Desactivado",
  T_46_META_WS_E_DISAPPEARNOTIFICATION: "Aviso de Desaparición",
  T_46_META_WS_E_DISCONNECT: "Desconectar",
  T_46_META_WS_E_DISGUISE: "Clon",
  T_46_META_WS_E_DOGHOUSE: "Casa para perros",
  T_46_META_WS_E_DOOR: "Puerta",
  T_46_META_WS_E_DOUBLE: "Doble",
  T_46_META_WS_E_DOUBLEDOOR: "Puerta doble",
  T_46_META_WS_E_DOUBLEJUMPSHOE: "Zapatos de doble salto",
  T_46_META_WS_E_DOUBLEMAGEZINE: "Cargador doble",
  T_46_META_WS_E_DRAW: "Empate",
  T_46_META_WS_E_DRILLZOMBIE: "Zombi taladro",
  T_46_META_WS_E_DRIVE: "Conducir",
  T_46_META_WS_E_DRIVER: "Conductor",
  T_46_META_WS_E_DROPBEAT: "Habilidad 4",
  T_46_META_WS_E_DRUMKEY1: "Notas Musicales - Batería",
  T_46_META_WS_E_DRUMKEY2: "Notas Musicales - Batería",
  T_46_META_WS_E_DUEL: "Batalla",
  T_46_META_WS_E_DUMMY: "Maniquí",
  T_46_META_WS_E_DUMMYGRENADE: "Granada ficticia",
  T_46_META_WS_E_DUMP: "Descarga",
  T_46_META_WS_E_DUSK: "Crepúsculo",
  T_46_META_WS_E_DUST: "Humo y Polvo",
  T_46_META_WS_E_DYNAMIC: "Dinámico",
  T_46_META_WS_E_E: "Constante Natural",
  T_46_META_WS_E_EAGLE: "EAGLE",
  T_46_META_WS_E_EASY: "Fácil",
  T_46_META_WS_E_ELECTRICSHOCK: "Choque Eléctrico",
  T_46_META_WS_E_ELECTRICSURFBOARD: "Tabla de surf eléctrica",
  T_46_META_WS_E_ELECTRICZONE: "Zona Eléctrica",
  T_46_META_WS_E_ELECTRONICBGM: "Música de Fondo Electrónica Bonita",
  T_46_META_WS_E_ELIMINATEDBOSS: "Destituir al Líder de Guild",
  T_46_META_WS_E_ELIMINATIONNOTIFICATION: "Advertencia de Asesinato",
  T_46_META_WS_E_EMOTE: "Emoticono",
  T_46_META_WS_E_ENABLE: "Habilitar",
  T_46_META_WS_E_ENERGETIC: "Energético",
  T_46_META_WS_E_ENTERVEHICLE: "Entrar al vehículo",
  T_46_META_WS_E_EP: "Energía (EP)",
  T_46_META_WS_E_EXCLAMATIONMARK: "Signo de Exclamación",
  T_46_META_WS_E_EXIT: "Salir",
  T_46_META_WS_E_EXITVEHICLE: "Salir del vehículo",
  T_46_META_WS_E_EXPLODE: "Autoexplosión",
  T_46_META_WS_E_EXPLOSION: "Efecto de Explosión",
  T_46_META_WS_E_EXPLOSIVEBLAZE: "Llamas de Explosión",
  T_46_META_WS_E_EXPLOSIVEPAINTSKILL: "Habilidad de Orbe de Energía",
  T_46_META_WS_E_EXPLOSIVEZOMBIE: "Zombi explosivo",
  T_46_META_WS_E_EYE: "Gafas",
  T_46_META_WS_E_FACEPAINT: "Pintura facial",
  T_46_META_WS_E_FACTION: "Facción",
  T_46_META_WS_E_FALLING: "Caída",
  T_46_META_WS_E_FALLINGSTAR: "Obtener Consumible",
  T_46_META_WS_E_FALSE: "No",
  T_46_META_WS_E_FAMAS: "FAMAS",
  T_46_META_WS_E_FAN: "Mecanismo del Hélice",
  T_46_META_WS_E_FAR: "Lejos",
  T_46_META_WS_E_FEATHER: "Pluma",
  T_46_META_WS_E_FEMALE: "Femenino",
  T_46_META_WS_E_FENCE: "Cerca",
  T_46_META_WS_E_FGL24: "FGL24",
  T_46_META_WS_E_FIGHTINGENTITY: "EntidadDeCombate",
  T_46_META_WS_E_FILLED: "Lleno",
  T_46_META_WS_E_FINISH: "Terminar",
  T_46_META_WS_E_FINISHINGPOINT: "Punto final",
  T_46_META_WS_E_FINISHLINEARCH: "Bandera de llegada",
  T_46_META_WS_E_FIRE: "Fuego",
  T_46_META_WS_E_FIRECHARGE: "Bola de Fuego",
  T_46_META_WS_E_FIREWORK: "Fuegos Artificiales",
  T_46_META_WS_E_FIRINGEFFECT: "Efecto de Disparo",
  T_46_META_WS_E_FIRSTPERSON: "Cámara en primera persona",
  T_46_META_WS_E_FIRSTPERSONCLASSIC: "Cámara en primera persona (clásica)",
  T_46_META_WS_E_FIST: "Puño",
  T_46_META_WS_E_FIT: "Ajustado",
  T_46_META_WS_E_FLAG: "Bandera",
  T_46_META_WS_E_FLAME: "Fuego",
  T_46_META_WS_E_FLAMEGUN: "Lanzallamas",
  T_46_META_WS_E_FLAMETHROWER: "Lanzallamas",
  T_46_META_WS_E_FLASH: "Granada de destello",
  T_46_META_WS_E_FLASHBANG: "Flashbang",
  T_46_META_WS_E_FLASHBANGSPARKS: "Humo de Granada de Destello",
  T_46_META_WS_E_FLASHFREEZE: "Congelamiento",
  T_46_META_WS_E_FLEXWALL: "Pared Retráctil",
  T_46_META_WS_E_FLICKER: "Parpadeo",
  T_46_META_WS_E_FLOWER: "Flor",
  T_46_META_WS_E_FLYBOMBBEE: "Abeja bomba voladora",
  T_46_META_WS_E_FLYPAN: "Mecanismo de Sartén",
  T_46_META_WS_E_FLYSHOE: "Zapatos voladores",
  T_46_META_WS_E_FOLDER: "Carpeta",
  T_46_META_WS_E_FOLDWINGS: "Alas plegables",
  T_46_META_WS_E_FOODTRUCK: "Camión de comida",
  T_46_META_WS_E_FOODTRUCKB: "Camión de comida B",
  T_46_META_WS_E_FOOTBALL: "Fútbol",
  T_46_META_WS_E_FOOTBALLGUN: "Pistola de fútbol",
  T_46_META_WS_E_FOOTBALLICE: "FootballIce",
  T_46_META_WS_E_FOOTBALLSHIELD: "FootballShield",
  T_46_META_WS_E_FOOTBALLSHOOTER: "Tirador de Fútbol",
  T_46_META_WS_E_FORCE: "Fuerza",
  T_46_META_WS_E_FOREGRIP_MR: "Empuñadura frontal MR",
  T_46_META_WS_E_FOREGRIP1: "Empuñadura frontal1",
  T_46_META_WS_E_FOREGRIP2: "Empuñadura frontal2",
  T_46_META_WS_E_FOREGRIP3: "Empuñadura frontal3",
  T_46_META_WS_E_FORWARD: "Adelante",
  T_46_META_WS_E_FOUNTAIN: "Fuente",
  T_46_META_WS_E_FREE: "Cámara libre",
  T_46_META_WS_E_FREEZEALL: "Congelar Todo",
  T_46_META_WS_E_FREEZEPOSITION: "Congelar Posición",
  T_46_META_WS_E_FREEZEPOSITIONX: "Congelar Posición X",
  T_46_META_WS_E_FREEZEPOSITIONY: "Congelar Posición Y",
  T_46_META_WS_E_FREEZEPOSITIONZ: "Congelar Posición Z",
  T_46_META_WS_E_FREEZEROTATION: "Congelar Rotación",
  T_46_META_WS_E_FREEZEROTATIONX: "Congelar Rotación X",
  T_46_META_WS_E_FREEZEROTATIONY: "Congelar Rotación Y",
  T_46_META_WS_E_FREEZEROTATIONZ: "Congelar Rotación Z",
  T_46_META_WS_E_FREEZEZONE: "Área Congelada",
  "T_46_META_WS_E_FROST GALAXY": "Galaxia de Hielo",
  T_46_META_WS_E_FROZEN: "Congelación",
  T_46_META_WS_E_FROZENGRENADE: "Granada Congelante",
  T_46_META_WS_E_FUNCTIONALITEMS: "Objetos funcionales",
  T_46_META_WS_E_FZLANTINGHEI: "FZLanTingHei",
  T_46_META_WS_E_G18: "G18",
  T_46_META_WS_E_G36: "G36",
  T_46_META_WS_E_GAME: "Juego",
  T_46_META_WS_E_GAMEOVER: "Fin del Juego 2",
  T_46_META_WS_E_GAMESTART: "Inicio del Juego",
  T_46_META_WS_E_GARAGE: "Garaje",
  T_46_META_WS_E_GATLING: "Gatling",
  T_46_META_WS_E_GEARSWITCHEDON: "Mecanismo Activado",
  T_46_META_WS_E_GENTLETAP: "Toque Suave",
  T_46_META_WS_E_GETITEM: "Obtener Consumible 2",
  T_46_META_WS_E_GFFLATIN: "GFFLatin",
  T_46_META_WS_E_GHOST: "Fantasma",
  T_46_META_WS_E_GIANTDICE: "Dados",
  T_46_META_WS_E_GIANTLOLLIPOP: "Paleta gigante",
  T_46_META_WS_E_GIFT: "Regalo",
  T_46_META_WS_E_GLOOWALL: "Pared de Gel",
  T_46_META_WS_E_GOLD_HEATGUN_I: "GOLD_HEATGUN_I",
  T_46_META_WS_E_GOLD_HEATGUN_II: "GOLD_HEATGUN_II",
  T_46_META_WS_E_GOLD_HEATGUN_III: "GOLD_HEATGUN_III",
  T_46_META_WS_E_GOLD_M1014_I: "GOLD_M1014_I",
  T_46_META_WS_E_GOLD_M1014_II: "GOLD_M1014_II",
  T_46_META_WS_E_GOLD_M1014_III: "GOLD_M1014_III",
  T_46_META_WS_E_GOLD_SCAR_I: "GOLD_SCAR_I",
  T_46_META_WS_E_GOLD_SCAR_II: "GOLD_SCAR_II",
  T_46_META_WS_E_GOLD_SCAR_III: "GOLD_SCAR_III",
  T_46_META_WS_E_GOLDAWM: "GoldAWM",
  T_46_META_WS_E_GOLDFAMAS_I: "GoldFamas_I",
  T_46_META_WS_E_GOLDFAMAS_II: "GoldFamas_II",
  T_46_META_WS_E_GOLDFAMAS_III: "GoldFamas_III",
  T_46_META_WS_E_GOLDGROZA: "GoldGroza",
  T_46_META_WS_E_GOLDKAR98K_I: "GoldKar98K_I",
  T_46_META_WS_E_GOLDKAR98K_II: "GoldKar98K_II",
  T_46_META_WS_E_GOLDKAR98K_III: "GoldKar98K_III",
  T_46_META_WS_E_GOLDKAR98K_III_FORINFECTION: "GoldKar98K_III_ForInfection",
  T_46_META_WS_E_GOLDM14_I: "GoldM14_I",
  T_46_META_WS_E_GOLDM14_II: "GoldM14_II",
  T_46_META_WS_E_GOLDM14_III: "GoldM14_III",
  T_46_META_WS_E_GOLDM14_III_FORINFECTION: "GoldM14_III_ForInfection",
  T_46_META_WS_E_GOLDM4A1_I: "GoldM4A1_I",
  T_46_META_WS_E_GOLDM4A1_II: "GoldM4A1_II",
  T_46_META_WS_E_GOLDM4A1_III: "GoldM4A1_III",
  T_46_META_WS_E_GOLDM4A1_III_FORINFECTION: "GoldM4A1_III_ForInfection",
  T_46_META_WS_E_GOLDM60_I: "GoldM60_I",
  T_46_META_WS_E_GOLDM60_II: "GoldM60_II",
  T_46_META_WS_E_GOLDM60_III: "GoldM60_III",
  T_46_META_WS_E_GOLDM60_III_FORINFECTION: "GoldM60_III_ForInfection",
  T_46_META_WS_E_GOLDMP5_I: "GoldMP5_I",
  T_46_META_WS_E_GOLDMP5_II: "GoldMP5_II",
  T_46_META_WS_E_GOLDMP5_III: "GoldMP5_III",
  T_46_META_WS_E_GOLDMP5_III_FORINFECTION: "GoldMP5_III_ForInfection",
  T_46_META_WS_E_GOLDSVD: "GoldSVD",
  T_46_META_WS_E_GOLDVSS_I: "GoldVSS_I",
  T_46_META_WS_E_GOLDVSS_II: "GoldVSS_II",
  T_46_META_WS_E_GOLDVSS_III: "GoldVSS_III",
  T_46_META_WS_E_GRAFFITIFLOWERBED: "Jardín de flores temático BIS",
  T_46_META_WS_E_GRAFFITIWALL: "Muro de grafiti",
  T_46_META_WS_E_GRAPPLINGHOOKGUN: "Pistola de gancho",
  T_46_META_WS_E_GREATCONDUCTOR: "Gran Conductor",
  T_46_META_WS_E_GREEN: "Verde",
  T_46_META_WS_E_GRENADE: "Granada",
  T_46_META_WS_E_GRID: "Rejilla",
  T_46_META_WS_E_GROZA: "GROZA",
  T_46_META_WS_E_GROZA2: "GROZA2",
  T_46_META_WS_E_GUARDTOWER: "Torre de Vigilancia",
  T_46_META_WS_E_GUILD: "Guilda",
  T_46_META_WS_E_GUN: "Arma",
  T_46_META_WS_E_GUNFIRE: "Tiro",
  T_46_META_WS_E_HALO: "Halo",
  T_46_META_WS_E_HAMMER: "Mecanismo de Martillo Gigante",
  T_46_META_WS_E_HANDCANNON: "HandCannon",
  T_46_META_WS_E_HANGER: "Estante para Secar",
  T_46_META_WS_E_HARD: "Difícil",
  T_46_META_WS_E_HATTRICK: "Habilidad 8",
  T_46_META_WS_E_HAYSTACK: "Montón de Heno",
  T_46_META_WS_E_HEAD: "Tocado",
  T_46_META_WS_E_HEADSHOOT: "Disparo en la Cabeza",
  T_46_META_WS_E_HEALINGGUN_SNIPER: "Healinggun_Sniper",
  T_46_META_WS_E_HEALINGPISTOL_X: "HealingPistol_X",
  T_46_META_WS_E_HEALPISTOL: "Arma de Curación",
  T_46_META_WS_E_HEART: "Corazón",
  T_46_META_WS_E_HEARTBEAT: "Latido",
  T_46_META_WS_E_HEATGUN: "HeatGun",
  T_46_META_WS_E_HEAVYWEAPON: "Arma pesada",
  T_46_META_WS_E_HELL: "Muy duro",
  T_46_META_WS_E_HELMET: "Casco",
  T_46_META_WS_E_HELMET1: "Casco1",
  T_46_META_WS_E_HELMET2: "Casco2",
  T_46_META_WS_E_HELMET3: "Casco3",
  T_46_META_WS_E_HEXAGON: "Hexágono",
  T_46_META_WS_E_HGAMMO: "Munición HG",
  T_46_META_WS_E_HIDEANDSEEKFLAMETHROWER: "Lanzallamas de escondite",
  T_46_META_WS_E_HIDERKILL: "Oculto Asesinado",
  T_46_META_WS_E_HIHATS: "Hi-hat",
  T_46_META_WS_E_HINDSILIGURI: "HindSiliguri",
  T_46_META_WS_E_HITBLUNT: "Golpe Sordo",
  T_46_META_WS_E_HITEFFECT: "Efecto de Impacto de Bala",
  T_46_META_WS_E_HITFEEDBACK: "Retroalimentación de Disparo",
  T_46_META_WS_E_HOOK: "Gancho",
  T_46_META_WS_E_HOOKGUN: "HookGun",
  T_46_META_WS_E_HOOKGUNAMMO: "Munición para pistola de gancho",
  T_46_META_WS_E_HORIZALINE: "Horizonte",
  T_46_META_WS_E_HORIZONTAL: "Horizontal",
  T_46_META_WS_E_HORN: "Altavoz",
  T_46_META_WS_E_HORROR: "Terror",
  T_46_META_WS_E_HOURGLASS: "Reloj de Arena",
  T_46_META_WS_E_HOUSE: "Casa",
  T_46_META_WS_E_HOUSEA: "Casa de una planta",
  T_46_META_WS_E_HOUSEB: "Casa de Dos",
  T_46_META_WS_E_HOUSEC: "Casa de tres plantas",
  T_46_META_WS_E_HP: "Salud (HP)",
  T_46_META_WS_E_HPBUFF: "Buff HP",
  T_46_META_WS_E_HUT: "Cabaña",
  T_46_META_WS_E_ICEA: "Hielo A",
  T_46_META_WS_E_ICEGUN: "IceGun",
  T_46_META_WS_E_ICEWALLMAKER: "Creador de muro de hielo",
  T_46_META_WS_E_ICONOBJECT: "Icono",
  T_46_META_WS_E_IMAGEWIDGET: "Widget de imagen",
  T_46_META_WS_E_IMPULSE: "Impulso",
  T_46_META_WS_E_INHALER: "Inhalador",
  T_46_META_WS_E_INJUREDFEMALE: "Grito de Mujer al Recibir Daño",
  T_46_META_WS_E_INJUREDMALE: "Grito de Hombre al Recibir Daño",
  T_46_META_WS_E_INK: "Efecto de Tinta",
  T_46_META_WS_E_INPUTLABLEWIDGET: "Widget de entrada",
  T_46_META_WS_E_INSECTCHIRPING: "Zumbido de Insectos",
  T_46_META_WS_E_INTERVAL10SECONDS: "10 segundos",
  T_46_META_WS_E_INTERVAL15SECONDS: "15 segundos",
  T_46_META_WS_E_INTERVAL30SECONDS: "30 segundos",
  T_46_META_WS_E_INTERVAL3SECONDS: "3 segundos",
  T_46_META_WS_E_INTERVAL5SECONDS: "5 segundos",
  T_46_META_WS_E_INTERVAL9999SECONDS: "9999 segundos",
  T_46_META_WS_E_INVISIBLE: "Invisible",
  T_46_META_WS_E_IPIPE: "Tubería I",
  T_46_META_WS_E_IRONFENCE: "Cercado",
  T_46_META_WS_E_IRONFENCEB: "Cercado B",
  T_46_META_WS_E_IRONPLATFORM: "Plataforma de Hierro",
  T_46_META_WS_E_ITEMENTITY: "Generador de consumibles",
  T_46_META_WS_E_JEEP: "Jeep",
  T_46_META_WS_E_JERRYCAN: "Barril de petróleo",
  T_46_META_WS_E_JERSEYMACHINE: "Máquina de camisetas",
  T_46_META_WS_E_JOINEDGAMEDULL: "Unirse a la Batalla",
  T_46_META_WS_E_JOINGAME: "Unirse al Juego",
  T_46_META_WS_E_JOYSTICKWIDGET: "Widget joystick",
  T_46_META_WS_E_JUMP: "Saltar",
  T_46_META_WS_E_JUMPATTACK: "Ataque de Salto",
  T_46_META_WS_E_JUSTPATROL: "Solo patrulla",
  T_46_META_WS_E_KAR98K: "Kar98K",
  T_46_META_WS_E_KATANA: "Katana",
  T_46_META_WS_E_KEY: "Llave",
  T_46_META_WS_E_KICK: "Bombo",
  T_46_META_WS_E_KILLINGTIPS: "Consejos de asesinato",
  T_46_META_WS_E_KILLZONE: "Zona de Muerte",
  T_46_META_WS_E_KINEMATIC: "Cinemático",
  T_46_META_WS_E_KNIFE: "Knife",
  T_46_META_WS_E_KNOCKDOWN: "Derribado",
  T_46_META_WS_E_KNOCKEDDOWN: "Derribado",
  T_46_META_WS_E_KORD: "Kord",
  T_46_META_WS_E_LABELWIDGET: "Widget de etiqueta",
  T_46_META_WS_E_LANDINGA: "Escalón A",
  T_46_META_WS_E_LANDINGB: "Escalón B",
  T_46_META_WS_E_LANDINGC: "Escalón C",
  T_46_META_WS_E_LANDMINE: "Mina terrestre",
  T_46_META_WS_E_LANUNCHERAMMO: "Munición de lanzador",
  T_46_META_WS_E_LASER: "Efecto de Láser",
  T_46_META_WS_E_LASERSKILL: "Habilidad Láser",
  T_46_META_WS_E_LATTICESCREEN: "Pantalla",
  T_46_META_WS_E_LAWNA: "Césped A",
  T_46_META_WS_E_LAWNB: "Césped B",
  T_46_META_WS_E_LAYOUTWIDGET: "Layout Widget",
  T_46_META_WS_E_LEAD1A2: "Lead1A2",
  T_46_META_WS_E_LEAD1A2SHARP: "Lead1A2#",
  T_46_META_WS_E_LEAD1B2: "Lead1B2",
  T_46_META_WS_E_LEAD1C2: "Lead1C2",
  T_46_META_WS_E_LEAD1C2SHARP: "Lead1C2#",
  T_46_META_WS_E_LEAD1D2: "Lead1D2",
  T_46_META_WS_E_LEAD1D2SHARP: "Lead1D2#",
  T_46_META_WS_E_LEAD1E2: "Lead1E2",
  T_46_META_WS_E_LEAD1F2: "Lead1F2",
  T_46_META_WS_E_LEAD1F2SHARP: "Lead1F2#",
  T_46_META_WS_E_LEAD1G2: "Lead1G2",
  T_46_META_WS_E_LEAD1G2SHARP: "Lead1G2#",
  T_46_META_WS_E_LEAD2A2: "Lead2A2",
  T_46_META_WS_E_LEAD2A2SHARP: "Lead2A2#",
  T_46_META_WS_E_LEAD2B2: "Lead2B2",
  T_46_META_WS_E_LEAD2C2: "Lead2C2",
  T_46_META_WS_E_LEAD2C2SHARP: "Lead2C2#",
  T_46_META_WS_E_LEAD2D2: "Lead2D2",
  T_46_META_WS_E_LEAD2D2SHARP: "Lead2D2#",
  T_46_META_WS_E_LEAD2E2: "Lead2E2",
  T_46_META_WS_E_LEAD2F2: "Lead2F2",
  T_46_META_WS_E_LEAD2F2SHARP: "Lead2F2#",
  T_46_META_WS_E_LEAD2G2: "Lead2G2",
  T_46_META_WS_E_LEAD2G2SHARP: "Lead2G2#",
  T_46_META_WS_E_LEAD3A2: "Lead3A2",
  T_46_META_WS_E_LEAD3A2SHARP: "Lead3A2#",
  T_46_META_WS_E_LEAD3B2: "Lead3B2",
  T_46_META_WS_E_LEAD3C2: "Lead3C2",
  T_46_META_WS_E_LEAD3C2SHARP: "Lead3C2#",
  T_46_META_WS_E_LEAD3D2: "Lead3D2",
  T_46_META_WS_E_LEAD3D2SHARP: "Lead3D2#",
  T_46_META_WS_E_LEAD3E2: "Lead3E2",
  T_46_META_WS_E_LEAD3F2: "Lead3F2",
  T_46_META_WS_E_LEAD3F2SHARP: "Lead3F2#",
  T_46_META_WS_E_LEAD3G2: "Lead3G2",
  T_46_META_WS_E_LEAD3G2SHARP: "Lead3G2#",
  T_46_META_WS_E_LEAFLESSTREE: "Madera Muerta",
  T_46_META_WS_E_LEVELMAXED: "Nivel Máximo",
  T_46_META_WS_E_LEVELUP: "Subir de Nivel",
  T_46_META_WS_E_LEVELUPDISCARDED: "Subir de Rango",
  T_46_META_WS_E_LIGHTBEAM: "Rayo de Luz",
  T_46_META_WS_E_LIGHTBEAMPREDISCARDED: "Rayo de Luz",
  T_46_META_WS_E_LIGHTEFFECT: "Efecto de Luz",
  T_46_META_WS_E_LIGHTNING: "Relámpago",
  T_46_META_WS_E_LIMB: "Extremidad",
  T_46_META_WS_E_LINE: "Línea",
  T_46_META_WS_E_LIQUID: "Líquido",
  T_46_META_WS_E_LOCAL: "Local",
  T_46_META_WS_E_LOCALPOSITION: "Posición local",
  T_46_META_WS_E_LOCK: "Cerradura",
  T_46_META_WS_E_LONGBOX: "Caja de Madera Larga",
  T_46_META_WS_E_LOOP: "Bucle",
  T_46_META_WS_E_LOOTITEMBOX: "Arma de Botín",
  T_46_META_WS_E_LOOTITEMBOXAMMO: "Munición de Botín",
  T_46_META_WS_E_LOOTITEMBOXARMOR: "Armadura de Botín",
  T_46_META_WS_E_LOOTITEMBOXCONSUMABLEITEM: "Consumible de Botín",
  T_46_META_WS_E_LOOTITEMBOXPROJECTILE: "Objeto Lanzable de Botín",
  T_46_META_WS_E_LOOTITEMBOXSIGHT: "Mira de Botín",
  T_46_META_WS_E_LOOTITEMBOXSOCCER: "Loot Soccer",
  T_46_META_WS_E_LOOTSOCCERICE: "Granada de hielo",
  T_46_META_WS_E_LOOTSOCCERRANDOM: "Botín de fútbol aleatorio",
  T_46_META_WS_E_LOOTSOCCERSHIELD: "Escudo de fútbol",
  T_46_META_WS_E_LOOTWEAPONRANDOM: "Botín de Arma Aleatorio",
  T_46_META_WS_E_LOSE: "Derrota",
  T_46_META_WS_E_LOUDSPEAKER: "Altavoz",
  T_46_META_WS_E_LOWFALLING: "Caída Baja",
  T_46_META_WS_E_M1014: "M1014",
  T_46_META_WS_E_M10142: "M10142",
  T_46_META_WS_E_M14: "M14",
  T_46_META_WS_E_M1873: "M1873",
  T_46_META_WS_E_M1887: "M1887",
  T_46_META_WS_E_M18872: "M18872",
  T_46_META_WS_E_M1887X: "M1887X",
  T_46_META_WS_E_M1917: "M1917",
  T_46_META_WS_E_M21A5: "M21A5",
  T_46_META_WS_E_M24: "M24",
  T_46_META_WS_E_M249: "M249",
  T_46_META_WS_E_M2492: "M2492",
  T_46_META_WS_E_M4A1: "M4A1",
  T_46_META_WS_E_M500: "M500",
  T_46_META_WS_E_M60: "M60",
  T_46_META_WS_E_M79: "M79",
  T_46_META_WS_E_M79AMMO: "Granada M79",
  T_46_META_WS_E_M79AMMO_EXCLUSIVE: "Granada especializada M79",
  T_46_META_WS_E_MAC10: "MAC10",
  T_46_META_WS_E_MACHETE: "Machete",
  T_46_META_WS_E_MACHINEGUN: "SMG",
  T_46_META_WS_E_MAG7: "MAG7",
  T_46_META_WS_E_MAG72: "MAG72",
  T_46_META_WS_E_MAGEZINE1: "Cargador1",
  T_46_META_WS_E_MAGEZINE2: "Cargador2",
  T_46_META_WS_E_MAGEZINE3: "Cargador3",
  T_46_META_WS_E_MAGMAA: "Magma A",
  T_46_META_WS_E_MAGNIFYINGGLASS: "Lupa",
  T_46_META_WS_E_MALE: "Masculino",
  T_46_META_WS_E_MARK: "Marca",
  T_46_META_WS_E_MARKER: "Marca",
  T_46_META_WS_E_MASK: "Accesorio facial",
  T_46_META_WS_E_MAXVALUE: "Valor Máximo",
  T_46_META_WS_E_MECHANICAL: "Chasquido Rápido 2",
  T_46_META_WS_E_MECHANICALDEVICEECHO: "Eco de Dispositivo Mecánico",
  T_46_META_WS_E_MEDICALPROPS: "Artículos médicos",
  T_46_META_WS_E_MEDICALTENT: "Tienda Médica",
  T_46_META_WS_E_MEDIUMHEARTBEAT: "Latido Medio",
  T_46_META_WS_E_MEDKIT: "MedKit",
  T_46_META_WS_E_MELEE: "Arma de Combate Cuerpo a Cuerpo",
  T_46_META_WS_E_MELEEWEAPONS: "Arma Cuerpo a Cuerpo",
  T_46_META_WS_E_MGL140: "MGL140",
  T_46_META_WS_E_MICROPHONE: "Micrófono",
  T_46_META_WS_E_MIDDLE: "Medio",
  T_46_META_WS_E_MINIHANDLE: "Mini empuñadura",
  T_46_META_WS_E_MINIMAP: "Mini mapa",
  T_46_META_WS_E_MINISENTRY: "Mini sentinela",
  T_46_META_WS_E_MINVALUE: "Valor Mínimo",
  T_46_META_WS_E_MISSILEEXPLODE: "Arma Tipo Misil",
  T_46_META_WS_E_MISSIONCOMPLETE: "Éxito de Misión 1",
  T_46_META_WS_E_MISTAKE: "Error",
  T_46_META_WS_E_MODERATE: "Moderado",
  T_46_META_WS_E_MONEY: "Dinero",
  T_46_META_WS_E_MONSTER: "Monstruo",
  T_46_META_WS_E_MONSTERSPAWN: "Punto de aparición del monstruo",
  T_46_META_WS_E_MONSTERTRUCK: "Camión monstruo",
  T_46_META_WS_E_MOON: "Luna",
  T_46_META_WS_E_MOSQUITO: "Mosquito",
  T_46_META_WS_E_MOTIONTRAIL: "Choque Trasero",
  T_46_META_WS_E_MOTOBIKE: "Motocicleta",
  T_46_META_WS_E_MOTORBIKE: "Motocicleta",
  T_46_META_WS_E_MOVE: "Mover",
  T_46_META_WS_E_MOVEMENT: "Mover",
  T_46_META_WS_E_MOVINGJOYSTICK: "Joystick de movimiento",
  T_46_META_WS_E_MP40: "MP40",
  T_46_META_WS_E_MP402: "MP402",
  T_46_META_WS_E_MP5: "MP5",
  T_46_META_WS_E_MRV: "Señor V",
  T_46_META_WS_E_MULTIPLIER: "Multiplicador",
  T_46_META_WS_E_MULTIPLY: "Multiplicar",
  T_46_META_WS_E_MULTIPLYACCUMULATE: "Multiplicar y Acumular",
  T_46_META_WS_E_MUSHROOM1: "Hongo1",
  T_46_META_WS_E_MUSHROOM2: "Hongo2",
  T_46_META_WS_E_MUSHROOM3: "Hongo3",
  T_46_META_WS_E_MUSHROOM4: "Hongo4",
  T_46_META_WS_E_MUSHSHADE: "Grupo de Setas Gigantes",
  T_46_META_WS_E_MUSIC: "Música",
  T_46_META_WS_E_MUZZLE1: "Boca1",
  T_46_META_WS_E_MUZZLE2: "Boca2",
  T_46_META_WS_E_MUZZLE3: "Boca3",
  T_46_META_WS_E_NEAR: "Cerca",
  T_46_META_WS_E_NIGHT: "Noche",
  T_46_META_WS_E_NOATTACK: "Sin ataque",
  T_46_META_WS_E_NODUALWIELDING: "Sin doble empuñadura",
  T_46_META_WS_E_NOERROR: "Sin Error",
  T_46_META_WS_E_NONE: "Ninguno",
  T_46_META_WS_E_NORMAL: "Normal",
  T_46_META_WS_E_NOSKIPKNOCKDOWN: "No Omitir Derribo",
  T_46_META_WS_E_NOTONASTALIQURDU: "NotoNastaliqUrdu",
  T_46_META_WS_E_NUTTYMOVEMENT: "Habilidad 7",
  T_46_META_WS_E_OBTAINEDCOINS: "Obtener Oro Medio",
  T_46_META_WS_E_OBTAINEDMANYCOINS: "Obtener Oro Grande",
  T_46_META_WS_E_OBTAINEDSOMECOINS: "Obtener Oro Pequeño",
  T_46_META_WS_E_OILDRUMEXPLODE: "Explosión de Barril de Aceite",
  T_46_META_WS_E_ONCE: "Una vez",
  T_46_META_WS_E_ONEWAY: "Unidireccional",
  T_46_META_WS_E_OPENFOLDER: "Carpeta Abierta",
  T_46_META_WS_E_OPENHIHATS: "Hi-hat abierto",
  T_46_META_WS_E_OPENINGBOX: "Abrir Caja",
  T_46_META_WS_E_OPENINGGUILDSUPPLY: "Suministro de Guild",
  T_46_META_WS_E_OPENINGWARCHEST: "Guardar Almacén",
  T_46_META_WS_E_ORANGE: "Naranja",
  T_46_META_WS_E_ORTHOGONAL: "Ortogonal",
  T_46_META_WS_E_OUTPOST: "Casa de Guardia",
  T_46_META_WS_E_P90: "P90",
  T_46_META_WS_E_P902: "P902",
  T_46_META_WS_E_PAINTEDWALLS: "Pared Pintada",
  T_46_META_WS_E_PAINTSHIELDSKILL: "Habilidad de Charco de Sangre",
  T_46_META_WS_E_PALM: "Papel",
  T_46_META_WS_E_PANEL: "Panel",
  T_46_META_WS_E_PARAFAL: "PARAFAL",
  T_46_META_WS_E_PARAFAL2: "PARAFAL2",
  T_46_META_WS_E_PASSENGERA: "Pasajero A",
  T_46_META_WS_E_PASSENGERB: "Pasajero B",
  T_46_META_WS_E_PASSENGERC: "Pasajero C",
  T_46_META_WS_E_PASSIVE: "Pasivo",
  T_46_META_WS_E_PASSIVESKILL: "Habilidad pasiva",
  T_46_META_WS_E_PATROLWHILEATTACK: "Patrulla y ataque",
  T_46_META_WS_E_PERSONALUAV: "UAV personal",
  T_46_META_WS_E_PERSPECTIVE: "Perspectiva",
  T_46_META_WS_E_PETTABBG: "Mascota",
  T_46_META_WS_E_PHASESTART: "Inicio de Fase",
  T_46_META_WS_E_PHONEBOOTH: "Cabina telefónica",
  T_46_META_WS_E_PI: "Π",
  T_46_META_WS_E_PIANOA3: "PianoA3",
  T_46_META_WS_E_PIANOA3SHARP: "PianoA3#",
  T_46_META_WS_E_PIANOA4: "PianoA4",
  T_46_META_WS_E_PIANOA4SHARP: "PianoA4#",
  T_46_META_WS_E_PIANOB3: "PianoB3",
  T_46_META_WS_E_PIANOB4: "PianoB4",
  T_46_META_WS_E_PIANOC3: "PianoC3",
  T_46_META_WS_E_PIANOC3SHARP: "PianoC3#",
  T_46_META_WS_E_PIANOC4: "PianoC4",
  T_46_META_WS_E_PIANOC4SHARP: "PianoC4#",
  T_46_META_WS_E_PIANOD3: "PianoD3",
  T_46_META_WS_E_PIANOD3SHARP: "PianoD3#",
  T_46_META_WS_E_PIANOD4: "PianoD4",
  T_46_META_WS_E_PIANOD4SHARP: "PianoD4#",
  T_46_META_WS_E_PIANOE3: "PianoE3",
  T_46_META_WS_E_PIANOE4: "PianoE4",
  T_46_META_WS_E_PIANOF3: "PianoF3",
  T_46_META_WS_E_PIANOF3SHARP: "PianoF3#",
  T_46_META_WS_E_PIANOF4: "PianoF4",
  T_46_META_WS_E_PIANOF4SHARP: "PianoF4#",
  T_46_META_WS_E_PIANOG3: "PianoG3",
  T_46_META_WS_E_PIANOG3SHARP: "PianoG3#",
  T_46_META_WS_E_PIANOG4: "PianoG4",
  T_46_META_WS_E_PIANOG4SHARP: "PianoG4#",
  T_46_META_WS_E_PIANOKEY1: "Notas Musicales - Piano",
  T_46_META_WS_E_PIANOKEY2: "Notas Musicales - Piano",
  T_46_META_WS_E_PICKUPS: "Recogidas",
  T_46_META_WS_E_PICKUPTRUCK: "SUV",
  T_46_META_WS_E_PILLAR: "Columna de Concreto",
  T_46_META_WS_E_PIN: "Llamada",
  T_46_META_WS_E_PINGPONG: "Ping Pong",
  T_46_META_WS_E_PIPECORNER: "Tubería de Codo",
  T_46_META_WS_E_PIPEINTERSECTION: "Tubería Cruzada",
  T_46_META_WS_E_PISTOL: "Pistola",
  T_46_META_WS_E_PISTOLAMMO: "Munición de pistola",
  T_46_META_WS_E_PLAIDAMUSEMENTPARKCUBE: "Bloque de parque de diversiones a cuadros",
  T_46_META_WS_E_PLASMA_X: "PLASMA_X",
  T_46_META_WS_E_PLAYER: "Jugador",
  T_46_META_WS_E_PLUS: "Más",
  T_46_META_WS_E_PODIUM: "Podio",
  T_46_META_WS_E_POISONGAS: "Gas Tóxico",
  T_46_META_WS_E_POISONGASPREDISCARDED: "Gas Tóxico",
  T_46_META_WS_E_PORTAL: "Portal",
  T_46_META_WS_E_POSTACCUMULATOR: "Post-acumulador",
  T_46_META_WS_E_POT: "Pot",
  T_46_META_WS_E_POUNDINGHEART: "Latido Rápido",
  T_46_META_WS_E_PREACCUMULATOR: "Pre-acumulador",
  T_46_META_WS_E_PRIMARYWEAPONA: "Arma principal A",
  T_46_META_WS_E_PRIMARYWEAPONB: "Arma principal B",
  T_46_META_WS_E_PRIOREXPLOSION: "Antes de la Explosión de la Bomba",
  T_46_META_WS_E_PROFILEWIDGET: "Widget de perfil",
  T_46_META_WS_E_PRONE: "En el Suelo",
  T_46_META_WS_E_PUMPKIN: "Calabaza",
  T_46_META_WS_E_PURPLE: "Púrpura",
  T_46_META_WS_E_QUADRILATERAL: "Cuadrilátero",
  T_46_META_WS_E_QUESTIONMARK: "Signo de Interrogación",
  T_46_META_WS_E_QUICKCHAT: "Chat rápido",
  T_46_META_WS_E_QUICKCHATSHOW: "Mostrar chat rápido",
  T_46_META_WS_E_RADIAL180: "Radial 180°",
  T_46_META_WS_E_RADIAL360: "Radial 360°",
  T_46_META_WS_E_RADIAL90: "Radial 90°",
  T_46_META_WS_E_RAMPAGE: "Racha",
  T_46_META_WS_E_RANDOM: "Aleatorio",
  T_46_META_WS_E_RANDOMBUFF: "Buff aleatorio",
  T_46_META_WS_E_RANKDOWN: "Descender de Rango",
  T_46_META_WS_E_REACTION: "Responder",
  T_46_META_WS_E_RECOVER: "Recuperar",
  T_46_META_WS_E_RECYCLE: "Reciclar",
  T_46_META_WS_E_RED: "Rojo",
  T_46_META_WS_E_REFINERYTANK: "Jarra de agua",
  T_46_META_WS_E_REFLECTIVECUBE: "Bloque básico de color sólido reflectante 1",
  T_46_META_WS_E_REFRESH: "Actualizar",
  T_46_META_WS_E_RELEASINGSKILL: "Efecto de Lanzamiento de Habilidad",
  T_46_META_WS_E_RELOAD: "Recargar",
  T_46_META_WS_E_REMINDER: "Recordatorio",
  T_46_META_WS_E_REPAIR: "Reparar",
  T_46_META_WS_E_REPAIREQUIP: "Reparar Equipos",
  T_46_META_WS_E_REPAIRKIT: "Kit de Reparación",
  T_46_META_WS_E_REPLACER: "Reemplazador",
  T_46_META_WS_E_REPORT: "Reportar",
  T_46_META_WS_E_REST: "Descanso",
  T_46_META_WS_E_RG550: "RG550",
  T_46_META_WS_E_RIDES: "Ride",
  T_46_META_WS_E_RIDICULE: "Burla",
  T_46_META_WS_E_RIDICULEFUNNY: "Burla Divertida",
  T_46_META_WS_E_RIFLE: "Rifle",
  T_46_META_WS_E_RIFLEAMMO: "Munición de rifle",
  T_46_META_WS_E_RIGHT: "Correcto",
  T_46_META_WS_E_RIGHTTRAPEZOID: "Trapecio Rectángulo",
  T_46_META_WS_E_RING: "Mecanismo de Anillo",
  T_46_META_WS_E_RINGPREDISCARDED: "Anillo",
  T_46_META_WS_E_RIPTIDERHYTHM: "Habilidad 9",
  T_46_META_WS_E_RISINGPARTICLE: "Partículas Ascendentes",
  T_46_META_WS_E_ROADBLOCK: "Barricada",
  T_46_META_WS_E_ROTATE: "Rotación",
  T_46_META_WS_E_RUNNING: "En curso",
  T_46_META_WS_E_RUSHTIME: "Frenesí",
  T_46_META_WS_E_SAMURAI: "Samurai",
  T_46_META_WS_E_SANDA: "Arena A",
  T_46_META_WS_E_SANDSTRUCTURE: "Escultura de Arena",
  T_46_META_WS_E_SCALE: "Escala",
  T_46_META_WS_E_SCAR: "SCAR",
  T_46_META_WS_E_SCAR2: "SCAR2",
  T_46_META_WS_E_SCARECROW: "Espantapájaros",
  T_46_META_WS_E_SCISSORS: "Tijeras",
  T_46_META_WS_E_SCOPE2X: "2x Visor",
  T_46_META_WS_E_SCOPE4X: "4x Visor",
  T_46_META_WS_E_SCROLLPANEL: "Panel de desplazamiento",
  T_46_META_WS_E_SECONDARYWEAPON: "Arma secundaria",
  T_46_META_WS_E_SENSESSHOCKWAVE: "Habilidad 10",
  T_46_META_WS_E_SERVER: "Servidor",
  T_46_META_WS_E_SET: "Traje completo",
  T_46_META_WS_E_SETTING: "Configuración",
  T_46_META_WS_E_SETTINGS: "Configuración",
  T_46_META_WS_E_SG: "Escopeta",
  T_46_META_WS_E_SGAMMO: "Munición SN",
  T_46_META_WS_E_SHARPMECHANICAL: "Chasquido Rápido 1",
  T_46_META_WS_E_SHIELD: "Defensa",
  T_46_META_WS_E_SHIELDBROKEN: "Escudo Roto",
  T_46_META_WS_E_SHIELDGUN: "ShieldGun",
  T_46_META_WS_E_SHIELDUP: "Levantar Escudo",
  T_46_META_WS_E_SHOCKWAVE: "Onda de Choque",
  T_46_META_WS_E_SHOES: "Zapatos",
  T_46_META_WS_E_SHOOTINGTARGET: "Objetivo en Movimiento",
  T_46_META_WS_E_SHORTDATE: "Fecha corta",
  T_46_META_WS_E_SHORTDATETIME: "Fecha y hora corta",
  T_46_META_WS_E_SHORTTIME: "Hora corta",
  T_46_META_WS_E_SHOTGUN: "Escopeta",
  T_46_META_WS_E_SHOTGUNAMMO: "Munición de escopeta",
  T_46_META_WS_E_SHOTGUNMUZZLE: "Boca para escopeta",
  T_46_META_WS_E_SHOW: "Mostrar",
  T_46_META_WS_E_SHRUB: "Caja de Madera Larga Cubierta de Arbustos",
  T_46_META_WS_E_SICKLE: "Sickle",
  T_46_META_WS_E_SIDESCROLLING: "Cámara de desplazamiento lateral",
  T_46_META_WS_E_SIGNAL: "Señal",
  T_46_META_WS_E_SIGNOUT: "Salir",
  T_46_META_WS_E_SILENCER: "Silenciador",
  T_46_META_WS_E_SIMPLE: "Simple",
  T_46_META_WS_E_SIMPLEWIDGET: "Widget simple",
  T_46_META_WS_E_SIMPLIFIEDARABIC: "SimplifiedArabic",
  T_46_META_WS_E_SINGLE: "Único",
  T_46_META_WS_E_SITEHUT: "Casa Contenedor",
  T_46_META_WS_E_SKILLCHARGINGCOMPLETE: "Carga de Habilidad Completa",
  T_46_META_WS_E_SKILLRECOVER: "Recuperación de Habilidad",
  T_46_META_WS_E_SKIPKNOCKDOWN: "Omitir Derribo",
  T_46_META_WS_E_SKS: "SKS",
  T_46_META_WS_E_SLICED: "Cortado",
  T_46_META_WS_E_SLOPE: "Pendiente",
  T_46_META_WS_E_SLOWHEARTBEAT: "Latido Lento",
  T_46_META_WS_E_SMG: "SMG",
  T_46_META_WS_E_SMGAMMO: "Munición SMG",
  T_46_META_WS_E_SMGMUZZLE: "Boca para SMG",
  T_46_META_WS_E_SMILEY: "Cara Sonriente",
  T_46_META_WS_E_SMOKE: "Humo",
  T_46_META_WS_E_SMOKEGRENADE: "Granada de humo",
  T_46_META_WS_E_SMOKEY: "Humo",
  T_46_META_WS_E_SMOOTH: "Suave",
  T_46_META_WS_E_SNAMMO: "Munición SN",
  T_46_META_WS_E_SNARES: "Tarola",
  T_46_META_WS_E_SNEAKERS: "Efecto de Zapatillas de Correr",
  T_46_META_WS_E_SNIPER: "Rifle de Francotirador",
  T_46_META_WS_E_SNIPERAMMO: "Munición de rifle de francotirador",
  T_46_META_WS_E_SNOWA: "Nieve A",
  T_46_META_WS_E_SNOWFLAKE: "Copo de Nieve",
  T_46_META_WS_E_SOCCER: "Fútbol",
  T_46_META_WS_E_SOCIALBUTTONWIDGET: "Widget social",
  T_46_META_WS_E_SOLARPANEL: "Panel Solar",
  T_46_META_WS_E_SORTBYPRIORITYHIGHTOLOW: "Por prioridad de alto a bajo",
  T_46_META_WS_E_SORTBYPRIORITYLOWTOHIGH: "Por prioridad de bajo a alto",
  T_46_META_WS_E_SPAS12: "SPAS12",
  T_46_META_WS_E_SPAS122: "SPAS122",
  T_46_META_WS_E_SPAWNPOINT: "Efecto de Punto de Aparición",
  T_46_META_WS_E_SPEAKER: "Altavoz",
  T_46_META_WS_E_SPECIALFIRINGSOUND: "Sonido de Arma Especial",
  T_46_META_WS_E_SPECIALGUN: "Arma especial",
  T_46_META_WS_E_SPHERE: "Esfera",
  T_46_META_WS_E_SPHERETRIGGER: "Disparador de colisión esférica",
  T_46_META_WS_E_SPIDERWEB: "Efecto de Habilidad",
  T_46_META_WS_E_SPORTSCAR: "Coche Deportivo",
  T_46_META_WS_E_SPOTLIGHT: "Luz",
  T_46_META_WS_E_SPREADOFPOISONGAS: "Difusión de Gas Tóxico",
  T_46_META_WS_E_SPRINT: "Corriendo Rápido",
  T_46_META_WS_E_SQUARE: "Cuadrado",
  T_46_META_WS_E_SQUAREBOX: "Caja de Madera Cuadrada",
  T_46_META_WS_E_SR: "Rifles de Francotirador",
  T_46_META_WS_E_STABLE: "Cabaña de paja",
  T_46_META_WS_E_STAIRS: "Escalera",
  T_46_META_WS_E_STANDING: "De pie",
  T_46_META_WS_E_STAR: "Estrella",
  T_46_META_WS_E_STATIC: "Estático",
  T_46_META_WS_E_STATUSTRIGGER: "Disparador de muerte o invulnerabilidad",
  T_46_META_WS_E_STEP: "Huella de Pasos",
  T_46_META_WS_E_STEPTRIGGER: "Activar Mecanismo",
  T_46_META_WS_E_STOCK_S: "Culata S",
  T_46_META_WS_E_STOCK_SR: "Culata SR",
  T_46_META_WS_E_STOCK1: "Culata1",
  T_46_META_WS_E_STOCK2: "Culata2",
  T_46_META_WS_E_STOCK3: "Culata3",
  T_46_META_WS_E_STONE: "Piedra",
  T_46_META_WS_E_STONEBRIDGE: "Puente de arco de piedra",
  T_46_META_WS_E_STONELANTERN: "Lámpara de Palacio",
  T_46_META_WS_E_STONESPLASH: "Escombros Voladores",
  T_46_META_WS_E_STORE: "Tienda",
  T_46_META_WS_E_STREETLAMP: "Farola",
  T_46_META_WS_E_STYLEA: "Estilo A",
  T_46_META_WS_E_STYLEB: "Estilo B",
  T_46_META_WS_E_STYLEC: "Estilo C",
  T_46_META_WS_E_SUBMACHINEGUN: "SMG",
  T_46_META_WS_E_SUBMACHINEGUNAMMO: "Munición de subfusil (SMG)",
  T_46_META_WS_E_SUCCESSFULHIT: "Impacto",
  T_46_META_WS_E_SUN: "Sol",
  T_46_META_WS_E_SUNSHADE: "Conjunto de patio con sombrilla",
  T_46_META_WS_E_SUPERCAR: "Coche deportivo",
  T_46_META_WS_E_SUPERMARKET: "Supermercado",
  T_46_META_WS_E_SURPRISEFIND: "Descubrir Sorpresa",
  T_46_META_WS_E_SUV: "SUV",
  T_46_META_WS_E_SVD: "SVD",
  T_46_META_WS_E_SVD2: "SVD2",
  T_46_META_WS_E_SWEAPWEAPONQUICK: "Cambio rápido de arma",
  T_46_META_WS_E_SWIMRING: "Anillo de Natación",
  T_46_META_WS_E_SWORD: "Espada",
  T_46_META_WS_E_SYMBOLIC: "Marcador de Suelo",
  T_46_META_WS_E_TANKZOMBIE: "Zombi tanque",
  T_46_META_WS_E_TAP: "Toque",
  T_46_META_WS_E_TAPPINGBUTTON: "Botón de Toque",
  T_46_META_WS_E_TAPPINGDISABLEDBUTTON: "Toque para Desactivar Botón",
  T_46_META_WS_E_TEAM: "Equipo",
  T_46_META_WS_E_TEAMMATESINFO: "Información de compañeros de equipo",
  T_46_META_WS_E_TELEPORT: "Teletransportar",
  T_46_META_WS_E_TELEPORTCORRECT: "Señal de Destino Correcto",
  T_46_META_WS_E_TELEPORTWRONG: "Señal de Destino Incorrecto",
  T_46_META_WS_E_TEXT: "Texto",
  T_46_META_WS_E_TEXTOBJECT: "Texto",
  T_46_META_WS_E_TEXTUREWIDGET: "Widget de textura",
  T_46_META_WS_E_THERMALSCOPE: "Alcance Térmico",
  T_46_META_WS_E_THIRDPERSON: "Cámara en tercera persona",
  T_46_META_WS_E_THIRDPERSONCLASSIC: "Cámara en tercera persona (clásica)",
  T_46_META_WS_E_THIRDPERSONLOCK: "Cámara en tercera persona fija",
  T_46_META_WS_E_THOMPSON: "THOMPSON",
  T_46_META_WS_E_THOMPSON2: "THOMPSON2",
  T_46_META_WS_E_THOWINGKNIFE2FORCOMPATIBILITY: "Cuchillo arrojadizo2 para compatibilidad",
  T_46_META_WS_E_THRILLBATTLE: "Habilidad 5",
  T_46_META_WS_E_THROWATTACK: "Lanzar granada",
  T_46_META_WS_E_THROWINGKNIFE: "ThrowingKnife",
  T_46_META_WS_E_THROWREDZOMBIE: "Zombi lanzador rojo",
  T_46_META_WS_E_THROWZOMBIE: "Zombi lanzador",
  T_46_META_WS_E_THUMBSUP: "Me Gusta",
  T_46_META_WS_E_THUNDER: "Choque Eléctrico",
  T_46_META_WS_E_TILEA: "Azulejo A",
  T_46_META_WS_E_TILEB: "Azulejo B",
  T_46_META_WS_E_TILEC: "Azulejo C",
  T_46_META_WS_E_TILED: "Azulejos",
  T_46_META_WS_E_TIPSSOUND: "Mostrar Consejos",
  T_46_META_WS_E_TOGGLEWIDGET: "Widget de alternancia",
  T_46_META_WS_E_TOILETBOWL: "Inodoro",
  T_46_META_WS_E_TONEA: "Tono A",
  T_46_META_WS_E_TOP: "Ropa superior",
  T_46_META_WS_E_TOPDOWN: "Cámara superior",
  T_46_META_WS_E_TORII: "Torii",
  T_46_META_WS_E_TOUCHPADWIDGET: "Widget touchpad",
  T_46_META_WS_E_TOWER: "Fortaleza",
  T_46_META_WS_E_TPIPE: "Tubería T",
  T_46_META_WS_E_TRACINGSTEPS: "Habilidad 3",
  T_46_META_WS_E_TRAILER: "Remolque",
  T_46_META_WS_E_TRANSFORMATION: "Cambio de Apariencia",
  T_46_META_WS_E_TRANSPARENT: "Transparente",
  T_46_META_WS_E_TRAPEZOID: "Trapecio",
  T_46_META_WS_E_TRASHCAN: "Cubo de Basura",
  T_46_META_WS_E_TRIANGLE: "Triángulo",
  T_46_META_WS_E_TRIGGERS: "Activador",
  T_46_META_WS_E_TRIPLE: "Triple",
  T_46_META_WS_E_TROPHY: "Trofeo",
  T_46_META_WS_E_TRUE: "Sí",
  T_46_META_WS_E_TUKTUK: "Tuk Tuk",
  T_46_META_WS_E_TUTUCAR: "Tuk Tuk",
  T_46_META_WS_E_TYRANTZOMBIE: "Zombi tirano",
  T_46_META_WS_E_UAVLITE: "UAV ligero",
  T_46_META_WS_E_UIFINISH: "Fin",
  T_46_META_WS_E_UITAP: "Toque en la UI",
  T_46_META_WS_E_UMP: "UMP",
  T_46_META_WS_E_UMP2: "UMP2",
  T_46_META_WS_E_UNITGENERATOR: "Generador de unidades",
  T_46_META_WS_E_UPWARDTURBULENCE: "Corriente Ascendente",
  T_46_META_WS_E_USP: "USP",
  T_46_META_WS_E_USP_2: "USP_2",
  T_46_META_WS_E_UZI: "UZI",
  T_46_META_WS_E_VAULTOVER: "Trepar",
  T_46_META_WS_E_VECTOR: "VECTOR",
  T_46_META_WS_E_VEHICLE: "Vehículo",
  T_46_META_WS_E_VEHICLEEXPLODE: "Explosión de Vehículo",
  T_46_META_WS_E_VELOCITY: "Velocidad",
  T_46_META_WS_E_VENDINGMACHINE: "Máquina expendedora",
  T_46_META_WS_E_VERTICAL: "Vertical",
  T_46_META_WS_E_VEST: "Chaleco",
  T_46_META_WS_E_VEST1: "Vest1",
  T_46_META_WS_E_VEST2: "Vest2",
  T_46_META_WS_E_VEST3: "Vest3",
  T_46_META_WS_E_VEST4: "Chaleco4",
  T_46_META_WS_E_VISUALEFFECTS: "Efectos Visuales",
  T_46_META_WS_E_VSK94: "VSK94",
  T_46_META_WS_E_VSS: "VSS",
  T_46_META_WS_E_WALLA: "Pared A",
  T_46_META_WS_E_WALLBRAWL: "Habilidad 2",
  T_46_META_WS_E_WARNING: "Advertencia",
  T_46_META_WS_E_WATERRING: "Salpicadura de Agua",
  T_46_META_WS_E_WAVE1: "Ola1",
  T_46_META_WS_E_WAVE2: "Ola2",
  T_46_META_WS_E_WAVE3: "Ola3",
  T_46_META_WS_E_WEAPONGENERATOR: "Arma",
  T_46_META_WS_E_WEAPONSLOT: "Ranura de armas",
  T_46_META_WS_E_WHISTLE: "Derrotar Enemigo",
  T_46_META_WS_E_WIDERANGE: "Rango Amplio",
  T_46_META_WS_E_WIN: "Victoria",
  T_46_META_WS_E_WINDATTACK: "Ataque de Viento",
  T_46_META_WS_E_WOODA: "Madera A",
  T_46_META_WS_E_WOODCUTZOMBIE: "Zombi cortador de madera",
  T_46_META_WS_E_WOODENPLANK: "Puente de Madera",
  T_46_META_WS_E_WORLDPOSITION: "Coordenadas mundiales",
  T_46_META_WS_E_WRECKEDBUS: "Autobús Destrozado",
  T_46_META_WS_E_WRECKEDCAR: "Coche Destrozado",
  T_46_META_WS_E_WRONG: "Incorrecto",
  T_46_META_WS_E_XM8: "XM8",
  T_46_META_WS_E_XM82: "XM82",
  T_46_META_WS_E_ZOMBIE: "Zombi",
  T_46_META_WS_E_ZOMBIES: "Zombie",
  T_46_META_WS_E_ZOOM: "Zoom",
  T_46_META_WS_ELIMINATE: "Eliminar",
  T_46_META_WS_ELIMINATEDENTITY: "Entidad eliminada",
  T_46_META_WS_ELIMINATEDPLAYER: "Jugador eliminado",
  T_46_META_WS_ENABLEDEFAULTBTREE: "Habilitar Árbol de Comportamiento Predeterminado",
  T_46_META_WS_ENABLEMOVINGSAFEZONE: "Habilitar zona segura en movimiento",
  T_46_META_WS_ENABLESAFEZONE: "Habilitar zona segura",
  T_46_META_WS_ENDCURRENTPHASE: "Terminar fase actual",
  T_46_META_WS_ENDMORPH: "Terminar Transformación",
  T_46_META_WS_ENDPOSITION: "Posición final",
  T_46_META_WS_ENTERVEHICLE: "Entrar en Vehículo",
  T_46_META_WS_ENTITY: "Entidad",
  T_46_META_WS_EQUIPMENTID: "ID de equipo",
  T_46_META_WS_EULERANGLETOQUATERNION: "Ángulo Euler a Cuaternión",
  T_46_META_WS_EXITVEHICLE: "Salir del Vehículo",
  T_46_META_WS_EXPONENTIATION: "Exponenciación",
  T_46_META_WS_FILTERENTITY: "Filtrar Entidad",
  T_46_META_WS_FILTERLEVELOBJECTS: "Filtrar objetos de nivel",
  T_46_META_WS_FIND: "Encontrar",
  T_46_META_WS_FINDAT: "Encontrar en",
  T_46_META_WS_FINDPATH: "Encontrar Ruta",
  T_46_META_WS_FLOOR: "Redondear hacia abajo",
  T_46_META_WS_FOOTBALLGOAL: "Gol de fútbol",
  T_46_META_WS_FORMAT: "Formatear",
  T_46_META_WS_GETALLKEYS: "Obtener todas las claves",
  T_46_META_WS_GETALLPLAYERS: "Obtener todos los jugadores",
  T_46_META_WS_GETALLSHOPS: "Obtener Todas las Tiendas",
  T_46_META_WS_GETALLTEAMS: "Obtener todos los equipos",
  T_46_META_WS_GETATTACKABLEENTITY: "Obtener Entidad Atacable",
  T_46_META_WS_GETATTACKABLEFACTIONS: "Obtener Facciones Atacables",
  T_46_META_WS_GETBACKPACKSKIN: "Obtener Skin de Mochila",
  T_46_META_WS_GETBLACKBOARDVALUE: "Obtener Valor de Blackboard",
  T_46_META_WS_GETBUFFS: "Obtener Buffs",
  T_46_META_WS_GETCHATCHANNEL: "Obtener Canal de Chat",
  T_46_META_WS_GETCHILDBYINDEX: "Obtener Hijo por Índice",
  T_46_META_WS_GETCHILDBYNAME: "Obtener Hijo por Nombre",
  T_46_META_WS_GETCHILDREN: "Obtener Hijos",
  T_46_META_WS_GETCOLORCHANNEL: "Obtener Canal de Color",
  T_46_META_WS_GETCONSUMABLES: "Obtener Consumibles",
  T_46_META_WS_GETCULLINGMASK: "Obtener Máscara de Culling",
  T_46_META_WS_GETCURRENTCAMERA: "Obtener Cámara Actual",
  T_46_META_WS_GETCURRENTCHATCHANNEL: "Obtener Canal de Chat Actual",
  T_46_META_WS_GETCUSTOMMISSIONPROGRESS: "Obtener Progreso de Misión Personalizada",
  T_46_META_WS_GETDYEDCOUNT: "Obtener Conteo de Teñido",
  T_46_META_WS_GETDYEDSTATUS: "Obtener Estado de Teñido",
  T_46_META_WS_GETEQUIPMENTS: "Obtener Equipos",
  T_46_META_WS_GETFACTION: "Obtener Facción",
  T_46_META_WS_GETGLOBALSLEEPTHRESHOLD: "Obtener Umbral de Sueño Global",
  T_46_META_WS_GETITEMCOUNT: "Obtener número de ítems",
  T_46_META_WS_GETLOADEDSCENES: "Obtener Escenas Cargadas",
  T_46_META_WS_GETLOCALAIMDIRECTION: "Obtener Dirección de Apuntado Local",
  T_46_META_WS_GETLOCALPLAYER: "Obtener Jugador Local",
  T_46_META_WS_GETLOCALTIMESTAMP: "Obtener Timestamp Local",
  T_46_META_WS_GETMAPID: "Obtener ID del Mapa",
  T_46_META_WS_GETMINIMAP: "Obtener Mini Mapa",
  T_46_META_WS_GETMONEY: "Obtener Dinero",
  T_46_META_WS_GETMONEYCOUNT: "Obtener Cantidad de Dinero",
  T_46_META_WS_GETMORPH: "Obtener Transformación",
  T_46_META_WS_GETNODEVARIABLE: "Obtener Variable de Nodo",
  T_46_META_WS_GETOUTFIT: "Obtener Atuendo",
  T_46_META_WS_GETOWNER: "Obtener propietario",
  T_46_META_WS_GETPARENT: "Obtener Padre",
  T_46_META_WS_GETPOSITIONNEARTEAMMATE: "Obtener posición cerca del compañero de equipo",
  T_46_META_WS_GETRANDOMSPAWNPOSITION: "Obtener posición de aparición aleatoria",
  T_46_META_WS_GETRESULTFROMCURVE: "Obtener Resultado de Curva",
  T_46_META_WS_GETSCENESKYBOX: "Obtener Skybox de Escena",
  T_46_META_WS_GETSERVERREGION: "Obtener región del servidor",
  T_46_META_WS_GETSERVERTIMESTAMP: "Obtener timestamp del servidor",
  T_46_META_WS_GETSKELETONPARTBYNAME: "Obtener Parte del Esqueleto por Nombre",
  T_46_META_WS_GETSKILLS: "Obtener Habilidades",
  T_46_META_WS_GETSLEEPTHRESHOLD: "Obtener Umbral de Sueño",
  T_46_META_WS_GETTOKENCOUNT: "Obtener recuento de tokens",
  T_46_META_WS_GETTOKENCOUNTTODAY: "Obtener recuento de tokens de hoy",
  T_46_META_WS_GETTYPE: "Obtener Tipo",
  T_46_META_WS_GETVEHICLESKIN: "Obtener Skin del Vehículo",
  T_46_META_WS_GETWALLET: "Obtener Billetera",
  T_46_META_WS_GETWEAPONSKIN: "Obtener Skin de Arma",
  T_46_META_WS_GETWIDGETBYPATH: "Obtener Widget por Ruta",
  T_46_META_WS_GETWIDGETFROMCUSTOMUI: "Obtener widget de UI personalizada",
  T_46_META_WS_GIVEJAILBREAKITEM: "Dar Ítem de Escape",
  T_46_META_WS_GIVEJAILBREAKREWARD: "Dar Recompensa de Escape",
  T_46_META_WS_HASAOISPECIALFOLLOW: "Existe Seguimiento Especial AOI",
  T_46_META_WS_HASCOMPONENT: "Tiene Componente",
  T_46_META_WS_HASSCRIPT: "Tiene Script",
  T_46_META_WS_HASTAG: "Tiene Etiqueta",
  T_46_META_WS_HELPEDPLAYER: "Jugador asistido",
  T_46_META_WS_HELPPLAYER: "Jugador asistente",
  T_46_META_WS_HIDEAPPEARANCEGROUP: "Ocultar Grupo de Apariencia",
  T_46_META_WS_HITENTITY: "Entidad golpeada",
  T_46_META_WS_HITFLY: "Golpe de Vuelo",
  T_46_META_WS_HITNORMAL: "Normal del golpe",
  T_46_META_WS_HITOBJECT: "Objeto golpeado",
  T_46_META_WS_HITPOSITION: "Posición del golpe",
  T_46_META_WS_INDEXOF: "Índice de",
  T_46_META_WS_INFECTIONZOMBIEGROWUP: "Evolución de zombie infectado",
  T_46_META_WS_INSERT: "Insertar",
  T_46_META_WS_ISATTACKABLE: "¿Es Atacable?",
  T_46_META_WS_ISCHATCHANNELEMPTY: "¿Está Vacío el Canal de Chat?",
  T_46_META_WS_ISEQUAL: "Es Igual",
  T_46_META_WS_ISFRIEND: "¿Es Amigo?",
  T_46_META_WS_ISHIT: "¿Ha sido golpeado?",
  T_46_META_WS_ISINSIDEBOX: "Dentro de la caja",
  T_46_META_WS_ISINSIDECYLINDER: "Dentro del cilindro",
  T_46_META_WS_ISINSIDESECTOR: "Dentro del sector",
  T_46_META_WS_ISINSIDESPHERE: "Dentro de la esfera",
  T_46_META_WS_ISSLEEPING: "Está Durmiendo",
  T_46_META_WS_ISSUBTYPEOF: "Es Subtipo de",
  T_46_META_WS_ITEM: "Entidad",
  T_46_META_WS_ITEMID: "ID del objeto",
  T_46_META_WS_JOIN: "Unir",
  T_46_META_WS_JOINCHATCHANNEL: "Unirse al Canal de Chat",
  T_46_META_WS_JOINFACTION: "Unirse a Facción",
  T_46_META_WS_LASTINDEXOF: "Último índice de",
  T_46_META_WS_LENGTH: "Longitud",
  T_46_META_WS_LERP: "Lerp",
  T_46_META_WS_LOADSCENE: "Cargar Escena",
  T_46_META_WS_LOGARITHM: "Logaritmo",
  T_46_META_WS_LOGERROR: "Registrar Error",
  T_46_META_WS_LOGINFO: "Registrar información",
  T_46_META_WS_LOGWARNING: "Registrar Advertencia",
  T_46_META_WS_LOOKROTATION: "Crear Rotación hacia la Dirección del Objetivo",
  T_46_META_WS_MAGNITUDE: "Magnitud",
  T_46_META_WS_MAKER: "Creador",
  T_46_META_WS_MAX: "Máx",
  T_46_META_WS_MECHANISM: "Mecanismo",
  T_46_META_WS_MIN: "Mín",
  T_46_META_WS_MONSTERUSESKILL: "Usar Habilidad",
  T_46_META_WS_MORPHOBJECT: "Objeto de morfología",
  T_46_META_WS_MORPHTO: "Transformar en",
  T_46_META_WS_MORPHTOBYITEMID: "Transformar en por ID de Elemento",
  T_46_META_WS_MOVECCT: "Mover CCT",
  T_46_META_WS_MOVEPOSITION: "Mover Posición",
  T_46_META_WS_MOVEROTATION: "Mover Rotación",
  T_46_META_WS_MULTIPLYQUATERNION: "Multiplicar Cuaternión",
  T_46_META_WS_MULTIRAYCAST: "Raycast Múltiple",
  T_46_META_WS_NEGATE: "Negativo",
  T_46_META_WS_NEW: "Nuevo",
  T_46_META_WS_NODENAME: "Nombre del nodo",
  T_46_META_WS_NORMALIZE: "Normalizar",
  T_46_META_WS_NOTIFYPLAYEFFECT: "Notificar reproducción de efecto",
  T_46_META_WS_NOTIFYPLAYICONANIMATION: "Notificar Animación de Icono",
  T_46_META_WS_NOTIFYPLAYSOUND: "Notificar reproducción de sonido",
  T_46_META_WS_NOTIFYSHOWTIPS: "Notificar mostrar consejos",
  T_46_META_WS_NUMTOSTRING: "Convertir Número a Cadena",
  T_46_META_WS_ONACCESSEQUIPMENT: "Al acceder al equipo",
  T_46_META_WS_ONACCESSITEM: "Al acceder al objeto",
  T_46_META_WS_ONACCESSWEAPON: "Al acceder al arma",
  T_46_META_WS_ONACE: "Al lograr un ACE",
  T_46_META_WS_ONAIMED: "Al haber apuntado",
  T_46_META_WS_ONAIMING: "Al apuntar",
  T_46_META_WS_ONASSIST: "Al dar una asistencia",
  T_46_META_WS_ONATTACK: "Al atacar",
  T_46_META_WS_ONATTACKSTOP: "Al dejar de atacar",
  T_46_META_WS_ONAWAKE: "Al despertar",
  T_46_META_WS_ONBEKNOCKEDDOWN: "Al ser derribado",
  T_46_META_WS_ONBOUNCEDBYTIRE: "Al rebotar con la llanta",
  T_46_META_WS_ONBOUNCEENTITY: "Al rebotar la entidad",
  T_46_META_WS_ONBUILTINBUTTONTAPPED: "Al tocar el botón UI integrado",
  T_46_META_WS_ONBULLETHIT: "Al ser golpeado por la bala",
  T_46_META_WS_ONCAMERARAYCAST: "Al realizar un raycast con la cámara",
  T_46_META_WS_ONCHARACTERCONTROLLERHIT: "Al golpear el controlador del personaje",
  T_46_META_WS_ONCHASE: "Al perseguir",
  T_46_META_WS_ONCHASESTOP: "Al dejar de perseguir",
  T_46_META_WS_ONCLIPEND: "Al terminar el clip",
  T_46_META_WS_ONCOLLISIONENTER: "Al comenzar la colisión",
  T_46_META_WS_ONCOLLISIONEXIT: "Al terminar la colisión",
  T_46_META_WS_ONCOUNTDOWNFINISHED: "Al terminar la cuenta regresiva",
  T_46_META_WS_ONCREEP: "Al arrastrarse",
  T_46_META_WS_ONCROUCH: "Al agacharse",
  T_46_META_WS_ONDEALDAMAGE: "Al causar daño",
  T_46_META_WS_ONDESTROY: "Al destruir",
  T_46_META_WS_ONDISABLE: "Al desactivar",
  T_46_META_WS_ONDISCONNECT: "Al desconectarse",
  T_46_META_WS_ONDOUBLETAPPED: "Al hacer doble clic",
  T_46_META_WS_ONDRAG: "Al arrastrar",
  T_46_META_WS_ONDRAGEND: "Al terminar de arrastrar",
  T_46_META_WS_ONDRAGSTART: "Al empezar a arrastrar",
  T_46_META_WS_ONDRIVED: "Al ser conducido",
  T_46_META_WS_ONDRIVEVEHICLE: "Al conducir el vehículo",
  T_46_META_WS_ONDROPCONSUMABLE: "Al soltar el consumible",
  T_46_META_WS_ONDROPPED: "Al soltar",
  T_46_META_WS_ONDROPWEAPON: "Al soltar el arma",
  T_46_META_WS_ONEACHLOOP: "En cada bucle",
  T_46_META_WS_ONELIMINATE: "Al eliminar",
  T_46_META_WS_ONELIMINATED: "Al ser eliminado",
  T_46_META_WS_ONENABLE: "Al activar",
  T_46_META_WS_ONEND: "Al terminar",
  T_46_META_WS_ONENTERED: "Al entrar",
  T_46_META_WS_ONENTERVEHICLE: "Al entrar en el vehículo",
  T_46_META_WS_ONENTITYENTER: "Al entrar el desencadenante",
  T_46_META_WS_ONENTITYEXIT: "Al salir el desencadenante",
  T_46_META_WS_ONEQUIPARMOR: "Al equipar la armadura",
  T_46_META_WS_ONEQUIPED: "Al equipar",
  T_46_META_WS_ONEQUIPWEAPON: "Al equipar el arma",
  T_46_META_WS_ONEXPLODE: "Al explotar",
  T_46_META_WS_ONFALL: "Al Caer",
  T_46_META_WS_ONFALLSTOP: "Al Detener Caída",
  T_46_META_WS_ONFIRE: "Al disparar",
  T_46_META_WS_ONFIXEDUPDATE: "Al actualizarse de manera fija",
  T_46_META_WS_ONFOOTBALLCOLLIDED: "Al colisionar el balón",
  T_46_META_WS_ONFRIENDSUPDATE: "Al actualizar el estado de amistad",
  T_46_META_WS_ONGAMEEND: "Al terminar el juego",
  T_46_META_WS_ONGAMEPAUSE: "Al pausar el juego",
  T_46_META_WS_ONGAMERESUME: "Al reanudar el juego",
  T_46_META_WS_ONGAMESTART: "Al comenzar el juego",
  T_46_META_WS_ONGOAL: "Al anotar un gol",
  T_46_META_WS_ONHITBYBULLET: "Al ser golpeado por la bala",
  T_46_META_WS_ONHITFLY: "Al golpear durante el vuelo",
  T_46_META_WS_ONHITFLYENTITY: "Al golpear la entidad voladora",
  T_46_META_WS_ONHOOKGUNFIRE: "Al disparar el gancho",
  T_46_META_WS_ONIDLE: "Al estar inactivo",
  T_46_META_WS_ONJAILBREAKAREABEGIN: "Al comenzar el área de escape de la cárcel",
  T_46_META_WS_ONJAILBREAKAREAEND: "Al terminar el área de escape de la cárcel",
  T_46_META_WS_ONJAILBREAKPLAYERJOIN: "Al unirse el jugador al área de escape de la cárcel",
  T_46_META_WS_ONJAILBREAKPLAYERQUIT: "Al salir el jugador del área de escape de la cárcel",
  T_46_META_WS_ONJOINCHATCHANNELSUCCESSFULLY: "Al unirse al canal de chat con éxito",
  T_46_META_WS_ONJOYSTICKMOVE: "Al mover el joystick",
  T_46_META_WS_ONJOYSTICKPRESSED: "Al presionar",
  T_46_META_WS_ONJOYSTICKRELEASED: "Al soltar",
  T_46_META_WS_ONJUMP: "Al saltar",
  T_46_META_WS_ONJUMPSTOP: "Al Saltar Detener",
  T_46_META_WS_ONLANDMINEACTIVE: "Al activar la mina terrestre",
  T_46_META_WS_ONLANDMINETRIGGER: "Al detonar la mina terrestre",
  T_46_META_WS_ONLEAVECHATCHANNEL: "Al salir del canal de chat",
  T_46_META_WS_ONLEAVEVEHICLE: "Al salir del vehículo",
  T_46_META_WS_ONLEFT: "Al salir",
  T_46_META_WS_ONLEVELOBJECTBEMORPHED: "Al transformarse el objeto de nivel",
  T_46_META_WS_ONMOVE: "Al moverse",
  T_46_META_WS_ONNODEENTER: "Al entrar en el nodo",
  T_46_META_WS_ONNODEEXIT: "Al salir del nodo",
  T_46_META_WS_ONPAUSE: "Al pausar",
  T_46_META_WS_ONPHASEEND: "Al terminar la fase",
  T_46_META_WS_ONPHASESTART: "Al comenzar la fase",
  T_46_META_WS_ONPICKEDUP: "Al recoger",
  T_46_META_WS_ONPLAYERASSIST: "Al asistir el jugador",
  T_46_META_WS_ONPLAYERBEELIMINATED: "Al ser eliminado el jugador",
  T_46_META_WS_ONPLAYERBEKNOCKEDDOWN: "Al derribar al jugador",
  T_46_META_WS_ONPLAYERDEALDAMAGE: "Al causar daño el jugador",
  T_46_META_WS_ONPLAYERELIMINATE: "Al eliminar el jugador",
  T_46_META_WS_ONPLAYERENTER: "Al entrar el jugador",
  T_46_META_WS_ONPLAYERJOIN: "Al unirse el jugador",
  T_46_META_WS_ONPLAYERJOINCHATCHANNELFAILURE: "Al fallar al unirse al canal de chat",
  T_46_META_WS_ONPLAYERLEAVE: "Al salir el jugador",
  T_46_META_WS_ONPLAYERPURCHASEREQUEST: "Al solicitar una compra el jugador",
  T_46_META_WS_ONPLAYERQUIT: "Al salir el jugador a mitad de partida",
  T_46_META_WS_ONPLAYERRANKCHANGE: "Al cambiar el rango del jugador",
  T_46_META_WS_ONPLAYERREQUESTFORPURCHASEFULFILLED: "Al cumplirse la solicitud de compra del jugador",
  T_46_META_WS_ONPLAYERREVIVED: "Al ser revivido el jugador",
  T_46_META_WS_ONPLAYERREVIVEDINSPAWNPOS: "Al revivir al jugador en el punto de aparición",
  T_46_META_WS_ONPLAYERSCORECHANGE: "Al cambiar la puntuación del jugador",
  T_46_META_WS_ONPLAYERSWITCHSCENE: "Al cambiar de escena el jugador",
  T_46_META_WS_ONPREDEALDAMAGE: "Antes de causar daño",
  T_46_META_WS_ONPREPURCHASE: "Antes de comprar",
  T_46_META_WS_ONPRESSED: "Al presionar",
  T_46_META_WS_ONPRETAKEDAMAGE: "Antes de recibir daño",
  T_46_META_WS_ONPURCHASE: "Al comprar",
  T_46_META_WS_ONRANKCHANGED: "Al cambiar el rango de la entidad",
  T_46_META_WS_ONRECONNECT: "Al reconectarse",
  T_46_META_WS_ONRELEASED: "Al soltar",
  T_46_META_WS_ONRELOAD: "Al recargar",
  T_46_META_WS_ONRESUME: "Al reanudar",
  T_46_META_WS_ONREVIVED: "Al ser revivido",
  T_46_META_WS_ONROUNDEND: "Al terminar la ronda",
  T_46_META_WS_ONROUNDSTART: "Al comenzar la ronda",
  T_46_META_WS_ONSCENELOAD: "Al cargar la escena",
  T_46_META_WS_ONSCENESWITCH: "Al cambiar la escena",
  T_46_META_WS_ONSCORECHANGE: "Al cambiar la puntuación de la entidad",
  T_46_META_WS_ONSHOTBYFOOTBALLSHOOTER: "Al ser disparado por el lanzador de fútbol",
  T_46_META_WS_ONSLEEP: "Al dormir",
  T_46_META_WS_ONSPAWN: "Al aparecer",
  T_46_META_WS_ONSPRAY: "Al rociar",
  T_46_META_WS_ONSPRAYED: "Al ser rociado",
  T_46_META_WS_ONSPRINT: "Al correr rápido",
  T_46_META_WS_ONSPRINTSTOP: "Al dejar de correr rápido",
  T_46_META_WS_ONSTANDUP: "Al ponerse de pie",
  T_46_META_WS_ONSTART: "Al comenzar",
  T_46_META_WS_ONSTARTFIRE: "Al atacar",
  T_46_META_WS_ONSTATEEND: "Al terminar el estado",
  T_46_META_WS_ONSURFING: "Al surfear",
  T_46_META_WS_ONSURFINGSTOP: "Al dejar de surfear",
  T_46_META_WS_ONSWITCHHANDHELD: "Al cambiar de dispositivo portátil",
  T_46_META_WS_ONTAKEDAMAGE: "Al recibir daño",
  T_46_META_WS_ONTAPPED: "Al tocar",
  T_46_META_WS_ONTEAMACE: "Al eliminarse completamente el equipo",
  T_46_META_WS_ONTEAMADD: "Al agregar el equipo",
  T_46_META_WS_ONTEAMREMOVE: "Al eliminar el equipo",
  T_46_META_WS_ONTEAMROUNDRANKCHANGE: "Al cambiar el rango del equipo en la ronda",
  T_46_META_WS_ONTEAMSCORECHANGE: "Al cambiar la puntuación del equipo",
  T_46_META_WS_ONTELEPORTENTITY: "Al teletransportar la entidad",
  T_46_META_WS_ONTEXTCHANGE: "Al cambiar el texto",
  T_46_META_WS_ONTHROWABLEEXPLODE: "Al explotar el objeto lanzable",
  T_46_META_WS_ONTOGGLE: "Al alternar",
  T_46_META_WS_ONTOUCHDOWN: "Al tocar abajo",
  T_46_META_WS_ONTOUCHUP: "Al tocar arriba",
  T_46_META_WS_ONUIHIDE: "Al ocultar la UI",
  T_46_META_WS_ONUISHOW: "Al mostrar la UI",
  T_46_META_WS_ONUPDATE: "Al actualizar",
  T_46_META_WS_ONUSEAVATARSKILL: "Al usar la habilidad del avatar",
  T_46_META_WS_ONUSECONSUMABLE: "Al usar consumible",
  T_46_META_WS_ONUSED: "Al usar",
  T_46_META_WS_ONUSEPORTAL: "Al usar el portal",
  T_46_META_WS_ONWAKEUP: "Al despertar",
  T_46_META_WS_ONWEAPONBEEQUIPED: "Al equipar el arma",
  T_46_META_WS_ONWEAPONDEALDAMAGE: "Al causar daño con el arma",
  T_46_META_WS_ONWEAPONELIMINATE: "Al eliminar con el arma",
  T_46_META_WS_ONWEAPONSTOPFIRING: "Al dejar de disparar el arma",
  T_46_META_WS_OWNER: "Propietario",
  T_46_META_WS_P_ACCELERATE: "Aceleración",
  T_46_META_WS_P_ACCELERATION: "Aceleración",
  T_46_META_WS_P_ACCOUNTID: "ID de Cuenta",
  T_46_META_WS_P_ACCURACY: "Precisión",
  T_46_META_WS_P_ACTIONTYPE: "Tipo de Acción",
  T_46_META_WS_P_ACTIVATEDALPHA: "Alfa Activado",
  T_46_META_WS_P_ACTIVE: "Activo",
  T_46_META_WS_P_ACTIVEINHIERARCHY: "Activo en la jerarquía",
  T_46_META_WS_P_ACTIVESELF: "Activo",
  T_46_META_WS_P_ACTIVETEXT: "Texto Activo",
  T_46_META_WS_P_ACTUALPOSITION: "Posición Actual",
  T_46_META_WS_P_AFTERACCUMULATOR: "Acumulador Posterior",
  T_46_META_WS_P_AIMASSISTCENTEROFFSET: "Desplazamiento del Centro de Asistencia de Apuntar",
  T_46_META_WS_P_AIMASSISTDISTANCE: "Distancia de Asistencia de Apuntar",
  T_46_META_WS_P_AIMASSISTTYPE: "Asistencia para apuntar",
  T_46_META_WS_P_AIRDROPSTATE: "Estado de Caída Aérea",
  T_46_META_WS_P_ALIGNMENTHORIZONTAL: "Alineación Horizontal",
  T_46_META_WS_P_ALIGNMENTVERTICAL: "Alineación Vertical",
  T_46_META_WS_P_ALLITEMS: "Todos los Artículos",
  T_46_META_WS_P_ALLMEMBERS: "Todos los Miembros",
  T_46_META_WS_P_ALLOWLOCKBYAIMASSIST: "Permitir bloqueo por ayuda de apuntado",
  T_46_META_WS_P_ALLOWPRESSEDOUTSIDE: "Permitir Presionado Fuera",
  T_46_META_WS_P_ALLPLAYERS: "Todos los Jugadores",
  T_46_META_WS_P_ALLTEAMMATES: "Todos los compañeros",
  T_46_META_WS_P_ALPHA: "Alfa",
  T_46_META_WS_P_ALWAYSSHOWMARK: "Siempre Mostrar Marca",
  T_46_META_WS_P_AMBIENTCOLOR: "Color Ambiental",
  T_46_META_WS_P_AMMOCLIPSIZE: "Tamaño del cargador",
  T_46_META_WS_P_AMMOMAGSIZE: "Tamaño del Cargador de Municiones",
  T_46_META_WS_P_AMMOPERSHOT: "Munición por Disparo",
  T_46_META_WS_P_AMMOTYPE: "Tipo de Munición",
  T_46_META_WS_P_ANCHORMAX: "Anclaje Máximo",
  T_46_META_WS_P_ANCHORMIN: "Anclaje Mínimo",
  T_46_META_WS_P_ANCHOROBJECT: "Objeto ancla",
  T_46_META_WS_P_ANCHORPOSITION: "Posición de Anclaje",
  T_46_META_WS_P_ANCHORTYPE: "Habilitar UITweener",
  T_46_META_WS_P_ANGLE: "Ángulo",
  T_46_META_WS_P_ANGLEDOWN: "Ángulo Abajo",
  T_46_META_WS_P_ANGLEUP: "Ángulo Arriba",
  T_46_META_WS_P_ANGULARDRAG: "Arrastre Angular",
  T_46_META_WS_P_ANGULARSPEED: "Velocidad Angular",
  T_46_META_WS_P_ANGULARVELOCITY: "Velocidad Angular (rad/s)",
  T_46_META_WS_P_ANIMATIONCLIP: "Nombre de la Animación",
  T_46_META_WS_P_ANIMATIONCONTROLLER: "Controlador de Animación",
  T_46_META_WS_P_ANIMATIONCONTROLLERRESID: "ID Recurso Controlador de Animación",
  T_46_META_WS_P_ARMORPENETRATION: "Penetración de Armadura",
  T_46_META_WS_P_ARMORPENETRATIONFACTOR: "Factor de Penetración de Armadura",
  T_46_META_WS_P_ARMORTYPE: "Tipo de Armadura",
  T_46_META_WS_P_ARROWOFFSET: "Desplazamiento de Flecha",
  T_46_META_WS_P_ARROWSIZE: "Tamaño de Flecha",
  T_46_META_WS_P_ARROWSPRITE: "Sprite de Flecha",
  T_46_META_WS_P_ASKBUYTARGET: "Solicitud de compra de objetivo",
  T_46_META_WS_P_ATTACHTARGET: "Objetivo Adjunto",
  T_46_META_WS_P_ATTACKABLEFACTIONS: "Facciones atacables",
  T_46_META_WS_P_ATTACKDAMAGE: "Daño de Ataque",
  T_46_META_WS_P_ATTACKINTERVAL: "Intervalo de Ataque",
  T_46_META_WS_P_ATTACKRANGE: "Rango de Ataque",
  T_46_META_WS_P_ATTACKTARGET: "Objetivo de Ataque",
  T_46_META_WS_P_ATTTACKABLETARGETS: "Objetivos atacables",
  T_46_META_WS_P_AUTOPLAY: "Estado de reproducción automática",
  T_46_META_WS_P_AVAILABLEPOINT: "Punto Disponible",
  T_46_META_WS_P_AVATAR: "Avatar",
  T_46_META_WS_P_AVATARID: "ID de Avatar",
  T_46_META_WS_P_BACKGROUND: "Fondo",
  T_46_META_WS_P_BACKGROUNDALPHA: "Alfa de Fondo",
  T_46_META_WS_P_BACKGROUNDCOLOR: "Color de Fondo",
  T_46_META_WS_P_BACKGROUNDCOLOR1: "Color de Fondo 1",
  T_46_META_WS_P_BACKGROUNDCOLOR2: "Color de Fondo 2",
  T_46_META_WS_P_BACKGROUNDFILL: "Relleno de Fondo",
  T_46_META_WS_P_BACKGROUNDICONNAME: "Nombre del Icono de Fondo",
  T_46_META_WS_P_BACKGROUNDNAME: "Nombre de Fondo",
  T_46_META_WS_P_BACKGROUNDOFFSET: "Desplazamiento de Fondo",
  T_46_META_WS_P_BACKGROUNDRADIUS: "Radio de Fondo",
  T_46_META_WS_P_BACKGROUNDSIZEDELTA: "Delta de Tamaño de Fondo",
  T_46_META_WS_P_BACKGROUNDSPRITE: "Sprite de Fondo",
  T_46_META_WS_P_BACKPACK: "Mochila",
  T_46_META_WS_P_BACKPACKSKINID: "ID de piel de mochila",
  T_46_META_WS_P_BACKWARDSPEED: "Velocidad Atrás",
  T_46_META_WS_P_BANNERID: "ID de Banner",
  T_46_META_WS_P_BASEHORIZONTALSPEED: "Velocidad Horizontal Base",
  T_46_META_WS_P_BASEMULTIPLIER: "Multiplicador Base",
  T_46_META_WS_P_BASETIME: "Tiempo Base",
  T_46_META_WS_P_BASEVERTICALSPEED: "Velocidad Vertical Base",
  T_46_META_WS_P_BEFOREACCUMULATOR: "Acumulador Anterior",
  T_46_META_WS_P_BEVTREEID: "ID del árbol de comportamiento",
  T_46_META_WS_P_BINDPROPERTYID: "ID de Propiedad Vinculada",
  T_46_META_WS_P_BODY: "Torso",
  T_46_META_WS_P_BODYDAMAGEFACTOR: "Factor de daño corporal",
  T_46_META_WS_P_BONEPOSITION: "Posición de los huesos",
  T_46_META_WS_P_BONESCALE: "Escalado de huesos",
  T_46_META_WS_P_BOOSTCD: "CD de Impulso",
  T_46_META_WS_P_BOOSTDURATION: "Duración del Impulso",
  T_46_META_WS_P_BOOSTSPEED: "Velocidad de Impulso",
  T_46_META_WS_P_BORDERLR: "Borde Izquierdo Derecho",
  T_46_META_WS_P_BORDERTB: "Borde Superior Inferior",
  T_46_META_WS_P_BOTTOMALPHA: "Alfa Inferior",
  T_46_META_WS_P_BOUNDWALLET: "Tipo de Anclaje HUD",
  T_46_META_WS_P_BRAKEHORSEPOWER: "Caballos de Fuerza de Freno",
  T_46_META_WS_P_BRAKETORQUE: "Torque de Freno",
  T_46_META_WS_P_BRRANK: "Rango BR",
  T_46_META_WS_P_BUFFTYPE: "Tipo de Buff",
  T_46_META_WS_P_BURNDAMAGE: "Daño por Quema",
  T_46_META_WS_P_BURNINGDAMAGEINTERVAL: "Intervalo de Daño por Quema",
  T_46_META_WS_P_BURNTIME: "Tiempo de Quema",
  T_46_META_WS_P_BUTTOM: "Parte inferior",
  T_46_META_WS_P_BUTTONCOLORS: "Colores de Botones",
  T_46_META_WS_P_BUTTONNAMES: "Nombres de Botones",
  T_46_META_WS_P_BUTTONSTYLE: "Estilo de botón",
  T_46_META_WS_P_CAMERABLOCKMODE: "Modo de Bloqueo de la Cámara",
  T_46_META_WS_P_CAMERAPROJECTIONMODE: "Modo de Proyección de la Cámara",
  T_46_META_WS_P_CAMERATYPE: "Cámara",
  T_46_META_WS_P_CANCELDRAGIFFITS: "Cancelar Arrastre si Ajusta",
  T_46_META_WS_P_CANCOSTDURABILITY: "Puede costar durabilidad",
  T_46_META_WS_P_CANDAMAGED: "Puede Ser Dañado",
  T_46_META_WS_P_CANDESTROY: "Puede ser destruido",
  T_46_META_WS_P_CANDESTROYED: "Puede Ser Destruido",
  T_46_META_WS_P_CANSELFTRIGGER: "Puede ser activado por uno mismo",
  T_46_META_WS_P_CANTEAMTRIGGER: "Puede ser activado por el equipo",
  "T_46_META_WS_P_CANTRIGGEREDBY SELF": "Puede ser activado por sí mismo",
  "T_46_META_WS_P_CANTRIGGEREDBY TEAM": "Puede ser activado por el equipo",
  "T_46_META_WS_P_CANTRIGGEREDBY VEHICLE": "Puede ser activado por un vehículo",
  T_46_META_WS_P_CANVEHICLETRIGGER: "Puede ser activado por un vehículo",
  T_46_META_WS_P_CELLSIZE: "Tamaño de Celda",
  T_46_META_WS_P_CELLSPACE: "Espacio de Celda",
  T_46_META_WS_P_CENTER: "Centro",
  T_46_META_WS_P_CENTERINVISIBLE: "Centro Invisible",
  T_46_META_WS_P_CENTEROFFSET: "Desplazamiento del Centro",
  T_46_META_WS_P_CENTEROFMASS: "Centro de Masa",
  T_46_META_WS_P_CENTERRANGE: "Rango Central",
  T_46_META_WS_P_CENTRALFLASHTIME: "Tiempo de Destello en los Bordes",
  T_46_META_WS_P_CENTRALLINEACTIVE: "Línea Central Activa",
  T_46_META_WS_P_CENTRALLINEPOSITION: "Posición de la Línea Central",
  T_46_META_WS_P_CHANNELID: "ID del Canal de Chat",
  T_46_META_WS_P_CHARGEMAX: "Carga máxima",
  T_46_META_WS_P_CHASETARGET: "Objetivo de Persecución",
  T_46_META_WS_P_CHATCHANNEL: "Canal de chat",
  T_46_META_WS_P_CHECKPOINTID: "ID de Punto de Control",
  T_46_META_WS_P_CHILDINDEX: "Índice de Hijo",
  T_46_META_WS_P_CHIPEXP: "Experiencia por chip",
  T_46_META_WS_P_CLICKSIZE: "Tamaño del clic",
  T_46_META_WS_P_CLIPLENGTH: "Duración del Clip",
  T_46_META_WS_P_CLIPPINGTYPE: "Tipo de Recorte",
  T_46_META_WS_P_COLLIDERID: "ID del Collider",
  T_46_META_WS_P_CONSTRAIN: "Restricción",
  T_46_META_WS_P_CONSTRAINT: "Restricción",
  T_46_META_WS_P_CONSTRAINTCOUNT: "Cantidad de Restricciones",
  T_46_META_WS_P_CONSUMABLETYPE: "Tipo de Consumible",
  T_46_META_WS_P_CONTENT: "Contenido",
  T_46_META_WS_P_CONTENTORIGIN: "Origen del Contenido",
  T_46_META_WS_P_CONTROLPOINTS: "Puntos de Control",
  T_46_META_WS_P_COORDINATESYSTEM: "Sistema de Coordenadas",
  T_46_META_WS_P_COUNT: "Conteo",
  T_46_META_WS_P_COUNTDOWNENDTIME: "Tiempo de Finalización de la Cuenta Regresiva (s)",
  T_46_META_WS_P_COUNTDOWNKEY: "Clave de Cuenta Regresiva",
  T_46_META_WS_P_COUNTDOWNTIME: "Tiempo de Cuenta Regresiva",
  T_46_META_WS_P_COUNTPERWAVE: "Cantidad por Ola",
  T_46_META_WS_P_CRASHMAXDAMAGE: "Daño Máximo por Choque",
  T_46_META_WS_P_CRASHMAXSPEED: "Velocidad Máxima de Choque",
  T_46_META_WS_P_CRASHMESSFACTOR: "Factor de Calidad de Choque",
  T_46_META_WS_P_CRASHMINDAMAGE: "Daño Mínimo por Choque",
  T_46_META_WS_P_CRAWLSPEEDSCALE: "Escala de velocidad de movimiento al arrastrarse",
  T_46_META_WS_P_CREATEDENTITY: "Entidad Creada",
  T_46_META_WS_P_CROUCHWALKSPEEDSCALE: "Escala de velocidad de movimiento al agacharse",
  T_46_META_WS_P_CSRANK: "Rango CS",
  "T_46_META_WS_P_CURRENT AMMO": "Munición Actual",
  T_46_META_WS_P_CURRENTANIMATIONRESOURCE: "Recurso de animación actual",
  T_46_META_WS_P_CURRENTCLIP: "Clip Actual",
  T_46_META_WS_P_CURRENTCLIPPROGRESS: "Progreso del Clip Actual",
  T_46_META_WS_P_CURRENTDURABILITY: "Durabilidad Actual",
  T_46_META_WS_P_CURRENTENERGY: "Energía Actual",
  T_46_META_WS_P_CURRENTHANDHELDITEM: "Elemento en mano actual",
  T_46_META_WS_P_CURRENTHP: "HP Actual",
  T_46_META_WS_P_CURRENTPHASEINDEX: "Índice de Fase Actual",
  T_46_META_WS_P_CURRENTPROGRESS: "Progreso Actual",
  T_46_META_WS_P_CURRENTROUNDINDEX: "Índice de Ronda Actual",
  T_46_META_WS_P_CURRENTSTATE: "Estado Actual",
  T_46_META_WS_P_CURRENTVALUE: "Valor Actual",
  T_46_META_WS_P_CURRENTWAVE: "Ola Actual",
  T_46_META_WS_P_CUSTOMCHARACTERRESOURCE: "Recurso de personaje personalizado",
  T_46_META_WS_P_CUSTOMGAMERESULT: "Resultado del juego personalizado",
  T_46_META_WS_P_CUSTOMGRAVITY: "Gravedad Personalizada",
  T_46_META_WS_P_CUSTOMPUSHFORCE: "Fuerza de Empuje Personalizada",
  T_46_META_WS_P_CUSTOMXY: "XY Personalizado",
  T_46_META_WS_P_DAMAGE: "Daño",
  "T_46_META_WS_P_DAMAGE RANGE": "Rango",
  T_46_META_WS_P_DAMAGEFACTOR: "Factor de Daño",
  T_46_META_WS_P_DAMAGEINTERVAL: "Intervalo de daño (s)",
  T_46_META_WS_P_DAMAGERADIUS: "Radio de Daño",
  T_46_META_WS_P_DAMAGERATIOHEAD: "Relación de daño a la cabeza",
  T_46_META_WS_P_DAMAGERATIOLIMB: "Relación de daño a extremidades",
  T_46_META_WS_P_DAMAGEREDUCTIONFACTOR: "Factor de Reducción de Daño",
  T_46_META_WS_P_DAMAGETAKENPCT: "Porcentaje de daño recibido",
  T_46_META_WS_P_DAMAGETAKENPERCENT: "Porcentaje de daño recibido",
  T_46_META_WS_P_DAMAGEVALUE: "Valor de Daño",
  T_46_META_WS_P_DARKNESS: "Oscuridad",
  T_46_META_WS_P_DECELERATIONPERCENT: "Porcentaje de desaceleración",
  T_46_META_WS_P_DEFAULTTEXT: "Texto Predeterminado",
  T_46_META_WS_P_DEFENSE: "Tasa de Defensa",
  T_46_META_WS_P_DEFENSERATE: "Tasa de defensa",
  T_46_META_WS_P_DELTA: "Delta",
  T_46_META_WS_P_DELTATIME: "Tiempo Delta",
  T_46_META_WS_P_DELTAVALUE: "Valor Delta",
  T_46_META_WS_P_DEPTH: "Profundidad",
  T_46_META_WS_P_DESC: "Descripción",
  T_46_META_WS_P_DESCRIPTION: "Descripción",
  T_46_META_WS_P_DESCRIPTIONKEY: "Clave de Descripción",
  T_46_META_WS_P_DESCRIPTIONPARAMS: "Parámetros de Descripción",
  T_46_META_WS_P_DESTVAL: "Valor de Destino",
  T_46_META_WS_P_DETECTRANGE: "Rango de Detección",
  T_46_META_WS_P_DIFFUSEALPHA: "Alfa Difusa",
  T_46_META_WS_P_DIFFUSECOLOR: "Color Difuso",
  T_46_META_WS_P_DIFFUSETEXTURE: "Textura Difusa",
  T_46_META_WS_P_DISABLECOLOR: "Color Desactivado",
  T_46_META_WS_P_DISABLEFALLDAMAGE: "Desactivar daño por caída",
  T_46_META_WS_P_DISABLEITEMDROP: "Desactivar caída de objetos",
  T_46_META_WS_P_DISABLEITEMPICKUP: "Desactivar recogida de objetos",
  T_46_META_WS_P_DISABLEMANUALCLOSING: "Deshabilitar cierre manual",
  T_46_META_WS_P_DISABLEQUICKCHAT: "Desactivar chat rápido",
  T_46_META_WS_P_DISABLERECIPROCATING: "Deshabilitar Movimiento Recíproco",
  T_46_META_WS_P_DISABLEVOICECHAT: "Desactivar chat de voz",
  T_46_META_WS_P_DISTANCE: "Distancia",
  T_46_META_WS_P_DOUBLEGUNTYPE: "Tipo de Arma Doble",
  T_46_META_WS_P_DOWNEDCRAWLSPEEDSCALE: "Escala de velocidad de movimiento al arrastrarse",
  T_46_META_WS_P_DOWNSPEED: "Velocidad Abajo",
  T_46_META_WS_P_DRAG: "Arrastre",
  T_46_META_WS_P_DRIVER: "Conductor",
  T_46_META_WS_P_DROPITEMS: "Artículos de Caída",
  T_46_META_WS_P_DURABILITY: "Durabilidad",
  T_46_META_WS_P_DURABILITYRECOVERY: "Recuperación de Durabilidad",
  T_46_META_WS_P_DURATION: "Duración",
  T_46_META_WS_P_EDGEFLASHTIME: "Interruptor de Efecto Flashbang",
  T_46_META_WS_P_EFFECTACTIVE: "Efecto Activo",
  T_46_META_WS_P_EFFECTCOLOR: "Color del Efecto",
  T_46_META_WS_P_EFFECTDURATION: "Tiempo de Activación",
  T_46_META_WS_P_EFFECTIVETIMEINTERVAL: "Intervalo de tiempo efectivo",
  T_46_META_WS_P_EFFECTRESID: "Ruta del recurso del efecto",
  T_46_META_WS_P_ENABLE: "Habilitar",
  T_46_META_WS_P_ENABLEATTACK: "Habilitar Ataque",
  T_46_META_WS_P_ENABLEBOTREVIVE: "Activar la recuperación del bot",
  T_46_META_WS_P_ENABLEDEPTHMAP: "Habilitar Mapa de Profundidad",
  T_46_META_WS_P_ENABLEDROPONDEATH: "Habilitar Caída al Morir",
  T_46_META_WS_P_ENABLELOCALIZATION: "Habilitar Localización",
  T_46_META_WS_P_ENABLEMOVEINMIDAIR: "Se Puede Mover en el Aire",
  T_46_META_WS_P_ENABLEPLAYERREVIVE: "Habilitar Revivir Jugador",
  T_46_META_WS_P_ENABLEPLAYERVIEW: "Habilitar Vista del Jugador",
  T_46_META_WS_P_ENABLEROTATEWITHGRAVITY: "Habilitar Rotación con Gravedad",
  T_46_META_WS_P_ENABLESKINATTRIBUTES: "Habilitar Atributos de la Piel",
  T_46_META_WS_P_ENABLESWINGING: "Habilitar balanceo",
  T_46_META_WS_P_ENABLETRACTION: "Habilitar tracción",
  T_46_META_WS_P_ENDPOSITION: "Posición Final",
  T_46_META_WS_P_ENDRADIUS: "Radio Final",
  T_46_META_WS_P_ENDTIME: "Tiempo de finalización (s)",
  T_46_META_WS_P_ENDTIMES: "Tiempo Final S",
  T_46_META_WS_P_ENDVALUE: "Valor Final",
  T_46_META_WS_P_ENERGY: "Energía",
  T_46_META_WS_P_ENERGYCOST: "Costo de Energía",
  T_46_META_WS_P_ENERGYRECOVERY: "Recuperación de Energía",
  T_46_META_WS_P_ENGINEHORSEPOWER: "Caballos de Fuerza del Motor",
  T_46_META_WS_P_ENGINETORQUE: "Torque del Motor",
  T_46_META_WS_P_EP: "EP",
  T_46_META_WS_P_EPMAX: "EP máximo",
  T_46_META_WS_P_EPRECOVERYAMOUNT: "Cantidad de recuperación de EP",
  T_46_META_WS_P_EVENTS: "Eventos",
  T_46_META_WS_P_EXPLODEDAMAGE: "Daño por Explosión",
  T_46_META_WS_P_EXPLODEDAMAGEREDUCTIONFACTOR: "Factor de Reducción de Daño por Explosión",
  T_46_META_WS_P_EXPLODEDELAY: "Retraso de Explosión",
  T_46_META_WS_P_EXPLODERANGE: "Rango de Explosión",
  T_46_META_WS_P_EXPLOSIONDELAY: "Tiempo de Destello Central",
  T_46_META_WS_P_EXPLOSIONRANGE: "Rango de Explosión",
  T_46_META_WS_P_EXPLOSIONTIME: "Retraso de Explosión",
  T_46_META_WS_P_EXPPERDAMAGE: "Exp por daño",
  T_46_META_WS_P_EXPPERMOVEMILE: "Exp por milla recorrida",
  T_46_META_WS_P_EXPPERSECOND: "Exp por segundo",
  T_46_META_WS_P_EXTRABACKPACKCAPACITY: "Capacidad extra de la mochila",
  T_46_META_WS_P_EXTRABAGCAPACITY: "Espacio Extra para Mochila",
  T_46_META_WS_P_EXTRAHPRATIO: "Relación de HP extra",
  T_46_META_WS_P_FACEPAINT: "Maquillaje",
  T_46_META_WS_P_FACTION: "Facción",
  T_46_META_WS_P_FALLINGDAMAGERATIO: "Proporción de Daño por Caída",
  T_46_META_WS_P_FALLSPEED: "Velocidad de Caída",
  T_46_META_WS_P_FASTAUTORELOADSPEED: "Velocidad de recarga automática",
  T_46_META_WS_P_FILEID: "ID de Archivo",
  T_46_META_WS_P_FILL: "Rellenar",
  T_46_META_WS_P_FILLAMOUNT: "Valor de Relleno",
  T_46_META_WS_P_FILLDIRECTION: "Dirección de Relleno",
  T_46_META_WS_P_FILLTYPE: "Tipo de Relleno",
  T_46_META_WS_P_FIREANGLELIMIT: "Límite de Ángulo de Fuego",
  T_46_META_WS_P_FIRETYPE: "Tipo de Fuego",
  T_46_META_WS_P_FIRSTSCOREPARAMS: "Parámetros del Primer Puntaje",
  T_46_META_WS_P_FIRSTSCORETITLE: "Título del Primer Puntaje",
  T_46_META_WS_P_FIRSTSCOREVALUE: "Valor del Primer Puntaje",
  T_46_META_WS_P_FIXEDDELTATIME: "Tiempo Delta Fijo",
  T_46_META_WS_P_FLASHBANGHITEFFECTSWITCH: "Duración del Efecto",
  T_46_META_WS_P_FLIP: "Voltear",
  T_46_META_WS_P_FLIPTYPE: "Tipo de Volteo",
  T_46_META_WS_P_FLYMAXHEIGHT: "Altura Máxima de Vuelo",
  T_46_META_WS_P_FLYSPEEDHORIZONTAL: "Velocidad de Vuelo Horizontal",
  T_46_META_WS_P_FLYSPEEDVERTICAL: "Velocidad de Vuelo Vertical",
  T_46_META_WS_P_FOGCOLOR: "Color de Niebla",
  T_46_META_WS_P_FOLLOWTARGET: "Seguir Objetivo",
  T_46_META_WS_P_FONT: "Fuente",
  T_46_META_WS_P_FONTSIZE: "Tamaño de Fuente",
  T_46_META_WS_P_FONTSTYLE: "Estilo de fuente",
  T_46_META_WS_P_FONTTYPE: "Tipo de fuente",
  T_46_META_WS_P_FORCESYNCTOCLIENT: "Forzar sincronización con el cliente",
  T_46_META_WS_P_FORWARD: "Adelante",
  T_46_META_WS_P_FORWARDSPEED: "Velocidad Adelante",
  T_46_META_WS_P_FOV: "Campo de Visión",
  T_46_META_WS_P_FREEZEDURATION: "Duración de congelación (s)",
  T_46_META_WS_P_FRIENDFACTIONS: "Facciones amigas",
  T_46_META_WS_P_FRIENDLYPLAYERS: "Jugadores amigables",
  T_46_META_WS_P_FULLDAMAGEDISTANCE: "Distancia de Daño Completo",
  T_46_META_WS_P_FUNCTIONTYPE: "Tipo de función",
  T_46_META_WS_P_GAINHPCOLOR: "Color de Ganancia de HP",
  T_46_META_WS_P_GAMEFRAMECOUNT: "Contador de fotogramas",
  T_46_META_WS_P_GAMETIMECOUNT: "Tiempo de Juego",
  T_46_META_WS_P_GEARSHIFTINGDELAY: "Retraso en el Cambio de Marcha",
  T_46_META_WS_P_GENDER: "Género",
  T_46_META_WS_P_GETONBOOSTCD: "CD para Subir al Boost",
  T_46_META_WS_P_GETONBOOSTCDSWITCH: "Interruptor de CD para Subir al Boost",
  T_46_META_WS_P_GETONSKATEBOARDCD: "CD para Subir al Skateboard",
  T_46_META_WS_P_GRADIENT: "Gradiente",
  T_46_META_WS_P_GRADIENTBOTTOM: "Gradiente Inferior",
  T_46_META_WS_P_GRADIENTTOP: "Gradiente Superior",
  T_46_META_WS_P_GRAVITY: "Gravedad",
  T_46_META_WS_P_GRENADEMAXDAMAGE: "Daño Máximo de Granada",
  T_46_META_WS_P_GRENADEMINDAMAGE: "Daño Mínimo de Granada",
  T_46_META_WS_P_GRENADERANGE: "Rango de Granada",
  T_46_META_WS_P_GROUPID: "ID del Grupo",
  T_46_META_WS_P_HEAD: "Cabeza",
  T_46_META_WS_P_HEADDAMAGEFACTOR: "Factor de daño en la cabeza",
  T_46_META_WS_P_HEADSHOTDAMAGEREDUCTION: "Reducción de daño de cabeza",
  T_46_META_WS_P_HEIGHT: "Altura",
  T_46_META_WS_P_HELMET: "Casco",
  T_46_META_WS_P_HIGHESTBRRANK: "Rango BR Más Alto",
  T_46_META_WS_P_HIGHESTCSRANK: "Rango CS Más Alto",
  T_46_META_WS_P_HIGHSHOOTANGLEMIN: "Ángulo de Elevación Mínimo",
  T_46_META_WS_P_HIGHSPEEDSTEERANGLE: "Límite de Dirección a Alta Velocidad",
  T_46_META_WS_P_HIGHSPEEDSTEERANGLEATSPEED: "Umbral de Dirección a Alta Velocidad",
  T_46_META_WS_P_HITPOINTEFFECT: "Efecto de punto de impacto",
  T_46_META_WS_P_HORIZONTALBAR: "Barra Horizontal",
  T_46_META_WS_P_HORIZONTALOFFSET: "Desplazamiento Horizontal",
  T_46_META_WS_P_HOSTILETEAMS: "Equipos hostiles",
  T_46_META_WS_P_HOSTTEAM: "Equipo anfitrión",
  T_46_META_WS_P_HP: "HP",
  T_46_META_WS_P_HPMAX: "HP Máx.",
  T_46_META_WS_P_HPRECOVERYAMOUNT: "Cantidad de recuperación de HP",
  T_46_META_WS_P_HPRECOVERYSPEED: "Velocidad de recuperación de HP (ms)",
  T_46_META_WS_P_ICON: "Icono",
  T_46_META_WS_P_ICONCOLOR: "Color del Icono",
  T_46_META_WS_P_ICONNAME: "Nombre del Icono",
  T_46_META_WS_P_ICONRESOURCE: "Recurso del Icono",
  T_46_META_WS_P_ID: "ID",
  "T_46_META_WS_P_IDAMAGE NTERVAL": "Intervalo de Daño (s)",
  T_46_META_WS_P_IDLEBRAKEINPUT: "Ratio de Freno en Reposo",
  T_46_META_WS_P_INACTIVATEDALPHA: "Alfa No Activado",
  T_46_META_WS_P_INDEX: "Índice",
  T_46_META_WS_P_INITIALMAGCOUNT: "Contador Inicial de Cargadores",
  T_46_META_WS_P_INITIALSPEED: "Velocidad Inicial",
  T_46_META_WS_P_INITIALVALUE: "Valor Inicial",
  T_46_META_WS_P_INITIALWORLDPOSITION: "Posición Inicial en el Mundo",
  T_46_META_WS_P_INSCENE: "En Escena",
  T_46_META_WS_P_INSTANCEID: "ID de instancia",
  T_46_META_WS_P_INTENSITY: "Intensidad",
  T_46_META_WS_P_INVERTFILL: "Invertir Relleno",
  T_46_META_WS_P_INVINCIBLE: "Invencible",
  "T_46_META_WS_P_IS SHOW": "Está Mostrado",
  T_46_META_WS_P_IS3D: "Es 3D",
  T_46_META_WS_P_ISACE: "¿Es ACE?",
  T_46_META_WS_P_ISACED: "¿Está Aplastado?",
  T_46_META_WS_P_ISAI: "¿Es IA?",
  T_46_META_WS_P_ISALWAYSINSCREEN: "Siempre en pantalla",
  T_46_META_WS_P_ISAPPLYSHADOW: "Aplicar Sombra",
  T_46_META_WS_P_ISATTACKABLE: "Es atacable",
  T_46_META_WS_P_ISAUTOCHASEENEMY: "Persecución automática del enemigo",
  T_46_META_WS_P_ISAUTOPLAY: "Reproducción Automática",
  T_46_META_WS_P_ISAUTOTELEPORT: "Es Teletransporte Automático",
  T_46_META_WS_P_ISBILLBOARD: "Siempre en el video",
  T_46_META_WS_P_ISBOLD: "Negrita",
  T_46_META_WS_P_ISBOTTOMCOLLIDING: "Colisión Inferior",
  T_46_META_WS_P_ISCENTERPOS: "¿Es Posición Central?",
  T_46_META_WS_P_ISCONSUMEAMMO: "Konsumo de Munición",
  T_46_META_WS_P_ISCONTINUOUS: "Es Continuo",
  T_46_META_WS_P_ISCOUNTDOWN: "¿Es Cuenta Regresiva?",
  T_46_META_WS_P_ISCURRENTANIMATIONLOOP: "La animación actual es un bucle?",
  T_46_META_WS_P_ISDEADDROP: "Soporte a la Muerte",
  T_46_META_WS_P_ISDEATHTRIGGER: "Es Disparador de Muerte",
  T_46_META_WS_P_ISDEBUG: "Habilitar Depuración de BTree",
  T_46_META_WS_P_ISDEFAULTSPAWNPOINT: "Es Punto de Aparición Predeterminado",
  T_46_META_WS_P_ISDROPONELIMINATED: "Se pierde al eliminarse",
  T_46_META_WS_P_ISEND: "¿Es el Final?",
  T_46_META_WS_P_ISFEBUTTON: "Es Botón FE",
  T_46_META_WS_P_ISGREY: "¿Es Gris?",
  T_46_META_WS_P_ISGROUNDED: "Está en el Suelo",
  T_46_META_WS_P_ISIGNOREDEPTH: "Ignorar profundidad",
  T_46_META_WS_P_ISINVINCIBLE: "Invencible",
  T_46_META_WS_P_ISITALIC: "Cursiva",
  T_46_META_WS_P_ISLASTROUND: "¿Es la Última Ronda?",
  T_46_META_WS_P_ISLOCALPOS: "¿Es Posición Local?",
  T_46_META_WS_P_ISLOOP: "¿Es Cíclico?",
  T_46_META_WS_P_ISMATCHPOINT: "¿Es Punto de Partido?",
  T_46_META_WS_P_ISMOVEABLE: "Se puede mover",
  T_46_META_WS_P_ISOCCUPIED: "Está Ocupado",
  T_46_META_WS_P_ISOPENTWEEN: "¿Está Habilitado OpenTween?",
  T_46_META_WS_P_ISPLAYING: "Está reproduciendo",
  T_46_META_WS_P_ISPURCHASABLE: "Artículos de la Tienda",
  T_46_META_WS_P_ISREVERSE: "Invertir",
  T_46_META_WS_P_ISSERVERDRIVEN: "Impulsado por el Servidor",
  T_46_META_WS_P_ISSHOW: "Mostrar",
  T_46_META_WS_P_ISSHOWHUDNAME: "Mostrar Nombre del HUD",
  T_46_META_WS_P_ISSHOWMAPINFO: "Mostrar Información del Mapa",
  T_46_META_WS_P_ISSHOWQUICKMESSAGE: "Mostrar Mensaje Rápido",
  T_46_META_WS_P_ISSHOWSCAN: "Mostrar Escaneo",
  T_46_META_WS_P_ISSHOWTAG: "Mostrar Etiqueta",
  T_46_META_WS_P_ISSIDECOLLIDING: "Colisión Lateral",
  T_46_META_WS_P_ISSILENCE: "Silenciado",
  T_46_META_WS_P_ISSINGLESHOT: "Disparo Único",
  T_46_META_WS_P_ISSKIPSTAGGERANIMATION: "Omitir animación de caída",
  T_46_META_WS_P_ISSLIDING: "Está Resbalando",
  T_46_META_WS_P_ISTOPCOLLIDING: "Colisión Superior",
  T_46_META_WS_P_ISUNDERLINE: "Subrayado",
  T_46_META_WS_P_ISVISIBLE: "Visible",
  T_46_META_WS_P_ITEMBACKGROUNDCOLORS: "Colores de Fondo de Tarjetas",
  T_46_META_WS_P_ITEMBACKGROUNDS: "Fondos de Tarjetas",
  T_46_META_WS_P_ITEMCOUNTS: "Comprable",
  T_46_META_WS_P_ITEMDESCRIPTIONS: "Descripciones de Tarjetas",
  T_46_META_WS_P_ITEMICONS: "Iconos de Tarjetas",
  T_46_META_WS_P_ITEMID: "ID del Objeto",
  T_46_META_WS_P_ITEMIDS: "IDs de objetos",
  T_46_META_WS_P_ITEMNAMES: "Nombres de Tarjetas",
  T_46_META_WS_P_ITEMPICKUPBANLIST: "Lista de artículos prohibidos",
  T_46_META_WS_P_JOYSTICKDRAGRADIUS: "Radio de Arrastre de Tapón de Joystick",
  T_46_META_WS_P_JOYSTICKIMAGE: "Imagen de Tapón de Joystick",
  T_46_META_WS_P_JOYSTICKRADIUS: "Radio de Tapón de Joystick",
  T_46_META_WS_P_JUMPCD: "CD de Salto",
  T_46_META_WS_P_JUMPHEIGHT: "Altura de Salto",
  T_46_META_WS_P_JUMPHEIGHTSCALE: "Escala de altura de salto",
  T_46_META_WS_P_KNOCKDOWNDAMAGEBONUS: "Bono de Daño por Derribar",
  T_46_META_WS_P_KNOCKDOWNSTATUS: "Estado de aturdimiento",
  T_46_META_WS_P_LABEL: "Etiqueta",
  T_46_META_WS_P_LABELCOLOR: "Color de Etiqueta",
  T_46_META_WS_P_LABELKEY: "Clave de Etiqueta",
  T_46_META_WS_P_LABELPARAMS: "Parámetros de Etiqueta",
  T_46_META_WS_P_LASTCHECKPOINTID: "ID actual del punto de control",
  T_46_META_WS_P_LASTSURVIVALTIME: "Último tiempo de supervivencia",
  T_46_META_WS_P_LAYERTYPE: "Tipo de capa",
  T_46_META_WS_P_LAYOUTTYPE: "Tipo de Diseño",
  T_46_META_WS_P_LEFTARM: "Brazo izquierdo",
  T_46_META_WS_P_LEFTBACKGROUNDCOLOR: "Color de Fondo Izquierdo",
  T_46_META_WS_P_LEFTCOLOR: "Color Izquierda",
  T_46_META_WS_P_LEFTDESCRIPTION: "Descripción del Equipo Izquierdo",
  T_46_META_WS_P_LEFTEFFECTACTIVE: "Efecto Izquierdo Activo",
  T_46_META_WS_P_LEFTFIRINGARCANGLE: "Ángulo de disparo a la izquierda",
  T_46_META_WS_P_LEFTFOOT: "Pie izquierdo",
  T_46_META_WS_P_LEFTHAND: "Mano izquierda",
  T_46_META_WS_P_LEFTICON: "Icono Izquierdo",
  T_46_META_WS_P_LEFTICONNAME: "Nombre del Icono Izquierdo",
  T_46_META_WS_P_LEFTLEG: "Pierna izquierda",
  T_46_META_WS_P_LEFTPLAYERS: "Jugadores Izquierdos",
  T_46_META_WS_P_LEFTSCORE: "Puntuación Izquierda",
  T_46_META_WS_P_LEFTSCOREAFTER: "Puntuación Final Izquierda",
  T_46_META_WS_P_LEFTSCORETEXT: "Puntuación Izquierda",
  T_46_META_WS_P_LEFTTEAM: "Equipo Derecho",
  T_46_META_WS_P_LEFTTEAMINDEX: "Índice del Equipo Izquierdo",
  T_46_META_WS_P_LEFTTEAMMATEALIVENUM: "Número de Jugadores Vivos Izquierdos",
  T_46_META_WS_P_LEFTTEAMMATEFLAGCOUNT: "Número de Banderas del Compañero de Equipo Izquierdo",
  T_46_META_WS_P_LEFTTEAMMATESTATES: "Estados de los Compañeros de Equipo Izquierdo",
  T_46_META_WS_P_LEFTTEAMNAME: "Nombre del Equipo Izquierdo",
  T_46_META_WS_P_LEFTTEAMSCORE: "Puntaje del Equipo Izquierdo",
  T_46_META_WS_P_LEFTTEXT: "Texto Izquierdo",
  T_46_META_WS_P_LENGTH: "Longitud",
  T_46_META_WS_P_LENSFLARE: "Resplandor de Lente",
  T_46_META_WS_P_LEVEL: "Nivel",
  T_46_META_WS_P_LIFETIME: "Tiempo de Vida (s)",
  T_46_META_WS_P_LIGHTCOLOR: "Color de Luz",
  T_46_META_WS_P_LIGHTINTENSITY: "Intensidad de Luz",
  T_46_META_WS_P_LIMBDAMAGEFACTOR: "Factor de daño en las extremidades",
  T_46_META_WS_P_LINESPACING: "Espaciado de Línea",
  T_46_META_WS_P_LOCALPOSITION: "Posición Local",
  T_46_META_WS_P_LOCALROTATION: "Rotación Local",
  T_46_META_WS_P_LOCALROTATIONQ: "Cuaternión de Rotación Local",
  T_46_META_WS_P_LOCALSCALE: "Escala Local",
  T_46_META_WS_P_LOCKEY: "Clave de Localización",
  T_46_META_WS_P_LOOPCOUNT: "Conteo de Repeticiones",
  T_46_META_WS_P_LOOTSOCCER: "Loot Soccer",
  T_46_META_WS_P_LOSEHPCOLOR: "Color de Pérdida de HP",
  T_46_META_WS_P_LOSEMVPS: "MVP de la Derrota",
  T_46_META_WS_P_LOSETEXT: "Texto de Derrota",
  "T_46_META_WS_P_MAIN CAMERA": "Cámara principal",
  T_46_META_WS_P_MAINCOLOR: "Color Principal",
  T_46_META_WS_P_MAINSCORELIST: "Puntajes Principales",
  T_46_META_WS_P_MAINSCORETITLE: "Título Principal del Puntaje",
  T_46_META_WS_P_MAINWEAPON: "Arma principal",
  T_46_META_WS_P_MAPSIZE: "Tamaño del Mapa",
  T_46_META_WS_P_MASK: "Máscara",
  T_46_META_WS_P_MASKNAME: "Nombre de Máscara",
  T_46_META_WS_P_MASS: "Masa (kg)",
  T_46_META_WS_P_MATCHTITLELEFT: "Título del Partido Izquierda",
  T_46_META_WS_P_MATCHTITLERIGHT: "Título del Partido Derecha",
  T_46_META_WS_P_MAXCAPACITY: "Capacidad Máxima",
  T_46_META_WS_P_MAXCOUNT: "Cantidad máx.",
  T_46_META_WS_P_MAXDAMAGE: "Daño Máximo",
  T_46_META_WS_P_MAXDEPRESSIONANGLE: "Ángulo máximo de depresión",
  T_46_META_WS_P_MAXDISPLACEMENT: "Desplazamiento Máx.",
  T_46_META_WS_P_MAXDISTANCE: "Distancia máxima",
  T_46_META_WS_P_MAXDURABILITY: "Durabilidad Máxima",
  T_46_META_WS_P_MAXDURABILITYRATIO: "Relación de durabilidad máxima",
  T_46_META_WS_P_MAXENERGY: "Energía Máxima",
  T_46_META_WS_P_MAXEP: "EP máximo",
  T_46_META_WS_P_MAXHP: "HP Máximo",
  T_46_META_WS_P_MAXJUMPCOUNT: "Cantidad Máxima de Saltos",
  T_46_META_WS_P_MAXJUMPHEIGHT: "Altura Máxima del Salto",
  T_46_META_WS_P_MAXLENGTH: "Longitud Máxima",
  T_46_META_WS_P_MAXPROGRESS: "Progreso Máximo",
  T_46_META_WS_P_MAXSCATTERRATIO: "Proporción máxima de dispersión",
  T_46_META_WS_P_MAXSPEED: "Velocidad Máxima",
  T_46_META_WS_P_MAXTURRETCOUNT: "Cantidad Máx. de Torres",
  T_46_META_WS_P_MAXVALUE: "Valor Máximo",
  T_46_META_WS_P_MAXWIDGETID: "ID de Widget Máximo",
  T_46_META_WS_P_MINDAMAGE: "Daño Mínimo",
  T_46_META_WS_P_MINDAMAGEDISTANCE: "Distancia Mínima de Daño",
  T_46_META_WS_P_MINDISTANCE: "Distancia mínima",
  T_46_META_WS_P_MINELEVATIONANGLE: "Ángulo mínimo de elevación",
  T_46_META_WS_P_MINENDHEIGHT: "Altura Mínima de Final",
  T_46_META_WS_P_MINFLYHEIGHT: "Altura Mínima de Vuelo",
  T_46_META_WS_P_MINMOVEDISTANCE: "Distancia Mínima de Movimiento",
  T_46_META_WS_P_MINVALUE: "Valor Mínimo",
  T_46_META_WS_P_MISSILEMAXDAMAGE: "Daño Máximo del Misil",
  T_46_META_WS_P_MISSILEMINDAMAGE: "Daño Mínimo del Misil",
  T_46_META_WS_P_MISSILERANGE: "Alcance del Misil",
  T_46_META_WS_P_MODEL: "Modelo",
  T_46_META_WS_P_MODELVISIBILITY: "Visibilidad del Modelo",
  T_46_META_WS_P_MODELVISIBLE: "Modelo Visible",
  T_46_META_WS_P_MONEY: "Dinero",
  T_46_META_WS_P_MONEYLIST: "Lista de dinero",
  T_46_META_WS_P_MONEYS: "Billetera Vinculada",
  T_46_META_WS_P_MONEYTYPE: "Tipo de Dinero",
  T_46_META_WS_P_MONSTERTYPE: "Tipo de monstruo",
  T_46_META_WS_P_MOTIONTYPE: "Tipo de Movimiento",
  T_46_META_WS_P_MOTIONVALUEX: "Valor de Movimiento X",
  T_46_META_WS_P_MOTIONVALUEY: "Valor de Movimiento Y",
  T_46_META_WS_P_MOTIONVALUEZ: "Valor de Movimiento Z",
  T_46_META_WS_P_MOVEMENTDURATION: "Duración del Movimiento",
  T_46_META_WS_P_MULTIPLIER: "Multiplicador",
  T_46_META_WS_P_MUSICELEMENTTYPE: "Tipo de Elemento Musical",
  T_46_META_WS_P_MUZZLEVELOCITY: "Velocidad de salida del cañón",
  T_46_META_WS_P_MVP: "MVP",
  T_46_META_WS_P_NAME: "Nombre",
  T_46_META_WS_P_NEXTROUNDINDEX: "Índice de la Siguiente Ronda",
  T_46_META_WS_P_NICKNAME: "Apodo",
  T_46_META_WS_P_NORMALCOLOR: "Color normal",
  T_46_META_WS_P_NORMALIZEDPOSITION: "Posición Normalizada",
  T_46_META_WS_P_NUMBERINFACTION: "Número en facción",
  T_46_META_WS_P_OBJECTID: "ID de Objeto",
  T_46_META_WS_P_OFFSET: "Desplazamiento",
  T_46_META_WS_P_OPTIONS: "Opciones",
  T_46_META_WS_P_OTHERDAMAGEFACTOR: "Otro factor de daño",
  T_46_META_WS_P_OUTFIT: "Atuendo",
  T_46_META_WS_P_OVERFLOW: "Desbordamiento",
  T_46_META_WS_P_OVERHEIGHTFALLSPEED: "Velocidad de Caída Después de Altura Máxima",
  T_46_META_WS_P_OVERLOADBYPLAYERCONFIGURATION: "Prioridad de Configuración del Jugador",
  T_46_META_WS_P_OWNER: "Propietario",
  T_46_META_WS_P_PARAMS: "Parámetros",
  T_46_META_WS_P_PARENT: "Padre",
  T_46_META_WS_P_PARENTID: "ID del Padre",
  T_46_META_WS_P_PARENTUI: "UI Padre",
  T_46_META_WS_P_PARENTWIDGETENTITYID: "ID de entidad del widget principal",
  T_46_META_WS_P_PARENTWIDGETFILEID: "ID de Archivo del Widget Padre",
  T_46_META_WS_P_PARTMASKA: "Máscara de Parte 1",
  T_46_META_WS_P_PASSENGERS: "Pasajeros",
  T_46_META_WS_P_PATHID: "ID de Ruta",
  T_46_META_WS_P_PAUSEEVENT: "Pausar Evento",
  T_46_META_WS_P_PERSONAID: "ID de Persona",
  T_46_META_WS_P_PHASEDURATION: "Duración (ms)",
  T_46_META_WS_P_PHASEENDTIME: "Tiempo de Fin (ms)",
  T_46_META_WS_P_PHYSICALLAYER: "Nivel Físico",
  T_46_META_WS_P_PINID: "ID de Pin",
  T_46_META_WS_P_PITCH: "Ángulo de Inclinación",
  T_46_META_WS_P_PIVOT: "Punto de Referencia",
  T_46_META_WS_P_PLAYER: "Jugador",
  T_46_META_WS_P_PLAYERAIMINGSPEEDFACTOR: "Factor de velocidad de apuntado del jugador",
  T_46_META_WS_P_PLAYERLIST: "Lista de Jugadores",
  T_46_META_WS_P_PLAYERNAME: "Nombre del Jugador",
  T_46_META_WS_P_PLAYERRANK: "Rango del Jugador",
  T_46_META_WS_P_PLAYERRANKS: "Rangos de Jugadores",
  T_46_META_WS_P_PLAYERS: "Jugadores",
  T_46_META_WS_P_PLAYERSCORETYPES: "Tipos de Puntaje del Jugador",
  T_46_META_WS_P_PLAYERSPEEDFACTOR: "Factor de Velocidad del Jugador",
  T_46_META_WS_P_PLAYERSPEEDFACTORWHILEFIRING: "Factor de Velocidad del Jugador Mientras Dispara",
  T_46_META_WS_P_PLAYERSTATUS: "Estado del jugador",
  T_46_META_WS_P_PLAYERTRACTIONSPEED: "Velocidad de tracción del jugador",
  T_46_META_WS_P_PLAYINGSTATUS: "Estado de reproducción",
  T_46_META_WS_P_PLAYSPEED: "Velocidad de Reproducción",
  T_46_META_WS_P_POINTPOSITION: "Posición del Punto",
  T_46_META_WS_P_POINTS: "Puntos",
  T_46_META_WS_P_POSITION: "Posición",
  T_46_META_WS_P_PREFABID: "ID de Prefabricado",
  T_46_META_WS_P_PRESSEDCOLOR: "Color Presionado",
  T_46_META_WS_P_PRESSEDSPRITE: "Sprite Presionado",
  T_46_META_WS_P_PRESSEDSPRITETYPE: "Tipo de Sprite Presionado",
  T_46_META_WS_P_PRICE: "Precio",
  T_46_META_WS_P_PRIORITY: "Prioridad",
  T_46_META_WS_P_PROFILEINFO: "Información del Perfil",
  T_46_META_WS_P_PROGRESS: "Progreso [0,1]",
  T_46_META_WS_P_PROGRESSICON: "Icono de Progreso",
  T_46_META_WS_P_PROGRESSICONNAME: "Nombre del Icono de Progreso",
  T_46_META_WS_P_PROPID: "ID de Propiedad",
  T_46_META_WS_P_PURCHASELIMIT: "Límite de Compra",
  T_46_META_WS_P_RADIUS: "Radio",
  T_46_META_WS_P_RANGE: "Rango",
  T_46_META_WS_P_RANK: "Rango",
  T_46_META_WS_P_RATIOSELFFACTOR: "Factor de daño propio",
  T_46_META_WS_P_RATIOTEAMMATEFACTOR: "Factor de daño a compañeros de equipo",
  T_46_META_WS_P_RATIOVEHICLEFACTOR: "Factor de daño a vehículos",
  T_46_META_WS_P_REFRESHTIME: "Tiempo de Actualización (s)",
  T_46_META_WS_P_RELOADSPEED: "Velocidad de recarga",
  T_46_META_WS_P_RELOADSPEEDFACTOR: "Factor de Velocidad de Recarga",
  T_46_META_WS_P_REMAINJUMPCOUNT: "Cantidad Restante de Saltos",
  T_46_META_WS_P_REMAINQUANTITY: "Cantidad Restante",
  T_46_META_WS_P_RENDERTYPE: "Tipo de renderizado",
  T_46_META_WS_P_REPEATTIMES: "Número de repeticiones",
  T_46_META_WS_P_REPLACEMENTPRIORITY: "Prioridad de reemplazo",
  T_46_META_WS_P_REQUESTEDITEMLIST: "ID del Jugador Desencadenante",
  T_46_META_WS_P_REQUESTTYPE: "Lista de Ítems Solicitados",
  T_46_META_WS_P_RESETPERROUND: "Reinicio por ronda",
  T_46_META_WS_P_RESETPOSITION: "Posición de Reinicio",
  T_46_META_WS_P_RESETTIME: "Tiempo de Reinicio",
  T_46_META_WS_P_RESOURCE: "Recursos",
  T_46_META_WS_P_RESOURCEID: "ID de Recurso",
  T_46_META_WS_P_RESTRICTWITHINPANEL: "Restringir Dentro del Panel",
  T_46_META_WS_P_RESULT: "Resultado",
  T_46_META_WS_P_RESULTTYPE: "Tipo de Resultado",
  T_46_META_WS_P_REVIVALPOINT: "Punto de resurgimiento",
  T_46_META_WS_P_REVIVECD: "Tiempo de resurrección ",
  T_46_META_WS_P_RIGHT: "Derecha",
  T_46_META_WS_P_RIGHTARM: "Brazo derecho",
  T_46_META_WS_P_RIGHTBACKGROUNDCOLOR: "Color de Fondo Derecho",
  T_46_META_WS_P_RIGHTCOLOR: "Color Derecha",
  T_46_META_WS_P_RIGHTDESCRIPTION: "Descripción del Equipo Derecho",
  T_46_META_WS_P_RIGHTEFFECTACTIVE: "Efecto Derecho Activo",
  T_46_META_WS_P_RIGHTFIRINGARCANGLE: "Ángulo de disparo a la derecha",
  T_46_META_WS_P_RIGHTFOOT: "Pie derecho",
  T_46_META_WS_P_RIGHTHAND: "Mano derecha",
  T_46_META_WS_P_RIGHTICON: "Icono Derecho",
  T_46_META_WS_P_RIGHTICONNAME: "Nombre del Icono Derecho",
  T_46_META_WS_P_RIGHTLEG: "Pierna derecha",
  T_46_META_WS_P_RIGHTPLAYERS: "Jugadores Derechos",
  T_46_META_WS_P_RIGHTSCORE: "Puntuación Derecha",
  T_46_META_WS_P_RIGHTSCOREAFTER: "Puntuación Final Derecha",
  T_46_META_WS_P_RIGHTSCORETEXT: "Puntuación Derecha",
  T_46_META_WS_P_RIGHTTEAM: "Títulos",
  T_46_META_WS_P_RIGHTTEAMINDEX: "Índice del Equipo Derecho",
  T_46_META_WS_P_RIGHTTEAMMATEALIVENUM: "Número de Jugadores Vivos Derechos",
  T_46_META_WS_P_RIGHTTEAMMATEFLAGCOUNT: "Cantidad de Banderas del Compañero Derecho",
  T_46_META_WS_P_RIGHTTEAMMATESTATES: "Estados de los Compañeros de Equipo Derecho",
  T_46_META_WS_P_RIGHTTEAMNAME: "Nombre del Equipo Derecho",
  T_46_META_WS_P_RIGHTTEAMSCORE: "Puntaje del Equipo Derecho",
  T_46_META_WS_P_RIGHTTEXT: "Texto Derecho",
  T_46_META_WS_P_RIMALPHA: "Alfa del Bisel",
  T_46_META_WS_P_RIMCOLOR: "Color del Bisel",
  T_46_META_WS_P_RIMTEXTURE: "Textura del Bisel",
  T_46_META_WS_P_ROLLINGFRICTIONCOEFF: "Coeficiente de Fricción de Rodamiento",
  T_46_META_WS_P_ROLLINGFRICTIONCOEFFRUSHING: "Coeficiente de Fricción de Rodamiento al Correr",
  T_46_META_WS_P_ROTATION: "Rotación",
  T_46_META_WS_P_ROTATIONANGLE: "Ángulo de Rotación",
  T_46_META_WS_P_ROTATIONQ: "Cuaternión de Rotación",
  T_46_META_WS_P_ROUNDINCOME: "Ingreso por Ronda",
  T_46_META_WS_P_ROUNDINCOMEDETAILNUMS: "Números de detalles de ingresos por ronda",
  T_46_META_WS_P_ROUNDINCOMEDETAILTITLES: "Títulos de detalles de ingresos por ronda",
  T_46_META_WS_P_ROUNDINCOMETITLE: "Título de Ingreso por Ronda",
  T_46_META_WS_P_ROUNDNUM: "Número de Ronda",
  T_46_META_WS_P_ROUNDNUMKEY: "Clave de Ronda",
  T_46_META_WS_P_ROUNDNUMLOCKEYPARAMS: "Parámetros de Clave de Ronda",
  T_46_META_WS_P_RUNSPEED: "Velocidad de Carrera",
  T_46_META_WS_P_RUNSPEEDSCALE: "Escala de velocidad de carrera",
  T_46_META_WS_P_RUSHDISTANCE: "Distancia de Rush",
  T_46_META_WS_P_RUSHENERGYCOST: "Costo de Energía Rush",
  T_46_META_WS_P_RUSHVERTICALSPEED: "Velocidad Vertical de Rush",
  T_46_META_WS_P_SCALE: "Escala",
  T_46_META_WS_P_SCATTERINCREASESPEED: "Velocidad de aumento de dispersión",
  T_46_META_WS_P_SCATTERMAX: "Dispersión máxima",
  T_46_META_WS_P_SCATTERMULTIPLIERWHILEMOVING: "Multiplicador de dispersión en movimiento",
  T_46_META_WS_P_SCATTERRECOVERSPEED: "Velocidad de recuperación de dispersión",
  T_46_META_WS_P_SCATTERSPEED: "Velocidad de dispersión",
  T_46_META_WS_P_SCATTERSPEEDCROUCHPRONE: "Velocidad de dispersión al agacharse o estar acostado",
  T_46_META_WS_P_SCATTERTHRESHOLD: "Umbral de dispersión",
  T_46_META_WS_P_SCOPETYPE: "Tipo de Mira",
  T_46_META_WS_P_SCORE: "Puntaje",
  T_46_META_WS_P_SCORES1: "Lista de Puntos 1",
  T_46_META_WS_P_SCORES2: "Lista de Puntos 2",
  T_46_META_WS_P_SCORES3: "Lista de Puntos 3",
  T_46_META_WS_P_SCORES4: "Lista de Puntos 4",
  T_46_META_WS_P_SCORES5: "Lista de Puntos 5",
  T_46_META_WS_P_SCORETEXTKEY: "Clave de Texto de Puntaje",
  T_46_META_WS_P_SCORETEXTKEYPARAMS: "Parámetros del Texto de Puntaje",
  T_46_META_WS_P_SCROLLCONTINUITY: "Continuidad de Desplazamiento",
  T_46_META_WS_P_SCROLLDIRECTION: "Dirección de Desplazamiento",
  T_46_META_WS_P_SCROLLEFFECT: "Efecto de Desplazamiento",
  T_46_META_WS_P_SCROLLWHEELSPEED: "Velocidad de Rueda de Desplazamiento",
  T_46_META_WS_P_SECONDSCORETITLE: "Título del Segundo Puntaje",
  T_46_META_WS_P_SECONDSCOREVALUE: "Valor del Segundo Puntaje",
  T_46_META_WS_P_SECONDSCOREVALUEPARAMS: "Parámetros del Segundo Puntaje",
  T_46_META_WS_P_SELECTEDCOLOR: "Color Seleccionado",
  T_46_META_WS_P_SELECTEDINDEX: "Índice Seleccionado",
  T_46_META_WS_P_SELECTEDSPRITE: "Sprite Seleccionado",
  T_46_META_WS_P_SELECTEDTYPE: "Tipo Seleccionado",
  T_46_META_WS_P_SELF: "Propio",
  T_46_META_WS_P_SELFDAMAGEFACTOR: "Factor de Daño Propio",
  T_46_META_WS_P_SET: "Conjunto",
  T_46_META_WS_P_SHADERNAME: "Nombre del Shader",
  T_46_META_WS_P_SHADOWCOLOR: "Color de Sombra",
  T_46_META_WS_P_SHADOWOFFSET: "Desplazamiento de Sombra",
  T_46_META_WS_P_SHADOWSTRENGTH: "Fuerza de Sombra",
  T_46_META_WS_P_SHELFS: "Desactivar Cierre Manual",
  T_46_META_WS_P_SHOES: "Zapatos",
  T_46_META_WS_P_SHOOTANGLEMAX: "Ángulo Máximo de Disparo",
  T_46_META_WS_P_SHOOTANGLEMIN: "Ángulo Mínimo de Disparo",
  T_46_META_WS_P_SHOP: "Tienda",
  T_46_META_WS_P_SHOPITEMS: "Estantes",
  T_46_META_WS_P_SHOWADDFRIEND: "Mostrar Agregar Amigo",
  T_46_META_WS_P_SHOWATTACKGRENADE: "Mostrar Granada de Ataque",
  T_46_META_WS_P_SHOWBACKGROUND: "Mostrar fondo",
  T_46_META_WS_P_SHOWCROUCH: "Mostrar Agachado",
  T_46_META_WS_P_SHOWDAMAGENUMBER: "Mostrar número de daño",
  T_46_META_WS_P_SHOWDEFENCEGRENADE: "Mostrar Granada de Defensa",
  T_46_META_WS_P_SHOWECCONOMY: "Mostrar Economía Externa",
  T_46_META_WS_P_SHOWECONOMY: "Mostrar Economía Externa",
  T_46_META_WS_P_SHOWFIRE: "Mostrar Fuego",
  T_46_META_WS_P_SHOWFRAME: "Mostrar Marco",
  T_46_META_WS_P_SHOWGIFT: "Mostrar Regalos",
  T_46_META_WS_P_SHOWHITPOINTEFFECT: "Mostrar efecto de punto de impacto",
  T_46_META_WS_P_SHOWJUMP: "Mostrar Saltando",
  T_46_META_WS_P_SHOWLIKE: "Mostrar Me Gusta",
  T_46_META_WS_P_SHOWLOBBY: "Mostrar Regresar al Vestíbulo",
  T_46_META_WS_P_SHOWMAPEVALUATE: "Mostrar Evaluación del Mapa",
  T_46_META_WS_P_SHOWMATCHDETAIL: "Mostrar Detalle del Partido",
  T_46_META_WS_P_SHOWMOVINGJOYSTICK: "Mostrar Joystick en Movimiento",
  T_46_META_WS_P_SHOWNAME: "Mostrar Apodo",
  T_46_META_WS_P_SHOWPIN: "Mostrar Pin",
  T_46_META_WS_P_SHOWPRONE: "Mostrar Reptando",
  T_46_META_WS_P_SHOWRANK: "Mostrar Rango",
  T_46_META_WS_P_SHOWREPLAY: "Mostrar Repetición",
  T_46_META_WS_P_SHOWREPORT: "Mostrar Reporte",
  T_46_META_WS_P_SHOWSHARE: "Mostrar Compartir",
  T_46_META_WS_P_SHOWSPRINT: "Mostrar Sprint",
  T_46_META_WS_P_SHOWTAG: "Mostrar Etiqueta",
  T_46_META_WS_P_SHOWTEAMMATESINFO: "Mostrar Información del Compañero",
  T_46_META_WS_P_SHOWTEAMMATESTATE: "Mostrar Estado de los Compañeros de Equipo",
  T_46_META_WS_P_SHOWTEAMSCORE: "Mostrar Puntaje del Equipo",
  T_46_META_WS_P_SHOWTIMETYPE: "Tipo de Visualización",
  T_46_META_WS_P_SHOWTWOTEAMSCORE: "Mostrar Puntaje de Dos Equipos",
  T_46_META_WS_P_SHRINKDURATION: "Duración de Reducción (ms)",
  T_46_META_WS_P_SHRINKENDTIME: "Tiempo de Reducción Final (ms)",
  T_46_META_WS_P_SHRINKSPEED: "Tasa de convergencia",
  T_46_META_WS_P_SHRINKSTARTTIME: "Tiempo de inicio de reducción (s)",
  T_46_META_WS_P_SIGHTAIMASSIST: "Permitir asistencia de apuntado en ADS",
  T_46_META_WS_P_SIGHTAIMASSISTDISTFALLOFF: "Coeficiente de atenuación de distancia de la asistencia de apuntado (0-1)",
  T_46_META_WS_P_SIGHTAIMASSISTDISTPRIOCOEF: "Coeficiente de impacto de prioridad de distancia en la asistencia de apuntado (>=1)",
  T_46_META_WS_P_SIGHTAIMASSISTDISTPRIOMAX: "Distancia máxima de prioridad de asistencia de apuntado",
  T_46_META_WS_P_SIGHTAIMASSISTDISTPRIOMIN: "Distancia mínima de prioridad de asistencia de apuntado",
  T_46_META_WS_P_SIGHTAIMASSISTDISTPRIORITY: "Permitir prioridad de distancia en la asistencia de apuntado",
  T_46_META_WS_P_SIGHTAIMASSISTSNAPRANGE: "Relación de atracción de la asistencia de apuntado en la pantalla (0-1)",
  T_46_META_WS_P_SIGHTAMPLIFYRATIO: "Relación de amplificación de la vista",
  T_46_META_WS_P_SIGHTFOVAMPLIFYRATIO: "Ampliación de FOV",
  T_46_META_WS_P_SIGHTROTSENSITIVENESS: "Sensibilidad de rotación en ADS",
  T_46_META_WS_P_SIGHTSHOOTMINDAMAGE: "Coeficiente de corrección de distancia mínima de daño en ADS",
  T_46_META_WS_P_SIGHTUIACTIONEXPAND: "Tiempo de ampliación ADS (s)",
  T_46_META_WS_P_SIGHTUIACTIONRATIO: "Ampliación ADS",
  T_46_META_WS_P_SIGHTUIACTIONRECOVERY: "Tiempo de recuperación ADS (s)",
  T_46_META_WS_P_SIZE: "Tamaño",
  T_46_META_WS_P_SIZEDELTA: "Delta de Tamaño",
  T_46_META_WS_P_SKELETON: "Esqueleto",
  T_46_META_WS_P_SKIN: "Piel",
  T_46_META_WS_P_SKINID: "ID de la skin",
  T_46_META_WS_P_SKINWIDTH: "Grosor de la Piel",
  T_46_META_WS_P_SKYBOXENV: "Caja de cielo",
  T_46_META_WS_P_SKYBOXRESOURCE: "Recurso de Cielo",
  T_46_META_WS_P_SLOPELIMIT: "Ángulo Máximo de Inclinación",
  T_46_META_WS_P_SMOOTHSCROLLSTART: "Desplazamiento Suave al Comenzar",
  T_46_META_WS_P_SOFTNESS: "Suavidad",
  T_46_META_WS_P_SORTTYPE: "Tipo de Ordenación",
  T_46_META_WS_P_SPAWNCOUNTPERWAVE: "Cantidad de Generación por Ola",
  T_46_META_WS_P_SPAWNPOINT: "Punto de aparición",
  T_46_META_WS_P_SPAWNPOINTCOUNT: "Cantidad de Puntos de Aparición",
  T_46_META_WS_P_SPAWNPOSITION: "Posición de Spawn",
  T_46_META_WS_P_SPEED: "Velocidad",
  T_46_META_WS_P_SPEEDWHILEAIMING: "Tasa de Velocidad de Movimiento al Apuntar",
  T_46_META_WS_P_SPRAYCOLOR: "Color de Pulverización",
  T_46_META_WS_P_SPRINTENERGYCOST: "Costo de Energía Sprint",
  T_46_META_WS_P_SPRINTHORIZONTALSPEED: "Velocidad Horizontal de Sprint",
  T_46_META_WS_P_SPRINTSPEEDSCALE: "Escala de velocidad de movimiento al correr",
  T_46_META_WS_P_SPRITENAME: "Forma del Sprite",
  T_46_META_WS_P_SPRITERESOURCE: "Recurso Sprite",
  T_46_META_WS_P_SRCVAL: "Valor de Origen",
  T_46_META_WS_P_STARTDROPTIME: "Tiempo de Caída Inicial (ms)",
  T_46_META_WS_P_STARTEVENT: "Iniciar Evento",
  T_46_META_WS_P_STARTPOSITION: "Posición Inicial",
  T_46_META_WS_P_STARTRADIUS: "Radio Inicial",
  T_46_META_WS_P_STARTSPAWNTIME: "Tiempo de Inicio de Aparición (s)",
  T_46_META_WS_P_STARTTIME: "Tiempo(s) de inicio",
  T_46_META_WS_P_STARTVALUE: "Valor Inicial",
  T_46_META_WS_P_STATICICONCOLORS: "Colores de Icono Estático",
  T_46_META_WS_P_STATICICONS: "Iconos Estáticos",
  T_46_META_WS_P_STATUS: "Estado de Sentry Mini",
  T_46_META_WS_P_STEPOFFSET: "Desplazamiento del Paso",
  T_46_META_WS_P_STOPDURATION: "Duración de Detención",
  T_46_META_WS_P_STOPEVENT: "Detener Evento",
  T_46_META_WS_P_STORE: "Tienda",
  T_46_META_WS_P_STROPID: "ID del Strop",
  T_46_META_WS_P_STYLE: "Estilo",
  T_46_META_WS_P_SUBTITLE: "Subtítulo",
  T_46_META_WS_P_SUMMULTIPLIER: "Acumulador de Suma",
  T_46_META_WS_P_SWINGEXITACCELERATION: "Aceleración de salida del balanceo",
  T_46_META_WS_P_SWINGINGSPEED: "Velocidad de balanceo",
  T_46_META_WS_P_TAGS: "Etiquetas",
  T_46_META_WS_P_TARGETCHECKPOINTID: "ID de punto de control objetivo",
  T_46_META_WS_P_TARGETICONCOLORS: "Colores de Icono de Objetivo",
  T_46_META_WS_P_TARGETICONS: "Iconos de Objetivo",
  T_46_META_WS_P_TARGETID: "ID de Objetivo",
  T_46_META_WS_P_TARGETITEMID: "ID del Ítem Objetivo",
  T_46_META_WS_P_TARGETROTATION: "Rotación del Objetivo",
  T_46_META_WS_P_TARGETSCALE: "Escala del Objetivo",
  T_46_META_WS_P_TEAMCOLOR: "Color del Equipo",
  T_46_META_WS_P_TEAMCOLORS: "Colores de Equipos",
  T_46_META_WS_P_TEAMINDEXS: "Índices de Equipos",
  T_46_META_WS_P_TEAMMATEDAMAGEFACTOR: "Factor de Daño de Compañero",
  T_46_META_WS_P_TEAMMEMBERNUM: "Número de miembros del equipo",
  T_46_META_WS_P_TEAMNUM: "Número de equipos",
  T_46_META_WS_P_TEAMRANK: "Rango del Equipo",
  T_46_META_WS_P_TEAMRANKDISPLAY: "Mostrar Rango del Equipo",
  T_46_META_WS_P_TEAMRANKS: "Rangos de Equipos",
  T_46_META_WS_P_TEAMSCORES: "Puntajes de Equipos",
  T_46_META_WS_P_TEAMSEQ: "Secuencia de Equipo",
  T_46_META_WS_P_TEMPLATEENTITY: "Entidad de plantilla",
  T_46_META_WS_P_TEMPORARYSHIELDPOINTS: "Puntos de escudo temporal",
  T_46_META_WS_P_TERRAINWETNESS: "Humedad del Terreno",
  T_46_META_WS_P_TEXT: "Texto",
  T_46_META_WS_P_TEXTCOLOR: "Color del Texto",
  T_46_META_WS_P_TEXTKEY: "Clave de Texto",
  T_46_META_WS_P_TEXTKEYPARAMS: "Parámetros de Clave de Texto",
  T_46_META_WS_P_TEXTURERESOURCE: "Recurso de Textura",
  T_46_META_WS_P_THEMECOLOR: "Color del Tema",
  T_46_META_WS_P_THROWABLETYPE: "Tipo de Lanzable",
  T_46_META_WS_P_THROWINGSPEED: "Velocidad de Lanzamiento",
  T_46_META_WS_P_THROWSPEED: "Velocidad de lanzamiento",
  T_46_META_WS_P_TICKINTERVAL: "Intervalo de Tick",
  T_46_META_WS_P_TIMEREQUIRED: "Tiempo requerido (ms)",
  T_46_META_WS_P_TIPSTYPE: "Tipo de Consejos",
  T_46_META_WS_P_TITLE: "Título",
  T_46_META_WS_P_TITLELIST: "Títulos",
  T_46_META_WS_P_TITLES: "Puntuaciones1",
  T_46_META_WS_P_TOP: "Parte superior",
  T_46_META_WS_P_TOPALPHA: "Alfa Superior",
  T_46_META_WS_P_TOTALHP: "HP Total",
  T_46_META_WS_P_TOTALLEVEL: "Nivel Total",
  T_46_META_WS_P_TOTALROUNDCOUNT: "Número total de rondas",
  T_46_META_WS_P_TOWSPEED: "Velocidad de remolque",
  T_46_META_WS_P_TRANSITIONSTAGE: "Etapa de Transición",
  T_46_META_WS_P_TRANSITIONTYPE: "Tipo de Transición",
  T_46_META_WS_P_TRIGGERPLAYERID: "Dinero",
  T_46_META_WS_P_TRIGGERRADIUS: "Rango del Disparador",
  T_46_META_WS_P_TRIGGERRANGE: "Rango de Disparo",
  T_46_META_WS_P_TRIGGERTIME: "Tiempo de activación",
  T_46_META_WS_P_TURNSPEED: "Velocidad de Giro",
  T_46_META_WS_P_TWEENERENABLED: "Equipo Izquierdo",
  T_46_META_WS_P_TWEENSTYLE: "Estilo de transición",
  T_46_META_WS_P_TYPE: "Tipo",
  T_46_META_WS_P_UNSELECTEDCOLOR: "Color No Seleccionado",
  T_46_META_WS_P_UNSELECTEDSPRITE: "Sprite No Seleccionado",
  T_46_META_WS_P_UNSELECTEDTYPE: "Tipo No Seleccionado",
  T_46_META_WS_P_UP: "Arriba",
  T_46_META_WS_P_UPDATETYPE: "Tipo de Actualización",
  T_46_META_WS_P_UPENERGYCOST: "Costo de Energía Ascendente",
  T_46_META_WS_P_UPSPEED: "Velocidad Arriba",
  T_46_META_WS_P_USECUSTOMPUSHFORCE: "Usar Fuerza de Empuje Personalizada",
  T_46_META_WS_P_USECUSTOMRESOURCE: "Usar Recurso Personalizado",
  T_46_META_WS_P_USEDCAPACITY: "Capacidad Usada",
  T_46_META_WS_P_USEGRAVITY: "Usar Gravedad",
  T_46_META_WS_P_USEPHYSICALCCT: "Usar CCT Físico",
  T_46_META_WS_P_USERUID: "UID del usuario",
  T_46_META_WS_P_UVOFFSET: "Desplazamiento UV",
  T_46_META_WS_P_UVSIZE: "Tamaño UV",
  T_46_META_WS_P_VALUE: "Valor",
  T_46_META_WS_P_VAULTDISTANCE: "Distancia de Vault",
  T_46_META_WS_P_VAULTHEIGHT: "Altura de Vault",
  T_46_META_WS_P_VEHICLEDAMAGEFACTOR: "Factor de Daño del Vehículo",
  T_46_META_WS_P_VEHICLESKINID: "ID de Skin del Vehículo",
  T_46_META_WS_P_VEHICLESKINIDS: "ID de piel del vehículo",
  T_46_META_WS_P_VELOCITY: "Velocidad (m/s)",
  T_46_META_WS_P_VELOCITYXZ: "Velocidad XZ",
  T_46_META_WS_P_VELOCITYY: "Velocidad Y",
  T_46_META_WS_P_VERTICALBAR: "Barra Vertical",
  T_46_META_WS_P_VERTICALOFFSET: "Desplazamiento Vertical",
  T_46_META_WS_P_VEST: "Chaleco",
  T_46_META_WS_P_VFXTEXTURETYPE: "Tipo de textura VFX",
  T_46_META_WS_P_VIEWINGANGLERESTRICTION: "Restricción de Ángulo de Visión",
  T_46_META_WS_P_VISIBILITYLAYER: "Capa de Visibilidad",
  T_46_META_WS_P_VISIBLE: "Visible",
  T_46_META_WS_P_VISIBLEONBACK: "Visible en la Espalda",
  T_46_META_WS_P_VISIBLEPLAYERS: "Jugadores Visibles",
  T_46_META_WS_P_VOLUME: "Volumen",
  T_46_META_WS_P_WALLETID: "ID de billetera",
  T_46_META_WS_P_WANDERRANGE: "Rango de Deambulación",
  T_46_META_WS_P_WAVECOUNT: "Cantidad de Olas",
  T_46_META_WS_P_WAVEINTERVAL: "Intervalo de Ola",
  T_46_META_WS_P_WEAPONDAMAGERATE: "Tasa de daño de arma",
  T_46_META_WS_P_WEAPONSKINIDS: "IDs de piel de arma",
  T_46_META_WS_P_WEAPONSUBTYPE: "Subtipo de Arma",
  T_46_META_WS_P_WEAPONTYPE: "Tipo de Arma",
  T_46_META_WS_P_WIDTH: "Ancho",
  T_46_META_WS_P_WINMVPS: "MVP de la Victoria",
  T_46_META_WS_P_WINTEXT: "Texto de Victoria",
  T_46_META_WS_P_WORDWRAP: "Ajuste de Palabras",
  T_46_META_WS_P_WORLDPOSITION: "Posición Mundial",
  T_46_META_WS_P_YAW: "Ángulo de Yaw",
  T_46_META_WS_PATROLALONG: "Patrullar a lo Largo",
  T_46_META_WS_PATROLTO: "Patrullar a",
  T_46_META_WS_PAUSE: "Pausar",
  T_46_META_WS_PAUSEEMOTE: "Pausar emote",
  T_46_META_WS_PAUSEFIXEDUPDATE: "Pausar Actualización Fija",
  T_46_META_WS_PHASE: "Fase",
  T_46_META_WS_PLAY: "Reproducir",
  T_46_META_WS_PLAYANIMATION: "Reproducir Animación",
  T_46_META_WS_PLAYCHARACTERANIMATIONCLIP: "Reproducir Clip de Animación del Personaje",
  T_46_META_WS_PLAYEMOTE: "Reproducir emote",
  T_46_META_WS_PLAYER: "Jugador",
  T_46_META_WS_PORTAL: "Portal",
  T_46_META_WS_POSE: "Postura",
  T_46_META_WS_POSITION: "Posición",
  T_46_META_WS_PREPOSE: "Postura previa ",
  T_46_META_WS_PROFANITYFILTER: "Filtro de Palabras Groseras",
  T_46_META_WS_PURSUITTARGET: "Objetivo de Persecución",
  T_46_META_WS_QUATERNIONTOAXISANGLE: "Cuaternión a Ángulo de Eje",
  T_46_META_WS_QUATERNIONTOEULERANGLE: "Cuaternión a Ángulo Euler",
  T_46_META_WS_QUITCHATCHANNEL: "Salir del Canal de Chat",
  T_46_META_WS_QUITFACTION: "Salir de Facción",
  T_46_META_WS_QUITGAME: "Salir del Juego",
  T_46_META_WS_QUITJAILBREAKMINIGAME: "Salir del Mini Juego de Escape",
  T_46_META_WS_RANDOMFLOAT: "Flotante aleatorio",
  T_46_META_WS_RANDOMINT: "Entero aleatorio",
  T_46_META_WS_RANK: "Clasificación",
  T_46_META_WS_READCSV: "Leer CSV",
  T_46_META_WS_READCSVCELL: "Leer Celda CSV",
  T_46_META_WS_READCSVCELLBYNAME: "Leer Celda CSV por Nombre",
  T_46_META_WS_READCSVCELLFROMSERVER: "Leer Celda CSV desde el Servidor",
  T_46_META_WS_READCSVCOLUMN: "Leer Columna CSV",
  T_46_META_WS_READCSVCOLUMNFROMSERVER: "Leer Columna CSV desde el Servidor",
  T_46_META_WS_READCSVFROMSERVER: "Leer CSV desde el Servidor",
  T_46_META_WS_READCSVROW: "Leer Fila CSV",
  T_46_META_WS_READCSVROWBYKEY: "Leer Fila CSV por Clave",
  T_46_META_WS_READCSVROWFROMSERVER: "Leer Fila CSV desde el Servidor",
  T_46_META_WS_READFROMACCUMULATEDDATASTORE: "Leer del Almacén de Datos Acumulados",
  T_46_META_WS_READFROMDATASTORE: "Leer del Almacén de Datos",
  T_46_META_WS_READFROMLEADBOARDDATASTORE: "Leer del Almacén de Datos de la Tabla de Clasificación",
  T_46_META_WS_READFROMLEADBOARDDATASTOREBYRANK: "Leer del Almacén de Datos de la Tabla de Clasificación por Rango",
  T_46_META_WS_REMOVEAOISPECIALFOLLOW: "Eliminar Seguimiento Especial AOI",
  T_46_META_WS_REMOVEBACKPACKSKIN: "Eliminar Skin de Mochila",
  T_46_META_WS_REMOVEBUFF: "Eliminar Buff",
  T_46_META_WS_REMOVECOMPONENT: "Eliminar Componente",
  T_46_META_WS_REMOVEFORMULAPROPERTYFACTOR: "Eliminar Factor de Propiedad de Fórmula",
  T_46_META_WS_REMOVEOUTFIT: "Eliminar Atuendo",
  T_46_META_WS_REMOVESCRIPT: "Eliminar Script",
  T_46_META_WS_REMOVEVEHICLESKIN: "Eliminar Skin del Vehículo",
  T_46_META_WS_REMOVEWEAPONSKIN: "Eliminar Skin de Arma",
  T_46_META_WS_REPLACE: "Reemplazar",
  T_46_META_WS_REQUESTMATCHMAKING: "Solicitar Emparejamiento",
  T_46_META_WS_RESET: "Restablecer",
  T_46_META_WS_RESETBACKPACKSKIN: "Restablecer Skin de Mochila",
  T_46_META_WS_RESETDYEING: "Restablecer Teñido",
  T_46_META_WS_RESETJERSEY: "Restablecer Jersey",
  T_46_META_WS_RESETOUTFIT: "Restablecer Atuendo",
  T_46_META_WS_RESETVEHICLESKIN: "Restablecer Skin del Vehículo",
  T_46_META_WS_RESETWEAPONSKIN: "Restablecer Skin de Arma",
  T_46_META_WS_RESUMEFIXEDUPDATE: "Reanudar Actualización Fija",
  T_46_META_WS_REVERSE: "Invertir",
  T_46_META_WS_REVIVALSOURCE: "Fuente de reanimación",
  T_46_META_WS_REVIVE: "Revivir",
  T_46_META_WS_ROUND: "Redondeo",
  T_46_META_WS_ROUNDINDEX: "Índice de ronda",
  T_46_META_WS_SAMPLEONCURVE: "Muestreo en Curva",
  T_46_META_WS_SCENENAME: "Nombre de la escena",
  T_46_META_WS_SCORE: "Puntuación",
  T_46_META_WS_SCORER: "Anotador",
  T_46_META_WS_SCORETYPE: "Tipo de puntuación",
  T_46_META_WS_SCREENMULTIRAYCAST: "Raycast de Múltiples Tactos en Pantalla",
  T_46_META_WS_SCREENSINGLERAYCAST: "Raycast de Tacto Único en Pantalla",
  T_46_META_WS_SCREENTOUCHRAY: "Rayo de Tacto en Pantalla",
  T_46_META_WS_SCREENTOWORLDPOINT: "Pantalla a Mundo",
  T_46_META_WS_SENDEVENT: "Enviar Evento",
  T_46_META_WS_SETACTIVE: "Establecer Activo",
  T_46_META_WS_SETALLPLAYERSMOVESTATUS: "Establecer estado de movimiento de todos los jugadores",
  T_46_META_WS_SETATTACKABLEENTITY: "Establecer Entidad Atacable",
  T_46_META_WS_SETATTACKABLEFACTION: "Establecer Facción Atacable",
  T_46_META_WS_SETATTACKABLETEAM: "Establecer Equipo Atacable",
  T_46_META_WS_SETBACKPACKSKIN: "Configurar Skin de Mochila",
  T_46_META_WS_SETBEHAVIORSTATUS: "Establecer Estado de Comportamiento",
  T_46_META_WS_SETBLACKBOARDVALUE: "Configurar Valor de Blackboard",
  T_46_META_WS_SETBUNDLE: "Establecer Paquete",
  T_46_META_WS_SETCAMERAFOCUS: "Establecer Enfoque de Cámara",
  T_46_META_WS_SETCAMERAFOLLOW: "Establecer Seguimiento de Cámara",
  T_46_META_WS_SETCHARACTER: "Establecer Personaje",
  T_46_META_WS_SETCULLINGMASK: "Configurar Máscara de Culling",
  T_46_META_WS_SETCULLINGMASKLAYER: "Configurar Capa de Máscara de Culling",
  T_46_META_WS_SETDEFAULTUISTATUS: "Configurar Estado de UI Predeterminado",
  T_46_META_WS_SETDROPSTATUS: "Establecer Estado de Descarte",
  T_46_META_WS_SETFALLINGDAMAGE: "Configurar Daño por Caída",
  T_46_META_WS_SETFOOTBALLPOSITION: "Establecer Posición del Balón",
  T_46_META_WS_SETFORMULAPROPERTYABSOLUTE: "Establecer Propiedad de Fórmula Absoluta",
  T_46_META_WS_SETFORMULAPROPERTYRELATIVE: "Establecer Propiedad de Fórmula Relativa",
  T_46_META_WS_SETFORWARD: "Establecer Orientación",
  T_46_META_WS_SETGLOBALSLEEPTHRESHOLD: "Establecer Umbral de Sueño Global",
  T_46_META_WS_SETINVINCIBILITY: "Establecer invulnerabilidad",
  T_46_META_WS_SETJERSEY: "Establecer Jersey",
  T_46_META_WS_SETOUTFIT: "Establecer Atuendo",
  T_46_META_WS_SETPARENT: "Establecer Padre",
  T_46_META_WS_SETPARENTCLIENT: "Configurar Nodo Padre",
  T_46_META_WS_SETPICKUPSTATUS: "Establecer Estado de Recogida",
  T_46_META_WS_SETPLAYERQUICKMESSAGESTATUS: "Establecer Estado de Mensaje Rápido del Jugador",
  T_46_META_WS_SETPLAYERVOICESTATUS: "Establecer Estado de Voz del Jugador",
  T_46_META_WS_SETPROPERTYSMOOTHLY: "Establecer Propiedad Suavemente",
  T_46_META_WS_SETSKILLS: "Establecer Habilidades",
  T_46_META_WS_SETSKYBOX: "Establecer skybox",
  T_46_META_WS_SETSLEEPTHRESHOLD: "Establecer Umbral de Sueño",
  T_46_META_WS_SETSPECIALITEMSTATUS: "Establecer estado del ítem especial",
  T_46_META_WS_SETVEHICLESKIN: "Configurar Skin del Vehículo",
  T_46_META_WS_SETWEAPONSKIN: "Establecer Skin de Arma",
  T_46_META_WS_SETWIDGETPARENT: "Establecer Widget Padre",
  T_46_META_WS_SHOPITEM: "Artículo de tienda",
  T_46_META_WS_SHOWAPPEARANCEGROUP: "Mostrar Grupo de Apariencia",
  T_46_META_WS_SHUFFLE: "Barajar",
  T_46_META_WS_SIN: "Sen",
  T_46_META_WS_SINGLERAYCAST: "Raycast Único",
  T_46_META_WS_SKILL: "Habilidad",
  T_46_META_WS_SLEEP: "Dormir",
  T_46_META_WS_SLERPQUATERNION: "Interpolación de Cuaternión",
  T_46_META_WS_SPAWNABLES: "Objetos generables",
  T_46_META_WS_SPAWNEDITEM: "Objeto generado",
  T_46_META_WS_SPAWNNEXTWAVE: "Generar Siguiente Ola",
  T_46_META_WS_SPHERECAST: "Sphere Cast",
  T_46_META_WS_SPHEREOVERLAP: "Sphere Overlap",
  T_46_META_WS_SPLIT: "Dividir",
  T_46_META_WS_SQRT: "Raíz cuadrada",
  T_46_META_WS_STARTPARACHUTE: "Iniciar Paracaídas",
  T_46_META_WS_STARTPOSITION: "Posición inicial",
  T_46_META_WS_STATENAME: "Nombre del estado",
  T_46_META_WS_STATUS: "Estado",
  T_46_META_WS_STRINGTOFLOAT: "Cadena a Flotante",
  T_46_META_WS_STRINGTOINT: "Cadena a Entero",
  T_46_META_WS_STRIP: "Eliminar",
  T_46_META_WS_SUB: "Restar",
  T_46_META_WS_SWITCHAOIPROXYOBSERVER: "Cambiar Observador de Proxy AOI",
  T_46_META_WS_SWITCHAPPEARANCEGROUP: "Cambiar Grupo de Apariencia",
  T_46_META_WS_SWITCHAREA: "Cambiar Área",
  T_46_META_WS_SWITCHCAMERA: "Cambiar Cámara",
  T_46_META_WS_SWITCHPHASE: "Cambiar fase",
  T_46_META_WS_SWITCHSCENE: "Cambiar Escena",
  T_46_META_WS_SWITCHWEAPON: "Cambiar Arma",
  T_46_META_WS_TAN: "Tan",
  T_46_META_WS_TARGET: "Objetivo",
  T_46_META_WS_TEAM: "Equipo",
  T_46_META_WS_TELEPORT: "Teletransportar",
  T_46_META_WS_TELEPORTCCT: "Teletransportar CCT",
  T_46_META_WS_TEXT: "Texto",
  "T_46_META_WS_TIMESTAMPTO LOCALSTRING": "Timestamp a Cadena de Localización",
  T_46_META_WS_TIRE: "Neumático",
  T_46_META_WS_TOLOWER: "Convertir a Minúsculas",
  T_46_META_WS_TOSTRING: "A String",
  T_46_META_WS_TOUPPER: "Convertir a Mayúsculas",
  T_46_META_WS_TRANSFERMONEY: "Transferir Dinero",
  T_46_META_WS_TRIGGER: "Disparador",
  T_46_META_WS_TYPEIS: "Tipo Es",
  T_46_META_WS_UNLOADSCENE: "Descargar Escena",
  T_46_META_WS_UPDATEJAILBREAKMISSION: "Actualizar Misión de Escape",
  T_46_META_WS_UPLOADGAMERESULT: "Subir Resultado del Juego",
  T_46_META_WS_VALUE: "Daño",
  T_46_META_WS_VECTOR2ANGLE: "Ángulo vectorial 2D",
  T_46_META_WS_VECTOR2DISTANCE: "Distancia vectorial 2D",
  T_46_META_WS_VECTOR2DOT: "Producto punto 2D",
  T_46_META_WS_VECTOR2MAGNITUDE: "Magnitud vectorial 2D",
  T_46_META_WS_VECTOR2NORMALIZE: "Normalizar vector 2D",
  T_46_META_WS_VECTOR2REFLECT: "Reflexión vectorial 2D",
  T_46_META_WS_VECTOR2TOVECTOR3: "Vector2 a Vector3",
  T_46_META_WS_VECTOR3REFLECT: "Reflexión vectorial 3D",
  T_46_META_WS_VECTOR3TOVECTOR2: "Vector3 a Vector2",
  T_46_META_WS_VEHICLE: "Vehículo",
  T_46_META_WS_VELOCITY: "Velocidad",
  T_46_META_WS_WAITFORMILESECOND: "Esperar milisegundos",
  T_46_META_WS_WAITFORNEXTFRAME: "Esperar al siguiente fotograma",
  T_46_META_WS_WAKEUP: "Despertar",
  T_46_META_WS_WAVES: "Olas",
  T_46_META_WS_WEAPON: "Arma",
  T_46_META_WS_WORLDTOSCREENPOINT: "Mundo a Pantalla",
  T_46_META_WS_WRITETOACCUMULATEDDATASTORE: "Escribir en el Almacén de Datos Acumulados",
  T_46_META_WS_WRITETODATASTORE: "Escribir en el Almacén de Datos",
  T_46_META_WS_WRITETOLEADBOARDDATASTORE: "Escribir en el Almacén de Datos de la Tabla de Clasificación",
  T_48_META_API_1_D: "Obtiene todos los jugadores de la partida actual y devuelve una lista de jugadores.",
  T_48_META_API_1_R_D: "Lista de jugadores",
  T_48_META_API_10_D: "Obtención de objetos de escena",
  T_48_META_API_10_P0_D: "Qué tipos de objetos de escena filtrar",
  T_48_META_API_10_R_D: "Lista de objetos de la escena",
  T_48_META_API_100_D: "Cargar escenarios sin descargar automáticamente los ya cargados",
  T_48_META_API_100_P0_D: "ID de la escena a cargar",
  T_48_META_API_10000_D: "Devuelve la entidad a la que está vinculado el script actual",
  T_48_META_API_10000_R_D: "La entidad a la que está vinculado el script actual",
  T_48_META_API_10001_D: "Utiliza el ID de la entidad para encontrar la entidad correspondiente, esta API es sólo para editores, el uso de esta API por parte del usuario no garantiza su compatibilidad, como eliminar o ajustar el",
  T_48_META_API_10001_P0_D: "ID de la entidad de destino",
  T_48_META_API_10001_R_D: "cosa que tiene una existencia material (por oposición a una existencia conceptual, virtual o en línea)",
  T_48_META_API_10002_D: "Obtener la entidad global para el juego",
  T_48_META_API_10002_R_D: "entidad global",
  T_48_META_API_10003_D: "Teletransporta a los jugadores a coordenadas específicas (obsoleto, usa Teletransportar)",
  T_48_META_API_10003_P0_D: "Jugadores teletransportados",
  T_48_META_API_10003_P1_D: "Coordenadas del punto transportado",
  T_48_META_API_10004_D: "Obtiene la posición cerca de los compañeros de equipo, eludirá la posición de los jugadores que no pueden estar de pie (obsoleto, utilice GetTeammateNearPosition)",
  T_48_META_API_10004_P0_D: "jugador objetivo",
  T_48_META_API_10004_R_D: "Coordenadas cerca de los compañeros de equipo",
  T_48_META_API_10005_D: "Jugadores pertenecientes a la entidad adquirente",
  T_48_META_API_10005_P0_D: "Entidad de destino, la entidad sólo se sincronizará con el reproductor al que pertenezca",
  T_48_META_API_10005_R_D: "Jugadores pertenecientes a la entidad objetivo",
  T_48_META_API_10006_D: "Hacer invencible al jugador",
  T_48_META_API_10006_P0_D: "jugador objetivo",
  T_48_META_API_10006_P1_D: "Duración del efecto de invulnerabilidad, en segundos",
  T_48_META_API_10007_D: "Clonar la entidad seleccionada y todas sus propiedades en la posición original",
  T_48_META_API_10007_P0_D: "Entidades creadas",
  T_48_META_API_10007_P1_D: "entidad a clonar",
  T_48_META_API_10008_D: "Infligir daño al jugador, si no se selecciona ninguna fuente de daño, el objetivo recibe daño del sistema.",
  T_48_META_API_10008_P0_D: "Entidades de juego perjudicadas",
  T_48_META_API_10008_P1_D: "Entidades de juego que causan daños",
  T_48_META_API_10008_P2_D: "Tipo de daño",
  T_48_META_API_10008_P3_D: "cantidad de daños",
  T_48_META_API_10009_D: "Resucitar a un jugador designado",
  T_48_META_API_10009_P0_D: "Jugadores resucitados",
  T_48_META_API_1001_D: "Si se cumple la condición, se ejecuta el nodo bajo IF. Si la condición no se cumple, se ejecuta el nodo bajo ELSE si hay un ELSE, de lo contrario finaliza la sentencia IF.",
  T_48_META_API_1001_P0_D: "La lista de condiciones debe ser coherente con el número de listas de subprocedimientos (listas de ramas lógicas).",
  T_48_META_API_10010_D: "Crea un elemento o lista de elementos en una ubicación especificada.",
  T_48_META_API_10010_P0_D: "Lugar de creación del artículo",
  T_48_META_API_10010_P1_D: "Objetos creados o lista de objetos",
  T_48_META_API_10010_P2_D: "Al crear una lista de artículos, es necesario rellenar una lista con el número de artículos correspondiente al orden de la lista de artículos.",
  T_48_META_API_10011_D: "Entidades de IA que patrullan hacia puntos objetivo",
  T_48_META_API_10011_P0_D: "Entidades de IA específicas",
  T_48_META_API_10011_P1_D: "Punto de destino móvil",
  T_48_META_API_10011_P2_D: "Si hay que volver al punto de partida",
  T_48_META_API_10011_P3_D: "Si se detectan y atacan objetivos hostiles mientras se patrulla",
  T_48_META_API_10012_D: "Patrulla de entidades AI por orden de la lista de coordenadas",
  T_48_META_API_10012_P0_D: "Entidades de IA específicas",
  T_48_META_API_10012_P1_D: "Lista de puntos de coordenadas móviles",
  T_48_META_API_10012_P2_D: "Tipo de patrulla, con opción de ida, vuelta o ciclo",
  T_48_META_API_10012_P3_D: "Si se detectan y atacan objetivos hostiles mientras se patrulla",
  T_48_META_API_10013_D: "El generador actualiza inmediatamente la siguiente oleada de entidades unitarias",
  T_48_META_API_10013_P0_D: "entidad generadora",
  T_48_META_API_10014_D: "Añade un factor para calcular atributos computables, que se calcularán mediante una fórmula compuesta de factores para producir el resultado final.",
  T_48_META_API_10014_P0_D: "entidad de destino",
  T_48_META_API_10014_P1_D: "Tipos de atributos calculables",
  T_48_META_API_10014_P2_D: "Tipo de factor de cálculo",
  T_48_META_API_10014_P3_D: "Cálculo de los valores de los factores",
  T_48_META_API_10015_D: "Borrar el factor de cómputo de los atributos computables",
  T_48_META_API_10015_P0_D: "entidad de destino",
  T_48_META_API_10015_P1_D: "Tipos de atributos calculables",
  T_48_META_API_10016_D: "Borrar todos los factores computacionales para todos los atributos computables de la entidad objetivo.",
  T_48_META_API_10016_P0_D: "entidad de destino",
  T_48_META_API_10017_D: "Modificar atributos",
  T_48_META_API_10017_P0_D: "entidad de destino",
  T_48_META_API_10017_P1_D: "Tipo de atributo",
  T_48_META_API_10017_P2_D: "Método de modificación",
  T_48_META_API_10017_P3_D: "estar de servicio",
  T_48_META_API_10018_D: "Establecer el valor de una propiedad computable",
  T_48_META_API_10018_P0_D: "entidad de destino",
  T_48_META_API_10018_P1_D: "Tipo de atributo",
  T_48_META_API_10018_P2_D: "estar de servicio",
  T_48_META_API_10019_D: "Compensación de modificaciones individuales de propiedades computables",
  T_48_META_API_10019_P0_D: "entidad de destino",
  T_48_META_API_10019_P1_D: "Tipo de atributo",
  T_48_META_API_1002_D: "El parámetro i parte del valor mínimo, y cada vez que se ejecuta el nodo inferior entonces i aumenta el valor de paso hasta que i es mayor o igual que el valor máximo.",
  T_48_META_API_1002_P0_D: "El nombre del índice cíclico, que se puede utilizar para obtener el valor del índice cíclico en una variable local.",
  T_48_META_API_1002_P1_D: "Valor inicial cíclico",
  T_48_META_API_1002_P2_D: "valor de fin de ciclo",
  T_48_META_API_1002_P3_D: "Tamaño de paso de bucle, cuando el valor inicial es menor que el valor final, el tamaño de paso debe ser mayor que 0; cuando el valor inicial es mayor que el valor final, el tamaño de paso debe ser menor que 0.",
  T_48_META_API_10020_D: "Obtiene todas las entidades del juego que cumplen los criterios del filtro",
  T_48_META_API_10020_P0_D: "El resultado del filtro debe contener el tipo introducido en este parámetro",
  T_48_META_API_10020_P1_D: "El resultado del filtro no debe contener el tipo introducido en este parámetro",
  T_48_META_API_10020_P2_D: "Los resultados del filtro contienen al menos uno de los tipos introducidos en este parámetro",
  T_48_META_API_10020_R_D: "Filtrar la lista de entidades resultantes",
  T_48_META_API_10021_D: "Añadiendo una velocidad al balón, la velocidad cambiará por la aceleración en la misma dirección",
  T_48_META_API_10021_P0_D: "Fútbol Goal",
  T_48_META_API_10021_P1_D: "Añadida velocidad espacial 3D",
  T_48_META_API_10022_D: "Destrucción de entidades designadas",
  T_48_META_API_10022_P0_D: "Entidades objetivo a destruir",
  T_48_META_API_10023_D: "Añadir etiquetas a las entidades",
  T_48_META_API_10023_P0_D: "entidad de destino",
  T_48_META_API_10023_P1_D: "Etiquetas personalizadas",
  T_48_META_API_10024_D: "Eliminar las etiquetas de las entidades",
  T_48_META_API_10024_P0_D: "entidad de destino",
  T_48_META_API_10024_P1_D: "Etiquetas personalizadas",
  T_48_META_API_10025_D: "Determinar si la entidad de destino contiene la etiqueta especificada",
  T_48_META_API_10025_P0_D: "entidad de destino",
  T_48_META_API_10025_P1_D: "Etiquetas personalizadas",
  T_48_META_API_10025_R_D: "Incluir o no la etiqueta especificada",
  T_48_META_API_10026_D: "Fijar la posición del balón",
  T_48_META_API_10026_P0_D: "entidad futbolística",
  T_48_META_API_10026_P1_D: "colocación",
  T_48_META_API_10026_P2_D: "Mantener la velocidad",
  T_48_META_API_10027_D: "Obtener la entidad de cámara utilizada actualmente por el jugador objetivo",
  T_48_META_API_10027_P0_D: "jugador objetivo",
  T_48_META_API_10027_R_D: "La entidad de cámara utilizada actualmente",
  T_48_META_API_10028_D: "Al cambiar la cámara del jugador objetivo a la cámara objetivo, el",
  T_48_META_API_10028_P0_D: "jugador objetivo",
  T_48_META_API_10028_P1_D: "cámara objetivo",
  T_48_META_API_10028_P2_D: "Método de conmutación, puede optar por mantener la lógica original o progresiva",
  T_48_META_API_10028_P3_D: "El tiempo de conmutación es el tiempo para cambiar de cámara en modo progresivo",
  T_48_META_API_10029_D: "Crear una cámara",
  T_48_META_API_10029_P0_D: "Tipo de cámara creada",
  T_48_META_API_10029_P1_D: "Entidad de cámara creada",
  T_48_META_API_1003_D: "Implementar un traversal de un contenedor de datos para llegar a cada sub-elemento, que contiene sub-procedimientos, el cuerpo del bucle es el sub-procedimiento",
  T_48_META_API_1003_P0_D: "Iterar sobre el nombre del elemento hijo, que se puede utilizar para llegar al valor del elemento hijo en la variable local",
  T_48_META_API_1003_P1_D: "El nombre del índice cíclico, que se puede utilizar para obtener el valor del índice cíclico en una variable local.",
  T_48_META_API_1003_P2_D: "El contenedor de datos a recorrer, actualmente se admiten los siguientes tipos: tipo array",
  T_48_META_API_10030_D: "Matar entidades combatibles",
  T_48_META_API_10030_P0_D: "Entidad objetivo, que debe estar preparada para el combate",
  T_48_META_API_10031_D: "Establece el estado activo de la entidad de destino y sus nodos hijos; la disponibilidad, visibilidad, colisiones, etc. se desactivan para los objetos inactivos.",
  T_48_META_API_10031_P0_D: "entidad de destino",
  T_48_META_API_10031_P1_D: "Activo o inactivo",
  T_48_META_API_10032_D: "Establece la posición de la entidad cámara para que siga siempre a la entidad objetivo",
  T_48_META_API_10032_P0_D: "cámara objetivo entidad",
  T_48_META_API_10032_P1_D: "Entidad objetivo a seguir",
  T_48_META_API_10032_P2_D: "Desplazamiento respecto a las coordenadas de la entidad de destino",
  T_48_META_API_10032_P3_D: "Sistema de coordenadas para los desplazamientos",
  T_48_META_API_10033_D: "Establecer la entidad de la cámara para que siempre mire a la entidad objetivo",
  T_48_META_API_10033_P0_D: "cámara objetivo entidad",
  T_48_META_API_10033_P1_D: "entidad de destino",
  T_48_META_API_10033_P2_D: "Desplazamiento del punto de mirada respecto a las coordenadas del objetivo",
  T_48_META_API_10033_P3_D: "Sistema de coordenadas para los desplazamientos",
  T_48_META_API_10034_D: "Crear interpolación",
  T_48_META_API_10034_P0_D: "entidad de destino",
  T_48_META_API_10034_P1_D: "Identificación de la propiedad",
  T_48_META_API_10034_P2_D: "SrcVal",
  T_48_META_API_10034_P3_D: "DestVal",
  T_48_META_API_10034_P4_D: "Estilo",
  T_48_META_API_10034_P5_D: "Curva",
  T_48_META_API_10034_P6_D: "Duración",
  T_48_META_API_10034_P7_D: "entre entidades",
  T_48_META_API_10035_D: "Para fijar el nodo padre es necesario que tanto el padre como el hijo tengan el componente Transform",
  T_48_META_API_10035_P0_D: "nodo padre",
  T_48_META_API_10035_P1_D: "nodo hijo",
  T_48_META_API_10035_P2_D: "Si desea mantener la posición actual del mundo, la rotación y el escalado de los nodos hijos, este elemento no es válido cuando se establece la interfaz de usuario.",
  T_48_META_API_10036_D: "NewCurve (obsoleto, utilice CreateTweenCurve)",
  T_48_META_API_10036_P0_D: "Puntos de control",
  T_48_META_API_10036_R_D: "TwennCurveEntity",
  T_48_META_API_10037_D: "Intenta reproducir la entidad de destino, que debe tener un componente reproducible",
  T_48_META_API_10037_P0_D: "Entidad jugable objetivo",
  T_48_META_API_10037_P1_D: `Si se va a reproducir 
true: reproducir 
false: continuar reproduciendo`,
  T_48_META_API_10038_D: "Pausar entidades jugables",
  T_48_META_API_10038_P0_D: "Entidad jugable objetivo",
  T_48_META_API_10039_D: "La creación de un movimiento balístico proporciona a la entidad objetivo una velocidad inicial y una aceleración con dirección",
  T_48_META_API_10039_P0_D: "entidad de destino",
  T_48_META_API_10039_P1_D: "velocidad inicial",
  T_48_META_API_10039_P2_D: "aceleración del movimiento",
  T_48_META_API_10039_P3_D: "Distancia máxima de desplazamiento",
  T_48_META_API_10039_P4_D: "Entidades de movimiento balístico creadas",
  T_48_META_API_10039_P5_D: "Si la reproducción se inicia automáticamente tras la creación",
  T_48_META_API_1004_D: "Interrumpe el proceso del bucle actual y sale del bucle",
  T_48_META_API_10040_D: "Crea un movimiento de seguimiento de posición en el que la entidad objetivo sigue al objeto especificado.",
  T_48_META_API_10040_P0_D: "entidad de destino",
  T_48_META_API_10040_P1_D: "Entidades objeto que siguen el movimiento",
  T_48_META_API_10040_P2_D: "La distancia sigue el desplazamiento de las coordenadas del objetivo",
  T_48_META_API_10040_P3_D: "Sistema de coordenadas utilizado",
  T_48_META_API_10040_P4_D: "Entidad creada Follow Motion",
  T_48_META_API_10040_P5_D: "Si la reproducción se inicia automáticamente tras la creación",
  T_48_META_API_10041_D: "Crea un movimiento de seguimiento de la mirada en el que la entidad objetivo permanece orientada hacia el objeto especificado.",
  T_48_META_API_10041_P0_D: "entidad de destino",
  T_48_META_API_10041_P1_D: "entidad considerada",
  T_48_META_API_10041_P2_D: "Desplazamiento del punto de mirada respecto a la entidad objeto",
  T_48_META_API_10041_P3_D: "Sistema de coordenadas utilizado",
  T_48_META_API_10041_P4_D: "Creación de entidades de movimiento que siguen la mirada",
  T_48_META_API_10041_P5_D: "Si la reproducción se inicia automáticamente tras la creación",
  T_48_META_API_10042_D: "abandonado",
  T_48_META_API_10042_P0_D: "entidad jugadora",
  T_48_META_API_10042_P1_D: "resultados de un concurso",
  T_48_META_API_10042_P2_D: "abandonado",
  T_48_META_API_10042_P3_D: "abandonado",
  T_48_META_API_10042_P4_D: "abandonado",
  T_48_META_API_10043_D: "Smoothing establece las propiedades de la entidad de destino, las propiedades cambian inmediatamente, pero el cliente reproduce un rendimiento de transición suave",
  T_48_META_API_10043_P0_D: "entidad de destino",
  T_48_META_API_10043_P1_D: "Un atributo de la entidad de destino",
  T_48_META_API_10043_P2_D: "El valor de destino, que debe coincidir con el tipo requerido cuando se definió la propiedad.",
  T_48_META_API_10044_D: "Realice una detección de rayos y devuelva la primera entidad impactada en la dirección del rayo. La entidad impactada necesita un componente de colisión. Si el parámetro de nivel se completa en el espacio en blanco, se puede detectar el terreno.",
  T_48_META_API_10044_P0_D: "Coordenadas de la posición inicial",
  T_48_META_API_10044_P1_D: "Dirección de detección de la radiación",
  T_48_META_API_10044_P2_D: "Distancia de detección de la radiación, sólo se aceptan valores positivos",
  T_48_META_API_10044_P3_D: "Máscara de capa de detección de rayos, sólo las capas rellenas participarán en el escaneo, si se deja en blanco todas las capas participarán en el escaneo.",
  T_48_META_API_10044_P4_D: "¿Es posible buscar desencadenantes",
  T_48_META_API_10044_P5_D: "entidad afectada",
  T_48_META_API_10044_P6_D: "coordenadas del punto de impacto",
  T_48_META_API_10044_P7_D: "Distancia del punto de impacto desde el punto inicial",
  T_48_META_API_10044_P8_D: "golpea la normal de la superficie",
  T_48_META_API_10045_D: "Realice una detección de rayos y devuelva todas las entidades impactadas en la dirección del rayo de cerca a lejos. Si el parámetro de nivel se completa en el espacio en blanco, se puede detectar el terreno.",
  T_48_META_API_10045_P0_D: "Coordenadas de la posición inicial",
  T_48_META_API_10045_P1_D: "Dirección de detección de la radiación",
  T_48_META_API_10045_P2_D: "Distancia de detección de la radiación, sólo se aceptan valores positivos",
  T_48_META_API_10045_P3_D: "Máscara de capa, sólo las capas rellenas participarán en el escaneado, si se deja en blanco todas las capas participarán en el escaneado.",
  T_48_META_API_10045_P4_D: "Si se puede detectar el desencadenante",
  T_48_META_API_10045_P5_D: "Lista de entidades afectadas",
  T_48_META_API_10045_P6_D: "Lista de puntos de impacto",
  T_48_META_API_10045_P7_D: "Lista de distancias de los puntos de impacto desde los puntos de inicio",
  T_48_META_API_10045_P8_D: "golpea la normal de la superficie",
  T_48_META_API_10046_D: "Creación de sólidos para plantillas mediante cuerpos prefabricados",
  T_48_META_API_10046_P0_D: "Entidades creadas",
  T_48_META_API_10046_P1_D: "Cuerpo prefabricado ID",
  T_48_META_API_10047_D: "decolorar",
  T_48_META_API_10047_P0_D: "Ajuste de las normales de los objetos",
  T_48_META_API_10047_P1_D: "Ajustar el punto de coloración",
  T_48_META_API_10047_P2_D: "color",
  T_48_META_API_10048_D: "Estado de los colores",
  T_48_META_API_10048_P0_D: "Ajustar el punto de coloración",
  T_48_META_API_10048_P1_D: "Fijar la dirección",
  T_48_META_API_10048_P2_D: "Distancia de ajuste",
  T_48_META_API_10048_R_D: "ColorDesc",
  T_48_META_API_10049_D: "Estadísticas para colorear",
  T_48_META_API_10049_P0_D: "color",
  T_48_META_API_10049_R_D: "Número de colores",
  T_48_META_API_1005_D: "Sáltate el resto del cuerpo del bucle y pasa directamente al siguiente bucle.",
  T_48_META_API_10050_D: "Gama Plana Coloración",
  T_48_META_API_10050_P0_D: "Ajuste de las normales de los objetos",
  T_48_META_API_10050_P1_D: "Ajustar el punto de coloración",
  T_48_META_API_10050_P2_D: "Ajuste del intervalo de tinción",
  T_48_META_API_10050_P3_D: "color",
  T_48_META_API_10050_P4_D: "Número de colores",
  T_48_META_API_10051_D: "mancha regional",
  T_48_META_API_10051_P0_D: "Ajuste de las normales de los objetos",
  T_48_META_API_10051_P1_D: "Ajustar el punto de coloración",
  T_48_META_API_10051_P2_D: "Ajuste del intervalo de tinción",
  T_48_META_API_10051_P3_D: "color",
  T_48_META_API_10051_P4_D: "Área de tinción fija",
  T_48_META_API_10051_P5_D: "coeficiente aleatorio (matem.)",
  T_48_META_API_10051_P6_D: "coeficiente de atenuación aleatoria",
  T_48_META_API_10051_P7_D: "Número de colores",
  T_48_META_API_10052_D: "Obtener todos los hijos de la entidad padre de destino",
  T_48_META_API_10052_P0_D: "entidad matriz",
  T_48_META_API_10052_R_D: "lista de nodos hijos",
  T_48_META_API_10053_D: "Obtiene el nodo hijo especificado de la entidad padre de destino basándose en el índice",
  T_48_META_API_10053_P0_D: "entidad matriz",
  T_48_META_API_10053_P1_D: "Índice de subnodo",
  T_48_META_API_10053_R_D: "entidad infantil",
  T_48_META_API_10054_D: "Obtener el padre de la entidad hija de destino",
  T_48_META_API_10054_P0_D: "entidad infantil",
  T_48_META_API_10054_R_D: "entidad matriz",
  T_48_META_API_10055_D: "Elimina todos los nodos hijos bajo la entidad de nodo padre especificada; los nodos deben tener el componente Transformar",
  T_48_META_API_10055_P0_D: "entidad matriz",
  T_48_META_API_10056_D: "Teletransporta al objetivo al lugar especificado",
  T_48_META_API_10056_P0_D: "unidad de transporte (por ejemplo, militar)",
  T_48_META_API_10056_P1_D: "coordenadas del punto de transmisión",
  T_48_META_API_10056_P2_D: "orientación de la unidad tras la transferencia",
  T_48_META_API_10057_D: "Obtén la ubicación cercana de un compañero de equipo al azar, y vuelve a tus propias coordenadas cercanas cuando no tengas un compañero de equipo, lo que evitará la ubicación de los jugadores que no puedan levantarse",
  T_48_META_API_10057_P0_D: "jugador objetivo",
  T_48_META_API_10057_R_D: "Coordenadas cercanas a los compañeros del jugador objetivo",
  T_48_META_API_10058_D: "Estado de la coloración clara",
  T_48_META_API_10059_D: "Reproduce el efecto de sonido especificado y, si hay más atributos que configurar, configura sus atributos de entidad mediante la entidad",
  T_48_META_API_10059_P0_D: "En el código es el nombre del parámetro formal utilizado para representar la entidad que crea el efecto de sonido, y su correspondiente valor de variable local es la entidad que crea el efecto de sonido",
  T_48_META_API_10059_P1_D: "La entidad de jugador a la que pertenece, visible sólo para ese jugador",
  T_48_META_API_10059_P2_D: "Tipos de sonido, los tipos de efectos de sonido que el jugador puede elegir.",
  T_48_META_API_1006_D: "Finaliza el proceso de ejecución actual, vuelve directamente a la ubicación de llamada, puede llevar los datos junto con el retorno",
  T_48_META_API_1006_P0_D: "Datos con los que desea volver al lugar de llamada",
  T_48_META_API_10060_D: "Expulsar del juego al jugador objetivo",
  T_48_META_API_10060_P0_D: "jugador objetivo",
  T_48_META_API_10060_P1_D: "Mostrar o no información sobre la liquidación",
  T_48_META_API_10061_D: "El jugador objetivo solicita ser emparejado con un mapa específico",
  T_48_META_API_10061_P0_D: "jugador objetivo",
  T_48_META_API_10061_P1_D: "código campo de batalla",
  T_48_META_API_10061_P2_D: "Si aparece o no una ventana emergente para volver a la partida original al cancelar una partida.",
  T_48_META_API_10062_D: "Interrupción de la entidad de sonido en reproducción",
  T_48_META_API_10062_P0_D: "Entidades de sonido que deben suspenderse",
  T_48_META_API_10063_D: "Reproducción continua de efectos de sonido, opcionalmente desde el principio",
  T_48_META_API_10063_P0_D: "Entidades sonoras que deben seguir reproduciéndose tras ser pausadas",
  T_48_META_API_10063_P1_D: "Empezar de cero",
  T_48_META_API_10064_D: "Crear una gota, la gota tiene tres fases: 1. listo, 2. cayendo, 3. aterrizó, sólo en el estado 1 puede modificar las propiedades de la gota",
  T_48_META_API_10064_P0_D: "Entidades de buzón creadas",
  T_48_META_API_1007_D: "Implementar un bucle que continúe ejecutándose en función de si la condición es verdadera o no, hasta que la condición sea falsa y el bucle termine.",
  T_48_META_API_1007_P0_D: "Cuando la condición es verdadera, el bucle continúa, y cuando la condición es falsa, el bucle termina.",
  T_48_META_API_1008_D: `Esperar hasta el inicio de la siguiente trama lógica
En el servidor, activar el modo de baja velocidad de fotogramas, esperará más tiempo
En el cliente, el tiempo de espera se ve afectado por el rendimiento del dispositivo y la complejidad de la lógica `,
  T_48_META_API_1009_D: "Espere un cierto tiempo, las funciones que utilizan esta API deben ser declaradas async.",
  T_48_META_API_1009_P0_D: "Tiempo de espera en milisegundos",
  T_48_META_API_101_D: "Desinstalación de una escena especificada",
  T_48_META_API_101_P0_D: "ID de escena a desinstalar",
  T_48_META_API_1010: "Devolución de llamada de evento",
  T_48_META_API_1010_D: "Acciones desencadenadas cuando se produce un evento",
  T_48_META_API_1010_P0: "Nombres de parámetros de eventos",
  T_48_META_API_1010_P0_D: "El nombre del parámetro formal del parámetro de evento, mediante el cual se puede obtener el valor real del parámetro en la variable local",
  T_48_META_API_1011: "Bloque de código",
  T_48_META_API_1011_D: "Un bloque de código para alojar una combinación de APIs",
  T_48_META_API_1011_P0: "Nombres de parámetros",
  T_48_META_API_1011_P0_D: "Nombres de parámetros formales cuando el bloque de código es una función personalizada",
  T_48_META_API_1012: "Busque e invoque una API personalizada con serial",
  T_48_META_API_1012_D: "Llama a funciones personalizadas en serie, y si hay una espera en la función personalizada, la ubicación de la llamada también espera",
  T_48_META_API_1012_P0_D: "La entidad donde reside la función personalizada",
  T_48_META_API_1012_P1: "Identificación del gráfico",
  T_48_META_API_1012_P1_D: "ID del script donde reside la función personalizada",
  T_48_META_API_1012_P2: "Identificación de función",
  T_48_META_API_1012_P2_D: "ID de función de la llamada de destino",
  T_48_META_API_1012_P3_D: "Lista de parámetros reales pasados a la función personalizada",
  T_48_META_API_1013: "Busque e invoque una API personalizada con Parallel",
  T_48_META_API_1013_D: "Llama a funciones personalizadas de forma paralela, volviendo inmediatamente a la posición de llamada para continuar por la línea, independientemente de si hay o no una espera en la función personalizada.",
  T_48_META_API_1013_P0_D: "La entidad donde reside la función personalizada",
  T_48_META_API_1013_P1: "Identificación del gráfico",
  T_48_META_API_1013_P1_D: "ID del script donde reside la función personalizada",
  T_48_META_API_1013_P2: "Identificación de función",
  T_48_META_API_1013_P2_D: "ID de función de la llamada de destino",
  T_48_META_API_1013_P3_D: "Lista de parámetros reales pasados a la función personalizada",
  T_48_META_API_1014: "Busque e invoque una API personalizada con serial",
  T_48_META_API_1014_D: "Llama a una función personalizada en el script actual de forma serial, y si hay una espera en la función personalizada, la ubicación de la llamada también espera",
  T_48_META_API_1014_P0: "Identificación de función",
  T_48_META_API_1014_P0_D: "ID de función de la llamada de destino",
  T_48_META_API_1014_P1_D: "Lista de parámetros reales pasados a la función personalizada",
  T_48_META_API_1015: "Busque e invoque una API personalizada con Parallel",
  T_48_META_API_1015_D: "Llama a funciones personalizadas de forma paralela, volviendo inmediatamente a la posición de llamada para continuar por la línea, independientemente de si hay o no una espera en la función personalizada.",
  T_48_META_API_1015_P0: "Establecer variable local por índice",
  T_48_META_API_1015_P0_D: "ID de función de la llamada de destino",
  T_48_META_API_1015_P1_D: "Lista de parámetros reales pasados a la función personalizada",
  T_48_META_API_1016_D: "Obtener el tipo del objetivo al llamar a esta API",
  T_48_META_API_1016_P0_D: "objetivo consultado",
  T_48_META_API_1016_R_D: "Tipo variable",
  T_48_META_API_1017_D: "Determinar si la variable de destino es del tipo especificado",
  T_48_META_API_1017_P0_D: "objetivo consultado",
  T_48_META_API_1017_P1_D: "Tipo de comparación",
  T_48_META_API_1017_R_D: "coherencia",
  T_48_META_API_1018_D: "Determina si la variable de destino es una subclase de un tipo determinado, el valor de retorno es un valor booleano",
  T_48_META_API_1018_P0_D: "Variable de destino consultada",
  T_48_META_API_1018_P1_D: "Tipo de comparación",
  T_48_META_API_1018_R_D: "Sea o no una subclase",
  T_48_META_API_1019_D: "Hace que la entidad de destino active el evento personalizado especificado",
  T_48_META_API_1019_P0_D: "Envío de identificadores de eventos personalizados",
  T_48_META_API_1019_P1_D: "entidad de destino",
  T_48_META_API_1019_P2_D: "lista de parámetros",
  T_48_META_API_102_D: "Al cambiar a una escena específica, se descargan las demás escenas cargadas.",
  T_48_META_API_102_P0_D: "ID de escena para cambiar a",
  T_48_META_API_1020_D: "La implementación de recorrer un contenedor para llegar a cada par clave-valor contiene sub-procedimientos, el cuerpo del bucle es el sub-procedimiento",
  T_48_META_API_1020_P0_D: "Iterando sobre el nombre de una clave, se puede utilizar para obtener el valor de la clave en una variable local",
  T_48_META_API_1020_P1_D: "Iterar sobre el nombre del valor, se puede utilizar para llegar al valor en la variable local",
  T_48_META_API_1020_P2_D: "Contenedores que deben atravesarse",
  T_48_META_API_1021_D: "Destruye el Bot especificado",
  T_48_META_API_1021_P0_D: "Jugadores bot que necesitan ser destruidos",
  T_48_META_API_1022_D: "Obliga al jugador objetivo a abandonar el portador",
  T_48_META_API_1022_P0_D: "jugador objetivo",
  T_48_META_API_1023_D: "Creación de puentes de lesiones",
  T_48_META_API_1023_P0_D: "omitir contenido",
  T_48_META_API_1023_P1_D: "tamaño de letra",
  T_48_META_API_1023_P2_D: "color de fuente",
  T_48_META_API_1023_P3_D: "Tiempo de espera en milisegundos",
  T_48_META_API_1023_P4_D: "entidad perjudicada",
  T_48_META_API_1023_P5_D: "Desplazamiento de la palabra de salto de daño con respecto a las coordenadas mundiales de la entidad objetivo.",
  T_48_META_API_1023_P6_D: "Tamaño de rango de las correcciones posicionales aleatorias en las ubicaciones de salto de daños de nuevo",
  T_48_META_API_1023_P7_D: "Si se ejecuta la animación de relleno",
  T_48_META_API_1024_D: "abandonado",
  T_48_META_API_1024_P0_D: "abandonado",
  T_48_META_API_1024_P1_D: "entidad de destino",
  T_48_META_API_1024_P2_D: "Cuando se selecciona, se envía al cliente si se llama desde el servidor, y al servidor si se llama desde el cliente.",
  T_48_META_API_1024_P3_D: "lista de parámetros",
  T_48_META_API_1025_D: "Consulta del progreso de una tarea personalizada",
  T_48_META_API_1025_P0_D: "jugador objetivo",
  T_48_META_API_1025_P1_D: "ID de tarea personalizada",
  T_48_META_API_1025_R_D: "Progresos de la misión",
  T_48_META_API_1026_D: "Obtener la skin de la mochila del jugador objetivo",
  T_48_META_API_1026_P0_D: "jugador objetivo",
  T_48_META_API_1026_R_D: "Mochila Skin ID",
  T_48_META_API_1027_D: "Definir el aspecto de la mochila del jugador objetivo",
  T_48_META_API_1027_P0_D: "jugador objetivo",
  T_48_META_API_1027_P1_D: "Mochila Skin ID",
  T_48_META_API_1028_D: "Restaura el aspecto de mochila del jugador objetivo a la configuración predeterminada fuera de la oficina.",
  T_48_META_API_1028_P0_D: "jugador objetivo",
  T_48_META_API_1029_D: "Vacía la skin de la mochila del jugador objetivo",
  T_48_META_API_1029_P0_D: "jugador objetivo",
  T_48_META_API_103_D: "Sustituye el estilo de entorno skybox del juego por la posibilidad de elegir entre día, atardecer, noche, etc.",
  T_48_META_API_103_P0_D: "Tipo Skybox",
  T_48_META_API_1030_D: "Obtener la parte del esqueleto por su nombre",
  T_48_META_API_1030_P0_D: "entidad de destino",
  T_48_META_API_1030_P1_D: "Nombre del punto colgante esquelético",
  T_48_META_API_1030_R_D: "Punto de la Armazón",
  T_48_META_API_1031_D: "Establece el nodo padre de una entidad objeto que soporta entidades que tienen montados componentes Transform, SkeletonPart, Player, MountPoint.",
  T_48_META_API_1031_P0_D: "nodo padre",
  T_48_META_API_1031_P1_D: "nodo hijo",
  T_48_META_API_1031_P2_D: "Si desea mantener la posición actual del mundo, la rotación y la escala de los nodos hijos, UI establecer este elemento no es válido",
  T_48_META_API_1032_D: "Reproduce un efecto de icono animado en el que el icono se desplaza desde la posición inicial hasta la posición final a la velocidad de reproducción.",
  T_48_META_API_1032_P0_D: "Icono ID de recurso",
  T_48_META_API_1032_P1_D: "color",
  T_48_META_API_1032_P2_D: "Icono Zoom",
  T_48_META_API_1032_P3_D: "Posición inicial centro",
  T_48_META_API_1032_P4_D: "Inicio del ámbito regional",
  T_48_META_API_1032_P5_D: "Posición final centro",
  T_48_META_API_1032_P6_D: "Rango de posición final",
  T_48_META_API_1032_P7_D: "La velocidad de reproducción, que es la distancia por segundo que recorre el icono",
  T_48_META_API_1033_D: "Realiza una operación de tangente inversa para obtener el ángulo",
  T_48_META_API_1033_P0_D: "Coordenadas del eje Y",
  T_48_META_API_1033_P1_D: "Coordenadas del eje X",
  T_48_META_API_1033_R_D: "Ángulo, rango (-180, 180]",
  T_48_META_API_1034_D: "Añadir componentes a entidades, sólo se admiten componentes personalizados creados por el usuario.",
  T_48_META_API_1034_P0_D: "entidad de destino",
  T_48_META_API_1034_P1_D: "ID del tipo de componente, sólo se admiten componentes personalizados creados por el usuario.",
  T_48_META_API_1034_P2_D: "Tanto si se añade correctamente como si no, los componentes existentes o no personalizados no se añadirán.",
  T_48_META_API_1035_D: "Eliminar componentes de entidades, sólo se admiten componentes personalizados",
  T_48_META_API_1035_P0_D: "entidad de destino",
  T_48_META_API_1035_P1_D: "ID del tipo de componente, sólo se admiten componentes personalizados creados por el usuario.",
  T_48_META_API_1035_P2_D: "Tanto si la eliminación se ha realizado correctamente como si no, los componentes no existentes o no personalizados no se eliminarán.",
  T_48_META_API_1036_D: "Personalizar la pantalla de salida del jugador",
  T_48_META_API_1036_P0_D: "leyenda",
  T_48_META_API_1036_P1_D: "elemento",
  T_48_META_API_1036_P2_D: "opciones",
  T_48_META_API_1036_P3_D: "Mostrar o no el fondo",
  T_48_META_API_1037_D: "Obtener todas las escenas cargadas actualmente",
  T_48_META_API_1037_R_D: "Lista de escenas",
  T_48_META_API_1038_D: "Obtener la dirección de puntería local del jugador",
  T_48_META_API_1038_R_D: "apuntar en la dirección correcta",
  T_48_META_API_1039_D: "Obtener marca de tiempo local",
  T_48_META_API_1039_R_D: "marca de tiempo",
  T_48_META_API_104_D: "Cambia al jugador a una ubicación especificada en una escena especificada, las escenas descargadas se cargarán automáticamente y no se descargarán automáticamente las escenas ya cargadas.",
  T_48_META_API_104_P0_D: "jugador",
  T_48_META_API_104_P1_D: "ID de la escena a cargar",
  T_48_META_API_104_P2_D: "Posición del jugador en el nuevo escenario",
  T_48_META_API_104_P3_D: "Orientación del jugador en el nuevo escenario",
  T_48_META_API_1040_D: "Pausa la actualización de fotogramas fijos para la plataforma actual, y el evento de actualización de fotogramas fijos para esa plataforma no se activará después de la pausa.",
  T_48_META_API_1041_D: "Reanudar la actualización de fotogramas fijos para la plataforma actual, y el evento de actualización de fotogramas fijos para esa plataforma comienza a dispararse de nuevo tras la reanudación.",
  T_48_META_API_1042_D: "Determinar la relación de amigo del jugador objetivo con el jugador cliente actual, el propio cliente actual no es amigo del cliente actual.",
  T_48_META_API_1042_P0_D: "jugador objetivo",
  T_48_META_API_1042_R_D: "Si es o no amigo del cliente actual",
  T_48_META_API_1043_D: "Activación de eventos personalizados",
  T_48_META_API_1043_P0_D: "ID de evento personalizado",
  T_48_META_API_1043_P1_D: "entidad de destino",
  T_48_META_API_1043_P2_D: "Funciona en plataformas de servidor o cliente",
  T_48_META_API_1043_P3_D: "lista de parámetros",
  T_48_META_API_1044_D: "Salto abierto",
  T_48_META_API_1044_P0_D: "jugador objetivo",
  T_48_META_API_1044_P1_D: "Por debajo de esta altitud, el paracaídas se verá obligado a abrirse.",
  T_48_META_API_1044_P2_D: "Velocidad al planear, el componente X representa la velocidad horizontal, el componente Y representa la velocidad vertical; el jugador aterriza hacia abajo cuando el componente Y es negativo.",
  T_48_META_API_1044_P3_D: "Velocidad en picado, el componente X representa la velocidad horizontal, el componente Y representa la velocidad vertical; el jugador desciende cuando el componente Y es negativo.",
  T_48_META_API_1044_P4_D: "Velocidad al abrir el paracaídas, el componente X representa la velocidad horizontal, el componente Y representa la velocidad vertical; cuando el componente Y es negativo el jugador aterriza hacia abajo.",
  T_48_META_API_1045_D: "Lee el valor correspondiente al identificador especificado en la tabla de datos.",
  T_48_META_API_1045_P0_D: "Nombres de tabla en la base de datos",
  T_48_META_API_1045_P1_D: "ID único del jugador",
  T_48_META_API_1045_P2_D: "identificador especificado",
  T_48_META_API_1045_P3_D: "Los resultados de las lecturas",
  T_48_META_API_1045_P4_D: "El código del campo de batalla correspondiente a la base de datos, que se puede rellenar en blanco, representa el código del campo de batalla del mapa actual.",
  T_48_META_API_1045_P5_D: "código de error",
  T_48_META_API_1046_D: "Recupera el valor correspondiente al identificador especificado en la tabla de datos del gráfico.",
  T_48_META_API_1046_P0_D: "Nombre de la tabla de clasificación en la base de datos",
  T_48_META_API_1046_P1_D: "identificador especificado",
  T_48_META_API_1046_P2_D: "Los resultados de las lecturas",
  T_48_META_API_1046_P3_D: "El código del campo de batalla correspondiente a la base de datos, que se puede rellenar en blanco, representa el código del campo de batalla del mapa actual.",
  T_48_META_API_1046_P4_D: "código de error",
  T_48_META_API_1047_D: "Recuperar el valor del intervalo de rango especificado en la tabla de datos Leaderboards.",
  T_48_META_API_1047_P0_D: "Nombre de la tabla de clasificación en la base de datos",
  T_48_META_API_1047_P1_D: "El rango inicial debe ser menor o igual que el rango final, y el rango comienza desde 1",
  T_48_META_API_1047_P2_D: "posición final",
  T_48_META_API_1047_P3_D: "Los resultados de las lecturas",
  T_48_META_API_1047_P4_D: "El código del campo de batalla correspondiente a la base de datos, que se puede rellenar en blanco, representa el código del campo de batalla del mapa actual.",
  T_48_META_API_1047_P5_D: "código de error",
  T_48_META_API_1048_D: "Lee el valor correspondiente al identificador especificado en la tabla de datos acumulados.",
  T_48_META_API_1048_P0_D: "Nombre de la tabla de datos acumulados en la base de datos",
  T_48_META_API_1048_P1_D: "identificador especificado",
  T_48_META_API_1048_P2_D: "Los resultados de las lecturas",
  T_48_META_API_1048_P3_D: "El código del campo de batalla correspondiente a la base de datos, que se puede rellenar en blanco, representa el código del campo de batalla del mapa actual.",
  T_48_META_API_1048_P4_D: "código de error",
  T_48_META_API_1049_D: "Escribe el valor correspondiente al identificador especificado en la tabla de datos.",
  T_48_META_API_1049_P0_D: "Nombres de tabla en la base de datos",
  T_48_META_API_1049_P1_D: "ID único del jugador",
  T_48_META_API_1049_P2_D: "identificador especificado",
  T_48_META_API_1049_P3_D: "Valor escrito",
  T_48_META_API_1049_P4_D: "El código del campo de batalla correspondiente a la base de datos, que se puede rellenar en blanco, representa el código del campo de batalla del mapa actual.",
  T_48_META_API_1049_P5_D: "código de error",
  T_48_META_API_105_D: "Obtener el skybox de la escena",
  T_48_META_API_105_P0_D: "Identificación de la escena",
  T_48_META_API_105_R_D: "skybox",
  T_48_META_API_1050_D: "Obtener el número de elementos de la lista",
  T_48_META_API_1050_P0_D: "lista de objetivos",
  T_48_META_API_1050_R_D: "Número de elementos",
  T_48_META_API_1051_D: "Obtener el valor del elemento en el índice especificado en la lista",
  T_48_META_API_1051_P0_D: "lista de objetivos",
  T_48_META_API_1051_P1_D: "Valores del índice, empezando por 0",
  T_48_META_API_1051_R_D: "valor elemental",
  T_48_META_API_1052_D: "Establece el valor del elemento correspondiente al índice especificado en la lista",
  T_48_META_API_1052_P0_D: "lista de objetivos",
  T_48_META_API_1052_P1_D: "Valores del índice, empezando por 0",
  T_48_META_API_1052_P2_D: "valor elemental",
  T_48_META_API_1053_D: "Añadir elementos al final de la lista",
  T_48_META_API_1053_P0_D: "lista de objetivos",
  T_48_META_API_1053_P1_D: "Elementos a añadir",
  T_48_META_API_1054_D: "Elimina de la lista el elemento situado en el índice especificado",
  T_48_META_API_1054_P0_D: "lista de objetivos",
  T_48_META_API_1054_P1_D: "Valores del índice, empezando por 0",
  T_48_META_API_1055_D: "Vaciar la lista de todos los elementos",
  T_48_META_API_1055_P0_D: "lista de objetivos",
  T_48_META_API_1056_D: "Invierte el orden de los elementos de la lista especificada.",
  T_48_META_API_1056_P0_D: "lista de objetivos",
  T_48_META_API_1057_D: "Copiar una lista",
  T_48_META_API_1057_P0_D: "lista de objetivos",
  T_48_META_API_1057_R_D: "Nueva lista copiada",
  T_48_META_API_1058_D: "Inserta un nuevo elemento en la posición de índice especificada en la lista, y los elementos en esa posición de índice y posteriores se mueven hacia atrás un lugar en secuencia.",
  T_48_META_API_1058_P0_D: "lista de objetivos",
  T_48_META_API_1058_P1_D: "Posición del índice a insertar, el índice cuenta desde 0",
  T_48_META_API_1058_P2_D: "El valor del nuevo elemento que se va a insertar",
  T_48_META_API_1059_D: "Volver a aleatorizar los elementos de la lista",
  T_48_META_API_1059_P0_D: "lista de objetivos",
  T_48_META_API_1060_D: "Compara ambos lados del argumento y devuelve verdadero o falso.",
  T_48_META_API_1060_P0_D: "El valor izquierdo utilizado para la comparación",
  T_48_META_API_1060_P1_D: "Métodos de comparación, se admiten los siguientes: >,>=,==,! =,<=,<,And(tipo bool cualificado),Or(tipo bool cualificado)",
  T_48_META_API_1060_P2_D: "El valor izquierdo utilizado para la comparación",
  T_48_META_API_1060_R_D: "Resultados comparativos",
  T_48_META_API_1061_D: "Las cuatro operaciones básicas: suma, resta, multiplicación, división y resto. La operación del resto sólo admite números enteros, y el resto de las operaciones admiten números enteros o decimales.",
  T_48_META_API_1061_P0_D: "valor izquierdo de una operación",
  T_48_META_API_1061_P1_D: "Tipos de las cuatro operaciones: suma, resta, multiplicación, división y resto, que no admite decimales.",
  T_48_META_API_1061_P2_D: "valor correcto de una operación",
  T_48_META_API_1061_R_D: "resultado del cálculo",
  T_48_META_API_1062_D: "Generar un entero aleatorio entre el entero de valor mínimo (incluido) y el entero de valor máximo (no incluido).",
  T_48_META_API_1062_P0_D: "Intervalo izquierdo de rango aleatorio con posibilidad de aleatorizar al valor relleno",
  T_48_META_API_1062_P1_D: "Rango aleatorio intervalo derecho, no se aleatorizará al valor relleno",
  T_48_META_API_1062_R_D: "Resultado aleatorio, entero",
  T_48_META_API_1063_D: "Generar un decimal aleatorio entre el decimal de valor mínimo (incluido) y el decimal de valor máximo (no incluido)",
  T_48_META_API_1063_P0_D: "Intervalo izquierdo de rango aleatorio, con una pequeña probabilidad de aleatoriedad al valor rellenado",
  T_48_META_API_1063_P1_D: "Rango aleatorio intervalo derecho, no se aleatorizará al valor relleno",
  T_48_META_API_1063_R_D: "Resultados aleatorios, decimales, con 7 decimales",
  T_48_META_API_1064_D: "Determinar si un objeto está vacío",
  T_48_META_API_1064_P0_D: "objeto vacío a juzgar",
  T_48_META_API_1064_R_D: "Está vacío",
  T_48_META_API_1065_D: "Inverso lógico, valor de entrada: verdadero o falso, valor de retorno: falso o verdadero",
  T_48_META_API_1065_P0_D: "Valores que deben solicitarse para no",
  T_48_META_API_1065_R_D: "El resultado de la no suma",
  T_48_META_API_1066_D: "Toma valores absolutos, admite enteros y decimales",
  T_48_META_API_1066_P0_D: "Valores para los que se requieren valores absolutos",
  T_48_META_API_1066_R_D: "El resultado de tomar valores absolutos",
  T_48_META_API_1067_D: "cálculo de la raíz cuadrada",
  T_48_META_API_1067_P0_D: "Necesidad de pedir el valor de la raíz cuadrada",
  T_48_META_API_1067_R_D: "El resultado de hallar la raíz cuadrada",
  T_48_META_API_1068_D: "Cálculo de valores negativos",
  T_48_META_API_1068_P0_D: "Valores negativos a solicitar",
  T_48_META_API_1068_R_D: "Resultados negativos",
  T_48_META_API_1069_D: "Unir dos cadenas",
  T_48_META_API_1069_P0_D: "valor izquierdo de una cadena",
  T_48_META_API_1069_P1_D: "valor derecho de una cadena",
  T_48_META_API_1069_R_D: "resultado de la concatenación de cadenas",
  T_48_META_API_1070_D: "Obtener longitud de cadena",
  T_48_META_API_1070_P0_D: "cadena",
  T_48_META_API_1070_R_D: "longitud de la cadena",
  T_48_META_API_1071_D: "Redondea el valor especificado al número entero más próximo.",
  T_48_META_API_1071_P0_D: "Valor a redondear por defecto",
  T_48_META_API_1071_R_D: "redondear al entero más próximo",
  T_48_META_API_1072_D: "Redondea el valor especificado al número entero más próximo.",
  T_48_META_API_1072_P0_D: "Valores a redondear",
  T_48_META_API_1072_R_D: "Resultados del redondeo",
  T_48_META_API_1073_D: "Redondea el valor especificado al número entero más próximo.",
  T_48_META_API_1073_P0_D: "Número de valores a redondear",
  T_48_META_API_1073_R_D: "resultado redondeado",
  T_48_META_API_1074_D: "Genera una nueva cadena después de reemplazar todas las cadenas especificadas en la cadena de destino",
  T_48_META_API_1074_P0_D: "cadena de destino",
  T_48_META_API_1074_P1_D: "La cadena antigua que debe sustituirse",
  T_48_META_API_1074_P2_D: "Nueva cadena para sustituir por",
  T_48_META_API_1074_R_D: "Sustitución de la cadena completada",
  T_48_META_API_1075_D: "Busca la primera aparición de una cadena especificada en la cadena de destino.",
  T_48_META_API_1075_P0_D: "cadena de destino",
  T_48_META_API_1075_P1_D: "La cadena especificada para buscar",
  T_48_META_API_1075_P2_D: "Busca la cadena desde la posición inicial, la posición de la cadena se cuenta desde 0",
  T_48_META_API_1075_R_D: "Especifica la posición de la primera aparición de la cadena en la cadena de destino, la posición de la cadena se cuenta desde 0.",
  T_48_META_API_1076_D: "Da salida a una nueva cadena tras interceptar una cadena de una longitud especificada desde una posición especificada.",
  T_48_META_API_1076_P0_D: "cadena de destino",
  T_48_META_API_1076_P1_D: "Posición en la que empezar a interceptar, la posición de la cadena se cuenta desde 0",
  T_48_META_API_1076_P2_D: "Longitud de intercepción, por defecto es hasta el final de la cadena.",
  T_48_META_API_1076_R_D: "Cadena interceptada",
  T_48_META_API_1077_D: "Compara dos listas con elementos idénticos, el tamaño de la lista no afecta al resultado.",
  T_48_META_API_1077_P0_D: "El valor izquierdo de la lista utilizado para la comparación",
  T_48_META_API_1077_P1_D: "El valor derecho de la lista utilizado para la comparación",
  T_48_META_API_1077_R_D: "Compare los resultados, la coherencia de contenido devuelve Verdadero, la incoherencia de contenido devuelve Falso.",
  T_48_META_API_1078_D: "Toma la cadena especificada como separador, corta la cadena de destino en un número de trozos y da salida a la nueva cadena, los N separadores consecutivos se cortarán en N-1 espacios de medio ancho como salida de los elementos de la lista de cadenas.",
  T_48_META_API_1078_P0_D: "cadena de destino",
  T_48_META_API_1078_P1_D: "cadena delimitadora",
  T_48_META_API_1078_R_D: "Produce una lista de cadenas, siempre terminada con un elemento de espacio de medio ancho",
  T_48_META_API_1079_D: "Extrae caracteres de la lista de posiciones de cadena y los combina en una nueva salida de cadena",
  T_48_META_API_1079_P0_D: "cadena de destino",
  T_48_META_API_1079_P1_D: "Lista de posiciones de cadena, posiciones de cadena contadas desde 0",
  T_48_META_API_1079_R_D: "Cadena de salida",
  T_48_META_API_1080_D: "Convierte todos los caracteres de la cadena de destino a mayúsculas",
  T_48_META_API_1080_P0_D: "cadena de destino",
  T_48_META_API_1080_R_D: "Cadena de salida",
  T_48_META_API_1081_D: "Convierte todos los caracteres de la cadena de destino a minúsculas",
  T_48_META_API_1081_P0_D: "cadena de destino",
  T_48_META_API_1081_R_D: "Cadena de salida",
  T_48_META_API_1082_D: "Elimina todos los espacios antes del primer carácter que no sea un espacio en blanco y después del último carácter que no sea un espacio en blanco de la cadena de destino.",
  T_48_META_API_1082_P0_D: "cadena de destino",
  T_48_META_API_1082_R_D: "Cadena de salida",
  T_48_META_API_1083_D: "Da salida a una nueva cadena después de enlazarla con un identificador especificado.",
  T_48_META_API_1083_P0_D: "Lista de cadenas objetivo",
  T_48_META_API_1083_P1_D: "Identificador especificado utilizado para concatenar cadenas",
  T_48_META_API_1083_R_D: "Cadena de salida",
  T_48_META_API_1084_D: "Escribe el valor correspondiente al identificador especificado en la tabla de datos de la clasificación",
  T_48_META_API_1084_P0_D: "Nombre de la tabla de clasificación en la base de datos",
  T_48_META_API_1084_P1_D: "identificador especificado",
  T_48_META_API_1084_P2_D: "Valor escrito",
  T_48_META_API_1084_P3_D: "El código del campo de batalla correspondiente a la base de datos, que se puede rellenar en blanco, representa el código del campo de batalla del mapa actual.",
  T_48_META_API_1084_P4_D: "código de error",
  T_48_META_API_1085_D: "Escribir el valor de desplazamiento correspondiente al identificador especificado en la tabla de datos acumulados.",
  T_48_META_API_1085_P0_D: "Nombre de la tabla de datos acumulados en la base de datos",
  T_48_META_API_1085_P1_D: "identificador especificado",
  T_48_META_API_1085_P2_D: "Tipos de operaciones cuadráticas",
  T_48_META_API_1085_P3_D: "Valor de offset escrito",
  T_48_META_API_1085_P4_D: "El código del campo de batalla correspondiente a la base de datos, que se puede rellenar en blanco, representa el código del campo de batalla del mapa actual.",
  T_48_META_API_1085_P5_D: "código de error",
  T_48_META_API_1086_D: "Elimina el valor correspondiente al identificador especificado en la tabla de datos.",
  T_48_META_API_1086_P0_D: "Nombres de tabla en la base de datos",
  T_48_META_API_1086_P1_D: "ID único del jugador",
  T_48_META_API_1086_P2_D: "identificador especificado",
  T_48_META_API_1086_P3_D: "El código del campo de batalla correspondiente a la base de datos, que se puede rellenar en blanco, representa el código del campo de batalla del mapa actual.",
  T_48_META_API_1086_P4_D: "código de error",
  T_48_META_API_1087_D: "Elimina el valor correspondiente al identificador especificado en la tabla de datos del gráfico.",
  T_48_META_API_1087_P0_D: "Nombre de la tabla de clasificación en la base de datos",
  T_48_META_API_1087_P1_D: "identificador especificado",
  T_48_META_API_1087_P2_D: "El código del campo de batalla correspondiente a la base de datos, que se puede rellenar en blanco, representa el código del campo de batalla del mapa actual.",
  T_48_META_API_1087_P3_D: "código de error",
  T_48_META_API_1088_D: "Elimina el valor correspondiente al rango especificado en la tabla Leaderboard.",
  T_48_META_API_1088_P0_D: "Nombre de la tabla de clasificación en la base de datos",
  T_48_META_API_1088_P1_D: "un puesto de prestigio",
  T_48_META_API_1088_P2_D: "El código del campo de batalla correspondiente a la base de datos, que se puede rellenar en blanco, representa el código del campo de batalla del mapa actual.",
  T_48_META_API_1088_P3_D: "código de error",
  T_48_META_API_1089_D: "Enviar un mensaje de usuario a Persona",
  T_48_META_API_1089_P0_D: "Objetivo PersonaID",
  T_48_META_API_1089_P1_D: "Mensaje",
  T_48_META_API_1090_D: "Enviar un mensaje de sistema a Persona",
  T_48_META_API_1090_P0_D: "Objetivo PersonaID",
  T_48_META_API_1090_P1_D: "Mensaje",
  T_48_META_API_1091_D: "Borrar la memoria de Persona",
  T_48_META_API_1091_P0_D: "código de error",
  T_48_META_API_1092_D: "Centro de Miembros Evoke",
  T_48_META_API_1092_P0_D: "código de error",
  T_48_META_API_1093_D: "Obtener la fecha de caducidad del miembro",
  T_48_META_API_1093_P0_D: "jugador objetivo",
  T_48_META_API_1093_P1_D: "marca de tiempo",
  T_48_META_API_1093_P2_D: "código de error",
  T_48_META_API_1094_D: "Determinar si un jugador es miembro",
  T_48_META_API_1094_P0_D: "código de error",
  T_48_META_API_1094_P1_D: "Si es usted miembro",
  T_48_META_API_1095_D: "Obtener la fecha de caducidad del miembro",
  T_48_META_API_1095_P0_D: "marca de tiempo",
  T_48_META_API_1095_P1_D: "código de error",
  T_48_META_API_1096_D: "Determinar si un jugador es miembro",
  T_48_META_API_1096_P0_D: "jugador objetivo",
  T_48_META_API_1096_P1_D: "código de error",
  T_48_META_API_1096_P2_D: "Si es usted miembro",
  T_48_META_API_1097_D: "Centro de Miembros Evoke",
  T_48_META_API_1097_P0_D: "jugador objetivo",
  T_48_META_API_1097_P1_D: "código de error",
  T_48_META_API_1099_D: "Configuración de observadores Persona, tras lo cual las conversaciones con Persona también se envían al observador.",
  T_48_META_API_1099_P0_D: "Objetivo PersonaID",
  T_48_META_API_1099_P1_D: "lista de vigilancia",
  T_48_META_API_11_D: "Finaliza la fase actual y pasa a la siguiente",
  T_48_META_API_1100_D: "Envío de mensajes de usuario a Persona mediante Streaming",
  T_48_META_API_1100_P0_D: "Objetivo PersonaID",
  T_48_META_API_1100_P1_D: "Mensaje",
  T_48_META_API_1101_D: "Envío de mensajes de sistema a Persona mediante streaming",
  T_48_META_API_1101_P0_D: "Objetivo PersonaID",
  T_48_META_API_1101_P1_D: "Mensaje",
  T_48_META_API_1101_P2_D: "Responder o no responder",
  T_48_META_API_1103_D: "Creación de semillas aleatorias",
  T_48_META_API_1103_P0_D: "torrente",
  T_48_META_API_1103_R_D: "Generador de números aleatorios",
  T_48_META_API_1104_D: "Obtiene el siguiente número aleatorio del generador de números aleatorios especificado, valor máximo 32767",
  T_48_META_API_1104_P0_D: "Generador de números aleatorios",
  T_48_META_API_1104_P1_D: "Alcance Mínimo",
  T_48_META_API_1104_P2_D: "Alcance Máximo",
  T_48_META_API_1104_R_D: "número aleatorio",
  T_48_META_API_1108_D: "Obtener el idioma del cliente utilizado por el reproductor",
  T_48_META_API_12_D: "Impresión de registros en la consola",
  T_48_META_API_12_P0_D: "Qué imprimir",
  T_48_META_API_13_D: "Produce una cadena con parámetros",
  T_48_META_API_13_P0_D: "Utilice el marcador de posición %v para un parámetro, el número de %v's y el número de parámetros tienen que ser el mismo.",
  T_48_META_API_13_P1_D: "La lista de parámetros que participan en la salida debe ser coherente con el número de %v en la descripción del formato",
  T_48_META_API_13_R_D: "Cadena de salida",
  T_48_META_API_14_D: "Limpieza de residuos de objetos del mapa, incluyendo cajas de muerte, objetos creados, objetos colocados, residuos de proyectiles, etc.",
  T_48_META_API_15_D: "Registros de entierros de concursos personalizados para el análisis de datos sobre la experiencia del usuario",
  T_48_META_API_15_P0_D: "Lista de nombres de campos que se deben notificar",
  T_48_META_API_15_P1_D: "Lista de valores de campo a notificar",
  T_48_META_API_1500_D: "Obtener el componente x del vector 3D",
  T_48_META_API_1500_P0_D: "Vector 3D",
  T_48_META_API_1500_R_D: "Componente x del vector 3D",
  T_48_META_API_1501_D: "Obtener el componente y del vector 3D",
  T_48_META_API_1501_P0_D: "Vector 3D",
  T_48_META_API_1501_R_D: "Componente Y del vector 3D",
  T_48_META_API_1502_D: "Obtener el componente z del vector 3D",
  T_48_META_API_1502_P0_D: "Vector 3D",
  T_48_META_API_1502_R_D: "Componente z del vector tridimensional",
  T_48_META_API_1503_D: "Establece el componente x del vector 3D",
  T_48_META_API_1503_P0_D: "Vector 3D",
  T_48_META_API_1503_P1_D: "Componente X",
  T_48_META_API_1504_D: "Establece el componente Y del vector 3D",
  T_48_META_API_1504_P0_D: "Vector 3D",
  T_48_META_API_1504_P1_D: "Componente Y",
  T_48_META_API_1505_D: "Establece el componente z del vector 3D",
  T_48_META_API_1505_P0_D: "Vector 3D",
  T_48_META_API_1505_P1_D: "Componente Z",
  T_48_META_API_1506_D: "Suma dos vectores 3D",
  T_48_META_API_1506_P0_D: "Valor izquierdo",
  T_48_META_API_1506_P1_D: "Valor derecho",
  T_48_META_API_1506_R_D: "Resultado de la suma de vectores 3D",
  T_48_META_API_1507_D: "Restar dos vectores 3D",
  T_48_META_API_1507_P0_D: "Valor izquierdo",
  T_48_META_API_1507_P1_D: "Valor derecho",
  T_48_META_API_1507_R_D: "El resultado de restar el valor derecho del valor izquierdo del vector 3D.",
  T_48_META_API_1508_D: "Escalado de vectores 3D",
  T_48_META_API_1508_P0_D: "Vectores 3D a escalar",
  T_48_META_API_1508_P1_D: "Desinflado vectorial 3D",
  T_48_META_API_1508_R_D: "Resultados del escalado vectorial 3D",
  T_48_META_API_1509_D: "Multiplica por puntos dos vectores 3D, el resultado de la multiplicación por puntos es un escalar",
  T_48_META_API_1509_P0_D: "Valor izquierdo",
  T_48_META_API_1509_P1_D: "Valor derecho",
  T_48_META_API_1509_R_D: "Resultado del producto escalar",
  T_48_META_API_1510_D: "Multiplicación cruzada de dos vectores 3D, el resultado de la multiplicación cruzada es un vector, perpendicular al plano donde se encuentran los dos vectores.",
  T_48_META_API_1510_P0_D: "Valor izquierdo",
  T_48_META_API_1510_P1_D: "Valor derecho",
  T_48_META_API_1510_R_D: "El resultado del producto cruz, orientado perpendicularmente al plano en el que se encuentran los dos vectores que intervienen en la operación.",
  T_48_META_API_1511_D: "Normalización de vectores 3D",
  T_48_META_API_1511_P0_D: "Vector 3D",
  T_48_META_API_1511_R_D: "Devuelve un nuevo vector normalizado. La longitud del módulo es 1",
  T_48_META_API_1512_D: "Modelización de vectores 3D",
  T_48_META_API_1512_P0_D: "Vector 3D",
  T_48_META_API_1512_R_D: "El resultado de la modelización, la longitud del vector módulo",
  T_48_META_API_1513_D: "Calcular la distancia euclidiana entre dos vectores 3D",
  T_48_META_API_1513_P0_D: "Valor izquierdo",
  T_48_META_API_1513_P1_D: "Valor derecho",
  T_48_META_API_1513_R_D: "Después de restar dos vectores, el módulo del vector resultante",
  T_48_META_API_1514_D: "Calcular el ángulo entre dos vectores 3D",
  T_48_META_API_1514_P0_D: "Valor izquierdo",
  T_48_META_API_1514_P1_D: "Valor derecho",
  T_48_META_API_1514_R_D: "Ángulo vectorial, rango de ángulos 0-180",
  T_48_META_API_1515_D: "Crear un vector 3D",
  T_48_META_API_1515_P0_D: "Componente X de un vector 3D",
  T_48_META_API_1515_P1_D: "Componente Y de un vector 3D",
  T_48_META_API_1515_P2_D: "Componente Z de un vector 3D",
  T_48_META_API_1515_R_D: "Vectores 3D creados",
  T_48_META_API_1516_D: "Obtener el punto de orientación de una nueva construcción (obsoleto, por favor no lo utilice)",
  T_48_META_API_1516_P0_D: "colocación",
  T_48_META_API_1516_P1_D: "girar hacia",
  T_48_META_API_1516_R_D: "DirectPoint",
  T_48_META_API_1517_D: "Tomar la posición del punto de dirección (obsoleto, no utilizar)",
  T_48_META_API_1517_P0_D: "punto de orientación",
  T_48_META_API_1517_R_D: "Posición",
  T_48_META_API_1518_D: "Tomar la orientación del punto de dirección (obsoleto, no utilizar)",
  T_48_META_API_1518_P0_D: "punto de orientación",
  T_48_META_API_1518_R_D: "Adelante",
  T_48_META_API_1519_D: "Crear una lista",
  T_48_META_API_1519_P0_D: "La longitud inicial de la lista, que debe ser inferior o igual a la capacidad inicial.",
  T_48_META_API_1519_P1_D: "La capacidad inicial de la lista debe ser mayor o igual que la longitud inicial. La capacidad puede ampliarse dinámicamente, pero consumirá algo de rendimiento, por lo que se recomienda establecer un valor adecuado al construir.",
  T_48_META_API_1519_R_D: "Crear una lista",
  T_48_META_API_1520_D: "Comprueba si la lista contiene el elemento especificado",
  T_48_META_API_1520_P0_D: "lista de objetivos",
  T_48_META_API_1520_P1_D: "El elemento especificado que debe comprobarse",
  T_48_META_API_1520_R_D: "Si contiene o no el elemento especificado",
  T_48_META_API_1521_D: "Añadir varios elementos al final de la lista de destino",
  T_48_META_API_1521_P0_D: "lista de objetivos",
  T_48_META_API_1521_P1_D: "Lista complementaria",
  T_48_META_API_1522_D: "Elimina el elemento especificado de la lista",
  T_48_META_API_1522_P0_D: "lista de objetivos",
  T_48_META_API_1522_P1_D: "El valor del elemento a eliminar",
  T_48_META_API_1523_D: "Obtiene el índice de la primera posición del elemento en la lista, si no hay ningún elemento objetivo en la lista, entonces se devuelve -1.",
  T_48_META_API_1523_P0_D: "lista de objetivos",
  T_48_META_API_1523_P1_D: "valor elemental",
  T_48_META_API_1523_R_D: "índice de localización",
  T_48_META_API_1524_D: "Obtiene el índice de la última posición del elemento en la lista, si no hay ningún elemento objetivo en la lista, devuelve -1.",
  T_48_META_API_1524_P0_D: "lista de objetivos",
  T_48_META_API_1524_P1_D: "valor elemental",
  T_48_META_API_1524_R_D: "índice de localización",
  T_48_META_API_1525_D: "Hallar el seno del ángulo",
  T_48_META_API_1525_P0_D: "Ángulo, 360 para 360 grados",
  T_48_META_API_1525_R_D: "sine",
  T_48_META_API_1526_D: "Hallar el coseno de un ángulo",
  T_48_META_API_1526_P0_D: "Ángulo, 360 para 360 grados",
  T_48_META_API_1526_R_D: "coseno",
  T_48_META_API_1527_D: "Hallar la tangente de un ángulo",
  T_48_META_API_1527_P0_D: "Ángulo, 360 para 360 grados",
  T_48_META_API_1527_R_D: "tangente",
  T_48_META_API_1528_D: "Construir un valor de color con transparencia fija en decimal 255, primero convertir el canal a un número binario, con cada 8 bits representando un canal, empalmados según R, G, B, y transparencia, y luego convertir ese número binario a tipo Int32 return",
  T_48_META_API_1528_P0_D: "El valor del canal rojo del color, en el rango [0,255], si excede el rango, se fijará al valor legal.",
  T_48_META_API_1528_P1_D: "El valor del canal verde del color, en el rango [0,255], si excede el rango, se fijará al valor legal.",
  T_48_META_API_1528_P2_D: "El valor del canal azul del color, en el rango [0,255], si excede el rango, se fijará al valor legal.",
  T_48_META_API_1528_R_D: "Valores de color construidos",
  T_48_META_API_1529_D: "Realiza una operación de seno inverso para obtener el ángulo",
  T_48_META_API_1529_P0_D: "Valor para el que se realiza la operación del seno inverso, en el rango [-1,1].",
  T_48_META_API_1529_R_D: "perspectivas",
  T_48_META_API_1530_D: "Realiza la operación del coseno inverso para obtener el ángulo",
  T_48_META_API_1530_P0_D: "El valor de la operación coseno inverso, en el rango [-1,1].",
  T_48_META_API_1530_R_D: "perspectivas",
  T_48_META_API_1531_D: "Realiza una operación de tangente inversa para obtener el ángulo",
  T_48_META_API_1531_P0_D: "Valor para el que se realiza la operación arctangente",
  T_48_META_API_1531_R_D: "perspectivas",
  T_48_META_API_1532_D: "Determina si la entidad objetivo está dentro de la esfera especificada, si la entidad no tiene atributos posicionales, devuelve false",
  T_48_META_API_1532_P0_D: "entidad de destino",
  T_48_META_API_1532_P1_D: "Especificar el centro de la esfera",
  T_48_META_API_1532_P2_D: "Especifique el radio de la esfera",
  T_48_META_API_1532_R_D: "Hallazgos",
  T_48_META_API_1533_D: "Determina si la entidad de destino se encuentra dentro del rango de cilindros especificado, si la entidad no tiene atributo de ubicación, devolverá false",
  T_48_META_API_1533_P0_D: "entidad de destino",
  T_48_META_API_1533_P1_D: "Especifique el centro del cilindro",
  T_48_META_API_1533_P2_D: "Especifique el radio de la sección transversal del cilindro",
  T_48_META_API_1533_P3_D: "Especifique la altura del cilindro",
  T_48_META_API_1533_P4_D: "Especificar el ángulo de Euler de un cilindro que gira en tres dimensiones alrededor de su punto central",
  T_48_META_API_1533_R_D: "Hallazgos",
  T_48_META_API_1534_D: "Determinar si la entidad de destino se encuentra dentro del rango de cubos especificado.",
  T_48_META_API_1534_P0_D: "entidad de destino",
  T_48_META_API_1534_P1_D: "Especifica el centro del cubo",
  T_48_META_API_1534_P2_D: "Especifique la longitud del cubo",
  T_48_META_API_1534_P3_D: "Especifique la anchura del cubo",
  T_48_META_API_1534_P4_D: "Especifica la altura del cubo",
  T_48_META_API_1534_P5_D: "Especifique los ángulos de Euler para la rotación tridimensional del cubo alrededor de su punto central",
  T_48_META_API_1534_R_D: "Hallazgos",
  T_48_META_API_1535_D: "Determinar si la entidad de destino se encuentra dentro de las columnas de sector especificadas.",
  T_48_META_API_1535_P0_D: "entidad de destino",
  T_48_META_API_1535_P1_D: "Especificar el centro del círculo de la sección media de una columna en forma de sector",
  T_48_META_API_1535_P2_D: "Especificar el radio de la sección central de una columna en forma de sector",
  T_48_META_API_1535_P3_D: "El radio de la sección transversal de la columna en forma de abanico que no se detectará, con el punto central en forma de círculo, no se detectará en esta región de columna en forma de abanico pequeña, sólo se detectará la diferencia entre la columna en ",
  T_48_META_API_1535_P4_D: "Especifique la altura de la columna en forma de abanico",
  T_48_META_API_1535_P5_D: "Detección de la sección transversal cilíndrica en forma de abanico del ángulo del centroide, superior a 360 cuando la detección de cilíndrico, inferior a 0 cuando el tamaño del área de detección es 0",
  T_48_META_API_1535_P6_D: "Especifique el ángulo de Euler de rotación de la columna en forma de abanico alrededor del punto central en tres lugares",
  T_48_META_API_1535_R_D: "Hallazgos",
  T_48_META_API_1536_D: "Compara el valor de dos números y devuelve el mayor",
  T_48_META_API_1536_P0_D: "Valor izquierdo",
  T_48_META_API_1536_P1_D: "Valor derecho",
  T_48_META_API_1536_R_D: "cifra mayor",
  T_48_META_API_1537_D: "Devuelve el valor máximo de la lista",
  T_48_META_API_1537_P0_D: "Lista de destino, sólo acepta elementos de lista de tipo numérico",
  T_48_META_API_1537_P1_D: "Compara los resultados, si hay no-números en la lista, etc., la comparación falla y devuelve false.",
  T_48_META_API_1537_P2_D: "Devuelve el mayor valor de la lista si la comparación tiene éxito, o 0 si la comparación falla.",
  T_48_META_API_1538_D: "Compara el valor de dos números y devuelve el menor",
  T_48_META_API_1538_P0_D: "Valor izquierdo",
  T_48_META_API_1538_P1_D: "Valor derecho",
  T_48_META_API_1538_R_D: "Cifras más pequeñas",
  T_48_META_API_1539_D: "Devuelve el valor más pequeño de la lista.",
  T_48_META_API_1539_P0_D: "Lista de destino, sólo acepta elementos de lista de tipo numérico",
  T_48_META_API_1539_P1_D: "Compara los resultados, si hay no-números en la lista, etc., la comparación falla y devuelve false.",
  T_48_META_API_1539_P2_D: "Devuelve el valor más pequeño de la lista si la comparación tiene éxito, o 0 si la comparación falla.",
  T_48_META_API_1540_D: "Interpolación lineal, devolviendo el valor correspondiente al progreso de interpolación entre el valor inicial y el valor objetivo, coeficientes de interpolación [0,1].",
  T_48_META_API_1540_P0_D: "Valor de inicio de la interpolación lineal, que se devuelve cuando el progreso de la interpolación es 0.",
  T_48_META_API_1540_P1_D: "Valor objetivo de interpolación lineal, que se devuelve cuando el progreso de la interpolación es 1",
  T_48_META_API_1540_P2_D: "Progreso de interpolación, el rango de valores [0,1], el valor de 0 para volver al valor inicial, el valor de 1 para volver al valor objetivo, el valor de 0,5 para volver a la media del valor inicial y el valor objetivo.",
  T_48_META_API_1540_R_D: "Valor de retorno de la interpolación lineal",
  T_48_META_API_1541_D: "Limitar el rango del valor objetivo, obtener el valor en el medio de las tres entradas; su función es limitar el valor objetivo al rango especificado, el valor objetivo es menor que el valor mínimo para volver al valor más pequeño, mayor que el valor máxi",
  T_48_META_API_1541_P0_D: "valor objetivo",
  T_48_META_API_1541_P1_D: "Valor mínimo del intervalo límite",
  T_48_META_API_1541_P2_D: "Valor máximo del rango límite",
  T_48_META_API_1541_R_D: "Valor de retorno tras la restricción",
  T_48_META_API_1542_D: "Obtener los valores de canal del color de destino",
  T_48_META_API_1542_P0_D: "color de destino",
  T_48_META_API_1542_P1_D: "Valor R del color, en el rango [0 , 255].",
  T_48_META_API_1542_P2_D: "Valor G del color, rango [0 , 255].",
  T_48_META_API_1542_P3_D: "Valor B del color, rango [0 , 255].",
  T_48_META_API_1542_P4_D: "Valor A del color, en el rango [0 , 255].",
  T_48_META_API_1543_D: "la operación de potencia",
  T_48_META_API_1543_P0_D: "base",
  T_48_META_API_1543_P1_D: "exponentes",
  T_48_META_API_1543_R_D: "resultado del cálculo",
  T_48_META_API_1544_D: "operación logarítmica",
  T_48_META_API_1544_P0_D: "base",
  T_48_META_API_1544_P1_D: "logaritmo",
  T_48_META_API_1544_R_D: "resultado del cálculo",
  T_48_META_API_1545_D: "Vector de dirección del ángulo de Euler",
  T_48_META_API_1545_P0_D: "vector de dirección",
  T_48_META_API_1545_R_D: "Ángulo de Euler",
  T_48_META_API_1546_D: "Vector de dirección de giro del ángulo de Euler",
  T_48_META_API_1546_P0_D: "Ángulo de Euler",
  T_48_META_API_1546_R_D: "vector de dirección",
  T_48_META_API_1547_D: "número entero a número en coma flotante",
  T_48_META_API_1547_P0_D: "entero",
  T_48_META_API_1547_R_D: "coma flotante",
  T_48_META_API_1548_D: "Rota el vector objetivo según el cuaternión",
  T_48_META_API_1548_P0_D: "vector objetivo",
  T_48_META_API_1548_P1_D: "cuaternión giratorio",
  T_48_META_API_1548_R_D: "vector girado",
  T_48_META_API_1549_D: "Convertir número objetivo en cadena",
  T_48_META_API_1549_P0_D: "Número de destino de la cadena a convertir",
  T_48_META_API_1549_P1_D: "Formato de la cadena numérica de salida",
  T_48_META_API_1549_R_D: "cadena",
  T_48_META_API_1598_D: "Obtener la fecha y hora del servidor",
  T_48_META_API_1598_R_D: "Devuelve el número de segundos transcurridos desde las 0:0:0 del 1 de enero de 1970",
  T_48_META_API_1599_D: "Obtener área del servidor",
  T_48_META_API_1599_R_D: "Volver a Abreviaturas regionales (BR,SAC,ID,NA,US,IND,SG,BD,VN,TH,ME,RU,EU,PK,TW)",
  T_48_META_API_16_D: "Registros de enterramiento de usuarios personalizados para el análisis de datos sobre la experiencia del usuario",
  T_48_META_API_16_P0_D: "Para hacer un seguimiento de los jugadores denunciados",
  T_48_META_API_16_P1_D: "Lista de nombres de campos que se deben notificar",
  T_48_META_API_16_P2_D: "Lista de valores de campo a notificar",
  T_48_META_API_1601_D: "Creación de un diccionario",
  T_48_META_API_1601_R_D: "Diccionario creado",
  T_48_META_API_1602_D: "Obtener el valor correspondiente a la clave especificada en el diccionario",
  T_48_META_API_1602_P0_D: "Diccionario de objetivos",
  T_48_META_API_1602_P1_D: "Llave",
  T_48_META_API_1602_R_D: "Valor",
  T_48_META_API_1603_D: "Establece el valor correspondiente a la clave especificada en el diccionario",
  T_48_META_API_1603_P0_D: "Diccionario de objetivos",
  T_48_META_API_1603_P1_D: "Llave",
  T_48_META_API_1603_P2_D: "Valor",
  T_48_META_API_1604_D: "Elimina el par clave-valor especificado del diccionario",
  T_48_META_API_1604_P0_D: "Diccionario de objetivos",
  T_48_META_API_1604_P1_D: "Llave",
  T_48_META_API_1605_D: "Borrar todos los pares clave-valor del diccionario",
  T_48_META_API_1605_P0_D: "Diccionario de objetivos",
  T_48_META_API_1606_D: "Obtener el número de pares clave-valor del diccionario",
  T_48_META_API_1606_P0_D: "Diccionario de objetivos",
  T_48_META_API_1606_R_D: "Longitud del diccionario",
  T_48_META_API_1607_D: "Determinar si una clave existe en un diccionario",
  T_48_META_API_1607_P0_D: "Diccionario de objetivos",
  T_48_META_API_1607_P1_D: "Llave",
  T_48_META_API_1607_R_D: "¿Existe?",
  T_48_META_API_1608_D: "Obtiene todas las claves del diccionario y las devuelve como una lista.",
  T_48_META_API_1608_P0_D: "Diccionario de objetivos",
  T_48_META_API_1608_R_D: "Lista de todos los valores clave",
  T_48_META_API_17_D: "Utilice un área de movimiento lineal en forma de caja para la detección y devuelva todas las entidades encontradas en la ruta del área en forma de caja de cerca a lejos. Si inicialmente están dentro del rango en forma de caja, no serán detectadas; si los parámetros jerárquicos se completan en los espacios en blanco, se pueden detectar terreno.",
  T_48_META_API_17_P0_D: "La mitad de la longitud de los tres lados de la región encajonada, sólo se aceptan valores positivos.",
  T_48_META_API_17_P1_D: "Punto central del área recuadrada",
  T_48_META_API_17_P2_D: "Rotación del área de la caja",
  T_48_META_API_17_P3_D: "Sentido de la marcha en la zona recuadrada",
  T_48_META_API_17_P4_D: "Distancia recorrida en el área del recuadro, sólo se aceptan valores positivos",
  T_48_META_API_17_P5_D: "Máscara de capa, sólo las capas rellenas participarán en el escaneado, si se deja en blanco todas las capas participarán en el escaneado.",
  T_48_META_API_17_P6_D: "Si se puede detectar el desencadenante",
  T_48_META_API_17_P7_D: "Lista de entidades afectadas",
  T_48_META_API_1700_D: "Convertir una cadena en un número entero",
  T_48_META_API_1700_P0_D: "cadena de destino",
  T_48_META_API_1700_P1_D: "entero resultante",
  T_48_META_API_1700_P2_D: "Si la conversión se ha realizado correctamente o no",
  T_48_META_API_1701_D: "Convertir una cadena en un número de coma flotante",
  T_48_META_API_1701_P0_D: "cadena de destino",
  T_48_META_API_1701_P1_D: "flotador resultante",
  T_48_META_API_1701_P2_D: "Si la conversión se ha realizado correctamente o no",
  T_48_META_API_18_D: "Utilice un área esférica en movimiento en línea recta para la detección y devuelva todas las entidades encontradas en la ruta del área esférica de cerca a lejos. Si inicialmente están en el área esférica, no se detectarán si el parámetro de nivel se completa en el espacio en blanco; , se puede detectar el terreno",
  T_48_META_API_18_P0_D: "Radio de la región esférica, sólo se aceptan valores positivos",
  T_48_META_API_18_P1_D: "punto central del área esférica",
  T_48_META_API_18_P2_D: "Dirección de desplazamiento en el área esférica",
  T_48_META_API_18_P3_D: "Distancia de desplazamiento del área esférica, sólo se aceptan valores positivos",
  T_48_META_API_18_P4_D: "Máscara de capa, sólo las capas rellenas participarán en el escaneado, si se deja en blanco todas las capas participarán en el escaneado.",
  T_48_META_API_18_P5_D: "Si se puede detectar el desencadenante",
  T_48_META_API_18_P6_D: "Lista de entidades afectadas",
  T_48_META_API_19_D: "Utilice un área de cápsula que se mueva linealmente para la detección y devuelva todas las entidades encontradas en la ruta del área de la cápsula de cerca a lejos. Si inicialmente están dentro del área de la cápsula, no se detectarán si se completa el parámetro de nivel; se puede detectar el terreno.",
  T_48_META_API_19_P0_D: "Radio de la semiesfera en cada extremo de la región del cuerpo de la cápsula, sólo se aceptan valores positivos.",
  T_48_META_API_19_P1_D: "La distancia entre los centros esféricos de los hemisferios de cada extremo de la región del cuerpo de la cápsula, que debe ser superior a dos veces el radio de los hemisferios de cada extremo.",
  T_48_META_API_19_P2_D: "Punto central de la región del cuerpo de la cápsula",
  T_48_META_API_19_P3_D: "Rotación de la región del cuerpo capsular",
  T_48_META_API_19_P4_D: "Dirección de desplazamiento en la región del cuerpo de la cápsula",
  T_48_META_API_19_P5_D: "La distancia recorrida en el área de la cápsula, solo se aceptan valores positivos",
  T_48_META_API_19_P6_D: "Máscara de capa, sólo las capas rellenas participarán en el escaneado, si se deja en blanco todas las capas participarán en el escaneado.",
  T_48_META_API_19_P7_D: "Si se puede detectar el desencadenante",
  T_48_META_API_19_P8_D: "Lista de entidades afectadas",
  T_48_META_API_2_D: "Obtiene todos los equipos del juego actual y devuelve la lista de equipos.",
  T_48_META_API_2_R_D: "Lista de equipos",
  T_48_META_API_20_D: "Utilice un área estática en forma de caja para la detección y devuelva todas las entidades dentro del área en forma de caja. Si el parámetro de nivel se completa en los espacios en blanco, se puede detectar el terreno.",
  T_48_META_API_20_P0_D: "La mitad de la longitud de los tres lados de la región encajonada, sólo se aceptan valores positivos.",
  T_48_META_API_20_P1_D: "Punto central del área recuadrada",
  T_48_META_API_20_P2_D: "Rotación del área de la caja",
  T_48_META_API_20_P3_D: "Máscara de capa, sólo las capas rellenas participarán en el escaneado, si se deja en blanco todas las capas participarán en el escaneado.",
  T_48_META_API_20_P4_D: "Si se puede detectar el desencadenante",
  T_48_META_API_20_P5_D: "Lista de entidades afectadas",
  T_48_META_API_2000_D: "Para establecer el valor de un atributo de la entidad de destino es necesario que el atributo ya haya sido definido.",
  T_48_META_API_2000_P0_D: "entidad de destino",
  T_48_META_API_2000_P1_D: "Un atributo de la entidad de destino",
  T_48_META_API_2000_P2_D: "El valor de destino, que debe coincidir con el tipo requerido cuando se definió la propiedad.",
  T_48_META_API_2000_P3_D: "Todos los tipos admiten la asignación, y los tipos numéricos admiten la autoadición, la autosuma, la automultiplicación, la autodivisión y la autosuma.",
  T_48_META_API_2001_D: "Obtener el valor de un atributo de una entidad",
  T_48_META_API_2001_P0_D: "entidad de destino",
  T_48_META_API_2001_P1_D: "El ID de un atributo de esta entidad",
  T_48_META_API_2001_R_D: "valor de un atributo",
  T_48_META_API_2002: "Establecer propiedad de gráfico",
  T_48_META_API_2002_D: "Configuración de variables de script",
  T_48_META_API_2002_P0_D: "entidad de destino",
  T_48_META_API_2002_P1: "Identificación del gráfico",
  T_48_META_API_2002_P1_D: "ID del script de destino",
  T_48_META_API_2002_P2: "Identificación de la propiedad",
  T_48_META_API_2002_P2_D: "ID de la propiedad miembro definida en el script",
  T_48_META_API_2002_P3: "Valor de la propiedad",
  T_48_META_API_2002_P3_D: "El valor de destino, que debe coincidir con el tipo requerido cuando se definió la propiedad.",
  T_48_META_API_2002_P4_D: "Todos los tipos admiten la asignación, y los tipos numéricos admiten la autoadición, la autosuma, la automultiplicación, la autodivisión y la autosuma.",
  T_48_META_API_2003: "Obtener propiedad gráfica",
  T_48_META_API_2003_D: "Obtención de variables de script",
  T_48_META_API_2003_P0_D: "entidad de destino",
  T_48_META_API_2003_P1: "Identificación del gráfico",
  T_48_META_API_2003_P1_D: "ID del script de destino",
  T_48_META_API_2003_P2: "Identificación de la propiedad",
  T_48_META_API_2003_P2_D: "ID del atributo de destino",
  T_48_META_API_2003_R_D: "valor de un atributo",
  T_48_META_API_2004_D: "Define e inicializa una variable local, cuyo ámbito se extiende desde la posición de declaración hasta el final del bloque de sentencias en el que se encuentra.",
  T_48_META_API_2004_P0_D: "nombre de la variable",
  T_48_META_API_2004_P1_D: "valor inicial variable",
  T_48_META_API_2004_P2_D: "Tipo de declaración de la variable, la asignación debe coincidir con el tipo declarado",
  T_48_META_API_2005_D: "Establecer el valor de una variable local, que se extiende desde la posición de declaración hasta el final del bloque de instrucciones en el que se encuentra.",
  T_48_META_API_2005_P0_D: "nombre de la variable",
  T_48_META_API_2005_P1: "Valor variable",
  T_48_META_API_2005_P1_D: "valor variable",
  T_48_META_API_2005_P2_D: "Todos los tipos admiten la asignación, y los tipos numéricos admiten la autoadición, la autosuma, la automultiplicación, la autodivisión y la autosuma.",
  T_48_META_API_2006: "Obtener variable local",
  T_48_META_API_2006_D: "Obtiene el valor de una variable local, cuyo ámbito abarca desde la posición de declaración hasta el final del bloque de sentencia.",
  T_48_META_API_2006_P0: "Nombre de la variable",
  T_48_META_API_2006_P0_D: "nombre de la variable",
  T_48_META_API_2006_R_D: "valor variable",
  T_48_META_API_2009: "Busque e invoque una API personalizada global con serial",
  T_48_META_API_2009_D: "Llama a funciones personalizadas globales de forma serial, y si hay una espera en la función personalizada, la ubicación de la llamada también espera",
  T_48_META_API_2009_P0: "Identificación del gráfico",
  T_48_META_API_2009_P0_D: "ID del script donde reside la función personalizada",
  T_48_META_API_2009_P1: "Identificación de función",
  T_48_META_API_2009_P1_D: "ID de la función personalizada llamada",
  T_48_META_API_2009_P2_D: "Lista de argumentos pasados a la función personalizada",
  T_48_META_API_2010: "Busque e invoque una API personalizada global con Parallel",
  T_48_META_API_2010_D: "Llama a funciones personalizadas globales de forma paralela, volviendo inmediatamente a la ubicación de la llamada para continuar por la línea, independientemente de si hay o no una espera en la función personalizada.",
  T_48_META_API_2010_P0: "Identificación del gráfico",
  T_48_META_API_2010_P0_D: "ID del script donde reside la función personalizada",
  T_48_META_API_2010_P1: "Identificación de función",
  T_48_META_API_2010_P1_D: "ID de la función personalizada llamada",
  T_48_META_API_2010_P2_D: "Lista de argumentos pasados a la función personalizada",
  T_48_META_API_2013: "Establecer propiedad de gráfico propio",
  T_48_META_API_2013_D: "Establecer variables para el script actual",
  T_48_META_API_2013_P0: "Identificación de la propiedad",
  T_48_META_API_2013_P0_D: "ID del atributo de destino",
  T_48_META_API_2013_P1: "Valor de la propiedad",
  T_48_META_API_2013_P1_D: "valor objetivo",
  T_48_META_API_2013_P2_D: "Todos los tipos admiten la asignación, y los tipos numéricos admiten la autoadición, la autosuma, la automultiplicación, la autodivisión y la autosuma.",
  T_48_META_API_2014: "Obtener la propiedad del gráfico propio",
  T_48_META_API_2014_D: "Obtención de variables para el script actual",
  T_48_META_API_2014_P0: "Identificación de la propiedad",
  T_48_META_API_2014_P0_D: "ID del atributo de destino",
  T_48_META_API_2014_R_D: "valor de un atributo",
  T_48_META_API_21_D: "Utilice un área esférica estática para la detección y devuelva todas las entidades dentro del área esférica. Si el parámetro de nivel se completa en los espacios en blanco, se puede detectar el terreno.",
  T_48_META_API_21_P0_D: "Radio de la región esférica, sólo se aceptan valores positivos",
  T_48_META_API_21_P1_D: "punto central del área esférica",
  T_48_META_API_21_P2_D: "Máscara de capa, sólo las capas rellenas participarán en el escaneado, si se deja en blanco todas las capas participarán en el escaneado.",
  T_48_META_API_21_P3_D: "Si se puede detectar el desencadenante",
  T_48_META_API_21_P4_D: "Lista de entidades afectadas",
  T_48_META_API_22_D: "Utilice un área de cápsula estática para la detección y devuelva todas las entidades dentro del área de la cápsula. Si se completa el parámetro de nivel, se puede detectar el terreno.",
  T_48_META_API_22_P0_D: "Radio de la semiesfera en cada extremo de la región del cuerpo de la cápsula, sólo se aceptan valores positivos.",
  T_48_META_API_22_P1_D: "La distancia entre los centros esféricos de los hemisferios de cada extremo de la región del cuerpo de la cápsula, que debe ser superior a dos veces el radio de los hemisferios de cada extremo.",
  T_48_META_API_22_P2_D: "Punto central de la región del cuerpo de la cápsula",
  T_48_META_API_22_P3_D: "Rotación de la región del cuerpo capsular",
  T_48_META_API_22_P4_D: "Máscara de capa, sólo las capas rellenas participarán en el escaneado, si se deja en blanco todas las capas participarán en el escaneado.",
  T_48_META_API_22_P5_D: "Si se puede detectar el desencadenante",
  T_48_META_API_22_P6_D: "Lista de entidades afectadas",
  T_48_META_API_23_D: "Establece el estado de objeto especial para el jugador, los objetos especiales sólo pueden tener un",
  T_48_META_API_23_P0_D: "jugador",
  T_48_META_API_23_P1_D: "Número de artículo",
  T_48_META_API_23_P2_D: "Habilitar o no el elemento",
  T_48_META_API_23_P3_D: "sustancia especial",
  T_48_META_API_24_D: "Aplica una fuerza al objetivo, que debe ser un objeto físico.",
  T_48_META_API_24_P0_D: "objeto físico de destino",
  T_48_META_API_24_P1_D: "vector de fuerza",
  T_48_META_API_24_P2_D: "Tipo de fuerza",
  T_48_META_API_25_D: "Aplicar una fuerza una vez en un punto, el objetivo debe ser un cuerpo rígido",
  T_48_META_API_25_P0_D: "cuerpo rígido objetivo",
  T_48_META_API_25_P1_D: "vector de fuerza",
  T_48_META_API_25_P2_D: "Posición de aplicación de la fuerza",
  T_48_META_API_25_P3_D: "Tipo de fuerza",
  T_48_META_API_26_D: "Aplica un par de torsión al objetivo, que debe ser rígido.",
  T_48_META_API_26_P0_D: "cuerpo rígido objetivo",
  T_48_META_API_26_P1_D: "torsión",
  T_48_META_API_26_P2_D: "Tipo de fuerza aplicada",
  T_48_META_API_27_D: "Mover el cuerpo rígido de destino a la posición especificada",
  T_48_META_API_27_P0_D: "cuerpo rígido objetivo",
  T_48_META_API_27_P1_D: "lugar designado",
  T_48_META_API_28_D: "Rotar el cuerpo rígido de destino",
  T_48_META_API_28_P0_D: "cuerpo rígido objetivo",
  T_48_META_API_28_P1_D: "cuaternión giratorio",
  T_48_META_API_29_D: "Crea un movimiento interpolado en el que las propiedades especificadas de la entidad de destino se suavizan de acuerdo con la configuración.",
  T_48_META_API_29_P0_D: "entidad de destino",
  T_48_META_API_29_P1_D: "ID de atributos que requieren cambios de movimiento",
  T_48_META_API_29_P2_D: "Valor inicial del atributo",
  T_48_META_API_29_P3_D: "Valor final del atributo",
  T_48_META_API_29_P4_D: `Puede elegir entre simple, bucle y reciprocante. 
 Bucle significa que, tras cada movimiento, la entidad se moverá de nuevo desde el valor inicial. Reciprocante significa que, tras completar el movimiento del valor inicial al valor objetivo, la entidad se moverá de nuevo desde el valor objetivo al valor inicial y repetirá el proceso.`,
  T_48_META_API_29_P5_D: "Punto de control de la curva de Bessel",
  T_48_META_API_29_P6_D: "Duración de un cambio en milisegundos",
  T_48_META_API_29_P7_D: "Entidades de movimiento interpoladas creadas",
  T_48_META_API_29_P8_D: "Si la reproducción se inicia automáticamente tras la creación",
  T_48_META_API_3_D: "Al cambiar a la fase objetivo, el turno también es una fase especial. Al cambiar a una fase en una ronda, la cuenta de rondas es 0.",
  T_48_META_API_3_P0_D: "Índice de rondas o fases objetivo",
  T_48_META_API_30_D: "Obliga al jugador objetivo a entrar en el vehículo especificado",
  T_48_META_API_30_P0_D: "jugador objetivo",
  T_48_META_API_30_P1_D: "entidad transportista",
  T_48_META_API_30_P2_D: "Número de asiento",
  T_48_META_API_30_P3_D: "Si consigue o no que el jugador entre en el transportista",
  T_48_META_API_3001_D: "Haz que el jugador objetivo descarte un objeto",
  T_48_META_API_3001_P0_D: "jugador objetivo",
  T_48_META_API_3001_P1_D: "entidad física",
  T_48_META_API_3002_D: "Obtiene las coordenadas disponibles dentro del punto de nacimiento aleatorio actualmente disponible que no está completamente ocupado (obsoleto, usa GetRandomSpawnPosition)",
  T_48_META_API_3002_P0_D: "Jugadores a los que hay que asignar una zona de nacimiento",
  T_48_META_API_3002_R_D: "Coordenadas de puntos aleatorios asignados al azar",
  T_48_META_API_3003_D: "Obtener la puntuación total del jugador para el tipo de punto especificado",
  T_48_META_API_3003_P0_D: "jugador",
  T_48_META_API_3003_P1_D: "Tipo de puntos",
  T_48_META_API_3003_R_D: "valor en puntos",
  T_48_META_API_3004_D: "Establecer la puntuación de la ronda para el tipo de punto especificado de un jugador",
  T_48_META_API_3004_P0_D: "entidad jugadora",
  T_48_META_API_3004_P1_D: "Tipo de puntos",
  T_48_META_API_3004_P2_D: "valor en puntos",
  T_48_META_API_3005_D: "Obtener la puntuación total del equipo para el tipo de punto especificado",
  T_48_META_API_3005_P0_D: "entidad del equipo",
  T_48_META_API_3005_P1_D: "Tipo de puntos",
  T_48_META_API_3005_R_D: "valor en puntos",
  T_48_META_API_3006_D: "Establecer la puntuación de la ronda para el tipo de punto especificado de un equipo",
  T_48_META_API_3006_P0_D: "entidad del equipo",
  T_48_META_API_3006_P1_D: "Tipo de puntos",
  T_48_META_API_3006_P2_D: "valor en puntos",
  T_48_META_API_3007_D: "Obtener la puntuación del jugador para la ronda y el tipo de punto especificados",
  T_48_META_API_3007_P0_D: "entidad jugadora",
  T_48_META_API_3007_P1_D: "Índice Redondo",
  T_48_META_API_3007_P2_D: "Tipo de puntos",
  T_48_META_API_3007_R_D: "valor en puntos",
  T_48_META_API_3008_D: "Obtener la puntuación del equipo para la ronda especificada, tipo de punto",
  T_48_META_API_3008_P0_D: "entidad del equipo",
  T_48_META_API_3008_P1_D: "Índice Redondo",
  T_48_META_API_3008_P2_D: "Tipo de puntos",
  T_48_META_API_3008_R_D: "valor en puntos",
  T_48_META_API_3009_D: "Obtener la clasificación general del juego del jugador",
  T_48_META_API_3009_P0_D: "entidad jugadora",
  T_48_META_API_3009_R_D: "posición en una clasificación de nombres",
  T_48_META_API_3011_D: "Obtener la clasificación general del juego del equipo",
  T_48_META_API_3011_P0_D: "abandonado",
  T_48_META_API_3011_R_D: "posición en una clasificación de nombres",
  T_48_META_API_3013_D: "Obtener la clasificación del jugador en una ronda determinada",
  T_48_META_API_3013_P0_D: "entidad jugadora",
  T_48_META_API_3013_P1_D: "Índice Redondo",
  T_48_META_API_3013_R_D: "posición en una clasificación de nombres",
  T_48_META_API_3014_D: "Obtener la clasificación de los equipos para una ronda determinada",
  T_48_META_API_3014_P0_D: "abandonado",
  T_48_META_API_3014_P1_D: "Índice Redondo",
  T_48_META_API_3014_R_D: "posición en una clasificación de nombres",
  T_48_META_API_3015_D: "Obtener la cartera de la entidad de destino",
  T_48_META_API_3015_P0_D: "entidad de destino",
  T_48_META_API_3015_P1_D: "Presencia de una cartera",
  T_48_META_API_3015_P2_D: "Entidad de billetera obtenida",
  T_48_META_API_3016_D: "Crea un monedero para el jugador objetivo, no es válido si el jugador ya tiene un monedero.",
  T_48_META_API_3016_P0_D: "jugador objetivo",
  T_48_META_API_3016_P1_D: "Entidad vinculada al monedero, propietario del monedero",
  T_48_META_API_3016_P2_D: "entidad monedero",
  T_48_META_API_3017_D: "Añadir divisas a un monedero específico",
  T_48_META_API_3017_P0_D: "Monedero objetivo",
  T_48_META_API_3017_P1_D: "Tipo de moneda añadido",
  T_48_META_API_3017_P2_D: "Aumento del número de monedas",
  T_48_META_API_3018_D: "Reducción de divisas para un monedero determinado",
  T_48_META_API_3018_P0_D: "Monedero objetivo",
  T_48_META_API_3018_P1_D: "Tipo de moneda reducido",
  T_48_META_API_3018_P2_D: "Reducción del número de monedas",
  T_48_META_API_3019_D: "Transferencia de divisas de un monedero a otro",
  T_48_META_API_3019_P0_D: "Monederos para transferir divisas",
  T_48_META_API_3019_P1_D: "Tipos de transferencias",
  T_48_META_API_3019_P2_D: "Número de divisas transferidas",
  T_48_META_API_3019_P3_D: "Cartera a la que se transfiere la moneda",
  T_48_META_API_3020_D: "Obtener el número de divisas de un tipo dado en un monedero determinado",
  T_48_META_API_3020_P0_D: "Monedero objetivo",
  T_48_META_API_3020_P1_D: "Tipo de moneda de la consulta",
  T_48_META_API_3020_R_D: "Importe de la divisa",
  T_48_META_API_3021_D: "Obtener las entidades del tipo de moneda especificado en el monedero especificado",
  T_48_META_API_3021_P0_D: "Monedero objetivo",
  T_48_META_API_3021_P1_D: "Tipo de moneda de la consulta",
  T_48_META_API_3021_R_D: "Entidades monetarias",
  T_48_META_API_3022_D: "Obtén todas las tiendas del juego, devuélvelas en forma de lista",
  T_48_META_API_3022_R_D: "Lista de entidades de la tienda",
  T_48_META_API_3023_D: "Sustituye la forma del reproductor de destino por la forma de un objeto de escena especificado.",
  T_48_META_API_3023_P0_D: "jugador objetivo",
  T_48_META_API_3023_P1_D: "Objetos de escena de destino para sustitución",
  T_48_META_API_3023_P2_D: "Sustitución del componente de camuflaje de transformación del jugador creado después del",
  T_48_META_API_3024_D: "Anula el estado de camuflaje del jugador",
  T_48_META_API_3024_P0_D: "jugador objetivo",
  T_48_META_API_3025_D: "Crear un alter ego en forma de entidad de escena en el jugador objetivo.",
  T_48_META_API_3025_P0_D: "jugador objetivo",
  T_48_META_API_3025_P1_D: "Entidades de escena para imágenes divididas",
  T_48_META_API_3025_P2_D: "Entidades de bilocación creadas",
  T_48_META_API_3026_D: "Obtención de la entidad camuflada del jugador",
  T_48_META_API_3026_P0_D: "jugador",
  T_48_META_API_3026_R_D: "Jugadores que disfrazan entidades",
  T_48_META_API_3027_D: "Obtener entidad de canal de chat por índice",
  T_48_META_API_3027_P0_D: "Índice del canal de chat, rango [1,8]",
  T_48_META_API_3027_R_D: "Entidades del canal de chat",
  T_48_META_API_3028_D: "Obtiene la entidad del canal de chat en el que se encuentra actualmente el jugador especificado",
  T_48_META_API_3028_P0_D: "jugador objetivo",
  T_48_META_API_3028_R_D: "Entidades del canal de chat",
  T_48_META_API_3029_D: "Permitir que los jugadores se unan al canal de chat designado, y cambiar al canal objetivo cuando los jugadores ya están en otros canales de chat.",
  T_48_META_API_3029_P0_D: "jugador objetivo",
  T_48_META_API_3029_P1_D: "Entidades del canal de chat",
  T_48_META_API_3030_D: "Hace que el jugador salga del canal en el que se encuentra actualmente, y queda en un estado en el que no está en ningún canal de chat después de eso",
  T_48_META_API_3030_P0_D: "jugador objetivo",
  T_48_META_API_3031_D: "abandonado",
  T_48_META_API_3031_P0_D: "Entidad del canal de chat, vacía cuando no hay ningún jugador en el canal",
  T_48_META_API_3032_D: "Establecer el estado de comportamiento del jugador",
  T_48_META_API_3032_P0_D: "jugador objetivo",
  T_48_META_API_3032_P1_D: "Tipos de comportamiento de los jugadores",
  T_48_META_API_3032_P2_D: `Habilitado: el botón HUD está disponible, normalmente utilizable
 Deshabilitado: el botón HUD está deshabilitado, no se puede acceder al estado de comportamiento de forma activa o pasiva
 Enmascarado: el botón HUD está oculto, no se puede acceder al est`,
  T_48_META_API_3033_D: "El jugador se transforma en un objeto en una escena determinada",
  T_48_META_API_3033_P0_D: "jugador objetivo",
  T_48_META_API_3033_P1_D: "que se transformará en",
  T_48_META_API_3033_P2_D: "Entidades creadas tras la transformación",
  T_48_META_API_3034_D: "El jugador crea un alter ego de su propia apariencia",
  T_48_META_API_3034_P0_D: "jugador objetivo",
  T_48_META_API_3034_P1_D: "Creación de entidades alter ego",
  T_48_META_API_3035_D: "Crear una tienda personalizada con estanterías como siguiente nivel de la tienda",
  T_48_META_API_3035_P0_D: "Creación de entidades comerciales",
  T_48_META_API_3036_D: "Crear una estantería personalizada en la que el nivel superior de la estantería sea la tienda y el inferior los productos.",
  T_48_META_API_3036_P0_D: "Entidades de estantería creadas",
  T_48_META_API_3037_D: "Crear un producto personalizado, el producto puede añadir artículos",
  T_48_META_API_3037_P0_D: "Entidades de productos básicos creadas",
  T_48_META_API_3038_D: "Añadir elementos a un producto permite añadir varios elementos a un producto utilizando el elemento varias veces.",
  T_48_META_API_3038_P0_D: "Entidades de productos básicos",
  T_48_META_API_3038_P1_D: "Elementos que deben añadirse",
  T_48_META_API_3038_P2_D: "Número de artículos",
  T_48_META_API_3039_D: "Dar recompensas por Jailbreak",
  T_48_META_API_3039_P0_D: "entidad jugadora",
  T_48_META_API_3039_P1_D: "cantidades",
  T_48_META_API_3039_P2_D: "dinero real",
  T_48_META_API_3040_D: "Tareas de jailbreak actualizadas",
  T_48_META_API_3040_P0_D: "entidad jugadora",
  T_48_META_API_3040_P1_D: "ID de tarea",
  T_48_META_API_3040_P2_D: "estar de servicio",
  T_48_META_API_3041_D: "Obtiene las coordenadas de un punto de nacimiento aleatorio, sólo de los puntos de nacimiento disponibles que no estén totalmente ocupados.",
  T_48_META_API_3041_P0_D: "jugador objetivo",
  T_48_META_API_3041_R_D: "Aleatorizar las coordenadas del punto de nacimiento, si no hay ningún punto de nacimiento que coincida con los criterios, devolverá una ubicación cercana a (0, 0, 0).",
  T_48_META_API_3042_D: "Salir del juego Jailbreak",
  T_48_META_API_3042_P0_D: "entidad jugadora",
  T_48_META_API_3042_P1_D: "ID de tarea",
  T_48_META_API_3043_D: "Basado en jailbreak props",
  T_48_META_API_3043_P0_D: "entidad jugadora",
  T_48_META_API_3043_P1_D: "Tipo de atrezzo",
  T_48_META_API_3043_P2_D: "Identificación del atrezzo",
  T_48_META_API_31_D: "Crea un movimiento relativo a sí mismo, en el que la entidad de destino cambia cada vez en relación con sus valores de atributo actuales.",
  T_48_META_API_31_P0_D: "entidad de destino",
  T_48_META_API_31_P1_D: "Propiedades que requieren cambios de movimiento",
  T_48_META_API_31_P2_D: "Cantidad de cambio por movimiento",
  T_48_META_API_31_P3_D: "Punto de control de la curva de Bessel",
  T_48_META_API_31_P4_D: `Único: el movimiento se detiene cuando el atributo cambia la cantidad Delta 
 Cíclico: el movimiento se repite, cada vez que el atributo cambia la cantidad Delta`,
  T_48_META_API_31_P5_D: "Duración de un cambio en milisegundos",
  T_48_META_API_31_P6_D: "Entidades creadas que se mueven respecto a sí mismas",
  T_48_META_API_31_P7_D: "Si la reproducción se inicia automáticamente tras la creación",
  T_48_META_API_3100_D: "El objetivo reproduce la animación en el estado especificado",
  T_48_META_API_3100_P0_D: "Componentes de entidad que reproducen animaciones con controladores de animación montables",
  T_48_META_API_3100_P1_D: "El estado especificado del controlador de animación",
  T_48_META_API_3100_P2_D: "Escalado de la velocidad de reproducción de animaciones",
  T_48_META_API_3100_P3_D: "Tipo bucle, puede mantener la lógica original de la animación, reproducirla una sola vez o hacer un bucle.",
  T_48_META_API_3101_D: "Reproduce animaciones de personajes, admite recursos de animación personalizados",
  T_48_META_API_3101_P0_D: "jugador objetivo",
  T_48_META_API_3101_P1_D: "ID de recurso de animación personalizado",
  T_48_META_API_3101_P2_D: "Hacer o no un bucle",
  T_48_META_API_3102_D: "Establecer los recursos de los personajes para un jugador determinado",
  T_48_META_API_3102_P0_D: "jugador objetivo",
  T_48_META_API_3102_P1_D: "Rol personalizado ID de recurso",
  T_48_META_API_3109_D: "El encendido suaviza el movimiento hasta el final de la zona de seguridad",
  T_48_META_API_3109_P0_D: "Posición inicial de la zona de seguridad",
  T_48_META_API_3109_P1_D: "Localización del final de la zona de seguridad",
  T_48_META_API_3109_P2_D: "Radio inicial de la zona de seguridad",
  T_48_META_API_3109_P3_D: "Radio final de la zona de seguridad",
  T_48_META_API_3109_P4_D: "Tiempo en segundos para que la zona de seguridad alcance su estado final",
  T_48_META_API_3109_P5_D: "Cantidad de daño por segundo recibido fuera de la zona segura",
  T_48_META_API_3110_D: "Cambiar de grupo de caracteres",
  T_48_META_API_3110_P0_D: "objetivos",
  T_48_META_API_3110_P1_D: "Grupo Apariencia",
  T_48_META_API_3111_D: "Mostrar Grupo de Apariencia de Rol",
  T_48_META_API_3111_P0_D: "objetivos",
  T_48_META_API_3111_P1_D: "Grupo Apariencia",
  T_48_META_API_3112_D: "Grupo de Apariencia de Carácter Oculto",
  T_48_META_API_3112_P0_D: "objetivos",
  T_48_META_API_3112_P1_D: "Grupo Apariencia",
  T_48_META_API_3121_D: "Envío de los resultados de las afirmaciones a Craftland Studio PC para uso estadístico",
  T_48_META_API_3121_P0_D: "expresión de aserción",
  T_48_META_API_3121_P1_D: "llamar la atención sobre algo",
  T_48_META_API_32_D: "Obtener los datos de la ficha de hoy del jugador",
  T_48_META_API_32_P0_D: "jugador objetivo",
  T_48_META_API_32_P1_D: "tokenID",
  T_48_META_API_32_P2_D: "Número de fichas",
  T_48_META_API_32_P3_D: "Si la tupla se ha invocado correctamente o no",
  T_48_META_API_3200_D: "Añade elementos al reproductor y devuelve una lista de los elementos emitidos",
  T_48_META_API_3200_P0_D: "jugador",
  T_48_META_API_3200_P1_D: "Número de artículo",
  T_48_META_API_3200_P2_D: "Número de artículos",
  T_48_META_API_3200_P3_D: "Una lista de elementos añadidos para el jugador, incluso si sólo se añade un elemento, se devuelve como una lista.",
  T_48_META_API_3201_D: "Devuelve la sangre al jugador designado sin superar el límite de sangre",
  T_48_META_API_3201_P0_D: "jugador objetivo",
  T_48_META_API_3201_P1_D: "Un valor que añade sangre al jugador, sólo se aceptan números positivos",
  T_48_META_API_3202_D: "Establecer la lista de habilidades del jugador objetivo",
  T_48_META_API_3202_P0_D: "jugador objetivo",
  T_48_META_API_3202_P1_D: "Lista de competencias",
  T_48_META_API_3203_D: "Obtener una lista de las habilidades del jugador objetivo",
  T_48_META_API_3203_P0_D: "jugador objetivo",
  T_48_META_API_3203_R_D: "Lista de competencias",
  T_48_META_API_3205_D: "Eliminar un número determinado de objetos del reproductor",
  T_48_META_API_3205_P0_D: "jugador objetivo",
  T_48_META_API_3205_P1_D: "Tipo de elemento que debe suprimirse",
  T_48_META_API_3205_P2_D: "El número de elementos que se eliminarán; si supera el número de elementos que posee el jugador, sólo se eliminarán los elementos que posea.",
  T_48_META_API_3206_D: "Obtener el número especificado de objetos en posesión de un jugador",
  T_48_META_API_3206_P0_D: "jugador objetivo",
  T_48_META_API_3206_P1_D: "Tipo de artículo",
  T_48_META_API_3206_R_D: "La cantidad de elementos que tiene el jugador",
  T_48_META_API_3207_D: "Detectar si el jugador puede activar el punto de control actual",
  T_48_META_API_3207_P0_D: "jugador objetivo",
  T_48_META_API_3207_P1_D: "Disparador",
  T_48_META_API_3207_R_D: "Verdadero: puede activarse, Falso: no puede activarse",
  T_48_META_API_3208_D: "Modo Infección Evolución Zombi",
  T_48_META_API_3208_P0_D: "jugador objetivo",
  T_48_META_API_3209_D: "La entidad AI detiene/ejecuta el árbol de comportamiento por defecto",
  T_48_META_API_3209_P0_D: "Permitir el objetivo del árbol de comportamiento",
  T_48_META_API_3209_P1_D: "Aplicar o no el árbol de comportamiento por defecto",
  T_48_META_API_3210_D: "Entidad de IA que persigue un objetivo designado",
  T_48_META_API_3210_P0_D: "Entidades de IA que realizan persecuciones",
  T_48_META_API_3210_P1_D: "objetivo",
  T_48_META_API_3211_D: "Destruir objetos del jugador (obsoleto, utilizar DeleteEquipment)",
  T_48_META_API_3211_P0_D: "El jugador cuyo objeto ha sido destruido",
  T_48_META_API_3211_P1_D: "Tipo de objeto destruido",
  T_48_META_API_3211_P2_D: "Ranura de arma, sólo arma.",
  T_48_META_API_3212_D: "Cambio de camisetas",
  T_48_META_API_3212_P0_D: "jugador objetivo",
  T_48_META_API_3212_P1_D: "Estilo de ropa",
  T_48_META_API_3212_P2_D: "Colores principales I",
  T_48_META_API_3212_P3_D: "Color principal II",
  T_48_META_API_3212_P4_D: "configure",
  T_48_META_API_3213_D: "Restaurar la camiseta del jugador a su estado original",
  T_48_META_API_3213_P0_D: "jugador objetivo",
  T_48_META_API_3214_D: "Chat de voz del jugador de Switch",
  T_48_META_API_3214_P0_D: "jugador objetivo",
  T_48_META_API_3214_P1_D: "Si se cierra el chat de voz, Verdadero:Cerrar Falso:Abrir",
  T_48_META_API_3215_D: "Chat rápido de Switch Player",
  T_48_META_API_3215_P0_D: "jugador objetivo",
  T_48_META_API_3215_P1_D: "Si se cierra el Chat Rápido, Verdadero:Cerrar Falso:Abrir",
  T_48_META_API_3216_D: "Establece si el jugador objetivo puede recoger objetos",
  T_48_META_API_3216_P0_D: "jugador objetivo",
  T_48_META_API_3216_P1_D: "Si está prohibido o no recoger objetos, verdadero: está prohibido recoger falsos: está permitido recoger",
  T_48_META_API_3217_D: "Establece si el jugador objetivo puede descartar objetos",
  T_48_META_API_3217_P0_D: "jugador objetivo",
  T_48_META_API_3217_P1_D: "Si está prohibido o no dejar caer objetos, verdadero: recoger está prohibido falso: recoger es posible",
  T_48_META_API_3218_D: "Destruye un arma en la ranura designada del jugador",
  T_48_META_API_3218_P0_D: "jugador objetivo",
  T_48_META_API_3218_P1_D: "Ranuras de armas a destruir",
  T_48_META_API_3218_P2_D: "Número a destruir",
  T_48_META_API_3218_P3_D: "Destrucción exitosa o no, la destrucción falla si no hay ningún arma equipada en la ranura del arma.",
  T_48_META_API_3219_D: "Vacía todos los objetos de la mochila del jugador objetivo, incluidos los objetos equipados.",
  T_48_META_API_3219_P0_D: "jugador objetivo",
  T_48_META_API_3220_D: "Ajuste de la orientación del jugador",
  T_48_META_API_3220_P0_D: "jugador objetivo",
  T_48_META_API_3220_P1_D: "Orientación del jugador",
  T_48_META_API_3221_D: "<Player>(obsoleto, no utilizar, ver atributo :Skeleton para más información)",
  T_48_META_API_3221_P0_D: "entidad jugadora",
  T_48_META_API_3221_P1_D: "zona de zoom",
  T_48_META_API_3221_P2_D: "valor de zoom",
  T_48_META_API_3222_D: "Otorgar un efecto de empuje a un jugador, el jugador objetivo caerá con una aceleración fija y el empuje será detenido forzosamente tras una colisión en el aire",
  T_48_META_API_3222_P0_D: "jugador objetivo",
  T_48_META_API_3222_P1_D: "Dirección de noqueo",
  T_48_META_API_3222_P2_D: "tiempo de atropello",
  T_48_META_API_3222_P3_D: "Velocidad inicial del eje Y en el impacto",
  T_48_META_API_3222_P4_D: "Velocidad inicial en el plano XZ en el momento del impacto",
  T_48_META_API_3222_P5_D: "Cambiar o no la orientación del jugador",
  T_48_META_API_3223_D: "Obtener el ID del traje del jugador o PNJ objetivo",
  T_48_META_API_3223_P0_D: "Jugador o PNJ objetivo",
  T_48_META_API_3223_P1_D: "Tipo de ropa",
  T_48_META_API_3223_R_D: "Identificación de la ropa",
  T_48_META_API_3224_D: "Establecer el ID del traje del jugador o PNJ objetivo",
  T_48_META_API_3224_P0_D: "Jugador o PNJ objetivo",
  T_48_META_API_3224_P1_D: "Identificación de la ropa",
  T_48_META_API_3225_D: "Restaura la ropa predeterminada del jugador objetivo, no se puede aplicar a los PNJ.",
  T_48_META_API_3225_P0_D: "jugador objetivo",
  T_48_META_API_3226_D: "Ataques de entidades de IA Objetivo designado",
  T_48_META_API_3226_P0_D: "La entidad de IA que realiza el ataque",
  T_48_META_API_3226_P1_D: "objetivo",
  T_48_META_API_3227_D: "Cambia el arma del jugador por el arma de la ranura especificada",
  T_48_META_API_3227_P0_D: "jugador objetivo",
  T_48_META_API_3227_P1_D: "Ranura de arma a cambiar",
  T_48_META_API_3227_P2_D: "Tanto si el cambio tiene éxito como si no, el cambio fallará si no hay ningún arma equipada en la ranura del arma.",
  T_48_META_API_3228_D: "Obtén aspectos de armas para jugadores o PNJ objetivo",
  T_48_META_API_3228_P0_D: "Jugador o PNJ objetivo",
  T_48_META_API_3228_P1_D: "ID de piel del arma",
  T_48_META_API_3228_R_D: "ID de piel del arma",
  T_48_META_API_3229_D: "Establecer la skin del arma del jugador o PNJ objetivo",
  T_48_META_API_3229_P0_D: "Jugador o PNJ objetivo",
  T_48_META_API_3229_P1_D: "ID de piel del arma",
  T_48_META_API_3230_D: "Restaura el aspecto de arma predeterminado del jugador objetivo, que no se puede aplicar a los PNJ.",
  T_48_META_API_3230_P0_D: "jugador objetivo",
  T_48_META_API_3230_P1_D: "Identificación del arma",
  T_48_META_API_3231_D: "Configurar el traje del jugador",
  T_48_META_API_3231_P0_D: "jugador objetivo",
  T_48_META_API_3231_P1_D: "Lista de ropa",
  T_48_META_API_3232_D: "Elimina todos los trajes del tipo especificado del jugador o PNJ objetivo",
  T_48_META_API_3232_P0_D: "Jugador o PNJ objetivo",
  T_48_META_API_3232_P1_D: "Tipo de ropa",
  T_48_META_API_3233_D: "Quitar la piel del arma designada de un jugador o PNJ",
  T_48_META_API_3233_P0_D: "Jugador o PNJ objetivo",
  T_48_META_API_3233_P1_D: "Identificación del arma",
  T_48_META_API_3234_D: "Añade potenciadores al objetivo",
  T_48_META_API_3234_P0_D: "Entidad objetivo, debe ser una entidad a la que se puedan añadir buffs",
  T_48_META_API_3234_P1_D: "Id de Buff",
  T_48_META_API_3235_D: "Elimina los potenciadores del objetivo",
  T_48_META_API_3235_P0_D: "Entidad objetivo, debe ser una entidad a la que se puedan añadir buffs",
  T_48_META_API_3235_P1_D: "Id de Buff",
  T_48_META_API_3236_D: "Obtener el buff actual del objetivo",
  T_48_META_API_3236_P0_D: "Entidad objetivo, debe ser una entidad a la que se puedan añadir buffs",
  T_48_META_API_3236_R_D: "Lista de Buff",
  T_48_META_API_3237_D: "Adquiere objetos de la barra de accesorios de la mochila del jugador objetivo.",
  T_48_META_API_3237_P0_D: "jugador objetivo",
  T_48_META_API_3237_P1_D: "Lista de atrezo",
  T_48_META_API_3238_D: "Añade accesorios a la ranura especificada del arma, los accesorios que no coincidan con la ranura fallarán; los accesorios coincidentes pero duplicados sustituirán a los accesorios originales, los accesorios originales se enviarán a la mochila del jugador",
  T_48_META_API_3238_P0_D: "jugador objetivo",
  T_48_META_API_3238_P1_D: "barra de equipamiento ranura",
  T_48_META_API_3238_P2_D: "sustitución (piezas)",
  T_48_META_API_3238_P3_D: "Verdadero: el accesorio se ha equipado con el arma en la ranura correspondiente. Falso: el accesorio no se ha añadido y no aparecerá en la mochila del jugador.",
  T_48_META_API_3238_P4_D: "Accesorios añadidos, null en caso de fallo",
  T_48_META_API_3239_D: "Obtener el equipo en la columna de equipo de mochila",
  T_48_META_API_3239_P0_D: "jugador objetivo",
  T_48_META_API_3239_P1_D: "barra de equipamiento ranura",
  T_48_META_API_3239_P2_D: "Equipo en la ranura especificada, vacío si no está equipado",
  T_48_META_API_3239_P3_D: "Todos los accesorios para este equipo",
  T_48_META_API_3240_D: "Un vector 2D toma el componente x",
  T_48_META_API_3240_P0_D: "vector bidimensional",
  T_48_META_API_3240_R_D: "Componente x del vector 2D",
  T_48_META_API_3241_D: "Los vectores bidimensionales toman el componente y",
  T_48_META_API_3241_P0_D: "vector bidimensional",
  T_48_META_API_3241_R_D: "Componente Y de un vector 2D",
  T_48_META_API_3242_D: "2D vector setting x-component",
  T_48_META_API_3242_P0_D: "vector bidimensional",
  T_48_META_API_3242_P1_D: "Componente x del vector 2D",
  T_48_META_API_3243_D: "2D vector setting y-component",
  T_48_META_API_3243_P0_D: "vector bidimensional",
  T_48_META_API_3243_P1_D: "Componente Y de un vector 2D",
  T_48_META_API_3244_D: "Suma dos vectores 2D",
  T_48_META_API_3244_P0_D: "Valor izquierdo",
  T_48_META_API_3244_P1_D: "Valor derecho",
  T_48_META_API_3244_R_D: "Resultado de la suma de vectores 2D",
  T_48_META_API_3245_D: "Restar dos vectores 2D",
  T_48_META_API_3245_P0_D: "Valor izquierdo",
  T_48_META_API_3245_P1_D: "Valor derecho",
  T_48_META_API_3245_R_D: "Resultado de la sustracción de vectores 2D",
  T_48_META_API_3246_D: "Multiplicar los vectores bidimensionales por",
  T_48_META_API_3246_P0_D: "vector bidimensional",
  T_48_META_API_3246_P1_D: "Valores de escala de vectores 2D",
  T_48_META_API_3246_R_D: "Resultado de la multiplicación de vectores 2D",
  T_48_META_API_3247_D: "Multiplicar por puntos dos vectores 2D, el resultado de la multiplicación por puntos es un escalar que caracteriza el ángulo entre los dos vectores.",
  T_48_META_API_3247_P0_D: "Valor izquierdo",
  T_48_META_API_3247_P1_D: "Valor derecho",
  T_48_META_API_3247_R_D: "Resultado del producto escalar",
  T_48_META_API_3248_D: "Calcular la distancia euclidiana entre dos vectores 2D",
  T_48_META_API_3248_P0_D: "Valor izquierdo",
  T_48_META_API_3248_P1_D: "Valor derecho",
  T_48_META_API_3248_R_D: "Después de restar dos vectores, el módulo del vector resultante",
  T_48_META_API_3249_D: "Calcular el ángulo entre dos vectores 2D",
  T_48_META_API_3249_P0_D: "Valor izquierdo",
  T_48_META_API_3249_P1_D: "Valor derecho",
  T_48_META_API_3249_R_D: "Ángulo vectorial, rango de ángulos 0-180",
  T_48_META_API_3250_D: "Normalizar el vector 2D",
  T_48_META_API_3250_P0_D: "vector bidimensional",
  T_48_META_API_3250_R_D: "Resultado normalizado para vectores de longitud 1m en la misma dirección que el vector",
  T_48_META_API_3251_D: "Modelización de un vector 2D",
  T_48_META_API_3251_P0_D: "vector bidimensional",
  T_48_META_API_3251_R_D: "El resultado de la modelización, como longitud del vector",
  T_48_META_API_3252_D: "Calcular el vector de un vector 2D tras la reflexión por una recta vertical normal",
  T_48_META_API_3252_P0_D: "vector 2D incidente",
  T_48_META_API_3252_P1_D: "Vector 2D normal",
  T_48_META_API_3252_R_D: "Vector 2D reflectante",
  T_48_META_API_3253_D: "Cálculo de vectores 3D tras la reflexión por un plano vertical normal",
  T_48_META_API_3253_P0_D: "vector 3D incidente",
  T_48_META_API_3253_P1_D: "Vector 3D normal",
  T_48_META_API_3253_R_D: "vector 3D reflectante",
  T_48_META_API_3254_D: "Convertir un vector 3D en un vector 2D, eliminar el componente Z del vector 3D.",
  T_48_META_API_3254_P0_D: "Vector 3D objetivo",
  T_48_META_API_3254_R_D: "Vector 2D convertido",
  T_48_META_API_3255_D: "vector 2D a vector 3D, el componente Z del vector 3D se fija en 0",
  T_48_META_API_3255_P0_D: "Vector 2D objetivo",
  T_48_META_API_3255_R_D: "Vector 3D convertido",
  T_48_META_API_3256_D: "Crear un vector 2D",
  T_48_META_API_3256_P0_D: "El componente x de un vector 2D",
  T_48_META_API_3256_P1_D: "Componente Y de un vector 2D",
  T_48_META_API_3256_R_D: "El vector 2D creado",
  T_48_META_API_3257_D: "Registros de entierros de concursos personalizados para el análisis de datos sobre la experiencia del usuario",
  T_48_META_API_3257_P0_D: "log",
  T_48_META_API_3258_D: "Registros de entierros de concursos personalizados para el análisis de datos sobre la experiencia del usuario",
  T_48_META_API_3258_P0_D: "Para hacer un seguimiento de los jugadores denunciados",
  T_48_META_API_3258_P1_D: "log",
  T_48_META_API_33_D: "filtros para palabras malsonantes",
  T_48_META_API_33_P0_D: "Texto original que requiere filtrado de palabras soeces",
  T_48_META_API_33_R_D: "Texto filtrado",
  T_48_META_API_3301_D: "Crear una entidad de campamento",
  T_48_META_API_3301_P0_D: "Entidades formadoras",
  T_48_META_API_3302_D: "La entidad objetivo se une al campo designado",
  T_48_META_API_3302_P0_D: "entidad de destino",
  T_48_META_API_3302_P1_D: "Entidades formadoras",
  T_48_META_API_3303_D: "Obtención de campamentos atacables",
  T_48_META_API_3303_P0_D: "campamento de ataque",
  T_48_META_API_3303_R_D: "Lista de entidades del campamento",
  T_48_META_API_3304_D: "Campos atacables para montar campamentos",
  T_48_META_API_3304_P0_D: "campamento de ataque",
  T_48_META_API_3304_P1_D: "campamento objetivo",
  T_48_META_API_3304_P2_D: "Atacabilidad",
  T_48_META_API_3305_D: "Establecer jugadores atacables",
  T_48_META_API_3305_P0_D: "jugador",
  T_48_META_API_3305_P1_D: "Jugadores atacables",
  T_48_META_API_3305_P2_D: "Atacabilidad",
  T_48_META_API_3306_D: "Establecer el equipo atacable del equipo",
  T_48_META_API_3306_P0_D: "equipo de ataque",
  T_48_META_API_3306_P1_D: "grupo destinatario",
  T_48_META_API_3306_P2_D: "Atacabilidad",
  T_48_META_API_3307_D: "abandonado",
  T_48_META_API_3307_P0_D: "abandonado",
  T_48_META_API_3307_R_D: "Lista de entidades de jugadores",
  T_48_META_API_3308_D: "La entidad designada se retira del campo actual",
  T_48_META_API_3308_P0_D: "entidad de destino",
  T_48_META_API_3309_D: "Campo de adquisición del objetivo",
  T_48_META_API_3309_P0_D: "entidad de destino",
  T_48_META_API_3309_R_D: "Entidades formadoras",
  T_48_META_API_3310_D: "Determinar si el objetivo puede ser atacado",
  T_48_META_API_3310_P0_D: "agresores",
  T_48_META_API_3310_P1_D: "entidad de destino",
  T_48_META_API_3310_R_D: "Atacabilidad",
  T_48_META_API_3311_D: "Establecer los objetivos atacables de una entidad",
  T_48_META_API_3311_P0_D: "agresores",
  T_48_META_API_3311_P1_D: "entidad de destino",
  T_48_META_API_3311_P2_D: "Atacabilidad",
  T_48_META_API_3312_D: "Adquisición de objetivos atacables de una entidad",
  T_48_META_API_3312_P0_D: "agresores",
  T_48_META_API_3312_R_D: "Lista de entidades atacables",
  T_48_META_API_34_D: "Determinar si existe un componente para la entidad de destino",
  T_48_META_API_34_P0_D: "entidad de destino",
  T_48_META_API_34_P1_D: "Tipo de componente",
  T_48_META_API_34_R_D: "¿Existe?",
  T_48_META_API_35_D: "Añadir Bot",
  T_48_META_API_35_P0_D: "Nivel de dificultad del bot",
  T_48_META_API_35_P1_D: "Equipo de Bot",
  T_48_META_API_35_P2_D: "Creado Bot Jugador Entidad",
  T_48_META_API_3500_D: "Obtener datos de fichas de jugador",
  T_48_META_API_3500_P0_D: "jugador objetivo",
  T_48_META_API_3500_P1_D: "tokenID",
  T_48_META_API_3500_P2_D: "Número de fichas",
  T_48_META_API_3500_P3_D: "éxito o fracaso",
  T_48_META_API_3501_D: "Añadir datos de token al reproductor",
  T_48_META_API_3501_P0_D: "jugador objetivo",
  T_48_META_API_3501_P1_D: "tokenID",
  T_48_META_API_3501_P2_D: "Número de fichas",
  T_48_META_API_3501_P3_D: "Si la tupla se ha invocado correctamente o no",
  T_48_META_API_3502_D: "Consumir ficha de jugador objetivo",
  T_48_META_API_3502_P0_D: "jugador objetivo",
  T_48_META_API_3502_P1_D: "tokenID",
  T_48_META_API_3502_P2_D: "Número de fichas",
  T_48_META_API_3502_P3_D: "Si la tupla se ha invocado correctamente o no",
  T_48_META_API_3503_D: "Añadir un token a la ubicación especificada",
  T_48_META_API_3503_P0_D: "colocación",
  T_48_META_API_3503_P1_D: "tokenID",
  T_48_META_API_3503_P2_D: "Número de fichas",
  T_48_META_API_3503_P3_D: "Si la tupla se ha invocado correctamente o no",
  T_48_META_API_3504_D: "La IA objetivo libera la habilidad especificada",
  T_48_META_API_3504_P0_D: "Objetivo AI",
  T_48_META_API_3504_P1_D: "técnica",
  T_48_META_API_3504_P2_D: "objetivo de habilidad",
  T_48_META_API_3504_P3_D: "Si la habilidad se libera con éxito o no",
  T_48_META_API_3505_D: "Crea trayectorias de principio a fin que evitan los bloques y pueden utilizarse para la búsqueda de trayectorias de la IA.",
  T_48_META_API_3505_P0_D: "coordenadas del punto de partida",
  T_48_META_API_3505_P1_D: "coordenadas del destino",
  T_48_META_API_3505_P2_D: "Si la ruta de búsqueda se ha establecido correctamente o no",
  T_48_META_API_3505_P3_D: "Conjunto de puntos de búsqueda",
  T_48_META_API_3506_D: "Configuración de la variable de pizarra del árbol de comportamiento",
  T_48_META_API_3506_P0_D: "Árbol de comportamientos objetivo",
  T_48_META_API_3506_P1_D: "nombre de la variable",
  T_48_META_API_3506_P2_D: "valor variable",
  T_48_META_API_3507_D: "Obtención de variables de la pizarra del árbol de comportamiento",
  T_48_META_API_3507_P0_D: "Árbol de comportamientos objetivo",
  T_48_META_API_3507_P1_D: "nombre de la variable",
  T_48_META_API_3507_P2_D: "valor variable",
  T_48_META_API_3508_D: "Obtener los parámetros de los nodos del árbol de comportamiento",
  T_48_META_API_3508_P0_D: "Nodos del árbol de comportamiento objetivo",
  T_48_META_API_3508_P1_D: "nombre del parámetro",
  T_48_META_API_3508_P2_D: "valor del parámetro",
  T_48_META_API_3509_D: "Obtener el skin de portador del jugador objetivo",
  T_48_META_API_3509_P0_D: "jugador objetivo",
  T_48_META_API_3509_P1_D: "Identificación del transportista",
  T_48_META_API_3509_R_D: "Piel portadora",
  T_48_META_API_3510_D: "Establecer el skin de portador del jugador objetivo",
  T_48_META_API_3510_P0_D: "jugador objetivo",
  T_48_META_API_3510_P1_D: "Identificación de la piel del portador",
  T_48_META_API_3511_D: "Limpiar la piel del vehículo especificado del jugador objetivo",
  T_48_META_API_3511_P0_D: "jugador objetivo",
  T_48_META_API_3511_P1_D: "Identificación del transportista",
  T_48_META_API_3512_D: "Restaurar el aspecto de portador predeterminado del jugador objetivo",
  T_48_META_API_3512_P0_D: "jugador objetivo",
  T_48_META_API_3512_P1_D: "Identificación del transportista",
  T_48_META_API_36_D: "Objetivo inactivo, sólo puede utilizarse para cuerpos rígidos de tipo Dinámico.",
  T_48_META_API_36_P0_D: "cuerpo rígido objetivo",
  T_48_META_API_37_D: "Objetivo despierto, sólo se puede utilizar en cuerpos rígidos de tipo Dinámico.",
  T_48_META_API_37_P0_D: "cuerpo rígido objetivo",
  T_48_META_API_38_D: "Comprobar si el cuerpo rígido de destino está inactivo",
  T_48_META_API_38_P0_D: "cuerpo rígido objetivo",
  T_48_META_API_38_R_D: "Si está hibernando o no",
  T_48_META_API_39_D: "Ajuste del umbral de hibernación",
  T_48_META_API_39_P0_D: "cuerpo rígido objetivo",
  T_48_META_API_39_P1_D: "Umbral de reposo, el movimiento y la rotación del cuerpo rígido es inferior a este valor durante un período de tiempo para entrar en el estado de reposo, el estado de reposo del cuerpo rígido ya no realizar cálculos físicos",
  T_48_META_API_4_D: "Establece si todos los jugadores pueden moverse",
  T_48_META_API_4_P0_D: `Verdadero: se puede mover 
 Falso: no se puede mover`,
  T_48_META_API_40_D: "Obtener umbral de hibernación",
  T_48_META_API_40_P0_D: "cuerpo rígido objetivo",
  T_48_META_API_40_R_D: "Umbral de reposo, el movimiento y la rotación del cuerpo rígido es inferior a este valor durante un período de tiempo para entrar en el estado de reposo, el estado de reposo del cuerpo rígido ya no realizar cálculos físicos",
  T_48_META_API_4000_D: "Lee el contenido de toda la tabla y devuelve una matriz bidimensional en orden de fila",
  T_48_META_API_4000_P0_D: "nombre de la tabla",
  T_48_META_API_4000_R_D: "Contenido de la tabla",
  T_48_META_API_4001_D: "Lee una fila de una tabla y devuelve una matriz",
  T_48_META_API_4001_P0_D: "nombre de la tabla",
  T_48_META_API_4001_P1_D: "Número de líneas a leer, contando desde 1",
  T_48_META_API_4001_R_D: "La tabla especifica el contenido de una fila",
  T_48_META_API_4002_D: "Lee el contenido de una columna de una tabla y devuelve un array",
  T_48_META_API_4002_P0_D: "nombre de la tabla",
  T_48_META_API_4002_P1_D: "Número de columnas a leer, contando desde 1",
  T_48_META_API_4002_R_D: "La tabla especifica el contenido de una columna",
  T_48_META_API_4003_D: "Lectura del contenido de una celda de una tabla",
  T_48_META_API_4003_P0_D: "nombre de la tabla",
  T_48_META_API_4003_P1_D: "Número de líneas a leer, contando desde 1",
  T_48_META_API_4003_P2_D: "Número de columnas a leer, contando desde 1",
  T_48_META_API_4003_R_D: "El contenido de la celda especificada de la tabla",
  T_48_META_API_4004_D: "Lectura del contenido de una celda de una tabla por nombre de fila y columna",
  T_48_META_API_4004_P0_D: "nombre de la tabla",
  T_48_META_API_4004_P1_D: "Número de líneas a leer, contando desde 1",
  T_48_META_API_4004_P2_D: "El nombre de la columna a leer",
  T_48_META_API_4004_R_D: "El contenido de la celda especificada de la tabla",
  T_48_META_API_4005_D: "Lee el contenido de toda la tabla y devuelve una matriz bidimensional",
  T_48_META_API_4005_P0_D: "nombre de la tabla",
  T_48_META_API_4005_R_D: "El contenido de la tabla, una matriz bidimensional",
  T_48_META_API_4006_D: "Lee una fila de una tabla y devuelve un array.",
  T_48_META_API_4006_P0_D: "nombre de la tabla",
  T_48_META_API_4006_P1_D: "Número de líneas a leer, contando desde 1",
  T_48_META_API_4006_R_D: "Tabla especifica el contenido de una fila, una matriz",
  T_48_META_API_4007_D: "Leer el contenido de una columna de toda la tabla, devolver array",
  T_48_META_API_4007_P0_D: "nombre de la tabla",
  T_48_META_API_4007_P1_D: "Número de columnas a leer, contando desde 1",
  T_48_META_API_4007_R_D: "Tabla especifica el contenido de una columna, matriz",
  T_48_META_API_4008_D: "Lectura del contenido de una celda de una tabla",
  T_48_META_API_4008_P0_D: "nombre de la tabla",
  T_48_META_API_4008_P1_D: "Número de líneas a leer, contando desde 1",
  T_48_META_API_4008_P2_D: "Número de columnas a leer, contando desde 1",
  T_48_META_API_4008_R_D: "El contenido de la celda especificada de la tabla",
  T_48_META_API_4009_D: "Busca la fila especificada por el número de columnas y el valor de la celda.",
  T_48_META_API_4009_P0_D: "nombre de la tabla",
  T_48_META_API_4009_P1_D: "Número de columnas a leer",
  T_48_META_API_4009_P2_D: "Valor de celda a buscar",
  T_48_META_API_4009_R_D: "Contenido de las filas encontradas, array",
  T_48_META_API_4010_D: "Obtener número de columna por nombre de columna",
  T_48_META_API_4010_P0_D: "nombre de la tabla",
  T_48_META_API_4010_P1_D: "Nombre de la columna para buscar el número de serie",
  T_48_META_API_4010_R_D: "Columnas, contando desde 1",
  T_48_META_API_41_D: "Establece el umbral de reposo global, válido sólo para cuerpos rígidos recién generados de tipo Dinámico.",
  T_48_META_API_41_P0_D: "Umbral de reposo, el movimiento y la rotación del cuerpo rígido es inferior a este valor durante un período de tiempo para entrar en el estado de reposo, el estado de reposo del cuerpo rígido ya no realizar cálculos físicos",
  T_48_META_API_42_D: "Obtener umbral global de hibernación",
  T_48_META_API_42_R_D: "Umbral latente, por defecto es 0.005, el movimiento y la rotación del cuerpo rígido es menor que este valor durante un período de tiempo para entrar en el estado latente, el cuerpo rígido latente ya no llevará a cabo cálculos físicos.",
  T_48_META_API_43_D: "Convierte el cuaternión dado en un ángulo de Euler, el orden de rotación del ángulo de Euler es YXZ, si el cuaternión entrante no es legal, devuelve (0,0,0)",
  T_48_META_API_43_P0_D: "El cuaternión de entrada",
  T_48_META_API_43_R_D: "Ángulos de Euler devueltos",
  T_48_META_API_44_D: "Conversión de un ángulo de Euler dado en un cuaternión",
  T_48_META_API_44_P0_D: "Entrada Ángulos de Euler",
  T_48_META_API_44_R_D: "Cuaternión devuelto",
  T_48_META_API_45_D: "Conversión de rotaciones de representaciones de ángulos axiales en cuaterniones",
  T_48_META_API_45_P0_D: "eje de rotación",
  T_48_META_API_45_P1_D: "Ángulo de giro en el sentido de las agujas del reloj alrededor del eje de rotación",
  T_48_META_API_45_R_D: "Cuaternión devuelto",
  T_48_META_API_46_D: "Conversión de cuaterniones en representaciones angulares axiales",
  T_48_META_API_46_P0_D: "El cuaternión de entrada",
  T_48_META_API_46_P1_D: "eje de rotación",
  T_48_META_API_46_P2_D: "Ángulo de giro en el sentido de las agujas del reloj alrededor del eje de rotación",
  T_48_META_API_47_D: "Configurar el progreso personalizado de finalización de tareas",
  T_48_META_API_47_P0_D: "jugador objetivo",
  T_48_META_API_47_P1_D: "ID de tarea",
  T_48_META_API_47_P2_D: "Progreso hacia la finalización, no se permiten números negativos",
  T_48_META_API_48_D: "Crea una curva de Bézier que puede utilizarse para interpolar el movimiento.",
  T_48_META_API_48_P0_D: "punto de control de la curva",
  T_48_META_API_48_R_D: "Curva de Bessel",
  T_48_META_API_49_D: "Obtener ID de mapa de escena",
  T_48_META_API_49_P0_D: "Identificación de la escena",
  T_48_META_API_49_R_D: "Mapa ID",
  T_48_META_API_5_D: "Eliminar objetos colocados en la escena (obsoleto, utilice DeleteEntity)",
  T_48_META_API_5_P0_D: "Entidades objeto que deben suprimirse",
  T_48_META_API_50_D: "Crea movimiento relativo a sí mismo en cada fotograma, con la entidad objetivo cambiando sus propios atributos una vez por fotograma, cada vez relativo a sus valores de atributo actuales.",
  T_48_META_API_50_P0_D: "entidad de destino",
  T_48_META_API_50_P1_D: "Propiedades que requieren cambios de movimiento",
  T_48_META_API_50_P2_D: "Cantidad de cambio por movimiento",
  T_48_META_API_50_P3_D: `Configuración cuando se utiliza en combinación con otros modos de movimiento
 Verdadero: puede utilizarse en combinación con movimiento relativo
 Falso: puede utilizarse en combinación con movimiento absoluto`,
  T_48_META_API_50_P4_D: "Entidades de movimiento creadas por fotograma en relación consigo mismas",
  T_48_META_API_50_P5_D: "Si la reproducción se inicia automáticamente tras la creación",
  T_48_META_API_5000_D: "Leer el valor correspondiente a una Clave en una tabla de la base de datos.",
  T_48_META_API_5000_P0_D: "Nombres de tabla en la base de datos",
  T_48_META_API_5000_P1_D: "Etiquetado de jugadores, gestión de la concurrencia",
  T_48_META_API_5000_P2_D: "Nombre personalizado utilizado para identificar los datos",
  T_48_META_API_5000_P3_D: "Devuelve el resultado de la lectura",
  T_48_META_API_5000_P4_D: "Código de campo de batalla correspondiente a la base de datos",
  T_48_META_API_5001_D: "Escribe el valor correspondiente a una Clave en una tabla de la base de datos.",
  T_48_META_API_5001_P0_D: "Nombres de tabla en la base de datos",
  T_48_META_API_5001_P1_D: "Etiquetado de jugadores, gestión de la concurrencia",
  T_48_META_API_5001_P2_D: "Nombre personalizado utilizado para identificar los datos",
  T_48_META_API_5001_P3_D: "Valor escrito",
  T_48_META_API_5001_P4_D: "El código del campo de batalla correspondiente a la base de datos, que se puede rellenar en blanco, representa el código del campo de batalla del mapa actual.",
  T_48_META_API_5002_D: "Borra el valor correspondiente a una Clave en una tabla de la base de datos.",
  T_48_META_API_5002_P0_D: "Nombres de tabla en la base de datos",
  T_48_META_API_5002_P1_D: "Etiquetado de jugadores, gestión de la concurrencia",
  T_48_META_API_5002_P2_D: "Nombre personalizado utilizado para identificar los datos",
  T_48_META_API_5002_P3_D: "Código de campo de batalla correspondiente a la base de datos",
  T_48_META_API_5003_D: "Recuperar el valor de una Clave en una tabla de la base de datos.",
  T_48_META_API_5003_P0_D: "Nombre de la tabla de clasificación en la base de datos",
  T_48_META_API_5003_P1_D: "Nombre personalizado utilizado para identificar los datos",
  T_48_META_API_5003_P2_D: "Devuelve el resultado de la lectura",
  T_48_META_API_5003_P3_D: "Código de campo de batalla correspondiente a la base de datos",
  T_48_META_API_5004_D: "Escribe el valor correspondiente a una Clave en una de las tablas de gráficos de la base de datos.",
  T_48_META_API_5004_P0_D: "Nombre de la tabla de clasificación en la base de datos",
  T_48_META_API_5004_P1_D: "Nombre personalizado utilizado para identificar los datos",
  T_48_META_API_5004_P2_D: "Valor escrito",
  T_48_META_API_5004_P3_D: "Código de campo de batalla correspondiente a la base de datos",
  T_48_META_API_5005_D: "Borrar el valor correspondiente a una Clave en una tabla gráfica de la base de datos.",
  T_48_META_API_5005_P0_D: "Nombres de tabla en la base de datos",
  T_48_META_API_5005_P1_D: "Nombre personalizado utilizado para identificar los datos",
  T_48_META_API_5005_P2_D: "Código de campo de batalla correspondiente a la base de datos",
  T_48_META_API_5006_D: "Eliminar el valor correspondiente a un rango en una tabla de clasificación de la base de datos.",
  T_48_META_API_5006_P0_D: "Nombres de tabla en la base de datos",
  T_48_META_API_5006_P1_D: "Clasificación en la Leaderboard",
  T_48_META_API_5006_P2_D: "Código de campo de batalla correspondiente a la base de datos",
  T_48_META_API_5007_D: "Leer los valores de un rango a otro en una tabla gráfica de la base de datos.",
  T_48_META_API_5007_P0_D: "Nombres de tabla en la base de datos",
  T_48_META_API_5007_P1_D: "posición inicial",
  T_48_META_API_5007_P2_D: "posición final",
  T_48_META_API_5007_P3_D: "Devuelve el resultado de la lectura",
  T_48_META_API_5007_P4_D: "Código de campo de batalla correspondiente a la base de datos",
  T_48_META_API_5008_D: "Leer el valor correspondiente a una Clave en una tabla de la base de datos acumulativa.",
  T_48_META_API_5008_P0_D: "Nombres de tabla en la base de datos",
  T_48_META_API_5008_P1_D: "Nombre personalizado utilizado para identificar los datos",
  T_48_META_API_5008_P2_D: "Devuelve el resultado de la lectura",
  T_48_META_API_5008_P3_D: "Código de campo de batalla correspondiente a la base de datos",
  T_48_META_API_5009_D: "Escribir el valor de desplazamiento correspondiente a una Clave en una tabla de la base de datos acumulativa",
  T_48_META_API_5009_P0_D: "Nombres de tabla en la base de datos",
  T_48_META_API_5009_P1_D: "Nombre personalizado utilizado para identificar los datos",
  T_48_META_API_5009_P2_D: "Los tipos de las cuatro operaciones, actualmente admiten los siguientes tipos: el tipo Int admite suma, resta, multiplicación, división y resto; el tipo Float admite suma, resta, multiplicación y división.",
  T_48_META_API_5009_P3_D: "Valor de offset escrito",
  T_48_META_API_5009_P4_D: "Código de campo de batalla correspondiente a la base de datos",
  T_48_META_API_51_D: "Restablecer entidad reproducible, devuelve la entidad reproducible a su forma inicial sin cambiar el estado de reproducción.",
  T_48_META_API_51_P0_D: "Entidad jugable objetivo",
  T_48_META_API_52_D: "Multiplicar dos cuaterniones, A*B significa rotar A y luego B. Un orden diferente de rotación conducirá a un resultado diferente.",
  T_48_META_API_52_P0_D: "cuaternión con valor izquierdo",
  T_48_META_API_52_P1_D: "cuaternión de valor recto",
  T_48_META_API_52_R_D: "Cuaternión resultante",
  T_48_META_API_53_D: "Crea un cuaternión giratorio orientado en una dirección especificada",
  T_48_META_API_53_P0_D: "indicar la dirección",
  T_48_META_API_53_P1_D: "hacia arriba",
  T_48_META_API_53_R_D: "La cantidad de rotación necesaria para alinear en la dirección especificada.",
  T_48_META_API_54_D: "Interpolación esférica cuaterniónica de A a B",
  T_48_META_API_54_P0_D: "Valor A",
  T_48_META_API_54_P1_D: "Valor B",
  T_48_META_API_54_P2_D: "Progreso de interpolación, el rango de valores [0,1], el valor de 0 para volver al principio del valor, el valor de 1 para volver al valor objetivo.",
  T_48_META_API_54_R_D: "Cuaternión resultante",
  T_48_META_API_57_D: "Imprime los datos de destino como advertencia en la consola",
  T_48_META_API_57_P0_D: "Qué imprimir",
  T_48_META_API_58_D: "Imprime los datos de destino en la consola como mensaje de error.",
  T_48_META_API_58_P0_D: "Qué imprimir",
  T_48_META_API_59_D: "Obtener el valor en la curva",
  T_48_META_API_59_P0_D: "de manera indirecta",
  T_48_META_API_59_P1_D: "Punto de muestreo, rango de valores [0,1]",
  T_48_META_API_59_R_D: "al final",
  T_48_META_API_6_D: "Crea objetos de escena en las coordenadas especificadas",
  T_48_META_API_6_P0_D: "Entidades de objeto de escena creadas",
  T_48_META_API_6_P1_D: "Localización de la generación de objetos",
  T_48_META_API_6_P2_D: "El ID del tipo de objeto creado, que debe registrarse previamente en el registro de activos para su uso en scripts de código.",
  T_48_META_API_60_D: "Interpolación basada en curvas",
  T_48_META_API_60_P0_D: "tipo de valor",
  T_48_META_API_60_P1_D: "valor inicial",
  T_48_META_API_60_P2_D: "valor objetivo",
  T_48_META_API_60_P3_D: "de manera indirecta",
  T_48_META_API_60_P4_D: "Punto de muestreo, rango de valores [0,1]",
  T_48_META_API_60_R_D: "al final",
  T_48_META_API_6000_D: "Añadir guiones a las entidades de destino",
  T_48_META_API_6000_P0_D: "entidad de destino",
  T_48_META_API_6000_P1_D: "ID de guión",
  T_48_META_API_6001_D: "Descarga de scripts para entidades de destino",
  T_48_META_API_6001_P0_D: "entidad de destino",
  T_48_META_API_6001_P1_D: "ID de guión",
  T_48_META_API_6002_D: "Comprueba si el script especificado existe para la entidad de destino",
  T_48_META_API_6002_P0_D: "entidad de destino",
  T_48_META_API_6002_P1_D: "ID de guión",
  T_48_META_API_6002_R_D: "Existencia del script especificado",
  T_48_META_API_61_D: "Establecer el nodo padre de un control de interfaz de usuario",
  T_48_META_API_61_P0_D: "Nodo padre, puede especificar control UI o UI personalizado",
  T_48_META_API_61_P1_D: "nodo hijo",
  T_48_META_API_62_D: "abandonado",
  T_48_META_API_62_P0_D: "abandonado",
  T_48_META_API_62_P1_D: "abandonado",
  T_48_META_API_62_P2_D: "abandonado",
  T_48_META_API_62_P3_D: "abandonado",
  T_48_META_API_62_P4_D: "abandonado",
  T_48_META_API_63_D: "Creación de un rayo desde la cámara actual hasta el punto táctil de la pantalla",
  T_48_META_API_63_P0_D: "contacto de pantalla",
  T_48_META_API_63_P1_D: "umbral",
  T_48_META_API_63_P2_D: "dirección del rayo",
  T_48_META_API_64_D: "Cargar información de facturación personalizada",
  T_48_META_API_64_P0_D: "entidad jugadora",
  T_48_META_API_64_P1_D: "resultados de un concurso",
  T_48_META_API_64_P2_D: "título integral (informática)",
  T_48_META_API_64_P3_D: "valor en puntos",
  T_48_META_API_65_D: "Reproduce el efecto de sonido especificado y establece sus propiedades de entidad si tienes más propiedades que establecer.",
  T_48_META_API_65_P0_D: "Entidades sonoras creadas",
  T_48_META_API_65_P1_D: "Jugador objetivo, sólo el jugador objetivo puede oír los efectos de sonido",
  T_48_META_API_65_P2_D: "Tipo de efecto sonoro",
  T_48_META_API_65_P3_D: "Tipo de bucle",
  T_48_META_API_65_P4_D: "Jugar o no jugar inmediatamente",
  T_48_META_API_66_D: "Crea el efecto visual especificado y establece sus atributos de entidad si hay más atributos que establecer.",
  T_48_META_API_66_P0_D: "Entidades de efectos especiales creadas",
  T_48_META_API_66_P1_D: "Jugadores seleccionados, visibles sólo para ellos",
  T_48_META_API_66_P2_D: "Tipo de efecto especial",
  T_48_META_API_66_P3_D: "Tipo de bucle",
  T_48_META_API_66_P4_D: "Jugar o no jugar inmediatamente",
  T_48_META_API_67_D: "Crea el efecto de sonido especificado y establece sus propiedades de entidad si hay más propiedades que establecer.",
  T_48_META_API_67_P0_D: "Entidades sonoras creadas",
  T_48_META_API_67_P1_D: "Tipo de efecto sonoro",
  T_48_META_API_67_P2_D: "Tipo de bucle",
  T_48_META_API_67_P3_D: "Jugar o no jugar inmediatamente",
  T_48_META_API_68_D: "Coordenadas mundiales convertidas a coordenadas de pantalla",
  T_48_META_API_68_P0_D: "coordenada mundial",
  T_48_META_API_68_P1_D: "Si está o no mapeado dentro de la pantalla",
  T_48_META_API_68_P2_D: "posición cartográfica",
  T_48_META_API_69_D: "Coordenadas de pantalla a coordenadas mundiales",
  T_48_META_API_69_P0_D: "coordenada de pantalla",
  T_48_META_API_69_P1_D: "Distancia de la pantalla",
  T_48_META_API_69_P2_D: "coordenada mundial",
  T_48_META_API_7_D: "Convertir el valor de destino en cadena",
  T_48_META_API_7_P0_D: "El valor de destino de la cadena a convertir",
  T_48_META_API_7_R_D: "cadena",
  T_48_META_API_70_D: "La detección de rayos por toque de pantalla devuelve la primera entidad golpeada",
  T_48_META_API_70_P0_D: "Pantalla de inicio Contactos",
  T_48_META_API_70_P1_D: "Distancia de detección",
  T_48_META_API_70_P2_D: "Máscara de capa, sólo las capas rellenas participarán en el escaneado, si se deja en blanco todas las capas participarán en el escaneado.",
  T_48_META_API_70_P3_D: "Si se puede detectar el desencadenante",
  T_48_META_API_70_P4_D: "entidad afectada",
  T_48_META_API_70_P5_D: "coordenadas del punto de impacto",
  T_48_META_API_70_P6_D: "Distancia del punto de impacto desde el punto inicial",
  T_48_META_API_70_P7_D: "golpea la normal de la superficie",
  T_48_META_API_71_D: "Detección de rayos por toque de pantalla, devuelve todas las entidades golpeadas",
  T_48_META_API_71_P0_D: "Pantalla de inicio Contactos",
  T_48_META_API_71_P1_D: "Distancia de detección",
  T_48_META_API_71_P2_D: "Máscara de capa, sólo las capas rellenas participarán en el escaneado, si se deja en blanco todas las capas participarán en el escaneado.",
  T_48_META_API_71_P3_D: "Si se puede detectar el desencadenante",
  T_48_META_API_71_P4_D: "Lista de entidades afectadas",
  T_48_META_API_71_P5_D: "Lista de coordenadas de los puntos de impacto",
  T_48_META_API_71_P6_D: "Lista de distancias entre el punto de impacto y el punto de inicio.",
  T_48_META_API_71_P7_D: "Lista de normales de superficie alcanzadas",
  T_48_META_API_72_D: "Crea el efecto visual especificado y establece sus atributos de entidad si hay más atributos que establecer.",
  T_48_META_API_72_P0_D: "Entidades de efectos especiales creadas",
  T_48_META_API_72_P1_D: "Tipo de efecto especial",
  T_48_META_API_72_P2_D: "Tipo de bucle",
  T_48_META_API_72_P3_D: "Jugar o no jugar inmediatamente",
  T_48_META_API_73_D: "Crear una interfaz de usuario integrada que no se sincronice con otros clientes",
  T_48_META_API_73_P0_D: "Creación de entidades de IU integradas",
  T_48_META_API_73_P1_D: "Tipos de IU integrados",
  T_48_META_API_74_D: "Crear una interfaz de usuario personalizada que no se sincronice con otros clientes",
  T_48_META_API_74_P0_D: "Creación de entidades de interfaz de usuario personalizadas",
  T_48_META_API_74_P1_D: "Índice de IU personalizado",
  T_48_META_API_75_D: "Obtener el reproductor correspondiente al cliente actual",
  T_48_META_API_75_R_D: "entidad jugadora",
  T_48_META_API_76_D: "Creación de monstruos de IA",
  T_48_META_API_76_P0_D: "Objetivo AI",
  T_48_META_API_76_P1_D: "Crear ubicación",
  T_48_META_API_76_P2_D: "Tipo AI",
  T_48_META_API_76_P3_D: "equipo afiliado",
  T_48_META_API_76_P4_D: "si reclamar o no automáticamente al enemigo",
  T_48_META_API_76_P5_D: "modo de ataque",
  T_48_META_API_76_P6_D: "Ruta de viaje",
  T_48_META_API_77_D: "Establecer el primer componente del vector",
  T_48_META_API_77_P0_D: "vectores",
  T_48_META_API_77_P1_D: "Valor del primer componente",
  T_48_META_API_77_R_D: "Vector después de modificar el primer componente",
  T_48_META_API_78_D: "Establecer el segundo componente del vector",
  T_48_META_API_78_P0_D: "vectores",
  T_48_META_API_78_P1_D: "Valor del segundo componente",
  T_48_META_API_78_R_D: "Vector después de modificar el segundo componente",
  T_48_META_API_79_D: "Establecer el tercer componente del vector",
  T_48_META_API_79_P0_D: "vectores",
  T_48_META_API_79_P1_D: "Valor del tercer componente",
  T_48_META_API_79_R_D: "Vector después de modificar el tercer componente",
  T_48_META_API_8_D: "Abra la zona de seguridad que se contrae al punto de coordenadas central.",
  T_48_META_API_8_P0_D: "Punto central de la zona de seguridad",
  T_48_META_API_8_P1_D: "Radio de la zona de seguridad",
  T_48_META_API_8_P2_D: "Tiempo de espera en segundos, al final del cual la zona de seguridad empezará a reducirse hacia el punto central.",
  T_48_META_API_8_P3_D: "Tiempo necesario para que la zona de seguridad se reduzca hasta el punto central, en segundos",
  T_48_META_API_8_P4_D: "Cantidad de daño por segundo recibido fuera de la zona segura",
  T_48_META_API_80_D: "Establece el primer componente del vector 2D",
  T_48_META_API_80_P0_D: "vector bidimensional",
  T_48_META_API_80_P1_D: "Valor del primer componente",
  T_48_META_API_80_R_D: "El vector 2D después de modificar el primer componente",
  T_48_META_API_81_D: "Establece el segundo componente del vector 2D",
  T_48_META_API_81_P0_D: "vector bidimensional",
  T_48_META_API_81_P1_D: "Valor del segundo componente",
  T_48_META_API_81_R_D: "El vector 2D después de modificar el segundo componente",
  T_48_META_API_82_D: "Mueve el controlador del personaje a la ubicación especificada, si actúa sobre el jugador, el jugador debe encender el controlador del jugador que utiliza el efecto de física para que surta efecto",
  T_48_META_API_82_P0_D: "Controlador de funciones de destino",
  T_48_META_API_82_P1_D: "lugar designado",
  T_48_META_API_83_D: "Obtener el nodo hijo especificado de la entidad padre de destino por su nombre",
  T_48_META_API_83_P0_D: "entidad matriz",
  T_48_META_API_83_P1_D: "Nombre del subnodo",
  T_48_META_API_83_R_D: "entidad infantil",
  T_48_META_API_84_D: "Prestar especial atención a la AOI y sincronizar siempre independientemente de la distancia",
  T_48_META_API_84_P0_D: "Objetivos de especial atención",
  T_48_META_API_84_P1_D: "observador",
  T_48_META_API_85_D: "Eliminar la atención especial AOI y cancelar la sincronización AOI fuera de vista",
  T_48_META_API_85_P0_D: "Objetivos de especial atención",
  T_48_META_API_85_P1_D: "observador",
  T_48_META_API_86_D: "Borra todas las preocupaciones especiales de la AOI para el objetivo especificado.",
  T_48_META_API_86_P0_D: "Objetivos de especial atención",
  T_48_META_API_87_D: "Determinar si existe una preocupación especial AOI",
  T_48_META_API_87_P0_D: "Objetivos de especial atención",
  T_48_META_API_87_P1_D: "abandonado",
  T_48_META_API_87_R_D: "¿Existe?",
  T_48_META_API_88_D: "Cambiar el observador proxy del jugador",
  T_48_META_API_88_P0_D: "jugador",
  T_48_META_API_88_P1_D: "observador delegado",
  T_48_META_API_89_D: "Desplaza el controlador del personaje una vez, y si actúa sobre el jugador, éste debe encender el controlador del jugador que utiliza el efecto físico para que surta efecto",
  T_48_META_API_89_P0_D: "El objeto objetivo, o en el caso de un jugador, el jugador debe tener activado un controlador de jugador que utilice efectos físicos para que el efecto surta efecto.",
  T_48_META_API_89_P1_D: "vector de desplazamiento",
  T_48_META_API_9_D: "Desactivar el mecanismo de zona segura, cuando la zona segura se reduce al mínimo, los jugadores fuera de la zona segura seguirán recibiendo daño, después de desactivar el mecanismo de zona segura los jugadores vuelven a la seguridad.",
  T_48_META_API_90_D: "Establece si el jugador puede abandonar libremente",
  T_48_META_API_90_P0_D: "jugador objetivo",
  T_48_META_API_90_P1_D: "Libertad para retirarse",
  T_48_META_API_9000_D: "Crear una interfaz de usuario integrada que sólo puedan ver determinados jugadores",
  T_48_META_API_9000_P0_D: "Creación de entidades de IU integradas",
  T_48_META_API_9000_P1_D: "La entidad de jugador a la que pertenece la interfaz de usuario, visible sólo para ese jugador.",
  T_48_META_API_9000_P2_D: "Tipos de IU integrados",
  T_48_META_API_9001_D: "Eliminar la interfaz de usuario integrada en el juego",
  T_48_META_API_9001_P0_D: "Entidades de IU incorporadas que deben eliminarse",
  T_48_META_API_9002_D: "Crea un icono con el tipo de icono especificado, y cuando hay más propiedades que establecer, establece además sus propiedades de entidad a través de la entidad (obsoleto, utilice CreateLevelObject)",
  T_48_META_API_9002_P0_D: "En el código es el nombre del parámetro formal utilizado para representar la entidad que crea el icono, y su correspondiente valor de variable local es la entidad que crea el icono",
  T_48_META_API_9002_P1_D: "La entidad de jugador a la que pertenece, visible sólo para ese jugador",
  T_48_META_API_9002_P2_D: "Ruta de recursos, la ruta de recursos correspondiente al icono seleccionado por el jugador",
  T_48_META_API_9003_D: "Eliminar el icono especificado (obsoleto, utilice DeleteEntity)",
  T_48_META_API_9003_P0_D: "La entidad icono que debe eliminarse",
  T_48_META_API_9004_D: "Crea un texto con el contenido de texto especificado, y cuando hay más atributos que establecer, establece además sus atributos de entidad a través de la entidad (obsoleto, por favor utilice CreateLevelObject)",
  T_48_META_API_9004_P0_D: "En el código es el nombre del parámetro formal utilizado para representar la entidad que crea el texto, y su correspondiente valor de variable local es la entidad que crea el texto",
  T_48_META_API_9004_P1_D: "La entidad de jugador a la que pertenece, visible sólo para ese jugador",
  T_48_META_API_9004_P2_D: "Contenido del texto a presentar",
  T_48_META_API_9005_D: "Eliminar el texto especificado (obsoleto, utilice DeleteEntity)",
  T_48_META_API_9005_P0_D: "Entidades de texto que deben eliminarse",
  T_48_META_API_9006_D: "Crea un icono con el tipo de efecto especificado, y cuando hay más propiedades que deben establecerse, a continuación, establece sus propiedades de entidad más a través de la entidad (obsoleto, por favor, utilice CreateEffect)",
  T_48_META_API_9006_P0_D: "En el código está el nombre del parámetro formal utilizado para representar la entidad que crea el efecto, y el valor de su variable local correspondiente es la entidad que crea el efecto.",
  T_48_META_API_9006_P1_D: "La entidad de jugador a la que pertenece, visible sólo para ese jugador",
  T_48_META_API_9006_P2_D: "Tipos de efectos, los tipos de efectos que pueden elegir los jugadores",
  T_48_META_API_9007_D: "Eliminar el efecto especificado (obsoleto, utilice DeleteEntity)",
  T_48_META_API_9007_P0_D: "La entidad de efectos a eliminar",
  T_48_META_API_9008_D: "Crear una interfaz de usuario personalizada que sólo puedan ver determinados jugadores",
  T_48_META_API_9008_P0_D: "Creación de entidades de interfaz de usuario personalizadas",
  T_48_META_API_9008_P1_D: "La entidad de jugador a la que pertenece la interfaz de usuario, visible sólo para ese jugador.",
  T_48_META_API_9008_P2_D: "Índice de IU personalizado",
  T_48_META_API_9009_D: "Eliminar la interfaz de usuario personalizada del juego",
  T_48_META_API_9009_P0_D: "Entidades de IU personalizadas que deben eliminarse",
  T_48_META_API_9010_D: "Obtención de controles de interfaz de usuario desde una interfaz de usuario personalizada",
  T_48_META_API_9010_P0_D: "Entidad de jugador a la que pertenece la IU",
  T_48_META_API_9010_P1_D: "Entidades de interfaz de usuario personalizadas",
  T_48_META_API_9010_P2_D: "Control Índice único",
  T_48_META_API_9010_R_D: "Entidad de control de la interfaz de usuario",
  T_48_META_API_9011_D: "Reproduce el sonido especificado y, si hay más propiedades que deban establecerse, establece además sus propiedades de entidad a través de la entidad (obsoleto, utilice CreateSound)",
  T_48_META_API_9011_P0_D: "En el código es el nombre del parámetro formal utilizado para representar la entidad que crea el efecto de sonido, y su correspondiente valor de variable local es la entidad que crea el efecto de sonido",
  T_48_META_API_9011_P1_D: "La entidad de jugador a la que pertenece, visible sólo para ese jugador",
  T_48_META_API_9011_P2_D: "Tipos de sonido, los tipos de efectos de sonido que el jugador puede elegir.",
  T_48_META_API_9012_D: "Eliminar el efecto de sonido especificado (obsoleto, utilice EliminarEntidad)",
  T_48_META_API_9012_P0_D: "Entidades de sonido que deben eliminarse",
  T_48_META_API_9013_D: "Obtención de un control de interfaz de usuario desde una interfaz de usuario personalizada mediante una ruta",
  T_48_META_API_9013_P0_D: "Entidad de jugador a la que pertenece la IU",
  T_48_META_API_9013_P1_D: "IU personalizada",
  T_48_META_API_9013_P2_D: "Ruta de control",
  T_48_META_API_9013_R_D: "Entidad de control de la interfaz de usuario",
  T_48_META_API_9014_D: "Entidad de sonido en reproducción interrumpida (obsoleto, utilice PauseSound)",
  T_48_META_API_9014_P0_D: "Entidades de sonido que deben suspenderse",
  T_48_META_API_9015_D: "Reanudar sonido, opcionalmente desde el principio (obsoleto, utilice ResumeSound)",
  T_48_META_API_9015_P0_D: "Entidades sonoras que deben seguir reproduciéndose tras ser pausadas",
  T_48_META_API_9015_P1_D: "Empezar de cero",
  T_48_META_API_9016_D: "Creación de controles de interfaz de usuario personalizados",
  T_48_META_API_9016_P0_D: "Creación de entidades de control personalizadas",
  T_48_META_API_9016_P1_D: "Tipo de control creado",
  T_48_META_API_9016_P2_D: "Entidades de IU afiliadas",
  T_48_META_API_9016_P3_D: "Control padre, si no se rellena, entonces la entidad UI será el nodo padre.",
  T_48_META_API_9017_D: "Configuración de la máscara de capa de la cámara de destino",
  T_48_META_API_9017_P0_D: "cámara objetivo entidad",
  T_48_META_API_9017_P1_D: "Máscara de capa, sólo las capas rellenas se mostrarán en la cámara de destino, si se deja en blanco se mostrarán todas las capas.",
  T_48_META_API_9018_D: "Obtener máscara de capa de cámara de destino",
  T_48_META_API_9018_P0_D: "cámara objetivo entidad",
  T_48_META_API_9018_R_D: "Máscara de capa, sólo las capas dentro de la máscara de capa se muestran en la cámara de destino",
  T_48_META_API_9019_D: "Establece si el nivel especificado es visible para la cámara de destino",
  T_48_META_API_9019_P0_D: "cámara objetivo entidad",
  T_48_META_API_9019_P1_D: "Jerarquía de visibilidad",
  T_48_META_API_9019_P2_D: "visibilidad",
  T_48_META_API_9020_D: "Establecer el estado predeterminado de la interfaz del reproductor de destino",
  T_48_META_API_9020_P0_D: "jugador objetivo",
  T_48_META_API_9020_P1_D: "Tipos de interfaz de jugador, que son elementos de interfaz de usuario utilizados para manipular al jugador y el contenido relacionado con el jugador.",
  T_48_META_API_9020_P2_D: "Valor del interruptor, determina la visibilidad de la interfaz del jugador.",
  T_48_META_API_9021_D: "Crear una cadena de localización de fecha y hora",
  T_48_META_API_9021_P0_D: "marca de tiempo",
  T_48_META_API_9021_P1_D: "Estilos de formato",
  T_48_META_API_9021_R_D: "Timestamp Cadena de localización",
  T_48_META_API_9022_D: "Crear un icono de minimapa",
  T_48_META_API_9022_P0_D: "Creadas las entidades icono del minimapa",
  T_48_META_API_9022_P1_D: "El jugador al que perteneces crea un icono de minimapa que sólo es visible para ese jugador.",
  T_48_META_API_9022_P2_D: "Mapa mental Icono Ruta de recursos",
  T_48_META_API_9023_D: "Crea un icono con el tipo de efecto especificado, y además establece sus propiedades de entidad a través de la entidad si hay más propiedades que establecer.",
  T_48_META_API_9023_P0_D: "En el código está el nombre del parámetro formal utilizado para representar la entidad que crea el efecto, y el valor de su variable local correspondiente es la entidad que crea el efecto.",
  T_48_META_API_9023_P1_D: "La entidad de jugador a la que pertenece, visible sólo para ese jugador",
  T_48_META_API_9023_P2_D: "Tipos de efectos, los tipos de efectos que pueden elegir los jugadores",
  T_48_META_API_9024_D: "Eliminar el efecto especificado (obsoleto, utilice DeleteEntity)",
  T_48_META_API_9024_P0_D: "La entidad de efectos a eliminar",
  T_48_META_API_9025_D: "Genera píxeles estáticos en el mapa para el objeto objetivo, que no se mueven con el objeto objetivo.",
  T_48_META_API_9025_P0_D: "Entidades estáticas de píxeles creadas",
  T_48_META_API_9025_P1_D: "El jugador al que pertenece, creando píxeles estáticos que sólo son visibles para ese jugador.",
  T_48_META_API_9025_P2_D: "entidad objeto de destino",
  T_48_META_API_9026_D: "Obtener la entidad del minimapa del jugador objetivo",
  T_48_META_API_9026_P0_D: "jugador objetivo",
  T_48_META_API_9026_R_D: "Mini mapa del jugador actual",
  T_48_META_API_9027_D: "Establecer el daño de la caída del jugador, puede establecer diferentes daños de acuerdo a los segmentos de altura",
  T_48_META_API_9027_P0_D: "jugador objetivo",
  T_48_META_API_9027_P1_D: "Lista segmentada por alturas",
  T_48_META_API_9027_P2_D: "Lista de segmentos de daños",
  T_48_META_API_91_D: "Al añadir un objetivo a un equipo específico, el objetivo abandonará el equipo al que pertenecía anteriormente.",
  T_48_META_API_91_P0_D: "Objetivos que deben añadirse al equipo",
  T_48_META_API_91_P1_D: "Únete al equipo",
  T_48_META_API_91_P2_D: "éxito o fracaso",
  T_48_META_API_92_D: "Al añadir un objetivo a un equipo recién creado, el objetivo dejará de pertenecer al equipo en el que estaba anteriormente.",
  T_48_META_API_92_P0_D: "Objetivos que deben añadirse al equipo",
  T_48_META_API_92_P1_D: "Nombre del nuevo equipo",
  T_48_META_API_92_P2_D: "éxito o fracaso",
  T_48_META_API_94_D: "Establezca el valor de una variable local por índice; antes de configurarla, la variable debe definirse en el proceso de llamada actual",
  T_48_META_API_94_P0: "Índice",
  T_48_META_API_94_P0_D: "Obtener una variable por índice",
  T_48_META_API_94_P1: "Valor variable",
  T_48_META_API_94_P1_D: "Valor de la variable objetivo",
  T_48_META_API_94_P2: "Tipo aritmético",
  T_48_META_API_94_P2_D: "Método de operación; todos los tipos admiten asignación, y los tipos numéricos también admiten operaciones de incremento, decremento, multiplicación, división y módulo.",
  T_48_META_API_94_P3: "Nombre de la variable",
  T_48_META_API_94_P3_D: "Nombre de la variable de destino. Se utiliza únicamente para la salida de error.",
  T_48_META_API_95: "Obtener variable local por índice",
  T_48_META_API_95_D: "Obtener el valor de una variable local; antes de obtenerlo, la variable debe estar definida en el proceso de llamada actual",
  T_48_META_API_95_P0: "Índice",
  T_48_META_API_95_P0_D: "Índice variable",
  T_48_META_API_95_P1: "Nombre de la variable",
  T_48_META_API_95_P1_D: "Nombre de la variable de destino. Se utiliza únicamente para la salida de error.",
  T_48_META_API_9500_D: "Efectos de reproducción del lado del cliente que notifican al reproductor de destino",
  T_48_META_API_9500_P0_D: "jugador objetivo",
  T_48_META_API_9500_P1_D: "Ruta de recursos para efectos especiales",
  T_48_META_API_9500_P2_D: "color",
  T_48_META_API_9500_P3_D: "Tamaño del zoom, por defecto es 1",
  T_48_META_API_9500_P4_D: "Objeto vinculado al que se añaden efectos como sus nodos hijos",
  T_48_META_API_9500_P5_D: "Desplazamiento en coordenadas globales respecto al objeto enlazado",
  T_48_META_API_9501_D: "Notificar al cliente del reproductor de destino que reproduzca un efecto de sonido",
  T_48_META_API_9501_P0_D: "jugador objetivo",
  T_48_META_API_9501_P1_D: "Tipo de efecto sonoro",
  T_48_META_API_9502_D: "Notificar al cliente del jugador de destino que muestre caracteres flotantes",
  T_48_META_API_9502_P0_D: "jugador objetivo",
  T_48_META_API_9502_P1_D: 'El contenido de la palabra "float',
  T_48_META_API_9502_P2_D: "Carácter flotante Color, Tipo Color",
  T_48_META_API_9502_P3_D: "Duración de la palabra flotante en milisegundos",
  T_48_META_API_9503_D: "Haz que la unidad objetivo juegue una vez una expresión de acción Emote",
  T_48_META_API_9503_P0_D: "Jugar a los goles de Emote",
  T_48_META_API_9503_P1_D: "Tipo de emoción",
  T_48_META_API_9504_D: "Pausar/reanudar la expresión del movimiento Emote de la unidad",
  T_48_META_API_9504_P0_D: "Suspender/reanudar los objetivos de Emote",
  T_48_META_API_9504_P1_D: "Verdadero: pausa la reproducción, Falso: reanuda la reproducción",
  T_48_META_EVT_1_D: "Se activa al inicio del juego, el servidor estará listo un tiempo antes que el cliente.",
  T_48_META_EVT_10_D: "Se activa antes de que la entidad actual reciba daño",
  T_48_META_EVT_10_P0_D: "Entidad atacante, posiblemente nula",
  T_48_META_EVT_10_P1_D: "Tipo de daño",
  T_48_META_EVT_10_P2_D: "Cuantía de los daños",
  T_48_META_EVT_10_P3_D: "parte herida",
  T_48_META_EVT_1000_D: "Se activa cuando cambian los puntos del jugador",
  T_48_META_EVT_1000_P0_D: "Jugadores con cambios en los puntos",
  T_48_META_EVT_1000_P1_D: "Tipos de puntos de cambio",
  T_48_META_EVT_1000_P2_D: "Valor integral después del cambio integral",
  T_48_META_EVT_1001_D: "Se activa cuando cambian los puntos del equipo",
  T_48_META_EVT_1001_P0_D: "Equipos con cambios en los puntos",
  T_48_META_EVT_1001_P1_D: "Tipos de puntos de cambio",
  T_48_META_EVT_1001_P2_D: "Valor integral después del cambio integral",
  T_48_META_EVT_1002_D: "Se activa cuando cambia la clasificación de un jugador",
  T_48_META_EVT_1002_P0_D: "Jugadores con cambios en la clasificación",
  T_48_META_EVT_1002_P1_D: "Clasificación tras el cambio de clasificación",
  T_48_META_EVT_1003_D: "abandonado",
  T_48_META_EVT_1003_P0_D: "abandonado",
  T_48_META_EVT_1003_P1_D: "Clasificación tras el cambio de clasificación",
  T_48_META_EVT_11_D: "Se activa cuando el jugador sale a mitad de partida",
  T_48_META_EVT_11_P0_D: "El jugador que se retiró a mitad de partida",
  T_48_META_EVT_12_D: "Se activa cuando el controlador del jugador toca una entidad, y sólo se activa cuando el controlador experimenta un movimiento activo",
  T_48_META_EVT_12_P0_D: "Entidades encontradas",
  T_48_META_EVT_13_D: "Se activa antes de que la entidad actual inflija daño",
  T_48_META_EVT_13_P0_D: "Entidades perjudicadas",
  T_48_META_EVT_13_P1_D: "Tipo de daño",
  T_48_META_EVT_13_P2_D: "Cuantía de los daños",
  T_48_META_EVT_13_P3_D: "parte herida",
  T_48_META_EVT_14_D: "Este evento sólo funciona en el lado del cliente si la entidad reproducible es una entidad de sonido, efecto, etc.",
  T_48_META_EVT_2_D: "Se dispara cuando se actualiza el marco lógico, dependiendo de la plataforma y la configuración, la frecuencia de este evento puede variar.",
  T_48_META_EVT_2002_D: "Se activa al morir el jugador",
  T_48_META_EVT_2002_P0_D: "Jugadores muertos",
  T_48_META_EVT_2003_D: "Se activa con las asistencias de los jugadores",
  T_48_META_EVT_2003_P0_D: "Jugadores con asistencias",
  T_48_META_EVT_2003_P1_D: "Jugadores muertos",
  T_48_META_EVT_2004_D: "Se activa cuando el jugador inflige daño",
  T_48_META_EVT_2004_P0_D: "El jugador que causó el daño",
  T_48_META_EVT_2004_P1_D: "reproductor dañado",
  T_48_META_EVT_2004_P2_D: "Tipo de daño",
  T_48_META_EVT_2004_P3_D: "cantidad de daños",
  T_48_META_EVT_2004_P4_D: "parte herida",
  T_48_META_EVT_2005_D: "Se activa cuando un jugador inflige una muerte",
  T_48_META_EVT_2005_P0_D: "jugador que ha causado un golpe",
  T_48_META_EVT_2005_P1_D: "Jugadores muertos",
  T_48_META_EVT_2005_P2_D: "Tipo de daño",
  T_48_META_EVT_2006_D: "Se activa cuando un jugador se une al juego",
  T_48_META_EVT_2006_P0_D: "Jugadores que se unen al juego",
  T_48_META_EVT_2007_D: "Se activa cuando se revive al jugador",
  T_48_META_EVT_2007_P0_D: "Jugadores resucitados",
  T_48_META_EVT_2007_P1_D: "Fuentes de la resurrección",
  T_48_META_EVT_2008_D: "Se activa cuando un jugador es derribado",
  T_48_META_EVT_2008_P0_D: "Jugador noqueado",
  T_48_META_EVT_2008_P1_D: "agresor",
  T_48_META_EVT_2009_D: "Se activa cuando el jugador se desconecta",
  T_48_META_EVT_2009_P0_D: "Jugadores desconectados",
  T_48_META_EVT_2010_D: "Se activa cuando el jugador se vuelve a conectar",
  T_48_META_EVT_2010_P0_D: "Jugadores reconectados",
  T_48_META_EVT_2100_D: "Se activa cuando se elimina el equipo",
  T_48_META_EVT_2100_P0_D: "Equipos eliminados",
  T_48_META_EVT_2101_D: "Se activa al añadir un equipo",
  T_48_META_EVT_2101_P0_D: "Equipos añadidos",
  T_48_META_EVT_2102_D: "Se activa cuando el equipo es destruido por el grupo",
  T_48_META_EVT_2102_P0_D: "El equipo que fue aniquilado",
  T_48_META_EVT_3_D: "Se activa al final de la partida y antes de que ésta termine en el servidor",
  T_48_META_EVT_30_D: "Se activa cuando la escena se carga correctamente",
  T_48_META_EVT_30_P0_D: "nombre de la escena",
  T_48_META_EVT_3000_D: "Se activa tras la creación de la entidad actual",
  T_48_META_EVT_3001_D: "Se activa antes de que se destruya la entidad actual",
  T_48_META_EVT_3002_D: "Se activa cuando el jugador entra en el disparador",
  T_48_META_EVT_3002_P0_D: "Jugadores que entran en el gatillo",
  T_48_META_EVT_3003_D: "Se dispara cuando el jugador abandona el disparador",
  T_48_META_EVT_3003_P0_D: "Jugadores que abandonan el gatillo",
  T_48_META_EVT_3004_D: "Se activa al hacer clic en el control de botón de interfaz de usuario",
  T_48_META_EVT_3004_P0_D: "Jugadores que hacen clic",
  T_48_META_EVT_3005_D: "Se activa al hacer clic en un botón de la interfaz de usuario integrada.",
  T_48_META_EVT_3005_P0_D: "Nombre del control de botón para hacer clic",
  T_48_META_EVT_3006_D: "Se activa cuando el jugador utiliza esquís acuáticos",
  T_48_META_EVT_3007_D: "Se activa cuando la entidad actual está disponible",
  T_48_META_EVT_3008_D: "Se activa cuando la entidad actual no está disponible",
  T_48_META_EVT_3009_D: "Se activa cuando una entidad ingresa a un disparador. Cuando se activa un evento de disparador, ambas partes reciben el evento. Una parte debe ser un cuerpo rígido y la otra parte debe ser un disparador. En particular, cuando el disparador es un objeto de disparador personalizado, solo el disparador recibirá el evento.",
  T_48_META_EVT_3009_P0_D: "Entidad contraria en el momento del hecho desencadenante",
  T_48_META_EVT_3010_D: "Se activa cuando la entidad abandona el disparador. Cuando se activa el evento, ambas partes reciben el evento. Una parte debe ser un cuerpo rígido y la otra parte debe ser un disparador. En particular, cuando el disparador es un objeto de disparador personalizado, solo el disparador recibirá el evento.",
  T_48_META_EVT_3010_P0_D: "Entidad contraria en el momento del hecho desencadenante",
  T_48_META_EVT_3011_D: "Se activa cuando se destruye la entidad actual",
  T_48_META_EVT_3011_P0_D: "Entidad atacante, posiblemente nula",
  T_48_META_EVT_3011_P1_D: "Tipo de daño",
  T_48_META_EVT_3011_P2_D: "parte herida",
  T_48_META_EVT_3012_D: "Se activa después de que la entidad actual sea atacada",
  T_48_META_EVT_3012_P0_D: "Entidad atacante, posiblemente nula",
  T_48_META_EVT_3012_P1_D: "Tipo de daño",
  T_48_META_EVT_3012_P2_D: "Cuantía de los daños",
  T_48_META_EVT_3012_P3_D: "parte herida",
  T_48_META_EVT_3013_D: "Se activa después de que la entidad actual inflija daño",
  T_48_META_EVT_3013_P0_D: "Entidades perjudicadas",
  T_48_META_EVT_3013_P1_D: "Tipo de daño",
  T_48_META_EVT_3013_P2_D: "Cuantía de los daños",
  T_48_META_EVT_3013_P3_D: "parte herida",
  T_48_META_EVT_3014_D: "Se activa después de que la entidad actual destruya otra entidad",
  T_48_META_EVT_3014_P0_D: "Entidades eliminadas",
  T_48_META_EVT_3014_P1_D: "parte herida",
  T_48_META_EVT_3015_D: "Se activa cuando este jugador resucita",
  T_48_META_EVT_3015_P0_D: "Tipo de fuente de resurrección del jugador",
  T_48_META_EVT_3016_D: "Se activa cuando el generador genera una entidad",
  T_48_META_EVT_3016_P0_D: "Lista de entidades generadas",
  T_48_META_EVT_3016_P1_D: "número de onda",
  T_48_META_EVT_3017_D: "Llamada cuando el jugador entra en la posición de rodillas de noqueo",
  T_48_META_EVT_3018_D: "Se activa cuando todos los miembros del equipo están muertos",
  T_48_META_EVT_3019_D: "Se activa al equiparse con casco, chaleco antibalas o mochila.",
  T_48_META_EVT_3019_P0_D: "Identificación del equipo",
  T_48_META_EVT_3020_D: "Se activa al sujetar un arma principal, secundaria o cuerpo a cuerpo, incluso al cambiar a puño",
  T_48_META_EVT_3020_P0_D: "Entidad de arma equipada en el momento del disparo",
  T_48_META_EVT_3021_D: "Se activa después del uso de accesorios, los accesorios que requieren tiempo para su uso activarán este evento después de que se complete el uso.",
  T_48_META_EVT_3021_P0_D: "Identificación del atrezzo",
  T_48_META_EVT_3021_P1_D: "Entidad de utilería, posiblemente nula",
  T_48_META_EVT_3021_P2_D: "Nueva entidad prop creada utilizando props, puede estar vacía",
  T_48_META_EVT_3022_D: "Se activa al adquirir un objeto",
  T_48_META_EVT_3022_P0_D: "Tipo de artículo",
  T_48_META_EVT_3022_P1_D: "Entidad objeto, posiblemente nula",
  T_48_META_EVT_3023_D: "Se activa cuando cambian los puntos de entidad",
  T_48_META_EVT_3023_P0_D: "Tipos de puntos de cambio",
  T_48_META_EVT_3023_P1_D: "Valor integral después del cambio integral",
  T_48_META_EVT_3024_D: "Se activa cuando cambia la clasificación de la entidad",
  T_48_META_EVT_3024_P0_D: "Clasificación tras el cambio de clasificación",
  T_48_META_EVT_3025_D: "Se activa con una asistencia",
  T_48_META_EVT_3025_P0_D: "hit",
  T_48_META_EVT_3026_D: "Se activa cuando una entidad entra en un vehículo, incluso como conductor y pasajero",
  T_48_META_EVT_3026_P0_D: "Entidades que entran en el transportista",
  T_48_META_EVT_3026_P1_D: "Transportistas inscritos",
  T_48_META_EVT_3027_D: "Se activa cuando la entidad abandona el transportista",
  T_48_META_EVT_3027_P0_D: "Entidades que abandonan el transportista",
  T_48_META_EVT_3027_P1_D: "Transportistas salientes",
  T_48_META_EVT_3028_D: "Se activa cuando se conduce físicamente un vehículo de transporte, cuando se está en un coche como conductor",
  T_48_META_EVT_3028_P0_D: "Entidad impulsora del transportista",
  T_48_META_EVT_3028_P1_D: "Vehículos propulsados",
  T_48_META_EVT_3029_D: "Se activa cuando se introduce físicamente el soporte",
  T_48_META_EVT_3029_P0_D: "entidad desencadenante",
  T_48_META_EVT_3030_D: "Se activa cuando el transportista sale",
  T_48_META_EVT_3030_P0_D: "entidad desencadenante",
  T_48_META_EVT_3031_D: "Se activa cuando el vehículo está siendo conducido por una entidad",
  T_48_META_EVT_3031_P0_D: "entidad desencadenante",
  T_48_META_EVT_3032_D: "Se activa después de que se produzca un teletransporte cuando una entidad utiliza un portal (obsoleto, utilice OnBouncesOffTire)",
  T_48_META_EVT_3032_P0_D: "Entidades que utilizan el portal",
  T_48_META_EVT_3032_P1_D: "Portal utilizado",
  T_48_META_EVT_3033_D: "Se activa cuando la entidad rebota",
  T_48_META_EVT_3033_P0_D: "entidad desencadenante",
  T_48_META_EVT_3033_P1_D: "Objetos rebotadores utilizados",
  T_48_META_EVT_3034_D: "Se activa después de que el portal permita a la entidad teletransportarse",
  T_48_META_EVT_3034_P0_D: "entidad transmisora",
  T_48_META_EVT_3035_D: "Se activa después de que el neumático rebote en la entidad",
  T_48_META_EVT_3035_P0_D: "entidad emergente",
  T_48_META_EVT_3036_D: "Se activa cuando una máquina envía una entidad en vuelo",
  T_48_META_EVT_3036_P0_D: "entidad que se desprende",
  T_48_META_EVT_3036_P1_D: "objeto generado por máquina",
  T_48_META_EVT_3037_D: "Se dispara cuando la entidad entra en el disparador",
  T_48_META_EVT_3037_P0_D: "Activación de la entrada",
  T_48_META_EVT_3038_D: "Se dispara cuando la entidad abandona el disparador",
  T_48_META_EVT_3038_P0_D: "Desencadenante de la salida",
  T_48_META_EVT_3039_D: "Se activa al adquirir una entidad de arma",
  T_48_META_EVT_3039_P0_D: "entidad armamentística",
  T_48_META_EVT_3040_D: "Se activa cuando una entidad es derribada por una máquina",
  T_48_META_EVT_3040_P0_D: "entidad que se desprende",
  T_48_META_EVT_3040_P1_D: "objeto generado por máquina",
  T_48_META_EVT_3041_D: "Se activa al apuntar a una entidad seleccionable",
  T_48_META_EVT_3041_P0_D: "Entidades destinatarias",
  T_48_META_EVT_3042_D: "Se activa cuando es objetivo de un jugador",
  T_48_META_EVT_3042_P0_D: "Apuntar a los jugadores",
  T_48_META_EVT_3043_D: "Se activa cuando la bala alcanza el objetivo",
  T_48_META_EVT_3043_P0_D: "hit",
  T_48_META_EVT_3043_P1_D: "Coordenadas mundiales de los lugares de impacto de bala",
  T_48_META_EVT_3044_D: "Se dispara al ser alcanzado por un arma",
  T_48_META_EVT_3044_P0_D: "armamento",
  T_48_META_EVT_3044_P1_D: "Coordenadas mundiales de la zona afectada",
  T_48_META_EVT_3045_D: "Se activa cuando el jugador elige transformarse en un objeto para ese nivel.",
  T_48_META_EVT_3045_P0_D: "El jugador se transforma en una entidad, no en el propio objeto de la escena",
  T_48_META_EVT_3046_D: "Se activa cuando un jugador resucita en ese punto de resurrección",
  T_48_META_EVT_3046_P0_D: "Jugadores resucitados en este punto de resurrección",
  T_48_META_EVT_3047_D: "Se activa cuando un jugador descarta un arma",
  T_48_META_EVT_3047_P0_D: "Entidades de armas abandonadas",
  T_48_META_EVT_3048_D: "Se activa cuando un jugador descarta un objeto que no sea un arma",
  T_48_META_EVT_3048_P0_D: "Tipo de artículo",
  T_48_META_EVT_3048_P1_D: "Entidad objeto, posiblemente nula",
  T_48_META_EVT_3049_D: "Se dispara al ser alcanzado por un cañón de fútbol",
  T_48_META_EVT_3049_P0_D: "jugador",
  T_48_META_EVT_3049_P1_D: "Velocidad tras ser golpeado",
  T_48_META_EVT_3050_D: "Se dispara al colisionar el balón con un sólido",
  T_48_META_EVT_3050_P0_D: "objeto de colisión",
  T_48_META_EVT_3050_P1_D: "Velocidad tras la colisión",
  T_48_META_EVT_3051_D: "Se activa cuando un jugador se une con éxito a un canal de voz",
  T_48_META_EVT_3051_P0_D: "entidad de canal de voz",
  T_48_META_EVT_3052_D: "Se activa cuando un jugador no consigue unirse a un canal de voz",
  T_48_META_EVT_3052_P0_D: "entidad de canal de voz",
  T_48_META_EVT_3053_D: "Se activa cuando un jugador sale de un canal de voz",
  T_48_META_EVT_3053_P0_D: "entidad de canal de voz",
  T_48_META_EVT_3054_D: "Se activa cuando el balón entra en la portería",
  T_48_META_EVT_3054_P0_D: "boca de gol",
  T_48_META_EVT_3054_P1_D: "Goleador, el último jugador que toca el balón antes de entrar en la portería",
  T_48_META_EVT_3054_P2_D: "Asistentes, penúltimo jugador en tocar el balón antes de que se marque el gol",
  T_48_META_EVT_3055_D: "Se activa cuando el jugador pulsa el botón de disparo",
  T_48_META_EVT_3056_D: "Se activa cuando el jugador salta",
  T_48_META_EVT_3057_D: "Se activa cuando el jugador se agacha",
  T_48_META_EVT_3058_D: "Se activa cuando el jugador cae",
  T_48_META_EVT_3059_D: "Se activa cuando el jugador esprinta",
  T_48_META_EVT_3060_D: "Se activa cuando se compra un artículo en la tienda.",
  T_48_META_EVT_3060_P0_D: "Jugadores que compran bienes",
  T_48_META_EVT_3060_P1_D: "mercancía",
  T_48_META_EVT_3061_D: "Se activa cuando el jugador equipa el arma",
  T_48_META_EVT_3061_P0_D: "Jugadores equipados con armas",
  T_48_META_EVT_3062_D: "Se activa cuando se mata a una unidad con esta arma",
  T_48_META_EVT_3062_P0_D: "Entidades muertas",
  T_48_META_EVT_3063_D: "Se activa al usar esta arma para infligir daño a una unidad.",
  T_48_META_EVT_3063_P0_D: "entidad perjudicada",
  T_48_META_EVT_3063_P1_D: "cantidad de daños",
  T_48_META_EVT_3064_D: "Se activa cuando el arma cambia de bala",
  T_48_META_EVT_3065_D: "Se activa cuando una entidad entra en el transportista, ya sea como conductor o como pasajero",
  T_48_META_EVT_3065_P0_D: "Transportistas inscritos",
  T_48_META_EVT_3066_D: "Se activa cuando la entidad abandona el transportista",
  T_48_META_EVT_3066_P0_D: "Transportistas salientes",
  T_48_META_EVT_3067_D: "Se dispara mientras se conduce físicamente el portador",
  T_48_META_EVT_3067_P0_D: "Vehículos propulsados",
  T_48_META_EVT_3068_D: "Se activa después de que se produzca un teletransporte cuando una entidad utiliza un portal",
  T_48_META_EVT_3068_P0_D: "Portal utilizado",
  T_48_META_EVT_3069_D: "Se activa cuando una entidad rebota en un neumático",
  T_48_META_EVT_3069_P0_D: "Neumáticos utilizados",
  T_48_META_EVT_3070_D: "Se activa cuando una entidad es derribada por una máquina",
  T_48_META_EVT_3070_P0_D: "objeto generado por máquina",
  T_48_META_EVT_3071_D: "Se activa cuando el jugador pulsa un botón de la interfaz de usuario.",
  T_48_META_EVT_3071_P0_D: "activador",
  T_48_META_EVT_3072_D: "Se activa cuando se levanta el control del botón de la interfaz de usuario",
  T_48_META_EVT_3072_P0_D: "activador",
  T_48_META_EVT_3073_D: "Se activa cuando el jugador hace doble clic en un botón de la interfaz de usuario.",
  T_48_META_EVT_3073_P0_D: "activador",
  T_48_META_EVT_3074_D: "Inicio del área Jailbreak",
  T_48_META_EVT_3075_D: "Se cierra el área de fuga de la prisión",
  T_48_META_EVT_3076_D: "Se activa cuando el jugador deja de usar los esquís acuáticos",
  T_48_META_EVT_3077_D: "Se activa cuando el reproductor cambia el contenido del texto del control del cuadro de entrada de la interfaz de usuario.",
  T_48_META_EVT_3077_P0_D: "activador",
  T_48_META_EVT_3077_P1_D: "Contenido del texto modificado",
  T_48_META_EVT_3078_D: "Se activa cuando la entidad jugable empieza a jugar",
  T_48_META_EVT_3078_P0_D: "entidad jugable",
  T_48_META_EVT_3079_D: "Se dispara cuando una entidad reproducible termina de reproducirse, este evento sólo funciona en el lado del cliente si la entidad reproducible es una entidad de sonido, efecto, etc.",
  T_48_META_EVT_3079_P0_D: "entidad jugable",
  T_48_META_EVT_3080_D: "Se activa cuando la entidad jugable sigue jugando",
  T_48_META_EVT_3080_P0_D: "entidad jugable",
  T_48_META_EVT_3081_D: "Se activa cuando una entidad reproducible pausa la reproducción",
  T_48_META_EVT_3081_P0_D: "entidad jugable",
  T_48_META_EVT_3082_D: "Los jugadores de Jailbreak se unen",
  T_48_META_EVT_3082_P0_D: "activador",
  T_48_META_EVT_3083_D: "Los jugadores de Jailbreak abandonan",
  T_48_META_EVT_3083_P0_D: "activador",
  T_48_META_EVT_3084_D: "Se activa al final de la cuenta atrás",
  T_48_META_EVT_3084_P0_D: "entidad afiliada",
  T_48_META_EVT_3085_D: "Se activa cuando se recoge un artículo",
  T_48_META_EVT_3085_P0_D: "Jugadores que recogen objetos",
  T_48_META_EVT_3086_D: "Se activa cuando se descarta un artículo",
  T_48_META_EVT_3086_P0_D: "El jugador que dejó caer el objeto",
  T_48_META_EVT_3087_D: "Se activa cuando se equipa este objeto",
  T_48_META_EVT_3088_D: "Se activa cuando se inicia el objeto tras la creación de la mina",
  T_48_META_EVT_3089_D: "Se activa cuando el objeto se activa después de crear la mina",
  T_48_META_EVT_3089_P0_D: "Orientación de los objetos tras la creación de la mina",
  T_48_META_EVT_3090_D: "Se activa antes de comprar un artículo en una tienda",
  T_48_META_EVT_3090_P0_D: "Jugadores que compran bienes",
  T_48_META_EVT_3090_P1_D: "mercancía",
  T_48_META_EVT_3091_D: "Se activa cuando se utiliza este dispositivo",
  T_48_META_EVT_3092_D: "Se activa cuando se dispara la pistola de gancho",
  T_48_META_EVT_3093_D: "Se activa cuando el proyectil explota tras ser lanzado.",
  T_48_META_EVT_3093_P0_D: "punto de explosión",
  T_48_META_EVT_3094_D: "Se dispara al ser alcanzado por una pistola de bolas de pintura",
  T_48_META_EVT_3094_P0_D: "Entidades de pistolas de pintura",
  T_48_META_EVT_3094_P1_D: "punto de ataque",
  T_48_META_EVT_3094_P2_D: "dar en la línea de meta",
  T_48_META_EVT_3095_D: "Se dispara al golpear con la pistola de pintura",
  T_48_META_EVT_3095_P0_D: "objeto golpeado",
  T_48_META_EVT_3095_P1_D: "punto de ataque",
  T_48_META_EVT_3095_P2_D: "dar en la línea de meta",
  T_48_META_EVT_3096_D: "Se activa cuando explota un portador o un cubo de tinte",
  T_48_META_EVT_3096_P0_D: "El jugador que causó la explosión",
  T_48_META_EVT_3096_P1_D: "Lista de jugadores afectados por la explosión",
  T_48_META_EVT_3097_D: "Se activa cuando el arma deja de disparar",
  T_48_META_EVT_3097_P0_D: "Capacidad actual del cargador en el momento del alto el fuego",
  T_48_META_EVT_3098_D: "Se activa cuando el objetivo perseguido entra en la zona de persecución",
  T_48_META_EVT_3099_D: "Se activa cuando el objetivo perseguido sale del radio de persecución",
  T_48_META_EVT_31_D: "Se activa al cambiar de escena con éxito",
  T_48_META_EVT_31_P0_D: "nombre de la escena",
  T_48_META_EVT_3100_D: "Se activa cuando el objetivo del ataque entra en el rango de ataque",
  T_48_META_EVT_3101_D: "Se activa cuando el objetivo del ataque está fuera de alcance",
  T_48_META_EVT_3102_D: "Se activa cuando la detección de rayos de la cámara se activa mediante un evento de clic del cliente",
  T_48_META_EVT_3102_P0_D: "activador",
  T_48_META_EVT_3102_P1_D: "Si el rayo de la cámara alcanza el objeto",
  T_48_META_EVT_3102_P2_D: "Posición de impacto del rayo de cámara",
  T_48_META_EVT_3102_P3_D: "Orientación de la cámara cliente",
  T_48_META_EVT_3102_P4_D: "Posición de la cámara cliente",
  T_48_META_EVT_3102_P5_D: "dar en el blanco",
  T_48_META_EVT_3103_D: "Se activa al abrir la pantalla de la tienda",
  T_48_META_EVT_3103_P0_D: "activador",
  T_48_META_EVT_3104_D: "Se activa cuando se cierra la pantalla de la tienda",
  T_48_META_EVT_3104_P0_D: "activador",
  T_48_META_EVT_3105_D: "Se activa cuando la lógica del árbol de comportamiento entra en el nodo",
  T_48_META_EVT_3105_P0_D: "Nombre del nodo",
  T_48_META_EVT_3105_P1_D: "entidad afiliada",
  T_48_META_EVT_3106_D: "Se activa cuando la lógica del árbol de comportamiento sale del nodo",
  T_48_META_EVT_3106_P0_D: "Nombre del nodo",
  T_48_META_EVT_3106_P1_D: "entidad afiliada",
  T_48_META_EVT_3107_D: "Se activa cuando se despierta un cuerpo rígido",
  T_48_META_EVT_3108_D: "Se activa cuando el cuerpo rígido entra en reposo",
  T_48_META_EVT_3109_D: "Se activa cuando el jugador se mueve",
  T_48_META_EVT_3109_P0_D: "oberturas",
  T_48_META_EVT_3110_D: "Se activa cuando el reproductor está en espera",
  T_48_META_EVT_3110_P0_D: "oberturas",
  T_48_META_EVT_3111_D: "Se activa cuando el jugador utiliza una habilidad",
  T_48_META_EVT_3111_P0_D: "Habilidades utilizadas",
  T_48_META_EVT_3112_D: "Se activa cuando el jugador termina de esprintar",
  T_48_META_EVT_3113_D: "Se activa cuando se adquiere el elemento correspondiente a la ranura de la enumeración SwitchEquipSlot.",
  T_48_META_EVT_3113_P0_D: "Entidades adquiridas",
  T_48_META_EVT_3114_D: "Se dispara al cambiar de objeto de mano, incluso al cambiar a puño",
  T_48_META_EVT_3114_P0_D: "Entidades de la partida retenidas tras el cambio",
  T_48_META_EVT_3115_D: "Se activa cuando un jugador en la tienda pide a alguien que compre un artículo",
  T_48_META_EVT_3115_P0_D: "Jugadores que solicitan merchandising",
  T_48_META_EVT_3115_P1_D: "mercancía",
  T_48_META_EVT_3116_D: "Se activa cuando un jugador de una tienda solicita un objeto a otra persona y la solicitud es aceptada.",
  T_48_META_EVT_3116_P0_D: "Ayuda para jugadores comprados",
  T_48_META_EVT_3116_P1_D: "Jugadores que solicitan ayuda para sus compras",
  T_48_META_EVT_3116_P2_D: "mercancía",
  T_48_META_EVT_3117_D: "Se activa en actualizaciones de fotogramas fijas a una frecuencia fija de 30 veces por segundo.",
  T_48_META_EVT_3118_D: "Se activa tras una llamada a la API de pausa del juego",
  T_48_META_EVT_3119_D: "Se activa tras una llamada a la API de restauración de partidas",
  T_48_META_EVT_3120_D: "Se activa cuando un jugador añade o elimina a un amigo",
  T_48_META_EVT_3121_D: "Se activa al recibir el mensaje Persona",
  T_48_META_EVT_3121_P0_D: "Contenido de la información",
  T_48_META_EVT_3121_P1_D: "Persona remitente",
  T_48_META_EVT_3122_D: "Se activa al final del salto de un jugador",
  T_48_META_EVT_3123_D: "Se activa cuando el jugador cae",
  T_48_META_EVT_3124_D: "Se activa al final de la caída de un jugador",
  T_48_META_EVT_3125_D: "Se activa al recibir el comportamiento de Persona",
  T_48_META_EVT_3125_P0_D: "comportamiento",
  T_48_META_EVT_3125_P1_D: "Persona remitente",
  T_48_META_EVT_3126_D: "Se activa cuando cambian los datos de los afiliados",
  T_48_META_EVT_3126_P0_D: "Cambio de estatus del diputado",
  T_48_META_EVT_3127_D: "Se activa al entrar en el Centro de Miembros",
  T_48_META_EVT_3128_D: "Se activa al salir del Centro de Atención a los Miembros",
  T_48_META_EVT_3129_D: "Se activa cuando el jugador entra en estado de derribo",
  T_48_META_EVT_3129_P0_D: "Entidad atacante, posiblemente nula",
  T_48_META_EVT_3130_D: "Se activa cuando se recibe el estado de Persona",
  T_48_META_EVT_3130_P0_D: "Persona remitente",
  T_48_META_EVT_3130_P1_D: "código de error",
  T_48_META_EVT_3131_D: "Se activa al enviar un mensaje a Persona a través de la interfaz de usuario.",
  T_48_META_EVT_3131_P0_D: "Contenido de la información",
  T_48_META_EVT_3131_P1_D: "Persona remitente",
  T_48_META_EVT_3132_D: "Se activa al final de la recepción de Persona",
  T_48_META_EVT_3132_P0_D: "Persona remitente",
  T_48_META_EVT_3132_P1_D: "código de error",
  T_48_META_EVT_32_D: "Se activa cuando el jugador cambia de escena",
  T_48_META_EVT_32_P0_D: "nombre de la escena",
  T_48_META_EVT_3200_D: "Se activa cuando el clip de animación termina de reproducirse",
  T_48_META_EVT_3200_P0_D: "Nombre del segmento animado",
  T_48_META_EVT_3201_D: "Se activa cuando el estado de animación termina de reproducirse",
  T_48_META_EVT_3201_P0_D: "Nombre del estado de animación",
  T_48_META_EVT_3204_D: "Se activa cuando cambia el estado del control Toggle.",
  T_48_META_EVT_3204_P0_D: "activador",
  T_48_META_EVT_3204_P1_D: "situación",
  T_48_META_EVT_3260_D: "Se activa cuando el jugador pulsa el panel táctil",
  T_48_META_EVT_3260_P0_D: "activador",
  T_48_META_EVT_3260_P1_D: "Posición de la prensa",
  T_48_META_EVT_3261_D: "Se activa cuando se levanta el panel táctil",
  T_48_META_EVT_3261_P0_D: "activador",
  T_48_META_EVT_3261_P1_D: "Posición de elevación",
  T_48_META_EVT_3262_D: "Se activa cuando el touchpad empieza a deslizarse",
  T_48_META_EVT_3262_P0_D: "activador",
  T_48_META_EVT_3262_P1_D: "Posición inicial del tobogán",
  T_48_META_EVT_3263_D: "Activado en un deslizamiento del touchpad, este evento se activa una vez por fotograma durante el deslizamiento",
  T_48_META_EVT_3263_P0_D: "activador",
  T_48_META_EVT_3263_P1_D: "Posición inicial del tobogán",
  T_48_META_EVT_3263_P2_D: "desplazamiento",
  T_48_META_EVT_3264_D: "Se activa al final de un deslizamiento del panel táctil",
  T_48_META_EVT_3264_P0_D: "activador",
  T_48_META_EVT_3264_P1_D: "Posición final",
  T_48_META_EVT_3265_D: "Se activa al pulsar el JoyStick",
  T_48_META_EVT_3265_P0_D: "activador",
  T_48_META_EVT_3266_D: "Se activa al levantar el JoyStick",
  T_48_META_EVT_3266_P0_D: "activador",
  T_48_META_EVT_3267_D: "Se activa al utilizar el joystick JoyStick",
  T_48_META_EVT_3267_P0_D: "activador",
  T_48_META_EVT_3267_P1_D: "Salida Desplazamiento",
  T_48_META_EVT_3268_D: "Se activa cuando el jugador se levanta de otra postura",
  T_48_META_EVT_3268_P0_D: "La postura del jugador antes de levantarse",
  T_48_META_EVT_3269_D: "Se activa cuando se dispara el arma",
  T_48_META_EVT_4_D: "Se activa al inicio de cada turno",
  T_48_META_EVT_4_P0_D: "Índice redondo, contando desde 0",
  T_48_META_EVT_5_D: "Se activa al final de cada turno",
  T_48_META_EVT_5_P0_D: "Índice redondo, contando desde 0",
  T_48_META_EVT_6_D: "Se dispara cuando una entidad ha colisionado, sólo soportado por entidades que tienen un componente de Cuerpo Rígido montado.",
  T_48_META_EVT_6_P0_D: "Entidades encontradas",
  T_48_META_EVT_7_D: "Se activa al principio de cada fase",
  T_48_META_EVT_7_P0_D: "entidad de paso",
  T_48_META_EVT_8_D: "Se activa al final de cada fase",
  T_48_META_EVT_8_P0_D: "entidad de paso",
  T_48_META_EVT_9_D: "Se dispara al final de la colisión de una entidad, sólo soportado por entidades que tienen un componente de Cuerpo Rígido montado sobre ellas.",
  T_48_META_EVT_9_P0_D: "Entidades encontradas",
  T_49_META_TYP_10_I1_D: "Lista de etiquetas",
  T_49_META_TYP_10_I2_D: "¿Está disponible?",
  T_49_META_TYP_10_I3_D: "¿Están disponibles todos los nodos principales?",
  T_49_META_TYP_10_I4_D: "¿Está disponible en la escena?",
  T_49_META_TYP_10_I5_D: "Si se habilita la actualización lógica. Al deshabilitarla, el script de la entidad dejará de actualizarse en cada fotograma.",
  T_49_META_TYP_10_I6_D: "Nombre de la entidad",
  T_49_META_TYP_10_I7_D: "Opción de filtro de área, 0 significa si el cálculo automático está controlado, 1 significa que no está controlado y siempre está sincronizado, 2 significa que está controlado",
  T_49_META_TYP_100_I0_D: "Establecer el rango de disparo",
  T_49_META_TYP_100_I1_D: "Visibilidad del Modelo",
  T_49_META_TYP_101_I0_D: "Jugador",
  T_49_META_TYP_101_I1_D: "ID del Ítem Objetivo",
  T_49_META_TYP_101_I2_D: "Rotación del Objetivo",
  T_49_META_TYP_101_I3_D: "Escala del Objetivo",
  T_49_META_TYP_1010_I1_D: "La duración del cronometraje, en segundos.",
  T_49_META_TYP_1010_I2_D: "La hora de inicio de la cuenta regresiva, en segundos del juego.",
  T_49_META_TYP_1010_I3_D: "El tipo de actualización de la temporización, consulte `EUITimeUpdateType`, opcional: estático, temporización, cuenta regresiva",
  T_49_META_TYP_1010_I4_D: "Posición de visualización, cuando hay un objetivo a seguir, es el desplazamiento relativo al origen del objetivo, cuando no hay ningún objetivo a seguir, es la coordenada de la pantalla",
  T_49_META_TYP_1011_I10_D: "Nombre del Icono de Progreso",
  T_49_META_TYP_1011_I2_D: "Color del Tema",
  T_49_META_TYP_1011_I3_D: "Si habilitar o no la visualización localizada",
  T_49_META_TYP_1011_I4_D: "Título",
  T_49_META_TYP_1011_I5_D: "Descripción",
  T_49_META_TYP_1011_I6_D: "Nombre del recurso del icono",
  T_49_META_TYP_1011_I7_D: "Progreso Máximo",
  T_49_META_TYP_1011_I8_D: "Progreso Actual",
  T_49_META_TYP_1011_I9_D: "Icono de Progreso",
  T_49_META_TYP_1012_I1_D: "Si habilitar o no la localización",
  T_49_META_TYP_1012_I2_D: "Texto de número redondo",
  T_49_META_TYP_1012_I3_D: "Parámetros de Clave de Ronda",
  T_49_META_TYP_1012_I5_D: "Color Izquierda",
  T_49_META_TYP_1012_I6_D: "Color Derecha",
  T_49_META_TYP_1013_I2_D: "Texto de número redondo",
  T_49_META_TYP_1013_I3_D: "Parámetros de Clave de Ronda",
  T_49_META_TYP_1014_I2_D: "Texto del título de la primera partitura",
  T_49_META_TYP_1014_I3_D: "El primer valor de puntuación",
  T_49_META_TYP_1014_I4_D: "Parámetros del Primer Puntaje",
  T_49_META_TYP_1014_I5_D: "Texto del título de la segunda partitura",
  T_49_META_TYP_1014_I6_D: "El segundo valor de puntuación",
  T_49_META_TYP_1014_I7_D: "Parámetros del Segundo Puntaje",
  T_49_META_TYP_1016_I1_D: "Muestra el estado correspondiente según el valor, victoria (1), derrota (2), empate (3), booyah (4)",
  T_49_META_TYP_1016_I2_D: "Mostrar las puntuaciones de 2 equipos. Si es verdadero, se mostrará; de lo contrario, se ocultará.",
  T_49_META_TYP_1016_I3_D: "Puntaje del Equipo Izquierdo",
  T_49_META_TYP_1016_I4_D: "Puntaje del Equipo Derecho",
  T_49_META_TYP_1016_I5_D: "Marca de tiempo de finalización de fase",
  T_49_META_TYP_1017_I1_D: "Nombre del Equipo Izquierdo",
  T_49_META_TYP_1017_I2_D: "Descripción del Equipo Izquierdo",
  T_49_META_TYP_1017_I3_D: "Nombre del Equipo Derecho",
  T_49_META_TYP_1017_I4_D: "Descripción del Equipo Derecho",
  T_49_META_TYP_1018_I1_D: "Número de Ronda",
  T_49_META_TYP_1018_I4_D: "Puntuación del equipo izquierdo",
  T_49_META_TYP_1018_I6_D: "Puntuación del equipo correcto",
  T_49_META_TYP_1019_I1_D: "Ganar, perder y empatar corresponden a 1 2 3 respectivamente",
  T_49_META_TYP_102_I0_D: "Tipo de fuente de resurrección, jugador resucitado de la muerte",
  T_49_META_TYP_102_I1_D: "Tipo de fuente de resurrección, el jugador resucita de un estado derribado.",
  T_49_META_TYP_1020_I2_D: "La clave de texto que se mostrará",
  T_49_META_TYP_1020_I3_D: "Matriz de parámetros correspondiente a la clave de texto",
  T_49_META_TYP_1021_I1_D: "Tiempo base en segundos",
  T_49_META_TYP_1021_I2_D: "Duración en segundos",
  T_49_META_TYP_1021_I3_D: "Posición de visualización. Cuando hay un objetivo a seguir, se muestra el desplazamiento con respecto al origen del objetivo. Si no hay ningún objetivo a seguir, se muestra la coordenada de la pantalla. El valor predeterminado es Vector3(0).",
  T_49_META_TYP_1022_I2_D: "La clave de texto que se mostrará",
  T_49_META_TYP_1022_I3_D: "Matriz de parámetros correspondiente a la clave de texto",
  T_49_META_TYP_1023_I1_D: "Se muestra la puntuación del equipo cuando es verdadero, de lo contrario está cerrado",
  T_49_META_TYP_1023_I4_D: "Mostrar cuando el estado del jugador es verdadero, de lo contrario cerrar",
  T_49_META_TYP_1023_I5_D: "La matriz de estado del jugador izquierdo, 0: número de jugadores vivos, 1: número de jugadores muertos, 2: número de jugadores caídos",
  T_49_META_TYP_1023_I6_D: "La matriz de estado del jugador correcto, 0: número de jugadores vivos, 1: número de jugadores muertos, 2: número de jugadores caídos",
  T_49_META_TYP_1023_I7_D: "Número de Banderas del Compañero de Equipo Izquierdo",
  T_49_META_TYP_1023_I8_D: "Cantidad de Banderas del Compañero Derecho",
  T_49_META_TYP_1024_I2_D: "Compensar",
  T_49_META_TYP_1024_I3_D: "Rango",
  T_49_META_TYP_1024_I4_D: "Color del Equipo",
  T_49_META_TYP_1024_I5_D: "Nombre del Icono",
  T_49_META_TYP_1024_I6_D: "Si el borde es verdadero, se mostrará, de lo contrario, se cerrará.",
  T_49_META_TYP_1024_I7_D: "Clave de Texto de Puntaje",
  T_49_META_TYP_1024_I8_D: "Parámetros del Texto de Puntaje",
  T_49_META_TYP_1028_I1_D: "Número de Jugadores Vivos Izquierdos",
  T_49_META_TYP_1028_I2_D: "Número de Jugadores Vivos Derechos",
  T_49_META_TYP_1028_I3_D: "Color de Fondo Izquierdo",
  T_49_META_TYP_1028_I4_D: "Color de Fondo Derecho",
  T_49_META_TYP_1028_I5_D: "Nombre del Icono Izquierdo",
  T_49_META_TYP_1028_I6_D: "Nombre del Icono Derecho",
  T_49_META_TYP_1029_I1_D: "Nombre del Icono",
  T_49_META_TYP_1029_I2_D: "Nombre del Icono de Fondo",
  T_49_META_TYP_103_I0_D: "Arma principal A",
  T_49_META_TYP_103_I1_D: "Arma principal B",
  T_49_META_TYP_103_I10_D: "Bomba congelante",
  T_49_META_TYP_103_I11_D: "Muro de hielo",
  T_49_META_TYP_103_I12_D: "Mina Terrestre",
  T_49_META_TYP_103_I13_D: "Torreta automática",
  T_49_META_TYP_103_I14_D: "Granada ficticia",
  T_49_META_TYP_103_I16_D: "Patineta, camuflaje...",
  T_49_META_TYP_103_I2_D: "Arma secundaria",
  T_49_META_TYP_103_I3_D: "armas explosivas",
  T_49_META_TYP_103_I5_D: "Arma pesada",
  T_49_META_TYP_1030_I3_D: "Número de Jugadores Vivos Izquierdos",
  T_49_META_TYP_1030_I4_D: "Número de Jugadores Vivos Derechos",
  T_49_META_TYP_1030_I5_D: "Nombre del icono del equipo a la izquierda",
  T_49_META_TYP_1030_I6_D: "Nombre del icono del equipo a la derecha",
  T_49_META_TYP_1031_I2_D: "Descripción de la información del aviso",
  T_49_META_TYP_1031_I3_D: "Marca de tiempo de inicio de la cuenta regresiva en segundos",
  T_49_META_TYP_1031_I4_D: "Parámetros de Descripción",
  T_49_META_TYP_1032_I1_D: "Tipo de Consejos",
  T_49_META_TYP_1032_I3_D: "Parámetros",
  T_49_META_TYP_1033_I1_D: "Fase de cambio, 0 significa que la ronda actual está resuelta, 1 significa que comienza la siguiente ronda",
  T_49_META_TYP_1033_I10_D: "Texto de aviso de error, déjelo en blanco para el valor predeterminado",
  T_49_META_TYP_1033_I11_D: "Título de Ingreso por Ronda",
  T_49_META_TYP_1033_I12_D: "Ingreso por Ronda",
  T_49_META_TYP_1033_I13_D: "Títulos de detalles de ingresos por ronda",
  T_49_META_TYP_1033_I14_D: "La lista detallada de valores de ingresos redondos corresponde a la lista de títulos detallada anterior.",
  T_49_META_TYP_1033_I15_D: "Apodo del jugador MVP",
  T_49_META_TYP_1033_I16_D: "Índice de la Siguiente Ronda",
  T_49_META_TYP_1033_I17_D: "¿Es Punto de Partido?",
  T_49_META_TYP_1033_I18_D: "¿Es la Última Ronda?",
  T_49_META_TYP_1033_I6_D: "Nombre del icono del equipo a la izquierda",
  T_49_META_TYP_1033_I7_D: "Nombre del icono del equipo a la derecha",
  T_49_META_TYP_1033_I8_D: "Muestra el estado correspondiente según el valor, victoria (1), fracaso (2)",
  T_49_META_TYP_1033_I9_D: "Texto de solicitud de victoria, déjelo en blanco como predeterminado",
  T_49_META_TYP_1036_I1_D: "Indica cuántos niveles hay",
  T_49_META_TYP_1036_I2_D: "Indica el nivel actual de zombies",
  T_49_META_TYP_1037_I1_D: "Indica cuántos puntos se muestran",
  T_49_META_TYP_1039_I3_D: "Marca de tiempo de inicio de la cuenta regresiva en segundos",
  T_49_META_TYP_104_I0_D: "Estilo A",
  T_49_META_TYP_104_I1_D: "Estilo B",
  T_49_META_TYP_104_I2_D: "Estilo C",
  T_49_META_TYP_1040_I10_D: "Descripciones de Tarjetas",
  T_49_META_TYP_1040_I11_D: "El índice del elemento seleccionado, comenzando desde 0. Si es menor que 0, significa deselección.",
  T_49_META_TYP_1040_I12_D: "Nombres de Botones",
  T_49_META_TYP_1040_I13_D: "Colores de Botones",
  T_49_META_TYP_1040_I2_D: "Clave de Cuenta Regresiva",
  T_49_META_TYP_1040_I3_D: "Tiempo de Cuenta Regresiva",
  T_49_META_TYP_1040_I4_D: "Clave de Descripción",
  T_49_META_TYP_1040_I5_D: "Matriz de parámetros de información de descripción",
  T_49_META_TYP_1040_I6_D: "Fondos de Tarjetas",
  T_49_META_TYP_1040_I7_D: "Colores de Fondo de Tarjetas",
  T_49_META_TYP_1040_I8_D: "Iconos de Tarjetas",
  T_49_META_TYP_1040_I9_D: "Nombres de Tarjetas",
  T_49_META_TYP_1041_I2_D: "Posición",
  T_49_META_TYP_1041_I3_D: "Imagen de icono",
  T_49_META_TYP_1041_I4_D: "Etiqueta",
  T_49_META_TYP_1041_I5_D: "Color de Fondo",
  T_49_META_TYP_1042_I1_D: "Posición Local",
  T_49_META_TYP_1043_I4_D: "Color de Texto",
  T_49_META_TYP_1043_I5_D: "Clave de Etiqueta",
  T_49_META_TYP_1043_I6_D: "Parámetros de Etiqueta",
  T_49_META_TYP_1045_I2_D: "Icono de botón",
  T_49_META_TYP_1045_I3_D: "Color del Icono",
  T_49_META_TYP_1045_I4_D: "El tamaño, el ancho y la altura son iguales.",
  T_49_META_TYP_1045_I5_D: "Posición relativa al punto de anclaje inferior derecho",
  T_49_META_TYP_1045_I6_D: "Cantidad de cargo, oculta si es menor a 0",
  T_49_META_TYP_1045_I7_D: "Hora de inicio del CD, en milisegundos",
  T_49_META_TYP_1045_I8_D: "Duración del CD en milisegundos",
  T_49_META_TYP_1045_I9_D: "Si es Verdadero, el botón aparecerá en gris, y si es Falso, se restaurará.",
  T_49_META_TYP_106_I1_D: "Habilitar",
  T_49_META_TYP_106_I2_D: "Deshabilitar",
  T_49_META_TYP_109_I0_D: "ID del Canal de Chat",
  T_49_META_TYP_109_I1_D: "Lista de Jugadores",
  T_49_META_TYP_11_I0_D: "¿El juego actual es ilegal? Si lo es, significa que ha perdido su valor para la confrontación. Se recomienda terminar el juego directamente.",
  T_49_META_TYP_11_I1_D: "La duración del juego actual, en milisegundos.",
  T_49_META_TYP_11_I10_D: "Si reiniciar el equipo en cada ronda",
  T_49_META_TYP_11_I11_D: "Si habilitar o no el mecanismo del círculo de veneno",
  T_49_META_TYP_11_I12_D: "Tamaño de la zona segura",
  T_49_META_TYP_11_I13_D: "Tiempo de inicio de la reducción",
  T_49_META_TYP_11_I14_D: "Duración de la reducción",
  T_49_META_TYP_11_I15_D: "Daño fuera de la zona",
  T_49_META_TYP_11_I18_D: "Tipo de resurrección",
  T_49_META_TYP_11_I2_D: "El índice de ronda actual, a través del cual se puede obtener la entidad de ronda actual",
  T_49_META_TYP_11_I27_D: "Conteo total de rondas",
  T_49_META_TYP_11_I3_D: "El índice de la etapa actual, a través del cual se puede obtener la entidad de la etapa actual",
  T_49_META_TYP_11_I32_D: "La cantidad de monedas de oro obtenidas al inicio de la ronda.",
  T_49_META_TYP_11_I33_D: "Cantidad de monedas de oro obtenidas al matar",
  T_49_META_TYP_11_I34_D: "Cantidad de monedas de oro obtenidas al ganar",
  T_49_META_TYP_11_I35_D: "Si se debe mostrar la interfaz de usuario de la billetera",
  T_49_META_TYP_11_I36_D: "Entidad Skybox",
  T_49_META_TYP_11_I37_D: "Cuadros de carrera acumulados desde que comenzó el juego",
  T_49_META_TYP_11_I38_D: "Se puede mover",
  T_49_META_TYP_11_I39_D: "Si se debe personalizar la liquidación",
  T_49_META_TYP_11_I4_D: "ID de plantilla del modo UGC preestablecido",
  T_49_META_TYP_11_I40_D: "¿Esta permitido unirse a mitad de camino?",
  T_49_META_TYP_11_I41_D: "Activa el modo de baja velocidad de cuadros, el juego se ejecutará a 15 FPS, de lo contrario, a 30 FPS.",
  T_49_META_TYP_11_I42_D: "El intervalo entre dos actualizaciones de marco lógico del servidor de juego",
  T_49_META_TYP_11_I43_D: "Intervalo de actualización de cuadro fijo en milisegundos",
  T_49_META_TYP_11_I5_D: "Si está desactivado, las resurrecciones de jugadores estarán deshabilitadas.",
  T_49_META_TYP_11_I6_D: "Si está cerrado, la resurrección del bot está deshabilitada",
  T_49_META_TYP_11_I7_D: "Tiempo de resurrección, en segundos",
  T_49_META_TYP_11_I8_D: "Número total de equipos en el juego",
  T_49_META_TYP_11_I9_D: "Número de miembros por equipo",
  T_49_META_TYP_110_I0_D: "Canal A",
  T_49_META_TYP_110_I1_D: "Canal B",
  T_49_META_TYP_110_I2_D: "Canal C",
  T_49_META_TYP_110_I3_D: "Canal D",
  T_49_META_TYP_110_I4_D: "Canal E",
  T_49_META_TYP_110_I5_D: "Canal F",
  T_49_META_TYP_111_I1_D: "Sprint",
  T_49_META_TYP_111_I2_D: "Atacar",
  T_49_META_TYP_111_I3_D: "Saltar",
  T_49_META_TYP_111_I4_D: "Trepar",
  T_49_META_TYP_111_I5_D: "Conducir",
  T_49_META_TYP_111_I6_D: "Entrar al vehículo",
  T_49_META_TYP_111_I7_D: "Salir del vehículo",
  T_49_META_TYP_111_I8_D: "Conducir vehículo",
  T_49_META_TYP_112_I0_D: "Habilitar",
  T_49_META_TYP_112_I1_D: "Deshabilitar",
  T_49_META_TYP_112_I2_D: "Invisible",
  T_49_META_TYP_117_I0_D: "Aplausos",
  T_49_META_TYP_117_I1_D: "Hi-hat",
  T_49_META_TYP_117_I2_D: "Bombo",
  T_49_META_TYP_117_I3_D: "Hi-hat abierto",
  T_49_META_TYP_117_I4_D: "Ride",
  T_49_META_TYP_117_I5_D: "Tarola",
  T_49_META_TYP_118_I0_D: "Si todos los miembros del campamento están muertos",
  T_49_META_TYP_118_I1_D: "Lista de todos los jugadores",
  T_49_META_TYP_118_I2_D: "Facciones Aliadas",
  T_49_META_TYP_118_I3_D: "Facciones atacables",
  T_49_META_TYP_118_I4_D: "Si se debe mostrar el nombre de la interfaz de usuario",
  T_49_META_TYP_118_I5_D: "Si se debe mostrar información del mapa",
  T_49_META_TYP_118_I6_D: "Si desea mostrar",
  T_49_META_TYP_118_I7_D: "Si desea mostrar",
  T_49_META_TYP_118_I8_D: "Todos los Miembros",
  T_49_META_TYP_118_I9_D: "Mostrar Mensaje Rápido",
  T_49_META_TYP_119_I0_D: "Sí",
  T_49_META_TYP_119_I1_D: "No",
  T_49_META_TYP_120_I1_D: "La entidad objetivo a seguir, el valor predeterminado está vacío",
  T_49_META_TYP_120_I2_D: "Color de la interfaz de usuario",
  T_49_META_TYP_120_I3_D: "Longitud de la interfaz de usuario",
  T_49_META_TYP_120_I4_D: "Valor de progreso actual, de 0 a 1,0",
  T_49_META_TYP_120_I5_D: "Posición de visualización. Cuando hay un objetivo a seguir, se muestra el desplazamiento con respecto al origen del objetivo. Si no hay ningún objetivo a seguir, se muestra la coordenada de la pantalla. El valor predeterminado es Vector3(0).",
  T_49_META_TYP_121_I0_D: "3 segundos",
  T_49_META_TYP_121_I1_D: "5 segundos",
  T_49_META_TYP_121_I2_D: "10 segundos",
  T_49_META_TYP_121_I3_D: "15 segundos",
  T_49_META_TYP_121_I4_D: "30 segundos",
  T_49_META_TYP_121_I5_D: "9999 segundos",
  T_49_META_TYP_122_I0_D: "Recurso de Cielo",
  T_49_META_TYP_122_I1_D: "Color de la luz",
  T_49_META_TYP_122_I10_D: "El GUID de la subescena",
  T_49_META_TYP_122_I11_D: "Interruptor de efecto de niebla",
  T_49_META_TYP_122_I12_D: "Modo de efecto de niebla",
  T_49_META_TYP_122_I13_D: "Densidad de niebla exponencial",
  T_49_META_TYP_122_I14_D: "La distancia inicial de la niebla lineal",
  T_49_META_TYP_122_I15_D: "Distancia final de la niebla lineal",
  T_49_META_TYP_122_I16_D: "Habilitar la función de efecto niebla",
  T_49_META_TYP_122_I17_D: "Ángulo de rotación de la fuente de luz principal",
  T_49_META_TYP_122_I18_D: "Habilitar la función de ángulo de rotación de la fuente de luz principal",
  T_49_META_TYP_122_I2_D: "Intensidad de la luz",
  T_49_META_TYP_122_I3_D: "Oscuridad",
  T_49_META_TYP_122_I4_D: "Fuerza de la sombra",
  T_49_META_TYP_122_I5_D: "Humedad del terreno",
  T_49_META_TYP_122_I6_D: "Destello de lente",
  T_49_META_TYP_122_I7_D: "Color de la niebla",
  T_49_META_TYP_122_I8_D: "Color del ambiente",
  T_49_META_TYP_123_I0_D: "Día",
  T_49_META_TYP_123_I1_D: "Noche",
  T_49_META_TYP_123_I2_D: "Ocaso",
  T_49_META_TYP_123_I3_D: "Vista de la ciudad",
  T_49_META_TYP_123_I4_D: "Cielo colorido",
  T_49_META_TYP_123_I5_D: "Luna congelada",
  T_49_META_TYP_124_I0_D: "Corto alcance",
  T_49_META_TYP_124_I1_D: "Media distancia",
  T_49_META_TYP_124_I2_D: "Larga distancia",
  T_49_META_TYP_125_I0_D: "Difuminar color",
  T_49_META_TYP_125_I2_D: "Difuminar textura",
  T_49_META_TYP_125_I4_D: "Difuminar alfa",
  T_49_META_TYP_126_I1_D: "Nombre",
  T_49_META_TYP_126_I2_D: "Valor de progreso actual",
  T_49_META_TYP_126_I3_D: "Valor máximo de progreso",
  T_49_META_TYP_126_I4_D: "Coordenadas de pantalla, el valor predeterminado es Vector3(0)",
  T_49_META_TYP_126_I5_D: "Longitud de la barra de progreso. El valor predeterminado actual es la longitud de la interfaz de usuario del prefabricado.",
  T_49_META_TYP_127_I0_D: "Traslación a lo largo de un eje determinado, se pueden combinar tres ejes",
  T_49_META_TYP_127_I1_D: "Girar a lo largo de un eje determinado, se pueden combinar tres ejes",
  T_49_META_TYP_127_I2_D: "Zoom a lo largo de un eje determinado, puedes combinar tres ejes",
  T_49_META_TYP_128_I0_D: "Arbustos",
  T_49_META_TYP_128_I1_D: "Calabaza",
  T_49_META_TYP_128_I2_D: "Espantapájaros",
  T_49_META_TYP_128_I3_D: "Armario",
  T_49_META_TYP_129_I0_D: "Botín aleatorio",
  T_49_META_TYP_129_I1_D: "Munición AR",
  T_49_META_TYP_129_I2_D: "Munición SMG",
  T_49_META_TYP_129_I3_D: "Munición SN",
  T_49_META_TYP_129_I4_D: "Munición HG",
  T_49_META_TYP_129_I5_D: "Bala SG",
  T_49_META_TYP_129_I6_D: "0",
  T_49_META_TYP_13_I1_D: "Coordenadas de anclaje relativas al nodo principal",
  T_49_META_TYP_13_I10_D: "Diferencia de tamaño entre el widget y el cuadro de anclaje",
  T_49_META_TYP_13_I11_D: "Punto de Referencia",
  T_49_META_TYP_13_I12_D: "profundidad",
  T_49_META_TYP_13_I14_D: "El orden de todos los nodos secundarios bajo el mismo nodo principal",
  T_49_META_TYP_13_I15_D: "ID del Padre",
  T_49_META_TYP_13_I16_D: "Identificación única",
  T_49_META_TYP_13_I17_D: "Prioridad",
  T_49_META_TYP_13_I18_D: "Posición Actual",
  T_49_META_TYP_13_I2_D: "Ancho",
  T_49_META_TYP_13_I4_D: "Ángulo de rotación del eje Z",
  T_49_META_TYP_13_I6_D: "El ID interno del control en el Prefab",
  T_49_META_TYP_13_I7_D: "Entidad de interfaz de usuario",
  T_49_META_TYP_13_I8_D: "Anclaje Mínimo",
  T_49_META_TYP_13_I9_D: "Anclaje Máximo",
  T_49_META_TYP_130_I0_D: "Botín de consumibles aleatorios",
  T_49_META_TYP_130_I1_D: "0",
  T_49_META_TYP_130_I2_D: "Kit de Reparación",
  T_49_META_TYP_130_I3_D: "Horizonte",
  T_49_META_TYP_130_I4_D: "Inhalador",
  T_49_META_TYP_131_I0_D: "Botín de armadura aleatorio",
  T_49_META_TYP_131_I1_D: "Armadura de nivel 1",
  T_49_META_TYP_131_I2_D: "Armadura de segundo nivel",
  T_49_META_TYP_131_I3_D: "Armadura de nivel 3",
  T_49_META_TYP_132_I0_D: "Botín de lanzamientos aleatorios",
  T_49_META_TYP_132_I1_D: "Granada",
  T_49_META_TYP_132_I4_D: "Congelamiento",
  T_49_META_TYP_133_I0_D: "Botín de alcance aleatorio",
  T_49_META_TYP_133_I1_D: "2x Visor",
  T_49_META_TYP_133_I2_D: "4x Visor",
  T_49_META_TYP_133_I3_D: "Alcance Térmico",
  T_49_META_TYP_134_I0_D: "Botín de Arma Aleatorio",
  T_49_META_TYP_134_I5_D: "Escopeta",
  T_49_META_TYP_134_I8_D: "Pistola de fútbol",
  T_49_META_TYP_135_I0_D: "Puntos de botín",
  T_49_META_TYP_136_I0_D: "Puntos de artículos consumibles de botín",
  T_49_META_TYP_137_I0_D: "Puntos de artículos consumibles de botín",
  T_49_META_TYP_138_I0_D: "Punto de zoom de botín",
  T_49_META_TYP_139_I0_D: "Puntos de armadura de botín",
  T_49_META_TYP_14_I0_D: "La salud actual del jugador",
  T_49_META_TYP_14_I1_D: "La salud máxima actual del jugador",
  T_49_META_TYP_14_I11_D: "Facción del jugador",
  T_49_META_TYP_14_I12_D: "El multiplicador de daño del jugador, como 2x, es 2.0",
  T_49_META_TYP_14_I13_D: "Utilice exactamente el mismo esqueleto que el personaje masculino o femenino. 0 significa no reemplazar el modelo",
  T_49_META_TYP_14_I14_D: "No entrará en conflicto con la escala de velocidad existente",
  T_49_META_TYP_14_I15_D: "No entrará en conflicto con la escala de altura de salto existente",
  T_49_META_TYP_14_I16_D: "Identidad, 0 Jugador normal, 1 Cazador, 2 Zombi madre, 3 Zombi normal, 4 Zombi evolucionado tipo 1, 5 Zombi evolucionado tipo 2, 6 Zombi evolucionado tipo 3",
  T_49_META_TYP_14_I17_D: "Nivel zombi, 1~3",
  T_49_META_TYP_14_I19_D: "Apodo del jugador",
  T_49_META_TYP_14_I2_D: "Determina si el jugador actual es un jugador de IA. La IA suele ser un PNJ o un monstruo JcE.",
  T_49_META_TYP_14_I20_D: "Al recibir daño, el porcentaje de daño se puede reducir o aumentar.",
  T_49_META_TYP_14_I21_D: "El EP actual del jugador",
  T_49_META_TYP_14_I22_D: "EP máximo del jugador",
  T_49_META_TYP_14_I23_D: "El arma principal que tenemos actualmente en la mano",
  T_49_META_TYP_14_I24_D: "Se pierde al eliminarse",
  T_49_META_TYP_14_I26_D: "Tipo de Tipo de Asistencia para Apuntar",
  T_49_META_TYP_14_I27_D: "Permitir bloqueo por ayuda de apuntado",
  T_49_META_TYP_14_I28_D: "Activar o desactivar el chat de voz: verdadero desactiva la voz, falso activa la voz",
  T_49_META_TYP_14_I29_D: "Activar o desactivar el chat rápido: verdadero desactiva la voz, falso activa la voz",
  T_49_META_TYP_14_I3_D: "Estado del jugador",
  T_49_META_TYP_14_I30_D: "Canal",
  T_49_META_TYP_14_I35_D: "Activar o desactivar la recogida de artículos: verdadero para deshabilitar la recogida, falso para habilitar la recogida",
  T_49_META_TYP_14_I36_D: "Activar o desactivar el descarte de elementos: verdadero para evitar que se descarten elementos, falso para permitir que se descarten elementos",
  T_49_META_TYP_14_I37_D: "Objetivos atacables",
  T_49_META_TYP_14_I38_D: "Jugadores amigables",
  T_49_META_TYP_14_I39_D: "Facción",
  T_49_META_TYP_14_I4_D: "Tiempo de supervivencia del jugador. Si el jugador muere, se recalcula el tiempo.",
  T_49_META_TYP_14_I40_D: "Número en facción",
  T_49_META_TYP_14_I41_D: "La cámara que está usando el jugador",
  T_49_META_TYP_14_I42_D: "Gravedad Personalizada",
  T_49_META_TYP_14_I43_D: "Casco",
  T_49_META_TYP_14_I44_D: "Chaleco",
  T_49_META_TYP_14_I5_D: "La invencibilidad del jugador",
  T_49_META_TYP_14_I52_D: "UID de usuario",
  T_49_META_TYP_14_I53_D: "Reducción de daño de cabeza",
  T_49_META_TYP_14_I54_D: "AVATAR ligado al jugador",
  T_49_META_TYP_14_I55_D: "Género",
  T_49_META_TYP_14_I56_D: "IDs de piel de arma",
  T_49_META_TYP_14_I57_D: "El punto de aparición del jugador",
  T_49_META_TYP_14_I58_D: "El punto de resurrección del jugador. Si no hay registro de punto de control, se usa el punto de nacimiento; de lo contrario, se usa el punto de control.",
  T_49_META_TYP_14_I59_D: "La posición actual del jugador",
  T_49_META_TYP_14_I6_D: "La entidad a la que pertenece el jugador",
  T_49_META_TYP_14_I60_D: "La dirección actual del jugador",
  T_49_META_TYP_14_I61_D: "Nodo utilizado para acceder a los huesos de la piel.",
  T_49_META_TYP_14_I62_D: "Mochila",
  T_49_META_TYP_14_I63_D: "Puntos de escudo temporal",
  T_49_META_TYP_14_I64_D: "ID de Skin del Vehículo",
  T_49_META_TYP_14_I65_D: "Omitir animación de caída",
  T_49_META_TYP_14_I66_D: "Desactivar daño por caída",
  T_49_META_TYP_14_I67_D: "Elemento en mano actual",
  T_49_META_TYP_14_I68_D: "Lista de artículos prohibidos",
  T_49_META_TYP_14_I69_D: "ID de recurso del jugador",
  T_49_META_TYP_14_I7_D: "El ID del punto de control actual",
  T_49_META_TYP_14_I70_D: "Objetivo al que enviar un mensaje de solicitud de compra",
  T_49_META_TYP_14_I71_D: "El ID del recurso Emote que se está reproduciendo actualmente",
  T_49_META_TYP_14_I72_D: "Si el gesto que se está reproduciendo actualmente se repite en bucle",
  T_49_META_TYP_14_I73_D: "Cómo lidiar con el estado de derribo",
  T_49_META_TYP_14_I74_D: "Si se debe habilitar el salto de daño, el valor predeterminado es Verdadero, lo que significa que está habilitado",
  T_49_META_TYP_14_I76_D: "¿Puedo dejarlo a mitad de camino?",
  T_49_META_TYP_14_I77_D: "La información del vestuario que el jugador debe conservar al transformarse en otro personaje",
  T_49_META_TYP_14_I8_D: "El ID del punto de control al que se dirige el objetivo",
  T_49_META_TYP_140_I0_D: "Ola 1",
  T_49_META_TYP_140_I1_D: "Ola 2",
  T_49_META_TYP_140_I2_D: "Ola 3",
  T_49_META_TYP_140_I3_D: "Continuo",
  T_49_META_TYP_141_I0_D: "Botín de fútbol aleatorio",
  T_49_META_TYP_141_I1_D: "Escudo de fútbol",
  T_49_META_TYP_141_I2_D: "Granada Congelante",
  T_49_META_TYP_142_I0_D: "Loot Soccer",
  T_49_META_TYP_143_I0_D: "Lead1C2",
  T_49_META_TYP_143_I1_D: "Lead1C2#",
  T_49_META_TYP_143_I10_D: "Lead1A2#",
  T_49_META_TYP_143_I11_D: "Lead1B2",
  T_49_META_TYP_143_I2_D: "Lead1D2",
  T_49_META_TYP_143_I3_D: "Lead1D2#",
  T_49_META_TYP_143_I4_D: "Lead1E2",
  T_49_META_TYP_143_I5_D: "Lead1F2",
  T_49_META_TYP_143_I6_D: "Lead1F2#",
  T_49_META_TYP_143_I7_D: "Lead1G2",
  T_49_META_TYP_143_I8_D: "Lead1G2#",
  T_49_META_TYP_143_I9_D: "Lead1A2",
  T_49_META_TYP_144_I0_D: "Lead2C2",
  T_49_META_TYP_144_I1_D: "Lead2C2#",
  T_49_META_TYP_144_I10_D: "Lead2A2#",
  T_49_META_TYP_144_I11_D: "Lead2B2",
  T_49_META_TYP_144_I2_D: "Lead2D2",
  T_49_META_TYP_144_I3_D: "Lead2D2#",
  T_49_META_TYP_144_I4_D: "Lead2E2",
  T_49_META_TYP_144_I5_D: "Lead2F2",
  T_49_META_TYP_144_I6_D: "Lead2F2#",
  T_49_META_TYP_144_I7_D: "Lead2G2",
  T_49_META_TYP_144_I8_D: "Lead2G2#",
  T_49_META_TYP_144_I9_D: "Lead2A2",
  T_49_META_TYP_145_I0_D: "Lead3C2",
  T_49_META_TYP_145_I1_D: "Lead3C2#",
  T_49_META_TYP_145_I10_D: "Lead3A2#",
  T_49_META_TYP_145_I11_D: "Lead3B2",
  T_49_META_TYP_145_I2_D: "Lead3D2",
  T_49_META_TYP_145_I3_D: "Lead3D2#",
  T_49_META_TYP_145_I4_D: "Lead3E2",
  T_49_META_TYP_145_I5_D: "Lead3F2",
  T_49_META_TYP_145_I6_D: "Lead3F2#",
  T_49_META_TYP_145_I7_D: "Lead3G2",
  T_49_META_TYP_145_I8_D: "Lead3G2#",
  T_49_META_TYP_145_I9_D: "Lead3A2",
  T_49_META_TYP_146_I0_D: "PianoC3",
  T_49_META_TYP_146_I1_D: "PianoC3#",
  T_49_META_TYP_146_I10_D: "PianoA3#",
  T_49_META_TYP_146_I11_D: "PianoB3",
  T_49_META_TYP_146_I12_D: "PianoC4",
  T_49_META_TYP_146_I13_D: "PianoC4#",
  T_49_META_TYP_146_I14_D: "PianoD4",
  T_49_META_TYP_146_I15_D: "PianoD4#",
  T_49_META_TYP_146_I16_D: "PianoE4",
  T_49_META_TYP_146_I17_D: "PianoF4",
  T_49_META_TYP_146_I18_D: "PianoF4#",
  T_49_META_TYP_146_I19_D: "PianoG4",
  T_49_META_TYP_146_I2_D: "PianoD3",
  T_49_META_TYP_146_I20_D: "PianoG4#",
  T_49_META_TYP_146_I21_D: "PianoA4",
  T_49_META_TYP_146_I22_D: "PianoA4#",
  T_49_META_TYP_146_I23_D: "PianoB4",
  T_49_META_TYP_146_I3_D: "PianoD3#",
  T_49_META_TYP_146_I4_D: "PianoE3",
  T_49_META_TYP_146_I5_D: "PianoF3",
  T_49_META_TYP_146_I6_D: "PianoF3#",
  T_49_META_TYP_146_I7_D: "PianoG3",
  T_49_META_TYP_146_I8_D: "PianoG3#",
  T_49_META_TYP_146_I9_D: "PianoA3",
  T_49_META_TYP_147_I0_D: "FF Classic (tiro)",
  T_49_META_TYP_147_I1_D: "Tercera persona",
  T_49_META_TYP_147_I2_D: "Primera persona (juego de disparos)",
  T_49_META_TYP_147_I3_D: "Vista superior",
  T_49_META_TYP_147_I4_D: "Desplazamiento horizontal",
  T_49_META_TYP_147_I5_D: "Cámara personalizada",
  T_49_META_TYP_147_I6_D: "Perseguir",
  T_49_META_TYP_147_I7_D: "Cámara de movimiento libre controlada por el jugador",
  T_49_META_TYP_147_I8_D: "Nueva cámara en primera persona",
  T_49_META_TYP_148_I0_D: "Proporciona una variedad de tipos de cámaras preestablecidas, así como tipos de cámaras personalizados.",
  T_49_META_TYP_148_I1_D: "El campo de visión es el ángulo de visión de la cámara.",
  T_49_META_TYP_148_I10_D: "Tipo de animación de cambio de cámara",
  T_49_META_TYP_148_I11_D: "Solo funciona cuando el cambio es suave. El tiempo de transición para cambiar a esta cámara se mide en milisegundos.",
  T_49_META_TYP_148_I12_D: "Cuando hay una obstrucción entre la cámara y el objeto que se está siguiendo, el modo de movimiento de la cámara",
  T_49_META_TYP_148_I13_D: "Cómo la cámara renderiza la imagen",
  T_49_META_TYP_148_I14_D: "Seguir el sistema de coordenadas de referencia de desplazamiento del objeto",
  T_49_META_TYP_148_I15_D: "Observe el sistema de coordenadas de referencia de desplazamiento del objeto",
  T_49_META_TYP_148_I16_D: "La máscara de capa de renderizado de la cámara puede filtrar los objetos renderizados de la cámara por nivel de visibilidad",
  T_49_META_TYP_148_I17_D: "Restricción de Ángulo de Visión",
  T_49_META_TYP_148_I2_D: "Generalmente se refiere al desplazamiento de la posición de la cámara con respecto a la posición de origen del jugador. El significado específico varía según el tipo de cámara.",
  T_49_META_TYP_148_I3_D: "Generalmente se refiere a la desviación del punto de enfoque de la cámara con respecto a la posición de origen del jugador. El significado específico varía según el tipo de cámara.",
  T_49_META_TYP_148_I4_D: "El ángulo de rotación vertical de la cámara.",
  T_49_META_TYP_148_I5_D: "El ángulo de rotación horizontal de la cámara.",
  T_49_META_TYP_148_I7_D: "El objetivo que sigue la cámara",
  T_49_META_TYP_148_I8_D: "Lo que está mirando la cámara",
  T_49_META_TYP_148_I9_D: "El jugador que actualmente usa la cámara",
  T_49_META_TYP_15_I0_D: "Si todos los miembros del equipo están actualmente muertos",
  T_49_META_TYP_15_I1_D: "Lista de todos los miembros del equipo",
  T_49_META_TYP_15_I3_D: "Lista de equipos enemigos",
  T_49_META_TYP_15_I4_D: "Lista de equipos amistosos",
  T_49_META_TYP_15_I5_D: "Equipo No.",
  T_49_META_TYP_150_I0_D: "Durabilidad",
  T_49_META_TYP_150_I1_D: "El radio de los hemisferios en ambos extremos de la cápsula.",
  T_49_META_TYP_150_I2_D: "Factor de Daño",
  T_49_META_TYP_152_I1_D: "Gravedad Personalizada",
  T_49_META_TYP_152_I2_D: "Si se debe mostrar el disparador, Verdadero significa mostrar",
  T_49_META_TYP_154_I0_D: "No se puede usar dos armas a la vez",
  T_49_META_TYP_154_I1_D: "Solo se puede usar con dos armas del mismo tipo.",
  T_49_META_TYP_154_I2_D: "Se puede usar con otra arma o contigo mismo.",
  T_49_META_TYP_155_I0_D: "calificación",
  T_49_META_TYP_155_I1_D: "Durabilidad Máxima",
  T_49_META_TYP_155_I2_D: "Durabilidad Actual",
  T_49_META_TYP_155_I3_D: "Factor de Reducción de Daño",
  T_49_META_TYP_155_I4_D: "Factor de Reducción de Daño por Explosión",
  T_49_META_TYP_155_I5_D: "Puede costar durabilidad",
  T_49_META_TYP_155_I6_D: "Puede ser destruido",
  T_49_META_TYP_156_I1_D: "Durabilidad Máxima",
  T_49_META_TYP_156_I2_D: "Durabilidad Actual",
  T_49_META_TYP_156_I3_D: "Factor de Reducción de Daño",
  T_49_META_TYP_156_I4_D: "Factor de Reducción de Daño por Explosión",
  T_49_META_TYP_156_I5_D: "Puede costar durabilidad",
  T_49_META_TYP_156_I6_D: "Puede ser destruido",
  T_49_META_TYP_157_I0_D: "Sin animación",
  T_49_META_TYP_157_I1_D: "Suave",
  T_49_META_TYP_158_I2_D: "Enumeración de tipo de anclaje de UI, el valor predeterminado es 9 (Centro)",
  T_49_META_TYP_158_I6_D: "Clave de Etiqueta",
  T_49_META_TYP_158_I7_D: "Parámetros de Etiqueta",
  T_49_META_TYP_158_I8_D: "Equipo Izquierdo",
  T_49_META_TYP_16_I1_D: "El ID del artículo correspondiente a la entidad",
  T_49_META_TYP_16_I2_D: "Solo se utiliza al cargar objetos estáticamente para determinar si NavMesh se genera estáticamente",
  T_49_META_TYP_16_I3_D: "Si se trata de un bloqueo dinámico de NavMesh",
  T_49_META_TYP_16_I4_D: "Carga asincrónica",
  T_49_META_TYP_160_I0_D: "Ladrillo A",
  T_49_META_TYP_160_I1_D: "Azulejo A",
  T_49_META_TYP_160_I10_D: "Arena A",
  T_49_META_TYP_160_I11_D: "Nieve A",
  T_49_META_TYP_160_I12_D: "Madera A",
  T_49_META_TYP_160_I13_D: "Tono A",
  T_49_META_TYP_160_I14_D: "Césped B",
  T_49_META_TYP_160_I15_D: "Ladrillo B",
  T_49_META_TYP_160_I16_D: "Ladrillo C",
  T_49_META_TYP_160_I17_D: "Borrar",
  T_49_META_TYP_160_I2_D: "Azulejo B",
  T_49_META_TYP_160_I3_D: "Azulejo C",
  T_49_META_TYP_160_I4_D: "Bambú A",
  T_49_META_TYP_160_I5_D: "Cemento A",
  T_49_META_TYP_160_I6_D: "Contenedor A",
  T_49_META_TYP_160_I7_D: "Césped A",
  T_49_META_TYP_160_I8_D: "Hielo A",
  T_49_META_TYP_160_I9_D: "Magma A",
  T_49_META_TYP_165_I0_D: "Si habilitar o no la colisión",
  T_49_META_TYP_165_I1_D: "Si actuar como desencadenante",
  T_49_META_TYP_165_I2_D: "Nivel físico, configure el nivel en el módulo físico, hasta 16",
  T_49_META_TYP_166_I0_D: "Emoticono 1",
  T_49_META_TYP_166_I1_D: "Emoticono 2",
  T_49_META_TYP_166_I2_D: "Emoticono 3",
  T_49_META_TYP_166_I3_D: "Emoticono 4",
  T_49_META_TYP_166_I4_D: "Emoticono 5",
  T_49_META_TYP_167_I0_D: "Tipo de textura VFX",
  T_49_META_TYP_170_I0_D: "¿Es visible? Si no lo es, el cliente deja de renderizar el objetivo.",
  T_49_META_TYP_170_I1_D: "Nivel visible, rango de valores [0,15], afecta la visibilidad en la cámara",
  T_49_META_TYP_171_I0_D: "Energía",
  T_49_META_TYP_172_I0_D: "Número de balas",
  T_49_META_TYP_173_I0_D: "Capacidad extra de la mochila",
  T_49_META_TYP_173_I1_D: "La configuración de la apariencia de los jugadores fuera del juego tiene prioridad",
  T_49_META_TYP_173_I2_D: "ID de diseño de mochila, configuración de diseño de mochila",
  T_49_META_TYP_174_I2_D: "Daño Máximo",
  T_49_META_TYP_174_I4_D: "Velocidad de Lanzamiento",
  T_49_META_TYP_174_I5_D: "Retardo de explosión, en segundos",
  T_49_META_TYP_174_I6_D: "Factor de daño propio",
  T_49_META_TYP_174_I7_D: "Factor de daño a compañeros de equipo",
  T_49_META_TYP_174_I8_D: "Factor de daño a vehículos",
  T_49_META_TYP_174_I9_D: "Piel",
  T_49_META_TYP_175_I0_D: "Radio del Área Congelada",
  T_49_META_TYP_175_I1_D: "Duración del área congelada, en segundos",
  T_49_META_TYP_176_I0_D: "El tipo principal de arma",
  T_49_META_TYP_176_I1_D: "Subtipo de Arma",
  T_49_META_TYP_177_I0_D: "Cuando hay una obstrucción entre la cámara y el objeto que se está siguiendo, la cámara no realiza ningún cambio.",
  T_49_META_TYP_177_I1_D: "Cuando hay una obstrucción entre la cámara y el objeto que se está siguiendo, la cámara se acercará al objeto que se está siguiendo.",
  T_49_META_TYP_177_I2_D: "Cuando hay un oclusor entre la cámara y el objeto a seguir, el oclusor se volverá semitransparente.",
  T_49_META_TYP_178_I0_D: "Cuando la cámara observa un objeto, los objetos que están más cerca aparecen más grandes y los objetos que están más lejos aparecen más pequeños.",
  T_49_META_TYP_178_I1_D: "Cuando la cámara observa un objeto, los objetos cercanos y lejanos tienen el mismo tamaño.",
  T_49_META_TYP_184_I0_D: "Especifique el UUID del recurso a renderizar.",
  T_49_META_TYP_185_I0_D: "Renderice la malla del modelo a utilizar",
  T_49_META_TYP_185_I1_D: "Lista de materiales a utilizar para renderizar",
  T_49_META_TYP_187_I0_D: "ID del objeto",
  T_49_META_TYP_190_I0_D: "Estado abierto",
  T_49_META_TYP_190_I1_D: "Resultados del juego",
  T_49_META_TYP_190_I10_D: "Lista de Puntos 1",
  T_49_META_TYP_190_I11_D: "Lista de Puntos 2",
  T_49_META_TYP_190_I12_D: "Lista de Puntos 3",
  T_49_META_TYP_190_I13_D: "MVP de la Victoria",
  T_49_META_TYP_190_I14_D: "MVP de la Derrota",
  T_49_META_TYP_190_I15_D: "Mostrar Detalle del Partido",
  T_49_META_TYP_190_I16_D: "Mostrar Evaluación del Mapa",
  T_49_META_TYP_190_I17_D: "Mostrar Regalos",
  T_49_META_TYP_190_I18_D: "Mostrar Reporte",
  T_49_META_TYP_190_I19_D: "Mostrar Repetición",
  T_49_META_TYP_190_I20_D: "Mostrar Compartir",
  T_49_META_TYP_190_I21_D: "Mostrar Regresar al Vestíbulo",
  T_49_META_TYP_190_I22_D: "Mostrar Me Gusta",
  T_49_META_TYP_190_I23_D: "Mostrar Agregar Amigo",
  T_49_META_TYP_190_I24_D: "Mostrar Economía Externa",
  T_49_META_TYP_190_I4_D: "Equipo Derecho",
  T_49_META_TYP_190_I5_D: "Títulos",
  T_49_META_TYP_190_I6_D: "Rango del Jugador",
  T_49_META_TYP_190_I9_D: "Títulos",
  T_49_META_TYP_191_I0_D: "Rango Central",
  T_49_META_TYP_191_I4_D: "Tiempo de destello central, en milisegundos",
  T_49_META_TYP_191_I5_D: "Tiempo de destello del borde, en milisegundos",
  T_49_META_TYP_191_I6_D: "Duración del Efecto",
  T_49_META_TYP_192_I3_D: "Duración del efecto especial, en segundos",
  T_49_META_TYP_193_I1_D: "Título del Partido Izquierda",
  T_49_META_TYP_193_I10_D: "Lista de Puntos 1",
  T_49_META_TYP_193_I11_D: "Lista de Puntos 2",
  T_49_META_TYP_193_I12_D: "Lista de Puntos 3",
  T_49_META_TYP_193_I13_D: "Lista de Puntos 4",
  T_49_META_TYP_193_I14_D: "Lista de Puntos 5",
  T_49_META_TYP_193_I15_D: "MVP de la Victoria",
  T_49_META_TYP_193_I16_D: "MVP de la Derrota",
  T_49_META_TYP_193_I17_D: "Mostrar Detalle del Partido",
  T_49_META_TYP_193_I18_D: "Mostrar Evaluación del Mapa",
  T_49_META_TYP_193_I19_D: "Mostrar Regalos",
  T_49_META_TYP_193_I2_D: "Título del Partido Derecha",
  T_49_META_TYP_193_I20_D: "Mostrar Reporte",
  T_49_META_TYP_193_I21_D: "Mostrar Repetición",
  T_49_META_TYP_193_I22_D: "Mostrar Compartir",
  T_49_META_TYP_193_I23_D: "Mostrar Regresar al Vestíbulo",
  T_49_META_TYP_193_I24_D: "Mostrar Me Gusta",
  T_49_META_TYP_193_I25_D: "Mostrar Agregar Amigo",
  T_49_META_TYP_193_I26_D: "Mostrar Economía Externa",
  T_49_META_TYP_193_I3_D: "Resultados del juego",
  T_49_META_TYP_193_I4_D: "Rango del Equipo",
  T_49_META_TYP_193_I5_D: "Rango del Jugador",
  T_49_META_TYP_193_I6_D: "Clasificación del equipo",
  T_49_META_TYP_193_I7_D: "Título Principal del Puntaje",
  T_49_META_TYP_193_I8_D: "Puntajes Principales",
  T_49_META_TYP_193_I9_D: "Títulos",
  T_49_META_TYP_194_I0_D: "El tiempo en segundos en que la mina hará efecto.",
  T_49_META_TYP_194_I1_D: "Radio de disparo",
  T_49_META_TYP_194_I2_D: "El tiempo necesario para activar una mina dentro de su alcance, en segundos.",
  T_49_META_TYP_194_I3_D: "Puede ser activado por uno mismo",
  T_49_META_TYP_194_I4_D: "Puede ser activado por el equipo",
  T_49_META_TYP_194_I5_D: "Puede ser activado por un vehículo",
  T_49_META_TYP_194_I6_D: "El tiempo de existencia de la mina, que explotará automáticamente al terminar. El tiempo comienza desde el momento en que se coloca la mina, en segundos.",
  T_49_META_TYP_194_I7_D: "Es atacable",
  T_49_META_TYP_194_I8_D: "Salud",
  T_49_META_TYP_195_I0_D: "Una vez",
  T_49_META_TYP_195_I2_D: "Reciprocante",
  T_49_META_TYP_197_I0_D: "¿Esta jugando?",
  T_49_META_TYP_197_I1_D: "Marcar un bit",
  T_49_META_TYP_197_I2_D: "Marcar para reproducir automáticamente al crear",
  T_49_META_TYP_198_I0_D: "El ID de propiedad correspondiente al archivo adjunto",
  T_49_META_TYP_199_I0_D: "EP máximo",
  T_49_META_TYP_199_I1_D: "Costo de Energía",
  T_49_META_TYP_199_I10_D: "Proporción de Daño por Caída",
  T_49_META_TYP_199_I11_D: "Energía Actual",
  T_49_META_TYP_199_I2_D: "Costo de Energía Ascendente",
  T_49_META_TYP_199_I3_D: "Costo de Energía Sprint",
  T_49_META_TYP_199_I4_D: "Costo de Energía Rush",
  T_49_META_TYP_199_I5_D: "Velocidad Horizontal Base",
  T_49_META_TYP_199_I6_D: "Velocidad Horizontal de Sprint",
  T_49_META_TYP_199_I7_D: "Velocidad Vertical Base",
  T_49_META_TYP_199_I8_D: "Velocidad vertical del sprint",
  T_49_META_TYP_199_I9_D: "Distancia de Rush",
  T_49_META_TYP_200_I0_D: "ID de región",
  T_49_META_TYP_200_I1_D: "Identificación del juego",
  T_49_META_TYP_201_I0_D: "Porcentaje de desaceleración: El porcentaje en el que se reduce la velocidad de los objetos acuáticos en aguas abiertas.",
  T_49_META_TYP_203_I0_D: "entidad de destino",
  T_49_META_TYP_203_I1_D: "ID de Propiedad",
  T_49_META_TYP_203_I10_D: "El momento en el que el servidor del juego comienza a funcionar",
  T_49_META_TYP_203_I11_D: "Valor Inicial",
  T_49_META_TYP_203_I12_D: "Valor Final",
  T_49_META_TYP_203_I13_D: "Porcentaje aprobado",
  T_49_META_TYP_203_I4_D: "Estilo de transición",
  T_49_META_TYP_203_I6_D: "Duración(es)",
  T_49_META_TYP_203_I7_D: "Invertir",
  T_49_META_TYP_203_I8_D: "Puntos de control",
  T_49_META_TYP_203_I9_D: "Forzar la sincronización del estado del servidor del juego",
  T_49_META_TYP_204_I0_D: "Altura Máxima del Salto",
  T_49_META_TYP_204_I1_D: "Porcentaje de daño por caída",
  T_49_META_TYP_204_I2_D: "Recuperación de Energía",
  T_49_META_TYP_204_I3_D: "Consumir energía",
  T_49_META_TYP_204_I4_D: "Energía Máxima",
  T_49_META_TYP_205_I0_D: "Altura Mínima de Vuelo",
  T_49_META_TYP_205_I1_D: "Altura Mínima de Final",
  T_49_META_TYP_205_I2_D: "Velocidad de Vuelo Horizontal",
  T_49_META_TYP_205_I3_D: "Velocidad de Vuelo Vertical",
  T_49_META_TYP_205_I4_D: "Velocidad de Caída",
  T_49_META_TYP_205_I5_D: "Velocidad de Giro",
  T_49_META_TYP_205_I6_D: "Altura Máxima de Vuelo",
  T_49_META_TYP_205_I7_D: "Velocidad de Caída Después de Altura Máxima",
  T_49_META_TYP_205_I8_D: "Aceleración de velocidad variable",
  T_49_META_TYP_206_I0_D: "Velocidad",
  T_49_META_TYP_206_I1_D: "Aceleración",
  T_49_META_TYP_206_I10_D: "A alta velocidad, el ángulo de dirección máximo",
  T_49_META_TYP_206_I11_D: "Tasa base de interpolación del ángulo de dirección de alta velocidad",
  T_49_META_TYP_206_I2_D: "Velocidad de Impulso",
  T_49_META_TYP_206_I3_D: "Duración del sprint en segundos",
  T_49_META_TYP_206_I4_D: "Tiempo de recuperación del sprint, en segundos",
  T_49_META_TYP_206_I6_D: "Salto de CD, en segundos",
  T_49_META_TYP_206_I7_D: "CD de sprint después de subirse a la patineta, unidad: segundos",
  T_49_META_TYP_206_I8_D: "Interruptor de CD para Subir al Boost",
  T_49_META_TYP_206_I9_D: "CD de deslizamiento en la patineta, en segundos",
  T_49_META_TYP_207_I1_D: "Índice de Inicio",
  T_49_META_TYP_207_I2_D: "Posición Final",
  T_49_META_TYP_207_I3_D: "Identificación de tirolesa",
  T_49_META_TYP_207_I4_D: "Identificación del grupo",
  T_49_META_TYP_207_I5_D: "¿Se acabó?",
  T_49_META_TYP_21_I0_D: "El nivel básico de UI",
  T_49_META_TYP_210_I1_D: "Velocidad Inicial",
  T_49_META_TYP_210_I2_D: "Aceleración",
  T_49_META_TYP_210_I3_D: "Desplazamiento Máximo",
  T_49_META_TYP_210_I4_D: "Posición Inicial en el Mundo",
  T_49_META_TYP_210_I5_D: "Sincronización forzada de la información de ubicación del servidor de juegos",
  T_49_META_TYP_211_I0_D: "Posición local",
  T_49_META_TYP_211_I1_D: "Posición mundial",
  T_49_META_TYP_212_I0_D: "Propio",
  T_49_META_TYP_212_I2_D: "Coordenadas de desplazamiento",
  T_49_META_TYP_213_I0_D: "Propio",
  T_49_META_TYP_213_I2_D: "Coordenadas de desplazamiento",
  T_49_META_TYP_215_I0_D: "Victoria",
  T_49_META_TYP_215_I1_D: "Derrota",
  T_49_META_TYP_215_I2_D: "¡Buuyah!",
  T_49_META_TYP_215_I3_D: "Empate",
  T_49_META_TYP_218_I0_D: "Intensidad",
  T_49_META_TYP_218_I1_D: "Rango",
  T_49_META_TYP_218_I2_D: "Color de la luz",
  T_49_META_TYP_22_I0_D: "Si el estado abierto es verdadero, se mostrará, de lo contrario, se cerrará.",
  T_49_META_TYP_22_I1_D: "ID de Prefabricado",
  T_49_META_TYP_22_I2_D: "ID de control máximo actual",
  T_49_META_TYP_22_I3_D: "El nivel básico de UI",
  T_49_META_TYP_22_I4_D: "Habilitar Vista del Jugador",
  T_49_META_TYP_22_I5_D: "Posición mundial",
  T_49_META_TYP_22_I6_D: "¿Esta en la escena?",
  T_49_META_TYP_22_I7_D: "Rotación en coordenadas mundiales",
  T_49_META_TYP_22_I8_D: "Escalado en coordenadas mundiales",
  T_49_META_TYP_221_I0_D: "Retraso en el cambio de marcha: cuanto mayor sea el valor, más lenta será la velocidad de cambio de marcha.",
  T_49_META_TYP_222_I0_D: "Retraso en el cambio de marcha: cuanto mayor sea el valor, más lenta será la velocidad de cambio de marcha.",
  T_49_META_TYP_225_I0_D: "Daño a la torreta",
  T_49_META_TYP_225_I1_D: "Intervalo de Daño (s)",
  T_49_META_TYP_225_I10_D: "Fuego dentro del ángulo",
  T_49_META_TYP_225_I11_D: "Tasa de reducción de daños",
  T_49_META_TYP_225_I12_D: "Penetración de Armadura",
  T_49_META_TYP_225_I2_D: "Precisión",
  T_49_META_TYP_225_I3_D: "Rango",
  T_49_META_TYP_225_I4_D: "Velocidad Angular",
  T_49_META_TYP_225_I5_D: "Ángulo Arriba",
  T_49_META_TYP_225_I6_D: "Ángulo Abajo",
  T_49_META_TYP_225_I7_D: "HP Máx.",
  T_49_META_TYP_225_I8_D: "Tiempo de Vida (s)",
  T_49_META_TYP_225_I9_D: "Cantidad Máx. de Torres",
  T_49_META_TYP_226_I0_D: "Estado actual de la torreta",
  T_49_META_TYP_226_I1_D: "Habilitar Ataque",
  T_49_META_TYP_227_I0_D: "Widget Simple",
  T_49_META_TYP_227_I1_D: "Widget de Imagen",
  T_49_META_TYP_227_I10_D: "Widget de Textura",
  T_49_META_TYP_227_I11_D: "Widget de Perfil",
  T_49_META_TYP_227_I12_D: "Widget de Alternar",
  T_49_META_TYP_227_I13_D: "Widget de Panel Táctil",
  T_49_META_TYP_227_I14_D: "Widget de Joystick",
  T_49_META_TYP_227_I15_D: "Widget social",
  T_49_META_TYP_227_I2_D: "Widget de Etiqueta",
  T_49_META_TYP_227_I3_D: "Widget de Botón",
  T_49_META_TYP_227_I4_D: "Widget de Etiqueta de Entrada",
  T_49_META_TYP_227_I5_D: "Panel",
  T_49_META_TYP_227_I6_D: "Panel de Desplazamiento",
  T_49_META_TYP_227_I7_D: "Cuadrícula",
  T_49_META_TYP_227_I8_D: "Widget de Diseño",
  T_49_META_TYP_227_I9_D: "Widget de Contenedor",
  T_49_META_TYP_231_I0_D: "Recuperación de Durabilidad",
  T_49_META_TYP_231_I1_D: "Intervalo de tiempo para que surta efecto, en segundos",
  T_49_META_TYP_233_I2_D: "La hora de finalización del cronometraje, en segundos.",
  T_49_META_TYP_233_I4_D: "Nombre del recurso del icono",
  T_49_META_TYP_234_I0_D: "Tiempo de activación, en segundos",
  T_49_META_TYP_234_I1_D: "Puede ser activado por uno mismo",
  T_49_META_TYP_234_I10_D: "Salud actual",
  T_49_META_TYP_234_I2_D: "Puede ser activado por el equipo",
  T_49_META_TYP_234_I3_D: "Puede ser activado por un vehículo",
  T_49_META_TYP_234_I4_D: "Duración, en segundos",
  T_49_META_TYP_234_I5_D: "Es atacable",
  T_49_META_TYP_234_I6_D: "Salud",
  T_49_META_TYP_235_I0_D: "Máxima salud",
  T_49_META_TYP_235_I2_D: "Cantidad máx.",
  T_49_META_TYP_237_I0_D: "Velocidad de lanzamiento",
  T_49_META_TYP_237_I1_D: "Velocidad de tracción del jugador",
  T_49_META_TYP_238_I0_D: "Color de Aerosol",
  T_49_META_TYP_239_I0_D: "Velocidad inicial",
  T_49_META_TYP_239_I1_D: "Aceleración (como la gravedad)",
  T_49_META_TYP_24_I0_D: "Pelea confusa",
  T_49_META_TYP_24_I1_D: "Arma",
  T_49_META_TYP_24_I10_D: "Daño de lanzamiento aéreo, daño suicida de monstruos",
  T_49_META_TYP_24_I11_D: "Daño por Incendio en la Explosión de Vehículo",
  T_49_META_TYP_24_I12_D: "Explosión de Barril de Aceite",
  T_49_META_TYP_24_I13_D: "Arma Tipo Misil",
  T_49_META_TYP_24_I14_D: "Monstruo",
  T_49_META_TYP_24_I15_D: "Zona de Daño",
  T_49_META_TYP_24_I17_D: "Habilidad del Personaje",
  T_49_META_TYP_24_I2_D: "Lanzar granada",
  T_49_META_TYP_24_I3_D: "Zona Segura",
  T_49_META_TYP_24_I4_D: "Vehículo",
  T_49_META_TYP_24_I5_D: "Caída",
  T_49_META_TYP_24_I6_D: "Zona de Muerte",
  T_49_META_TYP_24_I7_D: "Salir",
  T_49_META_TYP_24_I8_D: "Desconectar",
  T_49_META_TYP_24_I9_D: "Explosión de Vehículo",
  T_49_META_TYP_241_I0_D: "Velocidad de tracción",
  T_49_META_TYP_241_I1_D: "Velocidad de swing",
  T_49_META_TYP_241_I2_D: "Encienda el botón de tracción",
  T_49_META_TYP_241_I3_D: "Enciende el botón de swing",
  T_49_META_TYP_241_I4_D: "Ancla de movimiento",
  T_49_META_TYP_241_I5_D: "Aceleración de salida del balanceo",
  T_49_META_TYP_242_I2_D: "Efecto Izquierdo Activo",
  T_49_META_TYP_242_I3_D: "Efecto Derecho Activo",
  T_49_META_TYP_242_I4_D: "Línea Central Activa",
  T_49_META_TYP_242_I5_D: "Valor",
  T_49_META_TYP_242_I7_D: "Posición de la interfaz de usuario, solo son válidos los componentes XY",
  T_49_META_TYP_242_I8_D: "Posición de la línea media [0,1]",
  T_49_META_TYP_243_I0_D: "Ropa superior",
  T_49_META_TYP_243_I1_D: "Ropa inferior",
  T_49_META_TYP_243_I2_D: "Zapatos",
  T_49_META_TYP_243_I3_D: "Pintura facial",
  T_49_META_TYP_243_I4_D: "Tocado",
  T_49_META_TYP_243_I5_D: "Traje completo",
  T_49_META_TYP_243_I6_D: "Accesorio facial",
  T_49_META_TYP_244_I0_D: "El texto que se mostrará",
  T_49_META_TYP_244_I10_D: "Lista de jugadores que pueden ver esta entidad",
  T_49_META_TYP_244_I11_D: "Jerarquía de visualización",
  T_49_META_TYP_244_I2_D: "Seguir Objetivo",
  T_49_META_TYP_244_I3_D: "Cuando se ignora la profundidad, se puede mostrar a través de la pared, de lo contrario no se puede mostrar.",
  T_49_META_TYP_244_I4_D: "Siempre en el video",
  T_49_META_TYP_244_I5_D: "Cuando se establece como verdadero, la posición se mostrará en la pantalla cuando esté fuera de la pantalla.",
  T_49_META_TYP_244_I6_D: "Estilo de fuente",
  T_49_META_TYP_244_I7_D: "Tipo de fuente",
  T_49_META_TYP_244_I8_D: "Tamaño de fuente",
  T_49_META_TYP_245_I0_D: "Ruta del recurso del efecto",
  T_49_META_TYP_245_I11_D: "Jerarquía de visualización",
  T_49_META_TYP_245_I3_D: "Cuando se ignora la profundidad, se puede mostrar a través de la pared, de lo contrario no se puede mostrar.",
  T_49_META_TYP_245_I4_D: "Cuando se establece como verdadero, la posición se mostrará en la pantalla cuando esté fuera de la pantalla.",
  T_49_META_TYP_245_I5_D: "Siempre en el video",
  T_49_META_TYP_245_I6_D: "Tipo de renderizado",
  T_49_META_TYP_245_I7_D: "Ancho",
  T_49_META_TYP_246_I0_D: "Naranja",
  T_49_META_TYP_246_I1_D: "Púrpura",
  T_49_META_TYP_246_I2_D: "Rojo",
  T_49_META_TYP_246_I3_D: "Verde",
  T_49_META_TYP_246_I4_D: "Azul",
  T_49_META_TYP_247_I1_D: "Sprint",
  T_49_META_TYP_247_I14_D: "Emoticono",
  T_49_META_TYP_247_I15_D: "Chat rápido",
  T_49_META_TYP_247_I16_D: "Recogidas",
  T_49_META_TYP_247_I17_D: "Mostrar chat rápido",
  T_49_META_TYP_247_I18_D: "Salud (HP)",
  T_49_META_TYP_247_I19_D: "Energía (EP)",
  T_49_META_TYP_247_I2_D: "Atacar",
  T_49_META_TYP_247_I20_D: "Armadura",
  T_49_META_TYP_247_I21_D: "Recargar",
  T_49_META_TYP_247_I22_D: "Botón de cambio rápido de pistola",
  T_49_META_TYP_247_I23_D: "El botón de la bocina del vehículo se puede activar y desactivar",
  T_49_META_TYP_247_I24_D: "Botón de voz (micrófono) para encender/apagar",
  T_49_META_TYP_247_I25_D: "Activar o desactivar el botón de marca",
  T_49_META_TYP_247_I27_D: "El botón de señal de red se puede activar o desactivar",
  T_49_META_TYP_247_I28_D: "Habilidad activa",
  T_49_META_TYP_247_I29_D: "Retícula",
  T_49_META_TYP_247_I3_D: "Saltar",
  T_49_META_TYP_247_I30_D: "Habilidad pasiva",
  T_49_META_TYP_247_I4_D: "Consejos de asesinato",
  T_49_META_TYP_247_I5_D: "Ranura de armas",
  T_49_META_TYP_247_I6_D: "Mini mapa",
  T_49_META_TYP_247_I7_D: "Interfaz de usuario de mochila",
  T_49_META_TYP_247_I8_D: "Artículos médicos",
  T_49_META_TYP_247_I9_D: "Si es verdadero, se mostrará, de lo contrario, se cerrará.",
  T_49_META_TYP_249_I3_D: "armas explosivas",
  T_49_META_TYP_249_I5_D: "Arma pesada",
  T_49_META_TYP_249_I8_D: "Bomba congelante",
  T_49_META_TYP_249_I9_D: "Granada ficticia",
  T_49_META_TYP_25_I0_D: "El índice de la etapa actual, correspondiente al índice en el editor de procesos",
  T_49_META_TYP_25_I1_D: "La hora de inicio de la etapa actual, en ms",
  T_49_META_TYP_25_I2_D: "Hora de finalización de la etapa actual, en ms",
  T_49_META_TYP_25_I3_D: "La duración de la fase actual, en ms",
  T_49_META_TYP_250_I1_D: "Color de efecto especial, cuatro canales RGBA, rango de valor de canal único 0~255, almacenado en un Int32",
  T_49_META_TYP_250_I3_D: "Tipo de textura VFX",
  T_49_META_TYP_250_I4_D: "Difuminar alfa",
  T_49_META_TYP_2500_I1_D: "Es Punto de Aparición Predeterminado",
  T_49_META_TYP_2500_I3_D: "¿Ya hay un jugador nacido en esta zona de aparición?",
  T_49_META_TYP_2500_I4_D: "Las coordenadas del punto de nacimiento actualmente asignable",
  T_49_META_TYP_2502_I0_D: "Ya sea un detonante de muerte, o si no es un detonante de muerte, es un detonante de invencibilidad. (Este es un problema heredado de OB32, ¡divida la funcionalidad en el futuro!)",
  T_49_META_TYP_2502_I1_D: "Si se debe mostrar el borde del disparador, verdadero significa mostrar",
  T_49_META_TYP_2503_I0_D: "ID de Punto de Control",
  T_49_META_TYP_2503_I2_D: "Ubicación del punto de control",
  T_49_META_TYP_2507_I0_D: "¿A qué campamento pertenece la torre de defensa? Si es del mismo campamento que el jugador, no lo atacará.",
  T_49_META_TYP_2507_I1_D: "HP",
  T_49_META_TYP_2507_I10_D: "ID de Objeto",
  T_49_META_TYP_2507_I2_D: "HP Máximo",
  T_49_META_TYP_2507_I3_D: "Daño de ataque, el daño que un solo ataque puede causar al jugador.",
  T_49_META_TYP_2507_I4_D: "El intervalo entre dos ataques, en segundos.",
  T_49_META_TYP_2507_I5_D: "Se puede atacar el área con el centro como centro y un radio de cualquier tamaño.",
  T_49_META_TYP_2507_I6_D: "Tasa de reducción de daño, un decimal menor que 1. El daño final es el daño multiplicado por (1-tasa de reducción de daño)",
  T_49_META_TYP_2507_I7_D: "Objetivo de Ataque",
  T_49_META_TYP_2507_I8_D: "Ángulo",
  T_49_META_TYP_2507_I9_D: "Estado de Sentry Mini",
  T_49_META_TYP_2508_I0_D: "La cantidad de zombis que aparecerán en cada ola.",
  T_49_META_TYP_2508_I1_D: "¿Cuántas oleadas de zombies se generarán?",
  T_49_META_TYP_2508_I2_D: "Si se generará de forma continua, pero habrá un límite en la misma pantalla",
  T_49_META_TYP_2508_I3_D: "¿Qué onda se genera actualmente?",
  T_49_META_TYP_2508_I5_D: "¿Qué tipo de zombis aparecen en la ola actual?",
  T_49_META_TYP_2508_I6_D: "¿La IA dejará caer equipo u objetos cuando muera?",
  T_49_META_TYP_2508_I7_D: "Tiempo de Inicio de Aparición (s)",
  T_49_META_TYP_2508_I8_D: "El intervalo de tiempo entre la siguiente ola y la ola anterior",
  T_49_META_TYP_2509_I0_D: "La cantidad de unidades que se generarán en cada ola",
  T_49_META_TYP_2509_I1_D: "¿Cuántas oleadas de generadores de unidades se generarán en total?",
  T_49_META_TYP_2509_I2_D: "¿Qué onda se genera actualmente?",
  T_49_META_TYP_2509_I4_D: "¿Qué entidad se utilizará como plantilla para cada ola que se generará?",
  T_49_META_TYP_2509_I5_D: "Hora de aparición de la unidad",
  T_49_META_TYP_2509_I6_D: "Si se generará de forma continua, pero habrá un límite en la misma pantalla",
  T_49_META_TYP_2509_I7_D: "El intervalo de tiempo entre la siguiente ola y la ola anterior",
  T_49_META_TYP_2509_I8_D: "El prefabID de la plantilla",
  T_49_META_TYP_2510_I0_D: "Cantidad de Puntos de Aparición",
  T_49_META_TYP_252_I1_D: "Icono Izquierdo",
  T_49_META_TYP_252_I2_D: "Texto Izquierdo",
  T_49_META_TYP_252_I3_D: "Puntuación Izquierda",
  T_49_META_TYP_252_I5_D: "Icono Derecho",
  T_49_META_TYP_252_I6_D: "Texto Derecho",
  T_49_META_TYP_252_I7_D: "Puntuación Derecha",
  T_49_META_TYP_252_I8_D: "Progreso [0,1]",
  T_49_META_TYP_253_I0_D: "Seleccionar icono",
  T_49_META_TYP_253_I1_D: "Texto",
  T_49_META_TYP_253_I2_D: "Efecto Activo",
  T_49_META_TYP_253_I3_D: "Ubicación de la interfaz de usuario",
  T_49_META_TYP_254_I1_D: "Por ejemplo, 1,25 significa 1,25 veces la velocidad normal.",
  T_49_META_TYP_254_I2_D: "Color",
  T_49_META_TYP_256_I0_D: "Completamente quieto. El rendimiento más económico",
  T_49_META_TYP_256_I1_D: "Aplique la fuerza normalmente. El que más consume rendimiento",
  T_49_META_TYP_256_I2_D: "El movimiento se puede controlar mediante scripts y la masa puede considerarse infinita.",
  T_49_META_TYP_257_I0_D: "Los diferentes tipos de cuerpos rígidos tienen diferentes funciones.",
  T_49_META_TYP_257_I1_D: "Usar gravedad",
  T_49_META_TYP_257_I2_D: "Masa (kg), la masa efectiva mínima es 0,001 kg. Si es 0, significa masa infinita y no se moverá bajo fuerza.",
  T_49_META_TYP_257_I3_D: "Posición del centro de gravedad, sistema de coordenadas local",
  T_49_META_TYP_257_I4_D: "Velocidad lineal del movimiento del cuerpo rígido",
  T_49_META_TYP_257_I5_D: "Velocidad angular de un cuerpo rígido",
  T_49_META_TYP_257_I6_D: "Coeficiente de atenuación natural de la velocidad lineal. Cuanto mayor sea el coeficiente, más rápido decae la velocidad de movimiento.",
  T_49_META_TYP_257_I7_D: "Coeficiente de atenuación natural de la velocidad angular. Cuanto mayor sea el coeficiente, más rápido decae la velocidad de movimiento.",
  T_49_META_TYP_257_I8_D: "Las restricciones impuestas al cuerpo rígido son una colección de RigidbodyConstrainType",
  T_49_META_TYP_258_I0_D: "2017-10-10 13:38:10 ",
  T_49_META_TYP_258_I1_D: "13:45 ",
  T_49_META_TYP_258_I2_D: "10/10/2017 1:45 PM ",
  T_49_META_TYP_258_I3_D: "10/10/2017",
  T_49_META_TYP_259_I0_D: "Fondo",
  T_49_META_TYP_259_I1_D: "Texto",
  T_49_META_TYP_259_I2_D: "Ubicación de la interfaz de usuario",
  T_49_META_TYP_259_I4_D: "Color del Texto",
  T_49_META_TYP_260_I0_D: "Seleccionar icono",
  T_49_META_TYP_260_I1_D: "Color de la barra de progreso",
  T_49_META_TYP_260_I2_D: "Valor",
  T_49_META_TYP_260_I3_D: "Velocidad, m/s",
  T_49_META_TYP_260_I4_D: "Si se deben mostrar efectos especiales",
  T_49_META_TYP_260_I5_D: "Posición de la interfaz de usuario [0,1]",
  T_49_META_TYP_260_I6_D: "El progreso inicial de la habilidad, cuyo valor es [0, 1]. Una vez creada la interfaz de usuario, el progreso se sincronizará inmediatamente con el progreso actual.",
  T_49_META_TYP_260_I7_D: "Color del Efecto",
  T_49_META_TYP_260_I8_D: "Establecer el valor de escala del objeto",
  T_49_META_TYP_265_I1_D: "Si se debe realizar el relleno en segundo plano",
  T_49_META_TYP_265_I2_D: "Nombre de Fondo",
  T_49_META_TYP_265_I3_D: "Color de Fondo",
  T_49_META_TYP_265_I5_D: "BgAlpha",
  T_49_META_TYP_265_I6_D: "Tipo de corte",
  T_49_META_TYP_265_I7_D: "El tipo de máscara es el nombre de la imagen seleccionada al enmascarar",
  T_49_META_TYP_265_I8_D: "Unidad de suavizado de bordes",
  T_49_META_TYP_267_I0_D: "Punto de inicio del desplazamiento, el valor predeterminado es la esquina superior izquierda",
  T_49_META_TYP_267_I1_D: "Admite múltiples direcciones de desplazamiento",
  T_49_META_TYP_267_I10_D: "Barra Horizontal",
  T_49_META_TYP_267_I11_D: "Ubicación de la pantalla",
  T_49_META_TYP_267_I2_D: "Arrastre el componente en dirección XY",
  T_49_META_TYP_267_I3_D: "Admite múltiples efectos de arrastre",
  T_49_META_TYP_267_I4_D: "Factor de desplazamiento: cuanto mayor sea el valor, más rápido será el desplazamiento.",
  T_49_META_TYP_267_I5_D: "Factor de inercia, cuanto mayor sea el valor, mayor será la inercia al rodar.",
  T_49_META_TYP_267_I6_D: "Si el arrastre está limitado a la ventana gráfica, seleccionado de manera predeterminada",
  T_49_META_TYP_267_I7_D: "Cuando está marcada, el arrastre comenzará con una cámara lenta; si no está marcada, el arrastre comenzará a la velocidad del movimiento del mouse.",
  T_49_META_TYP_267_I8_D: "Cuando se ajuste a la ventana gráfica, salga del arrastre.",
  T_49_META_TYP_267_I9_D: "Barra Vertical",
  T_49_META_TYP_268_I0_D: "Predeterminado",
  T_49_META_TYP_268_I1_D: "Cerrar",
  T_49_META_TYP_268_I2_D: "Mostrar",
  T_49_META_TYP_269_I0_D: "Propietario",
  T_49_META_TYP_269_I1_D: "Identificación del conjunto",
  T_49_META_TYP_269_I2_D: "Identificación del tocado",
  T_49_META_TYP_269_I3_D: "Identificación facial",
  T_49_META_TYP_269_I4_D: "Identificación de maquillaje",
  T_49_META_TYP_269_I5_D: "Identificación de la parte superior del cuerpo",
  T_49_META_TYP_269_I6_D: "Identificación de la parte inferior del cuerpo",
  T_49_META_TYP_269_I7_D: "Identificación del calzado",
  T_49_META_TYP_272_I0_D: "Femenino",
  T_49_META_TYP_272_I1_D: "Masculino",
  T_49_META_TYP_273_I0_D: "Coordenadas mundiales correspondientes al centro del mapa pequeño",
  T_49_META_TYP_273_I1_D: "El tamaño del mapa pequeño, el ancho y la altura son iguales.",
  T_49_META_TYP_273_I2_D: "Si habilitar el modo de visualización del mapa de profundidad del minimapa",
  T_49_META_TYP_274_I1_D: "Escalada",
  T_49_META_TYP_274_I4_D: "Nivel de visualización de iconos",
  T_49_META_TYP_275_I0_D: "Escalado de huesos",
  T_49_META_TYP_275_I1_D: "Las coordenadas mundiales del nodo óseo.",
  T_49_META_TYP_276_I0_D: "cabeza",
  T_49_META_TYP_276_I1_D: "Brazo izquierdo",
  T_49_META_TYP_276_I2_D: "Mano izquierda",
  T_49_META_TYP_276_I3_D: "Brazo derecho",
  T_49_META_TYP_276_I4_D: "Mano derecha",
  T_49_META_TYP_276_I5_D: "Torso",
  T_49_META_TYP_276_I6_D: "Pierna izquierda",
  T_49_META_TYP_276_I7_D: "Pie izquierdo",
  T_49_META_TYP_276_I8_D: "Pierna derecha",
  T_49_META_TYP_276_I9_D: "Pie derecho",
  T_49_META_TYP_277_I1_D: "La distancia de detección del rayo de la cámara",
  T_49_META_TYP_277_I2_D: "Máscara de capa de colisión para la detección de rayos de la cámara",
  T_49_META_TYP_277_I3_D: "Desplazamiento de la posición del botón",
  T_49_META_TYP_277_I4_D: "Icono ID de recurso",
  T_49_META_TYP_277_I5_D: "Tamaño del área de clic",
  T_49_META_TYP_277_I6_D: "Si se debe mostrar el objeto en el punto de destino",
  T_49_META_TYP_277_I7_D: "Objeto de visualización del punto de destino",
  T_49_META_TYP_278_I0_D: "La entidad de destino para generar píxeles del mapa",
  T_49_META_TYP_28_I0_D: "¿Se puede reiniciar en cada ronda?",
  T_49_META_TYP_280_I0_D: "Radio de la esfera",
  T_49_META_TYP_281_I0_D: "El radio de los hemisferios en ambos extremos de la cápsula.",
  T_49_META_TYP_29_I0_D: "Esfera",
  T_49_META_TYP_29_I1_D: "Rayo de Luz",
  T_49_META_TYP_29_I10_D: "La columna de luz en la planta del pie ahora se utiliza para obtener retroalimentación al entrar en la línea de meta.",
  T_49_META_TYP_29_I11_D: "Congelación",
  T_49_META_TYP_29_I12_D: "Luz",
  T_49_META_TYP_29_I13_D: "Corriente Ascendente",
  T_49_META_TYP_29_I14_D: "Explosión de Gas",
  T_49_META_TYP_29_I15_D: "Oculto Asesinado",
  T_49_META_TYP_29_I16_D: "Racha",
  T_49_META_TYP_29_I17_D: "Muerte de Clon",
  T_49_META_TYP_29_I18_D: "Retroalimentación de Disparo",
  T_49_META_TYP_29_I19_D: "Muerte de Clon",
  T_49_META_TYP_29_I2_D: "Explosión",
  T_49_META_TYP_29_I20_D: "Clon",
  T_49_META_TYP_29_I21_D: "Portal",
  T_49_META_TYP_29_I22_D: "Humo de Granada de Destello",
  T_49_META_TYP_29_I23_D: "Bola de Fuego",
  T_49_META_TYP_29_I24_D: "Incendio en Bucle",
  T_49_META_TYP_29_I25_D: "Gas Tóxico",
  T_49_META_TYP_29_I26_D: "Corazón",
  T_49_META_TYP_29_I29_D: "Puerta",
  T_49_META_TYP_29_I30_D: "Fuegos Artificiales",
  T_49_META_TYP_29_I31_D: "Efecto de Zapatillas de Correr",
  T_49_META_TYP_29_I32_D: "Efecto de Explosión",
  T_49_META_TYP_29_I33_D: "Efecto de Punto de Aparición",
  T_49_META_TYP_29_I34_D: "Efecto de Láser",
  T_49_META_TYP_29_I35_D: "Efecto de Lanzamiento de Habilidad",
  T_49_META_TYP_29_I36_D: "Efecto de Bala",
  T_49_META_TYP_29_I37_D: "Efecto de Impacto de Bala",
  T_49_META_TYP_29_I38_D: "Efecto de Disparo",
  T_49_META_TYP_29_I39_D: "Efecto de Habilidad",
  T_49_META_TYP_29_I40_D: "Halo",
  T_49_META_TYP_29_I41_D: "burbuja",
  T_49_META_TYP_29_I42_D: "Humo y Polvo",
  T_49_META_TYP_29_I43_D: "Escombros Voladores",
  T_49_META_TYP_29_I44_D: "línea",
  T_49_META_TYP_29_I45_D: "Parpadeo",
  T_49_META_TYP_29_I47_D: "Partículas Ascendentes",
  T_49_META_TYP_29_I48_D: "Humo",
  T_49_META_TYP_29_I49_D: "Amuleto",
  T_49_META_TYP_29_I50_D: "Área Congelada",
  T_49_META_TYP_29_I51_D: "Niebla",
  T_49_META_TYP_29_I52_D: "Copo de Nieve",
  T_49_META_TYP_29_I53_D: "Fuego",
  T_49_META_TYP_29_I54_D: "Rayo de Luz",
  T_49_META_TYP_29_I55_D: "Difusión de Gas Tóxico",
  T_49_META_TYP_29_I56_D: "Gas Tóxico",
  T_49_META_TYP_29_I57_D: "Llamas de Explosión",
  T_49_META_TYP_29_I58_D: "Efecto de Luz",
  T_49_META_TYP_29_I59_D: "Estrella",
  T_49_META_TYP_29_I6_D: "Halo bajo tus pies",
  T_49_META_TYP_29_I60_D: "Fogata Ardiente",
  T_49_META_TYP_29_I61_D: "Salpicadura de Agua",
  T_49_META_TYP_29_I62_D: "Choque Eléctrico",
  T_49_META_TYP_29_I63_D: "Efecto de Tinta",
  T_49_META_TYP_29_I64_D: "Efecto de Agujero Negro",
  T_49_META_TYP_29_I65_D: "Efectos de Explosión de Agujero Negro",
  T_49_META_TYP_29_I66_D: "Efectos de Bola de Cristal",
  T_49_META_TYP_29_I67_D: "Efectos especiales de bala láser",
  T_49_META_TYP_29_I68_D: "Efecto de arrastre",
  T_49_META_TYP_29_I69_D: "Efectos de las nubes",
  T_49_META_TYP_29_I7_D: "Marcador de Suelo",
  T_49_META_TYP_29_I8_D: "Humo",
  T_49_META_TYP_29_I9_D: "Explosión de Amuleto",
  T_49_META_TYP_290_I0_D: "Intervalo de actualización, cuanto mayor sea el número, más lenta será la actualización, en milisegundos",
  T_49_META_TYP_290_I1_D: "Si habilitar la depuración",
  T_49_META_TYP_291_I0_D: "NodoCondición",
  T_49_META_TYP_291_I1_D: "NodoAcción",
  T_49_META_TYP_293_I0_D: "ID de árbol de comportamiento",
  T_49_META_TYP_293_I1_D: "Objetivo Adjunto",
  T_49_META_TYP_294_I1_D: "Tipo de diseño",
  T_49_META_TYP_294_I10_D: "Tipo de Ordenación",
  T_49_META_TYP_294_I2_D: "Origen del Contenido",
  T_49_META_TYP_294_I3_D: "Dirección de la disposición",
  T_49_META_TYP_294_I4_D: "Ancho y alto de la cuadrícula de subelementos",
  T_49_META_TYP_294_I5_D: "Espacio de Celda",
  T_49_META_TYP_294_I6_D: "Restricción",
  T_49_META_TYP_294_I7_D: "Cantidad de Restricciones",
  T_49_META_TYP_294_I8_D: "Desplazamiento vertical",
  T_49_META_TYP_294_I9_D: "Desplazamiento horizontal",
  T_49_META_TYP_295_I2_D: "Velocidad de Reproducción",
  T_49_META_TYP_296_I1_D: "Duración del Clip",
  T_49_META_TYP_297_I0_D: "Objeto enlazado",
  T_49_META_TYP_297_I4_D: "ID del recurso",
  T_49_META_TYP_298_I0_D: "Predeterminado",
  T_49_META_TYP_298_I2_D: "Una vez",
  T_49_META_TYP_30_I0_D: "Cuadrado",
  T_49_META_TYP_30_I1_D: "Cuadrilátero",
  T_49_META_TYP_30_I10_D: "Flecha",
  T_49_META_TYP_30_I11_D: "Llamada",
  T_49_META_TYP_30_I12_D: "Piedra",
  T_49_META_TYP_30_I13_D: "Tijeras",
  T_49_META_TYP_30_I14_D: "Papel",
  T_49_META_TYP_30_I15_D: "Me Gusta",
  T_49_META_TYP_30_I16_D: "Correcto",
  T_49_META_TYP_30_I17_D: "Incorrecto",
  T_49_META_TYP_30_I18_D: "Más",
  T_49_META_TYP_30_I19_D: "iluminación",
  T_49_META_TYP_30_I2_D: "Trapecio Rectángulo",
  T_49_META_TYP_30_I20_D: "Corazón",
  T_49_META_TYP_30_I21_D: "estrella",
  T_49_META_TYP_30_I22_D: "Luna",
  T_49_META_TYP_30_I23_D: "Sol",
  T_49_META_TYP_30_I24_D: "Gafas",
  T_49_META_TYP_30_I25_D: "Llave",
  T_49_META_TYP_30_I26_D: "Trofeo",
  T_49_META_TYP_30_I27_D: "Bandera",
  T_49_META_TYP_30_I28_D: "Reloj de Arena",
  T_49_META_TYP_30_I29_D: "Carpeta",
  T_49_META_TYP_30_I3_D: "Trapecio",
  T_49_META_TYP_30_I30_D: "Carpeta Abierta",
  T_49_META_TYP_30_I31_D: "Casa",
  T_49_META_TYP_30_I32_D: "Descanso",
  T_49_META_TYP_30_I33_D: "Actualizar",
  T_49_META_TYP_30_I34_D: "Bucle",
  T_49_META_TYP_30_I35_D: "Lupa",
  T_49_META_TYP_30_I36_D: "Cubo de Basura",
  T_49_META_TYP_30_I37_D: "Regresar",
  T_49_META_TYP_30_I38_D: "Diamante",
  T_49_META_TYP_30_I39_D: "Anillo de Natación",
  T_49_META_TYP_30_I4_D: "Hexágono",
  T_49_META_TYP_30_I40_D: "Dinero",
  T_49_META_TYP_30_I41_D: "Cerradura",
  T_49_META_TYP_30_I42_D: "Configuración",
  T_49_META_TYP_30_I43_D: "Salir",
  T_49_META_TYP_30_I44_D: "Diálogo",
  T_49_META_TYP_30_I45_D: "Mira",
  T_49_META_TYP_30_I46_D: "pistola",
  T_49_META_TYP_30_I47_D: "Espada",
  T_49_META_TYP_30_I48_D: "Explosión",
  T_49_META_TYP_30_I49_D: "Apuntar",
  T_49_META_TYP_30_I5_D: "Redondo",
  T_49_META_TYP_30_I50_D: "Cruz",
  T_49_META_TYP_30_I51_D: "Defensa",
  T_49_META_TYP_30_I52_D: "Monstruo",
  T_49_META_TYP_30_I53_D: "Reciclar",
  T_49_META_TYP_30_I54_D: "Regalo",
  T_49_META_TYP_30_I55_D: "Ropa",
  T_49_META_TYP_30_I56_D: "Juego",
  T_49_META_TYP_30_I57_D: "Jugador",
  T_49_META_TYP_30_I58_D: "Tienda",
  T_49_META_TYP_30_I59_D: "salida",
  T_49_META_TYP_30_I6_D: "Triángulo",
  T_49_META_TYP_30_I60_D: "Advertencia",
  T_49_META_TYP_30_I61_D: "Texto",
  T_49_META_TYP_30_I62_D: "Objeto temporizador",
  T_49_META_TYP_30_I63_D: "Campana",
  T_49_META_TYP_30_I64_D: "Mascota",
  T_49_META_TYP_30_I65_D: "bomba",
  T_49_META_TYP_30_I66_D: "Reparar",
  T_49_META_TYP_30_I67_D: "Cara Sonriente",
  T_49_META_TYP_30_I68_D: "Altavoz",
  T_49_META_TYP_30_I7_D: "Signo de Exclamación",
  T_49_META_TYP_30_I70_D: "Corona",
  T_49_META_TYP_30_I71_D: "Batalla",
  T_49_META_TYP_30_I72_D: "Guilda",
  T_49_META_TYP_30_I73_D: "Latido",
  T_49_META_TYP_30_I74_D: "Música",
  T_49_META_TYP_30_I75_D: "Vehículo",
  T_49_META_TYP_30_I76_D: "Arma de Combate Cuerpo a Cuerpo",
  T_49_META_TYP_30_I77_D: "Pistola",
  T_49_META_TYP_30_I78_D: "Rifle",
  T_49_META_TYP_30_I79_D: "Rifle de Francotirador",
  T_49_META_TYP_30_I8_D: "Signo de Interrogación",
  T_49_META_TYP_30_I80_D: "Escopeta",
  T_49_META_TYP_30_I81_D: "SMG",
  T_49_META_TYP_30_I82_D: "Arma de Curación",
  T_49_META_TYP_30_I83_D: "Romper Armadura",
  T_49_META_TYP_30_I84_D: "Disparo en la Cabeza",
  T_49_META_TYP_30_I85_D: "Habilidad 1",
  T_49_META_TYP_30_I86_D: "Habilidad 2",
  T_49_META_TYP_30_I87_D: "Habilidad 3",
  T_49_META_TYP_30_I88_D: "Habilidad 4",
  T_49_META_TYP_30_I89_D: "Habilidad 5",
  T_49_META_TYP_30_I9_D: "Marca",
  T_49_META_TYP_30_I90_D: "Habilidad 6",
  T_49_META_TYP_30_I91_D: "Habilidad 7",
  T_49_META_TYP_30_I92_D: "Habilidad 8",
  T_49_META_TYP_30_I93_D: "Habilidad 9",
  T_49_META_TYP_30_I94_D: "Habilidad 10",
  T_49_META_TYP_300_I0_D: "ID del recurso",
  T_49_META_TYP_300_I2_D: "Rotación",
  T_49_META_TYP_300_I3_D: "Entidad Creada",
  T_49_META_TYP_301_I1_D: "Autoexplosión",
  T_49_META_TYP_301_I2_D: "Ataque por Embestida",
  T_49_META_TYP_301_I3_D: "Onda de Choque",
  T_49_META_TYP_301_I4_D: "Ataque de Viento",
  T_49_META_TYP_301_I5_D: "Ataque de Salto",
  T_49_META_TYP_301_I6_D: "Levantar Escudo",
  T_49_META_TYP_301_I7_D: "Escudo Roto",
  T_49_META_TYP_302_I5_D: "Bolsa",
  T_49_META_TYP_302_I7_D: "Patineta, camuflaje...",
  T_49_META_TYP_303_I0_D: "Añadir PV máx. del jugador",
  T_49_META_TYP_303_I1_D: "Restaura PV del jugador continuamente",
  T_49_META_TYP_305_I0_D: "Terminar",
  T_49_META_TYP_305_I1_D: "En curso",
  T_49_META_TYP_307_I0_D: "Exp por daño",
  T_49_META_TYP_307_I1_D: "Exp por milla recorrida",
  T_49_META_TYP_307_I2_D: "Exp por segundo",
  T_49_META_TYP_307_I3_D: "Experiencia por chip",
  T_49_META_TYP_307_I4_D: "Carga máxima",
  T_49_META_TYP_308_I0_D: "Fabricante de gel",
  T_49_META_TYP_31_I0_D: "Explosión de granada",
  T_49_META_TYP_31_I1_D: "Cañonazo",
  T_49_META_TYP_31_I10_D: "Efecto de sonido de golpe que causa daño",
  T_49_META_TYP_31_I11_D: "Efectos de sonido mejorados",
  T_49_META_TYP_31_I12_D: "Efecto de sonido de clic débil",
  T_49_META_TYP_31_I13_D: "Efecto de sonido del mecanismo al pisar el jugador.",
  T_49_META_TYP_31_I14_D: "Efecto de sonido de reparación de equipos",
  T_49_META_TYP_31_I15_D: "Efecto de sonido de reparación de equipos",
  T_49_META_TYP_31_I16_D: "Efectos de sonido defectuosos o faltantes",
  T_49_META_TYP_31_I17_D: "Efecto de sonido de recordatorio",
  T_49_META_TYP_31_I18_D: "Efecto de sonido de aterrizaje de fútbol",
  T_49_META_TYP_31_I19_D: "Efecto de sonido de alegría",
  T_49_META_TYP_31_I2_D: "Sonido de Cuenta Regresiva",
  T_49_META_TYP_31_I20_D: "Efecto de sonido de advertencia de bomba",
  T_49_META_TYP_31_I21_D: "Efecto de sonido de explosión de bomba",
  T_49_META_TYP_31_I22_D: "Efecto de sonido de aparición de cazador",
  T_49_META_TYP_31_I23_D: "Efecto de sonido bgm final",
  T_49_META_TYP_31_I24_D: "Efecto de sonido de actualización de la caja de suministros",
  T_49_META_TYP_31_I25_D: "Efectos de sonido del acelerador",
  T_49_META_TYP_31_I26_D: "Efecto de sonido de recordatorio de desaparición",
  T_49_META_TYP_31_I27_D: "Efectos visuales y efectos de sonido",
  T_49_META_TYP_31_I28_D: "Efectos de sonido de insectos nocturnos",
  T_49_META_TYP_31_I29_D: "Efecto de sonido de golpe sordo",
  T_49_META_TYP_31_I3_D: "Toque en la UI",
  T_49_META_TYP_31_I30_D: "Efectos de sonido responsivos",
  T_49_META_TYP_31_I31_D: "Descubre efectos de sonido sorprendentes",
  T_49_META_TYP_31_I32_D: "Efecto de sonido de pequeño fantasma tocando",
  T_49_META_TYP_31_I33_D: "Efecto de sonido de inicio de fase",
  T_49_META_TYP_31_I34_D: "Efectos de sonido de zombis",
  T_49_META_TYP_31_I35_D: "Efectos de sonido de terror",
  T_49_META_TYP_31_I36_D: "Efectos de sonido de transformación",
  T_49_META_TYP_31_I37_D: "Efecto de sonido de latidos cardíacos rápidos",
  T_49_META_TYP_31_I38_D: "Efecto de sonido de latido del corazón a velocidad media",
  T_49_META_TYP_31_I39_D: "Efecto de sonido de latidos cardíacos lentos",
  T_49_META_TYP_31_I4_D: "Grito de Mujer al Recibir Daño",
  T_49_META_TYP_31_I40_D: "Efectos de sonido de rabia",
  T_49_META_TYP_31_I41_D: "Efecto de sonido de clic",
  T_49_META_TYP_31_I42_D: "Efecto de sonido de recuperación de habilidad",
  T_49_META_TYP_31_I43_D: "Se agregaron efectos de sonido del juego.",
  T_49_META_TYP_31_I44_D: "Efecto de sonido de eco mecánico",
  T_49_META_TYP_31_I45_D: "Efecto de sonido de mosquito",
  T_49_META_TYP_31_I46_D: "Efecto de sonido intensivo Ding Ding Ding 1",
  T_49_META_TYP_31_I47_D: "Efectos de sonido intensivos de Ding Ding Ding 2",
  T_49_META_TYP_31_I48_D: "Efecto de sonido de apertura del mecanismo",
  T_49_META_TYP_31_I49_D: "Efecto de sonido de carga 1",
  T_49_META_TYP_31_I5_D: "Grito de Hombre al Recibir Daño",
  T_49_META_TYP_31_I50_D: "Efecto de sonido de pasos",
  T_49_META_TYP_31_I51_D: "Efecto de sonido del mensaje 1 de éxito de misión",
  T_49_META_TYP_31_I52_D: "Efecto de sonido de advertencia de peligro 1",
  T_49_META_TYP_31_I53_D: "Efecto de sonido de advertencia de peligro 2",
  T_49_META_TYP_31_I54_D: "Efecto de sonido de cuenta regresiva 3",
  T_49_META_TYP_31_I55_D: "Efecto de sonido de consejos de visualización",
  T_49_META_TYP_31_I56_D: "Efecto de sonido ambiental de cuervos llamando",
  T_49_META_TYP_31_I57_D: "Efecto de sonido al teletransportarse al área equivocada usando el teletransportador",
  T_49_META_TYP_31_I58_D: "El efecto de sonido de teletransportarse al área correcta usando el punto de teletransporte",
  T_49_META_TYP_31_I59_D: "Transmitir sonido",
  T_49_META_TYP_31_I6_D: "Efecto de sonido al recoger una moneda de oro",
  T_49_META_TYP_31_I60_D: "Efecto de sonido de descarga eléctrica",
  T_49_META_TYP_31_I61_D: "Obtener efectos de sonido de utilería",
  T_49_META_TYP_31_I62_D: "Efectos de sonido de música de fondo electrónica de ensueño lindos",
  T_49_META_TYP_31_I63_D: "Efectos de sonido de música de fondo de juegos casuales",
  T_49_META_TYP_31_I64_D: "Abrir Caja",
  T_49_META_TYP_31_I65_D: "Subir de Nivel",
  T_49_META_TYP_31_I66_D: "Nivel Máximo",
  T_49_META_TYP_31_I67_D: "Botón de Toque",
  T_49_META_TYP_31_I68_D: "Cuenta Regresiva",
  T_49_META_TYP_31_I69_D: "Derrotar Enemigo",
  T_49_META_TYP_31_I7_D: "Efecto de sonido de activación al pasar la línea de meta en una carrera",
  T_49_META_TYP_31_I70_D: "Fin",
  T_49_META_TYP_31_I71_D: "Adelante",
  T_49_META_TYP_31_I72_D: "Victoria",
  T_49_META_TYP_31_I73_D: "Punto de control de la base de entrenamiento",
  T_49_META_TYP_31_I74_D: "Cuenta Regresiva",
  T_49_META_TYP_31_I75_D: "Inicio del Juego",
  T_49_META_TYP_31_I76_D: "Obtener Oro Grande",
  T_49_META_TYP_31_I77_D: "Obtener Oro Medio",
  T_49_META_TYP_31_I78_D: "Obtener Oro Pequeño",
  T_49_META_TYP_31_I79_D: "Unirse a la Batalla",
  T_49_META_TYP_31_I8_D: "Efecto de sonido de disparo",
  T_49_META_TYP_31_I80_D: "Suministro de Guild",
  T_49_META_TYP_31_I81_D: "Altavoz",
  T_49_META_TYP_31_I82_D: "Destituir al Líder de Guild",
  T_49_META_TYP_31_I83_D: "Guardar Almacén",
  T_49_META_TYP_31_I84_D: "Sonido de Arma Especial",
  T_49_META_TYP_31_I85_D: "Impacto de Bala",
  T_49_META_TYP_31_I86_D: "Mover",
  T_49_META_TYP_31_I87_D: "Toque para Desactivar Botón",
  T_49_META_TYP_31_I88_D: "Carga de Habilidad Completa",
  T_49_META_TYP_31_I89_D: "Habilidad Láser",
  T_49_META_TYP_31_I9_D: "Efectos de sonido degradados",
  T_49_META_TYP_31_I90_D: "Obtener Consumible 2",
  T_49_META_TYP_31_I91_D: "Cuenta Regresiva 3",
  T_49_META_TYP_31_I92_D: "Fin del Juego 2",
  T_49_META_TYP_31_I93_D: "Advertencia de Asesinato",
  T_49_META_TYP_31_I94_D: "Explosión",
  T_49_META_TYP_31_I95_D: "Habilidad de Orbe de Energía",
  T_49_META_TYP_31_I96_D: "Habilidad de Charco de Sangre",
  T_49_META_TYP_311_I1_D: "Daño Máximo",
  T_49_META_TYP_311_I3_D: "La velocidad de vuelo del objeto lanzado después de que sale de la mano, en m/s",
  T_49_META_TYP_311_I4_D: "El intervalo de tiempo desde que se suelta el objeto lanzado hasta que surte efecto, en segundos",
  T_49_META_TYP_313_I0_D: "Radio de la zona",
  T_49_META_TYP_313_I1_D: "La duración de la zona de contador, en segundos",
  T_49_META_TYP_314_I0_D: "ID de recurso del controlador de animación",
  T_49_META_TYP_314_I1_D: "Controlador de animación",
  T_49_META_TYP_315_I0_D: "Dueño de la mochila",
  T_49_META_TYP_315_I1_D: "Espacio para mochila",
  T_49_META_TYP_315_I2_D: "Capacidad usada",
  T_49_META_TYP_315_I3_D: "Todos los suministros",
  T_49_META_TYP_316_I0_D: "Recurso de Textura",
  T_49_META_TYP_316_I1_D: "Nombre del Shader",
  T_49_META_TYP_316_I11_D: "Método de inversión",
  T_49_META_TYP_316_I2_D: "Desplazamiento UV",
  T_49_META_TYP_316_I3_D: "Tamaño UV",
  T_49_META_TYP_316_I4_D: "Tipo de Relleno",
  T_49_META_TYP_316_I5_D: "Borde Izquierdo Derecho",
  T_49_META_TYP_316_I6_D: "Borde Superior Inferior",
  T_49_META_TYP_317_I0_D: "Ninguno",
  T_49_META_TYP_317_I1_D: "Congelar posición X",
  T_49_META_TYP_317_I2_D: "Congelar posición Y",
  T_49_META_TYP_317_I3_D: "Congelar posición Z",
  T_49_META_TYP_317_I4_D: "Limitar la rotación alrededor del eje X",
  T_49_META_TYP_317_I5_D: "Limitar la rotación alrededor del eje Y",
  T_49_META_TYP_317_I6_D: "Limitar la rotación alrededor del eje Z",
  T_49_META_TYP_317_I7_D: "Congelar posición",
  T_49_META_TYP_317_I8_D: "Congelar rotación",
  T_49_META_TYP_317_I9_D: "Congelar todo",
  T_49_META_TYP_318_I0_D: "Rango",
  T_49_META_TYP_318_I1_D: "Distancia de Daño Completo",
  T_49_META_TYP_318_I10_D: "Factor de velocidad de apuntado del jugador",
  T_49_META_TYP_318_I11_D: "Relación de amplificación de la vista",
  T_49_META_TYP_318_I12_D: "Ampliación de FOV",
  T_49_META_TYP_318_I13_D: "Ampliación ADS",
  T_49_META_TYP_318_I14_D: "Tiempo de ampliación ADS (s)",
  T_49_META_TYP_318_I15_D: "Tiempo de recuperación ADS (s)",
  T_49_META_TYP_318_I16_D: "Factor de corrección de la distancia mínima de daño para el alcance",
  T_49_META_TYP_318_I17_D: "Permitir asistencia de apuntado en ADS",
  T_49_META_TYP_318_I18_D: "Relación de atracción de la asistencia de apuntado en la pantalla (0-1)",
  T_49_META_TYP_318_I19_D: "Coeficiente de atenuación de distancia de la asistencia de apuntado (0-1)",
  T_49_META_TYP_318_I2_D: "Distancia Mínima de Daño",
  T_49_META_TYP_318_I20_D: "Permitir prioridad de distancia en la asistencia de apuntado",
  T_49_META_TYP_318_I21_D: "Distancia mínima de prioridad de asistencia de apuntado",
  T_49_META_TYP_318_I22_D: "Distancia máxima de prioridad de asistencia de apuntado",
  T_49_META_TYP_318_I23_D: "Coeficiente de impacto de prioridad de distancia en la asistencia de apuntado (>=1)",
  T_49_META_TYP_318_I24_D: "Sensibilidad de rotación en ADS",
  T_49_META_TYP_318_I25_D: "Tasa de convergencia",
  T_49_META_TYP_318_I3_D: "Tamaño del cargador",
  T_49_META_TYP_318_I4_D: "Intervalo de Ataque",
  T_49_META_TYP_318_I5_D: "Velocidad de recarga",
  T_49_META_TYP_318_I6_D: "Velocidad de recarga automática",
  T_49_META_TYP_318_I7_D: "Velocidad de dispersión",
  T_49_META_TYP_318_I8_D: "La tasa de dispersión al agacharse o tumbarse. Cada 0,1 significa que el alcance de la mira aumenta un 10 % con cada bala.",
  T_49_META_TYP_318_I9_D: "Dispersión máxima",
  T_49_META_TYP_319_I0_D: "Simple",
  T_49_META_TYP_319_I1_D: "Cortado",
  T_49_META_TYP_319_I2_D: "Azulejos",
  T_49_META_TYP_319_I3_D: "Lleno",
  T_49_META_TYP_319_I4_D: "Ajustado",
  T_49_META_TYP_32_I0_D: "El reproductor está en estado activo normal.",
  T_49_META_TYP_32_I1_D: "El jugador se encuentra en un estado derribado.",
  T_49_META_TYP_32_I2_D: "El jugador está en estado muerto",
  T_49_META_TYP_320_I0_D: "Horizontal",
  T_49_META_TYP_320_I1_D: "Vertical",
  T_49_META_TYP_320_I2_D: "Radial 90°",
  T_49_META_TYP_320_I3_D: "Radial 180°",
  T_49_META_TYP_320_I4_D: "Radial 360°",
  T_49_META_TYP_321_I0_D: "Distancia máxima para activar la asistencia de puntería",
  T_49_META_TYP_321_I1_D: "El desplazamiento de la retícula al activarse la puntería asistida. Si el punto de desplazamiento no está en la entidad, la puntería asistida fallará.",
  T_49_META_TYP_322_I0_D: "ninguno",
  T_49_META_TYP_322_I1_D: "cabeza",
  T_49_META_TYP_322_I2_D: "Cuerpo",
  T_49_META_TYP_322_I3_D: "Extremidad",
  T_49_META_TYP_323_I0_D: "Escala",
  T_49_META_TYP_323_I1_D: "ID de Cuenta",
  T_49_META_TYP_323_I2_D: "Información del perfil del jugador",
  T_49_META_TYP_323_I3_D: "Estilo",
  T_49_META_TYP_323_I4_D: "Mostrar Rango",
  T_49_META_TYP_323_I5_D: "Mostrar Pin",
  T_49_META_TYP_323_I6_D: "Mostrar Apodo",
  T_49_META_TYP_324_I0_D: "Genera una fuerza de magnitud especificada",
  T_49_META_TYP_324_I1_D: "Genera una aceleración de magnitud especificada",
  T_49_META_TYP_324_I2_D: "Genera un impulso de un tamaño específico",
  T_49_META_TYP_324_I3_D: "Genera la velocidad del tamaño especificado",
  T_49_META_TYP_326_I0_D: "ID de cuenta",
  T_49_META_TYP_326_I1_D: "ID de Avatar",
  T_49_META_TYP_326_I2_D: "ID de Banner",
  T_49_META_TYP_326_I3_D: "ID de Pin",
  T_49_META_TYP_326_I4_D: "Apodo del jugador",
  T_49_META_TYP_326_I5_D: "Rango BR",
  T_49_META_TYP_326_I6_D: "Rango BR Más Alto",
  T_49_META_TYP_326_I7_D: "Rango CS",
  T_49_META_TYP_326_I8_D: "Rango CS Más Alto",
  T_49_META_TYP_327_I0_D: "Identificación del recurso",
  T_49_META_TYP_327_I1_D: "Máscara parte 1",
  T_49_META_TYP_327_I2_D: "Máscara parte 2",
  T_49_META_TYP_327_I3_D: "Máscara parte 3",
  T_49_META_TYP_327_I4_D: "Máscara parte 4",
  T_49_META_TYP_329_I0_D: "Conductor",
  T_49_META_TYP_329_I1_D: "Pasajero A",
  T_49_META_TYP_329_I2_D: "Pasajero B",
  T_49_META_TYP_329_I3_D: "Pasajero C",
  T_49_META_TYP_33_I0_D: "En orden ascendente, los valores cero se ignoran y se ordenan en último lugar.",
  T_49_META_TYP_33_I1_D: "Descendente, de grande a pequeño",
  T_49_META_TYP_33_I2_D: "Ascendente, de pequeño a grande",
  T_49_META_TYP_330_I4_D: "Duración del efecto de invencibilidad (unidad: s)",
  T_49_META_TYP_330_I5_D: "Puntos de control",
  T_49_META_TYP_330_I8_D: "Valor Delta",
  T_49_META_TYP_332_I0_D: "Es Bucle",
  T_49_META_TYP_333_I0_D: "FZLanTingHei",
  T_49_META_TYP_333_I1_D: "SimplifiedArabic",
  T_49_META_TYP_333_I2_D: "NotoNastaliqUrdu",
  T_49_META_TYP_333_I3_D: "GFFLatin",
  T_49_META_TYP_333_I4_D: "AgencyFB",
  T_49_META_TYP_333_I5_D: "Supermercado",
  T_49_META_TYP_333_I6_D: "HindSiliguri",
  T_49_META_TYP_335_I0_D: "Ruta de recursos, vacía por defecto",
  T_49_META_TYP_335_I1_D: "Número de reproducciones, el valor predeterminado es 1",
  T_49_META_TYP_335_I2_D: "Volumen, el valor predeterminado es 50",
  T_49_META_TYP_335_I3_D: "Distancia máxima",
  T_49_META_TYP_335_I4_D: "Distancia mínima",
  T_49_META_TYP_335_I5_D: "¿Es música 3D?",
  T_49_META_TYP_335_I6_D: "Prioridad",
  T_49_META_TYP_335_I7_D: "Tiempo de espera antes de empezar, en segundos",
  T_49_META_TYP_335_I8_D: "Está reproduciendo",
  T_49_META_TYP_338_I0_D: "Estado del móvil",
  T_49_META_TYP_338_I1_D: "Estado del sprint",
  T_49_META_TYP_338_I2_D: "Estado del ataque",
  T_49_META_TYP_338_I3_D: "Estado de salto",
  T_49_META_TYP_338_I4_D: "Estado de escalada",
  T_49_META_TYP_338_I5_D: "Ingresar vehículo (conductor)",
  T_49_META_TYP_338_I6_D: "Ingreso al vehículo (pasajero)",
  T_49_META_TYP_338_I7_D: "Salir del vehículo",
  T_49_META_TYP_338_I8_D: "Conducir",
  T_49_META_TYP_339_I0_D: "Relación de daño a extremidades",
  T_49_META_TYP_339_I1_D: "Relación de daño a la cabeza",
  T_49_META_TYP_339_I2_D: "Relación de durabilidad máxima",
  T_49_META_TYP_339_I3_D: "Relación de HP extra",
  T_49_META_TYP_339_I4_D: "Factor de reducción de daños por explosión adicional (%)",
  T_49_META_TYP_339_I5_D: "Capacidad extra de la mochila",
  T_49_META_TYP_339_I6_D: "Prioridad de reemplazo",
  T_49_META_TYP_34_I0_D: "Puño predeterminado",
  T_49_META_TYP_34_I1_D: "Kar98K",
  T_49_META_TYP_34_I10_D: "AWM2",
  T_49_META_TYP_34_I100_D: "Famas-I",
  T_49_META_TYP_34_I101_D: "Groza-X",
  T_49_META_TYP_34_I102_D: "SVD-Y",
  T_49_META_TYP_34_I103_D: "G36",
  T_49_META_TYP_34_I104_D: "M24",
  T_49_META_TYP_34_I105_D: "M4A1-I",
  T_49_META_TYP_34_I106_D: "M4A1-II",
  T_49_META_TYP_34_I107_D: "M4A1-III",
  T_49_META_TYP_34_I108_D: "M4A1-III",
  T_49_META_TYP_34_I109_D: "Escopeta cargada",
  T_49_META_TYP_34_I11_D: "M1014",
  T_49_META_TYP_34_I110_D: "MAC10",
  T_49_META_TYP_34_I111_D: "Cañón de mano",
  T_49_META_TYP_34_I112_D: "IceGun",
  T_49_META_TYP_34_I113_D: "Pistola de escudo",
  T_49_META_TYP_34_I114_D: "MP5-II",
  T_49_META_TYP_34_I115_D: "MP5-III",
  T_49_META_TYP_34_I116_D: "MP5-III",
  T_49_META_TYP_34_I117_D: "M60-II",
  T_49_META_TYP_34_I118_D: "M60-III",
  T_49_META_TYP_34_I119_D: "M60-III",
  T_49_META_TYP_34_I12_D: "M10142",
  T_49_META_TYP_34_I120_D: "VSS-II",
  T_49_META_TYP_34_I121_D: "VSS-III",
  T_49_META_TYP_34_I122_D: "M14-II",
  T_49_META_TYP_34_I123_D: "M14-III",
  T_49_META_TYP_34_I124_D: "M14-III",
  T_49_META_TYP_34_I125_D: "Kar98K-II",
  T_49_META_TYP_34_I126_D: "Kar98K-III",
  T_49_META_TYP_34_I127_D: "Kar98K-III",
  T_49_META_TYP_34_I128_D: "Famas-II",
  T_49_META_TYP_34_I129_D: "Famas III",
  T_49_META_TYP_34_I13_D: "Granada de fuego",
  T_49_META_TYP_34_I133_D: "Granadas de destello",
  T_49_META_TYP_34_I134_D: "Granada de Humo",
  T_49_META_TYP_34_I135_D: "Granada Congelante",
  T_49_META_TYP_34_I136_D: "Chaleco antibalas Lv1",
  T_49_META_TYP_34_I137_D: "Chaleco antibalas Lv2",
  T_49_META_TYP_34_I138_D: "Chaleco antibalas Lv3",
  T_49_META_TYP_34_I139_D: "Casco Lv1",
  T_49_META_TYP_34_I14_D: "AK",
  T_49_META_TYP_34_I140_D: "Casco Lv2",
  T_49_META_TYP_34_I141_D: "Casco Lv3",
  T_49_META_TYP_34_I142_D: "Armadura a prueba de explosiones",
  T_49_META_TYP_34_I143_D: "Mochila Lv1",
  T_49_META_TYP_34_I144_D: "Mochila Lv2",
  T_49_META_TYP_34_I145_D: "Mochila Lv3",
  T_49_META_TYP_34_I146_D: "Bozal Lv1",
  T_49_META_TYP_34_I147_D: "Boca de cañón Lv2",
  T_49_META_TYP_34_I148_D: "Bozal Lv3",
  T_49_META_TYP_34_I149_D: "Silenciador",
  T_49_META_TYP_34_I15_D: "AK2",
  T_49_META_TYP_34_I150_D: "cañón de asalto",
  T_49_META_TYP_34_I151_D: "Hocico ancho",
  T_49_META_TYP_34_I152_D: "Revista Lv1",
  T_49_META_TYP_34_I153_D: "Revista Lv2",
  T_49_META_TYP_34_I154_D: "Revista Lv3",
  T_49_META_TYP_34_I155_D: "Revista de doble fajo",
  T_49_META_TYP_34_I156_D: "Revista Chain",
  T_49_META_TYP_34_I157_D: "Agarre nivel 1",
  T_49_META_TYP_34_I158_D: "Agarre Lv2",
  T_49_META_TYP_34_I159_D: "Agarre Lv3",
  T_49_META_TYP_34_I16_D: "UMP",
  T_49_META_TYP_34_I160_D: "soporte plegable",
  T_49_META_TYP_34_I161_D: "Empuñadura de rifle de tirador",
  T_49_META_TYP_34_I162_D: "Culata de escopeta",
  T_49_META_TYP_34_I163_D: "Culata de rifle de francotirador",
  T_49_META_TYP_34_I164_D: "Alcance de imágenes térmicas",
  T_49_META_TYP_34_I165_D: "Stock Lv1",
  T_49_META_TYP_34_I166_D: "Stock Lv2",
  T_49_META_TYP_34_I167_D: "Stock Lv3",
  T_49_META_TYP_34_I168_D: "Extensor de escudo",
  T_49_META_TYP_34_I169_D: "Armadura de cuerpo completo",
  T_49_META_TYP_34_I17_D: "UMP2",
  T_49_META_TYP_34_I170_D: "Capa intermedia excesiva",
  T_49_META_TYP_34_I171_D: "Capa intermedia a prueba de explosiones",
  T_49_META_TYP_34_I172_D: "Expansión de mochila",
  T_49_META_TYP_34_I173_D: "Respirador de tratamiento",
  T_49_META_TYP_34_I174_D: "Horizonte",
  T_49_META_TYP_34_I175_D: "0",
  T_49_META_TYP_34_I176_D: "Kit de reparación de armaduras",
  T_49_META_TYP_34_I177_D: "La torre de centinela de inteligencia artificial hecha de materiales de alta tecnología buscará y atacará activamente a los enemigos dentro de un rango determinado.",
  T_49_META_TYP_34_I178_D: "Hongo de nivel 1",
  T_49_META_TYP_34_I179_D: "Hongo de nivel 2",
  T_49_META_TYP_34_I18_D: "MP5",
  T_49_META_TYP_34_I180_D: "Hongo de nivel 3",
  T_49_META_TYP_34_I181_D: "Hongo de nivel 4",
  T_49_META_TYP_34_I182_D: "UAV personal",
  T_49_META_TYP_34_I184_D: "Mina de proximidad",
  T_49_META_TYP_34_I185_D: "Zapatos para volar a reacción",
  T_49_META_TYP_34_I186_D: "Botas de rebote potentes",
  T_49_META_TYP_34_I187_D: "ala delta",
  T_49_META_TYP_34_I188_D: "Granada señuelo",
  T_49_META_TYP_34_I189_D: "aerotabla magnética",
  T_49_META_TYP_34_I19_D: "Águila del desierto",
  T_49_META_TYP_34_I190_D: "Alicates para desactivar bombas",
  T_49_META_TYP_34_I191_D: "Mejorador de armas",
  T_49_META_TYP_34_I192_D: "Munición de rifle",
  T_49_META_TYP_34_I193_D: "Munición de pistola",
  T_49_META_TYP_34_I194_D: "Munición de rifle de francotirador",
  T_49_META_TYP_34_I195_D: "Munición de escopeta",
  T_49_META_TYP_34_I196_D: "Munición de subfusil (SMG)",
  T_49_META_TYP_34_I197_D: "Flechas",
  T_49_META_TYP_34_I198_D: "Granada M79",
  T_49_META_TYP_34_I199_D: "Bala de lanzallamas",
  T_49_META_TYP_34_I2_D: "BALLESTA",
  T_49_META_TYP_34_I20_D: "G18",
  T_49_META_TYP_34_I200_D: "CUCHILLO LANZAMIENTO2",
  T_49_META_TYP_34_I201_D: "Gancho",
  T_49_META_TYP_34_I202_D: "Pistola de fútbol",
  T_49_META_TYP_34_I203_D: "boxeo",
  T_49_META_TYP_34_I204_D: "Lanzallamas",
  T_49_META_TYP_34_I205_D: "Tarjeta Monkeygod",
  T_49_META_TYP_34_I206_D: "Tarjeta MadeManA",
  T_49_META_TYP_34_I207_D: "Tarjeta Djmale",
  T_49_META_TYP_34_I208_D: "Tarjeta de grafiti",
  T_49_META_TYP_34_I209_D: "Tarjeta de detective",
  T_49_META_TYP_34_I21_D: "M14",
  T_49_META_TYP_34_I210_D: "Tarjeta del profesor",
  T_49_META_TYP_34_I211_D: "Tarjeta de cazador de recompensas",
  T_49_META_TYP_34_I212_D: "Tarjeta Superstar",
  T_49_META_TYP_34_I213_D: "Tarjeta Xtreme",
  T_49_META_TYP_34_I214_D: "Tarjeta MusicBroCard",
  T_49_META_TYP_34_I215_D: "Tarjeta KentaCard",
  T_49_META_TYP_34_I216_D: "Tarjeta de seguimiento",
  T_49_META_TYP_34_I217_D: "Tarjeta de chica loca",
  T_49_META_TYP_34_I218_D: "Tarjeta RunSpeedUp",
  T_49_META_TYP_34_I219_D: "Tarjeta Santino",
  T_49_META_TYP_34_I22_D: "SCAR",
  T_49_META_TYP_34_I220_D: "Tarjeta de villano",
  T_49_META_TYP_34_I23_D: "SCAR",
  T_49_META_TYP_34_I24_D: "CICATRIZ-I",
  T_49_META_TYP_34_I25_D: "SCAR-II",
  T_49_META_TYP_34_I26_D: "CICATRIZ-III",
  T_49_META_TYP_34_I27_D: "M1014-I",
  T_49_META_TYP_34_I28_D: "M1014-II",
  T_49_META_TYP_34_I29_D: "M1014-III",
  T_49_META_TYP_34_I3_D: "Escudo de fútbol",
  T_49_META_TYP_34_I30_D: "Pistola de energía de sobrecalentamiento",
  T_49_META_TYP_34_I31_D: "Pistola de sobrecalentamiento-I",
  T_49_META_TYP_34_I32_D: "Pistola de sobrecalentamiento II",
  T_49_META_TYP_34_I33_D: "Cañón de sobrecalentamiento III",
  T_49_META_TYP_34_I34_D: "PLASMA-X",
  T_49_META_TYP_34_I35_D: "Pistola curativa-Y",
  T_49_META_TYP_34_I36_D: "Francotirador curativo",
  T_49_META_TYP_34_I37_D: "Pistola curativa",
  T_49_META_TYP_34_I38_D: "VSS",
  T_49_META_TYP_34_I39_D: "GROZA",
  T_49_META_TYP_34_I4_D: "FootballIce",
  T_49_META_TYP_34_I40_D: "GROZA",
  T_49_META_TYP_34_I41_D: "MP40",
  T_49_META_TYP_34_I42_D: "MP40",
  T_49_META_TYP_34_I43_D: "sartén",
  T_49_META_TYP_34_I44_D: "Machete",
  T_49_META_TYP_34_I45_D: "SKS",
  T_49_META_TYP_34_I46_D: "M249",
  T_49_META_TYP_34_I47_D: "M249-X",
  T_49_META_TYP_34_I48_D: "M1873",
  T_49_META_TYP_34_I49_D: "M79",
  T_49_META_TYP_34_I5_D: "Bizon",
  T_49_META_TYP_34_I50_D: "FAMAS",
  T_49_META_TYP_34_I51_D: "M500",
  T_49_META_TYP_34_I52_D: "SVD",
  T_49_META_TYP_34_I53_D: "SVD",
  T_49_META_TYP_34_I54_D: "AC80",
  T_49_META_TYP_34_I55_D: "Bate de béisbol",
  T_49_META_TYP_34_I56_D: "XM8",
  T_49_META_TYP_34_I57_D: "XM8",
  T_49_META_TYP_34_I58_D: "SPAS12",
  T_49_META_TYP_34_I59_D: "SPAS12",
  T_49_META_TYP_34_I6_D: "VSK94",
  T_49_META_TYP_34_I60_D: "M60",
  T_49_META_TYP_34_I61_D: "MGL140",
  T_49_META_TYP_34_I62_D: "P90",
  T_49_META_TYP_34_I63_D: "P90",
  T_49_META_TYP_34_I64_D: "AN94",
  T_49_META_TYP_34_I65_D: "Katana",
  T_49_META_TYP_34_I66_D: "CG15",
  T_49_META_TYP_34_I67_D: "RG550",
  T_49_META_TYP_34_I68_D: "Gatling",
  T_49_META_TYP_34_I7_D: "M4A1",
  T_49_META_TYP_34_I70_D: "Potente cañón de gancho",
  T_49_META_TYP_34_I71_D: "Cuchillo FF",
  T_49_META_TYP_34_I72_D: "M1887",
  T_49_META_TYP_34_I73_D: "3 balas 1887",
  T_49_META_TYP_34_I74_D: "M18872",
  T_49_META_TYP_34_I75_D: "THOMPSON",
  T_49_META_TYP_34_I76_D: "THOMPSON",
  T_49_META_TYP_34_I77_D: "M82B",
  T_49_META_TYP_34_I78_D: "M82B",
  T_49_META_TYP_34_I79_D: "AUG",
  T_49_META_TYP_34_I8_D: "USP",
  T_49_META_TYP_34_I80_D: "PARAFAL",
  T_49_META_TYP_34_I81_D: "PARAFAL",
  T_49_META_TYP_34_I82_D: "Pájaro carpintero",
  T_49_META_TYP_34_I83_D: "VECTOR",
  T_49_META_TYP_34_I84_D: "MAG-7",
  T_49_META_TYP_34_I85_D: "MAG-7",
  T_49_META_TYP_34_I86_D: "Guadaña",
  T_49_META_TYP_34_I87_D: "Martillo",
  T_49_META_TYP_34_I88_D: "Cuchillo arrojadizo (recogida)",
  T_49_META_TYP_34_I89_D: "Kord",
  T_49_META_TYP_34_I9_D: "AWM",
  T_49_META_TYP_34_I90_D: "M1917",
  T_49_META_TYP_34_I91_D: "USP-2",
  T_49_META_TYP_34_I92_D: "Martín pescador",
  T_49_META_TYP_34_I93_D: "UZI",
  T_49_META_TYP_34_I94_D: "MP5-I",
  T_49_META_TYP_34_I95_D: "M60-I",
  T_49_META_TYP_34_I96_D: "VSS-I",
  T_49_META_TYP_34_I97_D: "M14-I",
  T_49_META_TYP_34_I98_D: "Kar98K-I",
  T_49_META_TYP_34_I99_D: "AWM_Y",
  T_49_META_TYP_340_I0_D: "Fácil",
  T_49_META_TYP_340_I1_D: "Simple",
  T_49_META_TYP_340_I2_D: "Normal",
  T_49_META_TYP_340_I3_D: "Moderado",
  T_49_META_TYP_340_I4_D: "Difícil",
  T_49_META_TYP_340_I5_D: "Infierno",
  T_49_META_TYP_342_I0_D: "Iniciar Evento",
  T_49_META_TYP_342_I1_D: "Detener Evento",
  T_49_META_TYP_342_I2_D: "Pausar Evento",
  T_49_META_TYP_342_I3_D: "¿Cuánto tiempo hay que esperar después de ser creado para empezar a cronometrar, en milisegundos?",
  T_49_META_TYP_342_I4_D: "Conteo de Repeticiones",
  T_49_META_TYP_342_I5_D: "Eventos",
  T_49_META_TYP_342_I6_D: "Cuenta regresiva o cuenta regresiva",
  T_49_META_TYP_342_I7_D: "Estado del jugador",
  T_49_META_TYP_342_I8_D: "La hora de finalización del cronometraje, en segundos.",
  T_49_META_TYP_345_I10_D: "Cañón de mano",
  T_49_META_TYP_345_I12_D: "Cañón de pared de hielo",
  T_49_META_TYP_345_I13_D: "Lanzallamas",
  T_49_META_TYP_345_I4_D: "Escopeta",
  T_49_META_TYP_345_I6_D: "Arma especial",
  T_49_META_TYP_345_I8_D: "Cañón de carga",
  T_49_META_TYP_346_I0_D: "Munición de rifle",
  T_49_META_TYP_346_I1_D: "Munición de pistola",
  T_49_META_TYP_346_I2_D: "Munición de rifle de francotirador",
  T_49_META_TYP_346_I3_D: "Munición de escopeta",
  T_49_META_TYP_346_I4_D: "Munición de subfusil (SMG)",
  T_49_META_TYP_346_I5_D: "Flechas",
  T_49_META_TYP_346_I6_D: "Granada M79",
  T_49_META_TYP_346_I7_D: "Gancho",
  T_49_META_TYP_346_I8_D: "Granada especializada M79",
  T_49_META_TYP_347_I3_D: "Si es verdadero, se puede combinar con el movimiento relativo. Si es falso, debe combinarse con el movimiento absoluto; de lo contrario, la propiedad no se aplicará correctamente.",
  T_49_META_TYP_347_I6_D: "Valor Delta",
  T_49_META_TYP_350_I0_D: "Coche Deportivo",
  T_49_META_TYP_350_I1_D: "Motocicleta",
  T_49_META_TYP_350_I2_D: "Jeep",
  T_49_META_TYP_350_I3_D: "SUV",
  T_49_META_TYP_350_I4_D: "Camiones monstruo",
  T_49_META_TYP_350_I5_D: "Tuk-tuk",
  T_49_META_TYP_352_I1_D: "Sprite No Seleccionado",
  T_49_META_TYP_352_I2_D: "No se ha seleccionado ningún tipo de imagen",
  T_49_META_TYP_352_I3_D: "Color No Seleccionado",
  T_49_META_TYP_352_I4_D: "Sprite Seleccionado",
  T_49_META_TYP_352_I5_D: "Seleccionar el tipo de imagen",
  T_49_META_TYP_352_I6_D: "Color Seleccionado",
  T_49_META_TYP_353_I0_D: "Cantidad de recuperación de HP",
  T_49_META_TYP_353_I1_D: "Velocidad de recuperación de HP (ms)",
  T_49_META_TYP_353_I2_D: "Tiempo requerido (ms)",
  T_49_META_TYP_354_I0_D: "Cantidad de recuperación de EP",
  T_49_META_TYP_355_I0_D: "Cantidad de recuperación de HP",
  T_49_META_TYP_355_I1_D: "Cantidad de recuperación de EP",
  T_49_META_TYP_355_I2_D: "Tiempo requerido (ms)",
  T_49_META_TYP_356_I0_D: "Artículos de Caída",
  T_49_META_TYP_356_I1_D: "Tiempo de entrega de la caja de Airdrop en ms",
  T_49_META_TYP_356_I2_D: "Estado de Caída Aérea",
  T_49_META_TYP_357_I0_D: "Superficie",
  T_49_META_TYP_357_I1_D: "límite",
  T_49_META_TYP_359_I0_D: "Si se debe utilizar un controlador de jugador con física",
  T_49_META_TYP_359_I1_D: "Si se coloca en una pendiente que exceda este ángulo, se deslizará hacia abajo.",
  T_49_META_TYP_359_I10_D: "Esta aceleración de gravedad solo se aplica al controlador del jugador.",
  T_49_META_TYP_359_I11_D: "Masa, kg",
  T_49_META_TYP_359_I12_D: "Si la pendiente excede el ángulo máximo de subida, se deslizará hacia abajo.",
  T_49_META_TYP_359_I16_D: "Después de abrir, los primitivos o scripts del lado del servidor controlan el movimiento.",
  T_49_META_TYP_359_I17_D: "Cuando está habilitado, se puede personalizar la fuerza que aplica el personaje al empujar el cuerpo rígido.",
  T_49_META_TYP_359_I18_D: "La cantidad de fuerza aplicada cuando el personaje empuja el cuerpo rígido.",
  T_49_META_TYP_359_I19_D: "Verdadero cuando la parte inferior toca el colisionador, generalmente se usa para determinar si el jugador está en el suelo.",
  T_49_META_TYP_359_I2_D: "Solo los obstáculos que superen esta altura tendrán efecto de bloqueo. El rango de valores es [0, Altura].",
  T_49_META_TYP_359_I20_D: "Nivel físico personalizado, valor [0,15]",
  T_49_META_TYP_359_I21_D: "Habilitar Rotación con Gravedad",
  T_49_META_TYP_359_I3_D: "La profundidad de la cápsula que se puede incrustar. Puede evitar que el personaje se atasque o tiemble. No se recomienda modificarlo a menos que sea necesario. Rango de valores (0, Radio]",
  T_49_META_TYP_359_I4_D: "Distancia mínima de movimiento. Los movimientos menores a este valor no se ejecutarán. Si no hay ninguna necesidad especial, se recomienda mantenerlo como 0",
  T_49_META_TYP_359_I5_D: "El desplazamiento del centro del cuadro de colisión desde el origen de coordenadas local",
  T_49_META_TYP_359_I6_D: "El radio de la cápsula, valor mínimo es 0,01",
  T_49_META_TYP_359_I7_D: "La altura total de la cápsula, incluidos los hemisferios superior e inferior, con un valor mínimo de 2*Radio",
  T_49_META_TYP_359_I8_D: "Velocidad lineal actual, en m/s",
  T_49_META_TYP_360_I0_D: "Ángulo de disparo a la izquierda",
  T_49_META_TYP_360_I1_D: "Ángulo de disparo a la derecha",
  T_49_META_TYP_360_I2_D: "Ángulo mínimo de elevación",
  T_49_META_TYP_360_I3_D: "Ángulo máximo de depresión",
  T_49_META_TYP_360_I4_D: "Velocidad de salida del cañón",
  T_49_META_TYP_362_I0_D: "El tiempo de congelación después de golpear al jugador, en segundos.",
  T_49_META_TYP_363_I0_D: "Deshabilitar la solicitud de compra de HUD",
  T_49_META_TYP_363_I1_D: "Pide ayuda al equipo para realizar compras",
  T_49_META_TYP_363_I2_D: "Pide ayuda a la facción para comprar",
  T_49_META_TYP_364_I0_D: "¿Es Posición Central?",
  T_49_META_TYP_364_I1_D: "Hacer o no un bucle",
  T_49_META_TYP_364_I2_D: "Nombre de la animación",
  T_49_META_TYP_364_I3_D: "Si se reproducirá automáticamente",
  T_49_META_TYP_364_I4_D: "Usar Recurso Personalizado",
  T_49_META_TYP_366_I0_D: "Especifique el UUID del recurso Batch que se representará",
  T_49_META_TYP_367_I1_D: "Mostrar Etiqueta",
  T_49_META_TYP_367_I2_D: "El estilo de icono para marcar objetivos",
  T_49_META_TYP_367_I3_D: "El color de superposición del ícono que se muestra al marcar un objetivo",
  T_49_META_TYP_367_I4_D: "El estilo del icono mostrado en una escala",
  T_49_META_TYP_367_I5_D: "El color de superposición del icono se muestra en una escala",
  T_49_META_TYP_367_I6_D: "Siempre Mostrar Marca",
  T_49_META_TYP_370_I0_D: "Título principal",
  T_49_META_TYP_370_I1_D: "Subtítulo",
  T_49_META_TYP_370_I2_D: "Color de fondo superior",
  T_49_META_TYP_370_I3_D: "Color de fondo a continuación",
  T_49_META_TYP_371_I2_D: "Puntuación Izquierda",
  T_49_META_TYP_371_I3_D: "Puntuación Derecha",
  T_49_META_TYP_371_I4_D: "La última puntuación a la izquierda, utilizada para reproducir la animación de cambio de puntuación.",
  T_49_META_TYP_371_I5_D: "La última puntuación a la derecha se utiliza para reproducir la animación de cambio de puntuación.",
  T_49_META_TYP_372_I0_D: "De pie",
  T_49_META_TYP_372_I1_D: "Mostrar Agachado",
  T_49_META_TYP_372_I10_D: "Caída de gran altitud",
  T_49_META_TYP_372_I11_D: "Caer desde una altura baja, como saltar.",
  T_49_META_TYP_372_I12_D: "Zapatos voladores",
  T_49_META_TYP_372_I13_D: "Doble salto",
  T_49_META_TYP_372_I14_D: "Siéntate en una silla",
  T_49_META_TYP_372_I15_D: "Ser expulsado por una catapulta",
  T_49_META_TYP_372_I16_D: "Fase de preparación de la catapulta",
  T_49_META_TYP_372_I17_D: "Hélices de planeo planeo",
  T_49_META_TYP_372_I18_D: "Caída de la hélice de planeo",
  T_49_META_TYP_372_I19_D: "Rebotado por neumáticos",
  T_49_META_TYP_372_I2_D: "correr",
  T_49_META_TYP_372_I20_D: "Rebotado por un neumático humano",
  T_49_META_TYP_372_I21_D: "Una acción en el área de la fiesta",
  T_49_META_TYP_372_I22_D: "Tomar un avión",
  T_49_META_TYP_372_I23_D: "Entra el cañón",
  T_49_META_TYP_372_I24_D: "Al salir de un cañón, vehículo, etc., si el objeto en el que estás montado está volando, este es el estado",
  T_49_META_TYP_372_I25_D: "Después de saltar del trampolín",
  T_49_META_TYP_372_I26_D: "Bajarse de la tirolesa",
  T_49_META_TYP_372_I27_D: "No utilizado",
  T_49_META_TYP_372_I3_D: "Gatear",
  T_49_META_TYP_372_I4_D: "Natación rápida",
  T_49_META_TYP_372_I5_D: "Caída vertical",
  T_49_META_TYP_372_I6_D: "Más allá del muro",
  T_49_META_TYP_372_I7_D: "No utilizado",
  T_49_META_TYP_372_I8_D: "Derribado pero no muerto",
  T_49_META_TYP_372_I9_D: "Utilice una tabla de agua",
  T_49_META_TYP_374_I0_D: "Salud, nivel y color del trazo",
  T_49_META_TYP_374_I1_D: "A medida que disminuye la salud, la porción faltante muestra brevemente este color.",
  T_49_META_TYP_374_I10_D: "Desplazamiento relativo al objetivo a seguir",
  T_49_META_TYP_374_I11_D: "El valor de salud entre cada dos líneas divisorias no se mostrará si es menor o igual a 0",
  T_49_META_TYP_374_I12_D: "HP Total",
  T_49_META_TYP_374_I13_D: "HP Actual",
  T_49_META_TYP_374_I14_D: "Cuando esté habilitado, los cambios de salud se mostrarán en diferentes colores.",
  T_49_META_TYP_374_I15_D: "Cuando está habilitada, las propiedades de desplazamiento se convierten en coordenadas mundiales utilizando el sistema de coordenadas local.",
  T_49_META_TYP_374_I2_D: "Cuando la salud aumenta, la porción aumentada muestra brevemente este color.",
  T_49_META_TYP_374_I3_D: "El color del borde de salud y la parte inferior borrosa.",
  T_49_META_TYP_374_I4_D: "Rango 0~1, la transparencia de la interfaz de usuario general",
  T_49_META_TYP_374_I5_D: "Determina la escala general de la interfaz de usuario y las fuentes se escalan juntas.",
  T_49_META_TYP_374_I6_D: "Indica el nombre del propietario actual de la barra de salud.",
  T_49_META_TYP_374_I8_D: "La longitud de la barra de salud que se muestra en la pantalla.",
  T_49_META_TYP_374_I9_D: "Debe seguir una entidad con un componente Transformación",
  T_49_META_TYP_375_I1_D: "Entidad de combate",
  T_49_META_TYP_376_I1_D: "Entidad de combate",
  T_49_META_TYP_38_I0_D: "Alfa",
  T_49_META_TYP_382_I0_D: "por defecto",
  T_49_META_TYP_382_I1_D: "Omite el estado de derribo y muere directamente",
  T_49_META_TYP_382_I2_D: "No Omitir Derribo",
  T_49_META_TYP_387_I1_D: "Permitir Presionado Fuera",
  T_49_META_TYP_389_I0_D: "Desplazamiento predeterminado de la base",
  T_49_META_TYP_389_I1_D: "Sprite de Fondo",
  T_49_META_TYP_389_I10_D: "Alfa No Activado",
  T_49_META_TYP_389_I2_D: "Radio de Fondo",
  T_49_META_TYP_389_I3_D: "Imagen de Tapón de Joystick",
  T_49_META_TYP_389_I4_D: "Radio de Tapón de Joystick",
  T_49_META_TYP_389_I5_D: "Radio de Arrastre de Tapón de Joystick",
  T_49_META_TYP_389_I6_D: "Sprite de Flecha",
  T_49_META_TYP_389_I7_D: "Tamaño de Flecha",
  T_49_META_TYP_389_I8_D: "Desplazamiento de Flecha",
  T_49_META_TYP_389_I9_D: "Alfa Activado",
  T_49_META_TYP_39_I1_D: "Forma del Sprite",
  T_49_META_TYP_39_I10_D: "Gradiente Superior",
  T_49_META_TYP_39_I11_D: "Gradiente Inferior",
  T_49_META_TYP_39_I12_D: "Alfa Superior",
  T_49_META_TYP_39_I13_D: "Alfa Inferior",
  T_49_META_TYP_39_I3_D: "Voltear",
  T_49_META_TYP_39_I4_D: "Lleno",
  T_49_META_TYP_39_I5_D: "Centro Invisible",
  T_49_META_TYP_39_I6_D: "Dirección de Relleno",
  T_49_META_TYP_39_I7_D: "Valor de Relleno",
  T_49_META_TYP_39_I8_D: "Invertir Relleno",
  T_49_META_TYP_39_I9_D: "Gradiente",
  T_49_META_TYP_392_I0_D: "El tiempo que aparece la zona segura en cada ronda del juego, el valor predeterminado es 0, la unidad es ms",
  T_49_META_TYP_392_I1_D: "El tiempo que tarda en encogerse el círculo, en ms",
  T_49_META_TYP_392_I10_D: "El tiempo final del círculo que se encoge, en ms",
  T_49_META_TYP_392_I12_D: "Radio final del círculo venenoso",
  T_49_META_TYP_392_I13_D: "Tiempo de inicio de la reducción",
  T_49_META_TYP_392_I14_D: "Intervalo de Daño (ms)",
  T_49_META_TYP_392_I3_D: "La cantidad de daño infligido a los jugadores en el círculo de veneno.",
  T_49_META_TYP_392_I4_D: "Lista de jugadores en la zona segura",
  T_49_META_TYP_392_I5_D: "Tiempo de desaparición de la zona segura. Si el tiempo de desaparición de la zona segura es menor que el tiempo efectivo, no se generará ninguna zona segura.",
  T_49_META_TYP_392_I6_D: "ID del Grupo",
  T_49_META_TYP_392_I7_D: "Radio de inicio del círculo de veneno",
  T_49_META_TYP_392_I8_D: "Estado final",
  T_49_META_TYP_392_I9_D: "Estado",
  T_49_META_TYP_394_I0_D: "El valor es de aproximadamente 3,1416",
  T_49_META_TYP_394_I1_D: "El valor es de aproximadamente 2,7183",
  T_49_META_TYP_396_I0_D: "Título",
  T_49_META_TYP_396_I1_D: "Contenido",
  T_49_META_TYP_396_I2_D: "Opciones",
  T_49_META_TYP_396_I3_D: "Mostrar fondo",
  T_49_META_TYP_399_I0_D: "Altura de Salto",
  T_49_META_TYP_399_I1_D: "El número de saltos consecutivos que puedes realizar antes de aterrizar",
  T_49_META_TYP_399_I2_D: "Puedes realizar varios saltos antes de aterrizar.",
  T_49_META_TYP_399_I3_D: "Se Puede Mover en el Aire",
  T_49_META_TYP_40_I1_D: "Etiqueta",
  T_49_META_TYP_40_I10_D: "Espaciado de Línea",
  T_49_META_TYP_40_I11_D: "Método de desbordamiento",
  T_49_META_TYP_40_I12_D: "Estilo de fuente",
  T_49_META_TYP_40_I13_D: "Aplicar Sombra",
  T_49_META_TYP_40_I14_D: "Color de Sombra",
  T_49_META_TYP_40_I15_D: "Desplazamiento de Sombra",
  T_49_META_TYP_40_I3_D: "Clave de localización, se puede utilizar en varios idiomas",
  T_49_META_TYP_40_I5_D: "Alineación",
  T_49_META_TYP_40_I6_D: "Alineación Vertical",
  T_49_META_TYP_40_I7_D: "Negrita",
  T_49_META_TYP_40_I8_D: "Cursiva",
  T_49_META_TYP_40_I9_D: "Subrayado",
  T_49_META_TYP_400_I0_D: "Activo",
  T_49_META_TYP_400_I1_D: "Pasivo",
  T_49_META_TYP_400_I2_D: "Sin ataque",
  T_49_META_TYP_401_I0_D: "No se puede disparar",
  T_49_META_TYP_401_I1_D: "Puede disparar continuamente",
  T_49_META_TYP_401_I2_D: "Se dispara una vez por comando de ataque.",
  T_49_META_TYP_401_I3_D: "Cada comando de ataque se dispara tres veces.",
  T_49_META_TYP_401_I4_D: "Cada comando de ataque dispara dos veces.",
  T_49_META_TYP_401_I5_D: "Proyectil",
  T_49_META_TYP_402_I0_D: "Objetivo para agregar como amigo",
  T_49_META_TYP_402_I1_D: "Tipo de función",
  T_49_META_TYP_402_I2_D: "Estilo",
  T_49_META_TYP_403_I0_D: "Agregar Amigo",
  T_49_META_TYP_403_I1_D: "Reportar",
  T_49_META_TYP_404_I0_D: "Claro",
  T_49_META_TYP_404_I1_D: "Oscuro",
  T_49_META_TYP_405_I0_D: "Por jerarquía",
  T_49_META_TYP_405_I1_D: "Por prioridad de alto a bajo",
  T_49_META_TYP_405_I2_D: "Por prioridad de bajo a alto",
  T_49_META_TYP_406_I0_D: "Controla la distancia de la acción de salto del jugador.",
  T_49_META_TYP_406_I1_D: "Controla la altura del cuerpo del jugador al subir y bajar.",
  T_49_META_TYP_407_I0_D: "Local",
  T_49_META_TYP_407_I1_D: "Cliente",
  T_49_META_TYP_407_I2_D: "Servidor",
  T_49_META_TYP_407_I3_D: "Ambos",
  T_49_META_TYP_409_I0_D: "Sin error",
  T_49_META_TYP_409_I1_D: "Tiempo de espera de almacenamiento de datos, principalmente para operaciones de lectura",
  T_49_META_TYP_409_I10_D: "Error en el cambio de equipo: equipo objetivo no válido",
  T_49_META_TYP_409_I11_D: "Error en el cambio de equipo: los jugadores muertos no pueden cambiar de equipo.",
  T_49_META_TYP_409_I12_D: "Cambio de equipo fallido: no se permiten cambios de equipo en los vehículos",
  T_49_META_TYP_409_I2_D: "La frecuencia de lectura y escritura del almacenamiento de datos excede el límite",
  T_49_META_TYP_409_I3_D: "Anormalidad de parámetros",
  T_49_META_TYP_409_I4_D: "No se pudo crear la sala: No hay PersonaID válidos",
  T_49_META_TYP_409_I5_D: "Estado de error indefinido",
  T_49_META_TYP_409_I6_D: "Los servicios comerciales están cerrados y los usuarios ya no pueden utilizar los servicios del desarrollador.",
  T_49_META_TYP_409_I7_D: "Error en el cambio de equipo: modo no compatible",
  T_49_META_TYP_409_I8_D: "Error en el cambio de equipo: actualmente ya está en el equipo de destino",
  T_49_META_TYP_409_I9_D: "Error en el cambio de equipo: objeto no válido",
  T_49_META_TYP_41_I0_D: "Forma del Sprite",
  T_49_META_TYP_41_I19_D: "Desactivar el cuadro de colisión",
  T_49_META_TYP_41_I3_D: "Color Desactivado",
  T_49_META_TYP_41_I4_D: "Color Presionado",
  T_49_META_TYP_41_I5_D: "Tipo de Relleno",
  T_49_META_TYP_41_I6_D: "Es Botón FE",
  T_49_META_TYP_41_I7_D: "Sprite Presionado",
  T_49_META_TYP_41_I8_D: "Tipo de Sprite Presionado",
  T_49_META_TYP_41_I9_D: "Tipo de Volteo",
  T_49_META_TYP_411_I0_D: "Velocidad Adelante",
  T_49_META_TYP_411_I1_D: "Velocidad Atrás",
  T_49_META_TYP_411_I2_D: "Velocidad Arriba",
  T_49_META_TYP_411_I3_D: "Velocidad Abajo",
  T_49_META_TYP_411_I4_D: "Daño Mínimo de Granada",
  T_49_META_TYP_411_I5_D: "Daño Máximo de Granada",
  T_49_META_TYP_411_I6_D: "Rango de Granada",
  T_49_META_TYP_412_I0_D: "La cantidad de caballos de fuerza que gana el vehículo cuando se usa el botón del acelerador",
  T_49_META_TYP_412_I1_D: "La cantidad de caballos de fuerza que gana el vehículo cuando se usa el botón de marcha atrás/freno",
  T_49_META_TYP_412_I2_D: "A alta velocidad, el ángulo de dirección máximo",
  T_49_META_TYP_412_I3_D: "Umbral de velocidad para aplicación de ángulo de dirección máximo a alta velocidad",
  T_49_META_TYP_412_I4_D: "Después de alcanzar la velocidad máxima, el vehículo no proporcionará más caballos de fuerza, pero el vehículo puede superar esta velocidad máxima (por ejemplo, al ir cuesta abajo).",
  T_49_META_TYP_412_I5_D: "Cuando el vehículo no está siendo controlado, se desacelera multiplicando IdleBrakeInput por BrakeTorque",
  T_49_META_TYP_412_I6_D: "Se utiliza para calcular el daño causado por golpear a personas, utilizando los parámetros de la fórmula de daño.",
  T_49_META_TYP_412_I7_D: "Se utiliza para calcular el daño al impactar a personas. Al superar esta velocidad, el daño no aumenta.",
  T_49_META_TYP_412_I8_D: "Se utiliza para el cálculo de daños por colisión, daño mínimo.",
  T_49_META_TYP_412_I9_D: "Se utiliza para el cálculo de daños por colisión, daño máximo.",
  T_49_META_TYP_413_I0_D: "Ropa transformada del jugador (NPC)",
  T_49_META_TYP_414_I1_D: "Rango Amplio",
  T_49_META_TYP_415_I0_D: "ID de Persona",
  T_49_META_TYP_415_I1_D: "Apodo",
  T_49_META_TYP_415_I2_D: "Avatar",
  T_49_META_TYP_416_I1_D: "Persona atada",
  T_49_META_TYP_416_I2_D: "Compensar",
  T_49_META_TYP_416_I3_D: "Altura",
  T_49_META_TYP_416_I4_D: "Si desea responder a los mensajes del sistema",
  T_49_META_TYP_416_I5_D: "Apodo de Persona",
  T_49_META_TYP_416_I6_D: "PersonaAvatar",
  T_49_META_TYP_416_I7_D: "Apodo del usuario",
  T_49_META_TYP_416_I8_D: "Avatar de usuario",
  T_49_META_TYP_417_I0_D: "Identificación del recurso",
  T_49_META_TYP_418_I0_D: "Vencimiento de la membresía",
  T_49_META_TYP_418_I1_D: "Hazte miembro",
  T_49_META_TYP_418_I2_D: "Renovación de membresía",
  T_49_META_TYP_42_I0_D: "Texto Predeterminado",
  T_49_META_TYP_42_I1_D: "Texto Activo",
  T_49_META_TYP_42_I10_D: "Longitud Máxima",
  T_49_META_TYP_42_I14_D: "Color Presionado",
  T_49_META_TYP_42_I16_D: "Clave de localización, se puede utilizar en varios idiomas",
  T_49_META_TYP_42_I3_D: "Alineación",
  T_49_META_TYP_42_I4_D: "Alineación Vertical",
  T_49_META_TYP_42_I5_D: "Negrita",
  T_49_META_TYP_42_I6_D: "Cursiva",
  T_49_META_TYP_42_I7_D: "Subrayado",
  T_49_META_TYP_42_I8_D: "Espaciado de Línea",
  T_49_META_TYP_42_I9_D: "Ajuste de Palabras",
  T_49_META_TYP_424_I0_D: "Efecto de niebla lineal",
  T_49_META_TYP_424_I1_D: "Efecto de niebla de índice",
  T_49_META_TYP_424_I2_D: "Efecto de niebla cuadrada exponencial",
  T_49_META_TYP_426_I0_D: "Intensidad",
  T_49_META_TYP_426_I1_D: "Rango",
  T_49_META_TYP_426_I2_D: "El ángulo del cono del foco en grados",
  T_49_META_TYP_426_I3_D: "Color de la luz",
  T_49_META_TYP_428_I0_D: "IDs de piel de arma",
  T_49_META_TYP_428_I2_D: "Identificación del conjunto",
  T_49_META_TYP_428_I3_D: "Identificación del tocado",
  T_49_META_TYP_428_I4_D: "Identificación facial",
  T_49_META_TYP_428_I5_D: "Identificación de maquillaje",
  T_49_META_TYP_428_I6_D: "Identificación de la parte superior del cuerpo",
  T_49_META_TYP_428_I7_D: "Identificación de la parte inferior del cuerpo",
  T_49_META_TYP_428_I8_D: "Identificación del calzado",
  T_49_META_TYP_431_I1_D: "La trayectoria de la entidad objetivo",
  T_49_META_TYP_431_I3_D: "Velocidad de movimiento, unidad: m/s",
  T_49_META_TYP_431_I4_D: `¿El movimiento sigue la tangente del camino o no?
Por defecto, el valor es False, y el objeto no cambiará de dirección.
Si se establece en True, el objeto se orientará hacia la dirección del camino.`,
  T_49_META_TYP_431_I5_D: "Porcentaje jugado",
  T_49_META_TYP_432_I0_D: "Ángulo de balanceo, que afecta la rotación radial de la trayectoria en ambos lados de este punto",
  T_49_META_TYP_432_I1_D: "La posición relativa del punto de control de la tangente y el punto de referencia determina la tangente de la trayectoria.",
  T_49_META_TYP_433_I0_D: "Interpolar líneas rectas entre puntos de la ruta",
  T_49_META_TYP_433_I1_D: "Interpolación curva entre puntos de la trayectoria para un movimiento suave",
  T_49_META_TYP_433_I2_D: "Admite el ajuste manual de la tangente del punto de la curva.",
  T_49_META_TYP_434_I0_D: "Tipo de ruta",
  T_49_META_TYP_434_I1_D: "La longitud total del camino",
  T_49_META_TYP_434_I2_D: "Si el principio y el final están conectados",
  T_49_META_TYP_434_I3_D: "Colección de puntos de referencia",
  T_49_META_TYP_437_I3_D: "Jugadores Izquierdos",
  T_49_META_TYP_437_I4_D: "Jugadores Derechos",
  T_49_META_TYP_437_I5_D: "Matriz de nombres de tipos integrales",
  T_49_META_TYP_437_I6_D: "La matriz de puntos a la izquierda (Lista de una dimensión: jugadores; Lista de dos dimensiones: datos de puntos completados según el tipo de puntos personalizado)",
  T_49_META_TYP_437_I7_D: "La matriz de puntos a la derecha (Lista de una dimensión: jugadores; Lista de dos dimensiones: datos de puntos completados según el tipo de puntos personalizado)",
  T_49_META_TYP_438_I1_D: "Agrupación de jugadores",
  T_49_META_TYP_438_I2_D: "Matriz de clasificación de grupos",
  T_49_META_TYP_438_I3_D: "Matriz de puntuaciones de grupo",
  T_49_META_TYP_438_I4_D: "Matriz de nombres de tipos integrales",
  T_49_META_TYP_438_I5_D: "Matriz de colores agrupada",
  T_49_META_TYP_438_I6_D: "Matriz de puntos del jugador (correspondiente al orden cuando no está agrupado)",
  T_49_META_TYP_442_I1_D: "Puntuación Izquierda",
  T_49_META_TYP_442_I10_D: "Icono de muerte a la derecha",
  T_49_META_TYP_442_I2_D: "Puntuación Derecha",
  T_49_META_TYP_442_I3_D: "Número de supervivientes a la izquierda",
  T_49_META_TYP_442_I4_D: "Número de supervivientes a la derecha",
  T_49_META_TYP_442_I5_D: "Número de muertos a la izquierda",
  T_49_META_TYP_442_I6_D: "Número de muertos a la derecha",
  T_49_META_TYP_442_I7_D: "Icono de supervivencia a la izquierda",
  T_49_META_TYP_442_I8_D: "Icono de supervivencia a la derecha",
  T_49_META_TYP_442_I9_D: "Icono de la muerte a la izquierda",
  T_49_META_TYP_444_I0_D: "Inglés",
  T_49_META_TYP_444_I1_D: "Chino simplificado",
  T_49_META_TYP_444_I10_D: "Francés",
  T_49_META_TYP_444_I11_D: "Alemán",
  T_49_META_TYP_444_I12_D: "turco",
  T_49_META_TYP_444_I13_D: "hindi",
  T_49_META_TYP_444_I14_D: "japonés",
  T_49_META_TYP_444_I15_D: "rumano",
  T_49_META_TYP_444_I16_D: "árabe",
  T_49_META_TYP_444_I17_D: "birmano",
  T_49_META_TYP_444_I18_D: "Urdu",
  T_49_META_TYP_444_I19_D: "bengalí",
  T_49_META_TYP_444_I2_D: "chino tradicional",
  T_49_META_TYP_444_I3_D: "tailandés",
  T_49_META_TYP_444_I4_D: "vietnamita",
  T_49_META_TYP_444_I5_D: "indonesio",
  T_49_META_TYP_444_I6_D: "portugués",
  T_49_META_TYP_444_I7_D: "Español",
  T_49_META_TYP_444_I8_D: "ruso",
  T_49_META_TYP_444_I9_D: "coreano",
  T_49_META_TYP_51_I0_D: "Zombi normal",
  T_49_META_TYP_51_I1_D: "Zombi cortador de madera",
  T_49_META_TYP_51_I10_D: "Abeja bomba voladora",
  T_49_META_TYP_51_I11_D: "Dragón zombi",
  T_49_META_TYP_51_I2_D: "Zombi lanzador",
  T_49_META_TYP_51_I3_D: "Zombi explosivo",
  T_49_META_TYP_51_I4_D: "Zombi tirano",
  T_49_META_TYP_51_I5_D: "Zombi lanzador rojo",
  T_49_META_TYP_51_I6_D: "Señor V",
  T_49_META_TYP_51_I7_D: "Zombi tanque",
  T_49_META_TYP_51_I8_D: "Zombi taladro",
  T_49_META_TYP_51_I9_D: "Samurai",
  T_49_META_TYP_56_I10_D: "Retraso de Explosión",
  T_49_META_TYP_56_I11_D: "Rango de Explosión",
  T_49_META_TYP_56_I12_D: "Daño por Explosión",
  T_49_META_TYP_56_I13_D: "Tiempo de Quema",
  T_49_META_TYP_56_I14_D: "Daño por Quema",
  T_49_META_TYP_56_I15_D: "Intervalo de Daño por Quema",
  T_49_META_TYP_56_I17_D: "Conductor de vehículo",
  T_49_META_TYP_56_I18_D: "Todos los pasajeros a bordo",
  T_49_META_TYP_56_I19_D: "ID de Skin del Vehículo",
  T_49_META_TYP_56_I20_D: "Prioridad de Configuración del Jugador",
  T_49_META_TYP_56_I21_D: "HP Máximo",
  T_49_META_TYP_56_I22_D: "HP",
  T_49_META_TYP_57_I0_D: "Si transferir manualmente o automáticamente (manual por defecto)",
  T_49_META_TYP_58_I0_D: "Tipo de BUFF generado",
  T_49_META_TYP_58_I1_D: "El tiempo desde que se recoge un BUFF hasta que se genera el siguiente BUFF, en segundos",
  T_49_META_TYP_59_I0_D: "Tipo de Movimiento",
  T_49_META_TYP_59_I1_D: "Valor de Movimiento X",
  T_49_META_TYP_59_I2_D: "Valor de Movimiento Y",
  T_49_META_TYP_59_I3_D: "Valor de Movimiento Z",
  T_49_META_TYP_59_I4_D: "Duración del Movimiento",
  T_49_META_TYP_59_I5_D: "Duración de Detención",
  T_49_META_TYP_59_I6_D: "Deshabilitar Movimiento Recíproco",
  T_49_META_TYP_60_I0_D: "Puntos de armas de botín",
  T_49_META_TYP_61_I0_D: "Dinero Vinculado",
  T_49_META_TYP_61_I1_D: "Establecer el rango de disparo",
  T_49_META_TYP_61_I2_D: "Visibilidad del Modelo",
  T_49_META_TYP_62_I0_D: "Velocidad XZ",
  T_49_META_TYP_62_I1_D: "Velocidad Y",
  T_49_META_TYP_64_I0_D: "Tipo de componente musical",
  T_49_META_TYP_66_I0_D: "ID de instancia",
  T_49_META_TYP_66_I1_D: "Punto de Ruta",
  T_49_META_TYP_68_I0_D: "La salud actual de la IA",
  T_49_META_TYP_68_I1_D: "La salud máxima actual de la IA",
  T_49_META_TYP_68_I10_D: "¿La IA dejará caer equipo u objetos cuando muera?",
  T_49_META_TYP_68_I11_D: "Si la IA se encuentra actualmente en un estado invencible",
  T_49_META_TYP_68_I12_D: "Al recibir daño, el porcentaje de daño se puede reducir o aumentar.",
  T_49_META_TYP_68_I13_D: "Tipos de IA",
  T_49_META_TYP_68_I14_D: "si reclamar o no automáticamente al enemigo",
  T_49_META_TYP_68_I15_D: "0 significa ataque automático, 1 significa ataque defensivo, 2 significa ningún ataque en absoluto",
  T_49_META_TYP_68_I16_D: "ID de Ruta",
  T_49_META_TYP_68_I17_D: "Objetivo de Persecución",
  T_49_META_TYP_68_I18_D: "Objetivo de Ataque",
  T_49_META_TYP_68_I19_D: "Coordenadas del punto de aparición de la IA",
  T_49_META_TYP_68_I2_D: "Obtener la entidad del equipo al que pertenece la IA",
  T_49_META_TYP_68_I20_D: "Número de facción del equipo",
  T_49_META_TYP_68_I4_D: "Solo se puede modificar el poder de ataque de los ataques normales, y no se cuenta el poder de ataque de las habilidades.",
  T_49_META_TYP_68_I7_D: "El rango de movimiento libre de la IA. Solo se puede modificar el valor básico. Si hay una bonificación adicional, se añadirá según el valor.",
  T_49_META_TYP_68_I8_D: "La IA detecta el alcance del enemigo y solo puede modificar el valor básico. Si hay una bonificación adicional, se añadirá según el valor.",
  T_49_META_TYP_68_I9_D: "La velocidad de movimiento real. Si hay una aceleración de habilidad, se multiplicará por ella.",
  T_49_META_TYP_70_I0_D: "El ID de entidad de destino de la fórmula, utilizado internamente y no visible para el jugador.",
  T_49_META_TYP_70_I1_D: "El ID del atributo de entidad de destino de la fórmula, utilizado internamente y no visible para el jugador.",
  T_49_META_TYP_70_I2_D: "El valor mínimo permitido",
  T_49_META_TYP_70_I3_D: "El valor máximo permitido",
  T_49_META_TYP_70_I4_D: "Coeficiente Base",
  T_49_META_TYP_70_I5_D: "Pre-acumulador",
  T_49_META_TYP_70_I6_D: "Multiplicador",
  T_49_META_TYP_70_I7_D: "Multiplicar y Acumular",
  T_49_META_TYP_70_I8_D: "Post-acumulador",
  T_49_META_TYP_71_I0_D: "Número de producto",
  T_49_META_TYP_71_I1_D: "Precio",
  T_49_META_TYP_71_I10_D: "Artículos de la Tienda",
  T_49_META_TYP_71_I2_D: "Tipo de Moneda",
  T_49_META_TYP_71_I3_D: "Límite de compra total",
  T_49_META_TYP_71_I4_D: "Restricciones generales de compra actuales",
  T_49_META_TYP_71_I5_D: "Nombre del producto",
  T_49_META_TYP_71_I6_D: "Descripción del Producto",
  T_49_META_TYP_71_I7_D: "Lista de artículos del producto",
  T_49_META_TYP_71_I8_D: "Comprable",
  T_49_META_TYP_71_I9_D: "Ruta de recursos, vacía por defecto",
  T_49_META_TYP_72_I1_D: "Estantes",
  T_49_META_TYP_73_I1_D: "Desactivar Cierre Manual",
  T_49_META_TYP_74_I0_D: "Arma",
  T_49_META_TYP_74_I1_D: "Casco",
  T_49_META_TYP_74_I2_D: "Chaleco",
  T_49_META_TYP_74_I3_D: "Granada",
  T_49_META_TYP_75_I0_D: "Unidireccional",
  T_49_META_TYP_75_I1_D: "Ida y vuelta",
  T_49_META_TYP_76_I0_D: "Solo patrulla, no ataques objetivos en el camino.",
  T_49_META_TYP_76_I1_D: "Patrulla y ataque",
  T_49_META_TYP_79_I0_D: "Poder de ataque de armas",
  T_49_META_TYP_79_I1_D: "Rango de Ataque",
  T_49_META_TYP_79_I10_D: "Conteo de Inicio de Dispersión de Balas",
  T_49_META_TYP_79_I11_D: "ID del Objeto",
  T_49_META_TYP_79_I12_D: "Tiempo mínimo de espera entre dos disparos, en segundos. Cada disparo puede disparar varias balas, según el tipo de disparo.",
  T_49_META_TYP_79_I13_D: "Jugadores que poseen esta arma",
  T_49_META_TYP_79_I14_D: "Konsumo de Munición",
  T_49_META_TYP_79_I15_D: "Tipo de doble empuñadura (0: sin doble empuñadura, 1: propia, 2: cualquier arma)",
  T_49_META_TYP_79_I16_D: "Coeficiente de daño de armadura",
  T_49_META_TYP_79_I17_D: "Velocidad de movimiento del jugador",
  T_49_META_TYP_79_I18_D: "Relación de daño por impacto en el torso",
  T_49_META_TYP_79_I19_D: "Relación de daño por disparos a la cabeza",
  T_49_META_TYP_79_I2_D: "El tiempo mínimo de espera entre dos balas, en segundos.",
  T_49_META_TYP_79_I20_D: "Relación de daños en las extremidades",
  T_49_META_TYP_79_I21_D: "Relación de daño adicional (automóvil, pared de hielo del barril de petróleo)",
  T_49_META_TYP_79_I22_D: "Visible en la Espalda",
  T_49_META_TYP_79_I23_D: "Golpea el suelo para causar daño adicional",
  T_49_META_TYP_79_I24_D: "Munición por Disparo",
  T_49_META_TYP_79_I25_D: "Velocidad de recarga (velocidad base * coeficiente)",
  T_49_META_TYP_79_I26_D: "Conteo actual de municiones",
  T_49_META_TYP_79_I27_D: "Identificación del diseño de la pistola",
  T_49_META_TYP_79_I28_D: "Cuando se prioriza la configuración del jugador, la configuración del diseño del arma del jugador anulará los atributos del diseño del arma.",
  T_49_META_TYP_79_I29_D: "Al escribir las propiedades de un diseño de arma en un arma, el valor básico del arma se verá afectado por el diseño del arma.",
  T_49_META_TYP_79_I3_D: "Tamaño del Cargador de Municiones",
  T_49_META_TYP_79_I30_D: "Tasa de aumento de propagación (0,1 = cada ráfaga adicional de disparos aumenta la mira en un 10 %)",
  T_49_META_TYP_79_I31_D: "Velocidad de recuperación de la dispersión",
  T_49_META_TYP_79_I32_D: "La velocidad del jugador al disparar afecta",
  T_49_META_TYP_79_I33_D: "Tamaño de dispersión al moverse (1,5 = 1,5 * tamaño de la mira base)",
  T_49_META_TYP_79_I34_D: "Tipo de Arma",
  T_49_META_TYP_79_I36_D: "Tipo de Tipo de Fuego",
  T_49_META_TYP_79_I37_D: "Disparo Único",
  T_49_META_TYP_79_I38_D: "Silenciado",
  T_49_META_TYP_79_I39_D: "Tasa de Velocidad de Movimiento al Apuntar",
  T_49_META_TYP_79_I4_D: "Contador Inicial de Cargadores",
  T_49_META_TYP_79_I5_D: "Penetración de Armadura",
  T_49_META_TYP_79_I6_D: "Distancia de Daño Completo",
  T_49_META_TYP_79_I7_D: "Distancia Mínima de Daño",
  T_49_META_TYP_79_I8_D: "Daño Mínimo",
  T_49_META_TYP_79_I9_D: "La cantidad de balas que se pueden disparar antes de que comience la dispersión.",
  T_49_META_TYP_80_I1_D: "Cuando es verdadero, el cierre manual está prohibido",
  T_49_META_TYP_80_I2_D: "Entidad de tienda vinculada",
  T_49_META_TYP_80_I4_D: "ID de Billetera Vinculada",
  T_49_META_TYP_80_I5_D: "Tipo de Solicitud",
  T_49_META_TYP_80_I6_D: "El tipo de objetivo solicitado por el jugador de la IU actual",
  T_49_META_TYP_80_I7_D: "ID del Jugador Desencadenante",
  T_49_META_TYP_81_I0_D: "Buff aleatorio",
  T_49_META_TYP_81_I1_D: "Buff HP",
  T_49_META_TYP_81_I2_D: "Buff Bala",
  T_49_META_TYP_81_I3_D: "Buff Armadura",
  T_49_META_TYP_82_I1_D: "Icono de botón",
  T_49_META_TYP_82_I3_D: "Posición relativa al punto de anclaje",
  T_49_META_TYP_83_I1_D: "Dinero",
  T_49_META_TYP_83_I2_D: "Pasando parámetros",
  T_49_META_TYP_86_I0_D: "Mínimo",
  T_49_META_TYP_86_I1_D: "Máximo",
  T_49_META_TYP_86_I2_D: "Coeficiente base, multiplicado por el valor original antes de todos los cálculos",
  T_49_META_TYP_86_I3_D: "Preacumulador, acumula antes de la multiplicación y participa en el cálculo de la multiplicación.",
  T_49_META_TYP_86_I4_D: "Multiplicador continuo, multiplicación continua, por ejemplo (reducir al 90%, fortalecer al 110%) el efecto es Valor*90%*110%",
  T_49_META_TYP_86_I5_D: "El acumulador de multiplicación, por ejemplo (sumar 10%, sumar 5%) tiene el efecto de Valor*(1+10%+5%)",
  T_49_META_TYP_86_I6_D: "Post-acumulador, no participa en el cálculo de la multiplicación y se suma al final.",
  T_49_META_TYP_88_I0_D: "Tipo básico, la moneda del juego más básica, el tipo de precio de los productos generales en la versión actual",
  T_49_META_TYP_89_I0_D: "Actualmente, solo hay moneda base en la versión",
  T_49_META_TYP_89_I1_D: "Importe de la divisa",
  T_49_META_TYP_89_I2_D: "Iconos de moneda",
  T_49_META_TYP_89_I3_D: "Color del icono de moneda",
  T_49_META_TYP_90_I0_D: "El contenido de la billetera es un montón de monedas.",
  T_49_META_TYP_92_I0_D: "Caja de Madera Cuadrada",
  T_49_META_TYP_92_I1_D: "Caja de Madera Larga",
  T_49_META_TYP_92_I10_D: "Torre de Vigilancia",
  T_49_META_TYP_92_I100_D: "Escalera",
  T_49_META_TYP_92_I101_D: "Escalón B",
  T_49_META_TYP_92_I102_D: "Escalón A",
  T_49_META_TYP_92_I103_D: "Cabina telefónica",
  T_49_META_TYP_92_I104_D: "Pared temática BIS",
  T_49_META_TYP_92_I105_D: "Jardín de flores temático BIS",
  T_49_META_TYP_92_I106_D: "Máquina expendedora",
  T_49_META_TYP_92_I107_D: "Entidad Monstruosa",
  T_49_META_TYP_92_I108_D: "Generador de unidades",
  T_49_META_TYP_92_I109_D: "Coche Deportivo",
  T_49_META_TYP_92_I11_D: "Casa de Guardia",
  T_49_META_TYP_92_I110_D: "Tuk Tuk",
  T_49_META_TYP_92_I111_D: "Caja de madera destructible",
  T_49_META_TYP_92_I112_D: "SUV",
  T_49_META_TYP_92_I113_D: "Motocicleta",
  T_49_META_TYP_92_I114_D: "Camiones monstruo",
  T_49_META_TYP_92_I115_D: "Generador de oro",
  T_49_META_TYP_92_I116_D: "Escalón C",
  T_49_META_TYP_92_I117_D: "Señal",
  T_49_META_TYP_92_I118_D: "Cercado",
  T_49_META_TYP_92_I119_D: "Máquina de camisetas",
  T_49_META_TYP_92_I12_D: "Casa de Dos",
  T_49_META_TYP_92_I121_D: "Pilar de concreto",
  T_49_META_TYP_92_I122_D: "Caja de Botín de Fútbol",
  T_49_META_TYP_92_I123_D: "Barril de Aceite",
  T_49_META_TYP_92_I124_D: "Área de Baja Gravedad",
  T_49_META_TYP_92_I125_D: "Arma",
  T_49_META_TYP_92_I126_D: "Cercado B",
  T_49_META_TYP_92_I127_D: "Casa pequeña A",
  T_49_META_TYP_92_I128_D: "Camión dañado",
  T_49_META_TYP_92_I129_D: "Esfera Básica",
  T_49_META_TYP_92_I13_D: "Escultura de Arena",
  T_49_META_TYP_92_I130_D: "Cono básico",
  T_49_META_TYP_92_I131_D: "Cilindro básico",
  T_49_META_TYP_92_I132_D: "Generador de consumibles",
  T_49_META_TYP_92_I133_D: "Cuerpo de agua personalizado",
  T_49_META_TYP_92_I134_D: "Flecha",
  T_49_META_TYP_92_I135_D: "Bloque teñido",
  T_49_META_TYP_92_I136_D: "Tambor teñido",
  T_49_META_TYP_92_I137_D: "Texto",
  T_49_META_TYP_92_I138_D: "Icono",
  T_49_META_TYP_92_I139_D: "Muñeca de hielo",
  T_49_META_TYP_92_I14_D: "Fuente",
  T_49_META_TYP_92_I140_D: "Activador de Cápsula",
  T_49_META_TYP_92_I141_D: "Disparador de colisión esférica",
  T_49_META_TYP_92_I142_D: "Bloque básico de color sólido reflectante 1",
  T_49_META_TYP_92_I143_D: "Fabricante de autos de choque",
  T_49_META_TYP_92_I144_D: "Bloque de parque de diversiones a cuadros",
  T_49_META_TYP_92_I145_D: "Pantalla grande",
  T_49_META_TYP_92_I146_D: "Podio",
  T_49_META_TYP_92_I147_D: "Paleta gigante",
  T_49_META_TYP_92_I148_D: "Camión de comida B",
  T_49_META_TYP_92_I15_D: "Cerezo",
  T_49_META_TYP_92_I16_D: "Casa de una planta",
  T_49_META_TYP_92_I17_D: "Casa de tres plantas",
  T_49_META_TYP_92_I18_D: "Árbol de Plátano",
  T_49_META_TYP_92_I19_D: "Inodoro",
  T_49_META_TYP_92_I2_D: "Caja de Madera Larga Cubierta de Arbustos",
  T_49_META_TYP_92_I20_D: "Cerca",
  T_49_META_TYP_92_I21_D: "Contenedor Destructible",
  T_49_META_TYP_92_I22_D: "Cercado Destructible",
  T_49_META_TYP_92_I23_D: "Neumático",
  T_49_META_TYP_92_I24_D: "Coche Chocón",
  T_49_META_TYP_92_I25_D: "Vehículo Anfibio",
  T_49_META_TYP_92_I26_D: "Jeep",
  T_49_META_TYP_92_I27_D: "Cubo de Basura",
  T_49_META_TYP_92_I28_D: "Tienda Médica",
  T_49_META_TYP_92_I29_D: "Garaje",
  T_49_META_TYP_92_I3_D: "Montón de Heno",
  T_49_META_TYP_92_I30_D: "Pared Pintada",
  T_49_META_TYP_92_I31_D: "Torii",
  T_49_META_TYP_92_I32_D: "Plataforma de Hierro",
  T_49_META_TYP_92_I33_D: "Casa Contenedor",
  T_49_META_TYP_92_I34_D: "Remolque",
  T_49_META_TYP_92_I35_D: "Pared A",
  T_49_META_TYP_92_I36_D: "Notas Musicales - Piano",
  T_49_META_TYP_92_I37_D: "Notas Musicales - Piano",
  T_49_META_TYP_92_I38_D: "Notas Musicales - Batería",
  T_49_META_TYP_92_I39_D: "Notas Musicales - Batería",
  T_49_META_TYP_92_I4_D: "Coche Destrozado",
  T_49_META_TYP_92_I40_D: "Notas Musicales - Sintetizador A",
  T_49_META_TYP_92_I41_D: "Notas Musicales - Sintetizador A",
  T_49_META_TYP_92_I42_D: "Notas Musicales - Sintetizador B",
  T_49_META_TYP_92_I43_D: "Notas Musicales - Sintetizador B",
  T_49_META_TYP_92_I44_D: "Notas Musicales - Sintetizador C",
  T_49_META_TYP_92_I45_D: "Notas Musicales - Sintetizador C",
  T_49_META_TYP_92_I46_D: "Generador de Buff",
  T_49_META_TYP_92_I47_D: "Mecanismo de hélice",
  T_49_META_TYP_92_I48_D: "Mecanismo de sartén",
  T_49_META_TYP_92_I49_D: "Trampa de bloqueo",
  T_49_META_TYP_92_I5_D: "Autobús Destrozado",
  T_49_META_TYP_92_I50_D: "Mecanismo de anillo",
  T_49_META_TYP_92_I51_D: "Trampa de martillo gigante",
  T_49_META_TYP_92_I52_D: "Tablero móvil",
  T_49_META_TYP_92_I53_D: "Objetivo móvil",
  T_49_META_TYP_92_I54_D: "Pared telescópica",
  T_49_META_TYP_92_I55_D: "Componentes de armas de puntos de botín",
  T_49_META_TYP_92_I56_D: "Componente de bala de punto de botín",
  T_49_META_TYP_92_I57_D: "Componentes de artículos consumibles de puntos de botín",
  T_49_META_TYP_92_I58_D: "Componente de objeto de lanzamiento de puntos de botín",
  T_49_META_TYP_92_I59_D: "Componente de zoom de puntos de botín",
  T_49_META_TYP_92_I6_D: "Contenedor A",
  T_49_META_TYP_92_I60_D: "Componentes de armadura de puntos de botín",
  T_49_META_TYP_92_I61_D: "Tubería I",
  T_49_META_TYP_92_I62_D: "Tubería T",
  T_49_META_TYP_92_I63_D: "Tubería Cruzada",
  T_49_META_TYP_92_I64_D: "Tubería de Codo",
  T_49_META_TYP_92_I65_D: "Grupo de Setas Gigantes",
  T_49_META_TYP_92_I66_D: "Estante para Secar",
  T_49_META_TYP_92_I67_D: "Puente de Madera",
  T_49_META_TYP_92_I68_D: "Pantalla",
  T_49_META_TYP_92_I69_D: "Columna de Concreto",
  T_49_META_TYP_92_I7_D: "Contenedor B",
  T_49_META_TYP_92_I70_D: "Cactus",
  T_49_META_TYP_92_I71_D: "Madera Muerta",
  T_49_META_TYP_92_I72_D: "Lámpara de Palacio",
  T_49_META_TYP_92_I73_D: "Farola",
  T_49_META_TYP_92_I74_D: "Panel Solar",
  T_49_META_TYP_92_I75_D: "Aire acondicionado",
  T_49_META_TYP_92_I76_D: "Cuadrado",
  T_49_META_TYP_92_I77_D: "Pendiente",
  T_49_META_TYP_92_I78_D: "Camión de comida",
  T_49_META_TYP_92_I79_D: "Disparador de muerte o invulnerabilidad",
  T_49_META_TYP_92_I8_D: "Contenedor C",
  T_49_META_TYP_92_I80_D: "Punto de control",
  T_49_META_TYP_92_I81_D: "Posición final",
  T_49_META_TYP_92_I82_D: "Dados",
  T_49_META_TYP_92_I83_D: "Banco",
  T_49_META_TYP_92_I84_D: "Estación de autobús",
  T_49_META_TYP_92_I85_D: "Casa para perros",
  T_49_META_TYP_92_I86_D: "Cartelera",
  T_49_META_TYP_92_I87_D: "Jarra de agua",
  T_49_META_TYP_92_I88_D: "Muro de grafiti",
  T_49_META_TYP_92_I89_D: "Cabaña de paja",
  T_49_META_TYP_92_I9_D: "Cabaña",
  T_49_META_TYP_92_I90_D: "Puente de arco de piedra",
  T_49_META_TYP_92_I91_D: "Conjunto de patio con sombrilla",
  T_49_META_TYP_92_I92_D: "Bandera de llegada",
  T_49_META_TYP_92_I93_D: "Fortaleza",
  T_49_META_TYP_92_I94_D: "Punto de aparición del monstruo",
  T_49_META_TYP_92_I95_D: "Marca",
  T_49_META_TYP_92_I97_D: "Activador personalizado",
  T_49_META_TYP_92_I98_D: "Puerta doble",
  T_49_META_TYP_92_I99_D: "Barricada",
  T_49_META_TYP_94_I0_D: "Añadir",
  T_49_META_TYP_94_I1_D: "Multiplicar",
  T_49_META_TYP_95_I0_D: "Tipo de Moneda",
  T_49_META_TYP_95_I1_D: "Importe de la divisa",
  T_49_META_TYP_96_I0_D: "Obtener Billetera",
  T_49_META_TYP_96_I1_D: "Posición de visualización (el punto de anclaje es la esquina superior derecha)",
  T_49_META_TYP_97_I0_D: "Posición en coordenadas mundiales",
  T_49_META_TYP_97_I1_D: "El ángulo de rotación en el sistema de coordenadas mundial, los componentes XYZ son el ángulo de cabeceo, el ángulo de guiñada y el ángulo de balanceo, y el orden de rotación es YXZ.",
  T_49_META_TYP_97_I10_D: "La dirección del eje de coordenadas local x",
  T_49_META_TYP_97_I11_D: "La dirección del eje de coordenadas local z",
  T_49_META_TYP_97_I2_D: "Escalado en coordenadas mundiales",
  T_49_META_TYP_97_I3_D: "El nodo padre de este nodo",
  T_49_META_TYP_97_I4_D: "Rotación en coordenadas mundiales, expresada como cuaterniones",
  T_49_META_TYP_97_I5_D: "Posición en el sistema de coordenadas local",
  T_49_META_TYP_97_I6_D: "Rotación en el sistema de coordenadas local, expresada como un cuaternión",
  T_49_META_TYP_97_I7_D: "El ángulo de rotación en el sistema de coordenadas local, los componentes XYZ son el ángulo de cabeceo, el ángulo de guiñada y el ángulo de balanceo, y el orden de rotación es YXZ.",
  T_49_META_TYP_97_I8_D: "Escala de tamaño en el sistema de coordenadas local",
  T_49_META_TYP_97_I9_D: "La dirección del eje de coordenadas local y",
  T_49_META_TYP_99_I0_D: "Radio de fútbol",
  T_49_META_TYP_99_I1_D: "Coeficiente de fricción en condiciones normales",
  T_49_META_TYP_99_I2_D: "Coeficiente de fricción bajo impacto",
  T_49_META_TYP_99_I3_D: "Ángulo Mínimo de Disparo",
  T_49_META_TYP_99_I4_D: "Ángulo de Elevación Mínimo",
  T_49_META_TYP_99_I5_D: "Tiempo de Reinicio",
  T_49_META_TYP_99_I6_D: "Ángulo Máximo de Disparo",
  T_49_META_TYP_99_I7_D: "Posición de Reinicio",
  T_49_META_TYPE_0_D: "Objeto, la raíz de la jerarquía de tipos",
  T_49_META_TYPE_1_D: "La lista es un contenedor para un conjunto de datos.",
  T_49_META_TYPE_10_D: "Componente base de la entidad, todos los componentes combinarán este componente",
  T_49_META_TYPE_100_D: "Máquina de Camisetas",
  T_49_META_TYPE_101_D: "Objeto de Morfosis",
  T_49_META_TYPE_1010_D: "Información del Temporizador",
  T_49_META_TYPE_1011_D: "Banner de Apertura",
  T_49_META_TYPE_1012_D: "La entidad del banner al inicio de la ronda de los dos equipos. Modificar las propiedades de la entidad afectará el contenido mostrado en la interfaz de usuario correspondiente.",
  T_49_META_TYPE_1013_D: "Generalmente, la entidad del banner al inicio de la ronda, modificar las propiedades de la entidad afectará el contenido que se muestra en la IU correspondiente.",
  T_49_META_TYPE_1014_D: "Banner de puntuación de ronda de equipo. La modificación de los atributos de la entidad afectará el contenido mostrado en la interfaz de usuario correspondiente.",
  T_49_META_TYPE_1015_D: "Entidad del Administrador de Puntos de Control. La modificación de los atributos de la entidad afectará el contenido mostrado en la interfaz de usuario correspondiente.",
  T_49_META_TYPE_1016_D: "La entidad se muestra al final de la ronda. Modificar los atributos de la entidad afectará el contenido mostrado en la interfaz de usuario correspondiente.",
  T_49_META_TYPE_1017_D: "Si hay dos equipos al inicio, muestra la pancarta de dos equipos luchando entre sí.",
  T_49_META_TYPE_1018_D: "El marcador de ambos equipos",
  T_49_META_TYPE_1019_D: "Resultado final: ganar, perder, empatar",
  T_49_META_TYPE_102_D: "Tipo de fuente de resurrección: Muerte, Caída",
  T_49_META_TYPE_1020_D: "Entidad de número de giro, la modificación de los atributos de la entidad afectará el contenido que se muestra en la interfaz de usuario correspondiente.",
  T_49_META_TYPE_1021_D: "Entidad de cuenta regresiva de fase. La modificación de los atributos de la entidad afectará el contenido mostrado en la interfaz de usuario correspondiente.",
  T_49_META_TYPE_1022_D: "Entidad de subtítulo de información del juego. Modificar los atributos de la entidad afectará el contenido mostrado en la interfaz de usuario correspondiente.",
  T_49_META_TYPE_1023_D: "Entidades de información de juego de dos equipos. La modificación de los atributos de la entidad afectará el contenido mostrado en la interfaz de usuario correspondiente.",
  T_49_META_TYPE_1024_D: "Entidad de la interfaz de usuario con información del partido. Modificar los atributos de la entidad afectará el contenido mostrado en la interfaz de usuario correspondiente.",
  T_49_META_TYPE_1027_D: "Describe el tipo de un tipo, que se devuelve cuando se utiliza Typeof",
  T_49_META_TYPE_1028_D: "Entidad de información de facción. La modificación de los atributos de la entidad afectará el contenido mostrado en la interfaz de usuario correspondiente.",
  T_49_META_TYPE_1029_D: "El icono solicita información de la entidad; la modificación de los atributos de la entidad afectará el contenido que se muestra en la interfaz de usuario correspondiente.",
  T_49_META_TYPE_103_D: "Enumeración de tipos de ranuras de elementos",
  T_49_META_TYPE_1030_D: "Una entidad simplificada con la información del partido de ambos equipos. La modificación de los atributos de la entidad afectará el contenido mostrado en la interfaz de usuario correspondiente.",
  T_49_META_TYPE_1031_D: "Entidad de interfaz de solicitud de tiempo: la modificación de los atributos de la entidad afectará el contenido que se muestra en la interfaz de usuario correspondiente.",
  T_49_META_TYPE_1032_D: "El texto flotante indica la entidad. Modificar los atributos de la entidad afectará el contenido mostrado en la interfaz de usuario correspondiente.",
  T_49_META_TYPE_1033_D: "La entidad de cambio de turno incluye la información sobre el asentamiento del turno actual y el inicio del siguiente. La modificación de los atributos de la entidad afectará el contenido mostrado en la interfaz de usuario correspondiente.",
  T_49_META_TYPE_1035_D: "Abra la entidad de interfaz de usuario del botón del marcador. Modificar los atributos de la entidad afectará el contenido mostrado en la interfaz de usuario correspondiente.",
  T_49_META_TYPE_1036_D: "Modo de infección, interfaz de usuario que muestra el nivel actual del zombi",
  T_49_META_TYPE_1037_D: "Agregue una entidad de IU con efecto dinámico de puntos. Modificar los atributos de la entidad afectará el contenido mostrado en la IU correspondiente.",
  T_49_META_TYPE_1038_D: "Efectos de la interfaz de usuario del modo infección zombi",
  T_49_META_TYPE_1039_D: "La entidad de solicitud de texto flotante de cuenta regresiva; modificar los atributos de la entidad afectará el contenido que se muestra en la interfaz de usuario correspondiente.",
  T_49_META_TYPE_104_D: "Estilo de Camiseta",
  T_49_META_TYPE_1040_D: "Componente de Interfaz de Usuario de Selección de Carta",
  T_49_META_TYPE_1041_D: "Componente de Interfaz de Usuario de Notificación de Identidad",
  T_49_META_TYPE_1042_D: "Componente de Interfaz de Usuario de Cuenta Regresiva de 5 Segundos",
  T_49_META_TYPE_1043_D: "Componente de Interfaz de Usuario de Banner de Título",
  T_49_META_TYPE_1044_D: "Interruptor Incorporado de Interfaz de Usuario",
  T_49_META_TYPE_1045_D: "Botón de Interfaz de Usuario de Habilidad",
  T_49_META_TYPE_105_D: "Gol de fútbol",
  T_49_META_TYPE_106_D: "Tipo de asistencia de puntería",
  T_49_META_TYPE_107_D: "Se puede apuntar y golpear, pero no necesariamente recibirá daño.",
  T_49_META_TYPE_108_D: "Tipo entero, entero con signo de 64 bits",
  T_49_META_TYPE_109_D: "La entidad del canal de chat es un contenedor que contiene su propio ID de canal y jugadores.",
  T_49_META_TYPE_11_D: "Entidad global, única en todo el juego.",
  T_49_META_TYPE_110_D: "Canal de voz inactivo",
  T_49_META_TYPE_111_D: "Tipo de comportamiento",
  T_49_META_TYPE_112_D: "Tipo de Estado de Comportamiento del Jugador",
  T_49_META_TYPE_113_D: "Música de Tambor",
  T_49_META_TYPE_114_D: "Música Lead1",
  T_49_META_TYPE_115_D: "Música Lead2",
  T_49_META_TYPE_116_D: "Música Lead3",
  T_49_META_TYPE_117_D: "Tipo de componente de música de batería",
  T_49_META_TYPE_118_D: "Facción",
  T_49_META_TYPE_119_D: "Opciones de ataque",
  T_49_META_TYPE_12_D: "Una entidad de combate que puede atacar, ser atacada, matar, etc.",
  T_49_META_TYPE_120_D: "Componente de Interfaz de Usuario de Barra de Progreso",
  T_49_META_TYPE_121_D: "Cada intervalo de tiempo de onda",
  T_49_META_TYPE_122_D: "Skybox",
  T_49_META_TYPE_123_D: "Enumeración de tipos base de Skybox",
  T_49_META_TYPE_124_D: "Rango de búsqueda",
  T_49_META_TYPE_125_D: "Puede modificar la apariencia básica de los objetos, como las texturas y la transparencia.",
  T_49_META_TYPE_126_D: "Barra de Salud",
  T_49_META_TYPE_127_D: "Cómo mover objetos",
  T_49_META_TYPE_128_D: "Objeto Morfable",
  T_49_META_TYPE_129_D: "Tipo de Munición de Botín",
  T_49_META_TYPE_13_D: "Entidad de control de la interfaz de usuario",
  T_49_META_TYPE_130_D: "Tipo de Consumible de Botín",
  T_49_META_TYPE_131_D: "Tipo de Armadura de Botín",
  T_49_META_TYPE_132_D: "Tipo de Lanzable de Botín",
  T_49_META_TYPE_133_D: "Tipo de Visor de Botín",
  T_49_META_TYPE_134_D: "Tipo de Arma de Botín",
  T_49_META_TYPE_135_D: "Hará que caiga el tipo de munición seleccionado.",
  T_49_META_TYPE_136_D: "Producirá el tipo de caída de accesorios seleccionado",
  T_49_META_TYPE_137_D: "Hará que caiga un proyectil del tipo seleccionado.",
  T_49_META_TYPE_138_D: "Hará que se elimine un alcance del tipo seleccionado",
  T_49_META_TYPE_139_D: "Hará que la armadura del tipo seleccionado caiga",
  T_49_META_TYPE_14_D: "Entidades de jugador en el juego, una por usuario",
  T_49_META_TYPE_140_D: "Ola",
  T_49_META_TYPE_141_D: "Tipo de Tipo de Botín de Fútbol",
  T_49_META_TYPE_142_D: "Caja de Botín de Fútbol",
  T_49_META_TYPE_143_D: "Tipo de componente musical Lead1",
  T_49_META_TYPE_144_D: "Tipo de componente musical Lead2",
  T_49_META_TYPE_145_D: "Tipo de componente musical Lead3",
  T_49_META_TYPE_146_D: "Tipo de componente musical de teclado",
  T_49_META_TYPE_147_D: "Proporciona una variedad de tipos de cámaras preestablecidas, así como tipos de cámaras personalizados.",
  T_49_META_TYPE_148_D: "Componentes de la cámara",
  T_49_META_TYPE_149_D: "Key de localización",
  T_49_META_TYPE_15_D: "Las entidades del equipo en el juego, una para cada equipo.",
  T_49_META_TYPE_150_D: "Barril de Aceite",
  T_49_META_TYPE_151_D: "Un cuaternión es un vector especial de cuatro dimensiones que se utiliza únicamente para representar la rotación.",
  T_49_META_TYPE_152_D: "Área de Baja Gravedad",
  T_49_META_TYPE_153_D: "Contenedor de entidades, que generará entidades del tipo correspondiente en la ubicación",
  T_49_META_TYPE_154_D: "Tipo de Arma de Doble Empuñadura",
  T_49_META_TYPE_155_D: "Entidad de casco",
  T_49_META_TYPE_156_D: "Entidad de armadura corporal",
  T_49_META_TYPE_157_D: "Tipo de Tipo de Transição de Câmera",
  T_49_META_TYPE_158_D: "Interfaz de solicitud de texto",
  T_49_META_TYPE_159_D: "Vector2",
  T_49_META_TYPE_16_D: "Entidad de objeto de nivel",
  T_49_META_TYPE_160_D: "Tipo de mapa",
  T_49_META_TYPE_161_D: "VFX de Textura No Reemplazable",
  T_49_META_TYPE_162_D: "Lista de tipo",
  T_49_META_TYPE_163_D: "Tipo o lista de tipo",
  T_49_META_TYPE_164_D: "El componente es la clase base de todos los componentes de entidad o clases de componentes específicos",
  T_49_META_TYPE_165_D: "Componente de la caja de colisión",
  T_49_META_TYPE_166_D: "Ser emocionado",
  T_49_META_TYPE_167_D: "La entidad de efecto especial representa un efecto especial mostrado (eliminado, reciclable y reutilizable)",
  T_49_META_TYPE_17_D: "Lista de Objetos de Nivel",
  T_49_META_TYPE_170_D: "Indica si se puede configurar la visibilidad",
  T_49_META_TYPE_171_D: "Hongo",
  T_49_META_TYPE_172_D: "Munición",
  T_49_META_TYPE_173_D: "Mochila",
  T_49_META_TYPE_174_D: "Componentes de la granada",
  T_49_META_TYPE_175_D: "Granada Congelante",
  T_49_META_TYPE_176_D: "Generador de Armas",
  T_49_META_TYPE_177_D: "Cuando hay una obstrucción entre la cámara y el objeto que se está siguiendo, el modo de movimiento de la cámara",
  T_49_META_TYPE_178_D: "Cómo la cámara renderiza la imagen",
  T_49_META_TYPE_179_D: "Esfera Básica",
  T_49_META_TYPE_18_D: "(Obsoleto, no utilizar)",
  T_49_META_TYPE_180_D: "Se refiere a una propiedad de un componente",
  T_49_META_TYPE_181_D: "Se utiliza para describir el tipo de activo de malla.",
  T_49_META_TYPE_182_D: "Se utiliza para describir el tipo de activo material.",
  T_49_META_TYPE_183_D: "Se utiliza para describir el tipo de activo de textura.",
  T_49_META_TYPE_184_D: "Un componente de renderizado de puente para renderizar utilizando recursos de modelo integrados",
  T_49_META_TYPE_185_D: "Componente de renderizado personalizado para renderizar con recursos de modelo personalizados",
  T_49_META_TYPE_186_D: "Un componente de objeto en blanco que se puede utilizar con componentes de renderizador, componentes de colisionador, etc.",
  T_49_META_TYPE_187_D: "Contenedor",
  T_49_META_TYPE_188_D: "Cilindro o Cono Básico",
  T_49_META_TYPE_189_D: "Lista de cadenas localizadas",
  T_49_META_TYPE_19_D: "Plantilla de lista, puede especificar el tipo de contenido a través de T",
  T_49_META_TYPE_190_D: "Panel de Puntuación de Dos Equipos",
  T_49_META_TYPE_191_D: "Un arma arrojadiza táctica que puede cegar temporalmente a los enemigos dentro de un rango determinado.",
  T_49_META_TYPE_192_D: "Después de su uso, puede producir humo que oculta el evento, lo que constituye un arma poderosa para interrumpir el ataque del enemigo.",
  T_49_META_TYPE_193_D: "Panel de Resultados de Múltiples Equipos",
  T_49_META_TYPE_194_D: "Las minas de inducción se pueden colocar en el suelo. Explotarán cuando el enemigo se acerque. Ten cuidado de no pisarlas.",
  T_49_META_TYPE_195_D: "Cómo se reproduce el movimiento interpolado",
  T_49_META_TYPE_197_D: "Componentes jugables",
  T_49_META_TYPE_198_D: "Base de Ítem",
  T_49_META_TYPE_199_D: "Equipo auxiliar para el combate aéreo, pero hay que prestar atención al consumo energético en todo momento.",
  T_49_META_TYPE_2_D: "Tipo booleano, utilizado para representar verdadero, falso o sí o no.",
  T_49_META_TYPE_20_D: "Enumeración de tipos de interfaz incorporada, que se genera automáticamente en función del sistema de tipos",
  T_49_META_TYPE_200_D: "Área de fuga de la cárcel",
  T_49_META_TYPE_201_D: "Zonas donde se puede nadar después de entrar",
  T_49_META_TYPE_202_D: "ID del Collider",
  T_49_META_TYPE_203_D: "Movimiento de interpolación",
  T_49_META_TYPE_204_D: "Zapatos equipados con un dispositivo de potencia tecnológica que permite realizar doble salto en el aire.",
  T_49_META_TYPE_205_D: "Un ala delta que puede surcar el cielo. Puede usarse para aterrizar desde gran altura y desplazarse a un lugar más lejano.",
  T_49_META_TYPE_206_D: "Patineta",
  T_49_META_TYPE_207_D: "Tirolesa",
  T_49_META_TYPE_208_D: "Lista de jugables",
  T_49_META_TYPE_209_D: "Jugable o una lista de Jugables",
  T_49_META_TYPE_21_D: "Entidad de interfaz incorporada, que encapsula la interfaz de funciones específicas",
  T_49_META_TYPE_210_D: "La animación balística es una simulación del movimiento balístico.",
  T_49_META_TYPE_211_D: "Sistema de Coordenadas",
  T_49_META_TYPE_212_D: "Un objeto sigue a otro",
  T_49_META_TYPE_213_D: "El frente de un objeto siempre mira hacia el otro objeto.",
  T_49_META_TYPE_214_D: "El ID utilizado para describir el recurso de sprite del atlas",
  T_49_META_TYPE_215_D: "resultados de un concurso",
  T_49_META_TYPE_216_D: "Contenedor de datos del diccionario, el elemento de datos es un par de clave y valor.",
  T_49_META_TYPE_217_D: "Plantilla de datos de diccionario, el tipo de contenido se puede especificar mediante T1 y T2",
  T_49_META_TYPE_218_D: "Un tipo de fuente de luz que emite luz de igual intensidad en todas las direcciones desde su ubicación.",
  T_49_META_TYPE_219_D: "Vehículos de motocicleta",
  T_49_META_TYPE_22_D: "Interfaz personalizada, la interfaz creada por el jugador a través del editor de interfaz",
  T_49_META_TYPE_220_D: "vehículo tuk-tuk (vehículo de tres ruedas)",
  T_49_META_TYPE_221_D: "Vehículo de motocicleta anfibio/ametralladora",
  T_49_META_TYPE_222_D: "vehículo de cuatro ruedas",
  T_49_META_TYPE_224_D: "Lista de tipos de habilidades",
  T_49_META_TYPE_225_D: "La torreta de inteligencia artificial, hecha de materiales de alta tecnología, buscará y atacará activamente a los enemigos dentro de un rango determinado.",
  T_49_META_TYPE_226_D: "La torreta generada después de usar el soporte de torreta",
  T_49_META_TYPE_227_D: "Enumeración de tipos de controles de IU personalizados",
  T_49_META_TYPE_23_D: "Enumeración de tipos de objetos de nivel, que se generará automáticamente en función del sistema de tipos",
  T_49_META_TYPE_231_D: "Kit de Reparación",
  T_49_META_TYPE_233_D: "Círculo de Progreso",
  T_49_META_TYPE_234_D: "Mina Creada",
  T_49_META_TYPE_235_D: "Pared de Gel",
  T_49_META_TYPE_236_D: "Muro de Hielo Creado",
  T_49_META_TYPE_237_D: "Arma con Gancho",
  T_49_META_TYPE_238_D: "Pistola rociadora arcoíris",
  T_49_META_TYPE_239_D: "Rifle de Aerosol",
  T_49_META_TYPE_24_D: "Tipos de daños actualmente definidos por el sistema",
  T_49_META_TYPE_240_D: "La entidad es el portador de todos los componentes. Los componentes deben estar asociados a la entidad para generar instancias.",
  T_49_META_TYPE_241_D: "Potente cañón de gancho",
  T_49_META_TYPE_242_D: "Barra de Puntuación",
  T_49_META_TYPE_243_D: "Ranuras para ropa",
  T_49_META_TYPE_244_D: "Una entidad de texto representa un texto mostrado.",
  T_49_META_TYPE_245_D: "La entidad Icono representa un icono mostrado",
  T_49_META_TYPE_246_D: "Color de Aerosol",
  T_49_META_TYPE_247_D: "Tipo de Interfaz de Usuario para Jugadores",
  T_49_META_TYPE_248_D: "Entidad de conmutación de interfaz de usuario genérica",
  T_49_META_TYPE_249_D: "Cambiar Ranura de Equipos",
  T_49_META_TYPE_25_D: "Las etapas del proceso del juego, como el inicio del juego, la preparación del juego, el final del juego, etc.",
  T_49_META_TYPE_250_D: "La entidad de efecto representa un efecto mostrado",
  T_49_META_TYPE_2500_D: "El punto de aparición del jugador",
  T_49_META_TYPE_2501_D: "Los disparadores se utilizan para activar los eventos de entrada y salida de los jugadores (u otros objetos).",
  T_49_META_TYPE_2502_D: "Disparador de muerte o invencibilidad, cuando el jugador ingresa, controla si es efecto de muerte o invencibilidad según el atributo",
  T_49_META_TYPE_2503_D: "Puntos de control del modo carrera",
  T_49_META_TYPE_2504_D: "Generalmente se utiliza en el modo de carrera para identificar al jugador que ingresa a la línea de meta designada. Este es un disparador específico. Los disparadores personalizados se abrirán más adelante. Este punto final es simplemente un contenedor de",
  T_49_META_TYPE_2505_D: "La valla alrededor del punto de aparición, después de cerrarla, puedes abandonar el punto de aparición.",
  T_49_META_TYPE_2507_D: "Torre",
  T_49_META_TYPE_2508_D: "Generación de Monstruos",
  T_49_META_TYPE_2509_D: "Se pueden generar instancias del tipo correspondiente a pedido",
  T_49_META_TYPE_251_D: "Contenedor de Efectos",
  T_49_META_TYPE_2510_D: "Área de aparición del jugador (rectángulo)",
  T_49_META_TYPE_252_D: "UI de Resultado de Aerosol",
  T_49_META_TYPE_253_D: "Botón de Pista",
  T_49_META_TYPE_254_D: "Efecto de Latido del Corazón",
  T_49_META_TYPE_255_D: "Cadena de Localización de Timestamp",
  T_49_META_TYPE_256_D: "Tipo de Cuerpo rígido",
  T_49_META_TYPE_257_D: "Componente de cuerpo rígido",
  T_49_META_TYPE_258_D: "Tipo de Estilo de Formato de Marca de Tiempo",
  T_49_META_TYPE_259_D: "Consejos",
  T_49_META_TYPE_26_D: "Una ronda en el juego suele ser una ronda pequeña, que consta de varias etapas.",
  T_49_META_TYPE_260_D: "Botón de Habilidad de Progreso",
  T_49_META_TYPE_261_D: "Identificación única",
  T_49_META_TYPE_262_D: "ID del aspecto de arma",
  T_49_META_TYPE_263_D: "Identificación de la ropa",
  T_49_META_TYPE_264_D: "ID del artículo, cuando la versión solo tiene ID de arma",
  T_49_META_TYPE_265_D: "Entidad del panel de interfaz de usuario",
  T_49_META_TYPE_267_D: "Entidad de vista de desplazamiento de la interfaz de usuario, la interfaz de usuario que el jugador edita a través del editor de interfaz de usuario",
  T_49_META_TYPE_268_D: "Un interruptor con tres estados, además de encendido y apagado, puede elegir mantener la lógica original",
  T_49_META_TYPE_269_D: "Equipamiento del jugador",
  T_49_META_TYPE_270_D: "Entidad o ID prefab",
  T_49_META_TYPE_271_D: "Entidad del panel de IU, la IU que el jugador edita a través del editor de IU",
  T_49_META_TYPE_272_D: "Enumeración de género",
  T_49_META_TYPE_273_D: "Mini Mapa",
  T_49_META_TYPE_274_D: "El icono que se muestra en el minimapa puede seguir al objetivo.",
  T_49_META_TYPE_275_D: "Nodos de piezas individuales en un esqueleto",
  T_49_META_TYPE_276_D: "Nodo utilizado para acceder a los huesos de la piel.",
  T_49_META_TYPE_277_D: "Detección de rayos de la cámara del lado del cliente",
  T_49_META_TYPE_278_D: "El bloque de píxeles que se muestra en el mapa pequeño representa el tamaño de colisión del objeto en esa ubicación.",
  T_49_META_TYPE_279_D: "Tambor de Color",
  T_49_META_TYPE_28_D: "Al comienzo de cada ronda, el estado se restablecerá.",
  T_49_META_TYPE_280_D: "Activador Esférico",
  T_49_META_TYPE_281_D: "Activador de Cápsula",
  T_49_META_TYPE_282_D: "Describe el tipo de ID de configuración de activo, que se utiliza para indicar el ID de configuración de activo que viene con el paquete principal, que debe analizarse a través de la tabla de configuración antes de cargarlo.",
  T_49_META_TYPE_283_D: "Describe el tipo de activo, se utiliza para representar el identificador del activo y se puede cargar directamente",
  T_49_META_TYPE_284_D: "Representa un recurso de modelo humanoide que puede reemplazarse con un personaje jugador.",
  T_49_META_TYPE_285_D: "Lista o diccionario, se puede recorrer en bucle",
  T_49_META_TYPE_286_D: "Un ID que describe el activo del script.",
  T_49_META_TYPE_287_D: "Un ID que describe un activo de script estático.",
  T_49_META_TYPE_288_D: "Un ID que describe un activo de UI personalizado.",
  T_49_META_TYPE_289_D: "El ID utilizado para describir el activo preestablecido",
  T_49_META_TYPE_29_D: "Efectos especiales",
  T_49_META_TYPE_290_D: "Árbol de comportamiento",
  T_49_META_TYPE_291_D: "Tipo de Nodo de Árbol de Comportamiento",
  T_49_META_TYPE_292_D: "Nodo Personalizado de Árbol de Comportamiento",
  T_49_META_TYPE_293_D: "Entidad Adjuntable al Árbol de Comportamiento",
  T_49_META_TYPE_294_D: "Entidad de diseño de UI, la UI que los jugadores editan a través del editor de UI",
  T_49_META_TYPE_295_D: "Estado",
  T_49_META_TYPE_296_D: "Clip de Animación",
  T_49_META_TYPE_297_D: "Controlador de animación",
  T_49_META_TYPE_298_D: "Tipo de Bucle",
  T_49_META_TYPE_3_D: "Tipo entero, entero con signo de 32 bits",
  T_49_META_TYPE_30_D: "Icono",
  T_49_META_TYPE_300_D: "Entidad UI3DContainer, la interfaz de usuario que los jugadores editan a través del editor de interfaz de usuario",
  T_49_META_TYPE_301_D: "Tipo de Habilidad de IA",
  T_49_META_TYPE_302_D: "Enumeración de ranuras de equipo",
  T_49_META_TYPE_303_D: "Correspondiente a la columna Id en BuffData.csv, confirme con GPP si es aplicable antes de agregar nuevos elementos",
  T_49_META_TYPE_304_D: "Lista de tipos de potenciador",
  T_49_META_TYPE_305_D: "Estado del Nodo de Árbol de Comportamiento",
  T_49_META_TYPE_306_D: "Puedes agregar mejoras, eliminar mejoras y obtener una lista de mejoras agregadas.",
  T_49_META_TYPE_307_D: "Creador de Muro de Hielo",
  T_49_META_TYPE_308_D: "Tipo de ID de Artículo Especial",
  T_49_META_TYPE_309_D: "Lanzar objetos de utilería",
  T_49_META_TYPE_31_D: "Sonido",
  T_49_META_TYPE_310_D: "Ballesta",
  T_49_META_TYPE_311_D: "Base de Granada",
  T_49_META_TYPE_312_D: "Lanzar objetos de utilería",
  T_49_META_TYPE_313_D: "Granada DeIce Wall",
  T_49_META_TYPE_314_D: "Administrar controladores y recursos de animación",
  T_49_META_TYPE_315_D: "Mochila del jugador",
  T_49_META_TYPE_316_D: "Entidad UITexture, UI editada por el jugador a través del editor de UI",
  T_49_META_TYPE_317_D: "Restricciones de movimiento del cuerpo rígido, cada restricción se puede utilizar en combinación",
  T_49_META_TYPE_318_D: "Accesorio",
  T_49_META_TYPE_319_D: "Enumeración de tipo de relleno",
  T_49_META_TYPE_32_D: "Tipo de estado del jugador",
  T_49_META_TYPE_320_D: "Enumeración de dirección de relleno",
  T_49_META_TYPE_321_D: "Entidades que pueden ser el objetivo",
  T_49_META_TYPE_322_D: "Tipo de Parte del Cuerpo Dañado",
  T_49_META_TYPE_323_D: "Entidad UIProfileInfo, la interfaz de usuario que los jugadores editan a través del editor de interfaz de usuario",
  T_49_META_TYPE_324_D: "Varios efectos diferentes de fuerzas sobre cuerpos rígidos. Tenga en cuenta que esto solo es válido para cuerpos rígidos dinámicos.",
  T_49_META_TYPE_325_D: "El ID utilizado para describir el control en el activo de interfaz personalizado",
  T_49_META_TYPE_326_D: "Información del perfil del jugador",
  T_49_META_TYPE_327_D: "Reemplazo según la configuración de cada componente",
  T_49_META_TYPE_328_D: "ID de Árbol de Comportamiento",
  T_49_META_TYPE_329_D: "Tipo de Asiento",
  T_49_META_TYPE_33_D: "Ordenar por: Ascendente Ignorar valores cero, Descendente, Ascendente",
  T_49_META_TYPE_330_D: "Movimiento relativo a uno mismo",
  T_49_META_TYPE_331_D: "Curva de Bézier",
  T_49_META_TYPE_332_D: "Componentes reciclables",
  T_49_META_TYPE_333_D: "Tipo de Tipo de Fonte",
  T_49_META_TYPE_334_D: "ID del aspecto de vehículo",
  T_49_META_TYPE_335_D: "La entidad de efecto de sonido representa un efecto de sonido que se está reproduciendo.",
  T_49_META_TYPE_336_D: "Lista de Efectos de Sonido",
  T_49_META_TYPE_337_D: "Efecto de Sonido o Lista de Efectos de Sonido",
  T_49_META_TYPE_338_D: "Entidad de sincronización de atributos de comportamiento del jugador",
  T_49_META_TYPE_339_D: "Accesorio de Equipo",
  T_49_META_TYPE_34_D: "ID del objeto",
  T_49_META_TYPE_340_D: "Tipo de Dificultad del Bot",
  T_49_META_TYPE_341_D: "Diccionario de números enteros",
  T_49_META_TYPE_342_D: "Objeto temporizador",
  T_49_META_TYPE_343_D: "Cuchillo arrojadizo (recogida)",
  T_49_META_TYPE_344_D: "Cuchillo arrojadizo",
  T_49_META_TYPE_345_D: "Tipo de Arma",
  T_49_META_TYPE_346_D: "Tipo de Tipo de Munición",
  T_49_META_TYPE_347_D: "Movimiento Relativo a Uno Mismo por Cuadro",
  T_49_META_TYPE_348_D: "El puntero de función apunta a una instancia de función para implementar una función virtual o un mecanismo de delegación.",
  T_49_META_TYPE_349_D: "Se refiere al identificador de una corrutina y puede realizar algunas operaciones de identificador.",
  T_49_META_TYPE_350_D: "Enumeración de vehículos",
  T_49_META_TYPE_351_D: "Describe el tipo de objeto.",
  T_49_META_TYPE_352_D: "Entidad UIToggle, la interfaz de usuario que el jugador edita a través del editor de interfaz de usuario",
  T_49_META_TYPE_353_D: "Kit de Primeros Auxilios",
  T_49_META_TYPE_354_D: "Inhalador",
  T_49_META_TYPE_355_D: "Línea Horizontal",
  T_49_META_TYPE_356_D: "Airdrop, una vez finalizado el tiempo de preparación, comenzará a caer desde un lugar alto.",
  T_49_META_TYPE_357_D: "Color descriptivo de objetos, como bordes, superficies, etc. (eliminar, reciclable)",
  T_49_META_TYPE_358_D: "Se refiere a un evento",
  T_49_META_TYPE_359_D: "Controlador de jugador con efectos físicos, puede aplicar fuerza y recibir fuerza.",
  T_49_META_TYPE_360_D: "Plataforma de Lanzamiento",
  T_49_META_TYPE_361_D: "El cañón plegado puede usarse para lanzar personas cuando está desplegado. ¡Ten cuidado de no salirte de la zona segura!",
  T_49_META_TYPE_362_D: "¡Pelea de bolas de nieve! ¡Cargar!",
  T_49_META_TYPE_363_D: "Solicitud de compra en tienda",
  T_49_META_TYPE_364_D: "Activador de Animación",
  T_49_META_TYPE_365_D: "Componente de interfaz de activación de animación",
  T_49_META_TYPE_366_D: "Renderizador de combinación de lotes",
  T_49_META_TYPE_367_D: "Brújula superior",
  T_49_META_TYPE_368_D: "Rol personalizado ID de recurso",
  T_49_META_TYPE_369_D: "ID de recurso de animación personalizado",
  T_49_META_TYPE_370_D: "Información mostrada al inicio de la ronda",
  T_49_META_TYPE_371_D: "Al final de cada ronda, muestra los resultados.",
  T_49_META_TYPE_372_D: "Tipo de postura del jugador",
  T_49_META_TYPE_373_D: "ID de colección, utilizado para la recopilación de información de recursos",
  T_49_META_TYPE_374_D: "Barra de Salud de Seguimiento",
  T_49_META_TYPE_375_D: "Enumeración de tipos de objetivos de ataques de monstruos",
  T_49_META_TYPE_376_D: "Enumeración de tipos de objetivos de ataques a torres de defensa",
  T_49_META_TYPE_377_D: "Alias para entidades de jugadores y tipos de entidades de vehículos",
  T_49_META_TYPE_378_D: "Una identificación que describe el recurso de audio.",
  T_49_META_TYPE_379_D: "El ID utilizado para describir el activo de la tabla de configuración",
  T_49_META_TYPE_38_D: "Entidad de widget vacía de UI, UI editada por el jugador a través del editor de UI",
  T_49_META_TYPE_380_D: "Una identificación que describe el activo de efecto especial.",
  T_49_META_TYPE_381_D: "Una identificación que describe el activo del controlador de animación.",
  T_49_META_TYPE_382_D: "Método de manejo del estado de derribo",
  T_49_META_TYPE_383_D: "La superficie o las decoraciones del mapa",
  T_49_META_TYPE_384_D: "Objetos",
  T_49_META_TYPE_385_D: "ID de habilidad del personaje",
  T_49_META_TYPE_386_D: "Lista de IDs de habilidades",
  T_49_META_TYPE_387_D: "Entidad UITouchPad, la interfaz de usuario que el jugador edita a través del editor de interfaz de usuario",
  T_49_META_TYPE_388_D: "ID de aspecto de mochila",
  T_49_META_TYPE_389_D: "Entidad de joystick, interfaz de usuario editada por el jugador a través del editor de interfaz de usuario",
  T_49_META_TYPE_39_D: "Entidad de imagen de la interfaz de usuario, interfaz de usuario editada por el jugador a través del editor de interfaz de usuario",
  T_49_META_TYPE_390_D: "Jerárquico",
  T_49_META_TYPE_391_D: "UI Personalizado o Widget",
  T_49_META_TYPE_392_D: "Círculo de veneno Objetos que se pueden colocar",
  T_49_META_TYPE_393_D: "Entidades con componentes PhysicalCCT o Rigidbody",
  T_49_META_TYPE_394_D: "Constantes matemáticas",
  T_49_META_TYPE_395_D: "Las entidades con componentes PhysicalCCT o PlayerCCT pueden moverse con ellos",
  T_49_META_TYPE_396_D: "Configuración de Salida a Medida del Juego",
  T_49_META_TYPE_397_D: "Componente utilizado para describir la forma de la colisión",
  T_49_META_TYPE_398_D: "Cadena o Cadena Localizada",
  T_49_META_TYPE_399_D: "Controlador de personajes con efectos físicos, solo para personajes de FF",
  T_49_META_TYPE_4_D: "Tipo de punto flotante, número de punto flotante de precisión simple de 32 bits",
  T_49_META_TYPE_40_D: "Entidad de texto de la interfaz de usuario, interfaz de usuario editada por el jugador a través del editor de interfaz de usuario",
  T_49_META_TYPE_400_D: "Cómo adoptar un comportamiento agresivo",
  T_49_META_TYPE_401_D: "Tipo de Tipo de Fuego",
  T_49_META_TYPE_402_D: "Widget de Botón Social",
  T_49_META_TYPE_403_D: "Tipos de botones sociales",
  T_49_META_TYPE_404_D: "Estilos de botones sociales",
  T_49_META_TYPE_405_D: "Tipo de Ordenación de Diseño",
  T_49_META_TYPE_406_D: "Puede dispararse sobre obstáculos.",
  T_49_META_TYPE_407_D: "Tipo de Plataforma",
  T_49_META_TYPE_408_D: "Alias de Datos Básicos",
  T_49_META_TYPE_409_D: "Enumeración de códigos de error",
  T_49_META_TYPE_41_D: "Entidad del botón de UI, la UI que el jugador edita a través del editor de UI",
  T_49_META_TYPE_410_D: "Alias para una entidad de jugador o tipo de entidad de transformación.",
  T_49_META_TYPE_411_D: "Vehículo helicóptero",
  T_49_META_TYPE_412_D: "El componente del automóvil es la expansión funcional del componente del vehículo.",
  T_49_META_TYPE_413_D: "NPC",
  T_49_META_TYPE_414_D: "Limitar el ángulo de rotación de la cámara",
  T_49_META_TYPE_415_D: "Persona",
  T_49_META_TYPE_416_D: "Interfaz de la ventana de chat de Persona",
  T_49_META_TYPE_417_D: "Componente de entidad de partícula",
  T_49_META_TYPE_418_D: "Enumeración del estado de los miembros",
  T_49_META_TYPE_419_D: "Tipo de diseño de pistola",
  T_49_META_TYPE_42_D: "Entidad de entrada de UI, la UI que el jugador edita a través del editor de UI",
  T_49_META_TYPE_420_D: "Tipos de diseño de vehículos",
  T_49_META_TYPE_421_D: "Tipo de piel",
  T_49_META_TYPE_422_D: "Tipo de piel de mochila",
  T_49_META_TYPE_423_D: "ID de Persona",
  T_49_META_TYPE_424_D: "Efecto de niebla tipo básico",
  T_49_META_TYPE_425_D: "Identificación de activo de partículas",
  T_49_META_TYPE_426_D: "Un tipo de fuente de luz que emite luz cónica desde la fuente de luz hasta el eje Y negativo de la fuente de luz, iluminando el suelo de forma predeterminada.",
  T_49_META_TYPE_427_D: "NPC",
  T_49_META_TYPE_428_D: "La información del vestuario que el jugador debe conservar al transformarse en otro personaje",
  T_49_META_TYPE_429_D: "Jugador o entidad NPC",
  T_49_META_TYPE_43_D: "El tipo de elemento debe ser una lista de entidades de jugador.",
  T_49_META_TYPE_430_D: "Generador de números aleatorios",
  T_49_META_TYPE_431_D: "El objeto en movimiento se mueve a lo largo de una ruta personalizada",
  T_49_META_TYPE_432_D: "Personalizar puntos de referencia de rutas curvas",
  T_49_META_TYPE_433_D: "Personalizar el tipo de punto de referencia de la ruta de curva",
  T_49_META_TYPE_434_D: "Ruta de curva personalizada",
  T_49_META_TYPE_435_D: "Lista de identificadores únicos de jugadores",
  T_49_META_TYPE_436_D: "Lista de códigos de error",
  T_49_META_TYPE_437_D: "Entidad de la interfaz de usuario con detalles del partido para ambos equipos. Modificar los atributos de la entidad afectará el contenido mostrado en la interfaz de usuario correspondiente.",
  T_49_META_TYPE_438_D: "Entidad de IU de detalles de partidos de varios equipos: modificar los atributos de la entidad afectará el contenido que se muestra en la IU correspondiente.",
  T_49_META_TYPE_439_D: "Combinar",
  T_49_META_TYPE_44_D: "El tipo de elemento debe ser una lista de entidades del equipo.",
  T_49_META_TYPE_440_D: "Cronología",
  T_49_META_TYPE_441_D: "Identificación del recurso de la línea de tiempo",
  T_49_META_TYPE_442_D: "Nuevo componente de entidad simplificado para información de partidos de dos equipos, admite visualización de números totalmente personalizada",
  T_49_META_TYPE_443_D: "ID de activo del flujo de diálogo",
  T_49_META_TYPE_444_D: "Tipo de idioma",
  T_49_META_TYPE_45_D: "Lista de booleanos",
  T_49_META_TYPE_46_D: "Lista Int.",
  T_49_META_TYPE_47_D: "Lista flotante",
  T_49_META_TYPE_48_D: "Lista de cadenas",
  T_49_META_TYPE_49_D: "Lista de Vector3",
  T_49_META_TYPE_5_D: "Tipo de cadena, el valor es contenido de texto",
  T_49_META_TYPE_50_D: "El tipo de elemento debe ser una lista de entidades.",
  T_49_META_TYPE_51_D: "Tipo zombi",
  T_49_META_TYPE_53_D: "Objeto de Nivel Común",
  T_49_META_TYPE_54_D: "Objeto Destructible",
  T_49_META_TYPE_55_D: "Punto de Aparición General",
  T_49_META_TYPE_56_D: "Vehículo",
  T_49_META_TYPE_57_D: "Los jugadores pueden ser teletransportados a una ubicación designada al ingresar",
  T_49_META_TYPE_58_D: "Se pueden generar beneficios a pedido",
  T_49_META_TYPE_59_D: "Plataforma de Movimiento",
  T_49_META_TYPE_6_D: "Vector tridimensional, que puede representar coordenadas espaciales o direcciones espaciales.",
  T_49_META_TYPE_60_D: "Provocará la caída de un arma del tipo seleccionado.",
  T_49_META_TYPE_61_D: "Al ingresar al rango de activación se abrirá la tienda enlazada",
  T_49_META_TYPE_62_D: "Dados con excelente rebote",
  T_49_META_TYPE_63_D: "Los jugadores serán rebotados a la ubicación designada cuando la pisen.",
  T_49_META_TYPE_64_D: "Cuando el jugador lo pisa, emitirá un sonido.",
  T_49_META_TYPE_65_D: "Básico Escalable",
  T_49_META_TYPE_66_D: "Ruta Personalizada",
  T_49_META_TYPE_67_D: "Punto de Ruta",
  T_49_META_TYPE_68_D: "Entidades monstruosas de IA, como zombis",
  T_49_META_TYPE_69_D: "Los números grandes son números de punto flotante de alta precisión.",
  T_49_META_TYPE_7_D: "Número es un alias de tipo para un entero, un entero de 64 bits o un tipo de punto flotante.",
  T_49_META_TYPE_70_D: "Las fórmulas de atributos se utilizan para calcular los valores de los atributos de las entidades. Actualmente, solo se admiten algunos atributos de jugador y de armas.",
  T_49_META_TYPE_71_D: "Se utiliza únicamente para entidades vendidas en tiendas. Los bienes son diferentes del concepto de artículos obtenidos mediante la compra de bienes.",
  T_49_META_TYPE_72_D: "Contiene varios productos",
  T_49_META_TYPE_73_D: "Contiene varios estantes.",
  T_49_META_TYPE_74_D: "ID del objeto",
  T_49_META_TYPE_75_D: "Regreso",
  T_49_META_TYPE_76_D: "Estilo de patrulla",
  T_49_META_TYPE_77_D: "Una entidad generadora que puede generar y actualizar objetos",
  T_49_META_TYPE_78_D: "Una entidad unitaria que puede ser absorbida por generadores de unidades y generada en lotes.",
  T_49_META_TYPE_79_D: "Arma",
  T_49_META_TYPE_8_D: "Las condiciones son de tipo Bool especial",
  T_49_META_TYPE_80_D: "Interfaz de la tienda",
  T_49_META_TYPE_81_D: "Tipo de Buff",
  T_49_META_TYPE_82_D: "Componente de Interfaz de Usuario de Latidos del Corazón",
  T_49_META_TYPE_83_D: "Botón de Interacción",
  T_49_META_TYPE_84_D: "Entidades clasificables, capaces de ser clasificadas",
  T_49_META_TYPE_85_D: "Las entidades integrables tienen sus propias integrales",
  T_49_META_TYPE_86_D: "Tipo de factor de fórmula de atributo",
  T_49_META_TYPE_87_D: "Describe el tipo de color RGBA, el rango de valores de cada canal es de 0 a 255",
  T_49_META_TYPE_88_D: "Tipo de moneda, actualmente solo el tipo de moneda base",
  T_49_META_TYPE_89_D: "Entidad monetaria, utilizada para describir el tipo y cantidad de moneda.",
  T_49_META_TYPE_9_D: "Un conjunto de condiciones",
  T_49_META_TYPE_90_D: "La entidad de billetera es un contenedor para un conjunto de entidades monetarias.",
  T_49_META_TYPE_91_D: "Se refiere a un tipo de matriz de enteros o enteros",
  T_49_META_TYPE_92_D: "Tipo de Objeto Creable Dinámicamente",
  T_49_META_TYPE_93_D: "Entidades con propiedades formulables",
  T_49_META_TYPE_94_D: "Método de modificación de atributos",
  T_49_META_TYPE_95_D: "Generador de oro",
  T_49_META_TYPE_96_D: "Billetera",
  T_49_META_TYPE_97_D: "Posición, rotación y escala, soporte de estructura padre-hijo",
  T_49_META_TYPE_98_D: "Enumere todos los tipos disponibles",
  T_49_META_TYPE_99_D: "Fútbol"
};
export {
  _ as default
};
